(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("451Sc", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $2f891507bcc3501a$export$6503ec6e8aabbaf; }, function (v) { return $2f891507bcc3501a$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $2f891507bcc3501a$export$f7ad0328861e2f03; }, function (v) { return $2f891507bcc3501a$export$f7ad0328861e2f03 = v; });
var $2f891507bcc3501a$export$6503ec6e8aabbaf;
var $2f891507bcc3501a$export$f7ad0328861e2f03;
"use strict";
var $2f891507bcc3501a$var$mapping = new Map();
function $2f891507bcc3501a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$2f891507bcc3501a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $2f891507bcc3501a$var$resolve(id) {
    var resolved = $2f891507bcc3501a$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$2f891507bcc3501a$export$6503ec6e8aabbaf = $2f891507bcc3501a$var$register;
$2f891507bcc3501a$export$f7ad0328861e2f03 = $2f891507bcc3501a$var$resolve;

});

parcelRegister("i1aqH", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $d1e0691a4ecd19e1$export$bdfd709ae4826697; }, function (v) { return $d1e0691a4ecd19e1$export$bdfd709ae4826697 = v; });
var $d1e0691a4ecd19e1$export$bdfd709ae4826697;
var $d1e0691a4ecd19e1$export$c9e73fbda7da57b6;
var $d1e0691a4ecd19e1$export$5a759dc7a1cfb72a;
"use strict";
var $d1e0691a4ecd19e1$var$bundleURL = {};
function $d1e0691a4ecd19e1$var$getBundleURLCached(id) {
    var value = $d1e0691a4ecd19e1$var$bundleURL[id];
    if (!value) {
        value = $d1e0691a4ecd19e1$var$getBundleURL();
        $d1e0691a4ecd19e1$var$bundleURL[id] = value;
    }
    return value;
}
function $d1e0691a4ecd19e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ('' + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $d1e0691a4ecd19e1$var$getBaseURL(matches[2]);
    }
    return '/';
}
function $d1e0691a4ecd19e1$var$getBaseURL(url) {
    return ('' + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, '$1') + '/';
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $d1e0691a4ecd19e1$var$getOrigin(url) {
    var matches = ('' + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error('Origin not found');
    return matches[0];
}
$d1e0691a4ecd19e1$export$bdfd709ae4826697 = $d1e0691a4ecd19e1$var$getBundleURLCached;
$d1e0691a4ecd19e1$export$c9e73fbda7da57b6 = $d1e0691a4ecd19e1$var$getBaseURL;
$d1e0691a4ecd19e1$export$5a759dc7a1cfb72a = $d1e0691a4ecd19e1$var$getOrigin;

});

parcelRegister("cc6u1", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gfEwi"));

});
parcelRegister("gfEwi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $bd4d7a771fe61853$export$ffb0004e005737fa; }, function (v) { return $bd4d7a771fe61853$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $bd4d7a771fe61853$export$34b9dba7ce09269b; }, function (v) { return $bd4d7a771fe61853$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $bd4d7a771fe61853$export$25062201e9e25d76; }, function (v) { return $bd4d7a771fe61853$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bd4d7a771fe61853$export$ffb0004e005737fa;
var $bd4d7a771fe61853$export$34b9dba7ce09269b;
var $bd4d7a771fe61853$export$25062201e9e25d76;
'use strict';

var $fIwXP = parcelRequire("fIwXP");
var $bd4d7a771fe61853$var$k = Symbol.for("react.element"), $bd4d7a771fe61853$var$l = Symbol.for("react.fragment"), $bd4d7a771fe61853$var$m = Object.prototype.hasOwnProperty, $bd4d7a771fe61853$var$n = $fIwXP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $bd4d7a771fe61853$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $bd4d7a771fe61853$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$bd4d7a771fe61853$var$m.call(a, b) && !$bd4d7a771fe61853$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $bd4d7a771fe61853$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $bd4d7a771fe61853$var$n.current
    };
}
$bd4d7a771fe61853$export$ffb0004e005737fa = $bd4d7a771fe61853$var$l;
$bd4d7a771fe61853$export$34b9dba7ce09269b = $bd4d7a771fe61853$var$q;
$bd4d7a771fe61853$export$25062201e9e25d76 = $bd4d7a771fe61853$var$q;

});
parcelRegister("fIwXP", function(module, exports) {
'use strict';

module.exports = (parcelRequire("56YRW"));

});
parcelRegister("56YRW", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $3b8cba9a6536b6a4$export$dca3b0875bd9a954; }, function (v) { return $3b8cba9a6536b6a4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $3b8cba9a6536b6a4$export$16fa2f45be04daa8; }, function (v) { return $3b8cba9a6536b6a4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $3b8cba9a6536b6a4$export$ffb0004e005737fa; }, function (v) { return $3b8cba9a6536b6a4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $3b8cba9a6536b6a4$export$e2c29f18771995cb; }, function (v) { return $3b8cba9a6536b6a4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $3b8cba9a6536b6a4$export$221d75b3f55bb0bd; }, function (v) { return $3b8cba9a6536b6a4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $3b8cba9a6536b6a4$export$5f8d39834fd61797; }, function (v) { return $3b8cba9a6536b6a4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $3b8cba9a6536b6a4$export$74bf444e3cd11ea5; }, function (v) { return $3b8cba9a6536b6a4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $3b8cba9a6536b6a4$export$ae55be85d98224ed; }, function (v) { return $3b8cba9a6536b6a4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $3b8cba9a6536b6a4$export$3ba232387fd5d6dd; }, function (v) { return $3b8cba9a6536b6a4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $3b8cba9a6536b6a4$export$e530037191fcd5d7; }, function (v) { return $3b8cba9a6536b6a4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $3b8cba9a6536b6a4$export$fd42f52fd3ae1109; }, function (v) { return $3b8cba9a6536b6a4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $3b8cba9a6536b6a4$export$c8a8987d4410bf2d; }, function (v) { return $3b8cba9a6536b6a4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $3b8cba9a6536b6a4$export$d38cd72104c1f0e9; }, function (v) { return $3b8cba9a6536b6a4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $3b8cba9a6536b6a4$export$7d1e3a5e95ceca43; }, function (v) { return $3b8cba9a6536b6a4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $3b8cba9a6536b6a4$export$257a8862b851cb5b; }, function (v) { return $3b8cba9a6536b6a4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $3b8cba9a6536b6a4$export$a8257692ac88316c; }, function (v) { return $3b8cba9a6536b6a4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $3b8cba9a6536b6a4$export$488013bae63b21da; }, function (v) { return $3b8cba9a6536b6a4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $3b8cba9a6536b6a4$export$7c73462e0d25e514; }, function (v) { return $3b8cba9a6536b6a4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $3b8cba9a6536b6a4$export$7568632d0d33d16d; }, function (v) { return $3b8cba9a6536b6a4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $3b8cba9a6536b6a4$export$88948ce120ea2619; }, function (v) { return $3b8cba9a6536b6a4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $3b8cba9a6536b6a4$export$35808ee640e87ca7; }, function (v) { return $3b8cba9a6536b6a4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $3b8cba9a6536b6a4$export$fae74005e78b1a27; }, function (v) { return $3b8cba9a6536b6a4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e; }, function (v) { return $3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $3b8cba9a6536b6a4$export$6a7bc4e911dc01cf; }, function (v) { return $3b8cba9a6536b6a4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $3b8cba9a6536b6a4$export$6d9c69b0de29b591; }, function (v) { return $3b8cba9a6536b6a4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $3b8cba9a6536b6a4$export$f680877a34711e37; }, function (v) { return $3b8cba9a6536b6a4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $3b8cba9a6536b6a4$export$d5a552a76deda3c2; }, function (v) { return $3b8cba9a6536b6a4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $3b8cba9a6536b6a4$export$aaabe4eda9ed9969; }, function (v) { return $3b8cba9a6536b6a4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $3b8cba9a6536b6a4$export$e5c5a5f917a5871c; }, function (v) { return $3b8cba9a6536b6a4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $3b8cba9a6536b6a4$export$1538c33de8887b59; }, function (v) { return $3b8cba9a6536b6a4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $3b8cba9a6536b6a4$export$13e3392192263954; }, function (v) { return $3b8cba9a6536b6a4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $3b8cba9a6536b6a4$export$b8f5890fc79d6aca; }, function (v) { return $3b8cba9a6536b6a4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $3b8cba9a6536b6a4$export$60241385465d0a34; }, function (v) { return $3b8cba9a6536b6a4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $3b8cba9a6536b6a4$export$306c0aa65ff9ec16; }, function (v) { return $3b8cba9a6536b6a4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $3b8cba9a6536b6a4$export$7b286972b8d8ccbf; }, function (v) { return $3b8cba9a6536b6a4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $3b8cba9a6536b6a4$export$83d89fbfd8236492; }, function (v) { return $3b8cba9a6536b6a4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $3b8cba9a6536b6a4$export$dca3b0875bd9a954;
var $3b8cba9a6536b6a4$export$16fa2f45be04daa8;
var $3b8cba9a6536b6a4$export$ffb0004e005737fa;
var $3b8cba9a6536b6a4$export$e2c29f18771995cb;
var $3b8cba9a6536b6a4$export$221d75b3f55bb0bd;
var $3b8cba9a6536b6a4$export$5f8d39834fd61797;
var $3b8cba9a6536b6a4$export$74bf444e3cd11ea5;
var $3b8cba9a6536b6a4$export$ae55be85d98224ed;
var $3b8cba9a6536b6a4$export$3ba232387fd5d6dd;
var $3b8cba9a6536b6a4$export$e530037191fcd5d7;
var $3b8cba9a6536b6a4$export$fd42f52fd3ae1109;
var $3b8cba9a6536b6a4$export$c8a8987d4410bf2d;
var $3b8cba9a6536b6a4$export$d38cd72104c1f0e9;
var $3b8cba9a6536b6a4$export$7d1e3a5e95ceca43;
var $3b8cba9a6536b6a4$export$257a8862b851cb5b;
var $3b8cba9a6536b6a4$export$a8257692ac88316c;
var $3b8cba9a6536b6a4$export$488013bae63b21da;
var $3b8cba9a6536b6a4$export$7c73462e0d25e514;
var $3b8cba9a6536b6a4$export$7568632d0d33d16d;
var $3b8cba9a6536b6a4$export$88948ce120ea2619;
var $3b8cba9a6536b6a4$export$35808ee640e87ca7;
var $3b8cba9a6536b6a4$export$fae74005e78b1a27;
var $3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e;
var $3b8cba9a6536b6a4$export$6a7bc4e911dc01cf;
var $3b8cba9a6536b6a4$export$6d9c69b0de29b591;
var $3b8cba9a6536b6a4$export$f680877a34711e37;
var $3b8cba9a6536b6a4$export$d5a552a76deda3c2;
var $3b8cba9a6536b6a4$export$aaabe4eda9ed9969;
var $3b8cba9a6536b6a4$export$e5c5a5f917a5871c;
var $3b8cba9a6536b6a4$export$1538c33de8887b59;
var $3b8cba9a6536b6a4$export$13e3392192263954;
var $3b8cba9a6536b6a4$export$b8f5890fc79d6aca;
var $3b8cba9a6536b6a4$export$60241385465d0a34;
var $3b8cba9a6536b6a4$export$306c0aa65ff9ec16;
var $3b8cba9a6536b6a4$export$7b286972b8d8ccbf;
var $3b8cba9a6536b6a4$export$83d89fbfd8236492;
'use strict';
var $3b8cba9a6536b6a4$var$l = Symbol.for("react.element"), $3b8cba9a6536b6a4$var$n = Symbol.for("react.portal"), $3b8cba9a6536b6a4$var$p = Symbol.for("react.fragment"), $3b8cba9a6536b6a4$var$q = Symbol.for("react.strict_mode"), $3b8cba9a6536b6a4$var$r = Symbol.for("react.profiler"), $3b8cba9a6536b6a4$var$t = Symbol.for("react.provider"), $3b8cba9a6536b6a4$var$u = Symbol.for("react.context"), $3b8cba9a6536b6a4$var$v = Symbol.for("react.forward_ref"), $3b8cba9a6536b6a4$var$w = Symbol.for("react.suspense"), $3b8cba9a6536b6a4$var$x = Symbol.for("react.memo"), $3b8cba9a6536b6a4$var$y = Symbol.for("react.lazy"), $3b8cba9a6536b6a4$var$z = Symbol.iterator;
function $3b8cba9a6536b6a4$var$A(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a))) return null;
    a = $3b8cba9a6536b6a4$var$z && a[$3b8cba9a6536b6a4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $3b8cba9a6536b6a4$var$B = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $3b8cba9a6536b6a4$var$C = Object.assign, $3b8cba9a6536b6a4$var$D = {};
function $3b8cba9a6536b6a4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3b8cba9a6536b6a4$var$D;
    this.updater = e || $3b8cba9a6536b6a4$var$B;
}
$3b8cba9a6536b6a4$var$E.prototype.isReactComponent = {};
$3b8cba9a6536b6a4$var$E.prototype.setState = function(a, b) {
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$3b8cba9a6536b6a4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $3b8cba9a6536b6a4$var$F() {}
$3b8cba9a6536b6a4$var$F.prototype = $3b8cba9a6536b6a4$var$E.prototype;
function $3b8cba9a6536b6a4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $3b8cba9a6536b6a4$var$D;
    this.updater = e || $3b8cba9a6536b6a4$var$B;
}
var $3b8cba9a6536b6a4$var$H = $3b8cba9a6536b6a4$var$G.prototype = new $3b8cba9a6536b6a4$var$F;
$3b8cba9a6536b6a4$var$H.constructor = $3b8cba9a6536b6a4$var$G;
$3b8cba9a6536b6a4$var$C($3b8cba9a6536b6a4$var$H, $3b8cba9a6536b6a4$var$E.prototype);
$3b8cba9a6536b6a4$var$H.isPureReactComponent = !0;
var $3b8cba9a6536b6a4$var$I = Array.isArray, $3b8cba9a6536b6a4$var$J = Object.prototype.hasOwnProperty, $3b8cba9a6536b6a4$var$K = {
    current: null
}, $3b8cba9a6536b6a4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $3b8cba9a6536b6a4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$3b8cba9a6536b6a4$var$J.call(b, d) && !$3b8cba9a6536b6a4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $3b8cba9a6536b6a4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $3b8cba9a6536b6a4$var$K.current
    };
}
function $3b8cba9a6536b6a4$var$N(a, b) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $3b8cba9a6536b6a4$var$O(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && null !== a && a.$$typeof === $3b8cba9a6536b6a4$var$l;
}
function $3b8cba9a6536b6a4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $3b8cba9a6536b6a4$var$P = /\/+/g;
function $3b8cba9a6536b6a4$var$Q(a, b) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && null !== a && null != a.key ? $3b8cba9a6536b6a4$var$escape("" + a.key) : b.toString(36);
}
function $3b8cba9a6536b6a4$var$R(a, b, e, d, c) {
    var k = typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a);
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $3b8cba9a6536b6a4$var$l:
                case $3b8cba9a6536b6a4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $3b8cba9a6536b6a4$var$Q(h, 0) : d, $3b8cba9a6536b6a4$var$I(c) ? (e = "", null != a && (e = a.replace($3b8cba9a6536b6a4$var$P, "$&/") + "/"), $3b8cba9a6536b6a4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($3b8cba9a6536b6a4$var$O(c) && (c = $3b8cba9a6536b6a4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($3b8cba9a6536b6a4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($3b8cba9a6536b6a4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $3b8cba9a6536b6a4$var$Q(k, g);
        h += $3b8cba9a6536b6a4$var$R(k, b, e, f, c);
    }
    else if (f = $3b8cba9a6536b6a4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $3b8cba9a6536b6a4$var$Q(k, g++), h += $3b8cba9a6536b6a4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $3b8cba9a6536b6a4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $3b8cba9a6536b6a4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $3b8cba9a6536b6a4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $3b8cba9a6536b6a4$var$U = {
    current: null
}, $3b8cba9a6536b6a4$var$V = {
    transition: null
}, $3b8cba9a6536b6a4$var$W = {
    ReactCurrentDispatcher: $3b8cba9a6536b6a4$var$U,
    ReactCurrentBatchConfig: $3b8cba9a6536b6a4$var$V,
    ReactCurrentOwner: $3b8cba9a6536b6a4$var$K
};
function $3b8cba9a6536b6a4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$3b8cba9a6536b6a4$export$dca3b0875bd9a954 = {
    map: $3b8cba9a6536b6a4$var$S,
    forEach: function forEach(a, b, e) {
        $3b8cba9a6536b6a4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function count(a) {
        var b = 0;
        $3b8cba9a6536b6a4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function toArray(a) {
        return $3b8cba9a6536b6a4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function only(a) {
        if (!$3b8cba9a6536b6a4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$3b8cba9a6536b6a4$export$16fa2f45be04daa8 = $3b8cba9a6536b6a4$var$E;
$3b8cba9a6536b6a4$export$ffb0004e005737fa = $3b8cba9a6536b6a4$var$p;
$3b8cba9a6536b6a4$export$e2c29f18771995cb = $3b8cba9a6536b6a4$var$r;
$3b8cba9a6536b6a4$export$221d75b3f55bb0bd = $3b8cba9a6536b6a4$var$G;
$3b8cba9a6536b6a4$export$5f8d39834fd61797 = $3b8cba9a6536b6a4$var$q;
$3b8cba9a6536b6a4$export$74bf444e3cd11ea5 = $3b8cba9a6536b6a4$var$w;
$3b8cba9a6536b6a4$export$ae55be85d98224ed = $3b8cba9a6536b6a4$var$W;
$3b8cba9a6536b6a4$export$3ba232387fd5d6dd = $3b8cba9a6536b6a4$var$X;
$3b8cba9a6536b6a4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $3b8cba9a6536b6a4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $3b8cba9a6536b6a4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$3b8cba9a6536b6a4$var$J.call(b, f) && !$3b8cba9a6536b6a4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $3b8cba9a6536b6a4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$3b8cba9a6536b6a4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $3b8cba9a6536b6a4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $3b8cba9a6536b6a4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$3b8cba9a6536b6a4$export$c8a8987d4410bf2d = $3b8cba9a6536b6a4$var$M;
$3b8cba9a6536b6a4$export$d38cd72104c1f0e9 = function(a) {
    var b = $3b8cba9a6536b6a4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$3b8cba9a6536b6a4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$3b8cba9a6536b6a4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$v,
        render: a
    };
};
$3b8cba9a6536b6a4$export$a8257692ac88316c = $3b8cba9a6536b6a4$var$O;
$3b8cba9a6536b6a4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $3b8cba9a6536b6a4$var$T
    };
};
$3b8cba9a6536b6a4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $3b8cba9a6536b6a4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$3b8cba9a6536b6a4$export$7568632d0d33d16d = function(a) {
    var b = $3b8cba9a6536b6a4$var$V.transition;
    $3b8cba9a6536b6a4$var$V.transition = {};
    try {
        a();
    } finally{
        $3b8cba9a6536b6a4$var$V.transition = b;
    }
};
$3b8cba9a6536b6a4$export$88948ce120ea2619 = $3b8cba9a6536b6a4$var$X;
$3b8cba9a6536b6a4$export$35808ee640e87ca7 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useCallback(a, b);
};
$3b8cba9a6536b6a4$export$fae74005e78b1a27 = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useContext(a);
};
$3b8cba9a6536b6a4$export$dc8fbce3eb94dc1e = function() {};
$3b8cba9a6536b6a4$export$6a7bc4e911dc01cf = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useDeferredValue(a);
};
$3b8cba9a6536b6a4$export$6d9c69b0de29b591 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useEffect(a, b);
};
$3b8cba9a6536b6a4$export$f680877a34711e37 = function() {
    return $3b8cba9a6536b6a4$var$U.current.useId();
};
$3b8cba9a6536b6a4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $3b8cba9a6536b6a4$var$U.current.useImperativeHandle(a, b, e);
};
$3b8cba9a6536b6a4$export$aaabe4eda9ed9969 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useInsertionEffect(a, b);
};
$3b8cba9a6536b6a4$export$e5c5a5f917a5871c = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useLayoutEffect(a, b);
};
$3b8cba9a6536b6a4$export$1538c33de8887b59 = function(a, b) {
    return $3b8cba9a6536b6a4$var$U.current.useMemo(a, b);
};
$3b8cba9a6536b6a4$export$13e3392192263954 = function(a, b, e) {
    return $3b8cba9a6536b6a4$var$U.current.useReducer(a, b, e);
};
$3b8cba9a6536b6a4$export$b8f5890fc79d6aca = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useRef(a);
};
$3b8cba9a6536b6a4$export$60241385465d0a34 = function(a) {
    return $3b8cba9a6536b6a4$var$U.current.useState(a);
};
$3b8cba9a6536b6a4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $3b8cba9a6536b6a4$var$U.current.useSyncExternalStore(a, b, e);
};
$3b8cba9a6536b6a4$export$7b286972b8d8ccbf = function() {
    return $3b8cba9a6536b6a4$var$U.current.useTransition();
};
$3b8cba9a6536b6a4$export$83d89fbfd8236492 = "18.3.1";

});
parcelRegister("YtE9h", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b5c99e6a0876eaa$export$71511d61b312f219; });
function $0b5c99e6a0876eaa$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});





parcelRegister("fsZ8I", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b428e590a835ea4b$export$ae55be85d98224ed; }, function (v) { return $b428e590a835ea4b$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b428e590a835ea4b$export$d39a5bbd09211389; }, function (v) { return $b428e590a835ea4b$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b428e590a835ea4b$export$882461b6382ed46c; }, function (v) { return $b428e590a835ea4b$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b428e590a835ea4b$export$466bfc07425424d5; }, function (v) { return $b428e590a835ea4b$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b428e590a835ea4b$export$cd75ccfd720a3cd4; }, function (v) { return $b428e590a835ea4b$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b428e590a835ea4b$export$fa8d919ba61d84db; }, function (v) { return $b428e590a835ea4b$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b428e590a835ea4b$export$757ceba2d55c277e; }, function (v) { return $b428e590a835ea4b$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b428e590a835ea4b$export$b3890eb0ae9dca99; }, function (v) { return $b428e590a835ea4b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b428e590a835ea4b$export$502457920280e6be; }, function (v) { return $b428e590a835ea4b$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b428e590a835ea4b$export$c78a37762a8d58e1; }, function (v) { return $b428e590a835ea4b$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b428e590a835ea4b$export$dc54d992c10e8a18; }, function (v) { return $b428e590a835ea4b$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b428e590a835ea4b$export$83d89fbfd8236492; }, function (v) { return $b428e590a835ea4b$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $YtE9h = parcelRequire("YtE9h");
var $b428e590a835ea4b$export$ae55be85d98224ed;
var $b428e590a835ea4b$export$d39a5bbd09211389;
var $b428e590a835ea4b$export$882461b6382ed46c;
var $b428e590a835ea4b$export$466bfc07425424d5;
var $b428e590a835ea4b$export$cd75ccfd720a3cd4;
var $b428e590a835ea4b$export$fa8d919ba61d84db;
var $b428e590a835ea4b$export$757ceba2d55c277e;
var $b428e590a835ea4b$export$b3890eb0ae9dca99;
var $b428e590a835ea4b$export$502457920280e6be;
var $b428e590a835ea4b$export$c78a37762a8d58e1;
var $b428e590a835ea4b$export$dc54d992c10e8a18;
var $b428e590a835ea4b$export$83d89fbfd8236492;
'use strict';

var $fIwXP = parcelRequire("fIwXP");

var $go0bk = parcelRequire("go0bk");
function $b428e590a835ea4b$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b428e590a835ea4b$var$da = new Set, $b428e590a835ea4b$var$ea = {};
function $b428e590a835ea4b$var$fa(a, b) {
    $b428e590a835ea4b$var$ha(a, b);
    $b428e590a835ea4b$var$ha(a + "Capture", b);
}
function $b428e590a835ea4b$var$ha(a, b) {
    $b428e590a835ea4b$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b428e590a835ea4b$var$da.add(b[a]);
}
var $b428e590a835ea4b$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b428e590a835ea4b$var$ja = Object.prototype.hasOwnProperty, $b428e590a835ea4b$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b428e590a835ea4b$var$la = {}, $b428e590a835ea4b$var$ma = {};
function $b428e590a835ea4b$var$oa(a) {
    if ($b428e590a835ea4b$var$ja.call($b428e590a835ea4b$var$ma, a)) return !0;
    if ($b428e590a835ea4b$var$ja.call($b428e590a835ea4b$var$la, a)) return !1;
    if ($b428e590a835ea4b$var$ka.test(a)) return $b428e590a835ea4b$var$ma[a] = !0;
    $b428e590a835ea4b$var$la[a] = !0;
    return !1;
}
function $b428e590a835ea4b$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b === "undefined" ? "undefined" : (0, $YtE9h._)(b)){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b428e590a835ea4b$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b428e590a835ea4b$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b428e590a835ea4b$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b428e590a835ea4b$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b428e590a835ea4b$var$ra = /[\-:]([a-z])/g;
function $b428e590a835ea4b$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b428e590a835ea4b$var$ra, $b428e590a835ea4b$var$sa);
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b428e590a835ea4b$var$ra, $b428e590a835ea4b$var$sa);
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b428e590a835ea4b$var$ra, $b428e590a835ea4b$var$sa);
    $b428e590a835ea4b$var$z[b] = new $b428e590a835ea4b$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b428e590a835ea4b$var$z.xlinkHref = new $b428e590a835ea4b$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b428e590a835ea4b$var$z[a] = new $b428e590a835ea4b$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b428e590a835ea4b$var$ta(a, b, c, d) {
    var e = $b428e590a835ea4b$var$z.hasOwnProperty(b) ? $b428e590a835ea4b$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b428e590a835ea4b$var$qa(b, c, e, d) && (c = null), d || null === e ? $b428e590a835ea4b$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b428e590a835ea4b$var$ua = $fIwXP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b428e590a835ea4b$var$va = Symbol.for("react.element"), $b428e590a835ea4b$var$wa = Symbol.for("react.portal"), $b428e590a835ea4b$var$ya = Symbol.for("react.fragment"), $b428e590a835ea4b$var$za = Symbol.for("react.strict_mode"), $b428e590a835ea4b$var$Aa = Symbol.for("react.profiler"), $b428e590a835ea4b$var$Ba = Symbol.for("react.provider"), $b428e590a835ea4b$var$Ca = Symbol.for("react.context"), $b428e590a835ea4b$var$Da = Symbol.for("react.forward_ref"), $b428e590a835ea4b$var$Ea = Symbol.for("react.suspense"), $b428e590a835ea4b$var$Fa = Symbol.for("react.suspense_list"), $b428e590a835ea4b$var$Ga = Symbol.for("react.memo"), $b428e590a835ea4b$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b428e590a835ea4b$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b428e590a835ea4b$var$Ja = Symbol.iterator;
function $b428e590a835ea4b$var$Ka(a) {
    if (null === a || "object" !== (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a))) return null;
    a = $b428e590a835ea4b$var$Ja && a[$b428e590a835ea4b$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b428e590a835ea4b$var$A = Object.assign, $b428e590a835ea4b$var$La;
function $b428e590a835ea4b$var$Ma(a) {
    if (void 0 === $b428e590a835ea4b$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b428e590a835ea4b$var$La = b && b[1] || "";
    }
    return "\n" + $b428e590a835ea4b$var$La + a;
}
var $b428e590a835ea4b$var$Na = !1;
function $b428e590a835ea4b$var$Oa(a, b) {
    if (!a || $b428e590a835ea4b$var$Na) return "";
    $b428e590a835ea4b$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function b() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function set() {
                    throw Error();
                }
            }), "object" === (typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b428e590a835ea4b$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b428e590a835ea4b$var$Ma(a) : "";
}
function $b428e590a835ea4b$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b428e590a835ea4b$var$Ma(a.type);
        case 16:
            return $b428e590a835ea4b$var$Ma("Lazy");
        case 13:
            return $b428e590a835ea4b$var$Ma("Suspense");
        case 19:
            return $b428e590a835ea4b$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b428e590a835ea4b$var$Oa(a.type, !1), a;
        case 11:
            return a = $b428e590a835ea4b$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b428e590a835ea4b$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b428e590a835ea4b$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b428e590a835ea4b$var$ya:
            return "Fragment";
        case $b428e590a835ea4b$var$wa:
            return "Portal";
        case $b428e590a835ea4b$var$Aa:
            return "Profiler";
        case $b428e590a835ea4b$var$za:
            return "StrictMode";
        case $b428e590a835ea4b$var$Ea:
            return "Suspense";
        case $b428e590a835ea4b$var$Fa:
            return "SuspenseList";
    }
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a))) switch(a.$$typeof){
        case $b428e590a835ea4b$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b428e590a835ea4b$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b428e590a835ea4b$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b428e590a835ea4b$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b428e590a835ea4b$var$Qa(a.type) || "Memo";
        case $b428e590a835ea4b$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b428e590a835ea4b$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b428e590a835ea4b$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b428e590a835ea4b$var$Qa(b);
        case 8:
            return b === $b428e590a835ea4b$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b428e590a835ea4b$var$Sa(a) {
    switch(typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b428e590a835ea4b$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b428e590a835ea4b$var$Ua(a) {
    var b = $b428e590a835ea4b$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function get() {
                return e.call(this);
            },
            set: function set(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function getValue() {
                return d;
            },
            setValue: function setValue(a) {
                d = "" + a;
            },
            stopTracking: function stopTracking() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b428e590a835ea4b$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b428e590a835ea4b$var$Ua(a));
}
function $b428e590a835ea4b$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b428e590a835ea4b$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b428e590a835ea4b$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b428e590a835ea4b$var$Ya(a, b) {
    var c = b.checked;
    return $b428e590a835ea4b$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b428e590a835ea4b$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b428e590a835ea4b$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b428e590a835ea4b$var$ab(a, b) {
    b = b.checked;
    null != b && $b428e590a835ea4b$var$ta(a, "checked", b, !1);
}
function $b428e590a835ea4b$var$bb(a, b) {
    $b428e590a835ea4b$var$ab(a, b);
    var c = $b428e590a835ea4b$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b428e590a835ea4b$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b428e590a835ea4b$var$cb(a, b.type, $b428e590a835ea4b$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b428e590a835ea4b$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b428e590a835ea4b$var$cb(a, b, c) {
    if ("number" !== b || $b428e590a835ea4b$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b428e590a835ea4b$var$eb = Array.isArray;
function $b428e590a835ea4b$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b428e590a835ea4b$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b428e590a835ea4b$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b428e590a835ea4b$var$p(91));
    return $b428e590a835ea4b$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b428e590a835ea4b$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b428e590a835ea4b$var$p(92));
            if ($b428e590a835ea4b$var$eb(c)) {
                if (1 < c.length) throw Error($b428e590a835ea4b$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b428e590a835ea4b$var$Sa(c)
    };
}
function $b428e590a835ea4b$var$ib(a, b) {
    var c = $b428e590a835ea4b$var$Sa(b.value), d = $b428e590a835ea4b$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b428e590a835ea4b$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b428e590a835ea4b$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b428e590a835ea4b$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b428e590a835ea4b$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b428e590a835ea4b$var$mb, $b428e590a835ea4b$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b428e590a835ea4b$var$mb = $b428e590a835ea4b$var$mb || document.createElement("div");
        $b428e590a835ea4b$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b428e590a835ea4b$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b428e590a835ea4b$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b428e590a835ea4b$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b428e590a835ea4b$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b428e590a835ea4b$var$pb).forEach(function(a) {
    $b428e590a835ea4b$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b428e590a835ea4b$var$pb[b] = $b428e590a835ea4b$var$pb[a];
    });
});
function $b428e590a835ea4b$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b428e590a835ea4b$var$pb.hasOwnProperty(a) && $b428e590a835ea4b$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b428e590a835ea4b$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b428e590a835ea4b$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b428e590a835ea4b$var$tb = $b428e590a835ea4b$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b428e590a835ea4b$var$ub(a, b) {
    if (b) {
        if ($b428e590a835ea4b$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b428e590a835ea4b$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b428e590a835ea4b$var$p(60));
            if ("object" !== (0, $YtE9h._)(b.dangerouslySetInnerHTML) || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b428e590a835ea4b$var$p(61));
        }
        if (null != b.style && "object" !== (0, $YtE9h._)(b.style)) throw Error($b428e590a835ea4b$var$p(62));
    }
}
function $b428e590a835ea4b$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b428e590a835ea4b$var$wb = null;
function $b428e590a835ea4b$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b428e590a835ea4b$var$yb = null, $b428e590a835ea4b$var$zb = null, $b428e590a835ea4b$var$Ab = null;
function $b428e590a835ea4b$var$Bb(a) {
    if (a = $b428e590a835ea4b$var$Cb(a)) {
        if ("function" !== typeof $b428e590a835ea4b$var$yb) throw Error($b428e590a835ea4b$var$p(280));
        var b = a.stateNode;
        b && (b = $b428e590a835ea4b$var$Db(b), $b428e590a835ea4b$var$yb(a.stateNode, a.type, b));
    }
}
function $b428e590a835ea4b$var$Eb(a) {
    $b428e590a835ea4b$var$zb ? $b428e590a835ea4b$var$Ab ? $b428e590a835ea4b$var$Ab.push(a) : $b428e590a835ea4b$var$Ab = [
        a
    ] : $b428e590a835ea4b$var$zb = a;
}
function $b428e590a835ea4b$var$Fb() {
    if ($b428e590a835ea4b$var$zb) {
        var a = $b428e590a835ea4b$var$zb, b = $b428e590a835ea4b$var$Ab;
        $b428e590a835ea4b$var$Ab = $b428e590a835ea4b$var$zb = null;
        $b428e590a835ea4b$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b428e590a835ea4b$var$Bb(b[a]);
    }
}
function $b428e590a835ea4b$var$Gb(a, b) {
    return a(b);
}
function $b428e590a835ea4b$var$Hb() {}
var $b428e590a835ea4b$var$Ib = !1;
function $b428e590a835ea4b$var$Jb(a, b, c) {
    if ($b428e590a835ea4b$var$Ib) return a(b, c);
    $b428e590a835ea4b$var$Ib = !0;
    try {
        return $b428e590a835ea4b$var$Gb(a, b, c);
    } finally{
        if ($b428e590a835ea4b$var$Ib = !1, null !== $b428e590a835ea4b$var$zb || null !== $b428e590a835ea4b$var$Ab) $b428e590a835ea4b$var$Hb(), $b428e590a835ea4b$var$Fb();
    }
}
function $b428e590a835ea4b$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b428e590a835ea4b$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b428e590a835ea4b$var$p(231, b, typeof c === "undefined" ? "undefined" : (0, $YtE9h._)(c)));
    return c;
}
var $b428e590a835ea4b$var$Lb = !1;
if ($b428e590a835ea4b$var$ia) try {
    var $b428e590a835ea4b$var$Mb = {};
    Object.defineProperty($b428e590a835ea4b$var$Mb, "passive", {
        get: function get() {
            $b428e590a835ea4b$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b428e590a835ea4b$var$Mb, $b428e590a835ea4b$var$Mb);
    window.removeEventListener("test", $b428e590a835ea4b$var$Mb, $b428e590a835ea4b$var$Mb);
} catch (a) {
    $b428e590a835ea4b$var$Lb = !1;
}
function $b428e590a835ea4b$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b428e590a835ea4b$var$Ob = !1, $b428e590a835ea4b$var$Pb = null, $b428e590a835ea4b$var$Qb = !1, $b428e590a835ea4b$var$Rb = null, $b428e590a835ea4b$var$Sb = {
    onError: function onError(a) {
        $b428e590a835ea4b$var$Ob = !0;
        $b428e590a835ea4b$var$Pb = a;
    }
};
function $b428e590a835ea4b$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b428e590a835ea4b$var$Ob = !1;
    $b428e590a835ea4b$var$Pb = null;
    $b428e590a835ea4b$var$Nb.apply($b428e590a835ea4b$var$Sb, arguments);
}
function $b428e590a835ea4b$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b428e590a835ea4b$var$Tb.apply(this, arguments);
    if ($b428e590a835ea4b$var$Ob) {
        if ($b428e590a835ea4b$var$Ob) {
            var l = $b428e590a835ea4b$var$Pb;
            $b428e590a835ea4b$var$Ob = !1;
            $b428e590a835ea4b$var$Pb = null;
        } else throw Error($b428e590a835ea4b$var$p(198));
        $b428e590a835ea4b$var$Qb || ($b428e590a835ea4b$var$Qb = !0, $b428e590a835ea4b$var$Rb = l);
    }
}
function $b428e590a835ea4b$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b428e590a835ea4b$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b428e590a835ea4b$var$Xb(a) {
    if ($b428e590a835ea4b$var$Vb(a) !== a) throw Error($b428e590a835ea4b$var$p(188));
}
function $b428e590a835ea4b$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b428e590a835ea4b$var$Vb(a);
        if (null === b) throw Error($b428e590a835ea4b$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b428e590a835ea4b$var$Xb(e), a;
                if (f === d) return $b428e590a835ea4b$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b428e590a835ea4b$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b428e590a835ea4b$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b428e590a835ea4b$var$p(190));
    }
    if (3 !== c.tag) throw Error($b428e590a835ea4b$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b428e590a835ea4b$var$Zb(a) {
    a = $b428e590a835ea4b$var$Yb(a);
    return null !== a ? $b428e590a835ea4b$var$$b(a) : null;
}
function $b428e590a835ea4b$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b428e590a835ea4b$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b428e590a835ea4b$var$ac = $go0bk.unstable_scheduleCallback, $b428e590a835ea4b$var$bc = $go0bk.unstable_cancelCallback, $b428e590a835ea4b$var$cc = $go0bk.unstable_shouldYield, $b428e590a835ea4b$var$dc = $go0bk.unstable_requestPaint, $b428e590a835ea4b$var$B = $go0bk.unstable_now, $b428e590a835ea4b$var$ec = $go0bk.unstable_getCurrentPriorityLevel, $b428e590a835ea4b$var$fc = $go0bk.unstable_ImmediatePriority, $b428e590a835ea4b$var$gc = $go0bk.unstable_UserBlockingPriority, $b428e590a835ea4b$var$hc = $go0bk.unstable_NormalPriority, $b428e590a835ea4b$var$ic = $go0bk.unstable_LowPriority, $b428e590a835ea4b$var$jc = $go0bk.unstable_IdlePriority, $b428e590a835ea4b$var$kc = null, $b428e590a835ea4b$var$lc = null;
function $b428e590a835ea4b$var$mc(a) {
    if ($b428e590a835ea4b$var$lc && "function" === typeof $b428e590a835ea4b$var$lc.onCommitFiberRoot) try {
        $b428e590a835ea4b$var$lc.onCommitFiberRoot($b428e590a835ea4b$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b428e590a835ea4b$var$oc = Math.clz32 ? Math.clz32 : $b428e590a835ea4b$var$nc, $b428e590a835ea4b$var$pc = Math.log, $b428e590a835ea4b$var$qc = Math.LN2;
function $b428e590a835ea4b$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b428e590a835ea4b$var$pc(a) / $b428e590a835ea4b$var$qc | 0) | 0;
}
var $b428e590a835ea4b$var$rc = 64, $b428e590a835ea4b$var$sc = 4194304;
function $b428e590a835ea4b$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b428e590a835ea4b$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b428e590a835ea4b$var$tc(h) : (f &= g, 0 !== f && (d = $b428e590a835ea4b$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b428e590a835ea4b$var$tc(g) : 0 !== f && (d = $b428e590a835ea4b$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b428e590a835ea4b$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b428e590a835ea4b$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b428e590a835ea4b$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b428e590a835ea4b$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b428e590a835ea4b$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b428e590a835ea4b$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b428e590a835ea4b$var$yc() {
    var a = $b428e590a835ea4b$var$rc;
    $b428e590a835ea4b$var$rc <<= 1;
    0 === ($b428e590a835ea4b$var$rc & 4194240) && ($b428e590a835ea4b$var$rc = 64);
    return a;
}
function $b428e590a835ea4b$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b428e590a835ea4b$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b428e590a835ea4b$var$oc(b);
    a[b] = c;
}
function $b428e590a835ea4b$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b428e590a835ea4b$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b428e590a835ea4b$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b428e590a835ea4b$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b428e590a835ea4b$var$C = 0;
function $b428e590a835ea4b$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b428e590a835ea4b$var$Ec, $b428e590a835ea4b$var$Fc, $b428e590a835ea4b$var$Gc, $b428e590a835ea4b$var$Hc, $b428e590a835ea4b$var$Ic, $b428e590a835ea4b$var$Jc = !1, $b428e590a835ea4b$var$Kc = [], $b428e590a835ea4b$var$Lc = null, $b428e590a835ea4b$var$Mc = null, $b428e590a835ea4b$var$Nc = null, $b428e590a835ea4b$var$Oc = new Map, $b428e590a835ea4b$var$Pc = new Map, $b428e590a835ea4b$var$Qc = [], $b428e590a835ea4b$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b428e590a835ea4b$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b428e590a835ea4b$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b428e590a835ea4b$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b428e590a835ea4b$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b428e590a835ea4b$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b428e590a835ea4b$var$Pc.delete(b.pointerId);
    }
}
function $b428e590a835ea4b$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b428e590a835ea4b$var$Cb(b), null !== b && $b428e590a835ea4b$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b428e590a835ea4b$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b428e590a835ea4b$var$Lc = $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b428e590a835ea4b$var$Mc = $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b428e590a835ea4b$var$Nc = $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b428e590a835ea4b$var$Oc.set(f, $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b428e590a835ea4b$var$Pc.set(f, $b428e590a835ea4b$var$Tc($b428e590a835ea4b$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b428e590a835ea4b$var$Vc(a) {
    var b = $b428e590a835ea4b$var$Wc(a.target);
    if (null !== b) {
        var c = $b428e590a835ea4b$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b428e590a835ea4b$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b428e590a835ea4b$var$Ic(a.priority, function() {
                        $b428e590a835ea4b$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b428e590a835ea4b$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b428e590a835ea4b$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b428e590a835ea4b$var$wb = d;
            c.target.dispatchEvent(d);
            $b428e590a835ea4b$var$wb = null;
        } else return b = $b428e590a835ea4b$var$Cb(c), null !== b && $b428e590a835ea4b$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b428e590a835ea4b$var$Zc(a, b, c) {
    $b428e590a835ea4b$var$Xc(a) && c.delete(b);
}
function $b428e590a835ea4b$var$$c() {
    $b428e590a835ea4b$var$Jc = !1;
    null !== $b428e590a835ea4b$var$Lc && $b428e590a835ea4b$var$Xc($b428e590a835ea4b$var$Lc) && ($b428e590a835ea4b$var$Lc = null);
    null !== $b428e590a835ea4b$var$Mc && $b428e590a835ea4b$var$Xc($b428e590a835ea4b$var$Mc) && ($b428e590a835ea4b$var$Mc = null);
    null !== $b428e590a835ea4b$var$Nc && $b428e590a835ea4b$var$Xc($b428e590a835ea4b$var$Nc) && ($b428e590a835ea4b$var$Nc = null);
    $b428e590a835ea4b$var$Oc.forEach($b428e590a835ea4b$var$Zc);
    $b428e590a835ea4b$var$Pc.forEach($b428e590a835ea4b$var$Zc);
}
function $b428e590a835ea4b$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b428e590a835ea4b$var$Jc || ($b428e590a835ea4b$var$Jc = !0, $go0bk.unstable_scheduleCallback($go0bk.unstable_NormalPriority, $b428e590a835ea4b$var$$c)));
}
function $b428e590a835ea4b$var$bd(a) {
    function b(b) {
        return $b428e590a835ea4b$var$ad(b, a);
    }
    if (0 < $b428e590a835ea4b$var$Kc.length) {
        $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Kc[0], a);
        for(var c = 1; c < $b428e590a835ea4b$var$Kc.length; c++){
            var d = $b428e590a835ea4b$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b428e590a835ea4b$var$Lc && $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Lc, a);
    null !== $b428e590a835ea4b$var$Mc && $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Mc, a);
    null !== $b428e590a835ea4b$var$Nc && $b428e590a835ea4b$var$ad($b428e590a835ea4b$var$Nc, a);
    $b428e590a835ea4b$var$Oc.forEach(b);
    $b428e590a835ea4b$var$Pc.forEach(b);
    for(c = 0; c < $b428e590a835ea4b$var$Qc.length; c++)d = $b428e590a835ea4b$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b428e590a835ea4b$var$Qc.length && (c = $b428e590a835ea4b$var$Qc[0], null === c.blockedOn);)$b428e590a835ea4b$var$Vc(c), null === c.blockedOn && $b428e590a835ea4b$var$Qc.shift();
}
var $b428e590a835ea4b$var$cd = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig, $b428e590a835ea4b$var$dd = !0;
function $b428e590a835ea4b$var$ed(a, b, c, d) {
    var e = $b428e590a835ea4b$var$C, f = $b428e590a835ea4b$var$cd.transition;
    $b428e590a835ea4b$var$cd.transition = null;
    try {
        $b428e590a835ea4b$var$C = 1, $b428e590a835ea4b$var$fd(a, b, c, d);
    } finally{
        $b428e590a835ea4b$var$C = e, $b428e590a835ea4b$var$cd.transition = f;
    }
}
function $b428e590a835ea4b$var$gd(a, b, c, d) {
    var e = $b428e590a835ea4b$var$C, f = $b428e590a835ea4b$var$cd.transition;
    $b428e590a835ea4b$var$cd.transition = null;
    try {
        $b428e590a835ea4b$var$C = 4, $b428e590a835ea4b$var$fd(a, b, c, d);
    } finally{
        $b428e590a835ea4b$var$C = e, $b428e590a835ea4b$var$cd.transition = f;
    }
}
function $b428e590a835ea4b$var$fd(a, b, c, d) {
    if ($b428e590a835ea4b$var$dd) {
        var e = $b428e590a835ea4b$var$Yc(a, b, c, d);
        if (null === e) $b428e590a835ea4b$var$hd(a, b, d, $b428e590a835ea4b$var$id, c), $b428e590a835ea4b$var$Sc(a, d);
        else if ($b428e590a835ea4b$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b428e590a835ea4b$var$Sc(a, d), b & 4 && -1 < $b428e590a835ea4b$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b428e590a835ea4b$var$Cb(e);
                null !== f && $b428e590a835ea4b$var$Ec(f);
                f = $b428e590a835ea4b$var$Yc(a, b, c, d);
                null === f && $b428e590a835ea4b$var$hd(a, b, d, $b428e590a835ea4b$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b428e590a835ea4b$var$hd(a, b, d, null, c);
    }
}
var $b428e590a835ea4b$var$id = null;
function $b428e590a835ea4b$var$Yc(a, b, c, d) {
    $b428e590a835ea4b$var$id = null;
    a = $b428e590a835ea4b$var$xb(d);
    a = $b428e590a835ea4b$var$Wc(a);
    if (null !== a) {
        if (b = $b428e590a835ea4b$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b428e590a835ea4b$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b428e590a835ea4b$var$id = a;
    return null;
}
function $b428e590a835ea4b$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b428e590a835ea4b$var$ec()){
                case $b428e590a835ea4b$var$fc:
                    return 1;
                case $b428e590a835ea4b$var$gc:
                    return 4;
                case $b428e590a835ea4b$var$hc:
                case $b428e590a835ea4b$var$ic:
                    return 16;
                case $b428e590a835ea4b$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b428e590a835ea4b$var$kd = null, $b428e590a835ea4b$var$ld = null, $b428e590a835ea4b$var$md = null;
function $b428e590a835ea4b$var$nd() {
    if ($b428e590a835ea4b$var$md) return $b428e590a835ea4b$var$md;
    var a, b = $b428e590a835ea4b$var$ld, c = b.length, d, e = "value" in $b428e590a835ea4b$var$kd ? $b428e590a835ea4b$var$kd.value : $b428e590a835ea4b$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b428e590a835ea4b$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b428e590a835ea4b$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b428e590a835ea4b$var$pd() {
    return !0;
}
function $b428e590a835ea4b$var$qd() {
    return !1;
}
function $b428e590a835ea4b$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b428e590a835ea4b$var$pd : $b428e590a835ea4b$var$qd;
        this.isPropagationStopped = $b428e590a835ea4b$var$qd;
        return this;
    }
    $b428e590a835ea4b$var$A(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $YtE9h._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $b428e590a835ea4b$var$pd);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $YtE9h._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $b428e590a835ea4b$var$pd);
        },
        persist: function persist() {},
        isPersistent: $b428e590a835ea4b$var$pd
    });
    return b;
}
var $b428e590a835ea4b$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b428e590a835ea4b$var$td = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$sd), $b428e590a835ea4b$var$ud = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    view: 0,
    detail: 0
}), $b428e590a835ea4b$var$vd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$ud), $b428e590a835ea4b$var$wd, $b428e590a835ea4b$var$xd, $b428e590a835ea4b$var$yd, $b428e590a835ea4b$var$Ad = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b428e590a835ea4b$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b428e590a835ea4b$var$yd && ($b428e590a835ea4b$var$yd && "mousemove" === a.type ? ($b428e590a835ea4b$var$wd = a.screenX - $b428e590a835ea4b$var$yd.screenX, $b428e590a835ea4b$var$xd = a.screenY - $b428e590a835ea4b$var$yd.screenY) : $b428e590a835ea4b$var$xd = $b428e590a835ea4b$var$wd = 0, $b428e590a835ea4b$var$yd = a);
        return $b428e590a835ea4b$var$wd;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $b428e590a835ea4b$var$xd;
    }
}), $b428e590a835ea4b$var$Bd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Ad), $b428e590a835ea4b$var$Cd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$Ad, {
    dataTransfer: 0
}), $b428e590a835ea4b$var$Dd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Cd), $b428e590a835ea4b$var$Ed = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    relatedTarget: 0
}), $b428e590a835ea4b$var$Fd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Ed), $b428e590a835ea4b$var$Gd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b428e590a835ea4b$var$Hd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Gd), $b428e590a835ea4b$var$Id = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b428e590a835ea4b$var$Jd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Id), $b428e590a835ea4b$var$Kd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    data: 0
}), $b428e590a835ea4b$var$Ld = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Kd), $b428e590a835ea4b$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b428e590a835ea4b$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b428e590a835ea4b$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b428e590a835ea4b$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b428e590a835ea4b$var$Od[a]) ? !!b[a] : !1;
}
function $b428e590a835ea4b$var$zd() {
    return $b428e590a835ea4b$var$Pd;
}
var $b428e590a835ea4b$var$Qd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    key: function key(a) {
        if (a.key) {
            var b = $b428e590a835ea4b$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b428e590a835ea4b$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b428e590a835ea4b$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b428e590a835ea4b$var$zd,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $b428e590a835ea4b$var$od(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $b428e590a835ea4b$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b428e590a835ea4b$var$Rd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Qd), $b428e590a835ea4b$var$Sd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b428e590a835ea4b$var$Td = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Sd), $b428e590a835ea4b$var$Ud = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b428e590a835ea4b$var$zd
}), $b428e590a835ea4b$var$Vd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Ud), $b428e590a835ea4b$var$Wd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b428e590a835ea4b$var$Xd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Wd), $b428e590a835ea4b$var$Yd = $b428e590a835ea4b$var$A({}, $b428e590a835ea4b$var$Ad, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b428e590a835ea4b$var$Zd = $b428e590a835ea4b$var$rd($b428e590a835ea4b$var$Yd), $b428e590a835ea4b$var$$d = [
    9,
    13,
    27,
    32
], $b428e590a835ea4b$var$ae = $b428e590a835ea4b$var$ia && "CompositionEvent" in window, $b428e590a835ea4b$var$be = null;
$b428e590a835ea4b$var$ia && "documentMode" in document && ($b428e590a835ea4b$var$be = document.documentMode);
var $b428e590a835ea4b$var$ce = $b428e590a835ea4b$var$ia && "TextEvent" in window && !$b428e590a835ea4b$var$be, $b428e590a835ea4b$var$de = $b428e590a835ea4b$var$ia && (!$b428e590a835ea4b$var$ae || $b428e590a835ea4b$var$be && 8 < $b428e590a835ea4b$var$be && 11 >= $b428e590a835ea4b$var$be), $b428e590a835ea4b$var$ee = String.fromCharCode(32), $b428e590a835ea4b$var$fe = !1;
function $b428e590a835ea4b$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b428e590a835ea4b$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b428e590a835ea4b$var$he(a) {
    a = a.detail;
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && "data" in a ? a.data : null;
}
var $b428e590a835ea4b$var$ie = !1;
function $b428e590a835ea4b$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b428e590a835ea4b$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b428e590a835ea4b$var$fe = !0;
            return $b428e590a835ea4b$var$ee;
        case "textInput":
            return a = b.data, a === $b428e590a835ea4b$var$ee && $b428e590a835ea4b$var$fe ? null : a;
        default:
            return null;
    }
}
function $b428e590a835ea4b$var$ke(a, b) {
    if ($b428e590a835ea4b$var$ie) return "compositionend" === a || !$b428e590a835ea4b$var$ae && $b428e590a835ea4b$var$ge(a, b) ? (a = $b428e590a835ea4b$var$nd(), $b428e590a835ea4b$var$md = $b428e590a835ea4b$var$ld = $b428e590a835ea4b$var$kd = null, $b428e590a835ea4b$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b428e590a835ea4b$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b428e590a835ea4b$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b428e590a835ea4b$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b428e590a835ea4b$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b428e590a835ea4b$var$ne(a, b, c, d) {
    $b428e590a835ea4b$var$Eb(d);
    b = $b428e590a835ea4b$var$oe(b, "onChange");
    0 < b.length && (c = new $b428e590a835ea4b$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b428e590a835ea4b$var$pe = null, $b428e590a835ea4b$var$qe = null;
function $b428e590a835ea4b$var$re(a) {
    $b428e590a835ea4b$var$se(a, 0);
}
function $b428e590a835ea4b$var$te(a) {
    var b = $b428e590a835ea4b$var$ue(a);
    if ($b428e590a835ea4b$var$Wa(b)) return a;
}
function $b428e590a835ea4b$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b428e590a835ea4b$var$we = !1;
if ($b428e590a835ea4b$var$ia) {
    var $b428e590a835ea4b$var$xe;
    if ($b428e590a835ea4b$var$ia) {
        var $b428e590a835ea4b$var$ye = "oninput" in document;
        if (!$b428e590a835ea4b$var$ye) {
            var $b428e590a835ea4b$var$ze = document.createElement("div");
            $b428e590a835ea4b$var$ze.setAttribute("oninput", "return;");
            $b428e590a835ea4b$var$ye = "function" === typeof $b428e590a835ea4b$var$ze.oninput;
        }
        $b428e590a835ea4b$var$xe = $b428e590a835ea4b$var$ye;
    } else $b428e590a835ea4b$var$xe = !1;
    $b428e590a835ea4b$var$we = $b428e590a835ea4b$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b428e590a835ea4b$var$Ae() {
    $b428e590a835ea4b$var$pe && ($b428e590a835ea4b$var$pe.detachEvent("onpropertychange", $b428e590a835ea4b$var$Be), $b428e590a835ea4b$var$qe = $b428e590a835ea4b$var$pe = null);
}
function $b428e590a835ea4b$var$Be(a) {
    if ("value" === a.propertyName && $b428e590a835ea4b$var$te($b428e590a835ea4b$var$qe)) {
        var b = [];
        $b428e590a835ea4b$var$ne(b, $b428e590a835ea4b$var$qe, a, $b428e590a835ea4b$var$xb(a));
        $b428e590a835ea4b$var$Jb($b428e590a835ea4b$var$re, b);
    }
}
function $b428e590a835ea4b$var$Ce(a, b, c) {
    "focusin" === a ? ($b428e590a835ea4b$var$Ae(), $b428e590a835ea4b$var$pe = b, $b428e590a835ea4b$var$qe = c, $b428e590a835ea4b$var$pe.attachEvent("onpropertychange", $b428e590a835ea4b$var$Be)) : "focusout" === a && $b428e590a835ea4b$var$Ae();
}
function $b428e590a835ea4b$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b428e590a835ea4b$var$te($b428e590a835ea4b$var$qe);
}
function $b428e590a835ea4b$var$Ee(a, b) {
    if ("click" === a) return $b428e590a835ea4b$var$te(b);
}
function $b428e590a835ea4b$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b428e590a835ea4b$var$te(b);
}
function $b428e590a835ea4b$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b428e590a835ea4b$var$He = "function" === typeof Object.is ? Object.is : $b428e590a835ea4b$var$Ge;
function $b428e590a835ea4b$var$Ie(a, b) {
    if ($b428e590a835ea4b$var$He(a, b)) return !0;
    if ("object" !== (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) || null === a || "object" !== (typeof b === "undefined" ? "undefined" : (0, $YtE9h._)(b)) || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b428e590a835ea4b$var$ja.call(b, e) || !$b428e590a835ea4b$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b428e590a835ea4b$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b428e590a835ea4b$var$Ke(a, b) {
    var c = $b428e590a835ea4b$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b428e590a835ea4b$var$Je(c);
    }
}
function $b428e590a835ea4b$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b428e590a835ea4b$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b428e590a835ea4b$var$Me() {
    for(var a = window, b = $b428e590a835ea4b$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b428e590a835ea4b$var$Xa(a.document);
    }
    return b;
}
function $b428e590a835ea4b$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b428e590a835ea4b$var$Oe(a) {
    var b = $b428e590a835ea4b$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b428e590a835ea4b$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b428e590a835ea4b$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b428e590a835ea4b$var$Ke(c, f);
                var g = $b428e590a835ea4b$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b428e590a835ea4b$var$Pe = $b428e590a835ea4b$var$ia && "documentMode" in document && 11 >= document.documentMode, $b428e590a835ea4b$var$Qe = null, $b428e590a835ea4b$var$Re = null, $b428e590a835ea4b$var$Se = null, $b428e590a835ea4b$var$Te = !1;
function $b428e590a835ea4b$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b428e590a835ea4b$var$Te || null == $b428e590a835ea4b$var$Qe || $b428e590a835ea4b$var$Qe !== $b428e590a835ea4b$var$Xa(d) || (d = $b428e590a835ea4b$var$Qe, "selectionStart" in d && $b428e590a835ea4b$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b428e590a835ea4b$var$Se && $b428e590a835ea4b$var$Ie($b428e590a835ea4b$var$Se, d) || ($b428e590a835ea4b$var$Se = d, d = $b428e590a835ea4b$var$oe($b428e590a835ea4b$var$Re, "onSelect"), 0 < d.length && (b = new $b428e590a835ea4b$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b428e590a835ea4b$var$Qe)));
}
function $b428e590a835ea4b$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b428e590a835ea4b$var$We = {
    animationend: $b428e590a835ea4b$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b428e590a835ea4b$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b428e590a835ea4b$var$Ve("Animation", "AnimationStart"),
    transitionend: $b428e590a835ea4b$var$Ve("Transition", "TransitionEnd")
}, $b428e590a835ea4b$var$Xe = {}, $b428e590a835ea4b$var$Ye = {};
$b428e590a835ea4b$var$ia && ($b428e590a835ea4b$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b428e590a835ea4b$var$We.animationend.animation, delete $b428e590a835ea4b$var$We.animationiteration.animation, delete $b428e590a835ea4b$var$We.animationstart.animation), "TransitionEvent" in window || delete $b428e590a835ea4b$var$We.transitionend.transition);
function $b428e590a835ea4b$var$Ze(a) {
    if ($b428e590a835ea4b$var$Xe[a]) return $b428e590a835ea4b$var$Xe[a];
    if (!$b428e590a835ea4b$var$We[a]) return a;
    var b = $b428e590a835ea4b$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b428e590a835ea4b$var$Ye) return $b428e590a835ea4b$var$Xe[a] = b[c];
    return a;
}
var $b428e590a835ea4b$var$$e = $b428e590a835ea4b$var$Ze("animationend"), $b428e590a835ea4b$var$af = $b428e590a835ea4b$var$Ze("animationiteration"), $b428e590a835ea4b$var$bf = $b428e590a835ea4b$var$Ze("animationstart"), $b428e590a835ea4b$var$cf = $b428e590a835ea4b$var$Ze("transitionend"), $b428e590a835ea4b$var$df = new Map, $b428e590a835ea4b$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b428e590a835ea4b$var$ff(a, b) {
    $b428e590a835ea4b$var$df.set(a, b);
    $b428e590a835ea4b$var$fa(b, [
        a
    ]);
}
for(var $b428e590a835ea4b$var$gf = 0; $b428e590a835ea4b$var$gf < $b428e590a835ea4b$var$ef.length; $b428e590a835ea4b$var$gf++){
    var $b428e590a835ea4b$var$hf = $b428e590a835ea4b$var$ef[$b428e590a835ea4b$var$gf], $b428e590a835ea4b$var$jf = $b428e590a835ea4b$var$hf.toLowerCase(), $b428e590a835ea4b$var$kf = $b428e590a835ea4b$var$hf[0].toUpperCase() + $b428e590a835ea4b$var$hf.slice(1);
    $b428e590a835ea4b$var$ff($b428e590a835ea4b$var$jf, "on" + $b428e590a835ea4b$var$kf);
}
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$$e, "onAnimationEnd");
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$af, "onAnimationIteration");
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$bf, "onAnimationStart");
$b428e590a835ea4b$var$ff("dblclick", "onDoubleClick");
$b428e590a835ea4b$var$ff("focusin", "onFocus");
$b428e590a835ea4b$var$ff("focusout", "onBlur");
$b428e590a835ea4b$var$ff($b428e590a835ea4b$var$cf, "onTransitionEnd");
$b428e590a835ea4b$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b428e590a835ea4b$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b428e590a835ea4b$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b428e590a835ea4b$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b428e590a835ea4b$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b428e590a835ea4b$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b428e590a835ea4b$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b428e590a835ea4b$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b428e590a835ea4b$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b428e590a835ea4b$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b428e590a835ea4b$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b428e590a835ea4b$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b428e590a835ea4b$var$lf));
function $b428e590a835ea4b$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b428e590a835ea4b$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b428e590a835ea4b$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b428e590a835ea4b$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b428e590a835ea4b$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b428e590a835ea4b$var$Qb) throw a = $b428e590a835ea4b$var$Rb, $b428e590a835ea4b$var$Qb = !1, $b428e590a835ea4b$var$Rb = null, a;
}
function $b428e590a835ea4b$var$D(a, b) {
    var c = b[$b428e590a835ea4b$var$of];
    void 0 === c && (c = b[$b428e590a835ea4b$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b428e590a835ea4b$var$pf(b, a, 2, !1), c.add(d));
}
function $b428e590a835ea4b$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b428e590a835ea4b$var$pf(c, a, d, b);
}
var $b428e590a835ea4b$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b428e590a835ea4b$var$sf(a) {
    if (!a[$b428e590a835ea4b$var$rf]) {
        a[$b428e590a835ea4b$var$rf] = !0;
        $b428e590a835ea4b$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b428e590a835ea4b$var$mf.has(b) || $b428e590a835ea4b$var$qf(b, !1, a), $b428e590a835ea4b$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b428e590a835ea4b$var$rf] || (b[$b428e590a835ea4b$var$rf] = !0, $b428e590a835ea4b$var$qf("selectionchange", !1, b));
    }
}
function $b428e590a835ea4b$var$pf(a, b, c, d) {
    switch($b428e590a835ea4b$var$jd(b)){
        case 1:
            var e = $b428e590a835ea4b$var$ed;
            break;
        case 4:
            e = $b428e590a835ea4b$var$gd;
            break;
        default:
            e = $b428e590a835ea4b$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b428e590a835ea4b$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b428e590a835ea4b$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b428e590a835ea4b$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b428e590a835ea4b$var$Jb(function() {
        var _$d = f, _$e = $b428e590a835ea4b$var$xb(c), g = [];
        a: {
            var h = $b428e590a835ea4b$var$df.get(a);
            if (void 0 !== h) {
                var k = $b428e590a835ea4b$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b428e590a835ea4b$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b428e590a835ea4b$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b428e590a835ea4b$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b428e590a835ea4b$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b428e590a835ea4b$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b428e590a835ea4b$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b428e590a835ea4b$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b428e590a835ea4b$var$Vd;
                        break;
                    case $b428e590a835ea4b$var$$e:
                    case $b428e590a835ea4b$var$af:
                    case $b428e590a835ea4b$var$bf:
                        k = $b428e590a835ea4b$var$Hd;
                        break;
                    case $b428e590a835ea4b$var$cf:
                        k = $b428e590a835ea4b$var$Xd;
                        break;
                    case "scroll":
                        k = $b428e590a835ea4b$var$vd;
                        break;
                    case "wheel":
                        k = $b428e590a835ea4b$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b428e590a835ea4b$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b428e590a835ea4b$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = _$d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b428e590a835ea4b$var$Kb(w, x), null != F && t.push($b428e590a835ea4b$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, _$e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b428e590a835ea4b$var$wb && (n = c.relatedTarget || c.fromElement) && ($b428e590a835ea4b$var$Wc(n) || n[$b428e590a835ea4b$var$uf])) break a;
                if (k || h) {
                    h = _$e.window === _$e ? _$e : (h = _$e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = _$d, n = n ? $b428e590a835ea4b$var$Wc(n) : null, null !== n && (J = $b428e590a835ea4b$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = _$d;
                    if (k !== n) {
                        t = $b428e590a835ea4b$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b428e590a835ea4b$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b428e590a835ea4b$var$ue(k);
                        u = null == n ? h : $b428e590a835ea4b$var$ue(n);
                        h = new t(F, w + "leave", k, c, _$e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b428e590a835ea4b$var$Wc(_$e) === _$d && (t = new t(x, w + "enter", n, c, _$e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b428e590a835ea4b$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b428e590a835ea4b$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b428e590a835ea4b$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b428e590a835ea4b$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b428e590a835ea4b$var$vf(t);
                                x = $b428e590a835ea4b$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b428e590a835ea4b$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b428e590a835ea4b$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = _$d ? $b428e590a835ea4b$var$ue(_$d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b428e590a835ea4b$var$ve;
                else if ($b428e590a835ea4b$var$me(h)) {
                    if ($b428e590a835ea4b$var$we) na = $b428e590a835ea4b$var$Fe;
                    else {
                        na = $b428e590a835ea4b$var$De;
                        var xa = $b428e590a835ea4b$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b428e590a835ea4b$var$Ee);
                if (na && (na = na(a, _$d))) {
                    $b428e590a835ea4b$var$ne(g, na, c, _$e);
                    break a;
                }
                xa && xa(a, h, _$d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b428e590a835ea4b$var$cb(h, "number", h.value);
            }
            xa = _$d ? $b428e590a835ea4b$var$ue(_$d) : window;
            switch(a){
                case "focusin":
                    if ($b428e590a835ea4b$var$me(xa) || "true" === xa.contentEditable) $b428e590a835ea4b$var$Qe = xa, $b428e590a835ea4b$var$Re = _$d, $b428e590a835ea4b$var$Se = null;
                    break;
                case "focusout":
                    $b428e590a835ea4b$var$Se = $b428e590a835ea4b$var$Re = $b428e590a835ea4b$var$Qe = null;
                    break;
                case "mousedown":
                    $b428e590a835ea4b$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b428e590a835ea4b$var$Te = !1;
                    $b428e590a835ea4b$var$Ue(g, c, _$e);
                    break;
                case "selectionchange":
                    if ($b428e590a835ea4b$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b428e590a835ea4b$var$Ue(g, c, _$e);
            }
            var $a;
            if ($b428e590a835ea4b$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b428e590a835ea4b$var$ie ? $b428e590a835ea4b$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b428e590a835ea4b$var$de && "ko" !== c.locale && ($b428e590a835ea4b$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b428e590a835ea4b$var$ie && ($a = $b428e590a835ea4b$var$nd()) : ($b428e590a835ea4b$var$kd = _$e, $b428e590a835ea4b$var$ld = "value" in $b428e590a835ea4b$var$kd ? $b428e590a835ea4b$var$kd.value : $b428e590a835ea4b$var$kd.textContent, $b428e590a835ea4b$var$ie = !0)), xa = $b428e590a835ea4b$var$oe(_$d, ba), 0 < xa.length && (ba = new $b428e590a835ea4b$var$Ld(ba, a, null, c, _$e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b428e590a835ea4b$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b428e590a835ea4b$var$ce ? $b428e590a835ea4b$var$je(a, c) : $b428e590a835ea4b$var$ke(a, c)) _$d = $b428e590a835ea4b$var$oe(_$d, "onBeforeInput"), 0 < _$d.length && (_$e = new $b428e590a835ea4b$var$Ld("onBeforeInput", "beforeinput", null, c, _$e), g.push({
                event: _$e,
                listeners: _$d
            }), _$e.data = $a);
        }
        $b428e590a835ea4b$var$se(g, b);
    });
}
function $b428e590a835ea4b$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b428e590a835ea4b$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b428e590a835ea4b$var$Kb(a, c), null != f && d.unshift($b428e590a835ea4b$var$tf(a, f, e)), f = $b428e590a835ea4b$var$Kb(a, b), null != f && d.push($b428e590a835ea4b$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b428e590a835ea4b$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b428e590a835ea4b$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b428e590a835ea4b$var$Kb(c, f), null != k && g.unshift($b428e590a835ea4b$var$tf(c, k, h))) : e || (k = $b428e590a835ea4b$var$Kb(c, f), null != k && g.push($b428e590a835ea4b$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b428e590a835ea4b$var$xf = /\r\n?/g, $b428e590a835ea4b$var$yf = /\u0000|\uFFFD/g;
function $b428e590a835ea4b$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b428e590a835ea4b$var$xf, "\n").replace($b428e590a835ea4b$var$yf, "");
}
function $b428e590a835ea4b$var$Af(a, b, c) {
    b = $b428e590a835ea4b$var$zf(b);
    if ($b428e590a835ea4b$var$zf(a) !== b && c) throw Error($b428e590a835ea4b$var$p(425));
}
function $b428e590a835ea4b$var$Bf() {}
var $b428e590a835ea4b$var$Cf = null, $b428e590a835ea4b$var$Df = null;
function $b428e590a835ea4b$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === (0, $YtE9h._)(b.dangerouslySetInnerHTML) && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b428e590a835ea4b$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b428e590a835ea4b$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b428e590a835ea4b$var$Hf = "function" === typeof Promise ? Promise : void 0, $b428e590a835ea4b$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b428e590a835ea4b$var$Hf ? function Jf(a) {
    return $b428e590a835ea4b$var$Hf.resolve(null).then(a).catch($b428e590a835ea4b$var$If);
} : $b428e590a835ea4b$var$Ff;
function $b428e590a835ea4b$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b428e590a835ea4b$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b428e590a835ea4b$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b428e590a835ea4b$var$bd(b);
}
function $b428e590a835ea4b$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b428e590a835ea4b$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b428e590a835ea4b$var$Nf = Math.random().toString(36).slice(2), $b428e590a835ea4b$var$Of = "__reactFiber$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$Pf = "__reactProps$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$uf = "__reactContainer$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$of = "__reactEvents$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$Qf = "__reactListeners$" + $b428e590a835ea4b$var$Nf, $b428e590a835ea4b$var$Rf = "__reactHandles$" + $b428e590a835ea4b$var$Nf;
function $b428e590a835ea4b$var$Wc(a) {
    var b = a[$b428e590a835ea4b$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b428e590a835ea4b$var$uf] || c[$b428e590a835ea4b$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b428e590a835ea4b$var$Mf(a); null !== a;){
                if (c = a[$b428e590a835ea4b$var$Of]) return c;
                a = $b428e590a835ea4b$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b428e590a835ea4b$var$Cb(a) {
    a = a[$b428e590a835ea4b$var$Of] || a[$b428e590a835ea4b$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b428e590a835ea4b$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b428e590a835ea4b$var$p(33));
}
function $b428e590a835ea4b$var$Db(a) {
    return a[$b428e590a835ea4b$var$Pf] || null;
}
var $b428e590a835ea4b$var$Sf = [], $b428e590a835ea4b$var$Tf = -1;
function $b428e590a835ea4b$var$Uf(a) {
    return {
        current: a
    };
}
function $b428e590a835ea4b$var$E(a) {
    0 > $b428e590a835ea4b$var$Tf || (a.current = $b428e590a835ea4b$var$Sf[$b428e590a835ea4b$var$Tf], $b428e590a835ea4b$var$Sf[$b428e590a835ea4b$var$Tf] = null, $b428e590a835ea4b$var$Tf--);
}
function $b428e590a835ea4b$var$G(a, b) {
    $b428e590a835ea4b$var$Tf++;
    $b428e590a835ea4b$var$Sf[$b428e590a835ea4b$var$Tf] = a.current;
    a.current = b;
}
var $b428e590a835ea4b$var$Vf = {}, $b428e590a835ea4b$var$H = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$Vf), $b428e590a835ea4b$var$Wf = $b428e590a835ea4b$var$Uf(!1), $b428e590a835ea4b$var$Xf = $b428e590a835ea4b$var$Vf;
function $b428e590a835ea4b$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b428e590a835ea4b$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b428e590a835ea4b$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b428e590a835ea4b$var$$f() {
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H);
}
function $b428e590a835ea4b$var$ag(a, b, c) {
    if ($b428e590a835ea4b$var$H.current !== $b428e590a835ea4b$var$Vf) throw Error($b428e590a835ea4b$var$p(168));
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$H, b);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wf, c);
}
function $b428e590a835ea4b$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b428e590a835ea4b$var$p(108, $b428e590a835ea4b$var$Ra(a) || "Unknown", e));
    return $b428e590a835ea4b$var$A({}, c, d);
}
function $b428e590a835ea4b$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b428e590a835ea4b$var$Vf;
    $b428e590a835ea4b$var$Xf = $b428e590a835ea4b$var$H.current;
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$H, a);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wf, $b428e590a835ea4b$var$Wf.current);
    return !0;
}
function $b428e590a835ea4b$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b428e590a835ea4b$var$p(169));
    c ? (a = $b428e590a835ea4b$var$bg(a, b, $b428e590a835ea4b$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H), $b428e590a835ea4b$var$G($b428e590a835ea4b$var$H, a)) : $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wf, c);
}
var $b428e590a835ea4b$var$eg = null, $b428e590a835ea4b$var$fg = !1, $b428e590a835ea4b$var$gg = !1;
function $b428e590a835ea4b$var$hg(a) {
    null === $b428e590a835ea4b$var$eg ? $b428e590a835ea4b$var$eg = [
        a
    ] : $b428e590a835ea4b$var$eg.push(a);
}
function $b428e590a835ea4b$var$ig(a) {
    $b428e590a835ea4b$var$fg = !0;
    $b428e590a835ea4b$var$hg(a);
}
function $b428e590a835ea4b$var$jg() {
    if (!$b428e590a835ea4b$var$gg && null !== $b428e590a835ea4b$var$eg) {
        $b428e590a835ea4b$var$gg = !0;
        var a = 0, b = $b428e590a835ea4b$var$C;
        try {
            var c = $b428e590a835ea4b$var$eg;
            for($b428e590a835ea4b$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b428e590a835ea4b$var$eg = null;
            $b428e590a835ea4b$var$fg = !1;
        } catch (e) {
            throw null !== $b428e590a835ea4b$var$eg && ($b428e590a835ea4b$var$eg = $b428e590a835ea4b$var$eg.slice(a + 1)), $b428e590a835ea4b$var$ac($b428e590a835ea4b$var$fc, $b428e590a835ea4b$var$jg), e;
        } finally{
            $b428e590a835ea4b$var$C = b, $b428e590a835ea4b$var$gg = !1;
        }
    }
    return null;
}
var $b428e590a835ea4b$var$kg = [], $b428e590a835ea4b$var$lg = 0, $b428e590a835ea4b$var$mg = null, $b428e590a835ea4b$var$ng = 0, $b428e590a835ea4b$var$og = [], $b428e590a835ea4b$var$pg = 0, $b428e590a835ea4b$var$qg = null, $b428e590a835ea4b$var$rg = 1, $b428e590a835ea4b$var$sg = "";
function $b428e590a835ea4b$var$tg(a, b) {
    $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg++] = $b428e590a835ea4b$var$ng;
    $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg++] = $b428e590a835ea4b$var$mg;
    $b428e590a835ea4b$var$mg = a;
    $b428e590a835ea4b$var$ng = b;
}
function $b428e590a835ea4b$var$ug(a, b, c) {
    $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$rg;
    $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$sg;
    $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$qg;
    $b428e590a835ea4b$var$qg = a;
    var d = $b428e590a835ea4b$var$rg;
    a = $b428e590a835ea4b$var$sg;
    var e = 32 - $b428e590a835ea4b$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b428e590a835ea4b$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b428e590a835ea4b$var$rg = 1 << 32 - $b428e590a835ea4b$var$oc(b) + e | c << e | d;
        $b428e590a835ea4b$var$sg = f + a;
    } else $b428e590a835ea4b$var$rg = 1 << f | c << e | d, $b428e590a835ea4b$var$sg = a;
}
function $b428e590a835ea4b$var$vg(a) {
    null !== a.return && ($b428e590a835ea4b$var$tg(a, 1), $b428e590a835ea4b$var$ug(a, 1, 0));
}
function $b428e590a835ea4b$var$wg(a) {
    for(; a === $b428e590a835ea4b$var$mg;)$b428e590a835ea4b$var$mg = $b428e590a835ea4b$var$kg[--$b428e590a835ea4b$var$lg], $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg] = null, $b428e590a835ea4b$var$ng = $b428e590a835ea4b$var$kg[--$b428e590a835ea4b$var$lg], $b428e590a835ea4b$var$kg[$b428e590a835ea4b$var$lg] = null;
    for(; a === $b428e590a835ea4b$var$qg;)$b428e590a835ea4b$var$qg = $b428e590a835ea4b$var$og[--$b428e590a835ea4b$var$pg], $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg] = null, $b428e590a835ea4b$var$sg = $b428e590a835ea4b$var$og[--$b428e590a835ea4b$var$pg], $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg] = null, $b428e590a835ea4b$var$rg = $b428e590a835ea4b$var$og[--$b428e590a835ea4b$var$pg], $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg] = null;
}
var $b428e590a835ea4b$var$xg = null, $b428e590a835ea4b$var$yg = null, $b428e590a835ea4b$var$I = !1, $b428e590a835ea4b$var$zg = null;
function $b428e590a835ea4b$var$Ag(a, b) {
    var c = $b428e590a835ea4b$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b428e590a835ea4b$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b428e590a835ea4b$var$xg = a, $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b428e590a835ea4b$var$xg = a, $b428e590a835ea4b$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b428e590a835ea4b$var$qg ? {
                id: $b428e590a835ea4b$var$rg,
                overflow: $b428e590a835ea4b$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b428e590a835ea4b$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b428e590a835ea4b$var$xg = a, $b428e590a835ea4b$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b428e590a835ea4b$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b428e590a835ea4b$var$Eg(a) {
    if ($b428e590a835ea4b$var$I) {
        var b = $b428e590a835ea4b$var$yg;
        if (b) {
            var c = b;
            if (!$b428e590a835ea4b$var$Cg(a, b)) {
                if ($b428e590a835ea4b$var$Dg(a)) throw Error($b428e590a835ea4b$var$p(418));
                b = $b428e590a835ea4b$var$Lf(c.nextSibling);
                var d = $b428e590a835ea4b$var$xg;
                b && $b428e590a835ea4b$var$Cg(a, b) ? $b428e590a835ea4b$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b428e590a835ea4b$var$I = !1, $b428e590a835ea4b$var$xg = a);
            }
        } else {
            if ($b428e590a835ea4b$var$Dg(a)) throw Error($b428e590a835ea4b$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b428e590a835ea4b$var$I = !1;
            $b428e590a835ea4b$var$xg = a;
        }
    }
}
function $b428e590a835ea4b$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b428e590a835ea4b$var$xg = a;
}
function $b428e590a835ea4b$var$Gg(a) {
    if (a !== $b428e590a835ea4b$var$xg) return !1;
    if (!$b428e590a835ea4b$var$I) return $b428e590a835ea4b$var$Fg(a), $b428e590a835ea4b$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b428e590a835ea4b$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b428e590a835ea4b$var$yg)) {
        if ($b428e590a835ea4b$var$Dg(a)) throw $b428e590a835ea4b$var$Hg(), Error($b428e590a835ea4b$var$p(418));
        for(; b;)$b428e590a835ea4b$var$Ag(a, b), b = $b428e590a835ea4b$var$Lf(b.nextSibling);
    }
    $b428e590a835ea4b$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b428e590a835ea4b$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b428e590a835ea4b$var$yg = null;
        }
    } else $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$xg ? $b428e590a835ea4b$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b428e590a835ea4b$var$Hg() {
    for(var a = $b428e590a835ea4b$var$yg; a;)a = $b428e590a835ea4b$var$Lf(a.nextSibling);
}
function $b428e590a835ea4b$var$Ig() {
    $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$xg = null;
    $b428e590a835ea4b$var$I = !1;
}
function $b428e590a835ea4b$var$Jg(a) {
    null === $b428e590a835ea4b$var$zg ? $b428e590a835ea4b$var$zg = [
        a
    ] : $b428e590a835ea4b$var$zg.push(a);
}
var $b428e590a835ea4b$var$Kg = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig;
function $b428e590a835ea4b$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a))) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b428e590a835ea4b$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b428e590a835ea4b$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function b(a) {
                var _$b = e.refs;
                null === a ? delete _$b[f] : _$b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b428e590a835ea4b$var$p(284));
        if (!c._owner) throw Error($b428e590a835ea4b$var$p(290, a));
    }
    return a;
}
function $b428e590a835ea4b$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b428e590a835ea4b$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b428e590a835ea4b$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $b428e590a835ea4b$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b428e590a835ea4b$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b428e590a835ea4b$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b428e590a835ea4b$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === (typeof f === "undefined" ? "undefined" : (0, $YtE9h._)(f)) && null !== f && f.$$typeof === $b428e590a835ea4b$var$Ha && $b428e590a835ea4b$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $b428e590a835ea4b$var$Lg(a, b, c), d.return = a, d;
        d = $b428e590a835ea4b$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b428e590a835ea4b$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b428e590a835ea4b$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b428e590a835ea4b$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b428e590a835ea4b$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === (typeof b === "undefined" ? "undefined" : (0, $YtE9h._)(b)) && null !== b) {
            switch(b.$$typeof){
                case $b428e590a835ea4b$var$va:
                    return c = $b428e590a835ea4b$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $b428e590a835ea4b$var$Lg(a, null, b), c.return = a, c;
                case $b428e590a835ea4b$var$wa:
                    return b = $b428e590a835ea4b$var$Sg(b, a.mode, c), b.return = a, b;
                case $b428e590a835ea4b$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b428e590a835ea4b$var$eb(b) || $b428e590a835ea4b$var$Ka(b)) return b = $b428e590a835ea4b$var$Tg(b, a.mode, c, null), b.return = a, b;
            $b428e590a835ea4b$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === (typeof c === "undefined" ? "undefined" : (0, $YtE9h._)(c)) && null !== c) {
            switch(c.$$typeof){
                case $b428e590a835ea4b$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b428e590a835ea4b$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b428e590a835ea4b$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b428e590a835ea4b$var$eb(c) || $b428e590a835ea4b$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b428e590a835ea4b$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === (typeof d === "undefined" ? "undefined" : (0, $YtE9h._)(d)) && null !== d) {
            switch(d.$$typeof){
                case $b428e590a835ea4b$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b428e590a835ea4b$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b428e590a835ea4b$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b428e590a835ea4b$var$eb(d) || $b428e590a835ea4b$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b428e590a835ea4b$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b428e590a835ea4b$var$Ka(h);
        if ("function" !== typeof l) throw Error($b428e590a835ea4b$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b428e590a835ea4b$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b428e590a835ea4b$var$I && $b428e590a835ea4b$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === (typeof f === "undefined" ? "undefined" : (0, $YtE9h._)(f)) && null !== f && f.type === $b428e590a835ea4b$var$ya && null === f.key && (f = f.props.children);
        if ("object" === (typeof f === "undefined" ? "undefined" : (0, $YtE9h._)(f)) && null !== f) {
            switch(f.$$typeof){
                case $b428e590a835ea4b$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b428e590a835ea4b$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === (typeof k === "undefined" ? "undefined" : (0, $YtE9h._)(k)) && null !== k && k.$$typeof === $b428e590a835ea4b$var$Ha && $b428e590a835ea4b$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b428e590a835ea4b$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b428e590a835ea4b$var$ya ? (d = $b428e590a835ea4b$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b428e590a835ea4b$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $b428e590a835ea4b$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b428e590a835ea4b$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b428e590a835ea4b$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b428e590a835ea4b$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b428e590a835ea4b$var$eb(f)) return n(a, d, f, h);
            if ($b428e590a835ea4b$var$Ka(f)) return t(a, d, f, h);
            $b428e590a835ea4b$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b428e590a835ea4b$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b428e590a835ea4b$var$Ug = $b428e590a835ea4b$var$Og(!0), $b428e590a835ea4b$var$Vg = $b428e590a835ea4b$var$Og(!1), $b428e590a835ea4b$var$Wg = $b428e590a835ea4b$var$Uf(null), $b428e590a835ea4b$var$Xg = null, $b428e590a835ea4b$var$Yg = null, $b428e590a835ea4b$var$Zg = null;
function $b428e590a835ea4b$var$$g() {
    $b428e590a835ea4b$var$Zg = $b428e590a835ea4b$var$Yg = $b428e590a835ea4b$var$Xg = null;
}
function $b428e590a835ea4b$var$ah(a) {
    var b = $b428e590a835ea4b$var$Wg.current;
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wg);
    a._currentValue = b;
}
function $b428e590a835ea4b$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b428e590a835ea4b$var$ch(a, b) {
    $b428e590a835ea4b$var$Xg = a;
    $b428e590a835ea4b$var$Zg = $b428e590a835ea4b$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b428e590a835ea4b$var$dh = !0), a.firstContext = null);
}
function $b428e590a835ea4b$var$eh(a) {
    var b = a._currentValue;
    if ($b428e590a835ea4b$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b428e590a835ea4b$var$Yg) {
            if (null === $b428e590a835ea4b$var$Xg) throw Error($b428e590a835ea4b$var$p(308));
            $b428e590a835ea4b$var$Yg = a;
            $b428e590a835ea4b$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b428e590a835ea4b$var$Yg = $b428e590a835ea4b$var$Yg.next = a;
    }
    return b;
}
var $b428e590a835ea4b$var$fh = null;
function $b428e590a835ea4b$var$gh(a) {
    null === $b428e590a835ea4b$var$fh ? $b428e590a835ea4b$var$fh = [
        a
    ] : $b428e590a835ea4b$var$fh.push(a);
}
function $b428e590a835ea4b$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b428e590a835ea4b$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b428e590a835ea4b$var$ih(a, d);
}
function $b428e590a835ea4b$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b428e590a835ea4b$var$jh = !1;
function $b428e590a835ea4b$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b428e590a835ea4b$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b428e590a835ea4b$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b428e590a835ea4b$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b428e590a835ea4b$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b428e590a835ea4b$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b428e590a835ea4b$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b428e590a835ea4b$var$ih(a, c);
}
function $b428e590a835ea4b$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b428e590a835ea4b$var$Cc(a, c);
    }
}
function $b428e590a835ea4b$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b428e590a835ea4b$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $b428e590a835ea4b$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b428e590a835ea4b$var$A({}, q, r);
                            break a;
                        case 2:
                            $b428e590a835ea4b$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b428e590a835ea4b$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b428e590a835ea4b$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b428e590a835ea4b$var$p(191, e));
            e.call(d);
        }
    }
}
var $b428e590a835ea4b$var$th = {}, $b428e590a835ea4b$var$uh = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$th), $b428e590a835ea4b$var$vh = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$th), $b428e590a835ea4b$var$wh = $b428e590a835ea4b$var$Uf($b428e590a835ea4b$var$th);
function $b428e590a835ea4b$var$xh(a) {
    if (a === $b428e590a835ea4b$var$th) throw Error($b428e590a835ea4b$var$p(174));
    return a;
}
function $b428e590a835ea4b$var$yh(a, b) {
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$wh, b);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$vh, a);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$uh, $b428e590a835ea4b$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b428e590a835ea4b$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b428e590a835ea4b$var$lb(b, a);
    }
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$uh);
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$uh, b);
}
function $b428e590a835ea4b$var$zh() {
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$uh);
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$vh);
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$wh);
}
function $b428e590a835ea4b$var$Ah(a) {
    $b428e590a835ea4b$var$xh($b428e590a835ea4b$var$wh.current);
    var b = $b428e590a835ea4b$var$xh($b428e590a835ea4b$var$uh.current);
    var c = $b428e590a835ea4b$var$lb(b, a.type);
    b !== c && ($b428e590a835ea4b$var$G($b428e590a835ea4b$var$vh, a), $b428e590a835ea4b$var$G($b428e590a835ea4b$var$uh, c));
}
function $b428e590a835ea4b$var$Bh(a) {
    $b428e590a835ea4b$var$vh.current === a && ($b428e590a835ea4b$var$E($b428e590a835ea4b$var$uh), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$vh));
}
var $b428e590a835ea4b$var$L = $b428e590a835ea4b$var$Uf(0);
function $b428e590a835ea4b$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b428e590a835ea4b$var$Dh = [];
function $b428e590a835ea4b$var$Eh() {
    for(var a = 0; a < $b428e590a835ea4b$var$Dh.length; a++)$b428e590a835ea4b$var$Dh[a]._workInProgressVersionPrimary = null;
    $b428e590a835ea4b$var$Dh.length = 0;
}
var $b428e590a835ea4b$var$Fh = $b428e590a835ea4b$var$ua.ReactCurrentDispatcher, $b428e590a835ea4b$var$Gh = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig, $b428e590a835ea4b$var$Hh = 0, $b428e590a835ea4b$var$M = null, $b428e590a835ea4b$var$N = null, $b428e590a835ea4b$var$O = null, $b428e590a835ea4b$var$Ih = !1, $b428e590a835ea4b$var$Jh = !1, $b428e590a835ea4b$var$Kh = 0, $b428e590a835ea4b$var$Lh = 0;
function $b428e590a835ea4b$var$P() {
    throw Error($b428e590a835ea4b$var$p(321));
}
function $b428e590a835ea4b$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b428e590a835ea4b$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b428e590a835ea4b$var$Nh(a, b, c, d, e, f) {
    $b428e590a835ea4b$var$Hh = f;
    $b428e590a835ea4b$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b428e590a835ea4b$var$Fh.current = null === a || null === a.memoizedState ? $b428e590a835ea4b$var$Oh : $b428e590a835ea4b$var$Ph;
    a = c(d, e);
    if ($b428e590a835ea4b$var$Jh) {
        f = 0;
        do {
            $b428e590a835ea4b$var$Jh = !1;
            $b428e590a835ea4b$var$Kh = 0;
            if (25 <= f) throw Error($b428e590a835ea4b$var$p(301));
            f += 1;
            $b428e590a835ea4b$var$O = $b428e590a835ea4b$var$N = null;
            b.updateQueue = null;
            $b428e590a835ea4b$var$Fh.current = $b428e590a835ea4b$var$Qh;
            a = c(d, e);
        }while ($b428e590a835ea4b$var$Jh);
    }
    $b428e590a835ea4b$var$Fh.current = $b428e590a835ea4b$var$Rh;
    b = null !== $b428e590a835ea4b$var$N && null !== $b428e590a835ea4b$var$N.next;
    $b428e590a835ea4b$var$Hh = 0;
    $b428e590a835ea4b$var$O = $b428e590a835ea4b$var$N = $b428e590a835ea4b$var$M = null;
    $b428e590a835ea4b$var$Ih = !1;
    if (b) throw Error($b428e590a835ea4b$var$p(300));
    return a;
}
function $b428e590a835ea4b$var$Sh() {
    var a = 0 !== $b428e590a835ea4b$var$Kh;
    $b428e590a835ea4b$var$Kh = 0;
    return a;
}
function $b428e590a835ea4b$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b428e590a835ea4b$var$O ? $b428e590a835ea4b$var$M.memoizedState = $b428e590a835ea4b$var$O = a : $b428e590a835ea4b$var$O = $b428e590a835ea4b$var$O.next = a;
    return $b428e590a835ea4b$var$O;
}
function $b428e590a835ea4b$var$Uh() {
    if (null === $b428e590a835ea4b$var$N) {
        var a = $b428e590a835ea4b$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b428e590a835ea4b$var$N.next;
    var b = null === $b428e590a835ea4b$var$O ? $b428e590a835ea4b$var$M.memoizedState : $b428e590a835ea4b$var$O.next;
    if (null !== b) $b428e590a835ea4b$var$O = b, $b428e590a835ea4b$var$N = a;
    else {
        if (null === a) throw Error($b428e590a835ea4b$var$p(310));
        $b428e590a835ea4b$var$N = a;
        a = {
            memoizedState: $b428e590a835ea4b$var$N.memoizedState,
            baseState: $b428e590a835ea4b$var$N.baseState,
            baseQueue: $b428e590a835ea4b$var$N.baseQueue,
            queue: $b428e590a835ea4b$var$N.queue,
            next: null
        };
        null === $b428e590a835ea4b$var$O ? $b428e590a835ea4b$var$M.memoizedState = $b428e590a835ea4b$var$O = a : $b428e590a835ea4b$var$O = $b428e590a835ea4b$var$O.next = a;
    }
    return $b428e590a835ea4b$var$O;
}
function $b428e590a835ea4b$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b428e590a835ea4b$var$Wh(a) {
    var b = $b428e590a835ea4b$var$Uh(), c = b.queue;
    if (null === c) throw Error($b428e590a835ea4b$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b428e590a835ea4b$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b428e590a835ea4b$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b428e590a835ea4b$var$M.lanes |= m;
                $b428e590a835ea4b$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b428e590a835ea4b$var$He(d, b.memoizedState) || ($b428e590a835ea4b$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b428e590a835ea4b$var$M.lanes |= f, $b428e590a835ea4b$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b428e590a835ea4b$var$Xh(a) {
    var b = $b428e590a835ea4b$var$Uh(), c = b.queue;
    if (null === c) throw Error($b428e590a835ea4b$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b428e590a835ea4b$var$He(f, b.memoizedState) || ($b428e590a835ea4b$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b428e590a835ea4b$var$Yh() {}
function $b428e590a835ea4b$var$Zh(a, b) {
    var c = $b428e590a835ea4b$var$M, d = $b428e590a835ea4b$var$Uh(), e = b(), f = !$b428e590a835ea4b$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b428e590a835ea4b$var$dh = !0);
    d = d.queue;
    $b428e590a835ea4b$var$$h($b428e590a835ea4b$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b428e590a835ea4b$var$O && $b428e590a835ea4b$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b428e590a835ea4b$var$bi(9, $b428e590a835ea4b$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $b428e590a835ea4b$var$Q) throw Error($b428e590a835ea4b$var$p(349));
        0 !== ($b428e590a835ea4b$var$Hh & 30) || $b428e590a835ea4b$var$di(c, b, e);
    }
    return e;
}
function $b428e590a835ea4b$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b428e590a835ea4b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b428e590a835ea4b$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b428e590a835ea4b$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b428e590a835ea4b$var$ei(b) && $b428e590a835ea4b$var$fi(a);
}
function $b428e590a835ea4b$var$ai(a, b, c) {
    return c(function() {
        $b428e590a835ea4b$var$ei(b) && $b428e590a835ea4b$var$fi(a);
    });
}
function $b428e590a835ea4b$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b428e590a835ea4b$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b428e590a835ea4b$var$fi(a) {
    var b = $b428e590a835ea4b$var$ih(a, 1);
    null !== b && $b428e590a835ea4b$var$gi(b, a, 1, -1);
}
function $b428e590a835ea4b$var$hi(a) {
    var b = $b428e590a835ea4b$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b428e590a835ea4b$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b428e590a835ea4b$var$ii.bind(null, $b428e590a835ea4b$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b428e590a835ea4b$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b428e590a835ea4b$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b428e590a835ea4b$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b428e590a835ea4b$var$ji() {
    return $b428e590a835ea4b$var$Uh().memoizedState;
}
function $b428e590a835ea4b$var$ki(a, b, c, d) {
    var e = $b428e590a835ea4b$var$Th();
    $b428e590a835ea4b$var$M.flags |= a;
    e.memoizedState = $b428e590a835ea4b$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b428e590a835ea4b$var$li(a, b, c, d) {
    var e = $b428e590a835ea4b$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b428e590a835ea4b$var$N) {
        var g = $b428e590a835ea4b$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $b428e590a835ea4b$var$Mh(d, g.deps)) {
            e.memoizedState = $b428e590a835ea4b$var$bi(b, c, f, d);
            return;
        }
    }
    $b428e590a835ea4b$var$M.flags |= a;
    e.memoizedState = $b428e590a835ea4b$var$bi(1 | b, c, f, d);
}
function $b428e590a835ea4b$var$mi(a, b) {
    return $b428e590a835ea4b$var$ki(8390656, 8, a, b);
}
function $b428e590a835ea4b$var$$h(a, b) {
    return $b428e590a835ea4b$var$li(2048, 8, a, b);
}
function $b428e590a835ea4b$var$ni(a, b) {
    return $b428e590a835ea4b$var$li(4, 2, a, b);
}
function $b428e590a835ea4b$var$oi(a, b) {
    return $b428e590a835ea4b$var$li(4, 4, a, b);
}
function $b428e590a835ea4b$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b428e590a835ea4b$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b428e590a835ea4b$var$li(4, 4, $b428e590a835ea4b$var$pi.bind(null, b, a), c);
}
function $b428e590a835ea4b$var$ri() {}
function $b428e590a835ea4b$var$si(a, b) {
    var c = $b428e590a835ea4b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b428e590a835ea4b$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b428e590a835ea4b$var$ti(a, b) {
    var c = $b428e590a835ea4b$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b428e590a835ea4b$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b428e590a835ea4b$var$ui(a, b, c) {
    if (0 === ($b428e590a835ea4b$var$Hh & 21)) return a.baseState && (a.baseState = !1, $b428e590a835ea4b$var$dh = !0), a.memoizedState = c;
    $b428e590a835ea4b$var$He(c, b) || (c = $b428e590a835ea4b$var$yc(), $b428e590a835ea4b$var$M.lanes |= c, $b428e590a835ea4b$var$rh |= c, a.baseState = !0);
    return b;
}
function $b428e590a835ea4b$var$vi(a, b) {
    var c = $b428e590a835ea4b$var$C;
    $b428e590a835ea4b$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b428e590a835ea4b$var$Gh.transition;
    $b428e590a835ea4b$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b428e590a835ea4b$var$C = c, $b428e590a835ea4b$var$Gh.transition = d;
    }
}
function $b428e590a835ea4b$var$wi() {
    return $b428e590a835ea4b$var$Uh().memoizedState;
}
function $b428e590a835ea4b$var$xi(a, b, c) {
    var d = $b428e590a835ea4b$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b428e590a835ea4b$var$zi(a)) $b428e590a835ea4b$var$Ai(b, c);
    else if (c = $b428e590a835ea4b$var$hh(a, b, c, d), null !== c) {
        var e = $b428e590a835ea4b$var$R();
        $b428e590a835ea4b$var$gi(c, a, d, e);
        $b428e590a835ea4b$var$Bi(c, b, d);
    }
}
function $b428e590a835ea4b$var$ii(a, b, c) {
    var d = $b428e590a835ea4b$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b428e590a835ea4b$var$zi(a)) $b428e590a835ea4b$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b428e590a835ea4b$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b428e590a835ea4b$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b428e590a835ea4b$var$hh(a, b, e, d);
        null !== c && (e = $b428e590a835ea4b$var$R(), $b428e590a835ea4b$var$gi(c, a, d, e), $b428e590a835ea4b$var$Bi(c, b, d));
    }
}
function $b428e590a835ea4b$var$zi(a) {
    var b = a.alternate;
    return a === $b428e590a835ea4b$var$M || null !== b && b === $b428e590a835ea4b$var$M;
}
function $b428e590a835ea4b$var$Ai(a, b) {
    $b428e590a835ea4b$var$Jh = $b428e590a835ea4b$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b428e590a835ea4b$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b428e590a835ea4b$var$Cc(a, c);
    }
}
var $b428e590a835ea4b$var$Rh = {
    readContext: $b428e590a835ea4b$var$eh,
    useCallback: $b428e590a835ea4b$var$P,
    useContext: $b428e590a835ea4b$var$P,
    useEffect: $b428e590a835ea4b$var$P,
    useImperativeHandle: $b428e590a835ea4b$var$P,
    useInsertionEffect: $b428e590a835ea4b$var$P,
    useLayoutEffect: $b428e590a835ea4b$var$P,
    useMemo: $b428e590a835ea4b$var$P,
    useReducer: $b428e590a835ea4b$var$P,
    useRef: $b428e590a835ea4b$var$P,
    useState: $b428e590a835ea4b$var$P,
    useDebugValue: $b428e590a835ea4b$var$P,
    useDeferredValue: $b428e590a835ea4b$var$P,
    useTransition: $b428e590a835ea4b$var$P,
    useMutableSource: $b428e590a835ea4b$var$P,
    useSyncExternalStore: $b428e590a835ea4b$var$P,
    useId: $b428e590a835ea4b$var$P,
    unstable_isNewReconciler: !1
}, $b428e590a835ea4b$var$Oh = {
    readContext: $b428e590a835ea4b$var$eh,
    useCallback: function useCallback(a, b) {
        $b428e590a835ea4b$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b428e590a835ea4b$var$eh,
    useEffect: $b428e590a835ea4b$var$mi,
    useImperativeHandle: function useImperativeHandle(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b428e590a835ea4b$var$ki(4194308, 4, $b428e590a835ea4b$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function useLayoutEffect(a, b) {
        return $b428e590a835ea4b$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function useInsertionEffect(a, b) {
        return $b428e590a835ea4b$var$ki(4, 2, a, b);
    },
    useMemo: function useMemo(a, b) {
        var c = $b428e590a835ea4b$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function useReducer(a, b, c) {
        var d = $b428e590a835ea4b$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b428e590a835ea4b$var$xi.bind(null, $b428e590a835ea4b$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function useRef(a) {
        var b = $b428e590a835ea4b$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b428e590a835ea4b$var$hi,
    useDebugValue: $b428e590a835ea4b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        return $b428e590a835ea4b$var$Th().memoizedState = a;
    },
    useTransition: function useTransition() {
        var a = $b428e590a835ea4b$var$hi(!1), b = a[0];
        a = $b428e590a835ea4b$var$vi.bind(null, a[1]);
        $b428e590a835ea4b$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function useMutableSource() {},
    useSyncExternalStore: function useSyncExternalStore(a, b, c) {
        var d = $b428e590a835ea4b$var$M, e = $b428e590a835ea4b$var$Th();
        if ($b428e590a835ea4b$var$I) {
            if (void 0 === c) throw Error($b428e590a835ea4b$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b428e590a835ea4b$var$Q) throw Error($b428e590a835ea4b$var$p(349));
            0 !== ($b428e590a835ea4b$var$Hh & 30) || $b428e590a835ea4b$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b428e590a835ea4b$var$mi($b428e590a835ea4b$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b428e590a835ea4b$var$bi(9, $b428e590a835ea4b$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function useId() {
        var a = $b428e590a835ea4b$var$Th(), b = $b428e590a835ea4b$var$Q.identifierPrefix;
        if ($b428e590a835ea4b$var$I) {
            var c = $b428e590a835ea4b$var$sg;
            var d = $b428e590a835ea4b$var$rg;
            c = (d & ~(1 << 32 - $b428e590a835ea4b$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b428e590a835ea4b$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b428e590a835ea4b$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b428e590a835ea4b$var$Ph = {
    readContext: $b428e590a835ea4b$var$eh,
    useCallback: $b428e590a835ea4b$var$si,
    useContext: $b428e590a835ea4b$var$eh,
    useEffect: $b428e590a835ea4b$var$$h,
    useImperativeHandle: $b428e590a835ea4b$var$qi,
    useInsertionEffect: $b428e590a835ea4b$var$ni,
    useLayoutEffect: $b428e590a835ea4b$var$oi,
    useMemo: $b428e590a835ea4b$var$ti,
    useReducer: $b428e590a835ea4b$var$Wh,
    useRef: $b428e590a835ea4b$var$ji,
    useState: function useState() {
        return $b428e590a835ea4b$var$Wh($b428e590a835ea4b$var$Vh);
    },
    useDebugValue: $b428e590a835ea4b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b428e590a835ea4b$var$Uh();
        return $b428e590a835ea4b$var$ui(b, $b428e590a835ea4b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b428e590a835ea4b$var$Wh($b428e590a835ea4b$var$Vh)[0], b = $b428e590a835ea4b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b428e590a835ea4b$var$Yh,
    useSyncExternalStore: $b428e590a835ea4b$var$Zh,
    useId: $b428e590a835ea4b$var$wi,
    unstable_isNewReconciler: !1
}, $b428e590a835ea4b$var$Qh = {
    readContext: $b428e590a835ea4b$var$eh,
    useCallback: $b428e590a835ea4b$var$si,
    useContext: $b428e590a835ea4b$var$eh,
    useEffect: $b428e590a835ea4b$var$$h,
    useImperativeHandle: $b428e590a835ea4b$var$qi,
    useInsertionEffect: $b428e590a835ea4b$var$ni,
    useLayoutEffect: $b428e590a835ea4b$var$oi,
    useMemo: $b428e590a835ea4b$var$ti,
    useReducer: $b428e590a835ea4b$var$Xh,
    useRef: $b428e590a835ea4b$var$ji,
    useState: function useState() {
        return $b428e590a835ea4b$var$Xh($b428e590a835ea4b$var$Vh);
    },
    useDebugValue: $b428e590a835ea4b$var$ri,
    useDeferredValue: function useDeferredValue(a) {
        var b = $b428e590a835ea4b$var$Uh();
        return null === $b428e590a835ea4b$var$N ? b.memoizedState = a : $b428e590a835ea4b$var$ui(b, $b428e590a835ea4b$var$N.memoizedState, a);
    },
    useTransition: function useTransition() {
        var a = $b428e590a835ea4b$var$Xh($b428e590a835ea4b$var$Vh)[0], b = $b428e590a835ea4b$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b428e590a835ea4b$var$Yh,
    useSyncExternalStore: $b428e590a835ea4b$var$Zh,
    useId: $b428e590a835ea4b$var$wi,
    unstable_isNewReconciler: !1
};
function $b428e590a835ea4b$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $b428e590a835ea4b$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $b428e590a835ea4b$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b428e590a835ea4b$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b428e590a835ea4b$var$Ei = {
    isMounted: function isMounted(a) {
        return (a = a._reactInternals) ? $b428e590a835ea4b$var$Vb(a) === a : !1;
    },
    enqueueSetState: function enqueueSetState(a, b, c) {
        a = a._reactInternals;
        var d = $b428e590a835ea4b$var$R(), e = $b428e590a835ea4b$var$yi(a), f = $b428e590a835ea4b$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b428e590a835ea4b$var$nh(a, f, e);
        null !== b && ($b428e590a835ea4b$var$gi(b, a, e, d), $b428e590a835ea4b$var$oh(b, a, e));
    },
    enqueueReplaceState: function enqueueReplaceState(a, b, c) {
        a = a._reactInternals;
        var d = $b428e590a835ea4b$var$R(), e = $b428e590a835ea4b$var$yi(a), f = $b428e590a835ea4b$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b428e590a835ea4b$var$nh(a, f, e);
        null !== b && ($b428e590a835ea4b$var$gi(b, a, e, d), $b428e590a835ea4b$var$oh(b, a, e));
    },
    enqueueForceUpdate: function enqueueForceUpdate(a, b) {
        a = a._reactInternals;
        var c = $b428e590a835ea4b$var$R(), d = $b428e590a835ea4b$var$yi(a), e = $b428e590a835ea4b$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b428e590a835ea4b$var$nh(a, e, d);
        null !== b && ($b428e590a835ea4b$var$gi(b, a, d, c), $b428e590a835ea4b$var$oh(b, a, d));
    }
};
function $b428e590a835ea4b$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b428e590a835ea4b$var$Ie(c, d) || !$b428e590a835ea4b$var$Ie(e, f) : !0;
}
function $b428e590a835ea4b$var$Gi(a, b, c) {
    var d = !1, e = $b428e590a835ea4b$var$Vf;
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $YtE9h._)(f)) && null !== f ? f = $b428e590a835ea4b$var$eh(f) : (e = $b428e590a835ea4b$var$Zf(b) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b428e590a835ea4b$var$Yf(a, e) : $b428e590a835ea4b$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b428e590a835ea4b$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b428e590a835ea4b$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b428e590a835ea4b$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $b428e590a835ea4b$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $b428e590a835ea4b$var$kh(a);
    var f = b.contextType;
    "object" === (typeof f === "undefined" ? "undefined" : (0, $YtE9h._)(f)) && null !== f ? e.context = $b428e590a835ea4b$var$eh(f) : (f = $b428e590a835ea4b$var$Zf(b) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, e.context = $b428e590a835ea4b$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b428e590a835ea4b$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b428e590a835ea4b$var$Ei.enqueueReplaceState(e, e.state, null), $b428e590a835ea4b$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b428e590a835ea4b$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $b428e590a835ea4b$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b428e590a835ea4b$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b428e590a835ea4b$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b428e590a835ea4b$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $b428e590a835ea4b$var$Ni(a, b, c) {
    c = $b428e590a835ea4b$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b428e590a835ea4b$var$Oi || ($b428e590a835ea4b$var$Oi = !0, $b428e590a835ea4b$var$Pi = d);
        $b428e590a835ea4b$var$Li(a, b);
    };
    return c;
}
function $b428e590a835ea4b$var$Qi(a, b, c) {
    c = $b428e590a835ea4b$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b428e590a835ea4b$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b428e590a835ea4b$var$Li(a, b);
        "function" !== typeof d && (null === $b428e590a835ea4b$var$Ri ? $b428e590a835ea4b$var$Ri = new Set([
            this
        ]) : $b428e590a835ea4b$var$Ri.add(this));
        var _$c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== _$c ? _$c : ""
        });
    });
    return c;
}
function $b428e590a835ea4b$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b428e590a835ea4b$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b428e590a835ea4b$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $b428e590a835ea4b$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b428e590a835ea4b$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b428e590a835ea4b$var$mh(-1, 1), b.tag = 2, $b428e590a835ea4b$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b428e590a835ea4b$var$Wi = $b428e590a835ea4b$var$ua.ReactCurrentOwner, $b428e590a835ea4b$var$dh = !1;
function $b428e590a835ea4b$var$Xi(a, b, c, d) {
    b.child = null === a ? $b428e590a835ea4b$var$Vg(b, null, c, d) : $b428e590a835ea4b$var$Ug(b, a.child, c, d);
}
function $b428e590a835ea4b$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b428e590a835ea4b$var$ch(b, e);
    d = $b428e590a835ea4b$var$Nh(a, b, c, d, f, e);
    c = $b428e590a835ea4b$var$Sh();
    if (null !== a && !$b428e590a835ea4b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b428e590a835ea4b$var$Zi(a, b, e);
    $b428e590a835ea4b$var$I && c && $b428e590a835ea4b$var$vg(b);
    b.flags |= 1;
    $b428e590a835ea4b$var$Xi(a, b, d, e);
    return b.child;
}
function $b428e590a835ea4b$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b428e590a835ea4b$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b428e590a835ea4b$var$bj(a, b, f, d, e);
        a = $b428e590a835ea4b$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b428e590a835ea4b$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b428e590a835ea4b$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $b428e590a835ea4b$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b428e590a835ea4b$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b428e590a835ea4b$var$Ie(f, d) && a.ref === b.ref) {
            if ($b428e590a835ea4b$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b428e590a835ea4b$var$dh = !0);
            else return b.lanes = a.lanes, $b428e590a835ea4b$var$Zi(a, b, e);
        }
    }
    return $b428e590a835ea4b$var$cj(a, b, c, d, e);
}
function $b428e590a835ea4b$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$ej, $b428e590a835ea4b$var$fj), $b428e590a835ea4b$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$ej, $b428e590a835ea4b$var$fj), $b428e590a835ea4b$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$ej, $b428e590a835ea4b$var$fj);
            $b428e590a835ea4b$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$ej, $b428e590a835ea4b$var$fj), $b428e590a835ea4b$var$fj |= d;
    $b428e590a835ea4b$var$Xi(a, b, e, c);
    return b.child;
}
function $b428e590a835ea4b$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b428e590a835ea4b$var$cj(a, b, c, d, e) {
    var f = $b428e590a835ea4b$var$Zf(c) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current;
    f = $b428e590a835ea4b$var$Yf(b, f);
    $b428e590a835ea4b$var$ch(b, e);
    c = $b428e590a835ea4b$var$Nh(a, b, c, d, f, e);
    d = $b428e590a835ea4b$var$Sh();
    if (null !== a && !$b428e590a835ea4b$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b428e590a835ea4b$var$Zi(a, b, e);
    $b428e590a835ea4b$var$I && d && $b428e590a835ea4b$var$vg(b);
    b.flags |= 1;
    $b428e590a835ea4b$var$Xi(a, b, c, e);
    return b.child;
}
function $b428e590a835ea4b$var$hj(a, b, c, d, e) {
    if ($b428e590a835ea4b$var$Zf(c)) {
        var f = !0;
        $b428e590a835ea4b$var$cg(b);
    } else f = !1;
    $b428e590a835ea4b$var$ch(b, e);
    if (null === b.stateNode) $b428e590a835ea4b$var$ij(a, b), $b428e590a835ea4b$var$Gi(b, c, d), $b428e590a835ea4b$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === (typeof l === "undefined" ? "undefined" : (0, $YtE9h._)(l)) && null !== l ? l = $b428e590a835ea4b$var$eh(l) : (l = $b428e590a835ea4b$var$Zf(c) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, l = $b428e590a835ea4b$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b428e590a835ea4b$var$Hi(b, g, d, l);
        $b428e590a835ea4b$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $b428e590a835ea4b$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b428e590a835ea4b$var$Wf.current || $b428e590a835ea4b$var$jh ? ("function" === typeof m && ($b428e590a835ea4b$var$Di(b, c, m, d), k = b.memoizedState), (h = $b428e590a835ea4b$var$jh || $b428e590a835ea4b$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b428e590a835ea4b$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b428e590a835ea4b$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === (typeof k === "undefined" ? "undefined" : (0, $YtE9h._)(k)) && null !== k ? k = $b428e590a835ea4b$var$eh(k) : (k = $b428e590a835ea4b$var$Zf(c) ? $b428e590a835ea4b$var$Xf : $b428e590a835ea4b$var$H.current, k = $b428e590a835ea4b$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b428e590a835ea4b$var$Hi(b, g, d, k);
        $b428e590a835ea4b$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $b428e590a835ea4b$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b428e590a835ea4b$var$Wf.current || $b428e590a835ea4b$var$jh ? ("function" === typeof y && ($b428e590a835ea4b$var$Di(b, c, y, d), n = b.memoizedState), (l = $b428e590a835ea4b$var$jh || $b428e590a835ea4b$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b428e590a835ea4b$var$jj(a, b, c, d, f, e);
}
function $b428e590a835ea4b$var$jj(a, b, c, d, e, f) {
    $b428e590a835ea4b$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b428e590a835ea4b$var$dg(b, c, !1), $b428e590a835ea4b$var$Zi(a, b, f);
    d = b.stateNode;
    $b428e590a835ea4b$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b428e590a835ea4b$var$Ug(b, a.child, null, f), b.child = $b428e590a835ea4b$var$Ug(b, null, h, f)) : $b428e590a835ea4b$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b428e590a835ea4b$var$dg(b, c, !0);
    return b.child;
}
function $b428e590a835ea4b$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b428e590a835ea4b$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b428e590a835ea4b$var$ag(a, b.context, !1);
    $b428e590a835ea4b$var$yh(a, b.containerInfo);
}
function $b428e590a835ea4b$var$lj(a, b, c, d, e) {
    $b428e590a835ea4b$var$Ig();
    $b428e590a835ea4b$var$Jg(e);
    b.flags |= 256;
    $b428e590a835ea4b$var$Xi(a, b, c, d);
    return b.child;
}
var $b428e590a835ea4b$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b428e590a835ea4b$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b428e590a835ea4b$var$oj(a, b, c) {
    var d = b.pendingProps, e = $b428e590a835ea4b$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, e & 1);
    if (null === a) {
        $b428e590a835ea4b$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b428e590a835ea4b$var$pj(g, d, 0, null), a = $b428e590a835ea4b$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b428e590a835ea4b$var$nj(c), b.memoizedState = $b428e590a835ea4b$var$mj, a) : $b428e590a835ea4b$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b428e590a835ea4b$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b428e590a835ea4b$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b428e590a835ea4b$var$Pg(h, f) : (f = $b428e590a835ea4b$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b428e590a835ea4b$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b428e590a835ea4b$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b428e590a835ea4b$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b428e590a835ea4b$var$qj(a, b) {
    b = $b428e590a835ea4b$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b428e590a835ea4b$var$sj(a, b, c, d) {
    null !== d && $b428e590a835ea4b$var$Jg(d);
    $b428e590a835ea4b$var$Ug(b, a.child, null, c);
    a = $b428e590a835ea4b$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b428e590a835ea4b$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b428e590a835ea4b$var$Ki(Error($b428e590a835ea4b$var$p(422))), $b428e590a835ea4b$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b428e590a835ea4b$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b428e590a835ea4b$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b428e590a835ea4b$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $b428e590a835ea4b$var$nj(g);
        b.memoizedState = $b428e590a835ea4b$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b428e590a835ea4b$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b428e590a835ea4b$var$p(419));
        d = $b428e590a835ea4b$var$Ki(f, d, void 0);
        return $b428e590a835ea4b$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b428e590a835ea4b$var$dh || h) {
        d = $b428e590a835ea4b$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b428e590a835ea4b$var$ih(a, e), $b428e590a835ea4b$var$gi(d, a, e, -1));
        }
        $b428e590a835ea4b$var$tj();
        d = $b428e590a835ea4b$var$Ki(Error($b428e590a835ea4b$var$p(421)));
        return $b428e590a835ea4b$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b428e590a835ea4b$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(e.nextSibling);
    $b428e590a835ea4b$var$xg = b;
    $b428e590a835ea4b$var$I = !0;
    $b428e590a835ea4b$var$zg = null;
    null !== a && ($b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$rg, $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$sg, $b428e590a835ea4b$var$og[$b428e590a835ea4b$var$pg++] = $b428e590a835ea4b$var$qg, $b428e590a835ea4b$var$rg = a.id, $b428e590a835ea4b$var$sg = a.overflow, $b428e590a835ea4b$var$qg = b);
    b = $b428e590a835ea4b$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b428e590a835ea4b$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b428e590a835ea4b$var$bh(a.return, b, c);
}
function $b428e590a835ea4b$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b428e590a835ea4b$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b428e590a835ea4b$var$Xi(a, b, d.children, c);
    d = $b428e590a835ea4b$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b428e590a835ea4b$var$vj(a, c, b);
            else if (19 === a.tag) $b428e590a835ea4b$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b428e590a835ea4b$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b428e590a835ea4b$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b428e590a835ea4b$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b428e590a835ea4b$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $b428e590a835ea4b$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b428e590a835ea4b$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b428e590a835ea4b$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b428e590a835ea4b$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b428e590a835ea4b$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b428e590a835ea4b$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b428e590a835ea4b$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b428e590a835ea4b$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $b428e590a835ea4b$var$kj(b);
            $b428e590a835ea4b$var$Ig();
            break;
        case 5:
            $b428e590a835ea4b$var$Ah(b);
            break;
        case 1:
            $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$cg(b);
            break;
        case 4:
            $b428e590a835ea4b$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, $b428e590a835ea4b$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b428e590a835ea4b$var$oj(a, b, c);
                $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, $b428e590a835ea4b$var$L.current & 1);
                a = $b428e590a835ea4b$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, $b428e590a835ea4b$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b428e590a835ea4b$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, $b428e590a835ea4b$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b428e590a835ea4b$var$dj(a, b, c);
    }
    return $b428e590a835ea4b$var$Zi(a, b, c);
}
var $b428e590a835ea4b$var$zj, $b428e590a835ea4b$var$Aj, $b428e590a835ea4b$var$Bj, $b428e590a835ea4b$var$Cj;
$b428e590a835ea4b$var$zj = function zj(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b428e590a835ea4b$var$Aj = function Aj() {};
$b428e590a835ea4b$var$Bj = function Bj(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b428e590a835ea4b$var$xh($b428e590a835ea4b$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b428e590a835ea4b$var$Ya(a, e);
                d = $b428e590a835ea4b$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b428e590a835ea4b$var$A({}, e, {
                    value: void 0
                });
                d = $b428e590a835ea4b$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b428e590a835ea4b$var$gb(a, e);
                d = $b428e590a835ea4b$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b428e590a835ea4b$var$Bf);
        }
        $b428e590a835ea4b$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b428e590a835ea4b$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b428e590a835ea4b$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b428e590a835ea4b$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b428e590a835ea4b$var$Cj = function Cj(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b428e590a835ea4b$var$Dj(a, b) {
    if (!$b428e590a835ea4b$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b428e590a835ea4b$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b428e590a835ea4b$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $b428e590a835ea4b$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b428e590a835ea4b$var$S(b), null;
        case 1:
            return $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$$f(), $b428e590a835ea4b$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b428e590a835ea4b$var$zh();
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H);
            $b428e590a835ea4b$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b428e590a835ea4b$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b428e590a835ea4b$var$zg && ($b428e590a835ea4b$var$Fj($b428e590a835ea4b$var$zg), $b428e590a835ea4b$var$zg = null));
            $b428e590a835ea4b$var$Aj(a, b);
            $b428e590a835ea4b$var$S(b);
            return null;
        case 5:
            $b428e590a835ea4b$var$Bh(b);
            var e = $b428e590a835ea4b$var$xh($b428e590a835ea4b$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b428e590a835ea4b$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b428e590a835ea4b$var$p(166));
                    $b428e590a835ea4b$var$S(b);
                    return null;
                }
                a = $b428e590a835ea4b$var$xh($b428e590a835ea4b$var$uh.current);
                if ($b428e590a835ea4b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b428e590a835ea4b$var$Of] = b;
                    d[$b428e590a835ea4b$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b428e590a835ea4b$var$D("cancel", d);
                            $b428e590a835ea4b$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b428e590a835ea4b$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b428e590a835ea4b$var$lf.length; e++)$b428e590a835ea4b$var$D($b428e590a835ea4b$var$lf[e], d);
                            break;
                        case "source":
                            $b428e590a835ea4b$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b428e590a835ea4b$var$D("error", d);
                            $b428e590a835ea4b$var$D("load", d);
                            break;
                        case "details":
                            $b428e590a835ea4b$var$D("toggle", d);
                            break;
                        case "input":
                            $b428e590a835ea4b$var$Za(d, f);
                            $b428e590a835ea4b$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b428e590a835ea4b$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b428e590a835ea4b$var$hb(d, f), $b428e590a835ea4b$var$D("invalid", d);
                    }
                    $b428e590a835ea4b$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b428e590a835ea4b$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b428e590a835ea4b$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b428e590a835ea4b$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b428e590a835ea4b$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b428e590a835ea4b$var$Va(d);
                            $b428e590a835ea4b$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b428e590a835ea4b$var$Va(d);
                            $b428e590a835ea4b$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b428e590a835ea4b$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b428e590a835ea4b$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b428e590a835ea4b$var$Of] = b;
                    a[$b428e590a835ea4b$var$Pf] = d;
                    $b428e590a835ea4b$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b428e590a835ea4b$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b428e590a835ea4b$var$D("cancel", a);
                                $b428e590a835ea4b$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b428e590a835ea4b$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b428e590a835ea4b$var$lf.length; e++)$b428e590a835ea4b$var$D($b428e590a835ea4b$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b428e590a835ea4b$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b428e590a835ea4b$var$D("error", a);
                                $b428e590a835ea4b$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b428e590a835ea4b$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b428e590a835ea4b$var$Za(a, d);
                                e = $b428e590a835ea4b$var$Ya(a, d);
                                $b428e590a835ea4b$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b428e590a835ea4b$var$A({}, d, {
                                    value: void 0
                                });
                                $b428e590a835ea4b$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b428e590a835ea4b$var$hb(a, d);
                                e = $b428e590a835ea4b$var$gb(a, d);
                                $b428e590a835ea4b$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b428e590a835ea4b$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b428e590a835ea4b$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b428e590a835ea4b$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b428e590a835ea4b$var$ob(a, k) : "number" === typeof k && $b428e590a835ea4b$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b428e590a835ea4b$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b428e590a835ea4b$var$D("scroll", a) : null != k && $b428e590a835ea4b$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b428e590a835ea4b$var$Va(a);
                                $b428e590a835ea4b$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b428e590a835ea4b$var$Va(a);
                                $b428e590a835ea4b$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b428e590a835ea4b$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b428e590a835ea4b$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b428e590a835ea4b$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b428e590a835ea4b$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b428e590a835ea4b$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b428e590a835ea4b$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b428e590a835ea4b$var$p(166));
                c = $b428e590a835ea4b$var$xh($b428e590a835ea4b$var$wh.current);
                $b428e590a835ea4b$var$xh($b428e590a835ea4b$var$uh.current);
                if ($b428e590a835ea4b$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b428e590a835ea4b$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b428e590a835ea4b$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b428e590a835ea4b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b428e590a835ea4b$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b428e590a835ea4b$var$Of] = b, b.stateNode = d;
            }
            $b428e590a835ea4b$var$S(b);
            return null;
        case 13:
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b428e590a835ea4b$var$I && null !== $b428e590a835ea4b$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b428e590a835ea4b$var$Hg(), $b428e590a835ea4b$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b428e590a835ea4b$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b428e590a835ea4b$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b428e590a835ea4b$var$p(317));
                        f[$b428e590a835ea4b$var$Of] = b;
                    } else $b428e590a835ea4b$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b428e590a835ea4b$var$S(b);
                    f = !1;
                } else null !== $b428e590a835ea4b$var$zg && ($b428e590a835ea4b$var$Fj($b428e590a835ea4b$var$zg), $b428e590a835ea4b$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b428e590a835ea4b$var$L.current & 1) ? 0 === $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$T = 3) : $b428e590a835ea4b$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b428e590a835ea4b$var$S(b);
            return null;
        case 4:
            return $b428e590a835ea4b$var$zh(), $b428e590a835ea4b$var$Aj(a, b), null === a && $b428e590a835ea4b$var$sf(b.stateNode.containerInfo), $b428e590a835ea4b$var$S(b), null;
        case 10:
            return $b428e590a835ea4b$var$ah(b.type._context), $b428e590a835ea4b$var$S(b), null;
        case 17:
            return $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$$f(), $b428e590a835ea4b$var$S(b), null;
        case 19:
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$L);
            f = b.memoizedState;
            if (null === f) return $b428e590a835ea4b$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b428e590a835ea4b$var$Dj(f, !1);
                else {
                    if (0 !== $b428e590a835ea4b$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b428e590a835ea4b$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b428e590a835ea4b$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, $b428e590a835ea4b$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b428e590a835ea4b$var$B() > $b428e590a835ea4b$var$Gj && (b.flags |= 128, d = !0, $b428e590a835ea4b$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b428e590a835ea4b$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b428e590a835ea4b$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b428e590a835ea4b$var$I) return $b428e590a835ea4b$var$S(b), null;
                    } else 2 * $b428e590a835ea4b$var$B() - f.renderingStartTime > $b428e590a835ea4b$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $b428e590a835ea4b$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b428e590a835ea4b$var$B(), b.sibling = null, c = $b428e590a835ea4b$var$L.current, $b428e590a835ea4b$var$G($b428e590a835ea4b$var$L, d ? c & 1 | 2 : c & 1), b;
            $b428e590a835ea4b$var$S(b);
            return null;
        case 22:
        case 23:
            return $b428e590a835ea4b$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b428e590a835ea4b$var$fj & 1073741824) && ($b428e590a835ea4b$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b428e590a835ea4b$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b428e590a835ea4b$var$p(156, b.tag));
}
function $b428e590a835ea4b$var$Ij(a, b) {
    $b428e590a835ea4b$var$wg(b);
    switch(b.tag){
        case 1:
            return $b428e590a835ea4b$var$Zf(b.type) && $b428e590a835ea4b$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b428e590a835ea4b$var$zh(), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf), $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H), $b428e590a835ea4b$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b428e590a835ea4b$var$Bh(b), null;
        case 13:
            $b428e590a835ea4b$var$E($b428e590a835ea4b$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b428e590a835ea4b$var$p(340));
                $b428e590a835ea4b$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b428e590a835ea4b$var$E($b428e590a835ea4b$var$L), null;
        case 4:
            return $b428e590a835ea4b$var$zh(), null;
        case 10:
            return $b428e590a835ea4b$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $b428e590a835ea4b$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b428e590a835ea4b$var$Jj = !1, $b428e590a835ea4b$var$U = !1, $b428e590a835ea4b$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $b428e590a835ea4b$var$V = null;
function $b428e590a835ea4b$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b428e590a835ea4b$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b428e590a835ea4b$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b428e590a835ea4b$var$W(a, b, d);
    }
}
var $b428e590a835ea4b$var$Nj = !1;
function $b428e590a835ea4b$var$Oj(a, b) {
    $b428e590a835ea4b$var$Cf = $b428e590a835ea4b$var$dd;
    a = $b428e590a835ea4b$var$Me();
    if ($b428e590a835ea4b$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b428e590a835ea4b$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b428e590a835ea4b$var$dd = !1;
    for($b428e590a835ea4b$var$V = b; null !== $b428e590a835ea4b$var$V;)if (b = $b428e590a835ea4b$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b428e590a835ea4b$var$V = a;
    else for(; null !== $b428e590a835ea4b$var$V;){
        b = $b428e590a835ea4b$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b428e590a835ea4b$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b428e590a835ea4b$var$p(163));
            }
        } catch (F) {
            $b428e590a835ea4b$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b428e590a835ea4b$var$V = a;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
    n = $b428e590a835ea4b$var$Nj;
    $b428e590a835ea4b$var$Nj = !1;
    return n;
}
function $b428e590a835ea4b$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b428e590a835ea4b$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b428e590a835ea4b$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b428e590a835ea4b$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b428e590a835ea4b$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b428e590a835ea4b$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b428e590a835ea4b$var$Of], delete b[$b428e590a835ea4b$var$Pf], delete b[$b428e590a835ea4b$var$of], delete b[$b428e590a835ea4b$var$Qf], delete b[$b428e590a835ea4b$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b428e590a835ea4b$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b428e590a835ea4b$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b428e590a835ea4b$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b428e590a835ea4b$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b428e590a835ea4b$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b428e590a835ea4b$var$Vj(a, b, c), a = a.sibling; null !== a;)$b428e590a835ea4b$var$Vj(a, b, c), a = a.sibling;
}
function $b428e590a835ea4b$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b428e590a835ea4b$var$Wj(a, b, c), a = a.sibling; null !== a;)$b428e590a835ea4b$var$Wj(a, b, c), a = a.sibling;
}
var $b428e590a835ea4b$var$X = null, $b428e590a835ea4b$var$Xj = !1;
function $b428e590a835ea4b$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$b428e590a835ea4b$var$Zj(a, b, c), c = c.sibling;
}
function $b428e590a835ea4b$var$Zj(a, b, c) {
    if ($b428e590a835ea4b$var$lc && "function" === typeof $b428e590a835ea4b$var$lc.onCommitFiberUnmount) try {
        $b428e590a835ea4b$var$lc.onCommitFiberUnmount($b428e590a835ea4b$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b428e590a835ea4b$var$U || $b428e590a835ea4b$var$Lj(c, b);
        case 6:
            var d = $b428e590a835ea4b$var$X, e = $b428e590a835ea4b$var$Xj;
            $b428e590a835ea4b$var$X = null;
            $b428e590a835ea4b$var$Yj(a, b, c);
            $b428e590a835ea4b$var$X = d;
            $b428e590a835ea4b$var$Xj = e;
            null !== $b428e590a835ea4b$var$X && ($b428e590a835ea4b$var$Xj ? (a = $b428e590a835ea4b$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b428e590a835ea4b$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b428e590a835ea4b$var$X && ($b428e590a835ea4b$var$Xj ? (a = $b428e590a835ea4b$var$X, c = c.stateNode, 8 === a.nodeType ? $b428e590a835ea4b$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b428e590a835ea4b$var$Kf(a, c), $b428e590a835ea4b$var$bd(a)) : $b428e590a835ea4b$var$Kf($b428e590a835ea4b$var$X, c.stateNode));
            break;
        case 4:
            d = $b428e590a835ea4b$var$X;
            e = $b428e590a835ea4b$var$Xj;
            $b428e590a835ea4b$var$X = c.stateNode.containerInfo;
            $b428e590a835ea4b$var$Xj = !0;
            $b428e590a835ea4b$var$Yj(a, b, c);
            $b428e590a835ea4b$var$X = d;
            $b428e590a835ea4b$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b428e590a835ea4b$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b428e590a835ea4b$var$Mj(c, b, g) : 0 !== (f & 4) && $b428e590a835ea4b$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b428e590a835ea4b$var$Yj(a, b, c);
            break;
        case 1:
            if (!$b428e590a835ea4b$var$U && ($b428e590a835ea4b$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b428e590a835ea4b$var$W(c, b, h);
            }
            $b428e590a835ea4b$var$Yj(a, b, c);
            break;
        case 21:
            $b428e590a835ea4b$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b428e590a835ea4b$var$U = (d = $b428e590a835ea4b$var$U) || null !== c.memoizedState, $b428e590a835ea4b$var$Yj(a, b, c), $b428e590a835ea4b$var$U = d) : $b428e590a835ea4b$var$Yj(a, b, c);
            break;
        default:
            $b428e590a835ea4b$var$Yj(a, b, c);
    }
}
function $b428e590a835ea4b$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b428e590a835ea4b$var$Kj);
        b.forEach(function(b) {
            var d = $b428e590a835ea4b$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b428e590a835ea4b$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b428e590a835ea4b$var$X = h.stateNode;
                        $b428e590a835ea4b$var$Xj = !1;
                        break a;
                    case 3:
                        $b428e590a835ea4b$var$X = h.stateNode.containerInfo;
                        $b428e590a835ea4b$var$Xj = !0;
                        break a;
                    case 4:
                        $b428e590a835ea4b$var$X = h.stateNode.containerInfo;
                        $b428e590a835ea4b$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b428e590a835ea4b$var$X) throw Error($b428e590a835ea4b$var$p(160));
            $b428e590a835ea4b$var$Zj(f, g, e);
            $b428e590a835ea4b$var$X = null;
            $b428e590a835ea4b$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b428e590a835ea4b$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b428e590a835ea4b$var$dk(b, a), b = b.sibling;
}
function $b428e590a835ea4b$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            if (d & 4) {
                try {
                    $b428e590a835ea4b$var$Pj(3, a, a.return), $b428e590a835ea4b$var$Qj(3, a);
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
                try {
                    $b428e590a835ea4b$var$Pj(5, a, a.return);
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            d & 512 && null !== c && $b428e590a835ea4b$var$Lj(c, c.return);
            break;
        case 5:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            d & 512 && null !== c && $b428e590a835ea4b$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b428e590a835ea4b$var$ob(e, "");
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b428e590a835ea4b$var$ab(e, f);
                    $b428e590a835ea4b$var$vb(h, g);
                    var l = $b428e590a835ea4b$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b428e590a835ea4b$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b428e590a835ea4b$var$nb(e, q) : "children" === m ? $b428e590a835ea4b$var$ob(e, q) : $b428e590a835ea4b$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b428e590a835ea4b$var$bb(e, f);
                            break;
                        case "textarea":
                            $b428e590a835ea4b$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b428e590a835ea4b$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b428e590a835ea4b$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b428e590a835ea4b$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b428e590a835ea4b$var$Pf] = f;
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b428e590a835ea4b$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b428e590a835ea4b$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b428e590a835ea4b$var$bd(b.containerInfo);
            } catch (t) {
                $b428e590a835ea4b$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            break;
        case 13:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b428e590a835ea4b$var$fk = $b428e590a835ea4b$var$B()));
            d & 4 && $b428e590a835ea4b$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b428e590a835ea4b$var$U = (l = $b428e590a835ea4b$var$U) || m, $b428e590a835ea4b$var$ck(b, a), $b428e590a835ea4b$var$U = l) : $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b428e590a835ea4b$var$V = a, m = a.child; null !== m;){
                    for(q = $b428e590a835ea4b$var$V = m; null !== $b428e590a835ea4b$var$V;){
                        r = $b428e590a835ea4b$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b428e590a835ea4b$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $b428e590a835ea4b$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b428e590a835ea4b$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b428e590a835ea4b$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b428e590a835ea4b$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b428e590a835ea4b$var$V = y) : $b428e590a835ea4b$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b428e590a835ea4b$var$rb("display", g));
                            } catch (t) {
                                $b428e590a835ea4b$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b428e590a835ea4b$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b428e590a835ea4b$var$ck(b, a);
            $b428e590a835ea4b$var$ek(a);
            d & 4 && $b428e590a835ea4b$var$ak(a);
            break;
        case 21:
            break;
        default:
            $b428e590a835ea4b$var$ck(b, a), $b428e590a835ea4b$var$ek(a);
    }
}
function $b428e590a835ea4b$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b428e590a835ea4b$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b428e590a835ea4b$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b428e590a835ea4b$var$ob(e, ""), d.flags &= -33);
                    var f = $b428e590a835ea4b$var$Uj(a);
                    $b428e590a835ea4b$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b428e590a835ea4b$var$Uj(a);
                    $b428e590a835ea4b$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($b428e590a835ea4b$var$p(161));
            }
        } catch (k) {
            $b428e590a835ea4b$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b428e590a835ea4b$var$hk(a, b, c) {
    $b428e590a835ea4b$var$V = a;
    $b428e590a835ea4b$var$ik(a, b, c);
}
function $b428e590a835ea4b$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b428e590a835ea4b$var$V;){
        var e = $b428e590a835ea4b$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b428e590a835ea4b$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b428e590a835ea4b$var$U;
                h = $b428e590a835ea4b$var$Jj;
                var l = $b428e590a835ea4b$var$U;
                $b428e590a835ea4b$var$Jj = g;
                if (($b428e590a835ea4b$var$U = k) && !l) for($b428e590a835ea4b$var$V = e; null !== $b428e590a835ea4b$var$V;)g = $b428e590a835ea4b$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b428e590a835ea4b$var$jk(e) : null !== k ? (k.return = g, $b428e590a835ea4b$var$V = k) : $b428e590a835ea4b$var$jk(e);
                for(; null !== f;)$b428e590a835ea4b$var$V = f, $b428e590a835ea4b$var$ik(f, b, c), f = f.sibling;
                $b428e590a835ea4b$var$V = e;
                $b428e590a835ea4b$var$Jj = h;
                $b428e590a835ea4b$var$U = l;
            }
            $b428e590a835ea4b$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b428e590a835ea4b$var$V = f) : $b428e590a835ea4b$var$kk(a, b, c);
    }
}
function $b428e590a835ea4b$var$kk(a) {
    for(; null !== $b428e590a835ea4b$var$V;){
        var b = $b428e590a835ea4b$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b428e590a835ea4b$var$U || $b428e590a835ea4b$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b428e590a835ea4b$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b428e590a835ea4b$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b428e590a835ea4b$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b428e590a835ea4b$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b428e590a835ea4b$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b428e590a835ea4b$var$p(163));
                }
                $b428e590a835ea4b$var$U || b.flags & 512 && $b428e590a835ea4b$var$Rj(b);
            } catch (r) {
                $b428e590a835ea4b$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b428e590a835ea4b$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b428e590a835ea4b$var$V = c;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
}
function $b428e590a835ea4b$var$gk(a) {
    for(; null !== $b428e590a835ea4b$var$V;){
        var b = $b428e590a835ea4b$var$V;
        if (b === a) {
            $b428e590a835ea4b$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b428e590a835ea4b$var$V = c;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
}
function $b428e590a835ea4b$var$jk(a) {
    for(; null !== $b428e590a835ea4b$var$V;){
        var b = $b428e590a835ea4b$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b428e590a835ea4b$var$Qj(4, b);
                    } catch (k) {
                        $b428e590a835ea4b$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b428e590a835ea4b$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b428e590a835ea4b$var$Rj(b);
                    } catch (k) {
                        $b428e590a835ea4b$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b428e590a835ea4b$var$Rj(b);
                    } catch (k) {
                        $b428e590a835ea4b$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b428e590a835ea4b$var$W(b, b.return, k);
        }
        if (b === a) {
            $b428e590a835ea4b$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b428e590a835ea4b$var$V = h;
            break;
        }
        $b428e590a835ea4b$var$V = b.return;
    }
}
var $b428e590a835ea4b$var$lk = Math.ceil, $b428e590a835ea4b$var$mk = $b428e590a835ea4b$var$ua.ReactCurrentDispatcher, $b428e590a835ea4b$var$nk = $b428e590a835ea4b$var$ua.ReactCurrentOwner, $b428e590a835ea4b$var$ok = $b428e590a835ea4b$var$ua.ReactCurrentBatchConfig, $b428e590a835ea4b$var$K = 0, $b428e590a835ea4b$var$Q = null, $b428e590a835ea4b$var$Y = null, $b428e590a835ea4b$var$Z = 0, $b428e590a835ea4b$var$fj = 0, $b428e590a835ea4b$var$ej = $b428e590a835ea4b$var$Uf(0), $b428e590a835ea4b$var$T = 0, $b428e590a835ea4b$var$pk = null, $b428e590a835ea4b$var$rh = 0, $b428e590a835ea4b$var$qk = 0, $b428e590a835ea4b$var$rk = 0, $b428e590a835ea4b$var$sk = null, $b428e590a835ea4b$var$tk = null, $b428e590a835ea4b$var$fk = 0, $b428e590a835ea4b$var$Gj = Infinity, $b428e590a835ea4b$var$uk = null, $b428e590a835ea4b$var$Oi = !1, $b428e590a835ea4b$var$Pi = null, $b428e590a835ea4b$var$Ri = null, $b428e590a835ea4b$var$vk = !1, $b428e590a835ea4b$var$wk = null, $b428e590a835ea4b$var$xk = 0, $b428e590a835ea4b$var$yk = 0, $b428e590a835ea4b$var$zk = null, $b428e590a835ea4b$var$Ak = -1, $b428e590a835ea4b$var$Bk = 0;
function $b428e590a835ea4b$var$R() {
    return 0 !== ($b428e590a835ea4b$var$K & 6) ? $b428e590a835ea4b$var$B() : -1 !== $b428e590a835ea4b$var$Ak ? $b428e590a835ea4b$var$Ak : $b428e590a835ea4b$var$Ak = $b428e590a835ea4b$var$B();
}
function $b428e590a835ea4b$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b428e590a835ea4b$var$K & 2) && 0 !== $b428e590a835ea4b$var$Z) return $b428e590a835ea4b$var$Z & -$b428e590a835ea4b$var$Z;
    if (null !== $b428e590a835ea4b$var$Kg.transition) return 0 === $b428e590a835ea4b$var$Bk && ($b428e590a835ea4b$var$Bk = $b428e590a835ea4b$var$yc()), $b428e590a835ea4b$var$Bk;
    a = $b428e590a835ea4b$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b428e590a835ea4b$var$jd(a.type);
    return a;
}
function $b428e590a835ea4b$var$gi(a, b, c, d) {
    if (50 < $b428e590a835ea4b$var$yk) throw $b428e590a835ea4b$var$yk = 0, $b428e590a835ea4b$var$zk = null, Error($b428e590a835ea4b$var$p(185));
    $b428e590a835ea4b$var$Ac(a, c, d);
    if (0 === ($b428e590a835ea4b$var$K & 2) || a !== $b428e590a835ea4b$var$Q) a === $b428e590a835ea4b$var$Q && (0 === ($b428e590a835ea4b$var$K & 2) && ($b428e590a835ea4b$var$qk |= c), 4 === $b428e590a835ea4b$var$T && $b428e590a835ea4b$var$Ck(a, $b428e590a835ea4b$var$Z)), $b428e590a835ea4b$var$Dk(a, d), 1 === c && 0 === $b428e590a835ea4b$var$K && 0 === (b.mode & 1) && ($b428e590a835ea4b$var$Gj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$fg && $b428e590a835ea4b$var$jg());
}
function $b428e590a835ea4b$var$Dk(a, b) {
    var c = a.callbackNode;
    $b428e590a835ea4b$var$wc(a, b);
    var d = $b428e590a835ea4b$var$uc(a, a === $b428e590a835ea4b$var$Q ? $b428e590a835ea4b$var$Z : 0);
    if (0 === d) null !== c && $b428e590a835ea4b$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b428e590a835ea4b$var$bc(c);
        if (1 === b) 0 === a.tag ? $b428e590a835ea4b$var$ig($b428e590a835ea4b$var$Ek.bind(null, a)) : $b428e590a835ea4b$var$hg($b428e590a835ea4b$var$Ek.bind(null, a)), $b428e590a835ea4b$var$Jf(function() {
            0 === ($b428e590a835ea4b$var$K & 6) && $b428e590a835ea4b$var$jg();
        }), c = null;
        else {
            switch($b428e590a835ea4b$var$Dc(d)){
                case 1:
                    c = $b428e590a835ea4b$var$fc;
                    break;
                case 4:
                    c = $b428e590a835ea4b$var$gc;
                    break;
                case 16:
                    c = $b428e590a835ea4b$var$hc;
                    break;
                case 536870912:
                    c = $b428e590a835ea4b$var$jc;
                    break;
                default:
                    c = $b428e590a835ea4b$var$hc;
            }
            c = $b428e590a835ea4b$var$Fk(c, $b428e590a835ea4b$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b428e590a835ea4b$var$Gk(a, b) {
    $b428e590a835ea4b$var$Ak = -1;
    $b428e590a835ea4b$var$Bk = 0;
    if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(327));
    var c = a.callbackNode;
    if ($b428e590a835ea4b$var$Hk() && a.callbackNode !== c) return null;
    var d = $b428e590a835ea4b$var$uc(a, a === $b428e590a835ea4b$var$Q ? $b428e590a835ea4b$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b428e590a835ea4b$var$Ik(a, d);
    else {
        b = d;
        var e = $b428e590a835ea4b$var$K;
        $b428e590a835ea4b$var$K |= 2;
        var f = $b428e590a835ea4b$var$Jk();
        if ($b428e590a835ea4b$var$Q !== a || $b428e590a835ea4b$var$Z !== b) $b428e590a835ea4b$var$uk = null, $b428e590a835ea4b$var$Gj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$Kk(a, b);
        for(;;)try {
            $b428e590a835ea4b$var$Lk();
            break;
        } catch (h) {
            $b428e590a835ea4b$var$Mk(a, h);
        }
        $b428e590a835ea4b$var$$g();
        $b428e590a835ea4b$var$mk.current = f;
        $b428e590a835ea4b$var$K = e;
        null !== $b428e590a835ea4b$var$Y ? b = 0 : ($b428e590a835ea4b$var$Q = null, $b428e590a835ea4b$var$Z = 0, b = $b428e590a835ea4b$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b428e590a835ea4b$var$xc(a), 0 !== e && (d = e, b = $b428e590a835ea4b$var$Nk(a, e)));
        if (1 === b) throw c = $b428e590a835ea4b$var$pk, $b428e590a835ea4b$var$Kk(a, 0), $b428e590a835ea4b$var$Ck(a, d), $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$B()), c;
        if (6 === b) $b428e590a835ea4b$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b428e590a835ea4b$var$Ok(e) && (b = $b428e590a835ea4b$var$Ik(a, d), 2 === b && (f = $b428e590a835ea4b$var$xc(a), 0 !== f && (d = f, b = $b428e590a835ea4b$var$Nk(a, f))), 1 === b)) throw c = $b428e590a835ea4b$var$pk, $b428e590a835ea4b$var$Kk(a, 0), $b428e590a835ea4b$var$Ck(a, d), $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b428e590a835ea4b$var$p(345));
                case 2:
                    $b428e590a835ea4b$var$Pk(a, $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$uk);
                    break;
                case 3:
                    $b428e590a835ea4b$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $b428e590a835ea4b$var$fk + 500 - $b428e590a835ea4b$var$B(), 10 < b)) {
                        if (0 !== $b428e590a835ea4b$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b428e590a835ea4b$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b428e590a835ea4b$var$Ff($b428e590a835ea4b$var$Pk.bind(null, a, $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$uk), b);
                        break;
                    }
                    $b428e590a835ea4b$var$Pk(a, $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$uk);
                    break;
                case 4:
                    $b428e590a835ea4b$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b428e590a835ea4b$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b428e590a835ea4b$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b428e590a835ea4b$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b428e590a835ea4b$var$Ff($b428e590a835ea4b$var$Pk.bind(null, a, $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$uk), d);
                        break;
                    }
                    $b428e590a835ea4b$var$Pk(a, $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$uk);
                    break;
                case 5:
                    $b428e590a835ea4b$var$Pk(a, $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$uk);
                    break;
                default:
                    throw Error($b428e590a835ea4b$var$p(329));
            }
        }
    }
    $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$B());
    return a.callbackNode === c ? $b428e590a835ea4b$var$Gk.bind(null, a) : null;
}
function $b428e590a835ea4b$var$Nk(a, b) {
    var c = $b428e590a835ea4b$var$sk;
    a.current.memoizedState.isDehydrated && ($b428e590a835ea4b$var$Kk(a, b).flags |= 256);
    a = $b428e590a835ea4b$var$Ik(a, b);
    2 !== a && (b = $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$tk = c, null !== b && $b428e590a835ea4b$var$Fj(b));
    return a;
}
function $b428e590a835ea4b$var$Fj(a) {
    null === $b428e590a835ea4b$var$tk ? $b428e590a835ea4b$var$tk = a : $b428e590a835ea4b$var$tk.push.apply($b428e590a835ea4b$var$tk, a);
}
function $b428e590a835ea4b$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b428e590a835ea4b$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b428e590a835ea4b$var$Ck(a, b) {
    b &= ~$b428e590a835ea4b$var$rk;
    b &= ~$b428e590a835ea4b$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b428e590a835ea4b$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b428e590a835ea4b$var$Ek(a) {
    if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(327));
    $b428e590a835ea4b$var$Hk();
    var b = $b428e590a835ea4b$var$uc(a, 0);
    if (0 === (b & 1)) return $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$B()), null;
    var c = $b428e590a835ea4b$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b428e590a835ea4b$var$xc(a);
        0 !== d && (b = d, c = $b428e590a835ea4b$var$Nk(a, d));
    }
    if (1 === c) throw c = $b428e590a835ea4b$var$pk, $b428e590a835ea4b$var$Kk(a, 0), $b428e590a835ea4b$var$Ck(a, b), $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$B()), c;
    if (6 === c) throw Error($b428e590a835ea4b$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b428e590a835ea4b$var$Pk(a, $b428e590a835ea4b$var$tk, $b428e590a835ea4b$var$uk);
    $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$B());
    return null;
}
function $b428e590a835ea4b$var$Qk(a, b) {
    var c = $b428e590a835ea4b$var$K;
    $b428e590a835ea4b$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b428e590a835ea4b$var$K = c, 0 === $b428e590a835ea4b$var$K && ($b428e590a835ea4b$var$Gj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$fg && $b428e590a835ea4b$var$jg());
    }
}
function $b428e590a835ea4b$var$Rk(a) {
    null !== $b428e590a835ea4b$var$wk && 0 === $b428e590a835ea4b$var$wk.tag && 0 === ($b428e590a835ea4b$var$K & 6) && $b428e590a835ea4b$var$Hk();
    var b = $b428e590a835ea4b$var$K;
    $b428e590a835ea4b$var$K |= 1;
    var c = $b428e590a835ea4b$var$ok.transition, d = $b428e590a835ea4b$var$C;
    try {
        if ($b428e590a835ea4b$var$ok.transition = null, $b428e590a835ea4b$var$C = 1, a) return a();
    } finally{
        $b428e590a835ea4b$var$C = d, $b428e590a835ea4b$var$ok.transition = c, $b428e590a835ea4b$var$K = b, 0 === ($b428e590a835ea4b$var$K & 6) && $b428e590a835ea4b$var$jg();
    }
}
function $b428e590a835ea4b$var$Hj() {
    $b428e590a835ea4b$var$fj = $b428e590a835ea4b$var$ej.current;
    $b428e590a835ea4b$var$E($b428e590a835ea4b$var$ej);
}
function $b428e590a835ea4b$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b428e590a835ea4b$var$Gf(c));
    if (null !== $b428e590a835ea4b$var$Y) for(c = $b428e590a835ea4b$var$Y.return; null !== c;){
        var d = c;
        $b428e590a835ea4b$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b428e590a835ea4b$var$$f();
                break;
            case 3:
                $b428e590a835ea4b$var$zh();
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$Wf);
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$H);
                $b428e590a835ea4b$var$Eh();
                break;
            case 5:
                $b428e590a835ea4b$var$Bh(d);
                break;
            case 4:
                $b428e590a835ea4b$var$zh();
                break;
            case 13:
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$L);
                break;
            case 19:
                $b428e590a835ea4b$var$E($b428e590a835ea4b$var$L);
                break;
            case 10:
                $b428e590a835ea4b$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $b428e590a835ea4b$var$Hj();
        }
        c = c.return;
    }
    $b428e590a835ea4b$var$Q = a;
    $b428e590a835ea4b$var$Y = a = $b428e590a835ea4b$var$Pg(a.current, null);
    $b428e590a835ea4b$var$Z = $b428e590a835ea4b$var$fj = b;
    $b428e590a835ea4b$var$T = 0;
    $b428e590a835ea4b$var$pk = null;
    $b428e590a835ea4b$var$rk = $b428e590a835ea4b$var$qk = $b428e590a835ea4b$var$rh = 0;
    $b428e590a835ea4b$var$tk = $b428e590a835ea4b$var$sk = null;
    if (null !== $b428e590a835ea4b$var$fh) {
        for(b = 0; b < $b428e590a835ea4b$var$fh.length; b++)if (c = $b428e590a835ea4b$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b428e590a835ea4b$var$fh = null;
    }
    return a;
}
function $b428e590a835ea4b$var$Mk(a, b) {
    do {
        var c = $b428e590a835ea4b$var$Y;
        try {
            $b428e590a835ea4b$var$$g();
            $b428e590a835ea4b$var$Fh.current = $b428e590a835ea4b$var$Rh;
            if ($b428e590a835ea4b$var$Ih) {
                for(var d = $b428e590a835ea4b$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b428e590a835ea4b$var$Ih = !1;
            }
            $b428e590a835ea4b$var$Hh = 0;
            $b428e590a835ea4b$var$O = $b428e590a835ea4b$var$N = $b428e590a835ea4b$var$M = null;
            $b428e590a835ea4b$var$Jh = !1;
            $b428e590a835ea4b$var$Kh = 0;
            $b428e590a835ea4b$var$nk.current = null;
            if (null === c || null === c.return) {
                $b428e590a835ea4b$var$T = 1;
                $b428e590a835ea4b$var$pk = b;
                $b428e590a835ea4b$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b428e590a835ea4b$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === (typeof k === "undefined" ? "undefined" : (0, $YtE9h._)(k)) && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b428e590a835ea4b$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b428e590a835ea4b$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $b428e590a835ea4b$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b428e590a835ea4b$var$Si(f, l, b);
                            $b428e590a835ea4b$var$tj();
                            break a;
                        }
                        k = Error($b428e590a835ea4b$var$p(426));
                    }
                } else if ($b428e590a835ea4b$var$I && h.mode & 1) {
                    var J = $b428e590a835ea4b$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b428e590a835ea4b$var$Vi(J, g, h, f, b);
                        $b428e590a835ea4b$var$Jg($b428e590a835ea4b$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $b428e590a835ea4b$var$Ji(k, h);
                4 !== $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$T = 2);
                null === $b428e590a835ea4b$var$sk ? $b428e590a835ea4b$var$sk = [
                    f
                ] : $b428e590a835ea4b$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b428e590a835ea4b$var$Ni(f, k, b);
                            $b428e590a835ea4b$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b428e590a835ea4b$var$Ri || !$b428e590a835ea4b$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b428e590a835ea4b$var$Qi(f, h, b);
                                $b428e590a835ea4b$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b428e590a835ea4b$var$Sk(c);
        } catch (na) {
            b = na;
            $b428e590a835ea4b$var$Y === c && null !== c && ($b428e590a835ea4b$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b428e590a835ea4b$var$Jk() {
    var a = $b428e590a835ea4b$var$mk.current;
    $b428e590a835ea4b$var$mk.current = $b428e590a835ea4b$var$Rh;
    return null === a ? $b428e590a835ea4b$var$Rh : a;
}
function $b428e590a835ea4b$var$tj() {
    if (0 === $b428e590a835ea4b$var$T || 3 === $b428e590a835ea4b$var$T || 2 === $b428e590a835ea4b$var$T) $b428e590a835ea4b$var$T = 4;
    null === $b428e590a835ea4b$var$Q || 0 === ($b428e590a835ea4b$var$rh & 268435455) && 0 === ($b428e590a835ea4b$var$qk & 268435455) || $b428e590a835ea4b$var$Ck($b428e590a835ea4b$var$Q, $b428e590a835ea4b$var$Z);
}
function $b428e590a835ea4b$var$Ik(a, b) {
    var c = $b428e590a835ea4b$var$K;
    $b428e590a835ea4b$var$K |= 2;
    var d = $b428e590a835ea4b$var$Jk();
    if ($b428e590a835ea4b$var$Q !== a || $b428e590a835ea4b$var$Z !== b) $b428e590a835ea4b$var$uk = null, $b428e590a835ea4b$var$Kk(a, b);
    for(;;)try {
        $b428e590a835ea4b$var$Tk();
        break;
    } catch (e) {
        $b428e590a835ea4b$var$Mk(a, e);
    }
    $b428e590a835ea4b$var$$g();
    $b428e590a835ea4b$var$K = c;
    $b428e590a835ea4b$var$mk.current = d;
    if (null !== $b428e590a835ea4b$var$Y) throw Error($b428e590a835ea4b$var$p(261));
    $b428e590a835ea4b$var$Q = null;
    $b428e590a835ea4b$var$Z = 0;
    return $b428e590a835ea4b$var$T;
}
function $b428e590a835ea4b$var$Tk() {
    for(; null !== $b428e590a835ea4b$var$Y;)$b428e590a835ea4b$var$Uk($b428e590a835ea4b$var$Y);
}
function $b428e590a835ea4b$var$Lk() {
    for(; null !== $b428e590a835ea4b$var$Y && !$b428e590a835ea4b$var$cc();)$b428e590a835ea4b$var$Uk($b428e590a835ea4b$var$Y);
}
function $b428e590a835ea4b$var$Uk(a) {
    var b = $b428e590a835ea4b$var$Vk(a.alternate, a, $b428e590a835ea4b$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b428e590a835ea4b$var$Sk(a) : $b428e590a835ea4b$var$Y = b;
    $b428e590a835ea4b$var$nk.current = null;
}
function $b428e590a835ea4b$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b428e590a835ea4b$var$Ej(c, b, $b428e590a835ea4b$var$fj), null !== c) {
                $b428e590a835ea4b$var$Y = c;
                return;
            }
        } else {
            c = $b428e590a835ea4b$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b428e590a835ea4b$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b428e590a835ea4b$var$T = 6;
                $b428e590a835ea4b$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b428e590a835ea4b$var$Y = b;
            return;
        }
        $b428e590a835ea4b$var$Y = b = a;
    }while (null !== b);
    0 === $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$T = 5);
}
function $b428e590a835ea4b$var$Pk(a, b, c) {
    var d = $b428e590a835ea4b$var$C, e = $b428e590a835ea4b$var$ok.transition;
    try {
        $b428e590a835ea4b$var$ok.transition = null, $b428e590a835ea4b$var$C = 1, $b428e590a835ea4b$var$Wk(a, b, c, d);
    } finally{
        $b428e590a835ea4b$var$ok.transition = e, $b428e590a835ea4b$var$C = d;
    }
    return null;
}
function $b428e590a835ea4b$var$Wk(a, b, c, d) {
    do $b428e590a835ea4b$var$Hk();
    while (null !== $b428e590a835ea4b$var$wk);
    if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b428e590a835ea4b$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b428e590a835ea4b$var$Bc(a, f);
    a === $b428e590a835ea4b$var$Q && ($b428e590a835ea4b$var$Y = $b428e590a835ea4b$var$Q = null, $b428e590a835ea4b$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b428e590a835ea4b$var$vk || ($b428e590a835ea4b$var$vk = !0, $b428e590a835ea4b$var$Fk($b428e590a835ea4b$var$hc, function() {
        $b428e590a835ea4b$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b428e590a835ea4b$var$ok.transition;
        $b428e590a835ea4b$var$ok.transition = null;
        var g = $b428e590a835ea4b$var$C;
        $b428e590a835ea4b$var$C = 1;
        var h = $b428e590a835ea4b$var$K;
        $b428e590a835ea4b$var$K |= 4;
        $b428e590a835ea4b$var$nk.current = null;
        $b428e590a835ea4b$var$Oj(a, c);
        $b428e590a835ea4b$var$dk(c, a);
        $b428e590a835ea4b$var$Oe($b428e590a835ea4b$var$Df);
        $b428e590a835ea4b$var$dd = !!$b428e590a835ea4b$var$Cf;
        $b428e590a835ea4b$var$Df = $b428e590a835ea4b$var$Cf = null;
        a.current = c;
        $b428e590a835ea4b$var$hk(c, a, e);
        $b428e590a835ea4b$var$dc();
        $b428e590a835ea4b$var$K = h;
        $b428e590a835ea4b$var$C = g;
        $b428e590a835ea4b$var$ok.transition = f;
    } else a.current = c;
    $b428e590a835ea4b$var$vk && ($b428e590a835ea4b$var$vk = !1, $b428e590a835ea4b$var$wk = a, $b428e590a835ea4b$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($b428e590a835ea4b$var$Ri = null);
    $b428e590a835ea4b$var$mc(c.stateNode, d);
    $b428e590a835ea4b$var$Dk(a, $b428e590a835ea4b$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b428e590a835ea4b$var$Oi) throw $b428e590a835ea4b$var$Oi = !1, a = $b428e590a835ea4b$var$Pi, $b428e590a835ea4b$var$Pi = null, a;
    0 !== ($b428e590a835ea4b$var$xk & 1) && 0 !== a.tag && $b428e590a835ea4b$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b428e590a835ea4b$var$zk ? $b428e590a835ea4b$var$yk++ : ($b428e590a835ea4b$var$yk = 0, $b428e590a835ea4b$var$zk = a) : $b428e590a835ea4b$var$yk = 0;
    $b428e590a835ea4b$var$jg();
    return null;
}
function $b428e590a835ea4b$var$Hk() {
    if (null !== $b428e590a835ea4b$var$wk) {
        var a = $b428e590a835ea4b$var$Dc($b428e590a835ea4b$var$xk), b = $b428e590a835ea4b$var$ok.transition, c = $b428e590a835ea4b$var$C;
        try {
            $b428e590a835ea4b$var$ok.transition = null;
            $b428e590a835ea4b$var$C = 16 > a ? 16 : a;
            if (null === $b428e590a835ea4b$var$wk) var d = !1;
            else {
                a = $b428e590a835ea4b$var$wk;
                $b428e590a835ea4b$var$wk = null;
                $b428e590a835ea4b$var$xk = 0;
                if (0 !== ($b428e590a835ea4b$var$K & 6)) throw Error($b428e590a835ea4b$var$p(331));
                var e = $b428e590a835ea4b$var$K;
                $b428e590a835ea4b$var$K |= 4;
                for($b428e590a835ea4b$var$V = a.current; null !== $b428e590a835ea4b$var$V;){
                    var f = $b428e590a835ea4b$var$V, g = f.child;
                    if (0 !== ($b428e590a835ea4b$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b428e590a835ea4b$var$V = l; null !== $b428e590a835ea4b$var$V;){
                                    var m = $b428e590a835ea4b$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b428e590a835ea4b$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b428e590a835ea4b$var$V = q;
                                    else for(; null !== $b428e590a835ea4b$var$V;){
                                        m = $b428e590a835ea4b$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b428e590a835ea4b$var$Sj(m);
                                        if (m === l) {
                                            $b428e590a835ea4b$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b428e590a835ea4b$var$V = r;
                                            break;
                                        }
                                        $b428e590a835ea4b$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b428e590a835ea4b$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b428e590a835ea4b$var$V = g;
                    else b: for(; null !== $b428e590a835ea4b$var$V;){
                        f = $b428e590a835ea4b$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b428e590a835ea4b$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b428e590a835ea4b$var$V = x;
                            break b;
                        }
                        $b428e590a835ea4b$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b428e590a835ea4b$var$V = w; null !== $b428e590a835ea4b$var$V;){
                    g = $b428e590a835ea4b$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b428e590a835ea4b$var$V = u;
                    else b: for(g = w; null !== $b428e590a835ea4b$var$V;){
                        h = $b428e590a835ea4b$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b428e590a835ea4b$var$Qj(9, h);
                            }
                        } catch (na) {
                            $b428e590a835ea4b$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b428e590a835ea4b$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b428e590a835ea4b$var$V = F;
                            break b;
                        }
                        $b428e590a835ea4b$var$V = h.return;
                    }
                }
                $b428e590a835ea4b$var$K = e;
                $b428e590a835ea4b$var$jg();
                if ($b428e590a835ea4b$var$lc && "function" === typeof $b428e590a835ea4b$var$lc.onPostCommitFiberRoot) try {
                    $b428e590a835ea4b$var$lc.onPostCommitFiberRoot($b428e590a835ea4b$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b428e590a835ea4b$var$C = c, $b428e590a835ea4b$var$ok.transition = b;
        }
    }
    return !1;
}
function $b428e590a835ea4b$var$Xk(a, b, c) {
    b = $b428e590a835ea4b$var$Ji(c, b);
    b = $b428e590a835ea4b$var$Ni(a, b, 1);
    a = $b428e590a835ea4b$var$nh(a, b, 1);
    b = $b428e590a835ea4b$var$R();
    null !== a && ($b428e590a835ea4b$var$Ac(a, 1, b), $b428e590a835ea4b$var$Dk(a, b));
}
function $b428e590a835ea4b$var$W(a, b, c) {
    if (3 === a.tag) $b428e590a835ea4b$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b428e590a835ea4b$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b428e590a835ea4b$var$Ri || !$b428e590a835ea4b$var$Ri.has(d))) {
                a = $b428e590a835ea4b$var$Ji(c, a);
                a = $b428e590a835ea4b$var$Qi(b, a, 1);
                b = $b428e590a835ea4b$var$nh(b, a, 1);
                a = $b428e590a835ea4b$var$R();
                null !== b && ($b428e590a835ea4b$var$Ac(b, 1, a), $b428e590a835ea4b$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b428e590a835ea4b$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b428e590a835ea4b$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $b428e590a835ea4b$var$Q === a && ($b428e590a835ea4b$var$Z & c) === c && (4 === $b428e590a835ea4b$var$T || 3 === $b428e590a835ea4b$var$T && ($b428e590a835ea4b$var$Z & 130023424) === $b428e590a835ea4b$var$Z && 500 > $b428e590a835ea4b$var$B() - $b428e590a835ea4b$var$fk ? $b428e590a835ea4b$var$Kk(a, 0) : $b428e590a835ea4b$var$rk |= c);
    $b428e590a835ea4b$var$Dk(a, b);
}
function $b428e590a835ea4b$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b428e590a835ea4b$var$sc, $b428e590a835ea4b$var$sc <<= 1, 0 === ($b428e590a835ea4b$var$sc & 130023424) && ($b428e590a835ea4b$var$sc = 4194304)));
    var c = $b428e590a835ea4b$var$R();
    a = $b428e590a835ea4b$var$ih(a, b);
    null !== a && ($b428e590a835ea4b$var$Ac(a, b, c), $b428e590a835ea4b$var$Dk(a, c));
}
function $b428e590a835ea4b$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b428e590a835ea4b$var$Yk(a, c);
}
function $b428e590a835ea4b$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b428e590a835ea4b$var$p(314));
    }
    null !== d && d.delete(b);
    $b428e590a835ea4b$var$Yk(a, c);
}
var $b428e590a835ea4b$var$Vk;
$b428e590a835ea4b$var$Vk = function Vk(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b428e590a835ea4b$var$Wf.current) $b428e590a835ea4b$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b428e590a835ea4b$var$dh = !1, $b428e590a835ea4b$var$yj(a, b, c);
            $b428e590a835ea4b$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b428e590a835ea4b$var$dh = !1, $b428e590a835ea4b$var$I && 0 !== (b.flags & 1048576) && $b428e590a835ea4b$var$ug(b, $b428e590a835ea4b$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b428e590a835ea4b$var$ij(a, b);
            a = b.pendingProps;
            var e = $b428e590a835ea4b$var$Yf(b, $b428e590a835ea4b$var$H.current);
            $b428e590a835ea4b$var$ch(b, c);
            e = $b428e590a835ea4b$var$Nh(null, b, d, a, e, c);
            var f = $b428e590a835ea4b$var$Sh();
            b.flags |= 1;
            "object" === (typeof e === "undefined" ? "undefined" : (0, $YtE9h._)(e)) && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b428e590a835ea4b$var$Zf(d) ? (f = !0, $b428e590a835ea4b$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b428e590a835ea4b$var$kh(b), e.updater = $b428e590a835ea4b$var$Ei, b.stateNode = e, e._reactInternals = b, $b428e590a835ea4b$var$Ii(b, d, a, c), b = $b428e590a835ea4b$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $b428e590a835ea4b$var$I && f && $b428e590a835ea4b$var$vg(b), $b428e590a835ea4b$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b428e590a835ea4b$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b428e590a835ea4b$var$Zk(d);
                a = $b428e590a835ea4b$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $b428e590a835ea4b$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b428e590a835ea4b$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b428e590a835ea4b$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b428e590a835ea4b$var$$i(null, b, d, $b428e590a835ea4b$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($b428e590a835ea4b$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Ci(d, e), $b428e590a835ea4b$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Ci(d, e), $b428e590a835ea4b$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $b428e590a835ea4b$var$kj(b);
                if (null === a) throw Error($b428e590a835ea4b$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b428e590a835ea4b$var$lh(a, b);
                $b428e590a835ea4b$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b428e590a835ea4b$var$Ji(Error($b428e590a835ea4b$var$p(423)), b);
                        b = $b428e590a835ea4b$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b428e590a835ea4b$var$Ji(Error($b428e590a835ea4b$var$p(424)), b);
                        b = $b428e590a835ea4b$var$lj(a, b, d, c, e);
                        break a;
                    } else for($b428e590a835ea4b$var$yg = $b428e590a835ea4b$var$Lf(b.stateNode.containerInfo.firstChild), $b428e590a835ea4b$var$xg = b, $b428e590a835ea4b$var$I = !0, $b428e590a835ea4b$var$zg = null, c = $b428e590a835ea4b$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b428e590a835ea4b$var$Ig();
                    if (d === e) {
                        b = $b428e590a835ea4b$var$Zi(a, b, c);
                        break a;
                    }
                    $b428e590a835ea4b$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b428e590a835ea4b$var$Ah(b), null === a && $b428e590a835ea4b$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b428e590a835ea4b$var$Ef(d, e) ? g = null : null !== f && $b428e590a835ea4b$var$Ef(d, f) && (b.flags |= 32), $b428e590a835ea4b$var$gj(a, b), $b428e590a835ea4b$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $b428e590a835ea4b$var$Eg(b), null;
        case 13:
            return $b428e590a835ea4b$var$oj(a, b, c);
        case 4:
            return $b428e590a835ea4b$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b428e590a835ea4b$var$Ug(b, null, d, c) : $b428e590a835ea4b$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Ci(d, e), $b428e590a835ea4b$var$Yi(a, b, d, e, c);
        case 7:
            return $b428e590a835ea4b$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b428e590a835ea4b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b428e590a835ea4b$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b428e590a835ea4b$var$G($b428e590a835ea4b$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b428e590a835ea4b$var$He(f.value, g)) {
                        if (f.children === e.children && !$b428e590a835ea4b$var$Wf.current) {
                            b = $b428e590a835ea4b$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b428e590a835ea4b$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b428e590a835ea4b$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b428e590a835ea4b$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b428e590a835ea4b$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b428e590a835ea4b$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b428e590a835ea4b$var$ch(b, c), e = $b428e590a835ea4b$var$eh(e), d = d(e), b.flags |= 1, $b428e590a835ea4b$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b428e590a835ea4b$var$Ci(d, b.pendingProps), e = $b428e590a835ea4b$var$Ci(d.type, e), $b428e590a835ea4b$var$$i(a, b, d, e, c);
        case 15:
            return $b428e590a835ea4b$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b428e590a835ea4b$var$Ci(d, e), $b428e590a835ea4b$var$ij(a, b), b.tag = 1, $b428e590a835ea4b$var$Zf(d) ? (a = !0, $b428e590a835ea4b$var$cg(b)) : a = !1, $b428e590a835ea4b$var$ch(b, c), $b428e590a835ea4b$var$Gi(b, d, e), $b428e590a835ea4b$var$Ii(b, d, e, c), $b428e590a835ea4b$var$jj(null, b, d, !0, a, c);
        case 19:
            return $b428e590a835ea4b$var$xj(a, b, c);
        case 22:
            return $b428e590a835ea4b$var$dj(a, b, c);
    }
    throw Error($b428e590a835ea4b$var$p(156, b.tag));
};
function $b428e590a835ea4b$var$Fk(a, b) {
    return $b428e590a835ea4b$var$ac(a, b);
}
function $b428e590a835ea4b$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b428e590a835ea4b$var$Bg(a, b, c, d) {
    return new $b428e590a835ea4b$var$$k(a, b, c, d);
}
function $b428e590a835ea4b$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b428e590a835ea4b$var$Zk(a) {
    if ("function" === typeof a) return $b428e590a835ea4b$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b428e590a835ea4b$var$Da) return 11;
        if (a === $b428e590a835ea4b$var$Ga) return 14;
    }
    return 2;
}
function $b428e590a835ea4b$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $b428e590a835ea4b$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b428e590a835ea4b$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b428e590a835ea4b$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b428e590a835ea4b$var$ya:
            return $b428e590a835ea4b$var$Tg(c.children, e, f, b);
        case $b428e590a835ea4b$var$za:
            g = 8;
            e |= 8;
            break;
        case $b428e590a835ea4b$var$Aa:
            return a = $b428e590a835ea4b$var$Bg(12, c, b, e | 2), a.elementType = $b428e590a835ea4b$var$Aa, a.lanes = f, a;
        case $b428e590a835ea4b$var$Ea:
            return a = $b428e590a835ea4b$var$Bg(13, c, b, e), a.elementType = $b428e590a835ea4b$var$Ea, a.lanes = f, a;
        case $b428e590a835ea4b$var$Fa:
            return a = $b428e590a835ea4b$var$Bg(19, c, b, e), a.elementType = $b428e590a835ea4b$var$Fa, a.lanes = f, a;
        case $b428e590a835ea4b$var$Ia:
            return $b428e590a835ea4b$var$pj(c, e, f, b);
        default:
            if ("object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && null !== a) switch(a.$$typeof){
                case $b428e590a835ea4b$var$Ba:
                    g = 10;
                    break a;
                case $b428e590a835ea4b$var$Ca:
                    g = 9;
                    break a;
                case $b428e590a835ea4b$var$Da:
                    g = 11;
                    break a;
                case $b428e590a835ea4b$var$Ga:
                    g = 14;
                    break a;
                case $b428e590a835ea4b$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b428e590a835ea4b$var$p(130, null == a ? a : typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a), ""));
    }
    b = $b428e590a835ea4b$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b428e590a835ea4b$var$Tg(a, b, c, d) {
    a = $b428e590a835ea4b$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b428e590a835ea4b$var$pj(a, b, c, d) {
    a = $b428e590a835ea4b$var$Bg(22, a, d, b);
    a.elementType = $b428e590a835ea4b$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b428e590a835ea4b$var$Qg(a, b, c) {
    a = $b428e590a835ea4b$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b428e590a835ea4b$var$Sg(a, b, c) {
    b = $b428e590a835ea4b$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b428e590a835ea4b$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b428e590a835ea4b$var$zc(0);
    this.expirationTimes = $b428e590a835ea4b$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b428e590a835ea4b$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b428e590a835ea4b$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $b428e590a835ea4b$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b428e590a835ea4b$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b428e590a835ea4b$var$kh(f);
    return a;
}
function $b428e590a835ea4b$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b428e590a835ea4b$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b428e590a835ea4b$var$dl(a) {
    if (!a) return $b428e590a835ea4b$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b428e590a835ea4b$var$Vb(a) !== a || 1 !== a.tag) throw Error($b428e590a835ea4b$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b428e590a835ea4b$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b428e590a835ea4b$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b428e590a835ea4b$var$Zf(c)) return $b428e590a835ea4b$var$bg(a, c, b);
    }
    return b;
}
function $b428e590a835ea4b$var$el(a, b, c, d, e, f, g, h, k) {
    a = $b428e590a835ea4b$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $b428e590a835ea4b$var$dl(null);
    c = a.current;
    d = $b428e590a835ea4b$var$R();
    e = $b428e590a835ea4b$var$yi(c);
    f = $b428e590a835ea4b$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b428e590a835ea4b$var$nh(c, f, e);
    a.current.lanes = e;
    $b428e590a835ea4b$var$Ac(a, e, d);
    $b428e590a835ea4b$var$Dk(a, d);
    return a;
}
function $b428e590a835ea4b$var$fl(a, b, c, d) {
    var e = b.current, f = $b428e590a835ea4b$var$R(), g = $b428e590a835ea4b$var$yi(e);
    c = $b428e590a835ea4b$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b428e590a835ea4b$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b428e590a835ea4b$var$nh(e, b, g);
    null !== a && ($b428e590a835ea4b$var$gi(a, e, g, f), $b428e590a835ea4b$var$oh(a, e, g));
    return g;
}
function $b428e590a835ea4b$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b428e590a835ea4b$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b428e590a835ea4b$var$il(a, b) {
    $b428e590a835ea4b$var$hl(a, b);
    (a = a.alternate) && $b428e590a835ea4b$var$hl(a, b);
}
function $b428e590a835ea4b$var$jl() {
    return null;
}
var $b428e590a835ea4b$var$kl = "function" === typeof reportError ? reportError : function kl(a) {
    console.error(a);
};
function $b428e590a835ea4b$var$ll(a) {
    this._internalRoot = a;
}
$b428e590a835ea4b$var$ml.prototype.render = $b428e590a835ea4b$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b428e590a835ea4b$var$p(409));
    $b428e590a835ea4b$var$fl(a, b, null, null);
};
$b428e590a835ea4b$var$ml.prototype.unmount = $b428e590a835ea4b$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b428e590a835ea4b$var$Rk(function() {
            $b428e590a835ea4b$var$fl(null, a, null, null);
        });
        b[$b428e590a835ea4b$var$uf] = null;
    }
};
function $b428e590a835ea4b$var$ml(a) {
    this._internalRoot = a;
}
$b428e590a835ea4b$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b428e590a835ea4b$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b428e590a835ea4b$var$Qc.length && 0 !== b && b < $b428e590a835ea4b$var$Qc[c].priority; c++);
        $b428e590a835ea4b$var$Qc.splice(c, 0, a);
        0 === c && $b428e590a835ea4b$var$Vc(a);
    }
};
function $b428e590a835ea4b$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b428e590a835ea4b$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b428e590a835ea4b$var$pl() {}
function $b428e590a835ea4b$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function d() {
                var _$a = $b428e590a835ea4b$var$gl(g);
                f.call(_$a);
            };
        }
        var g = $b428e590a835ea4b$var$el(b, d, a, 0, null, !1, !1, "", $b428e590a835ea4b$var$pl);
        a._reactRootContainer = g;
        a[$b428e590a835ea4b$var$uf] = g.current;
        $b428e590a835ea4b$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b428e590a835ea4b$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function d() {
            var _$a = $b428e590a835ea4b$var$gl(k);
            h.call(_$a);
        };
    }
    var k = $b428e590a835ea4b$var$bl(a, 0, !1, null, null, !1, !1, "", $b428e590a835ea4b$var$pl);
    a._reactRootContainer = k;
    a[$b428e590a835ea4b$var$uf] = k.current;
    $b428e590a835ea4b$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b428e590a835ea4b$var$Rk(function() {
        $b428e590a835ea4b$var$fl(b, k, c, d);
    });
    return k;
}
function $b428e590a835ea4b$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function e() {
                var _$a = $b428e590a835ea4b$var$gl(g);
                h.call(_$a);
            };
        }
        $b428e590a835ea4b$var$fl(b, g, a, e);
    } else g = $b428e590a835ea4b$var$ql(c, b, a, e, d);
    return $b428e590a835ea4b$var$gl(g);
}
$b428e590a835ea4b$var$Ec = function Ec(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b428e590a835ea4b$var$tc(b.pendingLanes);
                0 !== c && ($b428e590a835ea4b$var$Cc(b, c | 1), $b428e590a835ea4b$var$Dk(b, $b428e590a835ea4b$var$B()), 0 === ($b428e590a835ea4b$var$K & 6) && ($b428e590a835ea4b$var$Gj = $b428e590a835ea4b$var$B() + 500, $b428e590a835ea4b$var$jg()));
            }
            break;
        case 13:
            $b428e590a835ea4b$var$Rk(function() {
                var b = $b428e590a835ea4b$var$ih(a, 1);
                if (null !== b) {
                    var c = $b428e590a835ea4b$var$R();
                    $b428e590a835ea4b$var$gi(b, a, 1, c);
                }
            }), $b428e590a835ea4b$var$il(a, 1);
    }
};
$b428e590a835ea4b$var$Fc = function Fc(a) {
    if (13 === a.tag) {
        var b = $b428e590a835ea4b$var$ih(a, 134217728);
        if (null !== b) {
            var c = $b428e590a835ea4b$var$R();
            $b428e590a835ea4b$var$gi(b, a, 134217728, c);
        }
        $b428e590a835ea4b$var$il(a, 134217728);
    }
};
$b428e590a835ea4b$var$Gc = function Gc(a) {
    if (13 === a.tag) {
        var b = $b428e590a835ea4b$var$yi(a), c = $b428e590a835ea4b$var$ih(a, b);
        if (null !== c) {
            var d = $b428e590a835ea4b$var$R();
            $b428e590a835ea4b$var$gi(c, a, b, d);
        }
        $b428e590a835ea4b$var$il(a, b);
    }
};
$b428e590a835ea4b$var$Hc = function Hc() {
    return $b428e590a835ea4b$var$C;
};
$b428e590a835ea4b$var$Ic = function Ic(a, b) {
    var c = $b428e590a835ea4b$var$C;
    try {
        return $b428e590a835ea4b$var$C = a, b();
    } finally{
        $b428e590a835ea4b$var$C = c;
    }
};
$b428e590a835ea4b$var$yb = function yb(a, b, c) {
    switch(b){
        case "input":
            $b428e590a835ea4b$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b428e590a835ea4b$var$Db(d);
                        if (!e) throw Error($b428e590a835ea4b$var$p(90));
                        $b428e590a835ea4b$var$Wa(d);
                        $b428e590a835ea4b$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b428e590a835ea4b$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b428e590a835ea4b$var$fb(a, !!c.multiple, b, !1);
    }
};
$b428e590a835ea4b$var$Gb = $b428e590a835ea4b$var$Qk;
$b428e590a835ea4b$var$Hb = $b428e590a835ea4b$var$Rk;
var $b428e590a835ea4b$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $b428e590a835ea4b$var$Cb,
        $b428e590a835ea4b$var$ue,
        $b428e590a835ea4b$var$Db,
        $b428e590a835ea4b$var$Eb,
        $b428e590a835ea4b$var$Fb,
        $b428e590a835ea4b$var$Qk
    ]
}, $b428e590a835ea4b$var$tl = {
    findFiberByHostInstance: $b428e590a835ea4b$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $b428e590a835ea4b$var$ul = {
    bundleType: $b428e590a835ea4b$var$tl.bundleType,
    version: $b428e590a835ea4b$var$tl.version,
    rendererPackageName: $b428e590a835ea4b$var$tl.rendererPackageName,
    rendererConfig: $b428e590a835ea4b$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b428e590a835ea4b$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function findHostInstanceByFiber(a) {
        a = $b428e590a835ea4b$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b428e590a835ea4b$var$tl.findFiberByHostInstance || $b428e590a835ea4b$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b428e590a835ea4b$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b428e590a835ea4b$var$vl.isDisabled && $b428e590a835ea4b$var$vl.supportsFiber) try {
        $b428e590a835ea4b$var$kc = $b428e590a835ea4b$var$vl.inject($b428e590a835ea4b$var$ul), $b428e590a835ea4b$var$lc = $b428e590a835ea4b$var$vl;
    } catch (a) {}
}
$b428e590a835ea4b$export$ae55be85d98224ed = $b428e590a835ea4b$var$sl;
$b428e590a835ea4b$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b428e590a835ea4b$var$nl(b)) throw Error($b428e590a835ea4b$var$p(200));
    return $b428e590a835ea4b$var$cl(a, b, null, c);
};
$b428e590a835ea4b$export$882461b6382ed46c = function(a, b) {
    if (!$b428e590a835ea4b$var$nl(a)) throw Error($b428e590a835ea4b$var$p(299));
    var c = !1, d = "", e = $b428e590a835ea4b$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b428e590a835ea4b$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$b428e590a835ea4b$var$uf] = b.current;
    $b428e590a835ea4b$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b428e590a835ea4b$var$ll(b);
};
$b428e590a835ea4b$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b428e590a835ea4b$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b428e590a835ea4b$var$p(268, a));
    }
    a = $b428e590a835ea4b$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b428e590a835ea4b$export$cd75ccfd720a3cd4 = function(a) {
    return $b428e590a835ea4b$var$Rk(a);
};
$b428e590a835ea4b$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b428e590a835ea4b$var$ol(b)) throw Error($b428e590a835ea4b$var$p(200));
    return $b428e590a835ea4b$var$rl(null, a, b, !0, c);
};
$b428e590a835ea4b$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b428e590a835ea4b$var$nl(a)) throw Error($b428e590a835ea4b$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b428e590a835ea4b$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b428e590a835ea4b$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b428e590a835ea4b$var$uf] = b.current;
    $b428e590a835ea4b$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b428e590a835ea4b$var$ml(b);
};
$b428e590a835ea4b$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b428e590a835ea4b$var$ol(b)) throw Error($b428e590a835ea4b$var$p(200));
    return $b428e590a835ea4b$var$rl(null, a, b, !1, c);
};
$b428e590a835ea4b$export$502457920280e6be = function(a) {
    if (!$b428e590a835ea4b$var$ol(a)) throw Error($b428e590a835ea4b$var$p(40));
    return a._reactRootContainer ? ($b428e590a835ea4b$var$Rk(function() {
        $b428e590a835ea4b$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b428e590a835ea4b$var$uf] = null;
        });
    }), !0) : !1;
};
$b428e590a835ea4b$export$c78a37762a8d58e1 = $b428e590a835ea4b$var$Qk;
$b428e590a835ea4b$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b428e590a835ea4b$var$ol(c)) throw Error($b428e590a835ea4b$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b428e590a835ea4b$var$p(38));
    return $b428e590a835ea4b$var$rl(a, b, c, !1, d);
};
$b428e590a835ea4b$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("go0bk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4T7oT"));

});
parcelRegister("4T7oT", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $38f20a15ebe50fce$export$c4744153514ff05d; }, function (v) { return $38f20a15ebe50fce$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $38f20a15ebe50fce$export$3e506c1ccc9cc1a7; }, function (v) { return $38f20a15ebe50fce$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $38f20a15ebe50fce$export$e26fe2ed2fa76875; }, function (v) { return $38f20a15ebe50fce$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $38f20a15ebe50fce$export$502329bbf4b505b1; }, function (v) { return $38f20a15ebe50fce$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $38f20a15ebe50fce$export$6e3807111c4874c4; }, function (v) { return $38f20a15ebe50fce$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $38f20a15ebe50fce$export$c27134553091fb3a; }, function (v) { return $38f20a15ebe50fce$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $38f20a15ebe50fce$export$33ee1acdc04fd2a2; }, function (v) { return $38f20a15ebe50fce$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $38f20a15ebe50fce$export$b00a404bbd5edef2; }, function (v) { return $38f20a15ebe50fce$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $38f20a15ebe50fce$export$8352ce38b91d0c62; }, function (v) { return $38f20a15ebe50fce$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $38f20a15ebe50fce$export$d66a1c1c77bd778b; }, function (v) { return $38f20a15ebe50fce$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $38f20a15ebe50fce$export$d3dfb8e4810cb555; }, function (v) { return $38f20a15ebe50fce$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $38f20a15ebe50fce$export$839f9183b0465a69; }, function (v) { return $38f20a15ebe50fce$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $38f20a15ebe50fce$export$72fdf0e06517287b; }, function (v) { return $38f20a15ebe50fce$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $38f20a15ebe50fce$export$4b844e58a3e414b4; }, function (v) { return $38f20a15ebe50fce$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $38f20a15ebe50fce$export$816d2913ae6b83b1; }, function (v) { return $38f20a15ebe50fce$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $38f20a15ebe50fce$export$61bcfe829111a1d0; }, function (v) { return $38f20a15ebe50fce$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $38f20a15ebe50fce$export$7ee8c9beb337bc3f; }, function (v) { return $38f20a15ebe50fce$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $38f20a15ebe50fce$export$b5836b71941fa3ed; }, function (v) { return $38f20a15ebe50fce$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $38f20a15ebe50fce$export$cf845f2c119da08a; }, function (v) { return $38f20a15ebe50fce$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $38f20a15ebe50fce$export$c4744153514ff05d;
var $38f20a15ebe50fce$export$3e506c1ccc9cc1a7;
var $38f20a15ebe50fce$export$e26fe2ed2fa76875;
var $38f20a15ebe50fce$export$502329bbf4b505b1;
var $38f20a15ebe50fce$export$6e3807111c4874c4;
var $38f20a15ebe50fce$export$c27134553091fb3a;
var $38f20a15ebe50fce$export$33ee1acdc04fd2a2;
var $38f20a15ebe50fce$export$b00a404bbd5edef2;
var $38f20a15ebe50fce$export$8352ce38b91d0c62;
var $38f20a15ebe50fce$export$d66a1c1c77bd778b;
var $38f20a15ebe50fce$export$d3dfb8e4810cb555;
var $38f20a15ebe50fce$export$839f9183b0465a69;
var $38f20a15ebe50fce$export$72fdf0e06517287b;
var $38f20a15ebe50fce$export$4b844e58a3e414b4;
var $38f20a15ebe50fce$export$816d2913ae6b83b1;
var $38f20a15ebe50fce$export$61bcfe829111a1d0;
var $38f20a15ebe50fce$export$7ee8c9beb337bc3f;
var $38f20a15ebe50fce$export$b5836b71941fa3ed;
var $38f20a15ebe50fce$export$cf845f2c119da08a;
'use strict';
function $38f20a15ebe50fce$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $38f20a15ebe50fce$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $38f20a15ebe50fce$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $38f20a15ebe50fce$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $38f20a15ebe50fce$var$g(C, c)) n < e && 0 > $38f20a15ebe50fce$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $38f20a15ebe50fce$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $38f20a15ebe50fce$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $YtE9h._)(performance)) && "function" === typeof performance.now) {
    var $38f20a15ebe50fce$var$l = performance;
    $38f20a15ebe50fce$export$c4744153514ff05d = function() {
        return $38f20a15ebe50fce$var$l.now();
    };
} else {
    var $38f20a15ebe50fce$var$p = Date, $38f20a15ebe50fce$var$q = $38f20a15ebe50fce$var$p.now();
    $38f20a15ebe50fce$export$c4744153514ff05d = function() {
        return $38f20a15ebe50fce$var$p.now() - $38f20a15ebe50fce$var$q;
    };
}
var $38f20a15ebe50fce$var$r = [], $38f20a15ebe50fce$var$t = [], $38f20a15ebe50fce$var$u = 1, $38f20a15ebe50fce$var$v = null, $38f20a15ebe50fce$var$y = 3, $38f20a15ebe50fce$var$z = !1, $38f20a15ebe50fce$var$A = !1, $38f20a15ebe50fce$var$B = !1, $38f20a15ebe50fce$var$D = "function" === typeof setTimeout ? setTimeout : null, $38f20a15ebe50fce$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $38f20a15ebe50fce$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $38f20a15ebe50fce$var$G(a) {
    for(var b = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t); null !== b;){
        if (null === b.callback) $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$t);
        else if (b.startTime <= a) $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$t), b.sortIndex = b.expirationTime, $38f20a15ebe50fce$var$f($38f20a15ebe50fce$var$r, b);
        else break;
        b = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t);
    }
}
function $38f20a15ebe50fce$var$H(a) {
    $38f20a15ebe50fce$var$B = !1;
    $38f20a15ebe50fce$var$G(a);
    if (!$38f20a15ebe50fce$var$A) {
        if (null !== $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r)) $38f20a15ebe50fce$var$A = !0, $38f20a15ebe50fce$var$I($38f20a15ebe50fce$var$J);
        else {
            var b = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t);
            null !== b && $38f20a15ebe50fce$var$K($38f20a15ebe50fce$var$H, b.startTime - a);
        }
    }
}
function $38f20a15ebe50fce$var$J(a, b) {
    $38f20a15ebe50fce$var$A = !1;
    $38f20a15ebe50fce$var$B && ($38f20a15ebe50fce$var$B = !1, $38f20a15ebe50fce$var$E($38f20a15ebe50fce$var$L), $38f20a15ebe50fce$var$L = -1);
    $38f20a15ebe50fce$var$z = !0;
    var c = $38f20a15ebe50fce$var$y;
    try {
        $38f20a15ebe50fce$var$G(b);
        for($38f20a15ebe50fce$var$v = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r); null !== $38f20a15ebe50fce$var$v && (!($38f20a15ebe50fce$var$v.expirationTime > b) || a && !$38f20a15ebe50fce$var$M());){
            var d = $38f20a15ebe50fce$var$v.callback;
            if ("function" === typeof d) {
                $38f20a15ebe50fce$var$v.callback = null;
                $38f20a15ebe50fce$var$y = $38f20a15ebe50fce$var$v.priorityLevel;
                var e = d($38f20a15ebe50fce$var$v.expirationTime <= b);
                b = $38f20a15ebe50fce$export$c4744153514ff05d();
                "function" === typeof e ? $38f20a15ebe50fce$var$v.callback = e : $38f20a15ebe50fce$var$v === $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r) && $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$r);
                $38f20a15ebe50fce$var$G(b);
            } else $38f20a15ebe50fce$var$k($38f20a15ebe50fce$var$r);
            $38f20a15ebe50fce$var$v = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r);
        }
        if (null !== $38f20a15ebe50fce$var$v) var w = !0;
        else {
            var m = $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t);
            null !== m && $38f20a15ebe50fce$var$K($38f20a15ebe50fce$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $38f20a15ebe50fce$var$v = null, $38f20a15ebe50fce$var$y = c, $38f20a15ebe50fce$var$z = !1;
    }
}
var $38f20a15ebe50fce$var$N = !1, $38f20a15ebe50fce$var$O = null, $38f20a15ebe50fce$var$L = -1, $38f20a15ebe50fce$var$P = 5, $38f20a15ebe50fce$var$Q = -1;
function $38f20a15ebe50fce$var$M() {
    return $38f20a15ebe50fce$export$c4744153514ff05d() - $38f20a15ebe50fce$var$Q < $38f20a15ebe50fce$var$P ? !1 : !0;
}
function $38f20a15ebe50fce$var$R() {
    if (null !== $38f20a15ebe50fce$var$O) {
        var a = $38f20a15ebe50fce$export$c4744153514ff05d();
        $38f20a15ebe50fce$var$Q = a;
        var b = !0;
        try {
            b = $38f20a15ebe50fce$var$O(!0, a);
        } finally{
            b ? $38f20a15ebe50fce$var$S() : ($38f20a15ebe50fce$var$N = !1, $38f20a15ebe50fce$var$O = null);
        }
    } else $38f20a15ebe50fce$var$N = !1;
}
var $38f20a15ebe50fce$var$S;
if ("function" === typeof $38f20a15ebe50fce$var$F) $38f20a15ebe50fce$var$S = function S() {
    $38f20a15ebe50fce$var$F($38f20a15ebe50fce$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $38f20a15ebe50fce$var$T = new MessageChannel, $38f20a15ebe50fce$var$U = $38f20a15ebe50fce$var$T.port2;
    $38f20a15ebe50fce$var$T.port1.onmessage = $38f20a15ebe50fce$var$R;
    $38f20a15ebe50fce$var$S = function S() {
        $38f20a15ebe50fce$var$U.postMessage(null);
    };
} else $38f20a15ebe50fce$var$S = function S() {
    $38f20a15ebe50fce$var$D($38f20a15ebe50fce$var$R, 0);
};
function $38f20a15ebe50fce$var$I(a) {
    $38f20a15ebe50fce$var$O = a;
    $38f20a15ebe50fce$var$N || ($38f20a15ebe50fce$var$N = !0, $38f20a15ebe50fce$var$S());
}
function $38f20a15ebe50fce$var$K(a, b) {
    $38f20a15ebe50fce$var$L = $38f20a15ebe50fce$var$D(function() {
        a($38f20a15ebe50fce$export$c4744153514ff05d());
    }, b);
}
$38f20a15ebe50fce$export$3e506c1ccc9cc1a7 = 5;
$38f20a15ebe50fce$export$e26fe2ed2fa76875 = 1;
$38f20a15ebe50fce$export$502329bbf4b505b1 = 4;
$38f20a15ebe50fce$export$6e3807111c4874c4 = 3;
$38f20a15ebe50fce$export$c27134553091fb3a = null;
$38f20a15ebe50fce$export$33ee1acdc04fd2a2 = 2;
$38f20a15ebe50fce$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$38f20a15ebe50fce$export$8352ce38b91d0c62 = function() {
    $38f20a15ebe50fce$var$A || $38f20a15ebe50fce$var$z || ($38f20a15ebe50fce$var$A = !0, $38f20a15ebe50fce$var$I($38f20a15ebe50fce$var$J));
};
$38f20a15ebe50fce$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $38f20a15ebe50fce$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$38f20a15ebe50fce$export$d3dfb8e4810cb555 = function() {
    return $38f20a15ebe50fce$var$y;
};
$38f20a15ebe50fce$export$839f9183b0465a69 = function() {
    return $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r);
};
$38f20a15ebe50fce$export$72fdf0e06517287b = function(a) {
    switch($38f20a15ebe50fce$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $38f20a15ebe50fce$var$y;
    }
    var c = $38f20a15ebe50fce$var$y;
    $38f20a15ebe50fce$var$y = b;
    try {
        return a();
    } finally{
        $38f20a15ebe50fce$var$y = c;
    }
};
$38f20a15ebe50fce$export$4b844e58a3e414b4 = function() {};
$38f20a15ebe50fce$export$816d2913ae6b83b1 = function() {};
$38f20a15ebe50fce$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $38f20a15ebe50fce$var$y;
    $38f20a15ebe50fce$var$y = a;
    try {
        return b();
    } finally{
        $38f20a15ebe50fce$var$y = c;
    }
};
$38f20a15ebe50fce$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $38f20a15ebe50fce$export$c4744153514ff05d();
    "object" === (typeof c === "undefined" ? "undefined" : (0, $YtE9h._)(c)) && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $38f20a15ebe50fce$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $38f20a15ebe50fce$var$f($38f20a15ebe50fce$var$t, a), null === $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$r) && a === $38f20a15ebe50fce$var$h($38f20a15ebe50fce$var$t) && ($38f20a15ebe50fce$var$B ? ($38f20a15ebe50fce$var$E($38f20a15ebe50fce$var$L), $38f20a15ebe50fce$var$L = -1) : $38f20a15ebe50fce$var$B = !0, $38f20a15ebe50fce$var$K($38f20a15ebe50fce$var$H, c - d))) : (a.sortIndex = e, $38f20a15ebe50fce$var$f($38f20a15ebe50fce$var$r, a), $38f20a15ebe50fce$var$A || $38f20a15ebe50fce$var$z || ($38f20a15ebe50fce$var$A = !0, $38f20a15ebe50fce$var$I($38f20a15ebe50fce$var$J)));
    return a;
};
$38f20a15ebe50fce$export$b5836b71941fa3ed = $38f20a15ebe50fce$var$M;
$38f20a15ebe50fce$export$cf845f2c119da08a = function(a) {
    var b = $38f20a15ebe50fce$var$y;
    return function() {
        var c = $38f20a15ebe50fce$var$y;
        $38f20a15ebe50fce$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $38f20a15ebe50fce$var$y = c;
        }
    };
};

});



parcelRegister("gHY9J", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $c29f5337323ae6dd$export$bf730a2d8bf68b42; }, function (v) { return $c29f5337323ae6dd$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c29f5337323ae6dd$export$bf730a2d8bf68b42;
'use strict';

var $fIwXP = parcelRequire("fIwXP");
function $c29f5337323ae6dd$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c29f5337323ae6dd$var$p = "function" === typeof Object.is ? Object.is : $c29f5337323ae6dd$var$n, $c29f5337323ae6dd$var$q = $fIwXP.useSyncExternalStore, $c29f5337323ae6dd$var$r = $fIwXP.useRef, $c29f5337323ae6dd$var$t = $fIwXP.useEffect, $c29f5337323ae6dd$var$u = $fIwXP.useMemo, $c29f5337323ae6dd$var$v = $fIwXP.useDebugValue;
$c29f5337323ae6dd$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $c29f5337323ae6dd$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $c29f5337323ae6dd$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var _$b = f.value;
                    if (h(_$b, a)) return k = _$b;
                }
                return k = a;
            }
            _$b = k;
            if ($c29f5337323ae6dd$var$p(d, a)) return _$b;
            var _$e = l(a);
            if (void 0 !== h && h(_$b, _$e)) return _$b;
            d = a;
            return k = _$e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $c29f5337323ae6dd$var$q(a, c[0], c[1]);
    $c29f5337323ae6dd$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $c29f5337323ae6dd$var$v(d);
    return d;
};

});

parcelRegister("1wVsT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $11d55af27ee762da$var$_react = $11d55af27ee762da$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $2Qs16 = parcelRequire("2Qs16");

var $11d55af27ee762da$var$_json2mq = $11d55af27ee762da$var$_interopRequireDefault((parcelRequire("jTrNc")));

var $11d55af27ee762da$var$_defaultProps = $11d55af27ee762da$var$_interopRequireDefault((parcelRequire("ZEwRt")));

var $8XSk1 = parcelRequire("8XSk1");
function $11d55af27ee762da$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $11d55af27ee762da$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $11d55af27ee762da$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $11d55af27ee762da$var$_typeof(o);
}
function $11d55af27ee762da$var$_extends() {
    $11d55af27ee762da$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $11d55af27ee762da$var$_extends.apply(this, arguments);
}
function $11d55af27ee762da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11d55af27ee762da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11d55af27ee762da$var$ownKeys(Object(t), !0).forEach(function(r) {
            $11d55af27ee762da$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11d55af27ee762da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $11d55af27ee762da$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $11d55af27ee762da$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $11d55af27ee762da$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $11d55af27ee762da$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $11d55af27ee762da$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11d55af27ee762da$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $11d55af27ee762da$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $11d55af27ee762da$var$_setPrototypeOf(subClass, superClass);
}
function $11d55af27ee762da$var$_setPrototypeOf(o, p) {
    $11d55af27ee762da$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $11d55af27ee762da$var$_setPrototypeOf(o, p);
}
function $11d55af27ee762da$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $11d55af27ee762da$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $11d55af27ee762da$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $11d55af27ee762da$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $11d55af27ee762da$var$_possibleConstructorReturn(this, result);
    };
}
function $11d55af27ee762da$var$_possibleConstructorReturn(self, call) {
    if (call && ($11d55af27ee762da$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $11d55af27ee762da$var$_assertThisInitialized(self);
}
function $11d55af27ee762da$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $11d55af27ee762da$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($11d55af27ee762da$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $11d55af27ee762da$var$_getPrototypeOf(o) {
    $11d55af27ee762da$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $11d55af27ee762da$var$_getPrototypeOf(o);
}
function $11d55af27ee762da$var$_defineProperty(obj, key, value) {
    key = $11d55af27ee762da$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $11d55af27ee762da$var$_toPropertyKey(t) {
    var i = $11d55af27ee762da$var$_toPrimitive(t, "string");
    return "symbol" == $11d55af27ee762da$var$_typeof(i) ? i : String(i);
}
function $11d55af27ee762da$var$_toPrimitive(t, r) {
    if ("object" != $11d55af27ee762da$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $11d55af27ee762da$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

var $11d55af27ee762da$var$enquire = (0, $8XSk1.canUseDOM)() && (parcelRequire("4RUun"));
var $11d55af27ee762da$var$Slider = module.exports["default"] = /*#__PURE__*/ function(_React$Component) {
    $11d55af27ee762da$var$_inherits(Slider, _React$Component);
    var _super = $11d55af27ee762da$var$_createSuper(Slider);
    function Slider(props) {
        var _this;
        $11d55af27ee762da$var$_classCallCheck(this, Slider);
        _this = _super.call(this, props);
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "innerSliderRefHandler", function(ref) {
            return _this.innerSlider = ref;
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickPrev", function() {
            return _this.innerSlider.slickPrev();
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickNext", function() {
            return _this.innerSlider.slickNext();
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return _this.innerSlider.slickGoTo(slide, dontAnimate);
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickPause", function() {
            return _this.innerSlider.pause("paused");
        });
        $11d55af27ee762da$var$_defineProperty($11d55af27ee762da$var$_assertThisInitialized(_this), "slickPlay", function() {
            return _this.innerSlider.autoPlay("play");
        });
        _this.state = {
            breakpoint: null
        };
        _this._responsiveMediaHandlers = [];
        return _this;
    }
    $11d55af27ee762da$var$_createClass(Slider, [
        {
            key: "media",
            value: function media(query, handler) {
                // javascript handler for  css media query
                $11d55af27ee762da$var$enquire.register(query, handler);
                this._responsiveMediaHandlers.push({
                    query: query,
                    handler: handler
                });
            } // handles responsive breakpoints
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                // performance monitoring
                //if (process.env.NODE_ENV !== 'production') {
                //const { whyDidYouUpdate } = require('why-did-you-update')
                //whyDidYouUpdate(React)
                //}
                if (this.props.responsive) {
                    var breakpoints = this.props.responsive.map(function(breakpt) {
                        return breakpt.breakpoint;
                    });
                    // sort them in increasing order of their numerical value
                    breakpoints.sort(function(x, y) {
                        return x - y;
                    });
                    breakpoints.forEach(function(breakpoint, index) {
                        // media query for each breakpoint
                        var bQuery;
                        if (index === 0) bQuery = (0, $11d55af27ee762da$var$_json2mq["default"])({
                            minWidth: 0,
                            maxWidth: breakpoint
                        });
                        else bQuery = (0, $11d55af27ee762da$var$_json2mq["default"])({
                            minWidth: breakpoints[index - 1] + 1,
                            maxWidth: breakpoint
                        });
                        // when not using server side rendering
                        (0, $8XSk1.canUseDOM)() && _this2.media(bQuery, function() {
                            _this2.setState({
                                breakpoint: breakpoint
                            });
                        });
                    });
                    // Register media query for full screen. Need to support resize from small to large
                    // convert javascript object to media query string
                    var query = (0, $11d55af27ee762da$var$_json2mq["default"])({
                        minWidth: breakpoints.slice(-1)[0]
                    });
                    (0, $8XSk1.canUseDOM)() && this.media(query, function() {
                        _this2.setState({
                            breakpoint: null
                        });
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this._responsiveMediaHandlers.forEach(function(obj) {
                    $11d55af27ee762da$var$enquire.unregister(obj.query, obj.handler);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var settings;
                var newProps;
                if (this.state.breakpoint) {
                    newProps = this.props.responsive.filter(function(resp) {
                        return resp.breakpoint === _this3.state.breakpoint;
                    });
                    settings = newProps[0].settings === "unslick" ? "unslick" : $11d55af27ee762da$var$_objectSpread($11d55af27ee762da$var$_objectSpread($11d55af27ee762da$var$_objectSpread({}, $11d55af27ee762da$var$_defaultProps["default"]), this.props), newProps[0].settings);
                } else settings = $11d55af27ee762da$var$_objectSpread($11d55af27ee762da$var$_objectSpread({}, $11d55af27ee762da$var$_defaultProps["default"]), this.props);
                // force scrolling by one if centerMode is on
                if (settings.centerMode) {
                    settings.slidesToScroll;
                    settings.slidesToScroll = 1;
                }
                // force showing one slide and scrolling by one if the fade mode is on
                if (settings.fade) {
                    settings.slidesToShow;
                    settings.slidesToScroll;
                    settings.slidesToShow = 1;
                    settings.slidesToScroll = 1;
                }
                // makes sure that children is an array, even when there is only 1 child
                var children = $11d55af27ee762da$var$_react["default"].Children.toArray(this.props.children);
                // Children may contain false or null, so we should filter them
                // children may also contain string filled with spaces (in certain cases where we use jsx strings)
                children = children.filter(function(child) {
                    if (typeof child === "string") return !!child.trim();
                    return !!child;
                });
                // rows and slidesPerRow logic is handled here
                if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
                    console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
                    settings.variableWidth = false;
                }
                var newChildren = [];
                var currentWidth = null;
                for(var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow){
                    var newSlide = [];
                    for(var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow){
                        var row = [];
                        for(var k = j; k < j + settings.slidesPerRow; k += 1){
                            if (settings.variableWidth && children[k].props.style) currentWidth = children[k].props.style.width;
                            if (k >= children.length) break;
                            row.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].cloneElement(children[k], {
                                key: 100 * i + 10 * j + k,
                                tabIndex: -1,
                                style: {
                                    width: "".concat(100 / settings.slidesPerRow, "%"),
                                    display: "inline-block"
                                }
                            }));
                        }
                        newSlide.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                            key: 10 * i + j
                        }, row));
                    }
                    if (settings.variableWidth) newChildren.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                        key: i,
                        style: {
                            width: currentWidth
                        }
                    }, newSlide));
                    else newChildren.push(/*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                        key: i
                    }, newSlide));
                }
                if (settings === "unslick") {
                    var className = "regular slider " + (this.props.className || "");
                    return /*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement("div", {
                        className: className
                    }, children);
                } else if (newChildren.length <= settings.slidesToShow && !settings.infinite) settings.unslick = true;
                return /*#__PURE__*/ $11d55af27ee762da$var$_react["default"].createElement($2Qs16.InnerSlider, $11d55af27ee762da$var$_extends({
                    style: this.props.style,
                    ref: this.innerSliderRefHandler
                }, (0, $8XSk1.filterSettings)(settings)), newChildren);
            }
        }
    ]);
    return Slider;
}($11d55af27ee762da$var$_react["default"].Component);

});
parcelRegister("2Qs16", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InnerSlider = void 0;

var $21262ba2c71116ec$var$_react = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $21262ba2c71116ec$var$_initialState = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("hFtm3")));

var $21262ba2c71116ec$var$_lodash = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("krOQK")));

var $21262ba2c71116ec$var$_classnames = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");

var $2DkJA = parcelRequire("2DkJA");

var $bmMxA = parcelRequire("bmMxA");

var $49Fws = parcelRequire("49Fws");

var $21262ba2c71116ec$var$_resizeObserverPolyfill = $21262ba2c71116ec$var$_interopRequireDefault((parcelRequire("4EfKw")));
function $21262ba2c71116ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $21262ba2c71116ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $21262ba2c71116ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $21262ba2c71116ec$var$_typeof(o);
}
function $21262ba2c71116ec$var$_extends() {
    $21262ba2c71116ec$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $21262ba2c71116ec$var$_extends.apply(this, arguments);
}
function $21262ba2c71116ec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $21262ba2c71116ec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $21262ba2c71116ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $21262ba2c71116ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21262ba2c71116ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21262ba2c71116ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $21262ba2c71116ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21262ba2c71116ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $21262ba2c71116ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $21262ba2c71116ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $21262ba2c71116ec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $21262ba2c71116ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $21262ba2c71116ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $21262ba2c71116ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $21262ba2c71116ec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $21262ba2c71116ec$var$_setPrototypeOf(subClass, superClass);
}
function $21262ba2c71116ec$var$_setPrototypeOf(o, p) {
    $21262ba2c71116ec$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $21262ba2c71116ec$var$_setPrototypeOf(o, p);
}
function $21262ba2c71116ec$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $21262ba2c71116ec$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $21262ba2c71116ec$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $21262ba2c71116ec$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $21262ba2c71116ec$var$_possibleConstructorReturn(this, result);
    };
}
function $21262ba2c71116ec$var$_possibleConstructorReturn(self, call) {
    if (call && ($21262ba2c71116ec$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $21262ba2c71116ec$var$_assertThisInitialized(self);
}
function $21262ba2c71116ec$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $21262ba2c71116ec$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($21262ba2c71116ec$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $21262ba2c71116ec$var$_getPrototypeOf(o) {
    $21262ba2c71116ec$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $21262ba2c71116ec$var$_getPrototypeOf(o);
}
function $21262ba2c71116ec$var$_defineProperty(obj, key, value) {
    key = $21262ba2c71116ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $21262ba2c71116ec$var$_toPropertyKey(t) {
    var i = $21262ba2c71116ec$var$_toPrimitive(t, "string");
    return "symbol" == $21262ba2c71116ec$var$_typeof(i) ? i : String(i);
}
function $21262ba2c71116ec$var$_toPrimitive(t, r) {
    if ("object" != $21262ba2c71116ec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $21262ba2c71116ec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $21262ba2c71116ec$var$InnerSlider = module.exports.InnerSlider = /*#__PURE__*/ function(_React$Component) {
    $21262ba2c71116ec$var$_inherits(InnerSlider, _React$Component);
    var _super = $21262ba2c71116ec$var$_createSuper(InnerSlider);
    function InnerSlider(props) {
        var _this;
        $21262ba2c71116ec$var$_classCallCheck(this, InnerSlider);
        _this = _super.call(this, props);
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "listRefHandler", function(ref) {
            return _this.list = ref;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "trackRefHandler", function(ref) {
            return _this.track = ref;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "adaptHeight", function() {
            if (_this.props.adaptiveHeight && _this.list) {
                var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
                _this.list.style.height = (0, $8XSk1.getHeight)(elem) + "px";
            }
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "componentDidMount", function() {
            _this.props.onInit && _this.props.onInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $8XSk1.getOnDemandLazySlides)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            var spec = $21262ba2c71116ec$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props);
            _this.updateState(spec, true, function() {
                _this.adaptHeight();
                _this.props.autoplay && _this.autoPlay("update");
            });
            if (_this.props.lazyLoad === "progressive") _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
            _this.ro = new $21262ba2c71116ec$var$_resizeObserverPolyfill["default"](function() {
                if (_this.state.animating) {
                    _this.onWindowResized(false); // don't set trackStyle hence don't break animation
                    _this.callbackTimers.push(setTimeout(function() {
                        return _this.onWindowResized();
                    }, _this.props.speed));
                } else _this.onWindowResized();
            });
            _this.ro.observe(_this.list);
            document.querySelectorAll && Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function(slide) {
                slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
                slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
            });
            if (window.addEventListener) window.addEventListener("resize", _this.onWindowResized);
            else window.attachEvent("onresize", _this.onWindowResized);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "componentWillUnmount", function() {
            if (_this.animationEndCallback) clearTimeout(_this.animationEndCallback);
            if (_this.lazyLoadTimer) clearInterval(_this.lazyLoadTimer);
            if (_this.callbackTimers.length) {
                _this.callbackTimers.forEach(function(timer) {
                    return clearTimeout(timer);
                });
                _this.callbackTimers = [];
            }
            if (window.addEventListener) window.removeEventListener("resize", _this.onWindowResized);
            else window.detachEvent("onresize", _this.onWindowResized);
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            _this.ro.disconnect();
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "componentDidUpdate", function(prevProps) {
            _this.checkImagesLoad();
            _this.props.onReInit && _this.props.onReInit();
            if (_this.props.lazyLoad) {
                var slidesToLoad = (0, $8XSk1.getOnDemandLazySlides)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state));
                if (slidesToLoad.length > 0) {
                    _this.setState(function(prevState) {
                        return {
                            lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
                        };
                    });
                    if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
                }
            }
            // if (this.props.onLazyLoad) {
            //   this.props.onLazyLoad([leftMostSlide])
            // }
            _this.adaptHeight();
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            var setTrackStyle = _this.didPropsChange(prevProps);
            setTrackStyle && _this.updateState(spec, setTrackStyle, function() {
                if (_this.state.currentSlide >= $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children)) _this.changeSlide({
                    message: "index",
                    index: $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children) - _this.props.slidesToShow,
                    currentSlide: _this.state.currentSlide
                });
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onWindowResized", function(setTrackStyle) {
            if (_this.debouncedResize) _this.debouncedResize.cancel();
            _this.debouncedResize = (0, $21262ba2c71116ec$var$_lodash["default"])(function() {
                return _this.resizeWindow(setTrackStyle);
            }, 50);
            _this.debouncedResize();
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "resizeWindow", function() {
            var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var isTrackMounted = Boolean(_this.track && _this.track.node);
            // prevent warning: setting state on unmounted component (server side rendering)
            if (!isTrackMounted) return;
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({
                listRef: _this.list,
                trackRef: _this.track
            }, _this.props), _this.state);
            _this.updateState(spec, setTrackStyle, function() {
                if (_this.props.autoplay) _this.autoPlay("update");
                else _this.pause("paused");
            });
            // animating state should be cleared while resizing, otherwise autoplay stops working
            _this.setState({
                animating: false
            });
            clearTimeout(_this.animationEndCallback);
            delete _this.animationEndCallback;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "updateState", function(spec, setTrackStyle, callback) {
            var updatedState = (0, $8XSk1.initializedState)(spec);
            spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, spec), updatedState), {}, {
                slideIndex: updatedState.currentSlide
            });
            var targetLeft = (0, $8XSk1.getTrackLeft)(spec);
            spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, spec), {}, {
                left: targetLeft
            });
            var trackStyle = (0, $8XSk1.getTrackCSS)(spec);
            if (setTrackStyle || $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children) !== $21262ba2c71116ec$var$_react["default"].Children.count(spec.children)) updatedState["trackStyle"] = trackStyle;
            _this.setState(updatedState, callback);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "ssrInit", function() {
            if (_this.props.variableWidth) {
                var _trackWidth = 0, _trackLeft = 0;
                var childrenWidths = [];
                var preClones = (0, $8XSk1.getPreClones)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                var postClones = (0, $8XSk1.getPostClones)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                    slideCount: _this.props.children.length
                }));
                _this.props.children.forEach(function(child) {
                    childrenWidths.push(child.props.style.width);
                    _trackWidth += child.props.style.width;
                });
                for(var i = 0; i < preClones; i++){
                    _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
                    _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
                }
                for(var _i = 0; _i < postClones; _i++)_trackWidth += childrenWidths[_i];
                for(var _i2 = 0; _i2 < _this.state.currentSlide; _i2++)_trackLeft += childrenWidths[_i2];
                var _trackStyle = {
                    width: _trackWidth + "px",
                    left: -_trackLeft + "px"
                };
                if (_this.props.centerMode) {
                    var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
                    _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
                }
                return {
                    trackStyle: _trackStyle
                };
            }
            var childrenCount = $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children);
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                slideCount: childrenCount
            });
            var slideCount = (0, $8XSk1.getPreClones)(spec) + (0, $8XSk1.getPostClones)(spec) + childrenCount;
            var trackWidth = 100 / _this.props.slidesToShow * slideCount;
            var slideWidth = 100 / slideCount;
            var trackLeft = -slideWidth * ((0, $8XSk1.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
            if (_this.props.centerMode) trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
            var trackStyle = {
                width: trackWidth + "%",
                left: trackLeft + "%"
            };
            return {
                slideWidth: slideWidth + "%",
                trackStyle: trackStyle
            };
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "checkImagesLoad", function() {
            var images = _this.list && _this.list.querySelectorAll && _this.list.querySelectorAll(".slick-slide img") || [];
            var imagesCount = images.length, loadedCount = 0;
            Array.prototype.forEach.call(images, function(image) {
                var handler = function handler() {
                    return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
                };
                if (!image.onclick) image.onclick = function() {
                    return image.parentNode.focus();
                };
                else {
                    var prevClickHandler = image.onclick;
                    image.onclick = function(e) {
                        prevClickHandler(e);
                        image.parentNode.focus();
                    };
                }
                if (!image.onload) {
                    if (_this.props.lazyLoad) image.onload = function() {
                        _this.adaptHeight();
                        _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
                    };
                    else {
                        image.onload = handler;
                        image.onerror = function() {
                            handler();
                            _this.props.onLazyLoadError && _this.props.onLazyLoadError();
                        };
                    }
                }
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "progressiveLazyLoad", function() {
            var slidesToLoad = [];
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state);
            for(var index = _this.state.currentSlide; index < _this.state.slideCount + (0, $8XSk1.getPostClones)(spec); index++)if (_this.state.lazyLoadedList.indexOf(index) < 0) {
                slidesToLoad.push(index);
                break;
            }
            for(var _index = _this.state.currentSlide - 1; _index >= -(0, $8XSk1.getPreClones)(spec); _index--)if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
                slidesToLoad.push(_index);
                break;
            }
            if (slidesToLoad.length > 0) {
                _this.setState(function(state) {
                    return {
                        lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
                    };
                });
                if (_this.props.onLazyLoad) _this.props.onLazyLoad(slidesToLoad);
            } else if (_this.lazyLoadTimer) {
                clearInterval(_this.lazyLoadTimer);
                delete _this.lazyLoadTimer;
            }
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slideHandler", function(index) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var _this$props = _this.props, asNavFor = _this$props.asNavFor, beforeChange = _this$props.beforeChange, onLazyLoad = _this$props.onLazyLoad, speed = _this$props.speed, afterChange = _this$props.afterChange; // capture currentslide before state is updated
            var currentSlide = _this.state.currentSlide;
            var _slideHandler = (0, $8XSk1.slideHandler)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({
                index: index
            }, _this.props), _this.state), {}, {
                trackRef: _this.track,
                useCSS: _this.props.useCSS && !dontAnimate
            })), state = _slideHandler.state, nextState = _slideHandler.nextState;
            if (!state) return;
            beforeChange && beforeChange(currentSlide, state.currentSlide);
            var slidesToLoad = state.lazyLoadedList.filter(function(value) {
                return _this.state.lazyLoadedList.indexOf(value) < 0;
            });
            onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
            if (!_this.props.waitForAnimate && _this.animationEndCallback) {
                clearTimeout(_this.animationEndCallback);
                afterChange && afterChange(currentSlide);
                delete _this.animationEndCallback;
            }
            _this.setState(state, function() {
                // asNavForIndex check is to avoid recursive calls of slideHandler in waitForAnimate=false mode
                if (asNavFor && _this.asNavForIndex !== index) {
                    _this.asNavForIndex = index;
                    asNavFor.innerSlider.slideHandler(index);
                }
                if (!nextState) return;
                _this.animationEndCallback = setTimeout(function() {
                    var animating = nextState.animating, firstBatch = $21262ba2c71116ec$var$_objectWithoutProperties(nextState, [
                        "animating"
                    ]);
                    _this.setState(firstBatch, function() {
                        _this.callbackTimers.push(setTimeout(function() {
                            return _this.setState({
                                animating: animating
                            });
                        }, 10));
                        afterChange && afterChange(state.currentSlide);
                        delete _this.animationEndCallback;
                    });
                }, speed);
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "changeSlide", function(options) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state);
            var targetSlide = (0, $8XSk1.changeSlide)(spec, options);
            if (targetSlide !== 0 && !targetSlide) return;
            if (dontAnimate === true) _this.slideHandler(targetSlide, dontAnimate);
            else _this.slideHandler(targetSlide);
            _this.props.autoplay && _this.autoPlay("update");
            if (_this.props.focusOnSelect) {
                var nodes = _this.list.querySelectorAll(".slick-current");
                nodes[0] && nodes[0].focus();
            }
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "clickHandler", function(e) {
            if (_this.clickable === false) {
                e.stopPropagation();
                e.preventDefault();
            }
            _this.clickable = true;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "keyHandler", function(e) {
            var dir = (0, $8XSk1.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
            dir !== "" && _this.changeSlide({
                message: dir
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "selectHandler", function(options) {
            _this.changeSlide(options);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "disableBodyScroll", function() {
            var preventDefault = function preventDefault(e) {
                e = e || window.event;
                if (e.preventDefault) e.preventDefault();
                e.returnValue = false;
            };
            window.ontouchmove = preventDefault;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "enableBodyScroll", function() {
            window.ontouchmove = null;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "swipeStart", function(e) {
            if (_this.props.verticalSwiping) _this.disableBodyScroll();
            var state = (0, $8XSk1.swipeStart)(e, _this.props.swipe, _this.props.draggable);
            state !== "" && _this.setState(state);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "swipeMove", function(e) {
            var state = (0, $8XSk1.swipeMove)(e, $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            if (state["swiping"]) _this.clickable = false;
            _this.setState(state);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "swipeEnd", function(e) {
            var state = (0, $8XSk1.swipeEnd)(e, $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state), {}, {
                trackRef: _this.track,
                listRef: _this.list,
                slideIndex: _this.state.currentSlide
            }));
            if (!state) return;
            var triggerSlideHandler = state["triggerSlideHandler"];
            delete state["triggerSlideHandler"];
            _this.setState(state);
            if (triggerSlideHandler === undefined) return;
            _this.slideHandler(triggerSlideHandler);
            if (_this.props.verticalSwiping) _this.enableBodyScroll();
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "touchEnd", function(e) {
            _this.swipeEnd(e);
            _this.clickable = true;
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slickPrev", function() {
            // this and fellow methods are wrapped in setTimeout
            // to make sure initialize setState has happened before
            // any of such methods are called
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "previous"
                });
            }, 0));
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slickNext", function() {
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "next"
                });
            }, 0));
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "slickGoTo", function(slide) {
            var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            slide = Number(slide);
            if (isNaN(slide)) return "";
            _this.callbackTimers.push(setTimeout(function() {
                return _this.changeSlide({
                    message: "index",
                    index: slide,
                    currentSlide: _this.state.currentSlide
                }, dontAnimate);
            }, 0));
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "play", function() {
            var nextIndex;
            if (_this.props.rtl) nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
            else {
                if ((0, $8XSk1.canGoNext)($21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state))) nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
                else return false;
            }
            _this.slideHandler(nextIndex);
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "autoPlay", function(playType) {
            if (_this.autoplayTimer) clearInterval(_this.autoplayTimer);
            var autoplaying = _this.state.autoplaying;
            if (playType === "update") {
                if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") return;
            } else if (playType === "leave") {
                if (autoplaying === "paused" || autoplaying === "focused") return;
            } else if (playType === "blur") {
                if (autoplaying === "paused" || autoplaying === "hovered") return;
            }
            _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
            _this.setState({
                autoplaying: "playing"
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "pause", function(pauseType) {
            if (_this.autoplayTimer) {
                clearInterval(_this.autoplayTimer);
                _this.autoplayTimer = null;
            }
            var autoplaying = _this.state.autoplaying;
            if (pauseType === "paused") _this.setState({
                autoplaying: "paused"
            });
            else if (pauseType === "focused") {
                if (autoplaying === "hovered" || autoplaying === "playing") _this.setState({
                    autoplaying: "focused"
                });
            } else // pauseType  is 'hovered'
            if (autoplaying === "playing") _this.setState({
                autoplaying: "hovered"
            });
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onDotsOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onDotsLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onTrackOver", function() {
            return _this.props.autoplay && _this.pause("hovered");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onTrackLeave", function() {
            return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onSlideFocus", function() {
            return _this.props.autoplay && _this.pause("focused");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "onSlideBlur", function() {
            return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
        });
        $21262ba2c71116ec$var$_defineProperty($21262ba2c71116ec$var$_assertThisInitialized(_this), "render", function() {
            var className = (0, $21262ba2c71116ec$var$_classnames["default"])("slick-slider", _this.props.className, {
                "slick-vertical": _this.props.vertical,
                "slick-initialized": true
            });
            var spec = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.props), _this.state);
            var trackProps = (0, $8XSk1.extractObject)(spec, [
                "fade",
                "cssEase",
                "speed",
                "infinite",
                "centerMode",
                "focusOnSelect",
                "currentSlide",
                "lazyLoad",
                "lazyLoadedList",
                "rtl",
                "slideWidth",
                "slideHeight",
                "listHeight",
                "vertical",
                "slidesToShow",
                "slidesToScroll",
                "slideCount",
                "trackStyle",
                "variableWidth",
                "unslick",
                "centerPadding",
                "targetSlide",
                "useCSS"
            ]);
            var pauseOnHover = _this.props.pauseOnHover;
            trackProps = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, trackProps), {}, {
                onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
                onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
                onMouseOver: pauseOnHover ? _this.onTrackOver : null,
                focusOnSelect: _this.props.focusOnSelect && _this.clickable ? _this.selectHandler : null
            });
            var dots;
            if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
                var dotProps = (0, $8XSk1.extractObject)(spec, [
                    "dotsClass",
                    "slideCount",
                    "slidesToShow",
                    "currentSlide",
                    "slidesToScroll",
                    "clickHandler",
                    "children",
                    "customPaging",
                    "infinite",
                    "appendDots"
                ]);
                var pauseOnDotsHover = _this.props.pauseOnDotsHover;
                dotProps = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, dotProps), {}, {
                    clickHandler: _this.changeSlide,
                    onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
                    onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
                    onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
                });
                dots = /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($bmMxA.Dots, dotProps);
            }
            var prevArrow, nextArrow;
            var arrowProps = (0, $8XSk1.extractObject)(spec, [
                "infinite",
                "centerMode",
                "currentSlide",
                "slideCount",
                "slidesToShow",
                "prevArrow",
                "nextArrow"
            ]);
            arrowProps.clickHandler = _this.changeSlide;
            if (_this.props.arrows) {
                prevArrow = /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($49Fws.PrevArrow, arrowProps);
                nextArrow = /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($49Fws.NextArrow, arrowProps);
            }
            var verticalHeightStyle = null;
            if (_this.props.vertical) verticalHeightStyle = {
                height: _this.state.listHeight
            };
            var centerPaddingStyle = null;
            if (_this.props.vertical === false) {
                if (_this.props.centerMode === true) centerPaddingStyle = {
                    padding: "0px " + _this.props.centerPadding
                };
            } else if (_this.props.centerMode === true) centerPaddingStyle = {
                padding: _this.props.centerPadding + " 0px"
            };
            var listStyle = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, verticalHeightStyle), centerPaddingStyle);
            var touchMove = _this.props.touchMove;
            var listProps = {
                className: "slick-list",
                style: listStyle,
                onClick: _this.clickHandler,
                onMouseDown: touchMove ? _this.swipeStart : null,
                onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onMouseUp: touchMove ? _this.swipeEnd : null,
                onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onTouchStart: touchMove ? _this.swipeStart : null,
                onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
                onTouchEnd: touchMove ? _this.touchEnd : null,
                onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
                onKeyDown: _this.props.accessibility ? _this.keyHandler : null
            };
            var innerSliderProps = {
                className: className,
                dir: "ltr",
                style: _this.props.style
            };
            if (_this.props.unslick) {
                listProps = {
                    className: "slick-list"
                };
                innerSliderProps = {
                    className: className
                };
            }
            return /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement("div", $21262ba2c71116ec$var$_extends({
                ref: _this.listRefHandler
            }, listProps), /*#__PURE__*/ $21262ba2c71116ec$var$_react["default"].createElement($2DkJA.Track, $21262ba2c71116ec$var$_extends({
                ref: _this.trackRefHandler
            }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
        });
        _this.list = null;
        _this.track = null;
        _this.state = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, $21262ba2c71116ec$var$_initialState["default"]), {}, {
            currentSlide: _this.props.initialSlide,
            targetSlide: _this.props.initialSlide ? _this.props.initialSlide : 0,
            slideCount: $21262ba2c71116ec$var$_react["default"].Children.count(_this.props.children)
        });
        _this.callbackTimers = [];
        _this.clickable = true;
        _this.debouncedResize = null;
        var ssrState = _this.ssrInit();
        _this.state = $21262ba2c71116ec$var$_objectSpread($21262ba2c71116ec$var$_objectSpread({}, _this.state), ssrState);
        return _this;
    }
    $21262ba2c71116ec$var$_createClass(InnerSlider, [
        {
            key: "didPropsChange",
            value: function didPropsChange(prevProps) {
                var setTrackStyle = false;
                for(var _i3 = 0, _Object$keys = Object.keys(this.props); _i3 < _Object$keys.length; _i3++){
                    var key = _Object$keys[_i3];
                    if (!prevProps.hasOwnProperty(key)) {
                        setTrackStyle = true;
                        break;
                    }
                    if ($21262ba2c71116ec$var$_typeof(prevProps[key]) === "object" || typeof prevProps[key] === "function" || isNaN(prevProps[key])) continue;
                    if (prevProps[key] !== this.props[key]) {
                        setTrackStyle = true;
                        break;
                    }
                }
                return setTrackStyle || $21262ba2c71116ec$var$_react["default"].Children.count(this.props.children) !== $21262ba2c71116ec$var$_react["default"].Children.count(prevProps.children);
            }
        }
    ]);
    return InnerSlider;
}($21262ba2c71116ec$var$_react["default"].Component);

});
parcelRegister("hFtm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $cdcd093a5ade8651$var$initialState = {
    animating: false,
    autoplaying: null,
    currentDirection: 0,
    currentLeft: null,
    currentSlide: 0,
    direction: 1,
    dragging: false,
    edgeDragged: false,
    initialized: false,
    lazyLoadedList: [],
    listHeight: null,
    listWidth: null,
    scrolling: false,
    slideCount: null,
    slideHeight: null,
    slideWidth: null,
    swipeLeft: null,
    swiped: false,
    // used by swipeEvent. differentites between touch and swipe.
    swiping: false,
    touchObject: {
        startX: 0,
        startY: 0,
        curX: 0,
        curY: 0
    },
    trackStyle: {},
    trackWidth: 0,
    targetSlide: 0
};
var $cdcd093a5ade8651$var$_default = module.exports["default"] = $cdcd093a5ade8651$var$initialState;

});

parcelRegister("krOQK", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $YtE9h = parcelRequire("YtE9h");
var $ee2dc5fddd2d168b$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $ee2dc5fddd2d168b$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ee2dc5fddd2d168b$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $ee2dc5fddd2d168b$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ee2dc5fddd2d168b$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ee2dc5fddd2d168b$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ee2dc5fddd2d168b$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ee2dc5fddd2d168b$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ee2dc5fddd2d168b$var$freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $YtE9h._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ee2dc5fddd2d168b$var$freeSelf = (typeof self === "undefined" ? "undefined" : (0, $YtE9h._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ee2dc5fddd2d168b$var$root = $ee2dc5fddd2d168b$var$freeGlobal || $ee2dc5fddd2d168b$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $ee2dc5fddd2d168b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ee2dc5fddd2d168b$var$objectToString = $ee2dc5fddd2d168b$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ee2dc5fddd2d168b$var$nativeMax = Math.max, $ee2dc5fddd2d168b$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ee2dc5fddd2d168b$var$now = function now() {
    return $ee2dc5fddd2d168b$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ee2dc5fddd2d168b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ee2dc5fddd2d168b$var$FUNC_ERROR_TEXT);
    wait = $ee2dc5fddd2d168b$var$toNumber(wait) || 0;
    if ($ee2dc5fddd2d168b$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ee2dc5fddd2d168b$var$nativeMax($ee2dc5fddd2d168b$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ee2dc5fddd2d168b$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ee2dc5fddd2d168b$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ee2dc5fddd2d168b$var$now());
    }
    function debounced() {
        var time = $ee2dc5fddd2d168b$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ee2dc5fddd2d168b$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value);
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ee2dc5fddd2d168b$var$isObjectLike(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ee2dc5fddd2d168b$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) == 'symbol' || $ee2dc5fddd2d168b$var$isObjectLike(value) && $ee2dc5fddd2d168b$var$objectToString.call(value) == $ee2dc5fddd2d168b$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ee2dc5fddd2d168b$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($ee2dc5fddd2d168b$var$isSymbol(value)) return $ee2dc5fddd2d168b$var$NAN;
    if ($ee2dc5fddd2d168b$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ee2dc5fddd2d168b$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($ee2dc5fddd2d168b$var$reTrim, '');
    var isBinary = $ee2dc5fddd2d168b$var$reIsBinary.test(value);
    return isBinary || $ee2dc5fddd2d168b$var$reIsOctal.test(value) ? $ee2dc5fddd2d168b$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ee2dc5fddd2d168b$var$reIsBadHex.test(value) ? $ee2dc5fddd2d168b$var$NAN : +value;
}
module.exports = $ee2dc5fddd2d168b$var$debounce;

});

parcelRegister("eR2a2", function(module, exports) {

var $YtE9h = parcelRequire("YtE9h");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if ((typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg)) !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && (0, $YtE9h._)(define.amd) === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("8XSk1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkSpecKeys = module.exports.checkNavigable = module.exports.changeSlide = module.exports.canUseDOM = module.exports.canGoNext = void 0;
module.exports.clamp = $686df89f63b82ce3$var$clamp;
module.exports.extractObject = void 0;
module.exports.filterSettings = $686df89f63b82ce3$var$filterSettings;
module.exports.validSettings = module.exports.swipeStart = module.exports.swipeMove = module.exports.swipeEnd = module.exports.slidesOnRight = module.exports.slidesOnLeft = module.exports.slideHandler = module.exports.siblingDirection = module.exports.safePreventDefault = module.exports.lazyStartIndex = module.exports.lazySlidesOnRight = module.exports.lazySlidesOnLeft = module.exports.lazyEndIndex = module.exports.keyHandler = module.exports.initializedState = module.exports.getWidth = module.exports.getTrackLeft = module.exports.getTrackCSS = module.exports.getTrackAnimateCSS = module.exports.getTotalSlides = module.exports.getSwipeDirection = module.exports.getSlideCount = module.exports.getRequiredLazySlides = module.exports.getPreClones = module.exports.getPostClones = module.exports.getOnDemandLazySlides = module.exports.getNavigableIndexes = module.exports.getHeight = void 0;

var $686df89f63b82ce3$var$_react = $686df89f63b82ce3$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $686df89f63b82ce3$var$_defaultProps = $686df89f63b82ce3$var$_interopRequireDefault((parcelRequire("ZEwRt")));
function $686df89f63b82ce3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $686df89f63b82ce3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $686df89f63b82ce3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $686df89f63b82ce3$var$_typeof(o);
}
function $686df89f63b82ce3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $686df89f63b82ce3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $686df89f63b82ce3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $686df89f63b82ce3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $686df89f63b82ce3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $686df89f63b82ce3$var$_defineProperty(obj, key, value) {
    key = $686df89f63b82ce3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $686df89f63b82ce3$var$_toPropertyKey(t) {
    var i = $686df89f63b82ce3$var$_toPrimitive(t, "string");
    return "symbol" == $686df89f63b82ce3$var$_typeof(i) ? i : String(i);
}
function $686df89f63b82ce3$var$_toPrimitive(t, r) {
    if ("object" != $686df89f63b82ce3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $686df89f63b82ce3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $686df89f63b82ce3$var$clamp(number, lowerBound, upperBound) {
    return Math.max(lowerBound, Math.min(number, upperBound));
}
var $686df89f63b82ce3$var$safePreventDefault = module.exports.safePreventDefault = function safePreventDefault(event) {
    var passiveEvents = [
        "onTouchStart",
        "onTouchMove",
        "onWheel"
    ];
    if (!passiveEvents.includes(event._reactName)) event.preventDefault();
};
var $686df89f63b82ce3$var$getOnDemandLazySlides = module.exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
    var onDemandSlides = [];
    var startIndex = $686df89f63b82ce3$var$lazyStartIndex(spec);
    var endIndex = $686df89f63b82ce3$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)if (spec.lazyLoadedList.indexOf(slideIndex) < 0) onDemandSlides.push(slideIndex);
    return onDemandSlides;
};
// return list of slides that need to be present
var $686df89f63b82ce3$var$getRequiredLazySlides = module.exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
    var requiredSlides = [];
    var startIndex = $686df89f63b82ce3$var$lazyStartIndex(spec);
    var endIndex = $686df89f63b82ce3$var$lazyEndIndex(spec);
    for(var slideIndex = startIndex; slideIndex < endIndex; slideIndex++)requiredSlides.push(slideIndex);
    return requiredSlides;
};
// startIndex that needs to be present
var $686df89f63b82ce3$var$lazyStartIndex = module.exports.lazyStartIndex = function lazyStartIndex(spec) {
    return spec.currentSlide - $686df89f63b82ce3$var$lazySlidesOnLeft(spec);
};
var $686df89f63b82ce3$var$lazyEndIndex = module.exports.lazyEndIndex = function lazyEndIndex(spec) {
    return spec.currentSlide + $686df89f63b82ce3$var$lazySlidesOnRight(spec);
};
var $686df89f63b82ce3$var$lazySlidesOnLeft = module.exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
    return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var $686df89f63b82ce3$var$lazySlidesOnRight = module.exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
    return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
// get width of an element
var $686df89f63b82ce3$var$getWidth = module.exports.getWidth = function getWidth(elem) {
    return elem && elem.offsetWidth || 0;
};
var $686df89f63b82ce3$var$getHeight = module.exports.getHeight = function getHeight(elem) {
    return elem && elem.offsetHeight || 0;
};
var $686df89f63b82ce3$var$getSwipeDirection = module.exports.getSwipeDirection = function getSwipeDirection(touchObject) {
    var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var xDist, yDist, r, swipeAngle;
    xDist = touchObject.startX - touchObject.curX;
    yDist = touchObject.startY - touchObject.curY;
    r = Math.atan2(yDist, xDist);
    swipeAngle = Math.round(r * 180 / Math.PI);
    if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
    if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) return "left";
    if (swipeAngle >= 135 && swipeAngle <= 225) return "right";
    if (verticalSwiping === true) {
        if (swipeAngle >= 35 && swipeAngle <= 135) return "up";
        else return "down";
    }
    return "vertical";
};
// whether or not we can go next
var $686df89f63b82ce3$var$canGoNext = module.exports.canGoNext = function canGoNext(spec) {
    var canGo = true;
    if (!spec.infinite) {
        if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) canGo = false;
        else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) canGo = false;
    }
    return canGo;
};
// given an object and a list of keys, return new object with given keys
var $686df89f63b82ce3$var$extractObject = module.exports.extractObject = function extractObject(spec, keys) {
    var newObject = {};
    keys.forEach(function(key) {
        return newObject[key] = spec[key];
    });
    return newObject;
};
// get initialized state
var $686df89f63b82ce3$var$initializedState = module.exports.initializedState = function initializedState(spec) {
    // spec also contains listRef, trackRef
    var slideCount = $686df89f63b82ce3$var$_react["default"].Children.count(spec.children);
    var listNode = spec.listRef;
    var listWidth = Math.ceil($686df89f63b82ce3$var$getWidth(listNode));
    var trackNode = spec.trackRef && spec.trackRef.node;
    var trackWidth = Math.ceil($686df89f63b82ce3$var$getWidth(trackNode));
    var slideWidth;
    if (!spec.vertical) {
        var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
        if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") centerPaddingAdj *= listWidth / 100;
        slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
    } else slideWidth = listWidth;
    var slideHeight = listNode && $686df89f63b82ce3$var$getHeight(listNode.querySelector('[data-index="0"]'));
    var listHeight = slideHeight * spec.slidesToShow;
    var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
    if (spec.rtl && spec.currentSlide === undefined) currentSlide = slideCount - 1 - spec.initialSlide;
    var lazyLoadedList = spec.lazyLoadedList || [];
    var slidesToLoad = $686df89f63b82ce3$var$getOnDemandLazySlides($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
        currentSlide: currentSlide,
        lazyLoadedList: lazyLoadedList
    }));
    lazyLoadedList = lazyLoadedList.concat(slidesToLoad);
    var state = {
        slideCount: slideCount,
        slideWidth: slideWidth,
        listWidth: listWidth,
        trackWidth: trackWidth,
        currentSlide: currentSlide,
        slideHeight: slideHeight,
        listHeight: listHeight,
        lazyLoadedList: lazyLoadedList
    };
    if (spec.autoplaying === null && spec.autoplay) state["autoplaying"] = "playing";
    return state;
};
var $686df89f63b82ce3$var$slideHandler = module.exports.slideHandler = function slideHandler(spec) {
    var waitForAnimate = spec.waitForAnimate, animating = spec.animating, fade = spec.fade, infinite = spec.infinite, index = spec.index, slideCount = spec.slideCount, lazyLoad = spec.lazyLoad, currentSlide = spec.currentSlide, centerMode = spec.centerMode, slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, useCSS = spec.useCSS;
    var lazyLoadedList = spec.lazyLoadedList;
    if (waitForAnimate && animating) return {};
    var animationSlide = index, finalSlide, animationLeft, finalLeft;
    var state = {}, nextState = {};
    var targetSlide = infinite ? index : $686df89f63b82ce3$var$clamp(index, 0, slideCount - 1);
    if (fade) {
        if (!infinite && (index < 0 || index >= slideCount)) return {};
        if (index < 0) animationSlide = index + slideCount;
        else if (index >= slideCount) animationSlide = index - slideCount;
        if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) lazyLoadedList = lazyLoadedList.concat(animationSlide);
        state = {
            animating: true,
            currentSlide: animationSlide,
            lazyLoadedList: lazyLoadedList,
            targetSlide: animationSlide
        };
        nextState = {
            animating: false,
            targetSlide: animationSlide
        };
    } else {
        finalSlide = animationSlide;
        if (animationSlide < 0) {
            finalSlide = animationSlide + slideCount;
            if (!infinite) finalSlide = 0;
            else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
        } else if (!$686df89f63b82ce3$var$canGoNext(spec) && animationSlide > currentSlide) animationSlide = finalSlide = currentSlide;
        else if (centerMode && animationSlide >= slideCount) {
            animationSlide = infinite ? slideCount : slideCount - 1;
            finalSlide = infinite ? 0 : slideCount - 1;
        } else if (animationSlide >= slideCount) {
            finalSlide = animationSlide - slideCount;
            if (!infinite) finalSlide = slideCount - slidesToShow;
            else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
        }
        if (!infinite && animationSlide + slidesToShow >= slideCount) finalSlide = slideCount - slidesToShow;
        animationLeft = $686df89f63b82ce3$var$getTrackLeft($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            slideIndex: animationSlide
        }));
        finalLeft = $686df89f63b82ce3$var$getTrackLeft($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            slideIndex: finalSlide
        }));
        if (!infinite) {
            if (animationLeft === finalLeft) animationSlide = finalSlide;
            animationLeft = finalLeft;
        }
        if (lazyLoad) lazyLoadedList = lazyLoadedList.concat($686df89f63b82ce3$var$getOnDemandLazySlides($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            currentSlide: animationSlide
        })));
        if (!useCSS) state = {
            currentSlide: finalSlide,
            trackStyle: $686df89f63b82ce3$var$getTrackCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                left: finalLeft
            })),
            lazyLoadedList: lazyLoadedList,
            targetSlide: targetSlide
        };
        else {
            state = {
                animating: true,
                currentSlide: finalSlide,
                trackStyle: $686df89f63b82ce3$var$getTrackAnimateCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                    left: animationLeft
                })),
                lazyLoadedList: lazyLoadedList,
                targetSlide: targetSlide
            };
            nextState = {
                animating: false,
                currentSlide: finalSlide,
                trackStyle: $686df89f63b82ce3$var$getTrackCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                    left: finalLeft
                })),
                swipeLeft: null,
                targetSlide: targetSlide
            };
        }
    }
    return {
        state: state,
        nextState: nextState
    };
};
var $686df89f63b82ce3$var$changeSlide = module.exports.changeSlide = function changeSlide(spec, options) {
    var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
    var slidesToScroll = spec.slidesToScroll, slidesToShow = spec.slidesToShow, slideCount = spec.slideCount, currentSlide = spec.currentSlide, previousTargetSlide = spec.targetSlide, lazyLoad = spec.lazyLoad, infinite = spec.infinite;
    unevenOffset = slideCount % slidesToScroll !== 0;
    indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
    if (options.message === "previous") {
        slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
        targetSlide = currentSlide - slideOffset;
        if (lazyLoad && !infinite) {
            previousInt = currentSlide - slideOffset;
            targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
        }
        if (!infinite) targetSlide = previousTargetSlide - slidesToScroll;
    } else if (options.message === "next") {
        slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
        targetSlide = currentSlide + slideOffset;
        if (lazyLoad && !infinite) targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
        if (!infinite) targetSlide = previousTargetSlide + slidesToScroll;
    } else if (options.message === "dots") // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    else if (options.message === "children") {
        // Click on the slides
        targetSlide = options.index;
        if (infinite) {
            var direction = $686df89f63b82ce3$var$siblingDirection($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
                targetSlide: targetSlide
            }));
            if (targetSlide > options.currentSlide && direction === "left") targetSlide = targetSlide - slideCount;
            else if (targetSlide < options.currentSlide && direction === "right") targetSlide = targetSlide + slideCount;
        }
    } else if (options.message === "index") targetSlide = Number(options.index);
    return targetSlide;
};
var $686df89f63b82ce3$var$keyHandler = module.exports.keyHandler = function keyHandler(e, accessibility, rtl) {
    if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
    if (e.keyCode === 37) return rtl ? "next" : "previous";
    if (e.keyCode === 39) return rtl ? "previous" : "next";
    return "";
};
var $686df89f63b82ce3$var$swipeStart = module.exports.swipeStart = function swipeStart(e, swipe, draggable) {
    e.target.tagName === "IMG" && $686df89f63b82ce3$var$safePreventDefault(e);
    if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
    return {
        dragging: true,
        touchObject: {
            startX: e.touches ? e.touches[0].pageX : e.clientX,
            startY: e.touches ? e.touches[0].pageY : e.clientY,
            curX: e.touches ? e.touches[0].pageX : e.clientX,
            curY: e.touches ? e.touches[0].pageY : e.clientY
        }
    };
};
var $686df89f63b82ce3$var$swipeMove = module.exports.swipeMove = function swipeMove(e, spec) {
    // spec also contains, trackRef and slideIndex
    var scrolling = spec.scrolling, animating = spec.animating, vertical = spec.vertical, swipeToSlide = spec.swipeToSlide, verticalSwiping = spec.verticalSwiping, rtl = spec.rtl, currentSlide = spec.currentSlide, edgeFriction = spec.edgeFriction, edgeDragged = spec.edgeDragged, onEdge = spec.onEdge, swiped = spec.swiped, swiping = spec.swiping, slideCount = spec.slideCount, slidesToScroll = spec.slidesToScroll, infinite = spec.infinite, touchObject = spec.touchObject, swipeEvent = spec.swipeEvent, listHeight = spec.listHeight, listWidth = spec.listWidth;
    if (scrolling) return;
    if (animating) return $686df89f63b82ce3$var$safePreventDefault(e);
    if (vertical && swipeToSlide && verticalSwiping) $686df89f63b82ce3$var$safePreventDefault(e);
    var swipeLeft, state = {};
    var curLeft = $686df89f63b82ce3$var$getTrackLeft(spec);
    touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
    touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
    touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
    var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
    if (!verticalSwiping && !swiping && verticalSwipeLength > 10) return {
        scrolling: true
    };
    if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
    var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
    if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
    var dotCount = Math.ceil(slideCount / slidesToScroll);
    var swipeDirection = $686df89f63b82ce3$var$getSwipeDirection(spec.touchObject, verticalSwiping);
    var touchSwipeLength = touchObject.swipeLength;
    if (!infinite) {
        if (currentSlide === 0 && (swipeDirection === "right" || swipeDirection === "down") || currentSlide + 1 >= dotCount && (swipeDirection === "left" || swipeDirection === "up") || !$686df89f63b82ce3$var$canGoNext(spec) && (swipeDirection === "left" || swipeDirection === "up")) {
            touchSwipeLength = touchObject.swipeLength * edgeFriction;
            if (edgeDragged === false && onEdge) {
                onEdge(swipeDirection);
                state["edgeDragged"] = true;
            }
        }
    }
    if (!swiped && swipeEvent) {
        swipeEvent(swipeDirection);
        state["swiped"] = true;
    }
    if (!vertical) {
        if (!rtl) swipeLeft = curLeft + touchSwipeLength * positionOffset;
        else swipeLeft = curLeft - touchSwipeLength * positionOffset;
    } else swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
    if (verticalSwiping) swipeLeft = curLeft + touchSwipeLength * positionOffset;
    state = $686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, state), {}, {
        touchObject: touchObject,
        swipeLeft: swipeLeft,
        trackStyle: $686df89f63b82ce3$var$getTrackCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            left: swipeLeft
        }))
    });
    if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) return state;
    if (touchObject.swipeLength > 10) {
        state["swiping"] = true;
        $686df89f63b82ce3$var$safePreventDefault(e);
    }
    return state;
};
var $686df89f63b82ce3$var$swipeEnd = module.exports.swipeEnd = function swipeEnd(e, spec) {
    var dragging = spec.dragging, swipe = spec.swipe, touchObject = spec.touchObject, listWidth = spec.listWidth, touchThreshold = spec.touchThreshold, verticalSwiping = spec.verticalSwiping, listHeight = spec.listHeight, swipeToSlide = spec.swipeToSlide, scrolling = spec.scrolling, onSwipe = spec.onSwipe, targetSlide = spec.targetSlide, currentSlide = spec.currentSlide, infinite = spec.infinite;
    if (!dragging) {
        if (swipe) $686df89f63b82ce3$var$safePreventDefault(e);
        return {};
    }
    var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
    var swipeDirection = $686df89f63b82ce3$var$getSwipeDirection(touchObject, verticalSwiping);
    // reset the state of touch related state variables.
    var state = {
        dragging: false,
        edgeDragged: false,
        scrolling: false,
        swiping: false,
        swiped: false,
        swipeLeft: null,
        touchObject: {}
    };
    if (scrolling) return state;
    if (!touchObject.swipeLength) return state;
    if (touchObject.swipeLength > minSwipe) {
        $686df89f63b82ce3$var$safePreventDefault(e);
        if (onSwipe) onSwipe(swipeDirection);
        var slideCount, newSlide;
        var activeSlide = infinite ? currentSlide : targetSlide;
        switch(swipeDirection){
            case "left":
            case "up":
                newSlide = activeSlide + $686df89f63b82ce3$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $686df89f63b82ce3$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 0;
                break;
            case "right":
            case "down":
                newSlide = activeSlide - $686df89f63b82ce3$var$getSlideCount(spec);
                slideCount = swipeToSlide ? $686df89f63b82ce3$var$checkNavigable(spec, newSlide) : newSlide;
                state["currentDirection"] = 1;
                break;
            default:
                slideCount = activeSlide;
        }
        state["triggerSlideHandler"] = slideCount;
    } else {
        // Adjust the track back to it's original position.
        var currentLeft = $686df89f63b82ce3$var$getTrackLeft(spec);
        state["trackStyle"] = $686df89f63b82ce3$var$getTrackAnimateCSS($686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, spec), {}, {
            left: currentLeft
        }));
    }
    return state;
};
var $686df89f63b82ce3$var$getNavigableIndexes = module.exports.getNavigableIndexes = function getNavigableIndexes(spec) {
    var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
    var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
    var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
    var indexes = [];
    while(breakpoint < max){
        indexes.push(breakpoint);
        breakpoint = counter + spec.slidesToScroll;
        counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
    }
    return indexes;
};
var $686df89f63b82ce3$var$checkNavigable = module.exports.checkNavigable = function checkNavigable(spec, index) {
    var navigables = $686df89f63b82ce3$var$getNavigableIndexes(spec);
    var prevNavigable = 0;
    if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
    else for(var n in navigables){
        if (index < navigables[n]) {
            index = prevNavigable;
            break;
        }
        prevNavigable = navigables[n];
    }
    return index;
};
var $686df89f63b82ce3$var$getSlideCount = module.exports.getSlideCount = function getSlideCount(spec) {
    var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
    if (spec.swipeToSlide) {
        var swipedSlide;
        var slickList = spec.listRef;
        var slides = slickList.querySelectorAll && slickList.querySelectorAll(".slick-slide") || [];
        Array.from(slides).every(function(slide) {
            if (!spec.vertical) {
                if (slide.offsetLeft - centerOffset + $686df89f63b82ce3$var$getWidth(slide) / 2 > spec.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            } else if (slide.offsetTop + $686df89f63b82ce3$var$getHeight(slide) / 2 > spec.swipeLeft * -1) {
                swipedSlide = slide;
                return false;
            }
            return true;
        });
        if (!swipedSlide) return 0;
        var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
        var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
        return slidesTraversed;
    } else return spec.slidesToScroll;
};
var $686df89f63b82ce3$var$checkSpecKeys = module.exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
    return keysArray.reduce(function(value, key) {
        return value && spec.hasOwnProperty(key);
    }, true) ? null : console.error("Keys Missing:", spec);
};
var $686df89f63b82ce3$var$getTrackCSS = module.exports.getTrackCSS = function getTrackCSS(spec) {
    $686df89f63b82ce3$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth"
    ]);
    var trackWidth, trackHeight;
    var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
    if (!spec.vertical) trackWidth = $686df89f63b82ce3$var$getTotalSlides(spec) * spec.slideWidth;
    else trackHeight = trackChildren * spec.slideHeight;
    var style = {
        opacity: 1,
        transition: "",
        WebkitTransition: ""
    };
    if (spec.useTransform) {
        var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
        var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
        style = $686df89f63b82ce3$var$_objectSpread($686df89f63b82ce3$var$_objectSpread({}, style), {}, {
            WebkitTransform: WebkitTransform,
            transform: transform,
            msTransform: msTransform
        });
    } else if (spec.vertical) style["top"] = spec.left;
    else style["left"] = spec.left;
    if (spec.fade) style = {
        opacity: 1
    };
    if (trackWidth) style.width = trackWidth;
    if (trackHeight) style.height = trackHeight;
    // Fallback for IE8
    if (window && !window.addEventListener && window.attachEvent) {
        if (!spec.vertical) style.marginLeft = spec.left + "px";
        else style.marginTop = spec.left + "px";
    }
    return style;
};
var $686df89f63b82ce3$var$getTrackAnimateCSS = module.exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
    $686df89f63b82ce3$var$checkSpecKeys(spec, [
        "left",
        "variableWidth",
        "slideCount",
        "slidesToShow",
        "slideWidth",
        "speed",
        "cssEase"
    ]);
    var style = $686df89f63b82ce3$var$getTrackCSS(spec);
    // useCSS is true by default so it can be undefined
    if (spec.useTransform) {
        style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
        style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
    } else if (spec.vertical) style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    else style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    return style;
};
var $686df89f63b82ce3$var$getTrackLeft = module.exports.getTrackLeft = function getTrackLeft(spec) {
    if (spec.unslick) return 0;
    $686df89f63b82ce3$var$checkSpecKeys(spec, [
        "slideIndex",
        "trackRef",
        "infinite",
        "centerMode",
        "slideCount",
        "slidesToShow",
        "slidesToScroll",
        "slideWidth",
        "listWidth",
        "variableWidth",
        "slideHeight"
    ]);
    var slideIndex = spec.slideIndex, trackRef = spec.trackRef, infinite = spec.infinite, centerMode = spec.centerMode, slideCount = spec.slideCount, slidesToShow = spec.slidesToShow, slidesToScroll = spec.slidesToScroll, slideWidth = spec.slideWidth, listWidth = spec.listWidth, variableWidth = spec.variableWidth, slideHeight = spec.slideHeight, fade = spec.fade, vertical = spec.vertical;
    var slideOffset = 0;
    var targetLeft;
    var targetSlide;
    var verticalOffset = 0;
    if (fade || spec.slideCount === 1) return 0;
    var slidesToOffset = 0;
    if (infinite) {
        slidesToOffset = -$686df89f63b82ce3$var$getPreClones(spec); // bring active slide to the beginning of visual area
        // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
        // shift current slide to center of the frame
        if (centerMode) slidesToOffset += parseInt(slidesToShow / 2);
    } else {
        if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) slidesToOffset = slidesToShow - slideCount % slidesToScroll;
        if (centerMode) slidesToOffset = parseInt(slidesToShow / 2);
    }
    slideOffset = slidesToOffset * slideWidth;
    verticalOffset = slidesToOffset * slideHeight;
    if (!vertical) targetLeft = slideIndex * slideWidth * -1 + slideOffset;
    else targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
    if (variableWidth === true) {
        var targetSlideIndex;
        var trackElem = trackRef && trackRef.node;
        targetSlideIndex = slideIndex + $686df89f63b82ce3$var$getPreClones(spec);
        targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
        targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
        if (centerMode === true) {
            targetSlideIndex = infinite ? slideIndex + $686df89f63b82ce3$var$getPreClones(spec) : slideIndex;
            targetSlide = trackElem && trackElem.children[targetSlideIndex];
            targetLeft = 0;
            for(var slide = 0; slide < targetSlideIndex; slide++)targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
            targetLeft -= parseInt(spec.centerPadding);
            targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
        }
    }
    return targetLeft;
};
var $686df89f63b82ce3$var$getPreClones = module.exports.getPreClones = function getPreClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    if (spec.variableWidth) return spec.slideCount;
    return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var $686df89f63b82ce3$var$getPostClones = module.exports.getPostClones = function getPostClones(spec) {
    if (spec.unslick || !spec.infinite) return 0;
    return spec.slideCount;
};
var $686df89f63b82ce3$var$getTotalSlides = module.exports.getTotalSlides = function getTotalSlides(spec) {
    return spec.slideCount === 1 ? 1 : $686df89f63b82ce3$var$getPreClones(spec) + spec.slideCount + $686df89f63b82ce3$var$getPostClones(spec);
};
var $686df89f63b82ce3$var$siblingDirection = module.exports.siblingDirection = function siblingDirection(spec) {
    if (spec.targetSlide > spec.currentSlide) {
        if (spec.targetSlide > spec.currentSlide + $686df89f63b82ce3$var$slidesOnRight(spec)) return "left";
        return "right";
    } else {
        if (spec.targetSlide < spec.currentSlide - $686df89f63b82ce3$var$slidesOnLeft(spec)) return "right";
        return "left";
    }
};
var $686df89f63b82ce3$var$slidesOnRight = module.exports.slidesOnRight = function slidesOnRight(_ref) {
    var slidesToShow = _ref.slidesToShow, centerMode = _ref.centerMode, rtl = _ref.rtl, centerPadding = _ref.centerPadding;
    // returns no of slides on the right of active slide
    if (centerMode) {
        var right = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) right += 1;
        if (rtl && slidesToShow % 2 === 0) right += 1;
        return right;
    }
    if (rtl) return 0;
    return slidesToShow - 1;
};
var $686df89f63b82ce3$var$slidesOnLeft = module.exports.slidesOnLeft = function slidesOnLeft(_ref2) {
    var slidesToShow = _ref2.slidesToShow, centerMode = _ref2.centerMode, rtl = _ref2.rtl, centerPadding = _ref2.centerPadding;
    // returns no of slides on the left of active slide
    if (centerMode) {
        var left = (slidesToShow - 1) / 2 + 1;
        if (parseInt(centerPadding) > 0) left += 1;
        if (!rtl && slidesToShow % 2 === 0) left += 1;
        return left;
    }
    if (rtl) return slidesToShow - 1;
    return 0;
};
var $686df89f63b82ce3$var$canUseDOM = module.exports.canUseDOM = function canUseDOM() {
    return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};
var $686df89f63b82ce3$var$validSettings = module.exports.validSettings = Object.keys($686df89f63b82ce3$var$_defaultProps["default"]);
function $686df89f63b82ce3$var$filterSettings(settings) {
    return $686df89f63b82ce3$var$validSettings.reduce(function(acc, settingName) {
        if (settings.hasOwnProperty(settingName)) acc[settingName] = settings[settingName];
        return acc;
    }, {});
}

});
parcelRegister("ZEwRt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $0b9522d7091ded2b$var$_react = $0b9522d7091ded2b$var$_interopRequireDefault((parcelRequire("fIwXP")));
function $0b9522d7091ded2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $0b9522d7091ded2b$var$defaultProps = {
    accessibility: true,
    adaptiveHeight: false,
    afterChange: null,
    appendDots: function appendDots(dots) {
        return /*#__PURE__*/ $0b9522d7091ded2b$var$_react["default"].createElement("ul", {
            style: {
                display: "block"
            }
        }, dots);
    },
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    beforeChange: null,
    centerMode: false,
    centerPadding: "50px",
    className: "",
    cssEase: "ease",
    customPaging: function customPaging(i) {
        return /*#__PURE__*/ $0b9522d7091ded2b$var$_react["default"].createElement("button", null, i + 1);
    },
    dots: false,
    dotsClass: "slick-dots",
    draggable: true,
    easing: "linear",
    edgeFriction: 0.35,
    fade: false,
    focusOnSelect: false,
    infinite: true,
    initialSlide: 0,
    lazyLoad: null,
    nextArrow: null,
    onEdge: null,
    onInit: null,
    onLazyLoadError: null,
    onReInit: null,
    pauseOnDotsHover: false,
    pauseOnFocus: false,
    pauseOnHover: true,
    prevArrow: null,
    responsive: null,
    rows: 1,
    rtl: false,
    slide: "div",
    slidesPerRow: 1,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    swipeEvent: null,
    swipeToSlide: false,
    touchMove: true,
    touchThreshold: 5,
    useCSS: true,
    useTransform: true,
    variableWidth: false,
    vertical: false,
    waitForAnimate: true,
    asNavFor: null
};
var $0b9522d7091ded2b$var$_default = module.exports["default"] = $0b9522d7091ded2b$var$defaultProps;

});


parcelRegister("2DkJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Track = void 0;

var $1eaf4eb0427faf1e$var$_react = $1eaf4eb0427faf1e$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $1eaf4eb0427faf1e$var$_classnames = $1eaf4eb0427faf1e$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");
function $1eaf4eb0427faf1e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $1eaf4eb0427faf1e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1eaf4eb0427faf1e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1eaf4eb0427faf1e$var$_typeof(o);
}
function $1eaf4eb0427faf1e$var$_extends() {
    $1eaf4eb0427faf1e$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1eaf4eb0427faf1e$var$_extends.apply(this, arguments);
}
function $1eaf4eb0427faf1e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1eaf4eb0427faf1e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $1eaf4eb0427faf1e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $1eaf4eb0427faf1e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1eaf4eb0427faf1e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1eaf4eb0427faf1e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $1eaf4eb0427faf1e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $1eaf4eb0427faf1e$var$_setPrototypeOf(subClass, superClass);
}
function $1eaf4eb0427faf1e$var$_setPrototypeOf(o, p) {
    $1eaf4eb0427faf1e$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1eaf4eb0427faf1e$var$_setPrototypeOf(o, p);
}
function $1eaf4eb0427faf1e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1eaf4eb0427faf1e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1eaf4eb0427faf1e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1eaf4eb0427faf1e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1eaf4eb0427faf1e$var$_possibleConstructorReturn(this, result);
    };
}
function $1eaf4eb0427faf1e$var$_possibleConstructorReturn(self, call) {
    if (call && ($1eaf4eb0427faf1e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $1eaf4eb0427faf1e$var$_assertThisInitialized(self);
}
function $1eaf4eb0427faf1e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1eaf4eb0427faf1e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1eaf4eb0427faf1e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $1eaf4eb0427faf1e$var$_getPrototypeOf(o) {
    $1eaf4eb0427faf1e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1eaf4eb0427faf1e$var$_getPrototypeOf(o);
}
function $1eaf4eb0427faf1e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1eaf4eb0427faf1e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1eaf4eb0427faf1e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1eaf4eb0427faf1e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1eaf4eb0427faf1e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1eaf4eb0427faf1e$var$_defineProperty(obj, key, value) {
    key = $1eaf4eb0427faf1e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1eaf4eb0427faf1e$var$_toPropertyKey(t) {
    var i = $1eaf4eb0427faf1e$var$_toPrimitive(t, "string");
    return "symbol" == $1eaf4eb0427faf1e$var$_typeof(i) ? i : String(i);
}
function $1eaf4eb0427faf1e$var$_toPrimitive(t, r) {
    if ("object" != $1eaf4eb0427faf1e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1eaf4eb0427faf1e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var $1eaf4eb0427faf1e$var$getSlideClasses = function getSlideClasses(spec) {
    var slickActive, slickCenter, slickCloned;
    var centerOffset, index;
    if (spec.rtl) index = spec.slideCount - 1 - spec.index;
    else index = spec.index;
    slickCloned = index < 0 || index >= spec.slideCount;
    if (spec.centerMode) {
        centerOffset = Math.floor(spec.slidesToShow / 2);
        slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
        if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) slickActive = true;
    } else slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
    var focusedSlide;
    if (spec.targetSlide < 0) focusedSlide = spec.targetSlide + spec.slideCount;
    else if (spec.targetSlide >= spec.slideCount) focusedSlide = spec.targetSlide - spec.slideCount;
    else focusedSlide = spec.targetSlide;
    var slickCurrent = index === focusedSlide;
    return {
        "slick-slide": true,
        "slick-active": slickActive,
        "slick-center": slickCenter,
        "slick-cloned": slickCloned,
        "slick-current": slickCurrent // dubious in case of RTL
    };
};
var $1eaf4eb0427faf1e$var$getSlideStyle = function getSlideStyle(spec) {
    var style = {};
    if (spec.variableWidth === undefined || spec.variableWidth === false) style.width = spec.slideWidth;
    if (spec.fade) {
        style.position = "relative";
        if (spec.vertical) style.top = -spec.index * parseInt(spec.slideHeight);
        else style.left = -spec.index * parseInt(spec.slideWidth);
        style.opacity = spec.currentSlide === spec.index ? 1 : 0;
        style.zIndex = spec.currentSlide === spec.index ? 999 : 998;
        if (spec.useCSS) style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    }
    return style;
};
var $1eaf4eb0427faf1e$var$getKey = function getKey(child, fallbackKey) {
    return child.key || fallbackKey;
};
var $1eaf4eb0427faf1e$var$renderSlides = function renderSlides(spec) {
    var key;
    var slides = [];
    var preCloneSlides = [];
    var postCloneSlides = [];
    var childrenCount = $1eaf4eb0427faf1e$var$_react["default"].Children.count(spec.children);
    var startIndex = (0, $8XSk1.lazyStartIndex)(spec);
    var endIndex = (0, $8XSk1.lazyEndIndex)(spec);
    $1eaf4eb0427faf1e$var$_react["default"].Children.forEach(spec.children, function(elem, index) {
        var child;
        var childOnClickOptions = {
            message: "children",
            index: index,
            slidesToScroll: spec.slidesToScroll,
            currentSlide: spec.currentSlide
        };
        // in case of lazyLoad, whether or not we want to fetch the slide
        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) child = elem;
        else child = /*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].createElement("div", null);
        var childStyle = $1eaf4eb0427faf1e$var$getSlideStyle($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        var slideClass = child.props.className || "";
        var slideClasses = $1eaf4eb0427faf1e$var$getSlideClasses($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
            index: index
        }));
        // push a cloned element of the desired slide
        slides.push(/*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].cloneElement(child, {
            key: "original" + $1eaf4eb0427faf1e$var$getKey(child, index),
            "data-index": index,
            className: (0, $1eaf4eb0427faf1e$var$_classnames["default"])(slideClasses, slideClass),
            tabIndex: "-1",
            "aria-hidden": !slideClasses["slick-active"],
            style: $1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({
                outline: "none"
            }, child.props.style || {}), childStyle),
            onClick: function onClick(e) {
                child.props && child.props.onClick && child.props.onClick(e);
                if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
            }
        }));
        // if slide needs to be precloned or postcloned
        if (spec.infinite && spec.fade === false) {
            var preCloneNo = childrenCount - index;
            if (preCloneNo <= (0, $8XSk1.getPreClones)(spec)) {
                key = -preCloneNo;
                if (key >= startIndex) child = elem;
                slideClasses = $1eaf4eb0427faf1e$var$getSlideClasses($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
                    index: key
                }));
                preCloneSlides.push(/*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].cloneElement(child, {
                    key: "precloned" + $1eaf4eb0427faf1e$var$getKey(child, key),
                    "data-index": key,
                    tabIndex: "-1",
                    className: (0, $1eaf4eb0427faf1e$var$_classnames["default"])(slideClasses, slideClass),
                    "aria-hidden": !slideClasses["slick-active"],
                    style: $1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, child.props.style || {}), childStyle),
                    onClick: function onClick(e) {
                        child.props && child.props.onClick && child.props.onClick(e);
                        if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                    }
                }));
            }
            key = childrenCount + index;
            if (key < endIndex) child = elem;
            slideClasses = $1eaf4eb0427faf1e$var$getSlideClasses($1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, spec), {}, {
                index: key
            }));
            postCloneSlides.push(/*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].cloneElement(child, {
                key: "postcloned" + $1eaf4eb0427faf1e$var$getKey(child, key),
                "data-index": key,
                tabIndex: "-1",
                className: (0, $1eaf4eb0427faf1e$var$_classnames["default"])(slideClasses, slideClass),
                "aria-hidden": !slideClasses["slick-active"],
                style: $1eaf4eb0427faf1e$var$_objectSpread($1eaf4eb0427faf1e$var$_objectSpread({}, child.props.style || {}), childStyle),
                onClick: function onClick(e) {
                    child.props && child.props.onClick && child.props.onClick(e);
                    if (spec.focusOnSelect) spec.focusOnSelect(childOnClickOptions);
                }
            }));
        }
    });
    if (spec.rtl) return preCloneSlides.concat(slides, postCloneSlides).reverse();
    else return preCloneSlides.concat(slides, postCloneSlides);
};
var $1eaf4eb0427faf1e$var$Track = module.exports.Track = /*#__PURE__*/ function(_React$PureComponent) {
    $1eaf4eb0427faf1e$var$_inherits(Track, _React$PureComponent);
    var _super = $1eaf4eb0427faf1e$var$_createSuper(Track);
    function Track() {
        var _this;
        $1eaf4eb0427faf1e$var$_classCallCheck(this, Track);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        $1eaf4eb0427faf1e$var$_defineProperty($1eaf4eb0427faf1e$var$_assertThisInitialized(_this), "node", null);
        $1eaf4eb0427faf1e$var$_defineProperty($1eaf4eb0427faf1e$var$_assertThisInitialized(_this), "handleRef", function(ref) {
            _this.node = ref;
        });
        return _this;
    }
    $1eaf4eb0427faf1e$var$_createClass(Track, [
        {
            key: "render",
            value: function render() {
                var slides = $1eaf4eb0427faf1e$var$renderSlides(this.props);
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave;
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                return /*#__PURE__*/ $1eaf4eb0427faf1e$var$_react["default"].createElement("div", $1eaf4eb0427faf1e$var$_extends({
                    ref: this.handleRef,
                    className: "slick-track",
                    style: this.props.trackStyle
                }, mouseEvents), slides);
            }
        }
    ]);
    return Track;
}($1eaf4eb0427faf1e$var$_react["default"].PureComponent);

});

parcelRegister("bmMxA", function(module, exports) {
"use strict";
function $846766efbe3c4105$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $846766efbe3c4105$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $846766efbe3c4105$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dots = void 0;

var $846766efbe3c4105$var$_react = $846766efbe3c4105$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $846766efbe3c4105$var$_classnames = $846766efbe3c4105$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");
function $846766efbe3c4105$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $846766efbe3c4105$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $846766efbe3c4105$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $846766efbe3c4105$var$ownKeys(Object(t), !0).forEach(function(r) {
            $846766efbe3c4105$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $846766efbe3c4105$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $846766efbe3c4105$var$_defineProperty(obj, key, value) {
    key = $846766efbe3c4105$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $846766efbe3c4105$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $846766efbe3c4105$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $846766efbe3c4105$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $846766efbe3c4105$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $846766efbe3c4105$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $846766efbe3c4105$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $846766efbe3c4105$var$_toPropertyKey(t) {
    var i = $846766efbe3c4105$var$_toPrimitive(t, "string");
    return "symbol" == $846766efbe3c4105$var$_typeof(i) ? i : String(i);
}
function $846766efbe3c4105$var$_toPrimitive(t, r) {
    if ("object" != $846766efbe3c4105$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $846766efbe3c4105$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $846766efbe3c4105$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $846766efbe3c4105$var$_setPrototypeOf(subClass, superClass);
}
function $846766efbe3c4105$var$_setPrototypeOf(o, p) {
    $846766efbe3c4105$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $846766efbe3c4105$var$_setPrototypeOf(o, p);
}
function $846766efbe3c4105$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $846766efbe3c4105$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $846766efbe3c4105$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $846766efbe3c4105$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $846766efbe3c4105$var$_possibleConstructorReturn(this, result);
    };
}
function $846766efbe3c4105$var$_possibleConstructorReturn(self, call) {
    if (call && ($846766efbe3c4105$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $846766efbe3c4105$var$_assertThisInitialized(self);
}
function $846766efbe3c4105$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $846766efbe3c4105$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($846766efbe3c4105$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $846766efbe3c4105$var$_getPrototypeOf(o) {
    $846766efbe3c4105$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $846766efbe3c4105$var$_getPrototypeOf(o);
}
var $846766efbe3c4105$var$getDotCount = function getDotCount(spec) {
    var dots;
    if (spec.infinite) dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
    else dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
    return dots;
};
var $846766efbe3c4105$var$Dots = module.exports.Dots = /*#__PURE__*/ function(_React$PureComponent) {
    $846766efbe3c4105$var$_inherits(Dots, _React$PureComponent);
    var _super = $846766efbe3c4105$var$_createSuper(Dots);
    function Dots() {
        $846766efbe3c4105$var$_classCallCheck(this, Dots);
        return _super.apply(this, arguments);
    }
    $846766efbe3c4105$var$_createClass(Dots, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                // In Autoplay the focus stays on clicked button even after transition
                // to next slide. That only goes away by click somewhere outside
                e.preventDefault();
                this.props.clickHandler(options);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, onMouseEnter = _this$props.onMouseEnter, onMouseOver = _this$props.onMouseOver, onMouseLeave = _this$props.onMouseLeave, infinite = _this$props.infinite, slidesToScroll = _this$props.slidesToScroll, slidesToShow = _this$props.slidesToShow, slideCount = _this$props.slideCount, currentSlide = _this$props.currentSlide;
                var dotCount = $846766efbe3c4105$var$getDotCount({
                    slideCount: slideCount,
                    slidesToScroll: slidesToScroll,
                    slidesToShow: slidesToShow,
                    infinite: infinite
                });
                var mouseEvents = {
                    onMouseEnter: onMouseEnter,
                    onMouseOver: onMouseOver,
                    onMouseLeave: onMouseLeave
                };
                var dots = [];
                for(var i = 0; i < dotCount; i++){
                    var _rightBound = (i + 1) * slidesToScroll - 1;
                    var rightBound = infinite ? _rightBound : (0, $8XSk1.clamp)(_rightBound, 0, slideCount - 1);
                    var _leftBound = rightBound - (slidesToScroll - 1);
                    var leftBound = infinite ? _leftBound : (0, $8XSk1.clamp)(_leftBound, 0, slideCount - 1);
                    var className = (0, $846766efbe3c4105$var$_classnames["default"])({
                        "slick-active": infinite ? currentSlide >= leftBound && currentSlide <= rightBound : currentSlide === leftBound
                    });
                    var dotOptions = {
                        message: "dots",
                        index: i,
                        slidesToScroll: slidesToScroll,
                        currentSlide: currentSlide
                    };
                    var onClick = this.clickHandler.bind(this, dotOptions);
                    dots = dots.concat(/*#__PURE__*/ $846766efbe3c4105$var$_react["default"].createElement("li", {
                        key: i,
                        className: className
                    }, /*#__PURE__*/ $846766efbe3c4105$var$_react["default"].cloneElement(this.props.customPaging(i), {
                        onClick: onClick
                    })));
                }
                return /*#__PURE__*/ $846766efbe3c4105$var$_react["default"].cloneElement(this.props.appendDots(dots), $846766efbe3c4105$var$_objectSpread({
                    className: this.props.dotsClass
                }, mouseEvents));
            }
        }
    ]);
    return Dots;
}($846766efbe3c4105$var$_react["default"].PureComponent);

});

parcelRegister("49Fws", function(module, exports) {
"use strict";
function $306836309029bd48$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $306836309029bd48$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $306836309029bd48$var$_typeof(o);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PrevArrow = module.exports.NextArrow = void 0;

var $306836309029bd48$var$_react = $306836309029bd48$var$_interopRequireDefault((parcelRequire("fIwXP")));

var $306836309029bd48$var$_classnames = $306836309029bd48$var$_interopRequireDefault((parcelRequire("eR2a2")));

var $8XSk1 = parcelRequire("8XSk1");
function $306836309029bd48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $306836309029bd48$var$_extends() {
    $306836309029bd48$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $306836309029bd48$var$_extends.apply(this, arguments);
}
function $306836309029bd48$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $306836309029bd48$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $306836309029bd48$var$ownKeys(Object(t), !0).forEach(function(r) {
            $306836309029bd48$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $306836309029bd48$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $306836309029bd48$var$_defineProperty(obj, key, value) {
    key = $306836309029bd48$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $306836309029bd48$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $306836309029bd48$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $306836309029bd48$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $306836309029bd48$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $306836309029bd48$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $306836309029bd48$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $306836309029bd48$var$_toPropertyKey(t) {
    var i = $306836309029bd48$var$_toPrimitive(t, "string");
    return "symbol" == $306836309029bd48$var$_typeof(i) ? i : String(i);
}
function $306836309029bd48$var$_toPrimitive(t, r) {
    if ("object" != $306836309029bd48$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $306836309029bd48$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $306836309029bd48$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $306836309029bd48$var$_setPrototypeOf(subClass, superClass);
}
function $306836309029bd48$var$_setPrototypeOf(o, p) {
    $306836309029bd48$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $306836309029bd48$var$_setPrototypeOf(o, p);
}
function $306836309029bd48$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $306836309029bd48$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $306836309029bd48$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $306836309029bd48$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $306836309029bd48$var$_possibleConstructorReturn(this, result);
    };
}
function $306836309029bd48$var$_possibleConstructorReturn(self, call) {
    if (call && ($306836309029bd48$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $306836309029bd48$var$_assertThisInitialized(self);
}
function $306836309029bd48$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $306836309029bd48$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($306836309029bd48$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $306836309029bd48$var$_getPrototypeOf(o) {
    $306836309029bd48$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $306836309029bd48$var$_getPrototypeOf(o);
}
var $306836309029bd48$var$PrevArrow = module.exports.PrevArrow = /*#__PURE__*/ function(_React$PureComponent) {
    $306836309029bd48$var$_inherits(PrevArrow, _React$PureComponent);
    var _super = $306836309029bd48$var$_createSuper(PrevArrow);
    function PrevArrow() {
        $306836309029bd48$var$_classCallCheck(this, PrevArrow);
        return _super.apply(this, arguments);
    }
    $306836309029bd48$var$_createClass(PrevArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var prevClasses = {
                    "slick-arrow": true,
                    "slick-prev": true
                };
                var prevHandler = this.clickHandler.bind(this, {
                    message: "previous"
                });
                if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
                    prevClasses["slick-disabled"] = true;
                    prevHandler = null;
                }
                var prevArrowProps = {
                    key: "0",
                    "data-role": "none",
                    className: (0, $306836309029bd48$var$_classnames["default"])(prevClasses),
                    style: {
                        display: "block"
                    },
                    onClick: prevHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var prevArrow;
                if (this.props.prevArrow) prevArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].cloneElement(this.props.prevArrow, $306836309029bd48$var$_objectSpread($306836309029bd48$var$_objectSpread({}, prevArrowProps), customProps));
                else prevArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].createElement("button", $306836309029bd48$var$_extends({
                    key: "0",
                    type: "button"
                }, prevArrowProps), " ", "Previous");
                return prevArrow;
            }
        }
    ]);
    return PrevArrow;
}($306836309029bd48$var$_react["default"].PureComponent);
var $306836309029bd48$var$NextArrow = module.exports.NextArrow = /*#__PURE__*/ function(_React$PureComponent2) {
    $306836309029bd48$var$_inherits(NextArrow, _React$PureComponent2);
    var _super2 = $306836309029bd48$var$_createSuper(NextArrow);
    function NextArrow() {
        $306836309029bd48$var$_classCallCheck(this, NextArrow);
        return _super2.apply(this, arguments);
    }
    $306836309029bd48$var$_createClass(NextArrow, [
        {
            key: "clickHandler",
            value: function clickHandler(options, e) {
                if (e) e.preventDefault();
                this.props.clickHandler(options, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var nextClasses = {
                    "slick-arrow": true,
                    "slick-next": true
                };
                var nextHandler = this.clickHandler.bind(this, {
                    message: "next"
                });
                if (!(0, $8XSk1.canGoNext)(this.props)) {
                    nextClasses["slick-disabled"] = true;
                    nextHandler = null;
                }
                var nextArrowProps = {
                    key: "1",
                    "data-role": "none",
                    className: (0, $306836309029bd48$var$_classnames["default"])(nextClasses),
                    style: {
                        display: "block"
                    },
                    onClick: nextHandler
                };
                var customProps = {
                    currentSlide: this.props.currentSlide,
                    slideCount: this.props.slideCount
                };
                var nextArrow;
                if (this.props.nextArrow) nextArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].cloneElement(this.props.nextArrow, $306836309029bd48$var$_objectSpread($306836309029bd48$var$_objectSpread({}, nextArrowProps), customProps));
                else nextArrow = /*#__PURE__*/ $306836309029bd48$var$_react["default"].createElement("button", $306836309029bd48$var$_extends({
                    key: "1",
                    type: "button"
                }, nextArrowProps), " ", "Next");
                return nextArrow;
            }
        }
    ]);
    return NextArrow;
}($306836309029bd48$var$_react["default"].PureComponent);

});

parcelRegister("4EfKw", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $36271d587aa793ca$export$2e2bcd8739ae039; });
/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */ /* eslint-disable require-jsdoc, valid-jsdoc */ var $36271d587aa793ca$var$MapShim = function() {
    if (typeof Map !== 'undefined') return Map;
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */ function getIndex(arr, key) {
        var result = -1;
        arr.some(function(entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ function() {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */ get: function get() {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */ class_1.prototype.get = function(key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */ class_1.prototype.set = function(key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) this.__entries__[index][1] = value;
            else this.__entries__.push([
                key,
                value
            ]);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.delete = function(key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) entries.splice(index, 1);
        };
        /**
         * @param {*} key
         * @returns {void}
         */ class_1.prototype.has = function(key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */ class_1.prototype.clear = function() {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */ class_1.prototype.forEach = function(callback, ctx) {
            if (ctx === void 0) ctx = null;
            for(var _i = 0, _a = this.__entries__; _i < _a.length; _i++){
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }();
}();
/**
 * Detects whether window and document objects are available in current environment.
 */ var $36271d587aa793ca$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
// Returns global object of a current environment.
var $36271d587aa793ca$var$global$1 = function() {
    if (typeof $parcel$global !== 'undefined' && $parcel$global.Math === Math) return $parcel$global;
    if (typeof self !== 'undefined' && self.Math === Math) return self;
    if (typeof window !== 'undefined' && window.Math === Math) return window;
    // eslint-disable-next-line no-new-func
    return Function('return this')();
}();
/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */ var $36271d587aa793ca$var$requestAnimationFrame$1 = function() {
    if (typeof requestAnimationFrame === 'function') // It's required to use a bounded function because IE sometimes throws
    // an "Invalid calling object" error if rAF is invoked without the global
    // object on the left hand side.
    return requestAnimationFrame.bind($36271d587aa793ca$var$global$1);
    return function(callback) {
        return setTimeout(function() {
            return callback(Date.now());
        }, 1000 / 60);
    };
}();
// Defines minimum timeout before adding a trailing call.
var $36271d587aa793ca$var$trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */ function $36271d587aa793ca$var$throttle(callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */ function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) proxy();
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */ function timeoutCallback() {
        $36271d587aa793ca$var$requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */ function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < $36271d587aa793ca$var$trailingTimeout) return;
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
// Minimum delay before invoking the update of observers.
var $36271d587aa793ca$var$REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var $36271d587aa793ca$var$transitionKeys = [
    'top',
    'right',
    'bottom',
    'left',
    'width',
    'height',
    'size',
    'weight'
];
// Check if MutationObserver is available.
var $36271d587aa793ca$var$mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */ var $36271d587aa793ca$var$ResizeObserverController = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */ function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */ this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */ this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */ this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */ this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = $36271d587aa793ca$var$throttle(this.refresh.bind(this), $36271d587aa793ca$var$REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */ ResizeObserverController.prototype.addObserver = function(observer) {
        if (!~this.observers_.indexOf(observer)) this.observers_.push(observer);
        // Add listeners if they haven't been added yet.
        if (!this.connected_) this.connect_();
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */ ResizeObserverController.prototype.removeObserver = function(observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) observers.splice(index, 1);
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) this.disconnect_();
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */ ResizeObserverController.prototype.refresh = function() {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) this.refresh();
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */ ResizeObserverController.prototype.updateObservers_ = function() {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function(observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function(observer) {
            return observer.broadcastActive();
        });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.connect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!$36271d587aa793ca$var$isBrowser || this.connected_) return;
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if ($36271d587aa793ca$var$mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        } else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */ ResizeObserverController.prototype.disconnect_ = function() {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!$36271d587aa793ca$var$isBrowser || !this.connected_) return;
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) this.mutationsObserver_.disconnect();
        if (this.mutationEventsAdded_) document.removeEventListener('DOMSubtreeModified', this.refresh);
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */ ResizeObserverController.prototype.onTransitionEnd_ = function(_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = $36271d587aa793ca$var$transitionKeys.some(function(key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) this.refresh();
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */ ResizeObserverController.getInstance = function() {
        if (!this.instance_) this.instance_ = new ResizeObserverController();
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */ ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}();
/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */ var $36271d587aa793ca$var$defineConfigurable = function defineConfigurable(target, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
};
/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */ var $36271d587aa793ca$var$getWindowOf = function getWindowOf(target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || $36271d587aa793ca$var$global$1;
};
// Placeholder of an empty content rectangle.
var $36271d587aa793ca$var$emptyRect = $36271d587aa793ca$var$createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */ function $36271d587aa793ca$var$toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */ function $36271d587aa793ca$var$getBordersSize(styles) {
    var positions = [];
    for(var _i = 1; _i < arguments.length; _i++)positions[_i - 1] = arguments[_i];
    return positions.reduce(function(size, position) {
        var value = styles['border-' + position + '-width'];
        return size + $36271d587aa793ca$var$toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */ function $36271d587aa793ca$var$getPaddings(styles) {
    var positions = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    var paddings = {};
    for(var _i = 0, positions_1 = positions; _i < positions_1.length; _i++){
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = $36271d587aa793ca$var$toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$getSVGContentRect(target) {
    var bbox = target.getBBox();
    return $36271d587aa793ca$var$createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) return $36271d587aa793ca$var$emptyRect;
    var styles = $36271d587aa793ca$var$getWindowOf(target).getComputedStyle(target);
    var paddings = $36271d587aa793ca$var$getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = $36271d587aa793ca$var$toFloat(styles.width), height = $36271d587aa793ca$var$toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) width -= $36271d587aa793ca$var$getBordersSize(styles, 'left', 'right') + horizPad;
        if (Math.round(height + vertPad) !== clientHeight) height -= $36271d587aa793ca$var$getBordersSize(styles, 'top', 'bottom') + vertPad;
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!$36271d587aa793ca$var$isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) width -= vertScrollbar;
        if (Math.abs(horizScrollbar) !== 1) height -= horizScrollbar;
    }
    return $36271d587aa793ca$var$createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ var $36271d587aa793ca$var$isSVGGraphicsElement = function() {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') return function(target) {
        return target instanceof $36271d587aa793ca$var$getWindowOf(target).SVGGraphicsElement;
    };
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function(target) {
        return target instanceof $36271d587aa793ca$var$getWindowOf(target).SVGElement && typeof target.getBBox === 'function';
    };
}();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */ function $36271d587aa793ca$var$isDocumentElement(target) {
    return target === $36271d587aa793ca$var$getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$getContentRect(target) {
    if (!$36271d587aa793ca$var$isBrowser) return $36271d587aa793ca$var$emptyRect;
    if ($36271d587aa793ca$var$isSVGGraphicsElement(target)) return $36271d587aa793ca$var$getSVGContentRect(target);
    return $36271d587aa793ca$var$getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */ function $36271d587aa793ca$var$createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    $36271d587aa793ca$var$defineConfigurable(rect, {
        x: x,
        y: y,
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */ function $36271d587aa793ca$var$createRectInit(x, y, width, height) {
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */ var $36271d587aa793ca$var$ResizeObservation = /** @class */ function() {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */ function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */ this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */ this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */ this.contentRect_ = $36271d587aa793ca$var$createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */ ResizeObservation.prototype.isActive = function() {
        var rect = $36271d587aa793ca$var$getContentRect(this.target);
        this.contentRect_ = rect;
        return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */ ResizeObservation.prototype.broadcastRect = function() {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}();
var $36271d587aa793ca$var$ResizeObserverEntry = /** @class */ function() {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */ function ResizeObserverEntry(target, rectInit) {
        var contentRect = $36271d587aa793ca$var$createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        $36271d587aa793ca$var$defineConfigurable(this, {
            target: target,
            contentRect: contentRect
        });
    }
    return ResizeObserverEntry;
}();
var $36271d587aa793ca$var$ResizeObserverSPI = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */ function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */ this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */ this.observations_ = new $36271d587aa793ca$var$MapShim();
        if (typeof callback !== 'function') throw new TypeError('The callback provided as parameter 1 is not a function.');
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */ ResizeObserverSPI.prototype.observe = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $36271d587aa793ca$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) return;
        observations.set(target, new $36271d587aa793ca$var$ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */ ResizeObserverSPI.prototype.unobserve = function(target) {
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) return;
        if (!(target instanceof $36271d587aa793ca$var$getWindowOf(target).Element)) throw new TypeError('parameter 1 is not of type "Element".');
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) return;
        observations.delete(target);
        if (!observations.size) this.controller_.removeObserver(this);
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.disconnect = function() {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.gatherActive = function() {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function(observation) {
            if (observation.isActive()) _this.activeObservations_.push(observation);
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.broadcastActive = function() {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) return;
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function(observation) {
            return new $36271d587aa793ca$var$ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */ ResizeObserverSPI.prototype.clearActive = function() {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */ ResizeObserverSPI.prototype.hasActive = function() {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}();
// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var $36271d587aa793ca$var$observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new $36271d587aa793ca$var$MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */ var $36271d587aa793ca$var$ResizeObserver = /** @class */ function() {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */ function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) throw new TypeError('Cannot call a class as a function.');
        if (!arguments.length) throw new TypeError('1 argument required, but only 0 present.');
        var controller = $36271d587aa793ca$var$ResizeObserverController.getInstance();
        var observer = new $36271d587aa793ca$var$ResizeObserverSPI(callback, controller, this);
        $36271d587aa793ca$var$observers.set(this, observer);
    }
    return ResizeObserver;
}();
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function(method) {
    $36271d587aa793ca$var$ResizeObserver.prototype[method] = function() {
        var _a;
        return (_a = $36271d587aa793ca$var$observers.get(this))[method].apply(_a, arguments);
    };
});
var $36271d587aa793ca$var$index = function() {
    // Export existing implementation if available.
    if (typeof $36271d587aa793ca$var$global$1.ResizeObserver !== 'undefined') return $36271d587aa793ca$var$global$1.ResizeObserver;
    return $36271d587aa793ca$var$ResizeObserver;
}();
var $36271d587aa793ca$export$2e2bcd8739ae039 = $36271d587aa793ca$var$index;

});


parcelRegister("jTrNc", function(module, exports) {

var $lJYuL = parcelRequire("lJYuL");
var $e7b8b669f720bf18$var$isDimension = function isDimension(feature) {
    var re = /[height|width]$/;
    return re.test(feature);
};
var $e7b8b669f720bf18$var$obj2mq = function obj2mq(obj) {
    var mq = '';
    var features = Object.keys(obj);
    features.forEach(function(feature, index) {
        var value = obj[feature];
        feature = $lJYuL(feature);
        // Add px to dimension features
        if ($e7b8b669f720bf18$var$isDimension(feature) && typeof value === 'number') value = value + 'px';
        if (value === true) mq += feature;
        else if (value === false) mq += 'not ' + feature;
        else mq += '(' + feature + ': ' + value + ')';
        if (index < features.length - 1) mq += ' and ';
    });
    return mq;
};
var $e7b8b669f720bf18$var$json2mq = function json2mq(query) {
    var mq = '';
    if (typeof query === 'string') return query;
    // Handling array of media queries
    if (query instanceof Array) {
        query.forEach(function(q, index) {
            mq += $e7b8b669f720bf18$var$obj2mq(q);
            if (index < query.length - 1) mq += ', ';
        });
        return mq;
    }
    // Handling single media query
    return $e7b8b669f720bf18$var$obj2mq(query);
};
module.exports = $e7b8b669f720bf18$var$json2mq;

});
parcelRegister("lJYuL", function(module, exports) {
var $fd3cba07ea16954e$var$camel2hyphen = function camel2hyphen(str) {
    return str.replace(/[A-Z]/g, function(match) {
        return '-' + match.toLowerCase();
    }).toLowerCase();
};
module.exports = $fd3cba07ea16954e$var$camel2hyphen;

});


parcelRegister("4RUun", function(module, exports) {

var $4HAd6 = parcelRequire("4HAd6");
module.exports = new $4HAd6();

});
parcelRegister("4HAd6", function(module, exports) {

var $3fyy4 = parcelRequire("3fyy4");

var $32NXA = parcelRequire("32NXA");
var $36c7443521185ca6$var$each = $32NXA.each;
var $36c7443521185ca6$var$isFunction = $32NXA.isFunction;
var $36c7443521185ca6$var$isArray = $32NXA.isArray;
/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */ function $36c7443521185ca6$var$MediaQueryDispatch() {
    if (!window.matchMedia) throw new Error('matchMedia not present, legacy browsers require a polyfill');
    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}
$36c7443521185ca6$var$MediaQueryDispatch.prototype = {
    constructor: $36c7443521185ca6$var$MediaQueryDispatch,
    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */ register: function register(q, options, shouldDegrade) {
        var queries = this.queries, isUnconditional = shouldDegrade && this.browserIsIncapable;
        if (!queries[q]) queries[q] = new $3fyy4(q, isUnconditional);
        //normalise to object in an array
        if ($36c7443521185ca6$var$isFunction(options)) options = {
            match: options
        };
        if (!$36c7443521185ca6$var$isArray(options)) options = [
            options
        ];
        $36c7443521185ca6$var$each(options, function(handler) {
            if ($36c7443521185ca6$var$isFunction(handler)) handler = {
                match: handler
            };
            queries[q].addHandler(handler);
        });
        return this;
    },
    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */ unregister: function unregister(q, handler) {
        var query = this.queries[q];
        if (query) {
            if (handler) query.removeHandler(handler);
            else {
                query.clear();
                delete this.queries[q];
            }
        }
        return this;
    }
};
module.exports = $36c7443521185ca6$var$MediaQueryDispatch;

});
parcelRegister("3fyy4", function(module, exports) {

var $9Lsgs = parcelRequire("9Lsgs");

var $32NXA = parcelRequire("32NXA");
var $25dd9270f3305f11$require$each = $32NXA.each;
/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */ function $25dd9270f3305f11$var$MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);
    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}
$25dd9270f3305f11$var$MediaQuery.prototype = {
    constuctor: $25dd9270f3305f11$var$MediaQuery,
    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */ addHandler: function addHandler(handler) {
        var qh = new $9Lsgs(handler);
        this.handlers.push(qh);
        this.matches() && qh.on();
    },
    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */ removeHandler: function removeHandler(handler) {
        var handlers = this.handlers;
        $25dd9270f3305f11$require$each(handlers, function(h, i) {
            if (h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i, 1); //remove from array and exit each early
            }
        });
    },
    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */ matches: function matches() {
        return this.mql.matches || this.isUnconditional;
    },
    /**
     * Clears all handlers and unbinds events
     */ clear: function clear() {
        $25dd9270f3305f11$require$each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },
    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */ assess: function assess() {
        var action = this.matches() ? 'on' : 'off';
        $25dd9270f3305f11$require$each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};
module.exports = $25dd9270f3305f11$var$MediaQuery;

});
parcelRegister("9Lsgs", function(module, exports) {
/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */ function $71be6d9392596ac0$var$QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}
$71be6d9392596ac0$var$QueryHandler.prototype = {
    constructor: $71be6d9392596ac0$var$QueryHandler,
    /**
     * coordinates setup of the handler
     *
     * @function
     */ setup: function setup() {
        if (this.options.setup) this.options.setup();
        this.initialised = true;
    },
    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */ on: function on() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },
    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */ off: function off() {
        this.options.unmatch && this.options.unmatch();
    },
    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */ destroy: function destroy() {
        this.options.destroy ? this.options.destroy() : this.off();
    },
    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */ equals: function equals(target) {
        return this.options === target || this.options.match === target;
    }
};
module.exports = $71be6d9392596ac0$var$QueryHandler;

});

parcelRegister("32NXA", function(module, exports) {
/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */ function $237850073447f175$var$each(collection, fn) {
    var i = 0, length = collection.length, cont;
    for(i; i < length; i++){
        cont = fn(collection[i], i);
        if (cont === false) break; //allow early exit
    }
}
/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */ function $237850073447f175$var$isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}
/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */ function $237850073447f175$var$isFunction(target) {
    return typeof target === 'function';
}
module.exports = {
    isFunction: $237850073447f175$var$isFunction,
    isArray: $237850073447f175$var$isArray,
    each: $237850073447f175$var$each
};

});





parcelRegister("5icQr", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return isDraft; });
$parcel$export(module.exports, "isDraftable", function () { return isDraftable; });
$parcel$export(module.exports, "current", function () { return current; });
$parcel$export(module.exports, "produce", function () { return produce; });

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function(obj, key, value) {
    return key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var __spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (__getOwnPropSymbols) try {
        for(var _iterator = __getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    throw new Error("[Immer] minified error nr: ".concat(error, ". Full error at: https://bit.ly/3cXEKWf"));
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
    if (!value || (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object") return false;
    var proto = getPrototypeOf(value);
    if (proto === null) return true;
    var Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter) {
    if (getArchtype(obj) === 0 /* Object */ ) Reflect.ownKeys(obj).forEach(function(key) {
        iter(key, obj[key], obj);
    });
    else obj.forEach(function(entry, index) {
        return iter(index, entry, obj);
    });
}
function getArchtype(thing) {
    var state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    var t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    var isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        var descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        var keys = Reflect.ownKeys(descriptors);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        var proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        var obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj) {
    var deep = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) Object.entries(obj).forEach(function(param) {
        var _param = (0, $kB67t._)(param, 2), key = _param[0], value = _param[1];
        return freeze(value, true);
    });
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
function isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    var plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    var state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    var baseDraft = scope.drafts_[0];
    var isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    if (!state) {
        each(value, function(key, childValue) {
            return finalizeProperty(rootScope, state, value, key, childValue, path);
        });
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        var result = state.copy_;
        var resultEach = result;
        var isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, function(key, childValue) {
            return finalizeProperty(rootScope, state, result, key, childValue, path, isSet2);
        });
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (isDraft(childValue)) {
        var path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        var res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && (typeof prop === "undefined" ? "undefined" : (0, $YtE9h._)(prop)) !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop)) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value) {
    var deep = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    var isArray = Array.isArray(base);
    var state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    var target = state;
    var traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    var _Proxy_revocable = Proxy.revocable(target, traps), revoke = _Proxy_revocable.revoke, proxy = _Proxy_revocable.proxy;
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get: function(state, prop) {
        if (prop === DRAFT_STATE) return state;
        var source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        var value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has: function(state, prop) {
        return prop in latest(state);
    },
    ownKeys: function(state) {
        return Reflect.ownKeys(latest(state));
    },
    set: function(state, prop, value) {
        var desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            var current2 = peek(latest(state), prop);
            var currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty: function(state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor: function(state, prop) {
        var owner = latest(state);
        var desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty: function() {
        die(11);
    },
    getPrototypeOf: function(state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf: function() {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, function(key, fn) {
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    var state = draft[DRAFT_STATE];
    var source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    var desc = getDescriptorFromProto(source, prop);
    return desc ? "value" in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    var proto = getPrototypeOf(source);
    while(proto){
        var desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = /*#__PURE__*/ function() {
    "use strict";
    function Immer2(config) {
        var _this = this;
        (0, $bB0zn._)(this, Immer2);
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = function(base, recipe, patchListener) {
            if (typeof base === "function" && typeof recipe !== "function") {
                var defaultBase = recipe;
                recipe = base;
                var self = _this;
                return function curriedProduce() {
                    var _this = this;
                    var base2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : defaultBase;
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    var _recipe;
                    return self.produce(base2, function(draft) {
                        return (_recipe = recipe).call.apply(_recipe, [
                            _this,
                            draft
                        ].concat((0, $2Xzd1._)(args)));
                    });
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            var result;
            if (isDraftable(base)) {
                var scope = enterScope(_this);
                var proxy = createProxy(base, void 0);
                var hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || (typeof base === "undefined" ? "undefined" : (0, $YtE9h._)(base)) !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (_this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    var p = [];
                    var ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = function(base, recipe) {
            var _this1 = _this;
            if (typeof base === "function") return function(state) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    args[_key - 1] = arguments[_key];
                }
                return _this1.produceWithPatches(state, function(draft) {
                    return base.apply(void 0, [
                        draft
                    ].concat((0, $2Xzd1._)(args)));
                });
            };
            var patches, inversePatches;
            var result = _this.produce(base, recipe, function(p, ip) {
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    (0, $6QEWP._)(Immer2, [
        {
            key: "createDraft",
            value: function createDraft(base) {
                if (!isDraftable(base)) die(8);
                if (isDraft(base)) base = current(base);
                var scope = enterScope(this);
                var proxy = createProxy(base, void 0);
                proxy[DRAFT_STATE].isManual_ = true;
                leaveScope(scope);
                return proxy;
            }
        },
        {
            key: "finishDraft",
            value: function finishDraft(draft, patchListener) {
                var state = draft && draft[DRAFT_STATE];
                if (!state || !state.isManual_) die(9);
                var scope = state.scope_;
                usePatchesInScope(scope, patchListener);
                return processResult(void 0, scope);
            }
        },
        {
            /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ key: "setAutoFreeze",
            value: function setAutoFreeze(value) {
                this.autoFreeze_ = value;
            }
        },
        {
            /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ key: "setUseStrictShallowCopy",
            value: function setUseStrictShallowCopy(value) {
                this.useStrictShallowCopy_ = value;
            }
        },
        {
            key: "applyPatches",
            value: function applyPatches(base, patches) {
                var i;
                for(i = patches.length - 1; i >= 0; i--){
                    var patch = patches[i];
                    if (patch.path.length === 0 && patch.op === "replace") {
                        base = patch.value;
                        break;
                    }
                }
                if (i > -1) patches = patches.slice(i + 1);
                var applyPatchesImpl = getPlugin("Patches").applyPatches_;
                if (isDraft(base)) return applyPatchesImpl(base, patches);
                return this.produce(base, function(draft) {
                    return applyPatchesImpl(draft, patches);
                });
            }
        }
    ]);
    return Immer2;
}();
function createProxy(value, parent) {
    var draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    var scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    var state = value[DRAFT_STATE];
    var copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = shallowCopy(value, true);
    each(copy, function(key, childValue) {
        set(copy, key, currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    var errorOffset = 16;
    var REPLACE = "replace";
    var ADD = "add";
    var REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, assigned_ = state.assigned_;
        var copy_ = state.copy_;
        if (copy_.length < base_.length) {
            var ref;
            ref = [
                copy_,
                base_
            ], base_ = ref[0], copy_ = ref[1], ref;
            var ref1;
            ref1 = [
                inversePatches,
                patches
            ], patches = ref1[0], inversePatches = ref1[1], ref1;
        }
        for(var i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            var path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(var i1 = base_.length; i1 < copy_.length; i1++){
            var path1 = basePath.concat([
                i1
            ]);
            patches.push({
                op: ADD,
                path: path1,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i1])
            });
        }
        for(var i2 = copy_.length - 1; base_.length <= i2; --i2){
            var path2 = basePath.concat([
                i2
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path2
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        each(state.assigned_, function(key, assignedValue) {
            var origValue = get(base_, key);
            var value = get(copy_, key);
            var op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            var path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        var base_ = state.base_, copy_ = state.copy_;
        var i = 0;
        base_.forEach(function(value) {
            if (!copy_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach(function(value) {
            if (!base_.has(value)) {
                var path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach(function(patch) {
            var path = patch.path, op = patch.op;
            var base = draft;
            for(var i = 0; i < path.length - 1; i++){
                var parentType = getArchtype(base);
                var p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if ((typeof base === "undefined" ? "undefined" : (0, $YtE9h._)(base)) !== "object") die(errorOffset + 2, path.join("/"));
            }
            var type = getArchtype(base);
            var value = deepClonePatchValue(patch.value);
            var key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(function(param) {
            var _param = (0, $kB67t._)(param, 2), k = _param[0], v = _param[1];
            return [
                k,
                deepClonePatchValue(v)
            ];
        }));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        var cloned = Object.create(getPrototypeOf(obj));
        for(var key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    var DraftMap = /*#__PURE__*/ function(Map1) {
        "use strict";
        (0, $5dLwP._)(DraftMap, Map1);
        function DraftMap(target, parent) {
            (0, $bB0zn._)(this, DraftMap);
            var _this;
            _this = (0, $3Gvhd._)(this, DraftMap);
            _this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: _this,
                isManual_: false,
                revoked_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftMap, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(key) {
                    return latest(this[DRAFT_STATE]).has(key);
                }
            },
            {
                key: "set",
                value: function set(key, value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!latest(state).has(key) || latest(state).get(key) !== value) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_.set(key, true);
                        state.copy_.set(key, value);
                        state.assigned_.set(key, true);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(key) {
                    if (!this.has(key)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareMapCopy(state);
                    markChanged(state);
                    if (state.base_.has(key)) state.assigned_.set(key, false);
                    else state.assigned_.delete(key);
                    state.copy_.delete(key);
                    return true;
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareMapCopy(state);
                        markChanged(state);
                        state.assigned_ = /* @__PURE__ */ new Map();
                        each(state.base_, function(key) {
                            state.assigned_.set(key, false);
                        });
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var _this = this;
                    var state = this[DRAFT_STATE];
                    latest(state).forEach(function(_value, key, _map) {
                        cb.call(thisArg, _this.get(key), key, _this);
                    });
                }
            },
            {
                key: "get",
                value: function get(key) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    var value = latest(state).get(key);
                    if (state.finalized_ || !isDraftable(value)) return value;
                    if (value !== state.base_.get(key)) return value;
                    var draft = createProxy(value, state);
                    prepareMapCopy(state);
                    state.copy_.set(key, draft);
                    return draft;
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return latest(this[DRAFT_STATE]).keys();
                }
            },
            {
                key: "values",
                value: function values() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.values();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: value
                        };
                    }), _obj;
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var _this = this;
                    var iterator = this.keys();
                    var _obj;
                    return _obj = {}, (0, $hD5pT._)(_obj, Symbol.iterator, function() {
                        return _this.entries();
                    }), (0, $hD5pT._)(_obj, "next", function() {
                        var r = iterator.next();
                        if (r.done) return r;
                        var value = _this.get(r.value);
                        return {
                            done: false,
                            value: [
                                r.value,
                                value
                            ]
                        };
                    }), _obj;
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.entries();
                }
            }
        ]);
        return DraftMap;
    }((0, $fPaN7._)(Map));
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    var DraftSet = /*#__PURE__*/ function(Set1) {
        "use strict";
        (0, $5dLwP._)(DraftSet, Set1);
        function DraftSet(target, parent) {
            (0, $bB0zn._)(this, DraftSet);
            var _this;
            _this = (0, $3Gvhd._)(this, DraftSet);
            _this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: _this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
            return _this;
        }
        (0, $6QEWP._)(DraftSet, [
            {
                key: "size",
                get: function get() {
                    return latest(this[DRAFT_STATE]).size;
                }
            },
            {
                key: "has",
                value: function has(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!state.copy_) return state.base_.has(value);
                    if (state.copy_.has(value)) return true;
                    if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
                    return false;
                }
            },
            {
                key: "add",
                value: function add(value) {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (!this.has(value)) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.add(value);
                    }
                    return this;
                }
            },
            {
                key: "delete",
                value: function _delete(value) {
                    if (!this.has(value)) return false;
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    markChanged(state);
                    return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
                }
            },
            {
                key: "clear",
                value: function clear() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    if (latest(state).size) {
                        prepareSetCopy(state);
                        markChanged(state);
                        state.copy_.clear();
                    }
                }
            },
            {
                key: "values",
                value: function values() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.values();
                }
            },
            {
                key: "entries",
                value: function entries() {
                    var state = this[DRAFT_STATE];
                    assertUnrevoked(state);
                    prepareSetCopy(state);
                    return state.copy_.entries();
                }
            },
            {
                key: "keys",
                value: function keys() {
                    return this.values();
                }
            },
            {
                key: (DRAFT_STATE, Symbol.iterator),
                value: function value() {
                    return this.values();
                }
            },
            {
                key: "forEach",
                value: function forEach(cb, thisArg) {
                    var iterator = this.values();
                    var result = iterator.next();
                    while(!result.done){
                        cb.call(thisArg, result.value, result.value, this);
                        result = iterator.next();
                    }
                }
            }
        ]);
        return DraftSet;
    }((0, $fPaN7._)(Set));
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach(function(value) {
                if (isDraftable(value)) {
                    var draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = immer.produceWithPatches.bind(immer);
var setAutoFreeze = immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = immer.setUseStrictShallowCopy.bind(immer);
var applyPatches = immer.applyPatches.bind(immer);
var createDraft = immer.createDraft.bind(immer);
var finishDraft = immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

});
parcelRegister("3Gvhd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2aed8e3a8a2d58d2$export$71511d61b312f219; });

var $ZhYhU = parcelRequire("ZhYhU");

var $bFohN = parcelRequire("bFohN");

var $oIOMH = parcelRequire("oIOMH");
function $2aed8e3a8a2d58d2$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $ZhYhU._)(derived);
    return (0, $oIOMH._)(_this, (0, $bFohN._)() ? Reflect.construct(derived, args || [], (0, $ZhYhU._)(_this).constructor) : derived.apply(_this, args));
}

});
parcelRegister("ZhYhU", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0b83a35ce2cd1792$export$71511d61b312f219; });
function $0b83a35ce2cd1792$export$71511d61b312f219(o) {
    $0b83a35ce2cd1792$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $0b83a35ce2cd1792$export$71511d61b312f219(o);
}

});

parcelRegister("bFohN", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $87e65cc21f1ac8a6$export$71511d61b312f219; });
function $87e65cc21f1ac8a6$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($87e65cc21f1ac8a6$export$71511d61b312f219 = function() {
        return !!result;
    })();
}

});

parcelRegister("oIOMH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $04a501f287790d91$export$71511d61b312f219; });

var $fWfWu = parcelRequire("fWfWu");

var $YtE9h = parcelRequire("YtE9h");
function $04a501f287790d91$export$71511d61b312f219(self, call) {
    if (call && ((0, $YtE9h._)(call) === "object" || typeof call === "function")) return call;
    return (0, $fWfWu._)(self);
}

});
parcelRegister("fWfWu", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $02fe9748b9e38ccb$export$71511d61b312f219; });
function $02fe9748b9e38ccb$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("bB0zn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8713978b2328d32b$export$71511d61b312f219; });
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("6QEWP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4fc75ccb937ab1df$export$71511d61b312f219; });
function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("hD5pT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd5a47cf8ef6d766$export$71511d61b312f219; });
function $cd5a47cf8ef6d766$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("5dLwP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3cd308d6b98edc5a$export$71511d61b312f219; });

var $eZsRM = parcelRequire("eZsRM");
function $3cd308d6b98edc5a$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $eZsRM._)(subClass, superClass);
}

});
parcelRegister("eZsRM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ae9d277b5847b878$export$71511d61b312f219; });
function $ae9d277b5847b878$export$71511d61b312f219(o, p) {
    $ae9d277b5847b878$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ae9d277b5847b878$export$71511d61b312f219(o, p);
}

});


parcelRegister("kB67t", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $efec029548ccee7f$export$71511d61b312f219; });

var $Q9cvz = parcelRequire("Q9cvz");

var $c4AWK = parcelRequire("c4AWK");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $Q9cvz._)(arr) || (0, $c4AWK._)(arr, i) || (0, $ihB7G._)(arr, i) || (0, $dNApw._)();
}

});
parcelRegister("Q9cvz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09cbfe85151ea6c6$export$71511d61b312f219; });
function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("c4AWK", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8ca2848f896a6803$export$71511d61b312f219; });
function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("dNApw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a0bc1859061deae1$export$71511d61b312f219; });
function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("ihB7G", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d4f69c5c6c4654b1$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $gNF1f._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $gNF1f._)(o, minLen);
}

});
parcelRegister("gNF1f", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c3b10a83b523f372$export$71511d61b312f219; });
function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("2Xzd1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $227c6742e0ff6f82$export$71511d61b312f219; });

var $gUOYc = parcelRequire("gUOYc");

var $Q6yVl = parcelRequire("Q6yVl");

var $4S8xA = parcelRequire("4S8xA");

var $ihB7G = parcelRequire("ihB7G");
function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $gUOYc._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $4S8xA._)();
}

});
parcelRegister("gUOYc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $c50969dc1df61e8b$export$71511d61b312f219; });

var $gNF1f = parcelRequire("gNF1f");
function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $gNF1f._)(arr);
}

});

parcelRegister("Q6yVl", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $09c9f293d010c0e1$export$71511d61b312f219; });
function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("4S8xA", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $38c2d4931cb7a7c4$export$71511d61b312f219; });
function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("fPaN7", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b853fd5b3c362aee$export$71511d61b312f219; });

var $f5KHm = parcelRequire("f5KHm");

var $ZhYhU = parcelRequire("ZhYhU");

var $cHvTP = parcelRequire("cHvTP");

var $eZsRM = parcelRequire("eZsRM");
function $b853fd5b3c362aee$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $b853fd5b3c362aee$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $cHvTP._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $f5KHm._)(Class, arguments, (0, $ZhYhU._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $eZsRM._)(Wrapper, Class);
    };
    return $b853fd5b3c362aee$export$71511d61b312f219(Class);
}

});
parcelRegister("f5KHm", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $afcb8bf546bf0e4a$export$71511d61b312f219; });

var $bFohN = parcelRequire("bFohN");

var $eZsRM = parcelRequire("eZsRM");
function $afcb8bf546bf0e4a$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $bFohN._)()) $afcb8bf546bf0e4a$export$71511d61b312f219 = Reflect.construct;
    else $afcb8bf546bf0e4a$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $eZsRM._)(instance, Class.prototype);
        return instance;
    };
    return $afcb8bf546bf0e4a$export$71511d61b312f219.apply(null, arguments);
}

});

parcelRegister("cHvTP", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $93f23ebd967272a8$export$71511d61b312f219; });
function $93f23ebd967272a8$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

});



parcelRegister("1wEEe", function(module, exports) {

$parcel$export(module.exports, "Simulate", function () { return $11c84f73d5981f85$export$a76a93d286570b3f; }, function (v) { return $11c84f73d5981f85$export$a76a93d286570b3f = v; });
$parcel$export(module.exports, "act", function () { return $11c84f73d5981f85$export$3ba232387fd5d6dd; }, function (v) { return $11c84f73d5981f85$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "findAllInRenderedTree", function () { return $11c84f73d5981f85$export$91e0e8d08413776c; }, function (v) { return $11c84f73d5981f85$export$91e0e8d08413776c = v; });
$parcel$export(module.exports, "findRenderedComponentWithType", function () { return $11c84f73d5981f85$export$cf85b0be788695f8; }, function (v) { return $11c84f73d5981f85$export$cf85b0be788695f8 = v; });
$parcel$export(module.exports, "findRenderedDOMComponentWithClass", function () { return $11c84f73d5981f85$export$95ce796e51d8db95; }, function (v) { return $11c84f73d5981f85$export$95ce796e51d8db95 = v; });
$parcel$export(module.exports, "findRenderedDOMComponentWithTag", function () { return $11c84f73d5981f85$export$ee3d4b88e6173a65; }, function (v) { return $11c84f73d5981f85$export$ee3d4b88e6173a65 = v; });
$parcel$export(module.exports, "isCompositeComponent", function () { return $11c84f73d5981f85$export$c88f2f08463dd6bf; }, function (v) { return $11c84f73d5981f85$export$c88f2f08463dd6bf = v; });
$parcel$export(module.exports, "isCompositeComponentWithType", function () { return $11c84f73d5981f85$export$fd62be247c9bdd2b; }, function (v) { return $11c84f73d5981f85$export$fd62be247c9bdd2b = v; });
$parcel$export(module.exports, "isDOMComponent", function () { return $11c84f73d5981f85$export$96547d165663a1ca; }, function (v) { return $11c84f73d5981f85$export$96547d165663a1ca = v; });
$parcel$export(module.exports, "isDOMComponentElement", function () { return $11c84f73d5981f85$export$14ef3c3df313310; }, function (v) { return $11c84f73d5981f85$export$14ef3c3df313310 = v; });
$parcel$export(module.exports, "isElement", function () { return $11c84f73d5981f85$export$45a5e7f76e0caa8d; }, function (v) { return $11c84f73d5981f85$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isElementOfType", function () { return $11c84f73d5981f85$export$8bb8d43ade7732d8; }, function (v) { return $11c84f73d5981f85$export$8bb8d43ade7732d8 = v; });
$parcel$export(module.exports, "mockComponent", function () { return $11c84f73d5981f85$export$f8697c8b7baa2bfc; }, function (v) { return $11c84f73d5981f85$export$f8697c8b7baa2bfc = v; });
$parcel$export(module.exports, "nativeTouchData", function () { return $11c84f73d5981f85$export$b76785168912a905; }, function (v) { return $11c84f73d5981f85$export$b76785168912a905 = v; });
$parcel$export(module.exports, "renderIntoDocument", function () { return $11c84f73d5981f85$export$e55763efe7217a7a; }, function (v) { return $11c84f73d5981f85$export$e55763efe7217a7a = v; });
$parcel$export(module.exports, "scryRenderedComponentsWithType", function () { return $11c84f73d5981f85$export$15ff870166444cd6; }, function (v) { return $11c84f73d5981f85$export$15ff870166444cd6 = v; });
$parcel$export(module.exports, "scryRenderedDOMComponentsWithClass", function () { return $11c84f73d5981f85$export$f1ce45e7b8222307; }, function (v) { return $11c84f73d5981f85$export$f1ce45e7b8222307 = v; });
$parcel$export(module.exports, "scryRenderedDOMComponentsWithTag", function () { return $11c84f73d5981f85$export$5b075b6b7d185915; }, function (v) { return $11c84f73d5981f85$export$5b075b6b7d185915 = v; });
$parcel$export(module.exports, "traverseTwoPhase", function () { return $11c84f73d5981f85$export$777ad1827b56d83e; }, function (v) { return $11c84f73d5981f85$export$777ad1827b56d83e = v; });
/**
 * @license React
 * react-dom-test-utils.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $11c84f73d5981f85$export$a76a93d286570b3f;
var $11c84f73d5981f85$export$3ba232387fd5d6dd;
var $11c84f73d5981f85$export$91e0e8d08413776c;
var $11c84f73d5981f85$export$cf85b0be788695f8;
var $11c84f73d5981f85$export$95ce796e51d8db95;
var $11c84f73d5981f85$export$ee3d4b88e6173a65;
var $11c84f73d5981f85$export$c88f2f08463dd6bf;
var $11c84f73d5981f85$export$fd62be247c9bdd2b;
var $11c84f73d5981f85$export$96547d165663a1ca;
var $11c84f73d5981f85$export$14ef3c3df313310;
var $11c84f73d5981f85$export$45a5e7f76e0caa8d;
var $11c84f73d5981f85$export$8bb8d43ade7732d8;
var $11c84f73d5981f85$export$f8697c8b7baa2bfc;
var $11c84f73d5981f85$export$b76785168912a905;
var $11c84f73d5981f85$export$e55763efe7217a7a;
var $11c84f73d5981f85$export$15ff870166444cd6;
var $11c84f73d5981f85$export$f1ce45e7b8222307;
var $11c84f73d5981f85$export$5b075b6b7d185915;
var $11c84f73d5981f85$export$777ad1827b56d83e;
'use strict';

var $fIwXP = parcelRequire("fIwXP");

var $9F3H4 = parcelRequire("9F3H4");
function $11c84f73d5981f85$var$m(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $11c84f73d5981f85$var$n(a) {
    if ($11c84f73d5981f85$var$m(a) !== a) throw Error("Unable to find node on an unmounted component.");
}
function $11c84f73d5981f85$var$p(a) {
    var b = a.alternate;
    if (!b) {
        b = $11c84f73d5981f85$var$m(a);
        if (null === b) throw Error("Unable to find node on an unmounted component.");
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var f = c.return;
        if (null === f) break;
        var g = f.alternate;
        if (null === g) {
            d = f.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (f.child === g.child) {
            for(g = f.child; g;){
                if (g === c) return $11c84f73d5981f85$var$n(f), a;
                if (g === d) return $11c84f73d5981f85$var$n(f), b;
                g = g.sibling;
            }
            throw Error("Unable to find node on an unmounted component.");
        }
        if (c.return !== d.return) c = f, d = g;
        else {
            for(var e = !1, h = f.child; h;){
                if (h === c) {
                    e = !0;
                    c = f;
                    d = g;
                    break;
                }
                if (h === d) {
                    e = !0;
                    d = f;
                    c = g;
                    break;
                }
                h = h.sibling;
            }
            if (!e) {
                for(h = g.child; h;){
                    if (h === c) {
                        e = !0;
                        c = g;
                        d = f;
                        break;
                    }
                    if (h === d) {
                        e = !0;
                        d = g;
                        c = f;
                        break;
                    }
                    h = h.sibling;
                }
                if (!e) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
            }
        }
        if (c.alternate !== d) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
    }
    if (3 !== c.tag) throw Error("Unable to find node on an unmounted component.");
    return c.stateNode.current === c ? a : b;
}
var $11c84f73d5981f85$var$q = Object.assign;
function $11c84f73d5981f85$var$r(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $11c84f73d5981f85$var$t() {
    return !0;
}
function $11c84f73d5981f85$var$u() {
    return !1;
}
function $11c84f73d5981f85$var$v(a) {
    function b(c, b, f, g, e) {
        this._reactName = c;
        this._targetInst = f;
        this.type = b;
        this.nativeEvent = g;
        this.target = e;
        this.currentTarget = null;
        for(var d in a)a.hasOwnProperty(d) && (c = a[d], this[d] = c ? c(g) : g[d]);
        this.isDefaultPrevented = (null != g.defaultPrevented ? g.defaultPrevented : !1 === g.returnValue) ? $11c84f73d5981f85$var$t : $11c84f73d5981f85$var$u;
        this.isPropagationStopped = $11c84f73d5981f85$var$u;
        return this;
    }
    $11c84f73d5981f85$var$q(b.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== (0, $YtE9h._)(a.returnValue) && (a.returnValue = !1), this.isDefaultPrevented = $11c84f73d5981f85$var$t);
        },
        stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== (0, $YtE9h._)(a.cancelBubble) && (a.cancelBubble = !0), this.isPropagationStopped = $11c84f73d5981f85$var$t);
        },
        persist: function persist() {},
        isPersistent: $11c84f73d5981f85$var$t
    });
    return b;
}
var $11c84f73d5981f85$var$w = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $11c84f73d5981f85$var$x = $11c84f73d5981f85$var$v($11c84f73d5981f85$var$w), $11c84f73d5981f85$var$y = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$w, {
    view: 0,
    detail: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$y);
var $11c84f73d5981f85$var$z, $11c84f73d5981f85$var$A, $11c84f73d5981f85$var$B, $11c84f73d5981f85$var$D = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$y, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $11c84f73d5981f85$var$C,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function movementX(a) {
        if ("movementX" in a) return a.movementX;
        a !== $11c84f73d5981f85$var$B && ($11c84f73d5981f85$var$B && "mousemove" === a.type ? ($11c84f73d5981f85$var$z = a.screenX - $11c84f73d5981f85$var$B.screenX, $11c84f73d5981f85$var$A = a.screenY - $11c84f73d5981f85$var$B.screenY) : $11c84f73d5981f85$var$A = $11c84f73d5981f85$var$z = 0, $11c84f73d5981f85$var$B = a);
        return $11c84f73d5981f85$var$z;
    },
    movementY: function movementY(a) {
        return "movementY" in a ? a.movementY : $11c84f73d5981f85$var$A;
    }
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$D);
var $11c84f73d5981f85$var$E = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$D, {
    dataTransfer: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$E);
var $11c84f73d5981f85$var$F = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$y, {
    relatedTarget: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$F);
var $11c84f73d5981f85$var$aa = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$w, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$aa);
var $11c84f73d5981f85$var$ba = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$w, {
    clipboardData: function clipboardData(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$ba);
var $11c84f73d5981f85$var$ca = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$w, {
    data: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$ca);
var $11c84f73d5981f85$var$da = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $11c84f73d5981f85$var$ea = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $11c84f73d5981f85$var$fa = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $11c84f73d5981f85$var$ha(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $11c84f73d5981f85$var$fa[a]) ? !!b[a] : !1;
}
function $11c84f73d5981f85$var$C() {
    return $11c84f73d5981f85$var$ha;
}
var $11c84f73d5981f85$var$ia = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$y, {
    key: function key(a) {
        if (a.key) {
            var b = $11c84f73d5981f85$var$da[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $11c84f73d5981f85$var$r(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $11c84f73d5981f85$var$ea[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $11c84f73d5981f85$var$C,
    charCode: function charCode(a) {
        return "keypress" === a.type ? $11c84f73d5981f85$var$r(a) : 0;
    },
    keyCode: function keyCode(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function which(a) {
        return "keypress" === a.type ? $11c84f73d5981f85$var$r(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$ia);
var $11c84f73d5981f85$var$ja = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$D, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$ja);
var $11c84f73d5981f85$var$ka = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$y, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $11c84f73d5981f85$var$C
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$ka);
var $11c84f73d5981f85$var$la = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$w, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$la);
var $11c84f73d5981f85$var$ma = $11c84f73d5981f85$var$q({}, $11c84f73d5981f85$var$D, {
    deltaX: function deltaX(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function deltaY(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
});
$11c84f73d5981f85$var$v($11c84f73d5981f85$var$ma);
function $11c84f73d5981f85$var$na(a, b, c, d, f, g, e, h, N) {
    var G = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, G);
    } catch (oa) {
        this.onError(oa);
    }
}
var $11c84f73d5981f85$var$H = !1, $11c84f73d5981f85$var$I = null, $11c84f73d5981f85$var$J = !1, $11c84f73d5981f85$var$K = null, $11c84f73d5981f85$var$pa = {
    onError: function onError(a) {
        $11c84f73d5981f85$var$H = !0;
        $11c84f73d5981f85$var$I = a;
    }
};
function $11c84f73d5981f85$var$qa(a, b, c, d, f, g, e, h, N) {
    $11c84f73d5981f85$var$H = !1;
    $11c84f73d5981f85$var$I = null;
    $11c84f73d5981f85$var$na.apply($11c84f73d5981f85$var$pa, arguments);
}
function $11c84f73d5981f85$var$ra(a, b, c, d, f, g, e, h, N) {
    $11c84f73d5981f85$var$qa.apply(this, arguments);
    if ($11c84f73d5981f85$var$H) {
        if ($11c84f73d5981f85$var$H) {
            var G = $11c84f73d5981f85$var$I;
            $11c84f73d5981f85$var$H = !1;
            $11c84f73d5981f85$var$I = null;
        } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
        $11c84f73d5981f85$var$J || ($11c84f73d5981f85$var$J = !0, $11c84f73d5981f85$var$K = G);
    }
}
var $11c84f73d5981f85$var$L = Array.isArray, $11c84f73d5981f85$var$M = $9F3H4.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events, $11c84f73d5981f85$var$sa = $11c84f73d5981f85$var$M[0], $11c84f73d5981f85$var$ta = $11c84f73d5981f85$var$M[1], $11c84f73d5981f85$var$ua = $11c84f73d5981f85$var$M[2], $11c84f73d5981f85$var$va = $11c84f73d5981f85$var$M[3], $11c84f73d5981f85$var$wa = $11c84f73d5981f85$var$M[4], $11c84f73d5981f85$var$xa = $fIwXP.unstable_act;
function $11c84f73d5981f85$var$ya() {}
function $11c84f73d5981f85$var$za(a, b) {
    if (!a) return [];
    a = $11c84f73d5981f85$var$p(a);
    if (!a) return [];
    for(var c = a, d = [];;){
        if (5 === c.tag || 6 === c.tag || 1 === c.tag || 0 === c.tag) {
            var f = c.stateNode;
            b(f) && d.push(f);
        }
        if (c.child) c.child.return = c, c = c.child;
        else {
            if (c === a) return d;
            for(; !c.sibling;){
                if (!c.return || c.return === a) return d;
                c = c.return;
            }
            c.sibling.return = c.return;
            c = c.sibling;
        }
    }
}
function $11c84f73d5981f85$var$O(a, b) {
    if (a && !a._reactInternals) {
        var c = String(a);
        a = $11c84f73d5981f85$var$L(a) ? "an array" : a && 1 === a.nodeType && a.tagName ? "a DOM node" : "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c;
        throw Error(b + "(...): the first argument must be a React class instance. Instead received: " + (a + "."));
    }
}
function $11c84f73d5981f85$var$P(a) {
    return !(!a || 1 !== a.nodeType || !a.tagName);
}
function $11c84f73d5981f85$var$Q(a) {
    return $11c84f73d5981f85$var$P(a) ? !1 : null != a && "function" === typeof a.render && "function" === typeof a.setState;
}
function $11c84f73d5981f85$var$R(a, b) {
    return $11c84f73d5981f85$var$Q(a) ? a._reactInternals.type === b : !1;
}
function $11c84f73d5981f85$var$S(a, b) {
    $11c84f73d5981f85$var$O(a, "findAllInRenderedTree");
    return a ? $11c84f73d5981f85$var$za(a._reactInternals, b) : [];
}
function $11c84f73d5981f85$var$T(a, b) {
    $11c84f73d5981f85$var$O(a, "scryRenderedDOMComponentsWithClass");
    return $11c84f73d5981f85$var$S(a, function(a) {
        if ($11c84f73d5981f85$var$P(a)) {
            var c = a.className;
            "string" !== typeof c && (c = a.getAttribute("class") || "");
            var f = c.split(/\s+/);
            if (!$11c84f73d5981f85$var$L(b)) {
                if (void 0 === b) throw Error("TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.");
                b = b.split(/\s+/);
            }
            return b.every(function(a) {
                return -1 !== f.indexOf(a);
            });
        }
        return !1;
    });
}
function $11c84f73d5981f85$var$U(a, b) {
    $11c84f73d5981f85$var$O(a, "scryRenderedDOMComponentsWithTag");
    return $11c84f73d5981f85$var$S(a, function(a) {
        return $11c84f73d5981f85$var$P(a) && a.tagName.toUpperCase() === b.toUpperCase();
    });
}
function $11c84f73d5981f85$var$V(a, b) {
    $11c84f73d5981f85$var$O(a, "scryRenderedComponentsWithType");
    return $11c84f73d5981f85$var$S(a, function(a) {
        return $11c84f73d5981f85$var$R(a, b);
    });
}
function $11c84f73d5981f85$var$W(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = $11c84f73d5981f85$var$ta(c);
    $11c84f73d5981f85$var$ra(d, b, void 0, a);
    a.currentTarget = null;
}
function $11c84f73d5981f85$var$X(a, b, c) {
    for(var d = []; a;){
        d.push(a);
        do a = a.return;
        while (a && 5 !== a.tag);
        a = a ? a : null;
    }
    for(a = d.length; 0 < a--;)b(d[a], "captured", c);
    for(a = 0; a < d.length; a++)b(d[a], "bubbled", c);
}
function $11c84f73d5981f85$var$Y(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = $11c84f73d5981f85$var$ua(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error("Expected `" + b + "` listener to be a function, instead got a value of `" + (typeof c === "undefined" ? "undefined" : (0, $YtE9h._)(c)) + "` type.");
    return c;
}
function $11c84f73d5981f85$var$Aa(a, b, c) {
    a && c && c._reactName && (b = $11c84f73d5981f85$var$Y(a, c._reactName)) && (null == c._dispatchListeners && (c._dispatchListeners = []), null == c._dispatchInstances && (c._dispatchInstances = []), c._dispatchListeners.push(b), c._dispatchInstances.push(a));
}
function $11c84f73d5981f85$var$Ba(a, b, c) {
    var d = c._reactName;
    "captured" === b && (d += "Capture");
    if (b = $11c84f73d5981f85$var$Y(a, d)) null == c._dispatchListeners && (c._dispatchListeners = []), null == c._dispatchInstances && (c._dispatchInstances = []), c._dispatchListeners.push(b), c._dispatchInstances.push(a);
}
var $11c84f73d5981f85$var$Z = {}, $11c84f73d5981f85$var$Ca = new Set([
    "mouseEnter",
    "mouseLeave",
    "pointerEnter",
    "pointerLeave"
]);
function $11c84f73d5981f85$var$Da(a) {
    return function(b, c) {
        if ($fIwXP.isValidElement(b)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a React element. Pass the DOM node you wish to simulate the event on instead. Note that TestUtils.Simulate will not work if you are using shallow rendering.");
        if ($11c84f73d5981f85$var$Q(b)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a component instance. Pass the DOM node you wish to simulate the event on instead.");
        var d = "on" + a[0].toUpperCase() + a.slice(1), f = new $11c84f73d5981f85$var$ya;
        f.target = b;
        f.type = a.toLowerCase();
        var g = $11c84f73d5981f85$var$sa(b), e = new $11c84f73d5981f85$var$x(d, f.type, g, f, b);
        e.persist();
        $11c84f73d5981f85$var$q(e, c);
        $11c84f73d5981f85$var$Ca.has(a) ? e && e._reactName && $11c84f73d5981f85$var$Aa(e._targetInst, null, e) : e && e._reactName && $11c84f73d5981f85$var$X(e._targetInst, $11c84f73d5981f85$var$Ba, e);
        $9F3H4.unstable_batchedUpdates(function() {
            $11c84f73d5981f85$var$va(b);
            if (e) {
                var _$a = e._dispatchListeners, _$c = e._dispatchInstances;
                if ($11c84f73d5981f85$var$L(_$a)) for(var d = 0; d < _$a.length && !e.isPropagationStopped(); d++)$11c84f73d5981f85$var$W(e, _$a[d], _$c[d]);
                else _$a && $11c84f73d5981f85$var$W(e, _$a, _$c);
                e._dispatchListeners = null;
                e._dispatchInstances = null;
                e.isPersistent() || e.constructor.release(e);
            }
            if ($11c84f73d5981f85$var$J) throw _$a = $11c84f73d5981f85$var$K, $11c84f73d5981f85$var$J = !1, $11c84f73d5981f85$var$K = null, _$a;
        });
        $11c84f73d5981f85$var$wa();
    };
}
"blur cancel click close contextMenu copy cut auxClick doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play pointerCancel pointerDown pointerUp rateChange reset resize seeked submit touchCancel touchEnd touchStart volumeChange drag dragEnter dragExit dragLeave dragOver mouseMove mouseOut mouseOver pointerMove pointerOut pointerOver scroll toggle touchMove wheel abort animationEnd animationIteration animationStart canPlay canPlayThrough durationChange emptied encrypted ended error gotPointerCapture load loadedData loadedMetadata loadStart lostPointerCapture playing progress seeking stalled suspend timeUpdate transitionEnd waiting mouseEnter mouseLeave pointerEnter pointerLeave change select beforeInput compositionEnd compositionStart compositionUpdate".split(" ").forEach(function(a) {
    $11c84f73d5981f85$var$Z[a] = $11c84f73d5981f85$var$Da(a);
});
$11c84f73d5981f85$export$a76a93d286570b3f = $11c84f73d5981f85$var$Z;
$11c84f73d5981f85$export$3ba232387fd5d6dd = $11c84f73d5981f85$var$xa;
$11c84f73d5981f85$export$91e0e8d08413776c = $11c84f73d5981f85$var$S;
$11c84f73d5981f85$export$cf85b0be788695f8 = function(a, b) {
    $11c84f73d5981f85$var$O(a, "findRenderedComponentWithType");
    a = $11c84f73d5981f85$var$V(a, b);
    if (1 !== a.length) throw Error("Did not find exactly one match (found: " + a.length + ") for componentType:" + b);
    return a[0];
};
$11c84f73d5981f85$export$95ce796e51d8db95 = function(a, b) {
    $11c84f73d5981f85$var$O(a, "findRenderedDOMComponentWithClass");
    a = $11c84f73d5981f85$var$T(a, b);
    if (1 !== a.length) throw Error("Did not find exactly one match (found: " + a.length + ") for class:" + b);
    return a[0];
};
$11c84f73d5981f85$export$ee3d4b88e6173a65 = function(a, b) {
    $11c84f73d5981f85$var$O(a, "findRenderedDOMComponentWithTag");
    a = $11c84f73d5981f85$var$U(a, b);
    if (1 !== a.length) throw Error("Did not find exactly one match (found: " + a.length + ") for tag:" + b);
    return a[0];
};
$11c84f73d5981f85$export$c88f2f08463dd6bf = $11c84f73d5981f85$var$Q;
$11c84f73d5981f85$export$fd62be247c9bdd2b = $11c84f73d5981f85$var$R;
$11c84f73d5981f85$export$96547d165663a1ca = $11c84f73d5981f85$var$P;
$11c84f73d5981f85$export$14ef3c3df313310 = function(a) {
    return !!(a && $fIwXP.isValidElement(a) && a.tagName);
};
$11c84f73d5981f85$export$45a5e7f76e0caa8d = function(a) {
    return $fIwXP.isValidElement(a);
};
$11c84f73d5981f85$export$8bb8d43ade7732d8 = function(a, b) {
    return $fIwXP.isValidElement(a) && a.type === b;
};
$11c84f73d5981f85$export$f8697c8b7baa2bfc = function(a, b) {
    b = b || a.mockTagName || "div";
    a.prototype.render.mockImplementation(function() {
        return $fIwXP.createElement(b, null, this.props.children);
    });
    return this;
};
$11c84f73d5981f85$export$b76785168912a905 = function(a, b) {
    return {
        touches: [
            {
                pageX: a,
                pageY: b
            }
        ]
    };
};
$11c84f73d5981f85$export$e55763efe7217a7a = function(a) {
    var b = document.createElement("div");
    return $9F3H4.render(a, b);
};
$11c84f73d5981f85$export$15ff870166444cd6 = $11c84f73d5981f85$var$V;
$11c84f73d5981f85$export$f1ce45e7b8222307 = $11c84f73d5981f85$var$T;
$11c84f73d5981f85$export$5b075b6b7d185915 = $11c84f73d5981f85$var$U;
$11c84f73d5981f85$export$777ad1827b56d83e = $11c84f73d5981f85$var$X;

});
parcelRegister("9F3H4", function(module, exports) {
'use strict';
function $708acee34f03ee3d$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($708acee34f03ee3d$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$708acee34f03ee3d$var$checkDCE();

module.exports = (parcelRequire("fsZ8I"));

});


parcelRegister("9EFo8", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return getConfig; });
$parcel$export(module.exports, "prettyDOM", function () { return prettyDOM; });
$parcel$export(module.exports, "configure", function () { return configure; });
$parcel$export(module.exports, "getQueriesForElement", function () { return getQueriesForElement; });
$parcel$export(module.exports, "fireEvent", function () { return fireEvent; });

var $7k5I8 = parcelRequire("7k5I8");

var $hD5pT = parcelRequire("hD5pT");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $1dxAe = parcelRequire("1dxAe");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $lFlDF = parcelRequire("lFlDF");

var $liMsA = parcelRequire("liMsA");
parcelRequire("dP2oG");
var $9WNlU = parcelRequire("9WNlU");
var $lX55U = parcelRequire("lX55U");

var $54Ttj = parcelRequire("54Ttj");

var $3szAT = parcelRequire("3szAT");

var $ibRPI = parcelRequire("ibRPI");
/**
 * Source: https://github.com/facebook/jest/blob/e7bb6a1e26ffab90611b2593912df15b69315611/packages/pretty-format/src/plugins/DOMElement.ts
 */ /* eslint-disable -- trying to stay as close to the original as possible */ /* istanbul ignore file */ function escapeHTML(str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
// Return empty string if keys is empty.
var printProps = function(keys, props, config, indentation, depth, refs, printer) {
    var indentationNext = indentation + config.indent;
    var colors = config.colors;
    return keys.map(function(key) {
        var value = props[key];
        var printed = printer(value, config, indentationNext, depth, refs);
        if (typeof value !== 'string') {
            if (printed.indexOf('\n') !== -1) printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
            printed = '{' + printed + '}';
        }
        return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
    }).join('');
};
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
var NodeTypeTextNode = 3;
// Return empty string if children is empty.
var printChildren = function(children, config, indentation, depth, refs, printer) {
    return children.map(function(child) {
        var printedChild = typeof child === 'string' ? printText(child, config) : printer(child, config, indentation, depth, refs);
        if (printedChild === '' && (typeof child === "undefined" ? "undefined" : (0, $YtE9h._)(child)) === 'object' && child !== null && child.nodeType !== NodeTypeTextNode) // A plugin serialized this Node to '' meaning we should ignore it.
        return '';
        return config.spacingOuter + indentation + printedChild;
    }).join('');
};
var printText = function(text, config) {
    var contentColor = config.colors.content;
    return contentColor.open + escapeHTML(text) + contentColor.close;
};
var printComment = function(comment, config) {
    var commentColor = config.colors.comment;
    return commentColor.open + '<!--' + escapeHTML(comment) + '-->' + commentColor.close;
};
// Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.
var printElement = function(type, printedProps, printedChildren, config, indentation) {
    var tagColor = config.colors.tag;
    return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
};
var printElementAsLeaf = function(type, config) {
    var tagColor = config.colors.tag;
    return tagColor.open + '<' + type + tagColor.close + " \u2026" + tagColor.open + ' />' + tagColor.close;
};
var ELEMENT_NODE$1 = 1;
var TEXT_NODE$1 = 3;
var COMMENT_NODE$1 = 8;
var FRAGMENT_NODE = 11;
var ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
var isCustomElement = function(val) {
    var tagName = val.tagName;
    return Boolean(typeof tagName === 'string' && tagName.includes('-') || typeof val.hasAttribute === 'function' && val.hasAttribute('is'));
};
var testNode = function(val) {
    var constructorName = val.constructor.name;
    var nodeType = val.nodeType;
    return nodeType === ELEMENT_NODE$1 && (ELEMENT_REGEXP.test(constructorName) || isCustomElement(val)) || nodeType === TEXT_NODE$1 && constructorName === 'Text' || nodeType === COMMENT_NODE$1 && constructorName === 'Comment' || nodeType === FRAGMENT_NODE && constructorName === 'DocumentFragment';
};
function nodeIsText(node) {
    return node.nodeType === TEXT_NODE$1;
}
function nodeIsComment(node) {
    return node.nodeType === COMMENT_NODE$1;
}
function nodeIsFragment(node) {
    return node.nodeType === FRAGMENT_NODE;
}
function createDOMElementFilter(filterNode) {
    return {
        test: function(val) {
            var _val$constructor2;
            return ((val == null || (_val$constructor2 = val.constructor) == null ? void 0 : _val$constructor2.name) || isCustomElement(val)) && testNode(val);
        },
        serialize: function(node, config, indentation, depth, refs, printer) {
            if (nodeIsText(node)) return printText(node.data, config);
            if (nodeIsComment(node)) return printComment(node.data, config);
            var type = nodeIsFragment(node) ? "DocumentFragment" : node.tagName.toLowerCase();
            if (++depth > config.maxDepth) return printElementAsLeaf(type, config);
            return printElement(type, printProps(nodeIsFragment(node) ? [] : Array.from(node.attributes).map(function(attr) {
                return attr.name;
            }).sort(), nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce(function(props, attribute) {
                props[attribute.name] = attribute.value;
                return props;
            }, {}), config, indentation + config.indent, depth, refs, printer), printChildren(Array.prototype.slice.call(node.childNodes || node.children).filter(filterNode), config, indentation + config.indent, depth, refs, printer), config, indentation);
        }
    };
}
// We try to load node dependencies
var chalk = null;
var readFileSync = null;
var codeFrameColumns = null;
try {
    var nodeRequire = module && module.require;
    readFileSync = nodeRequire.call(module, 'fs').readFileSync;
    codeFrameColumns = nodeRequire.call(module, '@babel/code-frame').codeFrameColumns;
    chalk = nodeRequire.call(module, 'chalk');
} catch (e) {
// We're in a browser environment
}
// frame has the form "at myMethod (location/to/my/file.js:10:2)"
function getCodeFrame(frame) {
    var locationStart = frame.indexOf('(') + 1;
    var locationEnd = frame.indexOf(')');
    var frameLocation = frame.slice(locationStart, locationEnd);
    var frameLocationElements = frameLocation.split(':');
    var _ref = [
        frameLocationElements[0],
        parseInt(frameLocationElements[1], 10),
        parseInt(frameLocationElements[2], 10)
    ], filename = _ref[0], line = _ref[1], column = _ref[2];
    var rawFileContents = '';
    try {
        rawFileContents = readFileSync(filename, 'utf-8');
    } catch (e) {
        return '';
    }
    var codeFrame = codeFrameColumns(rawFileContents, {
        start: {
            line: line,
            column: column
        }
    }, {
        highlightCode: true,
        linesBelow: 0
    });
    return chalk.dim(frameLocation) + "\n" + codeFrame + "\n";
}
function getUserCodeFrame() {
    // If we couldn't load dependencies, we can't generate the user trace
    /* istanbul ignore next */ if (!readFileSync || !codeFrameColumns) return '';
    var err = new Error();
    var firstClientCodeFrame = err.stack.split('\n').slice(1) // Remove first line which has the form "Error: TypeError"
    .find(function(frame) {
        return !frame.includes('node_modules/');
    }); // Ignore frames from 3rd party libraries
    return getCodeFrame(firstClientCodeFrame);
}
// Constant node.nodeType for text nodes, see:
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#Node_type_constants
var TEXT_NODE = 3;
function jestFakeTimersAreEnabled() {
    /* istanbul ignore else */ // eslint-disable-next-line
    if (typeof jest !== 'undefined' && jest !== null) return(// legacy timers
    setTimeout._isMockFunction === true || // modern timers
    // eslint-disable-next-line prefer-object-has-own -- not supported by our support matrix
    Object.prototype.hasOwnProperty.call(setTimeout, 'clock'));
    // istanbul ignore next
    return false;
}
function getDocument() {
    /* istanbul ignore if */ if (typeof window === 'undefined') throw new Error('Could not find default container');
    return window.document;
}
function getWindowFromNode(node) {
    if (node.defaultView) // node is document
    return node.defaultView;
    else if (node.ownerDocument && node.ownerDocument.defaultView) // node is a DOM node
    return node.ownerDocument.defaultView;
    else if (node.window) // node is window
    return node.window;
    else if (node.ownerDocument && node.ownerDocument.defaultView === null) throw new Error("It looks like the window object is not available for the provided node.");
    else if (node.then instanceof Function) throw new Error("It looks like you passed a Promise object instead of a DOM node. Did you do something like `fireEvent.click(screen.findBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`, or await the findBy query `fireEvent.click(await screen.findBy...`?");
    else if (Array.isArray(node)) throw new Error("It looks like you passed an Array instead of a DOM node. Did you do something like `fireEvent.click(screen.getAllBy...` when you meant to use a `getBy` query `fireEvent.click(screen.getBy...`?");
    else if (typeof node.debug === 'function' && typeof node.logTestingPlaygroundURL === 'function') throw new Error("It looks like you passed a `screen` object. Did you do something like `fireEvent.click(screen, ...` when you meant to use a query, e.g. `fireEvent.click(screen.getBy..., `?");
    else // The user passed something unusual to a calling function
    throw new Error("The given node is not an Element, the node type is: " + (typeof node === "undefined" ? "undefined" : (0, $YtE9h._)(node)) + ".");
}
function checkContainerType(container) {
    if (!container || !(typeof container.querySelector === 'function') || !(typeof container.querySelectorAll === 'function')) throw new TypeError("Expected container to be an Element, a Document or a DocumentFragment but got " + getTypeName(container) + ".");
    function getTypeName(object) {
        if ((typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) === 'object') return object === null ? 'null' : object.constructor.name;
        return typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object);
    }
}
var shouldHighlight = function() {
    var colors;
    try {
        var _process;
        colors = JSON.parse((_process = $ibRPI) == null || (_process = _process.env) == null ? void 0 : _process.COLORS);
    } catch (e) {
    // If this throws, process?.env?.COLORS wasn't parsable. Since we only
    // care about `true` or `false`, we can safely ignore the error.
    }
    if (typeof colors === 'boolean') // If `colors` is set explicitly (both `true` and `false`), use that value.
    return colors;
    else // If `colors` is not set, colorize if we're in node.
    return typeof $ibRPI !== 'undefined' && $ibRPI.versions !== undefined && $ibRPI.versions.node !== undefined;
};
var DOMCollection = $liMsA.plugins.DOMCollection;
// https://developer.mozilla.org/en-US/docs/Web/API/Node/nodeType#node_type_constants
var ELEMENT_NODE = 1;
var COMMENT_NODE = 8;
// https://github.com/facebook/jest/blob/615084195ae1ae61ddd56162c62bbdda17587569/packages/pretty-format/src/plugins/DOMElement.ts#L50
function filterCommentsAndDefaultIgnoreTagsTags(value) {
    return value.nodeType !== COMMENT_NODE && (value.nodeType !== ELEMENT_NODE || !value.matches(getConfig().defaultIgnore));
}
function prettyDOM(dom, maxLength, options) {
    if (options === void 0) options = {};
    if (!dom) dom = getDocument().body;
    if (typeof maxLength !== 'number') maxLength = (typeof $ibRPI !== 'undefined' && typeof $ibRPI.env !== 'undefined' && undefined, 7000);
    if (maxLength === 0) return '';
    if (dom.documentElement) dom = dom.documentElement;
    var domTypeName = typeof dom === "undefined" ? "undefined" : (0, $YtE9h._)(dom);
    if (domTypeName === 'object') domTypeName = dom.constructor.name;
    else // To don't fall with `in` operator
    dom = {};
    if (!('outerHTML' in dom)) throw new TypeError("Expected an element or document but got " + domTypeName);
    var _options_filterNode = options.filterNode, filterNode = _options_filterNode === void 0 ? filterCommentsAndDefaultIgnoreTagsTags : _options_filterNode, prettyFormatOptions = (0, $1dxAe._)(options, [
        "filterNode"
    ]);
    var debugContent = $liMsA.format(dom, (0, $eRslx._)({
        plugins: [
            createDOMElementFilter(filterNode),
            DOMCollection
        ],
        printFunctionName: false,
        highlight: shouldHighlight()
    }, prettyFormatOptions));
    return maxLength !== undefined && dom.outerHTML.length > maxLength ? debugContent.slice(0, maxLength) + "..." : debugContent;
}
var logDOM = function logDOM() {
    var userCodeFrame = getUserCodeFrame();
    if (userCodeFrame) console.log(prettyDOM.apply(void 0, arguments) + "\n\n" + userCodeFrame);
    else console.log(prettyDOM.apply(void 0, arguments));
};
// It would be cleaner for this to live inside './queries', but
// other parts of the code assume that all exports from
// './queries' are query functions.
var config = {
    testIdAttribute: 'data-testid',
    asyncUtilTimeout: 1000,
    // asyncWrapper and advanceTimersWrapper is to support React's async `act` function.
    // forcing react-testing-library to wrap all async functions would've been
    // a total nightmare (consider wrapping every findBy* query and then also
    // updating `within` so those would be wrapped too. Total nightmare).
    // so we have this config option that's really only intended for
    // react-testing-library to use. For that reason, this feature will remain
    // undocumented.
    asyncWrapper: function(cb) {
        return cb();
    },
    unstable_advanceTimersWrapper: function(cb) {
        return cb();
    },
    eventWrapper: function(cb) {
        return cb();
    },
    // default value for the `hidden` option in `ByRole` queries
    defaultHidden: false,
    // default value for the `ignore` option in `ByText` queries
    defaultIgnore: 'script, style',
    // showOriginalStackTrace flag to show the full error stack traces for async errors
    showOriginalStackTrace: false,
    // throw errors w/ suggestions for better queries. Opt in so off by default.
    throwSuggestions: false,
    // called when getBy* queries fail. (message, container) => Error
    getElementError: function(message, container) {
        var prettifiedDOM = prettyDOM(container);
        var error = new Error([
            message,
            "Ignored nodes: comments, " + config.defaultIgnore + "\n" + prettifiedDOM
        ].filter(Boolean).join('\n\n'));
        error.name = 'TestingLibraryElementError';
        return error;
    },
    _disableExpensiveErrorDiagnostics: false,
    computedStyleSupportsPseudoElements: false
};
function runWithExpensiveErrorDiagnosticsDisabled(callback) {
    try {
        config._disableExpensiveErrorDiagnostics = true;
        return callback();
    } finally{
        config._disableExpensiveErrorDiagnostics = false;
    }
}
function configure(newConfig) {
    if (typeof newConfig === 'function') // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig(config);
    // Merge the incoming config delta
    config = (0, $eRslx._)({}, config, newConfig);
}
function getConfig() {
    return config;
}
var labelledNodeNames = [
    'button',
    'meter',
    'output',
    'progress',
    'select',
    'textarea',
    'input'
];
function getTextContent(node) {
    if (labelledNodeNames.includes(node.nodeName.toLowerCase())) return '';
    if (node.nodeType === TEXT_NODE) return node.textContent;
    return Array.from(node.childNodes).map(function(childNode) {
        return getTextContent(childNode);
    }).join('');
}
function getLabelContent(element) {
    var textContent;
    if (element.tagName.toLowerCase() === 'label') textContent = getTextContent(element);
    else textContent = element.value || element.textContent;
    return textContent;
}
// Based on https://github.com/eps1lon/dom-accessibility-api/pull/352
function getRealLabels(element) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- types are not aware of older browsers that don't implement `labels`
    if (element.labels !== undefined) {
        var _labels;
        return (_labels = element.labels) != null ? _labels : [];
    }
    if (!isLabelable(element)) return [];
    var labels = element.ownerDocument.querySelectorAll('label');
    return Array.from(labels).filter(function(label) {
        return label.control === element;
    });
}
function isLabelable(element) {
    return /BUTTON|METER|OUTPUT|PROGRESS|SELECT|TEXTAREA/.test(element.tagName) || element.tagName === 'INPUT' && element.getAttribute('type') !== 'hidden';
}
function getLabels(container, element, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_selector = _ref.selector, selector = _ref_selector === void 0 ? '*' : _ref_selector;
    var ariaLabelledBy = element.getAttribute('aria-labelledby');
    var labelsId = ariaLabelledBy ? ariaLabelledBy.split(' ') : [];
    return labelsId.length ? labelsId.map(function(labelId) {
        var labellingElement = container.querySelector("[id=\"" + labelId + "\"]");
        return labellingElement ? {
            content: getLabelContent(labellingElement),
            formControl: null
        } : {
            content: '',
            formControl: null
        };
    }) : Array.from(getRealLabels(element)).map(function(label) {
        var textToMatch = getLabelContent(label);
        var formControlSelector = 'button, input, meter, output, progress, select, textarea';
        var labelledFormControl = Array.from(label.querySelectorAll(formControlSelector)).filter(function(formControlElement) {
            return formControlElement.matches(selector);
        })[0];
        return {
            content: textToMatch,
            formControl: labelledFormControl
        };
    });
}
function assertNotNullOrUndefined(matcher) {
    if (matcher === null || matcher === undefined) throw new Error("It looks like " + matcher + " was passed instead of a matcher. Did you do something like getByText(" + matcher + ")?");
}
function fuzzyMatches(textToMatch, node, matcher, normalizer) {
    if (typeof textToMatch !== 'string') return false;
    assertNotNullOrUndefined(matcher);
    var normalizedText = normalizer(textToMatch);
    if (typeof matcher === 'string' || typeof matcher === 'number') return normalizedText.toLowerCase().includes(matcher.toString().toLowerCase());
    else if (typeof matcher === 'function') return matcher(normalizedText, node);
    else return matchRegExp(matcher, normalizedText);
}
function matches(textToMatch, node, matcher, normalizer) {
    if (typeof textToMatch !== 'string') return false;
    assertNotNullOrUndefined(matcher);
    var normalizedText = normalizer(textToMatch);
    if (matcher instanceof Function) return matcher(normalizedText, node);
    else if (matcher instanceof RegExp) return matchRegExp(matcher, normalizedText);
    else return normalizedText === String(matcher);
}
function getDefaultNormalizer(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_trim = _ref.trim, trim = _ref_trim === void 0 ? true : _ref_trim, _ref_collapseWhitespace = _ref.collapseWhitespace, collapseWhitespace = _ref_collapseWhitespace === void 0 ? true : _ref_collapseWhitespace;
    return function(text) {
        var normalizedText = text;
        normalizedText = trim ? normalizedText.trim() : normalizedText;
        normalizedText = collapseWhitespace ? normalizedText.replace(/\s+/g, ' ') : normalizedText;
        return normalizedText;
    };
}
/**
 * Constructs a normalizer to pass to functions in matches.js
 * @param {boolean|undefined} trim The user-specified value for `trim`, without
 * any defaulting having been applied
 * @param {boolean|undefined} collapseWhitespace The user-specified value for
 * `collapseWhitespace`, without any defaulting having been applied
 * @param {Function|undefined} normalizer The user-specified normalizer
 * @returns {Function} A normalizer
 */ function makeNormalizer(_ref) {
    var trim = _ref.trim, collapseWhitespace = _ref.collapseWhitespace, normalizer = _ref.normalizer;
    if (!normalizer) // No custom normalizer specified. Just use default.
    return getDefaultNormalizer({
        trim: trim,
        collapseWhitespace: collapseWhitespace
    });
    if (typeof trim !== 'undefined' || typeof collapseWhitespace !== 'undefined') // They've also specified a value for trim or collapseWhitespace
    throw new Error('trim and collapseWhitespace are not supported with a normalizer. If you want to use the default trim and collapseWhitespace logic in your normalizer, use "getDefaultNormalizer({trim, collapseWhitespace})" and compose that into your normalizer');
    return normalizer;
}
function matchRegExp(matcher, text) {
    var match = matcher.test(text);
    if (matcher.global && matcher.lastIndex !== 0) {
        console.warn("To match all elements we had to reset the lastIndex of the RegExp because the global flag is enabled. We encourage to remove the global flag from the RegExp.");
        matcher.lastIndex = 0;
    }
    return match;
}
function getNodeText(node) {
    if (node.matches('input[type=submit], input[type=button], input[type=reset]')) return node.value;
    return Array.from(node.childNodes).filter(function(child) {
        return child.nodeType === TEXT_NODE && Boolean(child.textContent);
    }).map(function(c) {
        return c.textContent;
    }).join('');
}
var elementRoleList = buildElementRoleList((0, $54Ttj.elementRoles));
/**
 * @param {Element} element -
 * @returns {boolean} - `true` if `element` and its subtree are inaccessible
 */ function isSubtreeInaccessible(element) {
    if (element.hidden === true) return true;
    if (element.getAttribute('aria-hidden') === 'true') return true;
    var window1 = element.ownerDocument.defaultView;
    if (window1.getComputedStyle(element).display === 'none') return true;
    return false;
}
/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param {Element} element -
 * @param {object} [options] -
 * @param {function (element: Element): boolean} options.isSubtreeInaccessible -
 * can be used to return cached results from previous isSubtreeInaccessible calls
 * @returns {boolean} true if excluded, otherwise false
 */ function isInaccessible(element, options) {
    if (options === void 0) options = {};
    var tmp = options.isSubtreeInaccessible, isSubtreeInaccessibleImpl = tmp === void 0 ? isSubtreeInaccessible : tmp;
    var window1 = element.ownerDocument.defaultView;
    // since visibility is inherited we can exit early
    if (window1.getComputedStyle(element).visibility === 'hidden') return true;
    var currentElement = element;
    while(currentElement){
        if (isSubtreeInaccessibleImpl(currentElement)) return true;
        currentElement = currentElement.parentElement;
    }
    return false;
}
function getImplicitAriaRoles(currentNode) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint bug here:
        // eslint-disable-next-line no-unused-vars
        for(var _iterator = elementRoleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = _step.value, match = _step_value.match, roles = _step_value.roles;
            if (match(currentNode)) return (0, $2Xzd1._)(roles);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [];
}
function buildElementRoleList(elementRolesMap) {
    function makeElementSelector(_ref) {
        var name = _ref.name, attributes = _ref.attributes;
        return "" + name + attributes.map(function(_ref2) {
            var attributeName = _ref2.name, value = _ref2.value, _ref2_constraints = _ref2.constraints, constraints = _ref2_constraints === void 0 ? [] : _ref2_constraints;
            var shouldNotExist = constraints.indexOf('undefined') !== -1;
            var shouldBeNonEmpty = constraints.indexOf('set') !== -1;
            var hasExplicitValue = typeof value !== 'undefined';
            if (hasExplicitValue) return "[" + attributeName + "=\"" + value + "\"]";
            else if (shouldNotExist) return ":not([" + attributeName + "])";
            else if (shouldBeNonEmpty) return "[" + attributeName + "]:not([" + attributeName + "=\"\"])";
            return "[" + attributeName + "]";
        }).join('');
    }
    function getSelectorSpecificity(_ref3) {
        var _ref3_attributes = _ref3.attributes, attributes = _ref3_attributes === void 0 ? [] : _ref3_attributes;
        return attributes.length;
    }
    function bySelectorSpecificity(_ref4, _ref5) {
        var leftSpecificity = _ref4.specificity;
        var rightSpecificity = _ref5.specificity;
        return rightSpecificity - leftSpecificity;
    }
    function match(element) {
        var _element_attributes = element.attributes, attributes = _element_attributes === void 0 ? [] : _element_attributes;
        // https://github.com/testing-library/dom-testing-library/issues/814
        var typeTextIndex = attributes.findIndex(function(attribute) {
            return attribute.value && attribute.name === 'type' && attribute.value === 'text';
        });
        if (typeTextIndex >= 0) // not using splice to not mutate the attributes array
        attributes = (0, $2Xzd1._)(attributes.slice(0, typeTextIndex)).concat((0, $2Xzd1._)(attributes.slice(typeTextIndex + 1)));
        var selector = makeElementSelector((0, $kJeRc._)((0, $eRslx._)({}, element), {
            attributes: attributes
        }));
        return function(node) {
            if (typeTextIndex >= 0 && node.type !== 'text') return false;
            return node.matches(selector);
        };
    }
    var result = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint bug here:
        // eslint-disable-next-line no-unused-vars
        for(var _iterator = elementRolesMap.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), element = _step_value[0], roles = _step_value[1];
            result = (0, $2Xzd1._)(result).concat([
                {
                    match: match(element),
                    roles: Array.from(roles),
                    specificity: getSelectorSpecificity(element)
                }
            ]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return result.sort(bySelectorSpecificity);
}
function getRoles(container, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_hidden = _ref.hidden, hidden = _ref_hidden === void 0 ? false : _ref_hidden;
    function flattenDOM(node) {
        return [
            node
        ].concat((0, $2Xzd1._)(Array.from(node.children).reduce(function(acc, child) {
            return (0, $2Xzd1._)(acc).concat((0, $2Xzd1._)(flattenDOM(child)));
        }, [])));
    }
    return flattenDOM(container).filter(function(element) {
        return hidden === false ? isInaccessible(element) === false : true;
    }).reduce(function(acc, node) {
        var roles = [];
        // TODO: This violates html-aria which does not allow any role on every element
        if (node.hasAttribute('role')) roles = node.getAttribute('role').split(' ').slice(0, 1);
        else roles = getImplicitAriaRoles(node);
        return roles.reduce(function(rolesAcc, role) {
            return Array.isArray(rolesAcc[role]) ? (0, $kJeRc._)((0, $eRslx._)({}, rolesAcc), (0, $hD5pT._)({}, role, (0, $2Xzd1._)(rolesAcc[role]).concat([
                node
            ]))) : (0, $kJeRc._)((0, $eRslx._)({}, rolesAcc), (0, $hD5pT._)({}, role, [
                node
            ]));
        }, acc);
    }, {});
}
function prettyRoles(dom, _ref6) {
    var hidden = _ref6.hidden, includeDescription = _ref6.includeDescription;
    var roles = getRoles(dom, {
        hidden: hidden
    });
    // We prefer to skip generic role, we don't recommend it
    return Object.entries(roles).filter(function(_ref7) {
        var _$_ref7 = (0, $kB67t._)(_ref7, 1), role = _$_ref7[0];
        return role !== 'generic';
    }).map(function(_ref8) {
        var _$_ref8 = (0, $kB67t._)(_ref8, 2), role = _$_ref8[0], elements = _$_ref8[1];
        var delimiterBar = '-'.repeat(50);
        var elementsString = elements.map(function(el) {
            var nameString = "Name \"" + (0, $lX55U.computeAccessibleName)(el, {
                computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
            }) + "\":\n";
            var domString = prettyDOM(el.cloneNode(false));
            if (includeDescription) {
                var descriptionString = "Description \"" + (0, $9WNlU.computeAccessibleDescription)(el, {
                    computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
                }) + "\":\n";
                return "" + nameString + descriptionString + domString;
            }
            return "" + nameString + domString;
        }).join('\n\n');
        return role + ":\n\n" + elementsString + "\n\n" + delimiterBar;
    }).join('\n');
}
var logRoles = function logRoles(dom, _temp2) {
    var _ref = _temp2 === void 0 ? {} : _temp2, _ref_hidden = _ref.hidden, hidden = _ref_hidden === void 0 ? false : _ref_hidden;
    return console.log(prettyRoles(dom, {
        hidden: hidden
    }));
};
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)selected, undefined if not selectable
 */ function computeAriaSelected(element) {
    // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
    // https://www.w3.org/TR/html-aam-1.0/#details-id-97
    if (element.tagName === 'OPTION') return element.selected;
    // explicit value
    return checkBooleanAttribute(element, 'aria-selected');
}
/**
 * @param {Element} element -
 * @returns {boolean} -
 */ function computeAriaBusy(element) {
    // https://www.w3.org/TR/wai-aria-1.1/#aria-busy
    return element.getAttribute('aria-busy') === 'true';
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)checked, undefined if not checked-able
 */ function computeAriaChecked(element) {
    // implicit value from html-aam mappings: https://www.w3.org/TR/html-aam-1.0/#html-attribute-state-and-property-mappings
    // https://www.w3.org/TR/html-aam-1.0/#details-id-56
    // https://www.w3.org/TR/html-aam-1.0/#details-id-67
    if ('indeterminate' in element && element.indeterminate) return undefined;
    if ('checked' in element) return element.checked;
    // explicit value
    return checkBooleanAttribute(element, 'aria-checked');
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)pressed, undefined if not press-able
 */ function computeAriaPressed(element) {
    // https://www.w3.org/TR/wai-aria-1.1/#aria-pressed
    return checkBooleanAttribute(element, 'aria-pressed');
}
/**
 * @param {Element} element -
 * @returns {boolean | string | null} -
 */ function computeAriaCurrent(element) {
    var _ref9, _checkBooleanAttribut;
    // https://www.w3.org/TR/wai-aria-1.1/#aria-current
    return (_ref9 = (_checkBooleanAttribut = checkBooleanAttribute(element, 'aria-current')) != null ? _checkBooleanAttribut : element.getAttribute('aria-current')) != null ? _ref9 : false;
}
/**
 * @param {Element} element -
 * @returns {boolean | undefined} - false/true if (not)expanded, undefined if not expand-able
 */ function computeAriaExpanded(element) {
    // https://www.w3.org/TR/wai-aria-1.1/#aria-expanded
    return checkBooleanAttribute(element, 'aria-expanded');
}
function checkBooleanAttribute(element, attribute) {
    var attributeValue = element.getAttribute(attribute);
    if (attributeValue === 'true') return true;
    if (attributeValue === 'false') return false;
    return undefined;
}
/**
 * @param {Element} element -
 * @returns {number | undefined} - number if implicit heading or aria-level present, otherwise undefined
 */ function computeHeadingLevel(element) {
    // https://w3c.github.io/html-aam/#el-h1-h6
    // https://w3c.github.io/html-aam/#el-h1-h6
    var implicitHeadingLevels = {
        H1: 1,
        H2: 2,
        H3: 3,
        H4: 4,
        H5: 5,
        H6: 6
    };
    // explicit aria-level value
    // https://www.w3.org/TR/wai-aria-1.2/#aria-level
    var ariaLevelAttribute = element.getAttribute('aria-level') && Number(element.getAttribute('aria-level'));
    return ariaLevelAttribute || implicitHeadingLevels[element.tagName];
}
/**
 * @param {Element} element -
 * @returns {number | undefined} -
 */ function computeAriaValueNow(element) {
    var valueNow = element.getAttribute('aria-valuenow');
    return valueNow === null ? undefined : +valueNow;
}
/**
 * @param {Element} element -
 * @returns {number | undefined} -
 */ function computeAriaValueMax(element) {
    var valueMax = element.getAttribute('aria-valuemax');
    return valueMax === null ? undefined : +valueMax;
}
/**
 * @param {Element} element -
 * @returns {number | undefined} -
 */ function computeAriaValueMin(element) {
    var valueMin = element.getAttribute('aria-valuemin');
    return valueMin === null ? undefined : +valueMin;
}
/**
 * @param {Element} element -
 * @returns {string | undefined} -
 */ function computeAriaValueText(element) {
    var valueText = element.getAttribute('aria-valuetext');
    return valueText === null ? undefined : valueText;
}
var normalize = getDefaultNormalizer();
function escapeRegExp(string) {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
function getRegExpMatcher(string) {
    return new RegExp(escapeRegExp(string.toLowerCase()), 'i');
}
function makeSuggestion(queryName, element, content, _ref) {
    var variant = _ref.variant, name = _ref.name;
    var warning = '';
    var queryOptions = {};
    var queryArgs = [
        [
            'Role',
            'TestId'
        ].includes(queryName) ? content : getRegExpMatcher(content)
    ];
    if (name) queryOptions.name = getRegExpMatcher(name);
    if (queryName === 'Role' && isInaccessible(element)) {
        queryOptions.hidden = true;
        warning = "Element is inaccessible. This means that the element and all its children are invisible to screen readers.\n    If you are using the aria-hidden prop, make sure this is the right choice for your case.\n    ";
    }
    if (Object.keys(queryOptions).length > 0) queryArgs.push(queryOptions);
    var queryMethod = variant + "By" + queryName;
    return {
        queryName: queryName,
        queryMethod: queryMethod,
        queryArgs: queryArgs,
        variant: variant,
        warning: warning,
        toString: function() {
            if (warning) console.warn(warning);
            var _queryArgs = (0, $kB67t._)(queryArgs, 2), text = _queryArgs[0], options = _queryArgs[1];
            text = typeof text === 'string' ? "'" + text + "'" : text;
            options = options ? ", { " + Object.entries(options).map(function(_ref2) {
                var _$_ref2 = (0, $kB67t._)(_ref2, 2), k = _$_ref2[0], v = _$_ref2[1];
                return k + ": " + v;
            }).join(', ') + " }" : '';
            return queryMethod + "(" + text + options + ")";
        }
    };
}
function canSuggest(currentMethod, requestedMethod, data) {
    return data && (!requestedMethod || requestedMethod.toLowerCase() === currentMethod.toLowerCase());
}
function getSuggestedQuery(element, variant, method) {
    var _element$getAttribute, _getImplicitAriaRoles;
    if (variant === void 0) variant = 'get';
    // don't create suggestions for script and style elements
    if (element.matches(getConfig().defaultIgnore)) return undefined;
    //We prefer to suggest something else if the role is generic
    var role = (_element$getAttribute = element.getAttribute('role')) != null ? _element$getAttribute : (_getImplicitAriaRoles = getImplicitAriaRoles(element)) == null ? void 0 : _getImplicitAriaRoles[0];
    if (role !== 'generic' && canSuggest('Role', method, role)) return makeSuggestion('Role', element, role, {
        variant: variant,
        name: (0, $lX55U.computeAccessibleName)(element, {
            computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        })
    });
    var labelText = getLabels(document, element).map(function(label) {
        return label.content;
    }).join(' ');
    if (canSuggest('LabelText', method, labelText)) return makeSuggestion('LabelText', element, labelText, {
        variant: variant
    });
    var placeholderText = element.getAttribute('placeholder');
    if (canSuggest('PlaceholderText', method, placeholderText)) return makeSuggestion('PlaceholderText', element, placeholderText, {
        variant: variant
    });
    var textContent = normalize(getNodeText(element));
    if (canSuggest('Text', method, textContent)) return makeSuggestion('Text', element, textContent, {
        variant: variant
    });
    if (canSuggest('DisplayValue', method, element.value)) return makeSuggestion('DisplayValue', element, normalize(element.value), {
        variant: variant
    });
    var alt = element.getAttribute('alt');
    if (canSuggest('AltText', method, alt)) return makeSuggestion('AltText', element, alt, {
        variant: variant
    });
    var title = element.getAttribute('title');
    if (canSuggest('Title', method, title)) return makeSuggestion('Title', element, title, {
        variant: variant
    });
    var testId = element.getAttribute(getConfig().testIdAttribute);
    if (canSuggest('TestId', method, testId)) return makeSuggestion('TestId', element, testId, {
        variant: variant
    });
    return undefined;
}
// This is so the stack trace the developer sees is one that's
// closer to their code (because async stack traces are hard to follow).
function copyStackTrace(target, source) {
    target.stack = source.stack.replace(source.message, target.message);
}
function waitFor(callback, _ref) {
    var _ref_container = _ref.container, container = _ref_container === void 0 ? getDocument() : _ref_container, _ref_timeout = _ref.timeout, timeout = _ref_timeout === void 0 ? getConfig().asyncUtilTimeout : _ref_timeout, _ref_showOriginalStackTrace = _ref.showOriginalStackTrace, showOriginalStackTrace = _ref_showOriginalStackTrace === void 0 ? getConfig().showOriginalStackTrace : _ref_showOriginalStackTrace, stackTraceError = _ref.stackTraceError, _ref_interval = _ref.interval, interval = _ref_interval === void 0 ? 50 : _ref_interval, _ref_onTimeout = _ref.onTimeout, onTimeout = _ref_onTimeout === void 0 ? function(error) {
        Object.defineProperty(error, 'message', {
            value: getConfig().getElementError(error.message, container).message
        });
        return error;
    } : _ref_onTimeout, _ref_mutationObserverOptions = _ref.mutationObserverOptions, mutationObserverOptions = _ref_mutationObserverOptions === void 0 ? {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true
    } : _ref_mutationObserverOptions;
    if (typeof callback !== 'function') throw new TypeError('Received `callback` arg must be a function');
    return new Promise(/*#__PURE__*/ function() {
        var _$_ref = (0, $7k5I8._)(function(resolve, reject) {
            var lastError, intervalId, observer, finished, promiseStatus, overallTimeoutTimer, usingJestFakeTimers, _getConfig, advanceTimersWrapper, error, MutationObserver;
            function onDone(error, result) {
                finished = true;
                clearTimeout(overallTimeoutTimer);
                if (!usingJestFakeTimers) {
                    clearInterval(intervalId);
                    observer.disconnect();
                }
                if (error) reject(error);
                else resolve(result);
            }
            function checkRealTimersCallback() {
                if (jestFakeTimersAreEnabled()) {
                    var error = new Error("Changed from using real timers to fake timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to fake timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
                    if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
                    return reject(error);
                } else return checkCallback();
            }
            function checkCallback() {
                if (promiseStatus === 'pending') return;
                try {
                    var result = runWithExpensiveErrorDiagnosticsDisabled(callback);
                    if (typeof (result == null ? void 0 : result.then) === 'function') {
                        promiseStatus = 'pending';
                        result.then(function(resolvedValue) {
                            promiseStatus = 'resolved';
                            onDone(null, resolvedValue);
                        }, function(rejectedValue) {
                            promiseStatus = 'rejected';
                            lastError = rejectedValue;
                        });
                    } else onDone(null, result);
                // If `callback` throws, wait for the next mutation, interval, or timeout.
                } catch (error) {
                    // Save the most recent callback error to reject the promise with it in the event of a timeout
                    lastError = error;
                }
            }
            function handleTimeout() {
                var error;
                if (lastError) {
                    error = lastError;
                    if (!showOriginalStackTrace && error.name === 'TestingLibraryElementError') copyStackTrace(error, stackTraceError);
                } else {
                    error = new Error('Timed out in waitFor.');
                    if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
                }
                onDone(onTimeout(error), null);
            }
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        finished = false;
                        promiseStatus = 'idle';
                        overallTimeoutTimer = setTimeout(handleTimeout, timeout);
                        usingJestFakeTimers = jestFakeTimersAreEnabled();
                        if (!usingJestFakeTimers) return [
                            3,
                            4
                        ];
                        _getConfig = getConfig(), advanceTimersWrapper = _getConfig.unstable_advanceTimersWrapper;
                        checkCallback();
                        _state.label = 1;
                    case 1:
                        if (!!finished) return [
                            3,
                            3
                        ];
                        if (!jestFakeTimersAreEnabled()) {
                            error = new Error("Changed from using fake timers to real timers while using waitFor. This is not allowed and will result in very strange behavior. Please ensure you're awaiting all async things your test is doing before changing to real timers. For more info, please go to https://github.com/testing-library/dom-testing-library/issues/830");
                            if (!showOriginalStackTrace) copyStackTrace(error, stackTraceError);
                            reject(error);
                            return [
                                2
                            ];
                        }
                        // In this rare case, we *need* to wait for in-flight promises
                        // to resolve before continuing. We don't need to take advantage
                        // of parallelization so we're fine.
                        // https://stackoverflow.com/a/59243586/971592
                        // eslint-disable-next-line no-await-in-loop
                        return [
                            4,
                            advanceTimersWrapper(/*#__PURE__*/ (0, $7k5I8._)(function() {
                                return (0, $lFlDF.__generator)(this, function(_state) {
                                    // we *could* (maybe should?) use `advanceTimersToNextTimer` but it's
                                    // possible that could make this loop go on forever if someone is using
                                    // third party code that's setting up recursive timers so rapidly that
                                    // the user's timer's don't get a chance to resolve. So we'll advance
                                    // by an interval instead. (We have a test for this case).
                                    jest.advanceTimersByTime(interval);
                                    return [
                                        2
                                    ];
                                });
                            }))
                        ];
                    case 2:
                        _state.sent();
                        // Could have timed-out
                        if (finished) return [
                            3,
                            3
                        ];
                        // It's really important that checkCallback is run *before* we flush
                        // in-flight promises. To be honest, I'm not sure why, and I can't quite
                        // think of a way to reproduce the problem in a test, but I spent
                        // an entire day banging my head against a wall on this.
                        checkCallback();
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            3,
                            5
                        ];
                    case 4:
                        try {
                            checkContainerType(container);
                        } catch (e) {
                            reject(e);
                            return [
                                2
                            ];
                        }
                        intervalId = setInterval(checkRealTimersCallback, interval);
                        MutationObserver = getWindowFromNode(container).MutationObserver;
                        observer = new MutationObserver(checkRealTimersCallback);
                        observer.observe(container, mutationObserverOptions);
                        checkCallback();
                        _state.label = 5;
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(resolve, reject) {
            return _$_ref.apply(this, arguments);
        };
    }());
}
function waitForWrapper(callback, options) {
    // create the error here so its stack trace is as close to the
    // calling code as possible
    var stackTraceError = new Error('STACK_TRACE_MESSAGE');
    return getConfig().asyncWrapper(function() {
        return waitFor(callback, (0, $eRslx._)({
            stackTraceError: stackTraceError
        }, options));
    });
}
/*
eslint
  max-lines-per-function: ["error", {"max": 200}],
*/ function getElementError(message, container) {
    return getConfig().getElementError(message, container);
}
function getMultipleElementsFoundError(message, container) {
    return getElementError(message + "\n\n(If this is intentional, then use the `*AllBy*` variant of the query (like `queryAllByText`, `getAllByText`, or `findAllByText`)).", container);
}
function queryAllByAttribute(attribute, container, text, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_exact = _ref.exact, exact = _ref_exact === void 0 ? true : _ref_exact, collapseWhitespace = _ref.collapseWhitespace, trim = _ref.trim, normalizer = _ref.normalizer;
    var matcher = exact ? matches : fuzzyMatches;
    var matchNormalizer = makeNormalizer({
        collapseWhitespace: collapseWhitespace,
        trim: trim,
        normalizer: normalizer
    });
    return Array.from(container.querySelectorAll("[" + attribute + "]")).filter(function(node) {
        return matcher(node.getAttribute(attribute), node, text, matchNormalizer);
    });
}
function queryByAttribute(attribute, container, text, options) {
    var els = queryAllByAttribute(attribute, container, text, options);
    if (els.length > 1) throw getMultipleElementsFoundError("Found multiple elements by [" + attribute + "=" + text + "]", container);
    return els[0] || null;
}
// this accepts a query function and returns a function which throws an error
// if more than one elements is returned, otherwise it returns the first
// element or null
function makeSingleQuery(allQuery, getMultipleError) {
    return function(container) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        var els = allQuery.apply(void 0, [
            container
        ].concat((0, $2Xzd1._)(args)));
        if (els.length > 1) {
            var elementStrings = els.map(function(element) {
                return getElementError(null, element).message;
            }).join('\n\n');
            throw getMultipleElementsFoundError(getMultipleError.apply(void 0, [
                container
            ].concat((0, $2Xzd1._)(args))) + "\n\nHere are the matching elements:\n\n" + elementStrings, container);
        }
        return els[0] || null;
    };
}
function getSuggestionError(suggestion, container) {
    return getConfig().getElementError("A better query is available, try this:\n" + suggestion.toString() + "\n", container);
}
// this accepts a query function and returns a function which throws an error
// if an empty list of elements is returned
function makeGetAllQuery(allQuery, getMissingError) {
    return function(container) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        var els = allQuery.apply(void 0, [
            container
        ].concat((0, $2Xzd1._)(args)));
        if (!els.length) throw getConfig().getElementError(getMissingError.apply(void 0, [
            container
        ].concat((0, $2Xzd1._)(args))), container);
        return els;
    };
}
// this accepts a getter query function and returns a function which calls
// waitFor and passing a function which invokes the getter.
function makeFindQuery(getter) {
    return function(container, text, options, waitForOptions) {
        return waitForWrapper(function() {
            return getter(container, text, options);
        }, (0, $eRslx._)({
            container: container
        }, waitForOptions));
    };
}
var wrapSingleQueryWithSuggestion = function(query, queryAllByName, variant) {
    return function wrapSingleQueryWithSuggestion(container) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        var element = query.apply(void 0, [
            container
        ].concat((0, $2Xzd1._)(args)));
        var _args_slice = (0, $kB67t._)(args.slice(-1), 1), tmp = _args_slice[0], _ref = tmp === void 0 ? {} : tmp, _ref_suggest = _ref.suggest, suggest = _ref_suggest === void 0 ? getConfig().throwSuggestions : _ref_suggest;
        if (element && suggest) {
            var suggestion = getSuggestedQuery(element, variant);
            if (suggestion && !queryAllByName.endsWith(suggestion.queryName)) throw getSuggestionError(suggestion.toString(), container);
        }
        return element;
    };
};
var wrapAllByQueryWithSuggestion = function(query, queryAllByName, variant) {
    return function wrapAllByQueryWithSuggestion(container) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        var els = query.apply(void 0, [
            container
        ].concat((0, $2Xzd1._)(args)));
        var _args_slice = (0, $kB67t._)(args.slice(-1), 1), tmp = _args_slice[0], _ref = tmp === void 0 ? {} : tmp, _ref_suggest = _ref.suggest, suggest = _ref_suggest === void 0 ? getConfig().throwSuggestions : _ref_suggest;
        if (els.length && suggest) {
            // get a unique list of all suggestion messages.  We are only going to make a suggestion if
            // all the suggestions are the same
            var uniqueSuggestionMessages = (0, $2Xzd1._)(new Set(els.map(function(element) {
                var _getSuggestedQuery;
                return (_getSuggestedQuery = getSuggestedQuery(element, variant)) == null ? void 0 : _getSuggestedQuery.toString();
            })));
            if (// only want to suggest if all the els have the same suggestion.
            uniqueSuggestionMessages.length === 1 && !queryAllByName.endsWith(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- TODO: Can this be null at runtime?
            getSuggestedQuery(els[0], variant).queryName)) throw getSuggestionError(uniqueSuggestionMessages[0], container);
        }
        return els;
    };
};
// TODO: This deviates from the published declarations
// However, the implementation always required a dyadic (after `container`) not variadic `queryAllBy` considering the implementation of `makeFindQuery`
// This is at least statically true and can be verified by accepting `QueryMethod<Arguments, HTMLElement[]>`
function buildQueries(queryAllBy, getMultipleError, getMissingError) {
    var queryBy = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllBy, getMultipleError), queryAllBy.name, 'query');
    var getAllBy = makeGetAllQuery(queryAllBy, getMissingError);
    var getBy = makeSingleQuery(getAllBy, getMultipleError);
    var getByWithSuggestions = wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'get');
    var getAllWithSuggestions = wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name.replace('query', 'get'), 'getAll');
    var findAllBy = makeFindQuery(wrapAllByQueryWithSuggestion(getAllBy, queryAllBy.name, 'findAll'));
    var findBy = makeFindQuery(wrapSingleQueryWithSuggestion(getBy, queryAllBy.name, 'find'));
    return [
        queryBy,
        getAllWithSuggestions,
        getByWithSuggestions,
        findAllBy,
        findBy
    ];
}
var queryHelpers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    getElementError: getElementError,
    wrapAllByQueryWithSuggestion: wrapAllByQueryWithSuggestion,
    wrapSingleQueryWithSuggestion: wrapSingleQueryWithSuggestion,
    getMultipleElementsFoundError: getMultipleElementsFoundError,
    queryAllByAttribute: queryAllByAttribute,
    queryByAttribute: queryByAttribute,
    makeSingleQuery: makeSingleQuery,
    makeGetAllQuery: makeGetAllQuery,
    makeFindQuery: makeFindQuery,
    buildQueries: buildQueries
});
function queryAllLabels(container) {
    return Array.from(container.querySelectorAll('label,input')).map(function(node) {
        return {
            node: node,
            textToMatch: getLabelContent(node)
        };
    }).filter(function(_ref) {
        var textToMatch = _ref.textToMatch;
        return textToMatch !== null;
    });
}
var queryAllLabelsByText = function queryAllLabelsByText(container, text, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_exact = _ref.exact, exact = _ref_exact === void 0 ? true : _ref_exact, trim = _ref.trim, collapseWhitespace = _ref.collapseWhitespace, normalizer = _ref.normalizer;
    var matcher = exact ? matches : fuzzyMatches;
    var matchNormalizer = makeNormalizer({
        collapseWhitespace: collapseWhitespace,
        trim: trim,
        normalizer: normalizer
    });
    var textToMatchByLabels = queryAllLabels(container);
    return textToMatchByLabels.filter(function(_ref2) {
        var node = _ref2.node, textToMatch = _ref2.textToMatch;
        return matcher(textToMatch, node, text, matchNormalizer);
    }).map(function(_ref3) {
        var node = _ref3.node;
        return node;
    });
};
var queryAllByLabelText = function queryAllByLabelText(container, text, _temp2) {
    var _ref = _temp2 === void 0 ? {} : _temp2, _ref_selector = _ref.selector, selector = _ref_selector === void 0 ? '*' : _ref_selector, _ref_exact = _ref.exact, exact = _ref_exact === void 0 ? true : _ref_exact, collapseWhitespace = _ref.collapseWhitespace, trim = _ref.trim, normalizer = _ref.normalizer;
    checkContainerType(container);
    var matcher = exact ? matches : fuzzyMatches;
    var matchNormalizer = makeNormalizer({
        collapseWhitespace: collapseWhitespace,
        trim: trim,
        normalizer: normalizer
    });
    var matchingLabelledElements = Array.from(container.querySelectorAll('*')).filter(function(element) {
        return getRealLabels(element).length || element.hasAttribute('aria-labelledby');
    }).reduce(function(labelledElements, labelledElement) {
        var labelList = getLabels(container, labelledElement, {
            selector: selector
        });
        labelList.filter(function(label) {
            return Boolean(label.formControl);
        }).forEach(function(label) {
            if (matcher(label.content, label.formControl, text, matchNormalizer) && label.formControl) labelledElements.push(label.formControl);
        });
        var labelsValue = labelList.filter(function(label) {
            return Boolean(label.content);
        }).map(function(label) {
            return label.content;
        });
        if (matcher(labelsValue.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
        if (labelsValue.length > 1) labelsValue.forEach(function(labelValue, index) {
            if (matcher(labelValue, labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
            var labelsFiltered = (0, $2Xzd1._)(labelsValue);
            labelsFiltered.splice(index, 1);
            if (labelsFiltered.length > 1) {
                if (matcher(labelsFiltered.join(' '), labelledElement, text, matchNormalizer)) labelledElements.push(labelledElement);
            }
        });
        return labelledElements;
    }, []).concat(queryAllByAttribute('aria-label', container, text, {
        exact: exact,
        normalizer: matchNormalizer
    }));
    return Array.from(new Set(matchingLabelledElements)).filter(function(element) {
        return element.matches(selector);
    });
};
// the getAll* query would normally look like this:
// const getAllByLabelText = makeGetAllQuery(
//   queryAllByLabelText,
//   (c, text) => `Unable to find a label with the text of: ${text}`,
// )
// however, we can give a more helpful error message than the generic one,
// so we're writing this one out by hand.
var getAllByLabelText = function getAllByLabelText(container, text) {
    for(var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)rest[_key - 2] = arguments[_key];
    var els = queryAllByLabelText.apply(void 0, [
        container,
        text
    ].concat((0, $2Xzd1._)(rest)));
    if (!els.length) {
        var labels = queryAllLabelsByText.apply(void 0, [
            container,
            text
        ].concat((0, $2Xzd1._)(rest)));
        if (labels.length) {
            var tagNames = labels.map(function(label) {
                return getTagNameOfElementAssociatedWithLabelViaFor(container, label);
            }).filter(function(tagName) {
                return !!tagName;
            });
            if (tagNames.length) throw getConfig().getElementError(tagNames.map(function(tagName) {
                return "Found a label with the text of: " + text + ", however the element associated with this label (<" + tagName + " />) is non-labellable [https://html.spec.whatwg.org/multipage/forms.html#category-label]. If you really need to label a <" + tagName + " />, you can use aria-label or aria-labelledby instead.";
            }).join('\n\n'), container);
            else throw getConfig().getElementError("Found a label with the text of: " + text + ", however no form control was found associated to that label. Make sure you're using the \"for\" attribute or \"aria-labelledby\" attribute correctly.", container);
        } else throw getConfig().getElementError("Unable to find a label with the text of: " + text, container);
    }
    return els;
};
function getTagNameOfElementAssociatedWithLabelViaFor(container, label) {
    var htmlFor = label.getAttribute('for');
    if (!htmlFor) return null;
    var element = container.querySelector("[id=\"" + htmlFor + "\"]");
    return element ? element.tagName.toLowerCase() : null;
}
// the reason mentioned above is the same reason we're not using buildQueries
var getMultipleError$7 = function(c, text) {
    return "Found multiple elements with the text of: " + text;
};
var queryByLabelText = wrapSingleQueryWithSuggestion(makeSingleQuery(queryAllByLabelText, getMultipleError$7), queryAllByLabelText.name, 'query');
var getByLabelText = makeSingleQuery(getAllByLabelText, getMultipleError$7);
var findAllByLabelText = makeFindQuery(wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'findAll'));
var findByLabelText = makeFindQuery(wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'find'));
var getAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(getAllByLabelText, getAllByLabelText.name, 'getAll');
var getByLabelTextWithSuggestions = wrapSingleQueryWithSuggestion(getByLabelText, getAllByLabelText.name, 'get');
var queryAllByLabelTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByLabelText, queryAllByLabelText.name, 'queryAll');
var queryAllByPlaceholderText = function queryAllByPlaceholderText() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    checkContainerType(args[0]);
    return queryAllByAttribute.apply(void 0, [
        'placeholder'
    ].concat((0, $2Xzd1._)(args)));
};
var getMultipleError$6 = function(c, text) {
    return "Found multiple elements with the placeholder text of: " + text;
};
var getMissingError$6 = function(c, text) {
    return "Unable to find an element with the placeholder text of: " + text;
};
var queryAllByPlaceholderTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByPlaceholderText, queryAllByPlaceholderText.name, 'queryAll');
var _buildQueries = (0, $kB67t._)(buildQueries(queryAllByPlaceholderText, getMultipleError$6, getMissingError$6), 5), queryByPlaceholderText = _buildQueries[0], getAllByPlaceholderText = _buildQueries[1], getByPlaceholderText = _buildQueries[2], findAllByPlaceholderText = _buildQueries[3], findByPlaceholderText = _buildQueries[4];
var queryAllByText = function queryAllByText(container, text, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_selector = _ref.selector, selector = _ref_selector === void 0 ? '*' : _ref_selector, _ref_exact = _ref.exact, exact = _ref_exact === void 0 ? true : _ref_exact, collapseWhitespace = _ref.collapseWhitespace, trim = _ref.trim, _ref_ignore = _ref.ignore, ignore = _ref_ignore === void 0 ? getConfig().defaultIgnore : _ref_ignore, normalizer = _ref.normalizer;
    checkContainerType(container);
    var matcher = exact ? matches : fuzzyMatches;
    var matchNormalizer = makeNormalizer({
        collapseWhitespace: collapseWhitespace,
        trim: trim,
        normalizer: normalizer
    });
    var baseArray = [];
    if (typeof container.matches === 'function' && container.matches(selector)) baseArray = [
        container
    ];
    return (0, $2Xzd1._)(baseArray).concat((0, $2Xzd1._)(Array.from(container.querySelectorAll(selector))))// TODO: `matches` according lib.dom.d.ts can get only `string` but according our code it can handle also boolean :)
    .filter(function(node) {
        return !ignore || !node.matches(ignore);
    }).filter(function(node) {
        return matcher(getNodeText(node), node, text, matchNormalizer);
    });
};
var getMultipleError$5 = function(c, text) {
    return "Found multiple elements with the text: " + text;
};
var getMissingError$5 = function getMissingError$5(c, text, options) {
    if (options === void 0) options = {};
    var collapseWhitespace = options.collapseWhitespace, trim = options.trim, normalizer = options.normalizer, selector = options.selector;
    var matchNormalizer = makeNormalizer({
        collapseWhitespace: collapseWhitespace,
        trim: trim,
        normalizer: normalizer
    });
    var normalizedText = matchNormalizer(text.toString());
    var isNormalizedDifferent = normalizedText !== text.toString();
    var isCustomSelector = (selector != null ? selector : '*') !== '*';
    return "Unable to find an element with the text: " + (isNormalizedDifferent ? normalizedText + " (normalized from '" + text + "')" : text) + (isCustomSelector ? ", which matches selector '" + selector + "'" : '') + ". This could be because the text is broken up by multiple elements. In this case, you can provide a function for your text matcher to make your matcher more flexible.";
};
var queryAllByTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByText, queryAllByText.name, 'queryAll');
var _buildQueries1 = (0, $kB67t._)(buildQueries(queryAllByText, getMultipleError$5, getMissingError$5), 5), queryByText = _buildQueries1[0], getAllByText = _buildQueries1[1], getByText = _buildQueries1[2], findAllByText = _buildQueries1[3], findByText = _buildQueries1[4];
var queryAllByDisplayValue = function queryAllByDisplayValue(container, value, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_exact = _ref.exact, exact = _ref_exact === void 0 ? true : _ref_exact, collapseWhitespace = _ref.collapseWhitespace, trim = _ref.trim, normalizer = _ref.normalizer;
    checkContainerType(container);
    var matcher = exact ? matches : fuzzyMatches;
    var matchNormalizer = makeNormalizer({
        collapseWhitespace: collapseWhitespace,
        trim: trim,
        normalizer: normalizer
    });
    return Array.from(container.querySelectorAll("input,textarea,select")).filter(function(node) {
        if (node.tagName === 'SELECT') {
            var selectedOptions = Array.from(node.options).filter(function(option) {
                return option.selected;
            });
            return selectedOptions.some(function(optionNode) {
                return matcher(getNodeText(optionNode), optionNode, value, matchNormalizer);
            });
        } else return matcher(node.value, node, value, matchNormalizer);
    });
};
var getMultipleError$4 = function(c, value) {
    return "Found multiple elements with the display value: " + value + ".";
};
var getMissingError$4 = function(c, value) {
    return "Unable to find an element with the display value: " + value + ".";
};
var queryAllByDisplayValueWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByDisplayValue, queryAllByDisplayValue.name, 'queryAll');
var _buildQueries2 = (0, $kB67t._)(buildQueries(queryAllByDisplayValue, getMultipleError$4, getMissingError$4), 5), queryByDisplayValue = _buildQueries2[0], getAllByDisplayValue = _buildQueries2[1], getByDisplayValue = _buildQueries2[2], findAllByDisplayValue = _buildQueries2[3], findByDisplayValue = _buildQueries2[4];
// Valid tags are img, input, area and custom elements
var VALID_TAG_REGEXP = /^(img|input|area|.+-.+)$/i;
var queryAllByAltText = function queryAllByAltText(container, alt, options) {
    if (options === void 0) options = {};
    checkContainerType(container);
    return queryAllByAttribute('alt', container, alt, options).filter(function(node) {
        return VALID_TAG_REGEXP.test(node.tagName);
    });
};
var getMultipleError$3 = function(c, alt) {
    return "Found multiple elements with the alt text: " + alt;
};
var getMissingError$3 = function(c, alt) {
    return "Unable to find an element with the alt text: " + alt;
};
var queryAllByAltTextWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByAltText, queryAllByAltText.name, 'queryAll');
var _buildQueries3 = (0, $kB67t._)(buildQueries(queryAllByAltText, getMultipleError$3, getMissingError$3), 5), queryByAltText = _buildQueries3[0], getAllByAltText = _buildQueries3[1], getByAltText = _buildQueries3[2], findAllByAltText = _buildQueries3[3], findByAltText = _buildQueries3[4];
var isSvgTitle = function(node) {
    var _node$parentElement;
    return node.tagName.toLowerCase() === 'title' && ((_node$parentElement = node.parentElement) == null ? void 0 : _node$parentElement.tagName.toLowerCase()) === 'svg';
};
var queryAllByTitle = function queryAllByTitle(container, text, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_exact = _ref.exact, exact = _ref_exact === void 0 ? true : _ref_exact, collapseWhitespace = _ref.collapseWhitespace, trim = _ref.trim, normalizer = _ref.normalizer;
    checkContainerType(container);
    var matcher = exact ? matches : fuzzyMatches;
    var matchNormalizer = makeNormalizer({
        collapseWhitespace: collapseWhitespace,
        trim: trim,
        normalizer: normalizer
    });
    return Array.from(container.querySelectorAll('[title], svg > title')).filter(function(node) {
        return matcher(node.getAttribute('title'), node, text, matchNormalizer) || isSvgTitle(node) && matcher(getNodeText(node), node, text, matchNormalizer);
    });
};
var getMultipleError$2 = function(c, title) {
    return "Found multiple elements with the title: " + title + ".";
};
var getMissingError$2 = function(c, title) {
    return "Unable to find an element with the title: " + title + ".";
};
var queryAllByTitleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTitle, queryAllByTitle.name, 'queryAll');
var _buildQueries4 = (0, $kB67t._)(buildQueries(queryAllByTitle, getMultipleError$2, getMissingError$2), 5), queryByTitle = _buildQueries4[0], getAllByTitle = _buildQueries4[1], getByTitle = _buildQueries4[2], findAllByTitle = _buildQueries4[3], findByTitle = _buildQueries4[4];
/* eslint-disable complexity */ var queryAllByRole = function queryAllByRole(container, role, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_hidden = _ref.hidden, hidden = _ref_hidden === void 0 ? getConfig().defaultHidden : _ref_hidden, name = _ref.name, description = _ref.description, _ref_queryFallbacks = _ref.queryFallbacks, queryFallbacks = _ref_queryFallbacks === void 0 ? false : _ref_queryFallbacks, selected = _ref.selected, busy = _ref.busy, checked = _ref.checked, pressed = _ref.pressed, current = _ref.current, level = _ref.level, expanded = _ref.expanded, tmp = _ref.value, _ref1 = tmp === void 0 ? {} : tmp, valueNow = _ref1.now, valueMin = _ref1.min, valueMax = _ref1.max, valueText = _ref1.text;
    checkContainerType(container);
    if (selected !== undefined) {
        var _allRoles$get;
        // guard against unknown roles
        if (((_allRoles$get = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get.props['aria-selected']) === undefined) throw new Error("\"aria-selected\" is not supported on role \"" + role + "\".");
    }
    if (busy !== undefined) {
        var _allRoles$get2;
        // guard against unknown roles
        if (((_allRoles$get2 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get2.props['aria-busy']) === undefined) throw new Error("\"aria-busy\" is not supported on role \"" + role + "\".");
    }
    if (checked !== undefined) {
        var _allRoles$get3;
        // guard against unknown roles
        if (((_allRoles$get3 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get3.props['aria-checked']) === undefined) throw new Error("\"aria-checked\" is not supported on role \"" + role + "\".");
    }
    if (pressed !== undefined) {
        var _allRoles$get4;
        // guard against unknown roles
        if (((_allRoles$get4 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get4.props['aria-pressed']) === undefined) throw new Error("\"aria-pressed\" is not supported on role \"" + role + "\".");
    }
    if (current !== undefined) {
        var _allRoles$get5;
        /* istanbul ignore next */ // guard against unknown roles
        // All currently released ARIA versions support `aria-current` on all roles.
        // Leaving this for symmetry and forward compatibility
        if (((_allRoles$get5 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get5.props['aria-current']) === undefined) throw new Error("\"aria-current\" is not supported on role \"" + role + "\".");
    }
    if (level !== undefined) {
        // guard against using `level` option with any role other than `heading`
        if (role !== 'heading') throw new Error("Role \"" + role + "\" cannot have \"level\" property.");
    }
    if (valueNow !== undefined) {
        var _allRoles$get6;
        // guard against unknown roles
        if (((_allRoles$get6 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get6.props['aria-valuenow']) === undefined) throw new Error("\"aria-valuenow\" is not supported on role \"" + role + "\".");
    }
    if (valueMax !== undefined) {
        var _allRoles$get7;
        // guard against unknown roles
        if (((_allRoles$get7 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get7.props['aria-valuemax']) === undefined) throw new Error("\"aria-valuemax\" is not supported on role \"" + role + "\".");
    }
    if (valueMin !== undefined) {
        var _allRoles$get8;
        // guard against unknown roles
        if (((_allRoles$get8 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get8.props['aria-valuemin']) === undefined) throw new Error("\"aria-valuemin\" is not supported on role \"" + role + "\".");
    }
    if (valueText !== undefined) {
        var _allRoles$get9;
        // guard against unknown roles
        if (((_allRoles$get9 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get9.props['aria-valuetext']) === undefined) throw new Error("\"aria-valuetext\" is not supported on role \"" + role + "\".");
    }
    if (expanded !== undefined) {
        var _allRoles$get10;
        // guard against unknown roles
        if (((_allRoles$get10 = (0, $54Ttj.roles).get(role)) == null ? void 0 : _allRoles$get10.props['aria-expanded']) === undefined) throw new Error("\"aria-expanded\" is not supported on role \"" + role + "\".");
    }
    var subtreeIsInaccessibleCache = new WeakMap();
    function cachedIsSubtreeInaccessible(element) {
        if (!subtreeIsInaccessibleCache.has(element)) subtreeIsInaccessibleCache.set(element, isSubtreeInaccessible(element));
        return subtreeIsInaccessibleCache.get(element);
    }
    return Array.from(container.querySelectorAll(// Only query elements that can be matched by the following filters
    makeRoleSelector(role))).filter(function(node) {
        var isRoleSpecifiedExplicitly = node.hasAttribute('role');
        if (isRoleSpecifiedExplicitly) {
            var roleValue = node.getAttribute('role');
            if (queryFallbacks) return roleValue.split(' ').filter(Boolean).some(function(roleAttributeToken) {
                return roleAttributeToken === role;
            });
            // other wise only send the first token to match
            var _roleValue_split = (0, $kB67t._)(roleValue.split(' '), 1), firstRoleAttributeToken = _roleValue_split[0];
            return firstRoleAttributeToken === role;
        }
        var implicitRoles = getImplicitAriaRoles(node);
        return implicitRoles.some(function(implicitRole) {
            return implicitRole === role;
        });
    }).filter(function(element) {
        if (selected !== undefined) return selected === computeAriaSelected(element);
        if (busy !== undefined) return busy === computeAriaBusy(element);
        if (checked !== undefined) return checked === computeAriaChecked(element);
        if (pressed !== undefined) return pressed === computeAriaPressed(element);
        if (current !== undefined) return current === computeAriaCurrent(element);
        if (expanded !== undefined) return expanded === computeAriaExpanded(element);
        if (level !== undefined) return level === computeHeadingLevel(element);
        if (valueNow !== undefined || valueMax !== undefined || valueMin !== undefined || valueText !== undefined) {
            var valueMatches = true;
            if (valueNow !== undefined) valueMatches && (valueMatches = valueNow === computeAriaValueNow(element));
            if (valueMax !== undefined) valueMatches && (valueMatches = valueMax === computeAriaValueMax(element));
            if (valueMin !== undefined) valueMatches && (valueMatches = valueMin === computeAriaValueMin(element));
            if (valueText !== undefined) {
                var _computeAriaValueText;
                valueMatches && (valueMatches = matches((_computeAriaValueText = computeAriaValueText(element)) != null ? _computeAriaValueText : null, element, valueText, function(text) {
                    return text;
                }));
            }
            return valueMatches;
        }
        // don't care if aria attributes are unspecified
        return true;
    }).filter(function(element) {
        if (name === undefined) // Don't care
        return true;
        return matches((0, $lX55U.computeAccessibleName)(element, {
            computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }), element, name, function(text) {
            return text;
        });
    }).filter(function(element) {
        if (description === undefined) // Don't care
        return true;
        return matches((0, $9WNlU.computeAccessibleDescription)(element, {
            computedStyleSupportsPseudoElements: getConfig().computedStyleSupportsPseudoElements
        }), element, description, function(text) {
            return text;
        });
    }).filter(function(element) {
        return hidden === false ? isInaccessible(element, {
            isSubtreeInaccessible: cachedIsSubtreeInaccessible
        }) === false : true;
    });
};
function makeRoleSelector(role) {
    var _roleElements$get;
    var explicitRoleSelector = "*[role~=\"" + role + "\"]";
    var roleRelations = (_roleElements$get = (0, $54Ttj.roleElements).get(role)) != null ? _roleElements$get : new Set();
    var implicitRoleSelectors = new Set(Array.from(roleRelations).map(function(_ref) {
        var name = _ref.name;
        return name;
    }));
    // Current transpilation config sometimes assumes `...` is always applied to arrays.
    // `...` is equivalent to `Array.prototype.concat` for arrays.
    // If you replace this code with `[explicitRoleSelector, ...implicitRoleSelectors]`, make sure every transpilation target retains the `...` in favor of `Array.prototype.concat`.
    return [
        explicitRoleSelector
    ].concat(Array.from(implicitRoleSelectors)).join(',');
}
var getNameHint = function(name) {
    var nameHint = '';
    if (name === undefined) nameHint = '';
    else if (typeof name === 'string') nameHint = " and name \"" + name + "\"";
    else nameHint = " and name `" + name + "`";
    return nameHint;
};
var getMultipleError$1 = function getMultipleError$1(c, role, _temp2) {
    var name = (_temp2 === void 0 ? {} : _temp2).name;
    return "Found multiple elements with the role \"" + role + "\"" + getNameHint(name);
};
var getMissingError$1 = function getMissingError$1(container, role, _temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, _ref_hidden = _ref.hidden, hidden = _ref_hidden === void 0 ? getConfig().defaultHidden : _ref_hidden, name = _ref.name, description = _ref.description;
    if (getConfig()._disableExpensiveErrorDiagnostics) return "Unable to find role=\"" + role + "\"" + getNameHint(name);
    var roles = '';
    Array.from(container.children).forEach(function(childElement) {
        roles += prettyRoles(childElement, {
            hidden: hidden,
            includeDescription: description !== undefined
        });
    });
    var roleMessage;
    if (roles.length === 0) {
        if (hidden === false) roleMessage = "There are no accessible roles. But there might be some inaccessible roles. If you wish to access them, then set the `hidden` option to `true`. Learn more about this here: https://testing-library.com/docs/dom-testing-library/api-queries#byrole";
        else roleMessage = 'There are no available roles.';
    } else roleMessage = ("\nHere are the " + (hidden === false ? 'accessible' : 'available') + " roles:\n\n  " + roles.replace(/\n/g, '\n  ').replace(/\n\s\s\n/g, '\n\n') + "\n").trim();
    var nameHint = '';
    if (name === undefined) nameHint = '';
    else if (typeof name === 'string') nameHint = " and name \"" + name + "\"";
    else nameHint = " and name `" + name + "`";
    var descriptionHint = '';
    if (description === undefined) descriptionHint = '';
    else if (typeof description === 'string') descriptionHint = " and description \"" + description + "\"";
    else descriptionHint = " and description `" + description + "`";
    return ("\nUnable to find an " + (hidden === false ? 'accessible ' : '') + "element with the role \"" + role + "\"" + nameHint + descriptionHint + "\n\n" + roleMessage).trim();
};
var queryAllByRoleWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByRole, queryAllByRole.name, 'queryAll');
var _buildQueries5 = (0, $kB67t._)(buildQueries(queryAllByRole, getMultipleError$1, getMissingError$1), 5), queryByRole = _buildQueries5[0], getAllByRole = _buildQueries5[1], getByRole = _buildQueries5[2], findAllByRole = _buildQueries5[3], findByRole = _buildQueries5[4];
var getTestIdAttribute = function() {
    return getConfig().testIdAttribute;
};
var queryAllByTestId = function queryAllByTestId() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    checkContainerType(args[0]);
    return queryAllByAttribute.apply(void 0, [
        getTestIdAttribute()
    ].concat((0, $2Xzd1._)(args)));
};
var getMultipleError = function(c, id) {
    return "Found multiple elements by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
};
var getMissingError = function(c, id) {
    return "Unable to find an element by: [" + getTestIdAttribute() + "=\"" + id + "\"]";
};
var queryAllByTestIdWithSuggestions = wrapAllByQueryWithSuggestion(queryAllByTestId, queryAllByTestId.name, 'queryAll');
var _buildQueries6 = (0, $kB67t._)(buildQueries(queryAllByTestId, getMultipleError, getMissingError), 5), queryByTestId = _buildQueries6[0], getAllByTestId = _buildQueries6[1], getByTestId = _buildQueries6[2], findAllByTestId = _buildQueries6[3], findByTestId = _buildQueries6[4];
var queries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    queryAllByLabelText: queryAllByLabelTextWithSuggestions,
    queryByLabelText: queryByLabelText,
    getAllByLabelText: getAllByLabelTextWithSuggestions,
    getByLabelText: getByLabelTextWithSuggestions,
    findAllByLabelText: findAllByLabelText,
    findByLabelText: findByLabelText,
    queryByPlaceholderText: queryByPlaceholderText,
    queryAllByPlaceholderText: queryAllByPlaceholderTextWithSuggestions,
    getByPlaceholderText: getByPlaceholderText,
    getAllByPlaceholderText: getAllByPlaceholderText,
    findAllByPlaceholderText: findAllByPlaceholderText,
    findByPlaceholderText: findByPlaceholderText,
    queryByText: queryByText,
    queryAllByText: queryAllByTextWithSuggestions,
    getByText: getByText,
    getAllByText: getAllByText,
    findAllByText: findAllByText,
    findByText: findByText,
    queryByDisplayValue: queryByDisplayValue,
    queryAllByDisplayValue: queryAllByDisplayValueWithSuggestions,
    getByDisplayValue: getByDisplayValue,
    getAllByDisplayValue: getAllByDisplayValue,
    findAllByDisplayValue: findAllByDisplayValue,
    findByDisplayValue: findByDisplayValue,
    queryByAltText: queryByAltText,
    queryAllByAltText: queryAllByAltTextWithSuggestions,
    getByAltText: getByAltText,
    getAllByAltText: getAllByAltText,
    findAllByAltText: findAllByAltText,
    findByAltText: findByAltText,
    queryByTitle: queryByTitle,
    queryAllByTitle: queryAllByTitleWithSuggestions,
    getByTitle: getByTitle,
    getAllByTitle: getAllByTitle,
    findAllByTitle: findAllByTitle,
    findByTitle: findByTitle,
    queryByRole: queryByRole,
    queryAllByRole: queryAllByRoleWithSuggestions,
    getAllByRole: getAllByRole,
    getByRole: getByRole,
    findAllByRole: findAllByRole,
    findByRole: findByRole,
    queryByTestId: queryByTestId,
    queryAllByTestId: queryAllByTestIdWithSuggestions,
    getByTestId: getByTestId,
    getAllByTestId: getAllByTestId,
    findAllByTestId: findAllByTestId,
    findByTestId: findByTestId
});
/**
 * @typedef {{[key: string]: Function}} FuncMap
 */ /**
 * @param {HTMLElement} element container
 * @param {FuncMap} queries object of functions
 * @param {Object} initialValue for reducer
 * @returns {FuncMap} returns object of functions bound to container
 */ function getQueriesForElement(element, queries$1, initialValue) {
    if (queries$1 === void 0) queries$1 = queries;
    if (initialValue === void 0) initialValue = {};
    return Object.keys(queries$1).reduce(function(helpers, key) {
        var fn = queries$1[key];
        helpers[key] = fn.bind(null, element);
        return helpers;
    }, initialValue);
}
var isRemoved = function(result) {
    return !result || Array.isArray(result) && !result.length;
};
// Check if the element is not present.
// As the name implies, waitForElementToBeRemoved should check `present` --> `removed`
function initialCheck(elements) {
    if (isRemoved(elements)) throw new Error('The element(s) given to waitForElementToBeRemoved are already removed. waitForElementToBeRemoved requires that the element(s) exist(s) before waiting for removal.');
}
function waitForElementToBeRemoved(callback, options) {
    return _waitForElementToBeRemoved.apply(this, arguments);
}
function _waitForElementToBeRemoved() {
    _waitForElementToBeRemoved = (0, $7k5I8._)(function(callback, options) {
        var timeoutError, elements, getRemainingElements;
        return (0, $lFlDF.__generator)(this, function(_state) {
            // created here so we get a nice stacktrace
            timeoutError = new Error('Timed out in waitForElementToBeRemoved.');
            if (typeof callback !== 'function') {
                initialCheck(callback);
                elements = Array.isArray(callback) ? callback : [
                    callback
                ];
                getRemainingElements = elements.map(function(element) {
                    var parent = element.parentElement;
                    if (parent === null) return function() {
                        return null;
                    };
                    while(parent.parentElement)parent = parent.parentElement;
                    return function() {
                        return parent.contains(element) ? element : null;
                    };
                });
                callback = function() {
                    return getRemainingElements.map(function(c) {
                        return c();
                    }).filter(Boolean);
                };
            }
            initialCheck(callback());
            return [
                2,
                waitForWrapper(function() {
                    var result;
                    try {
                        result = callback();
                    } catch (error) {
                        if (error.name === 'TestingLibraryElementError') return undefined;
                        throw error;
                    }
                    if (!isRemoved(result)) throw timeoutError;
                    return undefined;
                }, options)
            ];
        });
    });
    return _waitForElementToBeRemoved.apply(this, arguments);
}
/*
eslint
  require-await: "off"
*/ var eventMap = {
    // Clipboard Events
    copy: {
        EventType: 'ClipboardEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    cut: {
        EventType: 'ClipboardEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    paste: {
        EventType: 'ClipboardEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Composition Events
    compositionEnd: {
        EventType: 'CompositionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    compositionStart: {
        EventType: 'CompositionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    compositionUpdate: {
        EventType: 'CompositionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Keyboard Events
    keyDown: {
        EventType: 'KeyboardEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            charCode: 0,
            composed: true
        }
    },
    keyPress: {
        EventType: 'KeyboardEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            charCode: 0,
            composed: true
        }
    },
    keyUp: {
        EventType: 'KeyboardEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            charCode: 0,
            composed: true
        }
    },
    // Focus Events
    focus: {
        EventType: 'FocusEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    blur: {
        EventType: 'FocusEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    focusIn: {
        EventType: 'FocusEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    focusOut: {
        EventType: 'FocusEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    // Form Events
    change: {
        EventType: 'Event',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    input: {
        EventType: 'InputEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    invalid: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: true
        }
    },
    submit: {
        EventType: 'Event',
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    },
    reset: {
        EventType: 'Event',
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    },
    // Mouse Events
    click: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            button: 0,
            composed: true
        }
    },
    contextMenu: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dblClick: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    drag: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dragEnd: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    dragEnter: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dragExit: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    dragLeave: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    dragOver: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    dragStart: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    drop: {
        EventType: 'DragEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseDown: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseEnter: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    mouseLeave: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false,
            composed: true
        }
    },
    mouseMove: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseOut: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseOver: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    mouseUp: {
        EventType: 'MouseEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Selection Events
    select: {
        EventType: 'Event',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // Touch Events
    touchCancel: {
        EventType: 'TouchEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    touchEnd: {
        EventType: 'TouchEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    touchMove: {
        EventType: 'TouchEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    touchStart: {
        EventType: 'TouchEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // UI Events
    resize: {
        EventType: 'UIEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    scroll: {
        EventType: 'UIEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    // Wheel Events
    wheel: {
        EventType: 'WheelEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    // Media Events
    abort: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    canPlay: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    canPlayThrough: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    durationChange: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    emptied: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    encrypted: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    ended: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    loadedData: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    loadedMetadata: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    loadStart: {
        EventType: 'ProgressEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    pause: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    play: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    playing: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    progress: {
        EventType: 'ProgressEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    rateChange: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    seeked: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    seeking: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    stalled: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    suspend: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    timeUpdate: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    volumeChange: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    waiting: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    // Events
    load: {
        // TODO: load events can be UIEvent or Event depending on what generated them
        // This is where this abstraction breaks down.
        // But the common targets are <img />, <script /> and window.
        // Neither of these targets receive a UIEvent
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    error: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    // Animation Events
    animationStart: {
        EventType: 'AnimationEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    animationEnd: {
        EventType: 'AnimationEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    animationIteration: {
        EventType: 'AnimationEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // Transition Events
    transitionCancel: {
        EventType: 'TransitionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    transitionEnd: {
        EventType: 'TransitionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    },
    transitionRun: {
        EventType: 'TransitionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    transitionStart: {
        EventType: 'TransitionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // pointer events
    pointerOver: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerEnter: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    pointerDown: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerMove: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerUp: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerCancel: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    pointerOut: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true,
            composed: true
        }
    },
    pointerLeave: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    gotPointerCapture: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    lostPointerCapture: {
        EventType: 'PointerEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false,
            composed: true
        }
    },
    // history events
    popState: {
        EventType: 'PopStateEvent',
        defaultInit: {
            bubbles: true,
            cancelable: false
        }
    },
    // window events
    offline: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    online: {
        EventType: 'Event',
        defaultInit: {
            bubbles: false,
            cancelable: false
        }
    },
    pageHide: {
        EventType: 'PageTransitionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    },
    pageShow: {
        EventType: 'PageTransitionEvent',
        defaultInit: {
            bubbles: true,
            cancelable: true
        }
    }
};
var eventAliasMap = {
    doubleClick: 'dblClick'
};
function fireEvent(element, event) {
    return getConfig().eventWrapper(function() {
        if (!event) throw new Error("Unable to fire an event - please provide an event object.");
        if (!element) throw new Error("Unable to fire a \"" + event.type + "\" event - please provide a DOM element.");
        return element.dispatchEvent(event);
    });
}
function createEvent(eventName, node, init, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref_EventType = _ref.EventType, EventType = _ref_EventType === void 0 ? 'Event' : _ref_EventType, _ref_defaultInit = _ref.defaultInit, defaultInit = _ref_defaultInit === void 0 ? {} : _ref_defaultInit;
    if (!node) throw new Error("Unable to fire a \"" + eventName + "\" event - please provide a DOM element.");
    var eventInit = (0, $eRslx._)({}, defaultInit, init);
    var tmp = eventInit.target, _ref1 = tmp === void 0 ? {} : tmp, value = _ref1.value, files = _ref1.files, targetProperties = (0, $1dxAe._)(eventInit.target, [
        "value",
        "files"
    ]);
    if (value !== undefined) setNativeValue(node, value);
    if (files !== undefined) // input.files is a read-only property so this is not allowed:
    // input.files = [file]
    // so we have to use this workaround to set the property
    Object.defineProperty(node, 'files', {
        configurable: true,
        enumerable: true,
        writable: true,
        value: files
    });
    Object.assign(node, targetProperties);
    var window1 = getWindowFromNode(node);
    var EventConstructor = window1[EventType] || window1.Event;
    var event;
    /* istanbul ignore else  */ if (typeof EventConstructor === 'function') event = new EventConstructor(eventName, eventInit);
    else {
        // IE11 polyfill from https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent#Polyfill
        event = window1.document.createEvent(EventType);
        var bubbles = eventInit.bubbles, cancelable = eventInit.cancelable, detail = eventInit.detail, otherInit = (0, $1dxAe._)(eventInit, [
            "bubbles",
            "cancelable",
            "detail"
        ]);
        event.initEvent(eventName, bubbles, cancelable, detail);
        Object.keys(otherInit).forEach(function(eventKey) {
            event[eventKey] = otherInit[eventKey];
        });
    }
    // DataTransfer is not supported in jsdom: https://github.com/jsdom/jsdom/issues/1568
    var dataTransferProperties = [
        'dataTransfer',
        'clipboardData'
    ];
    dataTransferProperties.forEach(function(dataTransferKey) {
        var dataTransferValue = eventInit[dataTransferKey];
        if ((typeof dataTransferValue === "undefined" ? "undefined" : (0, $YtE9h._)(dataTransferValue)) === 'object') {
            /* istanbul ignore if  */ if (typeof window1.DataTransfer === 'function') Object.defineProperty(event, dataTransferKey, {
                value: Object.getOwnPropertyNames(dataTransferValue).reduce(function(acc, propName) {
                    Object.defineProperty(acc, propName, {
                        value: dataTransferValue[propName]
                    });
                    return acc;
                }, new window1.DataTransfer())
            });
            else Object.defineProperty(event, dataTransferKey, {
                value: dataTransferValue
            });
        }
    });
    return event;
}
Object.keys(eventMap).forEach(function(key) {
    var _eventMap_key = eventMap[key], EventType = _eventMap_key.EventType, defaultInit = _eventMap_key.defaultInit;
    var eventName = key.toLowerCase();
    createEvent[key] = function(node, init) {
        return createEvent(eventName, node, init, {
            EventType: EventType,
            defaultInit: defaultInit
        });
    };
    fireEvent[key] = function(node, init) {
        return fireEvent(node, createEvent[key](node, init));
    };
});
// function written after some investigation here:
// https://github.com/facebook/react/issues/10135#issuecomment-401496776
function setNativeValue(element, value) {
    var _ref = Object.getOwnPropertyDescriptor(element, 'value') || {}, valueSetter = _ref.set;
    var prototype = Object.getPrototypeOf(element);
    var _ref1 = Object.getOwnPropertyDescriptor(prototype, 'value') || {}, prototypeValueSetter = _ref1.set;
    if (prototypeValueSetter && valueSetter !== prototypeValueSetter) prototypeValueSetter.call(element, value);
    else {
        /* istanbul ignore if */ // eslint-disable-next-line no-lonely-if -- Can't be ignored by istanbul otherwise
        if (valueSetter) valueSetter.call(element, value);
        else throw new Error('The given element does not have a value setter');
    }
}
Object.keys(eventAliasMap).forEach(function(aliasKey) {
    var key = eventAliasMap[aliasKey];
    fireEvent[aliasKey] = function() {
        var _fireEvent;
        return (_fireEvent = fireEvent)[key].apply(_fireEvent, arguments);
    };
});
/* eslint complexity:["error", 9] */ // WARNING: `lz-string` only has a default export but statically we assume named exports are allowed
function unindent(string) {
    // remove white spaces first, to save a few bytes.
    // testing-playground will reformat on load any ways.
    return string.replace(/[ \t]*[\n][ \t]*/g, '\n');
}
function encode(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($3szAT))).compressToEncodedURIComponent(unindent(value));
}
function getPlaygroundUrl(markup) {
    return "https://testing-playground.com/#markup=" + encode(markup);
}
var debug = function(element, maxLength, options) {
    return Array.isArray(element) ? element.forEach(function(el) {
        return logDOM(el, maxLength, options);
    }) : logDOM(element, maxLength, options);
};
var logTestingPlaygroundURL = function logTestingPlaygroundURL(element) {
    if (element === void 0) element = getDocument().body;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!element || !('innerHTML' in element)) {
        console.log("The element you're providing isn't a valid DOM element.");
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!element.innerHTML) {
        console.log("The provided element doesn't have any children.");
        return;
    }
    var playgroundUrl = getPlaygroundUrl(element.innerHTML);
    console.log("Open this URL in your browser\n\n" + playgroundUrl);
    return playgroundUrl;
};
var initialValue = {
    debug: debug,
    logTestingPlaygroundURL: logTestingPlaygroundURL
};
var screen = typeof document !== 'undefined' && document.body // eslint-disable-line @typescript-eslint/no-unnecessary-condition
 ? getQueriesForElement(document.body, queries, initialValue) : Object.keys(queries).reduce(function(helpers, key) {
    // `key` is for all intents and purposes the type of keyof `helpers`, which itself is the type of `initialValue` plus incoming properties from `queries`
    // if `Object.keys(something)` returned Array<keyof typeof something> this explicit type assertion would not be necessary
    // see https://stackoverflow.com/questions/55012174/why-doesnt-object-keys-return-a-keyof-type-in-typescript
    helpers[key] = function() {
        throw new TypeError('For queries bound to document.body a global document has to be available... Learn more: https://testing-library.com/s/screen-global-error');
    };
    return helpers;
}, initialValue);

});
parcelRegister("7k5I8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $554ed4b40b13e16f$export$71511d61b312f219; });
function $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $554ed4b40b13e16f$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $554ed4b40b13e16f$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("eRslx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ad1c00e896d27009$export$71511d61b312f219; });

var $hD5pT = parcelRequire("hD5pT");
function $ad1c00e896d27009$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $hD5pT._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("kJeRc", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f17388ede13a49cc$export$71511d61b312f219; });
function $f17388ede13a49cc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f17388ede13a49cc$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $f17388ede13a49cc$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("1dxAe", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0e310e53d1915a72$export$71511d61b312f219; });

var $34tHH = parcelRequire("34tHH");
function $0e310e53d1915a72$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = (0, $34tHH._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("34tHH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $23c8c95eb785a6d9$export$71511d61b312f219; });
function $23c8c95eb785a6d9$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("lFlDF", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $fc5e3658b603cf39$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $fc5e3658b603cf39$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $YtE9h = parcelRequire("YtE9h");
var $fc5e3658b603cf39$var$extendStatics = function extendStatics1(d, b) {
    $fc5e3658b603cf39$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $fc5e3658b603cf39$var$extendStatics(d, b);
};
function $fc5e3658b603cf39$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $fc5e3658b603cf39$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $fc5e3658b603cf39$export$18ce0697a983be9b = function __assign1() {
    $fc5e3658b603cf39$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $fc5e3658b603cf39$export$18ce0697a983be9b.apply(this, arguments);
};
function $fc5e3658b603cf39$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $fc5e3658b603cf39$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $fc5e3658b603cf39$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $fc5e3658b603cf39$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $fc5e3658b603cf39$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $fc5e3658b603cf39$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $YtE9h._)(x)) === "symbol" ? x : "".concat(x);
}
function $fc5e3658b603cf39$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $fc5e3658b603cf39$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $fc5e3658b603cf39$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $fc5e3658b603cf39$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $fc5e3658b603cf39$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $fc5e3658b603cf39$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $fc5e3658b603cf39$export$45d3717a4c69092e(o, m, p);
}
function $fc5e3658b603cf39$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $fc5e3658b603cf39$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $fc5e3658b603cf39$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fc5e3658b603cf39$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $fc5e3658b603cf39$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $fc5e3658b603cf39$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $fc5e3658b603cf39$export$10c90e4f7922046c(v) {
    return this instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? (this.v = v, this) : new $fc5e3658b603cf39$export$10c90e4f7922046c(v);
}
function $fc5e3658b603cf39$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $fc5e3658b603cf39$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $fc5e3658b603cf39$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $fc5e3658b603cf39$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $fc5e3658b603cf39$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $fc5e3658b603cf39$export$19a8beecd37a4c45 === "function" ? $fc5e3658b603cf39$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $fc5e3658b603cf39$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $fc5e3658b603cf39$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $fc5e3658b603cf39$var$ownKeys = function ownKeys1(o) {
    $fc5e3658b603cf39$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $fc5e3658b603cf39$var$ownKeys(o);
};
function $fc5e3658b603cf39$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $fc5e3658b603cf39$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $fc5e3658b603cf39$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $fc5e3658b603cf39$var$__setModuleDefault(result, mod);
    return result;
}
function $fc5e3658b603cf39$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $fc5e3658b603cf39$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $fc5e3658b603cf39$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $fc5e3658b603cf39$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $YtE9h._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $fc5e3658b603cf39$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $fc5e3658b603cf39$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $fc5e3658b603cf39$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $fc5e3658b603cf39$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $fc5e3658b603cf39$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $fc5e3658b603cf39$export$2e2bcd8739ae039 = {
    __extends: $fc5e3658b603cf39$export$a8ba968b8961cb8a,
    __assign: $fc5e3658b603cf39$export$18ce0697a983be9b,
    __rest: $fc5e3658b603cf39$export$3c9a16f847548506,
    __decorate: $fc5e3658b603cf39$export$29e00dfd3077644b,
    __param: $fc5e3658b603cf39$export$d5ad3fd78186038f,
    __esDecorate: $fc5e3658b603cf39$export$3a84e1ae4e97e9b0,
    __runInitializers: $fc5e3658b603cf39$export$d831c04e792af3d,
    __propKey: $fc5e3658b603cf39$export$6a2a36740a146cb8,
    __setFunctionName: $fc5e3658b603cf39$export$d1a06452d3489bc7,
    __metadata: $fc5e3658b603cf39$export$f1db080c865becb9,
    __awaiter: $fc5e3658b603cf39$export$1050f835b63b671e,
    __generator: $fc5e3658b603cf39$export$67ebef60e6f28a6,
    __createBinding: $fc5e3658b603cf39$export$45d3717a4c69092e,
    __exportStar: $fc5e3658b603cf39$export$f33643c0debef087,
    __values: $fc5e3658b603cf39$export$19a8beecd37a4c45,
    __read: $fc5e3658b603cf39$export$8d051b38c9118094,
    __spread: $fc5e3658b603cf39$export$afc72e2116322959,
    __spreadArrays: $fc5e3658b603cf39$export$6388937ca91ccae8,
    __spreadArray: $fc5e3658b603cf39$export$1216008129fb82ed,
    __await: $fc5e3658b603cf39$export$10c90e4f7922046c,
    __asyncGenerator: $fc5e3658b603cf39$export$e427f37a30a4de9b,
    __asyncDelegator: $fc5e3658b603cf39$export$bbd80228419bb833,
    __asyncValues: $fc5e3658b603cf39$export$e3b29a3d6162315f,
    __makeTemplateObject: $fc5e3658b603cf39$export$4fb47efe1390b86f,
    __importStar: $fc5e3658b603cf39$export$c21735bcef00d192,
    __importDefault: $fc5e3658b603cf39$export$da59b14a69baef04,
    __classPrivateFieldGet: $fc5e3658b603cf39$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $fc5e3658b603cf39$export$d40a35129aaff81f,
    __classPrivateFieldIn: $fc5e3658b603cf39$export$81fdc39f203e4e04,
    __addDisposableResource: $fc5e3658b603cf39$export$88ac25d8e944e405,
    __disposeResources: $fc5e3658b603cf39$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $fc5e3658b603cf39$export$889dfb5d17574b0b
};

});

parcelRegister("liMsA", function(module, exports) {

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $5dLwP = parcelRequire("5dLwP");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = module.exports.DEFAULT_OPTIONS = void 0;
module.exports.format = $f820de8d3588eb2a$var$format;
module.exports.plugins = void 0;

var $f820de8d3588eb2a$var$_ansiStyles = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("b7IGp")));

var $5F5iA = parcelRequire("5F5iA");

var $f820de8d3588eb2a$var$_AsymmetricMatcher = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("iQjAR")));

var $f820de8d3588eb2a$var$_ConvertAnsi = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("kW50u")));

var $f820de8d3588eb2a$var$_DOMCollection = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("hNwGK")));

var $f820de8d3588eb2a$var$_DOMElement = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("atktS")));

var $f820de8d3588eb2a$var$_Immutable = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("bzNvA")));

var $f820de8d3588eb2a$var$_ReactElement = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("7g49e")));

var $f820de8d3588eb2a$var$_ReactTestComponent = $f820de8d3588eb2a$var$_interopRequireDefault((parcelRequire("eFn2s")));
function $f820de8d3588eb2a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable local/ban-types-eventually */ var $f820de8d3588eb2a$var$toString = Object.prototype.toString;
var $f820de8d3588eb2a$var$toISOString = Date.prototype.toISOString;
var $f820de8d3588eb2a$var$errorToString = Error.prototype.toString;
var $f820de8d3588eb2a$var$regExpToString = RegExp.prototype.toString;
/**
 * Explicitly comparing typeof constructor to function avoids undefined as name
 * when mock identity-obj-proxy returns the key as the value for any key.
 */ var $f820de8d3588eb2a$var$getConstructorName = function(val) {
    return typeof val.constructor === 'function' && val.constructor.name || 'Object';
};
/* global window */ /** Is val is equal to global window object? Works even if it does not exist :) */ var $f820de8d3588eb2a$var$isWindow = function(val) {
    return typeof window !== 'undefined' && val === window;
};
var $f820de8d3588eb2a$var$SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;
var $f820de8d3588eb2a$var$NEWLINE_REGEXP = /\n/gi;
var $f820de8d3588eb2a$var$PrettyFormatPluginError = /*#__PURE__*/ function(Error1) {
    (0, $5dLwP._)(PrettyFormatPluginError, Error1);
    function PrettyFormatPluginError(message, stack) {
        (0, $bB0zn._)(this, PrettyFormatPluginError);
        var _this;
        _this = (0, $3Gvhd._)(this, PrettyFormatPluginError, [
            message
        ]);
        _this.stack = stack;
        _this.name = _this.constructor.name;
        return _this;
    }
    return PrettyFormatPluginError;
}((0, $fPaN7._)(Error));
function $f820de8d3588eb2a$var$isToStringedArrayType(toStringed) {
    return toStringed === '[object Array]' || toStringed === '[object ArrayBuffer]' || toStringed === '[object DataView]' || toStringed === '[object Float32Array]' || toStringed === '[object Float64Array]' || toStringed === '[object Int8Array]' || toStringed === '[object Int16Array]' || toStringed === '[object Int32Array]' || toStringed === '[object Uint8Array]' || toStringed === '[object Uint8ClampedArray]' || toStringed === '[object Uint16Array]' || toStringed === '[object Uint32Array]';
}
function $f820de8d3588eb2a$var$printNumber(val) {
    return Object.is(val, -0) ? '-0' : String(val);
}
function $f820de8d3588eb2a$var$printBigInt(val) {
    return String("".concat(val, "n"));
}
function $f820de8d3588eb2a$var$printFunction(val, printFunctionName) {
    if (!printFunctionName) return '[Function]';
    return '[Function ' + (val.name || 'anonymous') + ']';
}
function $f820de8d3588eb2a$var$printSymbol(val) {
    return String(val).replace($f820de8d3588eb2a$var$SYMBOL_REGEXP, 'Symbol($1)');
}
function $f820de8d3588eb2a$var$printError(val) {
    return '[' + $f820de8d3588eb2a$var$errorToString.call(val) + ']';
}
/**
 * The first port of call for printing an object, handles most of the
 * data-types in JS.
 */ function $f820de8d3588eb2a$var$printBasicValue(val, printFunctionName, escapeRegex, escapeString) {
    if (val === true || val === false) return '' + val;
    if (val === undefined) return 'undefined';
    if (val === null) return 'null';
    var typeOf = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    if (typeOf === 'number') return $f820de8d3588eb2a$var$printNumber(val);
    if (typeOf === 'bigint') return $f820de8d3588eb2a$var$printBigInt(val);
    if (typeOf === 'string') {
        if (escapeString) return '"' + val.replace(/"|\\/g, '\\$&') + '"';
        return '"' + val + '"';
    }
    if (typeOf === 'function') return $f820de8d3588eb2a$var$printFunction(val, printFunctionName);
    if (typeOf === 'symbol') return $f820de8d3588eb2a$var$printSymbol(val);
    var toStringed = $f820de8d3588eb2a$var$toString.call(val);
    if (toStringed === '[object WeakMap]') return 'WeakMap {}';
    if (toStringed === '[object WeakSet]') return 'WeakSet {}';
    if (toStringed === '[object Function]' || toStringed === '[object GeneratorFunction]') return $f820de8d3588eb2a$var$printFunction(val, printFunctionName);
    if (toStringed === '[object Symbol]') return $f820de8d3588eb2a$var$printSymbol(val);
    if (toStringed === '[object Date]') return isNaN(+val) ? 'Date { NaN }' : $f820de8d3588eb2a$var$toISOString.call(val);
    if (toStringed === '[object Error]') return $f820de8d3588eb2a$var$printError(val);
    if (toStringed === '[object RegExp]') {
        if (escapeRegex) // https://github.com/benjamingr/RegExp.escape/blob/main/polyfill.js
        return $f820de8d3588eb2a$var$regExpToString.call(val).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');
        return $f820de8d3588eb2a$var$regExpToString.call(val);
    }
    if (val instanceof Error) return $f820de8d3588eb2a$var$printError(val);
    return null;
}
/**
 * Handles more complex objects ( such as objects with circular references.
 * maps and sets etc )
 */ function $f820de8d3588eb2a$var$printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON) {
    if (refs.indexOf(val) !== -1) return '[Circular]';
    refs = refs.slice();
    refs.push(val);
    var hitMaxDepth = ++depth > config.maxDepth;
    var min = config.min;
    if (config.callToJSON && !hitMaxDepth && val.toJSON && typeof val.toJSON === 'function' && !hasCalledToJSON) return $f820de8d3588eb2a$var$printer(val.toJSON(), config, indentation, depth, refs, true);
    var toStringed = $f820de8d3588eb2a$var$toString.call(val);
    if (toStringed === '[object Arguments]') return hitMaxDepth ? '[Arguments]' : (min ? '' : 'Arguments ') + '[' + (0, $5F5iA.printListItems)(val, config, indentation, depth, refs, $f820de8d3588eb2a$var$printer) + ']';
    if ($f820de8d3588eb2a$var$isToStringedArrayType(toStringed)) return hitMaxDepth ? '[' + val.constructor.name + ']' : (min ? '' : !config.printBasicPrototype && val.constructor.name === 'Array' ? '' : val.constructor.name + ' ') + '[' + (0, $5F5iA.printListItems)(val, config, indentation, depth, refs, $f820de8d3588eb2a$var$printer) + ']';
    if (toStringed === '[object Map]') return hitMaxDepth ? '[Map]' : 'Map {' + (0, $5F5iA.printIteratorEntries)(val.entries(), config, indentation, depth, refs, $f820de8d3588eb2a$var$printer, ' => ') + '}';
    if (toStringed === '[object Set]') return hitMaxDepth ? '[Set]' : 'Set {' + (0, $5F5iA.printIteratorValues)(val.values(), config, indentation, depth, refs, $f820de8d3588eb2a$var$printer) + '}';
     // Avoid failure to serialize global window object in jsdom test environment.
    // For example, not even relevant if window is prop of React element.
    return hitMaxDepth || $f820de8d3588eb2a$var$isWindow(val) ? '[' + $f820de8d3588eb2a$var$getConstructorName(val) + ']' : (min ? '' : !config.printBasicPrototype && $f820de8d3588eb2a$var$getConstructorName(val) === 'Object' ? '' : $f820de8d3588eb2a$var$getConstructorName(val) + ' ') + '{' + (0, $5F5iA.printObjectProperties)(val, config, indentation, depth, refs, $f820de8d3588eb2a$var$printer) + '}';
}
function $f820de8d3588eb2a$var$isNewPlugin(plugin) {
    return plugin.serialize != null;
}
function $f820de8d3588eb2a$var$printPlugin(plugin, val, config, indentation, depth, refs) {
    var printed;
    try {
        printed = $f820de8d3588eb2a$var$isNewPlugin(plugin) ? plugin.serialize(val, config, indentation, depth, refs, $f820de8d3588eb2a$var$printer) : plugin.print(val, function(valChild) {
            return $f820de8d3588eb2a$var$printer(valChild, config, indentation, depth, refs);
        }, function(str) {
            var indentationNext = indentation + config.indent;
            return indentationNext + str.replace($f820de8d3588eb2a$var$NEWLINE_REGEXP, '\n' + indentationNext);
        }, {
            edgeSpacing: config.spacingOuter,
            min: config.min,
            spacing: config.spacingInner
        }, config.colors);
    } catch (error) {
        throw new $f820de8d3588eb2a$var$PrettyFormatPluginError(error.message, error.stack);
    }
    if (typeof printed !== 'string') throw new Error('pretty-format: Plugin must return type "string" but instead returned "'.concat(typeof printed === "undefined" ? "undefined" : (0, $YtE9h._)(printed), '".'));
    return printed;
}
function $f820de8d3588eb2a$var$findPlugin(plugins, val) {
    for(var p = 0; p < plugins.length; p++)try {
        if (plugins[p].test(val)) return plugins[p];
    } catch (error) {
        throw new $f820de8d3588eb2a$var$PrettyFormatPluginError(error.message, error.stack);
    }
    return null;
}
function $f820de8d3588eb2a$var$printer(val, config, indentation, depth, refs, hasCalledToJSON) {
    var plugin = $f820de8d3588eb2a$var$findPlugin(config.plugins, val);
    if (plugin !== null) return $f820de8d3588eb2a$var$printPlugin(plugin, val, config, indentation, depth, refs);
    var basicResult = $f820de8d3588eb2a$var$printBasicValue(val, config.printFunctionName, config.escapeRegex, config.escapeString);
    if (basicResult !== null) return basicResult;
    return $f820de8d3588eb2a$var$printComplexValue(val, config, indentation, depth, refs, hasCalledToJSON);
}
var $f820de8d3588eb2a$var$DEFAULT_THEME = {
    comment: 'gray',
    content: 'reset',
    prop: 'yellow',
    tag: 'cyan',
    value: 'green'
};
var $f820de8d3588eb2a$var$DEFAULT_THEME_KEYS = Object.keys($f820de8d3588eb2a$var$DEFAULT_THEME);
var $f820de8d3588eb2a$var$DEFAULT_OPTIONS = {
    callToJSON: true,
    compareKeys: undefined,
    escapeRegex: false,
    escapeString: true,
    highlight: false,
    indent: 2,
    maxDepth: Infinity,
    min: false,
    plugins: [],
    printBasicPrototype: true,
    printFunctionName: true,
    theme: $f820de8d3588eb2a$var$DEFAULT_THEME
};
module.exports.DEFAULT_OPTIONS = $f820de8d3588eb2a$var$DEFAULT_OPTIONS;
function $f820de8d3588eb2a$var$validateOptions(options) {
    Object.keys(options).forEach(function(key) {
        if (!$f820de8d3588eb2a$var$DEFAULT_OPTIONS.hasOwnProperty(key)) throw new Error('pretty-format: Unknown option "'.concat(key, '".'));
    });
    if (options.min && options.indent !== undefined && options.indent !== 0) throw new Error('pretty-format: Options "min" and "indent" cannot be used together.');
    if (options.theme !== undefined) {
        if (options.theme === null) throw new Error('pretty-format: Option "theme" must not be null.');
        if ((0, $YtE9h._)(options.theme) !== 'object') throw new Error('pretty-format: Option "theme" must be of type "object" but instead received "'.concat((0, $YtE9h._)(options.theme), '".'));
    }
}
var $f820de8d3588eb2a$var$getColorsHighlight = function(options) {
    return $f820de8d3588eb2a$var$DEFAULT_THEME_KEYS.reduce(function(colors, key) {
        var value = options.theme && options.theme[key] !== undefined ? options.theme[key] : $f820de8d3588eb2a$var$DEFAULT_THEME[key];
        var color = value && $f820de8d3588eb2a$var$_ansiStyles.default[value];
        if (color && typeof color.close === 'string' && typeof color.open === 'string') colors[key] = color;
        else throw new Error('pretty-format: Option "theme" has a key "'.concat(key, '" whose value "').concat(value, '" is undefined in ansi-styles.'));
        return colors;
    }, Object.create(null));
};
var $f820de8d3588eb2a$var$getColorsEmpty = function() {
    return $f820de8d3588eb2a$var$DEFAULT_THEME_KEYS.reduce(function(colors, key) {
        colors[key] = {
            close: '',
            open: ''
        };
        return colors;
    }, Object.create(null));
};
var $f820de8d3588eb2a$var$getPrintFunctionName = function(options) {
    return options && options.printFunctionName !== undefined ? options.printFunctionName : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.printFunctionName;
};
var $f820de8d3588eb2a$var$getEscapeRegex = function(options) {
    return options && options.escapeRegex !== undefined ? options.escapeRegex : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.escapeRegex;
};
var $f820de8d3588eb2a$var$getEscapeString = function(options) {
    return options && options.escapeString !== undefined ? options.escapeString : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.escapeString;
};
var $f820de8d3588eb2a$var$getConfig = function(options) {
    var _options$printBasicPr;
    return {
        callToJSON: options && options.callToJSON !== undefined ? options.callToJSON : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.callToJSON,
        colors: options && options.highlight ? $f820de8d3588eb2a$var$getColorsHighlight(options) : $f820de8d3588eb2a$var$getColorsEmpty(),
        compareKeys: options && typeof options.compareKeys === 'function' ? options.compareKeys : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.compareKeys,
        escapeRegex: $f820de8d3588eb2a$var$getEscapeRegex(options),
        escapeString: $f820de8d3588eb2a$var$getEscapeString(options),
        indent: options && options.min ? '' : $f820de8d3588eb2a$var$createIndent(options && options.indent !== undefined ? options.indent : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.indent),
        maxDepth: options && options.maxDepth !== undefined ? options.maxDepth : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.maxDepth,
        min: options && options.min !== undefined ? options.min : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.min,
        plugins: options && options.plugins !== undefined ? options.plugins : $f820de8d3588eb2a$var$DEFAULT_OPTIONS.plugins,
        printBasicPrototype: (_options$printBasicPr = options === null || options === void 0 ? void 0 : options.printBasicPrototype) !== null && _options$printBasicPr !== void 0 ? _options$printBasicPr : true,
        printFunctionName: $f820de8d3588eb2a$var$getPrintFunctionName(options),
        spacingInner: options && options.min ? ' ' : '\n',
        spacingOuter: options && options.min ? '' : '\n'
    };
};
function $f820de8d3588eb2a$var$createIndent(indent) {
    return new Array(indent + 1).join(' ');
}
/**
 * Returns a presentation string of your `val` object
 * @param val any potential JavaScript object
 * @param options Custom settings
 */ function $f820de8d3588eb2a$var$format(val, options) {
    if (options) {
        $f820de8d3588eb2a$var$validateOptions(options);
        if (options.plugins) {
            var plugin = $f820de8d3588eb2a$var$findPlugin(options.plugins, val);
            if (plugin !== null) return $f820de8d3588eb2a$var$printPlugin(plugin, val, $f820de8d3588eb2a$var$getConfig(options), '', 0, []);
        }
    }
    var basicResult = $f820de8d3588eb2a$var$printBasicValue(val, $f820de8d3588eb2a$var$getPrintFunctionName(options), $f820de8d3588eb2a$var$getEscapeRegex(options), $f820de8d3588eb2a$var$getEscapeString(options));
    if (basicResult !== null) return basicResult;
    return $f820de8d3588eb2a$var$printComplexValue(val, $f820de8d3588eb2a$var$getConfig(options), '', 0, []);
}
var $f820de8d3588eb2a$var$plugins = {
    AsymmetricMatcher: $f820de8d3588eb2a$var$_AsymmetricMatcher.default,
    ConvertAnsi: $f820de8d3588eb2a$var$_ConvertAnsi.default,
    DOMCollection: $f820de8d3588eb2a$var$_DOMCollection.default,
    DOMElement: $f820de8d3588eb2a$var$_DOMElement.default,
    Immutable: $f820de8d3588eb2a$var$_Immutable.default,
    ReactElement: $f820de8d3588eb2a$var$_ReactElement.default,
    ReactTestComponent: $f820de8d3588eb2a$var$_ReactTestComponent.default
};
module.exports.plugins = $f820de8d3588eb2a$var$plugins;
var $f820de8d3588eb2a$var$_default = $f820de8d3588eb2a$var$format;
module.exports.default = $f820de8d3588eb2a$var$_default;

});
parcelRegister("b7IGp", function(module, exports) {

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");
'use strict';
var ANSI_BACKGROUND_OFFSET = 10;
var wrapAnsi256 = function() {
    var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return function(code) {
        return "\x1b[".concat(38 + offset, ";5;").concat(code, "m");
    };
};
var wrapAnsi16m = function() {
    var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return function(red, green, blue) {
        return "\x1b[".concat(38 + offset, ";2;").concat(red, ";").concat(green, ";").concat(blue, "m");
    };
};
function assembleStyles() {
    var _styles;
    var codes = new Map();
    var styles = {
        modifier: {
            reset: [
                0,
                0
            ],
            // 21 isn't widely supported and 22 does the same thing
            bold: [
                1,
                22
            ],
            dim: [
                2,
                22
            ],
            italic: [
                3,
                23
            ],
            underline: [
                4,
                24
            ],
            overline: [
                53,
                55
            ],
            inverse: [
                7,
                27
            ],
            hidden: [
                8,
                28
            ],
            strikethrough: [
                9,
                29
            ]
        },
        color: {
            black: [
                30,
                39
            ],
            red: [
                31,
                39
            ],
            green: [
                32,
                39
            ],
            yellow: [
                33,
                39
            ],
            blue: [
                34,
                39
            ],
            magenta: [
                35,
                39
            ],
            cyan: [
                36,
                39
            ],
            white: [
                37,
                39
            ],
            // Bright color
            blackBright: [
                90,
                39
            ],
            redBright: [
                91,
                39
            ],
            greenBright: [
                92,
                39
            ],
            yellowBright: [
                93,
                39
            ],
            blueBright: [
                94,
                39
            ],
            magentaBright: [
                95,
                39
            ],
            cyanBright: [
                96,
                39
            ],
            whiteBright: [
                97,
                39
            ]
        },
        bgColor: {
            bgBlack: [
                40,
                49
            ],
            bgRed: [
                41,
                49
            ],
            bgGreen: [
                42,
                49
            ],
            bgYellow: [
                43,
                49
            ],
            bgBlue: [
                44,
                49
            ],
            bgMagenta: [
                45,
                49
            ],
            bgCyan: [
                46,
                49
            ],
            bgWhite: [
                47,
                49
            ],
            // Bright color
            bgBlackBright: [
                100,
                49
            ],
            bgRedBright: [
                101,
                49
            ],
            bgGreenBright: [
                102,
                49
            ],
            bgYellowBright: [
                103,
                49
            ],
            bgBlueBright: [
                104,
                49
            ],
            bgMagentaBright: [
                105,
                49
            ],
            bgCyanBright: [
                106,
                49
            ],
            bgWhiteBright: [
                107,
                49
            ]
        }
    };
    // Alias bright black as gray (and grey)
    styles.color.gray = styles.color.blackBright;
    styles.bgColor.bgGray = styles.bgColor.bgBlackBright;
    styles.color.grey = styles.color.blackBright;
    styles.bgColor.bgGrey = styles.bgColor.bgBlackBright;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(styles)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), groupName = _step_value[0], group = _step_value[1];
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.entries(group)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value1 = (0, $kB67t._)(_step1.value, 2), styleName = _step_value1[0], style = _step_value1[1];
                    styles[styleName] = {
                        open: "\x1b[".concat(style[0], "m"),
                        close: "\x1b[".concat(style[1], "m")
                    };
                    group[styleName] = styles[styleName];
                    codes.set(style[0], style[1]);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            Object.defineProperty(styles, groupName, {
                value: group,
                enumerable: false
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    Object.defineProperty(styles, 'codes', {
        value: codes,
        enumerable: false
    });
    styles.color.close = '\u001B[39m';
    styles.bgColor.close = '\u001B[49m';
    styles.color.ansi256 = wrapAnsi256();
    styles.color.ansi16m = wrapAnsi16m();
    styles.bgColor.ansi256 = wrapAnsi256(ANSI_BACKGROUND_OFFSET);
    styles.bgColor.ansi16m = wrapAnsi16m(ANSI_BACKGROUND_OFFSET);
    // From https://github.com/Qix-/color-convert/blob/3f0e0d4e92e235796ccb17f6e85c72094a651f49/conversions.js
    Object.defineProperties(styles, {
        rgbToAnsi256: {
            value: function(red, green, blue) {
                // We use the extended greyscale palette here, with the exception of
                // black and white. normal palette only has 4 greyscale shades.
                if (red === green && green === blue) {
                    if (red < 8) return 16;
                    if (red > 248) return 231;
                    return Math.round((red - 8) / 247 * 24) + 232;
                }
                return 16 + 36 * Math.round(red / 255 * 5) + 6 * Math.round(green / 255 * 5) + Math.round(blue / 255 * 5);
            },
            enumerable: false
        },
        hexToRgb: {
            value: function(hex) {
                var matches = RegExp("(?<colorString>[a-f\\d]{6}|[a-f\\d]{3})", "i").exec(hex.toString(16));
                if (!matches) return [
                    0,
                    0,
                    0
                ];
                var colorString = matches.groups.colorString;
                if (colorString.length === 3) colorString = colorString.split('').map(function(character) {
                    return character + character;
                }).join('');
                var integer = Number.parseInt(colorString, 16);
                return [
                    integer >> 16 & 0xFF,
                    integer >> 8 & 0xFF,
                    integer & 0xFF
                ];
            },
            enumerable: false
        },
        hexToAnsi256: {
            value: function(hex) {
                return (_styles = styles).rgbToAnsi256.apply(_styles, (0, $2Xzd1._)(styles.hexToRgb(hex)));
            },
            enumerable: false
        }
    });
    return styles;
}
// Make the export immutable
Object.defineProperty(module, 'exports', {
    enumerable: true,
    get: assembleStyles
});

});

parcelRegister("5F5iA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.printIteratorEntries = $41f4e454b74714a0$var$printIteratorEntries;
module.exports.printIteratorValues = $41f4e454b74714a0$var$printIteratorValues;
module.exports.printListItems = $41f4e454b74714a0$var$printListItems;
module.exports.printObjectProperties = $41f4e454b74714a0$var$printObjectProperties;
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ var $41f4e454b74714a0$var$getKeysOfEnumerableProperties = function(object, compareKeys) {
    var keys = Object.keys(object).sort(compareKeys);
    if (Object.getOwnPropertySymbols) Object.getOwnPropertySymbols(object).forEach(function(symbol) {
        if (Object.getOwnPropertyDescriptor(object, symbol).enumerable) keys.push(symbol);
    });
    return keys;
};
/**
 * Return entries (for example, of a map)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */ function $41f4e454b74714a0$var$printIteratorEntries(iterator, config, indentation, depth, refs, printer) {
    var // What a distracting diff if you change a data structure to/from
    // ECMAScript Object or Immutable.Map/OrderedMap which use the default.
    separator = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : ': ';
    var result = '';
    var current = iterator.next();
    if (!current.done) {
        result += config.spacingOuter;
        var indentationNext = indentation + config.indent;
        while(!current.done){
            var name = printer(current.value[0], config, indentationNext, depth, refs);
            var value = printer(current.value[1], config, indentationNext, depth, refs);
            result += indentationNext + name + separator + value;
            current = iterator.next();
            if (!current.done) result += ',' + config.spacingInner;
            else if (!config.min) result += ',';
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
/**
 * Return values (for example, of a set)
 * with spacing, indentation, and comma
 * without surrounding punctuation (braces or brackets)
 */ function $41f4e454b74714a0$var$printIteratorValues(iterator, config, indentation, depth, refs, printer) {
    var result = '';
    var current = iterator.next();
    if (!current.done) {
        result += config.spacingOuter;
        var indentationNext = indentation + config.indent;
        while(!current.done){
            result += indentationNext + printer(current.value, config, indentationNext, depth, refs);
            current = iterator.next();
            if (!current.done) result += ',' + config.spacingInner;
            else if (!config.min) result += ',';
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
/**
 * Return items (for example, of an array)
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, brackets)
 **/ function $41f4e454b74714a0$var$printListItems(list, config, indentation, depth, refs, printer) {
    var result = '';
    if (list.length) {
        result += config.spacingOuter;
        var indentationNext = indentation + config.indent;
        for(var i = 0; i < list.length; i++){
            result += indentationNext;
            if (i in list) result += printer(list[i], config, indentationNext, depth, refs);
            if (i < list.length - 1) result += ',' + config.spacingInner;
            else if (!config.min) result += ',';
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}
/**
 * Return properties of an object
 * with spacing, indentation, and comma
 * without surrounding punctuation (for example, braces)
 */ function $41f4e454b74714a0$var$printObjectProperties(val, config, indentation, depth, refs, printer) {
    var result = '';
    var keys = $41f4e454b74714a0$var$getKeysOfEnumerableProperties(val, config.compareKeys);
    if (keys.length) {
        result += config.spacingOuter;
        var indentationNext = indentation + config.indent;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            var name = printer(key, config, indentationNext, depth, refs);
            var value = printer(val[key], config, indentationNext, depth, refs);
            result += indentationNext + name + ': ' + value;
            if (i < keys.length - 1) result += ',' + config.spacingInner;
            else if (!config.min) result += ',';
        }
        result += config.spacingOuter + indentation;
    }
    return result;
}

});

parcelRegister("iQjAR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.test = module.exports.serialize = module.exports.default = void 0;

var $5F5iA = parcelRequire("5F5iA");
var $db7c483213503c63$var$global = function() {
    if (typeof globalThis !== 'undefined') return globalThis;
    else if (typeof $db7c483213503c63$var$global !== 'undefined') return $db7c483213503c63$var$global;
    else if (typeof self !== 'undefined') return self;
    else if (typeof window !== 'undefined') return window;
    else return Function('return this')();
}();
var $db7c483213503c63$var$Symbol = $db7c483213503c63$var$global['jest-symbol-do-not-touch'] || $db7c483213503c63$var$global.Symbol;
var $db7c483213503c63$var$asymmetricMatcher = typeof $db7c483213503c63$var$Symbol === 'function' && $db7c483213503c63$var$Symbol.for ? $db7c483213503c63$var$Symbol.for('jest.asymmetricMatcher') : 0x1357a5;
var $db7c483213503c63$var$SPACE = ' ';
var $db7c483213503c63$var$serialize = function(val, config, indentation, depth, refs, printer) {
    var stringedValue = val.toString();
    if (stringedValue === 'ArrayContaining' || stringedValue === 'ArrayNotContaining') {
        if (++depth > config.maxDepth) return '[' + stringedValue + ']';
        return stringedValue + $db7c483213503c63$var$SPACE + '[' + (0, $5F5iA.printListItems)(val.sample, config, indentation, depth, refs, printer) + ']';
    }
    if (stringedValue === 'ObjectContaining' || stringedValue === 'ObjectNotContaining') {
        if (++depth > config.maxDepth) return '[' + stringedValue + ']';
        return stringedValue + $db7c483213503c63$var$SPACE + '{' + (0, $5F5iA.printObjectProperties)(val.sample, config, indentation, depth, refs, printer) + '}';
    }
    if (stringedValue === 'StringMatching' || stringedValue === 'StringNotMatching') return stringedValue + $db7c483213503c63$var$SPACE + printer(val.sample, config, indentation, depth, refs);
    if (stringedValue === 'StringContaining' || stringedValue === 'StringNotContaining') return stringedValue + $db7c483213503c63$var$SPACE + printer(val.sample, config, indentation, depth, refs);
    return val.toAsymmetricMatcher();
};
module.exports.serialize = $db7c483213503c63$var$serialize;
var $db7c483213503c63$var$test = function(val) {
    return val && val.$$typeof === $db7c483213503c63$var$asymmetricMatcher;
};
module.exports.test = $db7c483213503c63$var$test;
var $db7c483213503c63$var$plugin = {
    serialize: $db7c483213503c63$var$serialize,
    test: $db7c483213503c63$var$test
};
var $db7c483213503c63$var$_default = $db7c483213503c63$var$plugin;
module.exports.default = $db7c483213503c63$var$_default;

});

parcelRegister("kW50u", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.test = module.exports.serialize = module.exports.default = void 0;

var $f3dd1bb4dc27f80f$var$_ansiRegex = $f3dd1bb4dc27f80f$var$_interopRequireDefault((parcelRequire("aIodq")));

var $f3dd1bb4dc27f80f$var$_ansiStyles = $f3dd1bb4dc27f80f$var$_interopRequireDefault((parcelRequire("b7IGp")));
function $f3dd1bb4dc27f80f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f3dd1bb4dc27f80f$var$toHumanReadableAnsi = function(text) {
    return text.replace((0, $f3dd1bb4dc27f80f$var$_ansiRegex.default)(), function(match) {
        switch(match){
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.red.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.green.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.cyan.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.gray.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.white.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.yellow.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bgRed.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bgGreen.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bgYellow.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.inverse.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.dim.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bold.close:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.reset.open:
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.reset.close:
                return '</>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.red.open:
                return '<red>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.green.open:
                return '<green>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.cyan.open:
                return '<cyan>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.gray.open:
                return '<gray>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.white.open:
                return '<white>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.yellow.open:
                return '<yellow>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bgRed.open:
                return '<bgRed>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bgGreen.open:
                return '<bgGreen>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bgYellow.open:
                return '<bgYellow>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.inverse.open:
                return '<inverse>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.dim.open:
                return '<dim>';
            case $f3dd1bb4dc27f80f$var$_ansiStyles.default.bold.open:
                return '<bold>';
            default:
                return '';
        }
    });
};
var $f3dd1bb4dc27f80f$var$test = function(val) {
    return typeof val === 'string' && !!val.match((0, $f3dd1bb4dc27f80f$var$_ansiRegex.default)());
};
module.exports.test = $f3dd1bb4dc27f80f$var$test;
var $f3dd1bb4dc27f80f$var$serialize = function(val, config, indentation, depth, refs, printer) {
    return printer($f3dd1bb4dc27f80f$var$toHumanReadableAnsi(val), config, indentation, depth, refs);
};
module.exports.serialize = $f3dd1bb4dc27f80f$var$serialize;
var $f3dd1bb4dc27f80f$var$plugin = {
    serialize: $f3dd1bb4dc27f80f$var$serialize,
    test: $f3dd1bb4dc27f80f$var$test
};
var $f3dd1bb4dc27f80f$var$_default = $f3dd1bb4dc27f80f$var$plugin;
module.exports.default = $f3dd1bb4dc27f80f$var$_default;

});
parcelRegister("aIodq", function(module, exports) {
'use strict';
module.exports = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_onlyFirst = _ref.onlyFirst, onlyFirst = _ref_onlyFirst === void 0 ? false : _ref_onlyFirst;
    var pattern = [
        '[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)',
        '(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))'
    ].join('|');
    return new RegExp(pattern, onlyFirst ? undefined : 'g');
};

});


parcelRegister("hNwGK", function(module, exports) {

var $eRslx = parcelRequire("eRslx");
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.test = module.exports.serialize = module.exports.default = void 0;

var $5F5iA = parcelRequire("5F5iA");
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /* eslint-disable local/ban-types-eventually */ var $cf505e8435817dc9$var$SPACE = ' ';
var $cf505e8435817dc9$var$OBJECT_NAMES = [
    'DOMStringMap',
    'NamedNodeMap'
];
var $cf505e8435817dc9$var$ARRAY_REGEXP = /^(HTML\w*Collection|NodeList)$/;
var $cf505e8435817dc9$var$testName = function(name) {
    return $cf505e8435817dc9$var$OBJECT_NAMES.indexOf(name) !== -1 || $cf505e8435817dc9$var$ARRAY_REGEXP.test(name);
};
var $cf505e8435817dc9$var$test = function(val) {
    return val && val.constructor && !!val.constructor.name && $cf505e8435817dc9$var$testName(val.constructor.name);
};
module.exports.test = $cf505e8435817dc9$var$test;
var $cf505e8435817dc9$var$isNamedNodeMap = function(collection) {
    return collection.constructor.name === 'NamedNodeMap';
};
var $cf505e8435817dc9$var$serialize = function(collection, config, indentation, depth, refs, printer) {
    var name = collection.constructor.name;
    if (++depth > config.maxDepth) return '[' + name + ']';
    return (config.min ? '' : name + $cf505e8435817dc9$var$SPACE) + ($cf505e8435817dc9$var$OBJECT_NAMES.indexOf(name) !== -1 ? '{' + (0, $5F5iA.printObjectProperties)($cf505e8435817dc9$var$isNamedNodeMap(collection) ? Array.from(collection).reduce(function(props, attribute) {
        props[attribute.name] = attribute.value;
        return props;
    }, {}) : (0, $eRslx._)({}, collection), config, indentation, depth, refs, printer) + '}' : '[' + (0, $5F5iA.printListItems)(Array.from(collection), config, indentation, depth, refs, printer) + ']');
};
module.exports.serialize = $cf505e8435817dc9$var$serialize;
var $cf505e8435817dc9$var$plugin = {
    serialize: $cf505e8435817dc9$var$serialize,
    test: $cf505e8435817dc9$var$test
};
var $cf505e8435817dc9$var$_default = $cf505e8435817dc9$var$plugin;
module.exports.default = $cf505e8435817dc9$var$_default;

});

parcelRegister("atktS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.test = module.exports.serialize = module.exports.default = void 0;

var $Ztuzc = parcelRequire("Ztuzc");
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $79fc7fdfb8bdc1a7$var$ELEMENT_NODE = 1;
var $79fc7fdfb8bdc1a7$var$TEXT_NODE = 3;
var $79fc7fdfb8bdc1a7$var$COMMENT_NODE = 8;
var $79fc7fdfb8bdc1a7$var$FRAGMENT_NODE = 11;
var $79fc7fdfb8bdc1a7$var$ELEMENT_REGEXP = /^((HTML|SVG)\w*)?Element$/;
var $79fc7fdfb8bdc1a7$var$testHasAttribute = function(val) {
    try {
        return typeof val.hasAttribute === 'function' && val.hasAttribute('is');
    } catch (e) {
        return false;
    }
};
var $79fc7fdfb8bdc1a7$var$testNode = function(val) {
    var constructorName = val.constructor.name;
    var nodeType = val.nodeType, tagName = val.tagName;
    var isCustomElement = typeof tagName === 'string' && tagName.includes('-') || $79fc7fdfb8bdc1a7$var$testHasAttribute(val);
    return nodeType === $79fc7fdfb8bdc1a7$var$ELEMENT_NODE && ($79fc7fdfb8bdc1a7$var$ELEMENT_REGEXP.test(constructorName) || isCustomElement) || nodeType === $79fc7fdfb8bdc1a7$var$TEXT_NODE && constructorName === 'Text' || nodeType === $79fc7fdfb8bdc1a7$var$COMMENT_NODE && constructorName === 'Comment' || nodeType === $79fc7fdfb8bdc1a7$var$FRAGMENT_NODE && constructorName === 'DocumentFragment';
};
var $79fc7fdfb8bdc1a7$var$test = function(val) {
    var _val$constructor;
    return (val === null || val === void 0 ? void 0 : (_val$constructor = val.constructor) === null || _val$constructor === void 0 ? void 0 : _val$constructor.name) && $79fc7fdfb8bdc1a7$var$testNode(val);
};
module.exports.test = $79fc7fdfb8bdc1a7$var$test;
function $79fc7fdfb8bdc1a7$var$nodeIsText(node) {
    return node.nodeType === $79fc7fdfb8bdc1a7$var$TEXT_NODE;
}
function $79fc7fdfb8bdc1a7$var$nodeIsComment(node) {
    return node.nodeType === $79fc7fdfb8bdc1a7$var$COMMENT_NODE;
}
function $79fc7fdfb8bdc1a7$var$nodeIsFragment(node) {
    return node.nodeType === $79fc7fdfb8bdc1a7$var$FRAGMENT_NODE;
}
var $79fc7fdfb8bdc1a7$var$serialize = function(node, config, indentation, depth, refs, printer) {
    if ($79fc7fdfb8bdc1a7$var$nodeIsText(node)) return (0, $Ztuzc.printText)(node.data, config);
    if ($79fc7fdfb8bdc1a7$var$nodeIsComment(node)) return (0, $Ztuzc.printComment)(node.data, config);
    var type = $79fc7fdfb8bdc1a7$var$nodeIsFragment(node) ? 'DocumentFragment' : node.tagName.toLowerCase();
    if (++depth > config.maxDepth) return (0, $Ztuzc.printElementAsLeaf)(type, config);
    return (0, $Ztuzc.printElement)(type, (0, $Ztuzc.printProps)($79fc7fdfb8bdc1a7$var$nodeIsFragment(node) ? [] : Array.from(node.attributes).map(function(attr) {
        return attr.name;
    }).sort(), $79fc7fdfb8bdc1a7$var$nodeIsFragment(node) ? {} : Array.from(node.attributes).reduce(function(props, attribute) {
        props[attribute.name] = attribute.value;
        return props;
    }, {}), config, indentation + config.indent, depth, refs, printer), (0, $Ztuzc.printChildren)(Array.prototype.slice.call(node.childNodes || node.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
};
module.exports.serialize = $79fc7fdfb8bdc1a7$var$serialize;
var $79fc7fdfb8bdc1a7$var$plugin = {
    serialize: $79fc7fdfb8bdc1a7$var$serialize,
    test: $79fc7fdfb8bdc1a7$var$test
};
var $79fc7fdfb8bdc1a7$var$_default = $79fc7fdfb8bdc1a7$var$plugin;
module.exports.default = $79fc7fdfb8bdc1a7$var$_default;

});
parcelRegister("Ztuzc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.printText = module.exports.printProps = module.exports.printElementAsLeaf = module.exports.printElement = module.exports.printComment = module.exports.printChildren = void 0;

var $0b8c931e6847eea3$var$_escapeHTML = $0b8c931e6847eea3$var$_interopRequireDefault((parcelRequire("7KuWj")));
function $0b8c931e6847eea3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Return empty string if keys is empty.
var $0b8c931e6847eea3$var$printProps = function(keys, props, config, indentation, depth, refs, printer) {
    var indentationNext = indentation + config.indent;
    var colors = config.colors;
    return keys.map(function(key) {
        var value = props[key];
        var printed = printer(value, config, indentationNext, depth, refs);
        if (typeof value !== 'string') {
            if (printed.indexOf('\n') !== -1) printed = config.spacingOuter + indentationNext + printed + config.spacingOuter + indentation;
            printed = '{' + printed + '}';
        }
        return config.spacingInner + indentation + colors.prop.open + key + colors.prop.close + '=' + colors.value.open + printed + colors.value.close;
    }).join('');
}; // Return empty string if children is empty.
module.exports.printProps = $0b8c931e6847eea3$var$printProps;
var $0b8c931e6847eea3$var$printChildren = function(children, config, indentation, depth, refs, printer) {
    return children.map(function(child) {
        return config.spacingOuter + indentation + (typeof child === 'string' ? $0b8c931e6847eea3$var$printText(child, config) : printer(child, config, indentation, depth, refs));
    }).join('');
};
module.exports.printChildren = $0b8c931e6847eea3$var$printChildren;
var $0b8c931e6847eea3$var$printText = function(text, config) {
    var contentColor = config.colors.content;
    return contentColor.open + (0, $0b8c931e6847eea3$var$_escapeHTML.default)(text) + contentColor.close;
};
module.exports.printText = $0b8c931e6847eea3$var$printText;
var $0b8c931e6847eea3$var$printComment = function(comment, config) {
    var commentColor = config.colors.comment;
    return commentColor.open + '<!--' + (0, $0b8c931e6847eea3$var$_escapeHTML.default)(comment) + '-->' + commentColor.close;
}; // Separate the functions to format props, children, and element,
// so a plugin could override a particular function, if needed.
// Too bad, so sad: the traditional (but unnecessary) space
// in a self-closing tagColor requires a second test of printedProps.
module.exports.printComment = $0b8c931e6847eea3$var$printComment;
var $0b8c931e6847eea3$var$printElement = function(type, printedProps, printedChildren, config, indentation) {
    var tagColor = config.colors.tag;
    return tagColor.open + '<' + type + (printedProps && tagColor.close + printedProps + config.spacingOuter + indentation + tagColor.open) + (printedChildren ? '>' + tagColor.close + printedChildren + config.spacingOuter + indentation + tagColor.open + '</' + type : (printedProps && !config.min ? '' : ' ') + '/') + '>' + tagColor.close;
};
module.exports.printElement = $0b8c931e6847eea3$var$printElement;
var $0b8c931e6847eea3$var$printElementAsLeaf = function(type, config) {
    var tagColor = config.colors.tag;
    return tagColor.open + '<' + type + tagColor.close + " \u2026" + tagColor.open + ' />' + tagColor.close;
};
module.exports.printElementAsLeaf = $0b8c931e6847eea3$var$printElementAsLeaf;

});
parcelRegister("7KuWj", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = $5a44d43758721066$var$escapeHTML;
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $5a44d43758721066$var$escapeHTML(str) {
    return str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

});



parcelRegister("bzNvA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.test = module.exports.serialize = module.exports.default = void 0;

var $5F5iA = parcelRequire("5F5iA");
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // SENTINEL constants are from https://github.com/facebook/immutable-js
var $86d95deebeb43a22$var$IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
var $86d95deebeb43a22$var$IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
var $86d95deebeb43a22$var$IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
var $86d95deebeb43a22$var$IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
var $86d95deebeb43a22$var$IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
var $86d95deebeb43a22$var$IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@'; // immutable v4
var $86d95deebeb43a22$var$IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
var $86d95deebeb43a22$var$IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
var $86d95deebeb43a22$var$IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
var $86d95deebeb43a22$var$getImmutableName = function(name) {
    return 'Immutable.' + name;
};
var $86d95deebeb43a22$var$printAsLeaf = function(name) {
    return '[' + name + ']';
};
var $86d95deebeb43a22$var$SPACE = ' ';
var $86d95deebeb43a22$var$LAZY = "\u2026"; // Seq is lazy if it calls a method like filter
var $86d95deebeb43a22$var$printImmutableEntries = function(val, config, indentation, depth, refs, printer, type) {
    return ++depth > config.maxDepth ? $86d95deebeb43a22$var$printAsLeaf($86d95deebeb43a22$var$getImmutableName(type)) : $86d95deebeb43a22$var$getImmutableName(type) + $86d95deebeb43a22$var$SPACE + '{' + (0, $5F5iA.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) + '}';
}; // Record has an entries method because it is a collection in immutable v3.
// Return an iterator for Immutable Record from version v3 or v4.
function $86d95deebeb43a22$var$getRecordEntries(val) {
    var i = 0;
    return {
        next: function() {
            if (i < val._keys.length) {
                var key = val._keys[i++];
                return {
                    done: false,
                    value: [
                        key,
                        val.get(key)
                    ]
                };
            }
            return {
                done: true,
                value: undefined
            };
        }
    };
}
var $86d95deebeb43a22$var$printImmutableRecord = function(val, config, indentation, depth, refs, printer) {
    // _name property is defined only for an Immutable Record instance
    // which was constructed with a second optional descriptive name arg
    var name = $86d95deebeb43a22$var$getImmutableName(val._name || 'Record');
    return ++depth > config.maxDepth ? $86d95deebeb43a22$var$printAsLeaf(name) : name + $86d95deebeb43a22$var$SPACE + '{' + (0, $5F5iA.printIteratorEntries)($86d95deebeb43a22$var$getRecordEntries(val), config, indentation, depth, refs, printer) + '}';
};
var $86d95deebeb43a22$var$printImmutableSeq = function(val, config, indentation, depth, refs, printer) {
    var name = $86d95deebeb43a22$var$getImmutableName('Seq');
    if (++depth > config.maxDepth) return $86d95deebeb43a22$var$printAsLeaf(name);
    if (val[$86d95deebeb43a22$var$IS_KEYED_SENTINEL]) return name + $86d95deebeb43a22$var$SPACE + '{' + // from Immutable collection of entries or from ECMAScript object
    (val._iter || val._object ? (0, $5F5iA.printIteratorEntries)(val.entries(), config, indentation, depth, refs, printer) : $86d95deebeb43a22$var$LAZY) + '}';
    return name + $86d95deebeb43a22$var$SPACE + '[' + (val._iter || // from Immutable collection of values
    val._array || // from ECMAScript array
    val._collection || // from ECMAScript collection in immutable v4
    val._iterable // from ECMAScript collection in immutable v3
     ? (0, $5F5iA.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) : $86d95deebeb43a22$var$LAZY) + ']';
};
var $86d95deebeb43a22$var$printImmutableValues = function(val, config, indentation, depth, refs, printer, type) {
    return ++depth > config.maxDepth ? $86d95deebeb43a22$var$printAsLeaf($86d95deebeb43a22$var$getImmutableName(type)) : $86d95deebeb43a22$var$getImmutableName(type) + $86d95deebeb43a22$var$SPACE + '[' + (0, $5F5iA.printIteratorValues)(val.values(), config, indentation, depth, refs, printer) + ']';
};
var $86d95deebeb43a22$var$serialize = function(val, config, indentation, depth, refs, printer) {
    if (val[$86d95deebeb43a22$var$IS_MAP_SENTINEL]) return $86d95deebeb43a22$var$printImmutableEntries(val, config, indentation, depth, refs, printer, val[$86d95deebeb43a22$var$IS_ORDERED_SENTINEL] ? 'OrderedMap' : 'Map');
    if (val[$86d95deebeb43a22$var$IS_LIST_SENTINEL]) return $86d95deebeb43a22$var$printImmutableValues(val, config, indentation, depth, refs, printer, 'List');
    if (val[$86d95deebeb43a22$var$IS_SET_SENTINEL]) return $86d95deebeb43a22$var$printImmutableValues(val, config, indentation, depth, refs, printer, val[$86d95deebeb43a22$var$IS_ORDERED_SENTINEL] ? 'OrderedSet' : 'Set');
    if (val[$86d95deebeb43a22$var$IS_STACK_SENTINEL]) return $86d95deebeb43a22$var$printImmutableValues(val, config, indentation, depth, refs, printer, 'Stack');
    if (val[$86d95deebeb43a22$var$IS_SEQ_SENTINEL]) return $86d95deebeb43a22$var$printImmutableSeq(val, config, indentation, depth, refs, printer);
     // For compatibility with immutable v3 and v4, let record be the default.
    return $86d95deebeb43a22$var$printImmutableRecord(val, config, indentation, depth, refs, printer);
}; // Explicitly comparing sentinel properties to true avoids false positive
// when mock identity-obj-proxy returns the key as the value for any key.
module.exports.serialize = $86d95deebeb43a22$var$serialize;
var $86d95deebeb43a22$var$test = function(val) {
    return val && (val[$86d95deebeb43a22$var$IS_ITERABLE_SENTINEL] === true || val[$86d95deebeb43a22$var$IS_RECORD_SENTINEL] === true);
};
module.exports.test = $86d95deebeb43a22$var$test;
var $86d95deebeb43a22$var$plugin = {
    serialize: $86d95deebeb43a22$var$serialize,
    test: $86d95deebeb43a22$var$test
};
var $86d95deebeb43a22$var$_default = $86d95deebeb43a22$var$plugin;
module.exports.default = $86d95deebeb43a22$var$_default;

});

parcelRegister("7g49e", function(module, exports) {

var $YtE9h = parcelRequire("YtE9h");
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.test = module.exports.serialize = module.exports.default = void 0;

var $548d3ebbd8e63b60$var$ReactIs = $548d3ebbd8e63b60$var$_interopRequireWildcard((parcelRequire("3txOv")));

var $Ztuzc = parcelRequire("Ztuzc");
function $548d3ebbd8e63b60$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== 'function') return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($548d3ebbd8e63b60$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $548d3ebbd8e63b60$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || (typeof obj === "undefined" ? "undefined" : (0, $YtE9h._)(obj)) !== 'object' && typeof obj !== 'function') return {
        default: obj
    };
    var cache = $548d3ebbd8e63b60$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates. All Rights Reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Given element.props.children, or subtree during recursive traversal,
// return flattened array of children.
var $548d3ebbd8e63b60$var$getChildren = function(arg) {
    var children = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if (Array.isArray(arg)) arg.forEach(function(item) {
        $548d3ebbd8e63b60$var$getChildren(item, children);
    });
    else if (arg != null && arg !== false) children.push(arg);
    return children;
};
var $548d3ebbd8e63b60$var$getType = function(element) {
    var type = element.type;
    if (typeof type === 'string') return type;
    if (typeof type === 'function') return type.displayName || type.name || 'Unknown';
    if ($548d3ebbd8e63b60$var$ReactIs.isFragment(element)) return 'React.Fragment';
    if ($548d3ebbd8e63b60$var$ReactIs.isSuspense(element)) return 'React.Suspense';
    if ((typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) === 'object' && type !== null) {
        if ($548d3ebbd8e63b60$var$ReactIs.isContextProvider(element)) return 'Context.Provider';
        if ($548d3ebbd8e63b60$var$ReactIs.isContextConsumer(element)) return 'Context.Consumer';
        if ($548d3ebbd8e63b60$var$ReactIs.isForwardRef(element)) {
            if (type.displayName) return type.displayName;
            var functionName = type.render.displayName || type.render.name || '';
            return functionName !== '' ? 'ForwardRef(' + functionName + ')' : 'ForwardRef';
        }
        if ($548d3ebbd8e63b60$var$ReactIs.isMemo(element)) {
            var functionName1 = type.displayName || type.type.displayName || type.type.name || '';
            return functionName1 !== '' ? 'Memo(' + functionName1 + ')' : 'Memo';
        }
    }
    return 'UNDEFINED';
};
var $548d3ebbd8e63b60$var$getPropKeys = function(element) {
    var props = element.props;
    return Object.keys(props).filter(function(key) {
        return key !== 'children' && props[key] !== undefined;
    }).sort();
};
var $548d3ebbd8e63b60$var$serialize = function(element, config, indentation, depth, refs, printer) {
    return ++depth > config.maxDepth ? (0, $Ztuzc.printElementAsLeaf)($548d3ebbd8e63b60$var$getType(element), config) : (0, $Ztuzc.printElement)($548d3ebbd8e63b60$var$getType(element), (0, $Ztuzc.printProps)($548d3ebbd8e63b60$var$getPropKeys(element), element.props, config, indentation + config.indent, depth, refs, printer), (0, $Ztuzc.printChildren)($548d3ebbd8e63b60$var$getChildren(element.props.children), config, indentation + config.indent, depth, refs, printer), config, indentation);
};
module.exports.serialize = $548d3ebbd8e63b60$var$serialize;
var $548d3ebbd8e63b60$var$test = function(val) {
    return val != null && $548d3ebbd8e63b60$var$ReactIs.isElement(val);
};
module.exports.test = $548d3ebbd8e63b60$var$test;
var $548d3ebbd8e63b60$var$plugin = {
    serialize: $548d3ebbd8e63b60$var$serialize,
    test: $548d3ebbd8e63b60$var$test
};
var $548d3ebbd8e63b60$var$_default = $548d3ebbd8e63b60$var$plugin;
module.exports.default = $548d3ebbd8e63b60$var$_default;

});
parcelRegister("3txOv", function(module, exports) {
'use strict';

module.exports = (parcelRequire("aWwJq"));

});
parcelRegister("aWwJq", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $7f78b5fe39d3c8c7$export$a7c73072b1a182ae; }, function (v) { return $7f78b5fe39d3c8c7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $7f78b5fe39d3c8c7$export$9f27bc3417b4524d; }, function (v) { return $7f78b5fe39d3c8c7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $7f78b5fe39d3c8c7$export$db77ccec0bb4ccac; }, function (v) { return $7f78b5fe39d3c8c7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $7f78b5fe39d3c8c7$export$8392c0c9d3dcbd35; }, function (v) { return $7f78b5fe39d3c8c7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $7f78b5fe39d3c8c7$export$ffb0004e005737fa; }, function (v) { return $7f78b5fe39d3c8c7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $7f78b5fe39d3c8c7$export$b624eff549462981; }, function (v) { return $7f78b5fe39d3c8c7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $7f78b5fe39d3c8c7$export$7897aa7841a5380c; }, function (v) { return $7f78b5fe39d3c8c7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $7f78b5fe39d3c8c7$export$602eac185826482c; }, function (v) { return $7f78b5fe39d3c8c7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $7f78b5fe39d3c8c7$export$e2c29f18771995cb; }, function (v) { return $7f78b5fe39d3c8c7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $7f78b5fe39d3c8c7$export$5f8d39834fd61797; }, function (v) { return $7f78b5fe39d3c8c7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $7f78b5fe39d3c8c7$export$74bf444e3cd11ea5; }, function (v) { return $7f78b5fe39d3c8c7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $7f78b5fe39d3c8c7$export$92387174baf9b227; }, function (v) { return $7f78b5fe39d3c8c7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $7f78b5fe39d3c8c7$export$ec112efeb987d9c6; }, function (v) { return $7f78b5fe39d3c8c7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $7f78b5fe39d3c8c7$export$b706b080d889d2c9; }, function (v) { return $7f78b5fe39d3c8c7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $7f78b5fe39d3c8c7$export$5be5a87408f70ddc; }, function (v) { return $7f78b5fe39d3c8c7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $7f78b5fe39d3c8c7$export$45a5e7f76e0caa8d; }, function (v) { return $7f78b5fe39d3c8c7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $7f78b5fe39d3c8c7$export$455c2e768291efa6; }, function (v) { return $7f78b5fe39d3c8c7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $7f78b5fe39d3c8c7$export$9522e17588c12572; }, function (v) { return $7f78b5fe39d3c8c7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $7f78b5fe39d3c8c7$export$2110ac352bb060b9; }, function (v) { return $7f78b5fe39d3c8c7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $7f78b5fe39d3c8c7$export$56885ab8b9c456ab; }, function (v) { return $7f78b5fe39d3c8c7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $7f78b5fe39d3c8c7$export$d927fcb6adf8f9de; }, function (v) { return $7f78b5fe39d3c8c7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $7f78b5fe39d3c8c7$export$b82d16f27459e05a; }, function (v) { return $7f78b5fe39d3c8c7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $7f78b5fe39d3c8c7$export$522c17b4f5e123e8; }, function (v) { return $7f78b5fe39d3c8c7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $7f78b5fe39d3c8c7$export$1aabd8a0274ecfd6; }, function (v) { return $7f78b5fe39d3c8c7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $7f78b5fe39d3c8c7$export$9b621391a187a31a; }, function (v) { return $7f78b5fe39d3c8c7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $7f78b5fe39d3c8c7$export$f5bbd400c2f4426f; }, function (v) { return $7f78b5fe39d3c8c7$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $YtE9h = parcelRequire("YtE9h");
var $7f78b5fe39d3c8c7$export$a7c73072b1a182ae;
var $7f78b5fe39d3c8c7$export$9f27bc3417b4524d;
var $7f78b5fe39d3c8c7$export$db77ccec0bb4ccac;
var $7f78b5fe39d3c8c7$export$8392c0c9d3dcbd35;
var $7f78b5fe39d3c8c7$export$ffb0004e005737fa;
var $7f78b5fe39d3c8c7$export$b624eff549462981;
var $7f78b5fe39d3c8c7$export$7897aa7841a5380c;
var $7f78b5fe39d3c8c7$export$602eac185826482c;
var $7f78b5fe39d3c8c7$export$e2c29f18771995cb;
var $7f78b5fe39d3c8c7$export$5f8d39834fd61797;
var $7f78b5fe39d3c8c7$export$74bf444e3cd11ea5;
var $7f78b5fe39d3c8c7$export$92387174baf9b227;
var $7f78b5fe39d3c8c7$export$ec112efeb987d9c6;
var $7f78b5fe39d3c8c7$export$b706b080d889d2c9;
var $7f78b5fe39d3c8c7$export$5be5a87408f70ddc;
var $7f78b5fe39d3c8c7$export$45a5e7f76e0caa8d;
var $7f78b5fe39d3c8c7$export$455c2e768291efa6;
var $7f78b5fe39d3c8c7$export$9522e17588c12572;
var $7f78b5fe39d3c8c7$export$2110ac352bb060b9;
var $7f78b5fe39d3c8c7$export$56885ab8b9c456ab;
var $7f78b5fe39d3c8c7$export$d927fcb6adf8f9de;
var $7f78b5fe39d3c8c7$export$b82d16f27459e05a;
var $7f78b5fe39d3c8c7$export$522c17b4f5e123e8;
var $7f78b5fe39d3c8c7$export$1aabd8a0274ecfd6;
var $7f78b5fe39d3c8c7$export$9b621391a187a31a;
var $7f78b5fe39d3c8c7$export$f5bbd400c2f4426f;
'use strict';
var $7f78b5fe39d3c8c7$var$b = 60103, $7f78b5fe39d3c8c7$var$c = 60106, $7f78b5fe39d3c8c7$var$d = 60107, $7f78b5fe39d3c8c7$var$e = 60108, $7f78b5fe39d3c8c7$var$f = 60114, $7f78b5fe39d3c8c7$var$g = 60109, $7f78b5fe39d3c8c7$var$h = 60110, $7f78b5fe39d3c8c7$var$k = 60112, $7f78b5fe39d3c8c7$var$l = 60113, $7f78b5fe39d3c8c7$var$m = 60120, $7f78b5fe39d3c8c7$var$n = 60115, $7f78b5fe39d3c8c7$var$p = 60116, $7f78b5fe39d3c8c7$var$q = 60121, $7f78b5fe39d3c8c7$var$r = 60122, $7f78b5fe39d3c8c7$var$u = 60117, $7f78b5fe39d3c8c7$var$v = 60129, $7f78b5fe39d3c8c7$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $7f78b5fe39d3c8c7$var$x = Symbol.for;
    $7f78b5fe39d3c8c7$var$b = $7f78b5fe39d3c8c7$var$x("react.element");
    $7f78b5fe39d3c8c7$var$c = $7f78b5fe39d3c8c7$var$x("react.portal");
    $7f78b5fe39d3c8c7$var$d = $7f78b5fe39d3c8c7$var$x("react.fragment");
    $7f78b5fe39d3c8c7$var$e = $7f78b5fe39d3c8c7$var$x("react.strict_mode");
    $7f78b5fe39d3c8c7$var$f = $7f78b5fe39d3c8c7$var$x("react.profiler");
    $7f78b5fe39d3c8c7$var$g = $7f78b5fe39d3c8c7$var$x("react.provider");
    $7f78b5fe39d3c8c7$var$h = $7f78b5fe39d3c8c7$var$x("react.context");
    $7f78b5fe39d3c8c7$var$k = $7f78b5fe39d3c8c7$var$x("react.forward_ref");
    $7f78b5fe39d3c8c7$var$l = $7f78b5fe39d3c8c7$var$x("react.suspense");
    $7f78b5fe39d3c8c7$var$m = $7f78b5fe39d3c8c7$var$x("react.suspense_list");
    $7f78b5fe39d3c8c7$var$n = $7f78b5fe39d3c8c7$var$x("react.memo");
    $7f78b5fe39d3c8c7$var$p = $7f78b5fe39d3c8c7$var$x("react.lazy");
    $7f78b5fe39d3c8c7$var$q = $7f78b5fe39d3c8c7$var$x("react.block");
    $7f78b5fe39d3c8c7$var$r = $7f78b5fe39d3c8c7$var$x("react.server.block");
    $7f78b5fe39d3c8c7$var$u = $7f78b5fe39d3c8c7$var$x("react.fundamental");
    $7f78b5fe39d3c8c7$var$v = $7f78b5fe39d3c8c7$var$x("react.debug_trace_mode");
    $7f78b5fe39d3c8c7$var$w = $7f78b5fe39d3c8c7$var$x("react.legacy_hidden");
}
function $7f78b5fe39d3c8c7$var$y(a) {
    if ("object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $7f78b5fe39d3c8c7$var$b:
                switch(a = a.type, a){
                    case $7f78b5fe39d3c8c7$var$d:
                    case $7f78b5fe39d3c8c7$var$f:
                    case $7f78b5fe39d3c8c7$var$e:
                    case $7f78b5fe39d3c8c7$var$l:
                    case $7f78b5fe39d3c8c7$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $7f78b5fe39d3c8c7$var$h:
                            case $7f78b5fe39d3c8c7$var$k:
                            case $7f78b5fe39d3c8c7$var$p:
                            case $7f78b5fe39d3c8c7$var$n:
                            case $7f78b5fe39d3c8c7$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $7f78b5fe39d3c8c7$var$c:
                return t;
        }
    }
}
var $7f78b5fe39d3c8c7$var$z = $7f78b5fe39d3c8c7$var$g, $7f78b5fe39d3c8c7$var$A = $7f78b5fe39d3c8c7$var$b, $7f78b5fe39d3c8c7$var$B = $7f78b5fe39d3c8c7$var$k, $7f78b5fe39d3c8c7$var$C = $7f78b5fe39d3c8c7$var$d, $7f78b5fe39d3c8c7$var$D = $7f78b5fe39d3c8c7$var$p, $7f78b5fe39d3c8c7$var$E = $7f78b5fe39d3c8c7$var$n, $7f78b5fe39d3c8c7$var$F = $7f78b5fe39d3c8c7$var$c, $7f78b5fe39d3c8c7$var$G = $7f78b5fe39d3c8c7$var$f, $7f78b5fe39d3c8c7$var$H = $7f78b5fe39d3c8c7$var$e, $7f78b5fe39d3c8c7$var$I = $7f78b5fe39d3c8c7$var$l;
$7f78b5fe39d3c8c7$export$a7c73072b1a182ae = $7f78b5fe39d3c8c7$var$h;
$7f78b5fe39d3c8c7$export$9f27bc3417b4524d = $7f78b5fe39d3c8c7$var$z;
$7f78b5fe39d3c8c7$export$db77ccec0bb4ccac = $7f78b5fe39d3c8c7$var$A;
$7f78b5fe39d3c8c7$export$8392c0c9d3dcbd35 = $7f78b5fe39d3c8c7$var$B;
$7f78b5fe39d3c8c7$export$ffb0004e005737fa = $7f78b5fe39d3c8c7$var$C;
$7f78b5fe39d3c8c7$export$b624eff549462981 = $7f78b5fe39d3c8c7$var$D;
$7f78b5fe39d3c8c7$export$7897aa7841a5380c = $7f78b5fe39d3c8c7$var$E;
$7f78b5fe39d3c8c7$export$602eac185826482c = $7f78b5fe39d3c8c7$var$F;
$7f78b5fe39d3c8c7$export$e2c29f18771995cb = $7f78b5fe39d3c8c7$var$G;
$7f78b5fe39d3c8c7$export$5f8d39834fd61797 = $7f78b5fe39d3c8c7$var$H;
$7f78b5fe39d3c8c7$export$74bf444e3cd11ea5 = $7f78b5fe39d3c8c7$var$I;
$7f78b5fe39d3c8c7$export$92387174baf9b227 = function() {
    return !1;
};
$7f78b5fe39d3c8c7$export$ec112efeb987d9c6 = function() {
    return !1;
};
$7f78b5fe39d3c8c7$export$b706b080d889d2c9 = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$h;
};
$7f78b5fe39d3c8c7$export$5be5a87408f70ddc = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$g;
};
$7f78b5fe39d3c8c7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && null !== a && a.$$typeof === $7f78b5fe39d3c8c7$var$b;
};
$7f78b5fe39d3c8c7$export$455c2e768291efa6 = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$k;
};
$7f78b5fe39d3c8c7$export$9522e17588c12572 = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$d;
};
$7f78b5fe39d3c8c7$export$2110ac352bb060b9 = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$p;
};
$7f78b5fe39d3c8c7$export$56885ab8b9c456ab = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$n;
};
$7f78b5fe39d3c8c7$export$d927fcb6adf8f9de = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$c;
};
$7f78b5fe39d3c8c7$export$b82d16f27459e05a = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$f;
};
$7f78b5fe39d3c8c7$export$522c17b4f5e123e8 = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$e;
};
$7f78b5fe39d3c8c7$export$1aabd8a0274ecfd6 = function(a) {
    return $7f78b5fe39d3c8c7$var$y(a) === $7f78b5fe39d3c8c7$var$l;
};
$7f78b5fe39d3c8c7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $7f78b5fe39d3c8c7$var$d || a === $7f78b5fe39d3c8c7$var$f || a === $7f78b5fe39d3c8c7$var$v || a === $7f78b5fe39d3c8c7$var$e || a === $7f78b5fe39d3c8c7$var$l || a === $7f78b5fe39d3c8c7$var$m || a === $7f78b5fe39d3c8c7$var$w || "object" === (typeof a === "undefined" ? "undefined" : (0, $YtE9h._)(a)) && null !== a && (a.$$typeof === $7f78b5fe39d3c8c7$var$p || a.$$typeof === $7f78b5fe39d3c8c7$var$n || a.$$typeof === $7f78b5fe39d3c8c7$var$g || a.$$typeof === $7f78b5fe39d3c8c7$var$h || a.$$typeof === $7f78b5fe39d3c8c7$var$k || a.$$typeof === $7f78b5fe39d3c8c7$var$u || a.$$typeof === $7f78b5fe39d3c8c7$var$q || a[0] === $7f78b5fe39d3c8c7$var$r) ? !0 : !1;
};
$7f78b5fe39d3c8c7$export$f5bbd400c2f4426f = $7f78b5fe39d3c8c7$var$y;

});



parcelRegister("eFn2s", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.test = module.exports.serialize = module.exports.default = void 0;

var $Ztuzc = parcelRequire("Ztuzc");
var $aad6c3fe515f5ca7$var$global = function() {
    if (typeof globalThis !== 'undefined') return globalThis;
    else if (typeof $aad6c3fe515f5ca7$var$global !== 'undefined') return $aad6c3fe515f5ca7$var$global;
    else if (typeof self !== 'undefined') return self;
    else if (typeof window !== 'undefined') return window;
    else return Function('return this')();
}();
var $aad6c3fe515f5ca7$var$Symbol = $aad6c3fe515f5ca7$var$global['jest-symbol-do-not-touch'] || $aad6c3fe515f5ca7$var$global.Symbol;
var $aad6c3fe515f5ca7$var$testSymbol = typeof $aad6c3fe515f5ca7$var$Symbol === 'function' && $aad6c3fe515f5ca7$var$Symbol.for ? $aad6c3fe515f5ca7$var$Symbol.for('react.test.json') : 0xea71357;
var $aad6c3fe515f5ca7$var$getPropKeys = function(object) {
    var props = object.props;
    return props ? Object.keys(props).filter(function(key) {
        return props[key] !== undefined;
    }).sort() : [];
};
var $aad6c3fe515f5ca7$var$serialize = function(object, config, indentation, depth, refs, printer) {
    return ++depth > config.maxDepth ? (0, $Ztuzc.printElementAsLeaf)(object.type, config) : (0, $Ztuzc.printElement)(object.type, object.props ? (0, $Ztuzc.printProps)($aad6c3fe515f5ca7$var$getPropKeys(object), object.props, config, indentation + config.indent, depth, refs, printer) : '', object.children ? (0, $Ztuzc.printChildren)(object.children, config, indentation + config.indent, depth, refs, printer) : '', config, indentation);
};
module.exports.serialize = $aad6c3fe515f5ca7$var$serialize;
var $aad6c3fe515f5ca7$var$test = function(val) {
    return val && val.$$typeof === $aad6c3fe515f5ca7$var$testSymbol;
};
module.exports.test = $aad6c3fe515f5ca7$var$test;
var $aad6c3fe515f5ca7$var$plugin = {
    serialize: $aad6c3fe515f5ca7$var$serialize,
    test: $aad6c3fe515f5ca7$var$test
};
var $aad6c3fe515f5ca7$var$_default = $aad6c3fe515f5ca7$var$plugin;
module.exports.default = $aad6c3fe515f5ca7$var$_default;

});


parcelRegister("dP2oG", function(module, exports) {

$parcel$export(module.exports, "computeAccessibleDescription", function () { return (parcelRequire("9WNlU")).computeAccessibleDescription; });
$parcel$export(module.exports, "computeAccessibleName", function () { return (parcelRequire("lX55U")).computeAccessibleName; });

var $9WNlU = parcelRequire("9WNlU");

var $lX55U = parcelRequire("lX55U");

var $5rRYk = parcelRequire("5rRYk");
parcelRequire("lYf5C");

});
parcelRegister("9WNlU", function(module, exports) {

$parcel$export(module.exports, "computeAccessibleDescription", function () { return $bfd0d5aecf983601$export$4ebd5c9c71c9a21b; });

var $3Iky5 = parcelRequire("3Iky5");

var $6f9V5 = parcelRequire("6f9V5");
function $bfd0d5aecf983601$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $bfd0d5aecf983601$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $bfd0d5aecf983601$var$_typeof(obj);
}
function $bfd0d5aecf983601$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bfd0d5aecf983601$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $bfd0d5aecf983601$var$ownKeys(Object(source), !0).forEach(function(key) {
            $bfd0d5aecf983601$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $bfd0d5aecf983601$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bfd0d5aecf983601$var$_defineProperty(obj, key, value) {
    key = $bfd0d5aecf983601$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bfd0d5aecf983601$var$_toPropertyKey(arg) {
    var key = $bfd0d5aecf983601$var$_toPrimitive(arg, "string");
    return $bfd0d5aecf983601$var$_typeof(key) === "symbol" ? key : String(key);
}
function $bfd0d5aecf983601$var$_toPrimitive(input, hint) {
    if ($bfd0d5aecf983601$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($bfd0d5aecf983601$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $bfd0d5aecf983601$export$4ebd5c9c71c9a21b(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var description = (0, $6f9V5.queryIdRefs)(root, "aria-describedby").map(function(element) {
        return (0, $3Iky5.computeTextAlternative)(element, $bfd0d5aecf983601$var$_objectSpread($bfd0d5aecf983601$var$_objectSpread({}, options), {}, {
            compute: "description"
        }));
    }).join(" ");
    // TODO: Technically we need to make sure that node wasn't used for the accessible name
    //       This causes `description_1.0_combobox-focusable-manual` to fail
    //
    // https://www.w3.org/TR/html-aam-1.0/#accessible-name-and-description-computation
    // says for so many elements to use the `title` that we assume all elements are considered
    if (description === "") {
        var title = root.getAttribute("title");
        description = title === null ? "" : title;
    }
    return description;
}

});
parcelRegister("3Iky5", function(module, exports) {

$parcel$export(module.exports, "computeTextAlternative", function () { return $0df3f3212c2f958a$export$5b345f9130795500; });
/**
 * implements https://w3c.github.io/accname/
 */ 
var $7kHtc = parcelRequire("7kHtc");

var $7G2fT = parcelRequire("7G2fT");
parcelRequire("6f9V5");
var $5rRYk = parcelRequire("5rRYk");
var $6f9V5 = parcelRequire("6f9V5");
/**
 *  A string of characters where all carriage returns, newlines, tabs, and form-feeds are replaced with a single space, and multiple spaces are reduced to a single space. The string contains only character data; it does not contain any markup.
 */ /**
 *
 * @param {string} string -
 * @returns {FlatString} -
 */ function $0df3f3212c2f958a$var$asFlatString(s) {
    return s.trim().replace(/\s\s+/g, " ");
}
/**
 *
 * @param node -
 * @param options - These are not optional to prevent accidentally calling it without options in `computeAccessibleName`
 * @returns {boolean} -
 */ function $0df3f3212c2f958a$var$isHidden(node, getComputedStyleImplementation) {
    if (!(0, $6f9V5.isElement)(node)) return false;
    if (node.hasAttribute("hidden") || node.getAttribute("aria-hidden") === "true") return true;
    var style = getComputedStyleImplementation(node);
    return style.getPropertyValue("display") === "none" || style.getPropertyValue("visibility") === "hidden";
}
/**
 * @param {Node} node -
 * @returns {boolean} - As defined in step 2E of https://w3c.github.io/accname/#mapping_additional_nd_te
 */ function $0df3f3212c2f958a$var$isControl(node) {
    return (0, $6f9V5.hasAnyConcreteRoles)(node, [
        "button",
        "combobox",
        "listbox",
        "textbox"
    ]) || $0df3f3212c2f958a$var$hasAbstractRole(node, "range");
}
function $0df3f3212c2f958a$var$hasAbstractRole(node, role) {
    if (!(0, $6f9V5.isElement)(node)) return false;
    switch(role){
        case "range":
            return (0, $6f9V5.hasAnyConcreteRoles)(node, [
                "meter",
                "progressbar",
                "scrollbar",
                "slider",
                "spinbutton"
            ]);
        default:
            throw new TypeError("No knowledge about abstract role '".concat(role, "'. This is likely a bug :("));
    }
}
/**
 * element.querySelectorAll but also considers owned tree
 * @param element
 * @param selectors
 */ function $0df3f3212c2f958a$var$querySelectorAllSubtree(element, selectors) {
    var elements = (0, $7kHtc.default)(element.querySelectorAll(selectors));
    (0, $6f9V5.queryIdRefs)(element, "aria-owns").forEach(function(root) {
        // babel transpiles this assuming an iterator
        elements.push.apply(elements, (0, $7kHtc.default)(root.querySelectorAll(selectors)));
    });
    return elements;
}
function $0df3f3212c2f958a$var$querySelectedOptions(listbox) {
    if ((0, $6f9V5.isHTMLSelectElement)(listbox)) // IE11 polyfill
    return listbox.selectedOptions || $0df3f3212c2f958a$var$querySelectorAllSubtree(listbox, "[selected]");
    return $0df3f3212c2f958a$var$querySelectorAllSubtree(listbox, '[aria-selected="true"]');
}
function $0df3f3212c2f958a$var$isMarkedPresentational(node) {
    return (0, $6f9V5.hasAnyConcreteRoles)(node, [
        "none",
        "presentation"
    ]);
}
/**
 * Elements specifically listed in html-aam
 *
 * We don't need this for `label` or `legend` elements.
 * Their implicit roles already allow "naming from content".
 *
 * sources:
 *
 * - https://w3c.github.io/html-aam/#table-element
 */ function $0df3f3212c2f958a$var$isNativeHostLanguageTextAlternativeElement(node) {
    return (0, $6f9V5.isHTMLTableCaptionElement)(node);
}
/**
 * https://w3c.github.io/aria/#namefromcontent
 */ function $0df3f3212c2f958a$var$allowsNameFromContent(node) {
    return (0, $6f9V5.hasAnyConcreteRoles)(node, [
        "button",
        "cell",
        "checkbox",
        "columnheader",
        "gridcell",
        "heading",
        "label",
        "legend",
        "link",
        "menuitem",
        "menuitemcheckbox",
        "menuitemradio",
        "option",
        "radio",
        "row",
        "rowheader",
        "switch",
        "tab",
        "tooltip",
        "treeitem"
    ]);
}
/**
 * TODO https://github.com/eps1lon/dom-accessibility-api/issues/100
 */ function $0df3f3212c2f958a$var$isDescendantOfNativeHostLanguageTextAlternativeElement(// eslint-disable-next-line @typescript-eslint/no-unused-vars -- not implemented yet
node) {
    return false;
}
function $0df3f3212c2f958a$var$getValueOfTextbox(element) {
    if ((0, $6f9V5.isHTMLInputElement)(element) || (0, $6f9V5.isHTMLTextAreaElement)(element)) return element.value;
    // https://github.com/eps1lon/dom-accessibility-api/issues/4
    return element.textContent || "";
}
function $0df3f3212c2f958a$var$getTextualContent(declaration) {
    var content = declaration.getPropertyValue("content");
    if (/^["'].*["']$/.test(content)) return content.slice(1, -1);
    return "";
}
/**
 * https://html.spec.whatwg.org/multipage/forms.html#category-label
 * TODO: form-associated custom elements
 * @param element
 */ function $0df3f3212c2f958a$var$isLabelableElement(element) {
    var localName = (0, $5rRYk.getLocalName)(element);
    return localName === "button" || localName === "input" && element.getAttribute("type") !== "hidden" || localName === "meter" || localName === "output" || localName === "progress" || localName === "select" || localName === "textarea";
}
/**
 * > [...], then the first such descendant in tree order is the label element's labeled control.
 * -- https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param element
 */ function $0df3f3212c2f958a$var$findLabelableElement(element) {
    if ($0df3f3212c2f958a$var$isLabelableElement(element)) return element;
    var labelableElement = null;
    element.childNodes.forEach(function(childNode) {
        if (labelableElement === null && (0, $6f9V5.isElement)(childNode)) {
            var descendantLabelableElement = $0df3f3212c2f958a$var$findLabelableElement(childNode);
            if (descendantLabelableElement !== null) labelableElement = descendantLabelableElement;
        }
    });
    return labelableElement;
}
/**
 * Polyfill of HTMLLabelElement.control
 * https://html.spec.whatwg.org/multipage/forms.html#labeled-control
 * @param label
 */ function $0df3f3212c2f958a$var$getControlOfLabel(label) {
    if (label.control !== undefined) return label.control;
    var htmlFor = label.getAttribute("for");
    if (htmlFor !== null) return label.ownerDocument.getElementById(htmlFor);
    return $0df3f3212c2f958a$var$findLabelableElement(label);
}
/**
 * Polyfill of HTMLInputElement.labels
 * https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/labels
 * @param element
 */ function $0df3f3212c2f958a$var$getLabels(element) {
    var labelsProperty = element.labels;
    if (labelsProperty === null) return labelsProperty;
    if (labelsProperty !== undefined) return (0, $7kHtc.default)(labelsProperty);
    // polyfill
    if (!$0df3f3212c2f958a$var$isLabelableElement(element)) return null;
    var document = element.ownerDocument;
    return (0, $7kHtc.default)(document.querySelectorAll("label")).filter(function(label) {
        return $0df3f3212c2f958a$var$getControlOfLabel(label) === element;
    });
}
/**
 * Gets the contents of a slot used for computing the accname
 * @param slot
 */ function $0df3f3212c2f958a$var$getSlotContents(slot) {
    // Computing the accessible name for elements containing slots is not
    // currently defined in the spec. This implementation reflects the
    // behavior of NVDA 2020.2/Firefox 81 and iOS VoiceOver/Safari 13.6.
    var assignedNodes = slot.assignedNodes();
    if (assignedNodes.length === 0) // if no nodes are assigned to the slot, it displays the default content
    return (0, $7kHtc.default)(slot.childNodes);
    return assignedNodes;
}
function $0df3f3212c2f958a$export$5b345f9130795500(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var consultedNodes = new (0, $7G2fT.default)();
    var window = (0, $6f9V5.safeWindow)(root);
    var _options$compute = options.compute, compute = _options$compute === void 0 ? "name" : _options$compute, _options$computedStyl = options.computedStyleSupportsPseudoElements, computedStyleSupportsPseudoElements = _options$computedStyl === void 0 ? options.getComputedStyle !== undefined : _options$computedStyl, _options$getComputedS = options.getComputedStyle, getComputedStyle = _options$getComputedS === void 0 ? window.getComputedStyle.bind(window) : _options$getComputedS, _options$hidden = options.hidden, hidden = _options$hidden === void 0 ? false : _options$hidden;
    // 2F.i
    function computeMiscTextAlternative(node, context) {
        var accumulatedText = "";
        if ((0, $6f9V5.isElement)(node) && computedStyleSupportsPseudoElements) {
            var pseudoBefore = getComputedStyle(node, "::before");
            var beforeContent = $0df3f3212c2f958a$var$getTextualContent(pseudoBefore);
            accumulatedText = "".concat(beforeContent, " ").concat(accumulatedText);
        }
        // FIXME: Including aria-owns is not defined in the spec
        // But it is required in the web-platform-test
        var childNodes = (0, $6f9V5.isHTMLSlotElement)(node) ? $0df3f3212c2f958a$var$getSlotContents(node) : (0, $7kHtc.default)(node.childNodes).concat((0, $6f9V5.queryIdRefs)(node, "aria-owns"));
        childNodes.forEach(function(child) {
            var result = computeTextAlternative(child, {
                isEmbeddedInLabel: context.isEmbeddedInLabel,
                isReferenced: false,
                recursion: true
            });
            // TODO: Unclear why display affects delimiter
            // see https://github.com/w3c/accname/issues/3
            var display = (0, $6f9V5.isElement)(child) ? getComputedStyle(child).getPropertyValue("display") : "inline";
            var separator = display !== "inline" ? " " : "";
            // trailing separator for wpt tests
            accumulatedText += "".concat(separator).concat(result).concat(separator);
        });
        if ((0, $6f9V5.isElement)(node) && computedStyleSupportsPseudoElements) {
            var pseudoAfter = getComputedStyle(node, "::after");
            var afterContent = $0df3f3212c2f958a$var$getTextualContent(pseudoAfter);
            accumulatedText = "".concat(accumulatedText, " ").concat(afterContent);
        }
        return accumulatedText.trim();
    }
    /**
   *
   * @param element
   * @param attributeName
   * @returns A string non-empty string or `null`
   */ function useAttribute(element, attributeName) {
        var attribute = element.getAttributeNode(attributeName);
        if (attribute !== null && !consultedNodes.has(attribute) && attribute.value.trim() !== "") {
            consultedNodes.add(attribute);
            return attribute.value;
        }
        return null;
    }
    function computeTooltipAttributeValue(node) {
        if (!(0, $6f9V5.isElement)(node)) return null;
        return useAttribute(node, "title");
    }
    function computeElementTextAlternative(node) {
        if (!(0, $6f9V5.isElement)(node)) return null;
        // https://w3c.github.io/html-aam/#fieldset-and-legend-elements
        if ((0, $6f9V5.isHTMLFieldSetElement)(node)) {
            consultedNodes.add(node);
            var children = (0, $7kHtc.default)(node.childNodes);
            for(var i = 0; i < children.length; i += 1){
                var child = children[i];
                if ((0, $6f9V5.isHTMLLegendElement)(child)) return computeTextAlternative(child, {
                    isEmbeddedInLabel: false,
                    isReferenced: false,
                    recursion: false
                });
            }
        } else if ((0, $6f9V5.isHTMLTableElement)(node)) {
            // https://w3c.github.io/html-aam/#table-element
            consultedNodes.add(node);
            var _children = (0, $7kHtc.default)(node.childNodes);
            for(var _i = 0; _i < _children.length; _i += 1){
                var _child = _children[_i];
                if ((0, $6f9V5.isHTMLTableCaptionElement)(_child)) return computeTextAlternative(_child, {
                    isEmbeddedInLabel: false,
                    isReferenced: false,
                    recursion: false
                });
            }
        } else if ((0, $6f9V5.isSVGSVGElement)(node)) {
            // https://www.w3.org/TR/svg-aam-1.0/
            consultedNodes.add(node);
            var _children2 = (0, $7kHtc.default)(node.childNodes);
            for(var _i2 = 0; _i2 < _children2.length; _i2 += 1){
                var _child2 = _children2[_i2];
                if ((0, $6f9V5.isSVGTitleElement)(_child2)) return _child2.textContent;
            }
            return null;
        } else if ((0, $5rRYk.getLocalName)(node) === "img" || (0, $5rRYk.getLocalName)(node) === "area") {
            // https://w3c.github.io/html-aam/#area-element
            // https://w3c.github.io/html-aam/#img-element
            var nameFromAlt = useAttribute(node, "alt");
            if (nameFromAlt !== null) return nameFromAlt;
        } else if ((0, $6f9V5.isHTMLOptGroupElement)(node)) {
            var nameFromLabel = useAttribute(node, "label");
            if (nameFromLabel !== null) return nameFromLabel;
        }
        if ((0, $6f9V5.isHTMLInputElement)(node) && (node.type === "button" || node.type === "submit" || node.type === "reset")) {
            // https://w3c.github.io/html-aam/#input-type-text-input-type-password-input-type-search-input-type-tel-input-type-email-input-type-url-and-textarea-element-accessible-description-computation
            var nameFromValue = useAttribute(node, "value");
            if (nameFromValue !== null) return nameFromValue;
            // TODO: l10n
            if (node.type === "submit") return "Submit";
            // TODO: l10n
            if (node.type === "reset") return "Reset";
        }
        var labels = $0df3f3212c2f958a$var$getLabels(node);
        if (labels !== null && labels.length !== 0) {
            consultedNodes.add(node);
            return (0, $7kHtc.default)(labels).map(function(element) {
                return computeTextAlternative(element, {
                    isEmbeddedInLabel: true,
                    isReferenced: false,
                    recursion: true
                });
            }).filter(function(label) {
                return label.length > 0;
            }).join(" ");
        }
        // https://w3c.github.io/html-aam/#input-type-image-accessible-name-computation
        // TODO: wpt test consider label elements but html-aam does not mention them
        // We follow existing implementations over spec
        if ((0, $6f9V5.isHTMLInputElement)(node) && node.type === "image") {
            var _nameFromAlt = useAttribute(node, "alt");
            if (_nameFromAlt !== null) return _nameFromAlt;
            var nameFromTitle = useAttribute(node, "title");
            if (nameFromTitle !== null) return nameFromTitle;
            // TODO: l10n
            return "Submit Query";
        }
        if ((0, $6f9V5.hasAnyConcreteRoles)(node, [
            "button"
        ])) {
            // https://www.w3.org/TR/html-aam-1.0/#button-element
            var nameFromSubTree = computeMiscTextAlternative(node, {
                isEmbeddedInLabel: false,
                isReferenced: false
            });
            if (nameFromSubTree !== "") return nameFromSubTree;
        }
        return null;
    }
    function computeTextAlternative(current, context) {
        if (consultedNodes.has(current)) return "";
        // 2A
        if (!hidden && $0df3f3212c2f958a$var$isHidden(current, getComputedStyle) && !context.isReferenced) {
            consultedNodes.add(current);
            return "";
        }
        // 2B
        var labelAttributeNode = (0, $6f9V5.isElement)(current) ? current.getAttributeNode("aria-labelledby") : null;
        // TODO: Do we generally need to block query IdRefs of attributes we have already consulted?
        var labelElements = labelAttributeNode !== null && !consultedNodes.has(labelAttributeNode) ? (0, $6f9V5.queryIdRefs)(current, "aria-labelledby") : [];
        if (compute === "name" && !context.isReferenced && labelElements.length > 0) {
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- Can't be null here otherwise labelElements would be empty
            consultedNodes.add(labelAttributeNode);
            return labelElements.map(function(element) {
                // TODO: Chrome will consider repeated values i.e. use a node multiple times while we'll bail out in computeTextAlternative.
                return computeTextAlternative(element, {
                    isEmbeddedInLabel: context.isEmbeddedInLabel,
                    isReferenced: true,
                    // this isn't recursion as specified, otherwise we would skip
                    // `aria-label` in
                    // <input id="myself" aria-label="foo" aria-labelledby="myself"
                    recursion: false
                });
            }).join(" ");
        }
        // 2C
        // Changed from the spec in anticipation of https://github.com/w3c/accname/issues/64
        // spec says we should only consider skipping if we have a non-empty label
        var skipToStep2E = context.recursion && $0df3f3212c2f958a$var$isControl(current) && compute === "name";
        if (!skipToStep2E) {
            var ariaLabel = ((0, $6f9V5.isElement)(current) && current.getAttribute("aria-label") || "").trim();
            if (ariaLabel !== "" && compute === "name") {
                consultedNodes.add(current);
                return ariaLabel;
            }
            // 2D
            if (!$0df3f3212c2f958a$var$isMarkedPresentational(current)) {
                var elementTextAlternative = computeElementTextAlternative(current);
                if (elementTextAlternative !== null) {
                    consultedNodes.add(current);
                    return elementTextAlternative;
                }
            }
        }
        // special casing, cheating to make tests pass
        // https://github.com/w3c/accname/issues/67
        if ((0, $6f9V5.hasAnyConcreteRoles)(current, [
            "menu"
        ])) {
            consultedNodes.add(current);
            return "";
        }
        // 2E
        if (skipToStep2E || context.isEmbeddedInLabel || context.isReferenced) {
            if ((0, $6f9V5.hasAnyConcreteRoles)(current, [
                "combobox",
                "listbox"
            ])) {
                consultedNodes.add(current);
                var selectedOptions = $0df3f3212c2f958a$var$querySelectedOptions(current);
                if (selectedOptions.length === 0) // defined per test `name_heading_combobox`
                return (0, $6f9V5.isHTMLInputElement)(current) ? current.value : "";
                return (0, $7kHtc.default)(selectedOptions).map(function(selectedOption) {
                    return computeTextAlternative(selectedOption, {
                        isEmbeddedInLabel: context.isEmbeddedInLabel,
                        isReferenced: false,
                        recursion: true
                    });
                }).join(" ");
            }
            if ($0df3f3212c2f958a$var$hasAbstractRole(current, "range")) {
                consultedNodes.add(current);
                if (current.hasAttribute("aria-valuetext")) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
                return current.getAttribute("aria-valuetext");
                if (current.hasAttribute("aria-valuenow")) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute guard
                return current.getAttribute("aria-valuenow");
                // Otherwise, use the value as specified by a host language attribute.
                return current.getAttribute("value") || "";
            }
            if ((0, $6f9V5.hasAnyConcreteRoles)(current, [
                "textbox"
            ])) {
                consultedNodes.add(current);
                return $0df3f3212c2f958a$var$getValueOfTextbox(current);
            }
        }
        // 2F: https://w3c.github.io/accname/#step2F
        if ($0df3f3212c2f958a$var$allowsNameFromContent(current) || (0, $6f9V5.isElement)(current) && context.isReferenced || $0df3f3212c2f958a$var$isNativeHostLanguageTextAlternativeElement(current) || $0df3f3212c2f958a$var$isDescendantOfNativeHostLanguageTextAlternativeElement(current)) {
            var accumulatedText2F = computeMiscTextAlternative(current, {
                isEmbeddedInLabel: context.isEmbeddedInLabel,
                isReferenced: false
            });
            if (accumulatedText2F !== "") {
                consultedNodes.add(current);
                return accumulatedText2F;
            }
        }
        if (current.nodeType === current.TEXT_NODE) {
            consultedNodes.add(current);
            return current.textContent || "";
        }
        if (context.recursion) {
            consultedNodes.add(current);
            return computeMiscTextAlternative(current, {
                isEmbeddedInLabel: context.isEmbeddedInLabel,
                isReferenced: false
            });
        }
        var tooltipAttributeValue = computeTooltipAttributeValue(current);
        if (tooltipAttributeValue !== null) {
            consultedNodes.add(current);
            return tooltipAttributeValue;
        }
        // TODO should this be reachable?
        consultedNodes.add(current);
        return "";
    }
    return $0df3f3212c2f958a$var$asFlatString(computeTextAlternative(root, {
        isEmbeddedInLabel: false,
        // by spec computeAccessibleDescription starts with the referenced elements as roots
        isReferenced: compute === "description",
        recursion: false
    }));
}

});
parcelRegister("7kHtc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e5e3664bcf6088ce$export$2e2bcd8739ae039; });
/**
 * @source {https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Polyfill}
 * but without thisArg (too hard to type, no need to `this`)
 */ var $e5e3664bcf6088ce$var$toStr = Object.prototype.toString;
function $e5e3664bcf6088ce$var$isCallable(fn) {
    return typeof fn === "function" || $e5e3664bcf6088ce$var$toStr.call(fn) === "[object Function]";
}
function $e5e3664bcf6088ce$var$toInteger(value) {
    var number = Number(value);
    if (isNaN(number)) return 0;
    if (number === 0 || !isFinite(number)) return number;
    return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
}
var $e5e3664bcf6088ce$var$maxSafeInteger = Math.pow(2, 53) - 1;
function $e5e3664bcf6088ce$var$toLength(value) {
    var len = $e5e3664bcf6088ce$var$toInteger(value);
    return Math.min(Math.max(len, 0), $e5e3664bcf6088ce$var$maxSafeInteger);
}
function $e5e3664bcf6088ce$export$2e2bcd8739ae039(arrayLike, mapFn) {
    // 1. Let C be the this value.
    // edit(@eps1lon): we're not calling it as Array.from
    var C = Array;
    // 2. Let items be ToObject(arrayLike).
    var items = Object(arrayLike);
    // 3. ReturnIfAbrupt(items).
    if (arrayLike == null) throw new TypeError("Array.from requires an array-like object - not null or undefined");
    // 4. If mapfn is undefined, then let mapping be false.
    // const mapFn = arguments.length > 1 ? arguments[1] : void undefined;
    if (typeof mapFn !== "undefined") {
        // 5. else
        // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
        if (!$e5e3664bcf6088ce$var$isCallable(mapFn)) throw new TypeError("Array.from: when provided, the second argument must be a function");
    }
    // 10. Let lenValue be Get(items, "length").
    // 11. Let len be ToLength(lenValue).
    var len = $e5e3664bcf6088ce$var$toLength(items.length);
    // 13. If IsConstructor(C) is true, then
    // 13. a. Let A be the result of calling the [[Construct]] internal method
    // of C with an argument list containing the single item len.
    // 14. a. Else, Let A be ArrayCreate(len).
    var A = $e5e3664bcf6088ce$var$isCallable(C) ? Object(new C(len)) : new Array(len);
    // 16. Let k be 0.
    var k = 0;
    // 17. Repeat, while k < len… (also steps a - h)
    var kValue;
    while(k < len){
        kValue = items[k];
        if (mapFn) A[k] = mapFn(kValue, k);
        else A[k] = kValue;
        k += 1;
    }
    // 18. Let putStatus be Put(A, "length", len, true).
    A.length = len;
    // 20. Return A.
    return A;
}

});

parcelRegister("7G2fT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3e894ec2a1026b9$export$2e2bcd8739ae039; });
function $a3e894ec2a1026b9$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $a3e894ec2a1026b9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $a3e894ec2a1026b9$var$_typeof(obj);
}
function $a3e894ec2a1026b9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a3e894ec2a1026b9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a3e894ec2a1026b9$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a3e894ec2a1026b9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a3e894ec2a1026b9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a3e894ec2a1026b9$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a3e894ec2a1026b9$var$_defineProperty(obj, key, value) {
    key = $a3e894ec2a1026b9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a3e894ec2a1026b9$var$_toPropertyKey(arg) {
    var key = $a3e894ec2a1026b9$var$_toPrimitive(arg, "string");
    return $a3e894ec2a1026b9$var$_typeof(key) === "symbol" ? key : String(key);
}
function $a3e894ec2a1026b9$var$_toPrimitive(input, hint) {
    if ($a3e894ec2a1026b9$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($a3e894ec2a1026b9$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
// for environments without Set we fallback to arrays with unique members
var $a3e894ec2a1026b9$var$SetLike = /*#__PURE__*/ function() {
    function SetLike() {
        var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        $a3e894ec2a1026b9$var$_classCallCheck(this, SetLike);
        $a3e894ec2a1026b9$var$_defineProperty(this, "items", void 0);
        this.items = items;
    }
    $a3e894ec2a1026b9$var$_createClass(SetLike, [
        {
            key: "add",
            value: function add(value) {
                if (this.has(value) === false) this.items.push(value);
                return this;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.items = [];
            }
        },
        {
            key: "delete",
            value: function _delete(value) {
                var previousLength = this.items.length;
                this.items = this.items.filter(function(item) {
                    return item !== value;
                });
                return previousLength !== this.items.length;
            }
        },
        {
            key: "forEach",
            value: function forEach(callbackfn) {
                var _this = this;
                this.items.forEach(function(item) {
                    callbackfn(item, item, _this);
                });
            }
        },
        {
            key: "has",
            value: function has(value) {
                return this.items.indexOf(value) !== -1;
            }
        },
        {
            key: "size",
            get: function get() {
                return this.items.length;
            }
        }
    ]);
    return SetLike;
}();
var $a3e894ec2a1026b9$export$2e2bcd8739ae039 = typeof Set === "undefined" ? Set : $a3e894ec2a1026b9$var$SetLike;

});

parcelRegister("6f9V5", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $287617daecc57235$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLTableCaptionElement", function () { return $287617daecc57235$export$7bec295fe7a71cc3; });
$parcel$export(module.exports, "isHTMLInputElement", function () { return $287617daecc57235$export$88a6ceeed5737ba3; });
$parcel$export(module.exports, "isHTMLOptGroupElement", function () { return $287617daecc57235$export$bd3879fce36eda9b; });
$parcel$export(module.exports, "isHTMLSelectElement", function () { return $287617daecc57235$export$45bc5bbc5efddf5; });
$parcel$export(module.exports, "isHTMLTableElement", function () { return $287617daecc57235$export$8756991f0c3249b6; });
$parcel$export(module.exports, "isHTMLTextAreaElement", function () { return $287617daecc57235$export$b7395b0e7f36a30b; });
$parcel$export(module.exports, "safeWindow", function () { return $287617daecc57235$export$7dd80fbc14cd23b1; });
$parcel$export(module.exports, "isHTMLFieldSetElement", function () { return $287617daecc57235$export$224ee1e631187c8e; });
$parcel$export(module.exports, "isHTMLLegendElement", function () { return $287617daecc57235$export$b5145d164c8e27ab; });
$parcel$export(module.exports, "isHTMLSlotElement", function () { return $287617daecc57235$export$f3a7a3e8dd95230a; });
$parcel$export(module.exports, "isSVGSVGElement", function () { return $287617daecc57235$export$66957ea77182581d; });
$parcel$export(module.exports, "isSVGTitleElement", function () { return $287617daecc57235$export$2880bca45de60ab2; });
$parcel$export(module.exports, "queryIdRefs", function () { return $287617daecc57235$export$bd387f6d41bd1b18; });
$parcel$export(module.exports, "hasAnyConcreteRoles", function () { return $287617daecc57235$export$d8043cfd36e131b1; });
$parcel$export(module.exports, "getLocalName", function () { return (parcelRequire("5rRYk")).getLocalName; });

var $5rRYk = parcelRequire("5rRYk");
function $287617daecc57235$export$45a5e7f76e0caa8d(node) {
    return node !== null && node.nodeType === node.ELEMENT_NODE;
}
function $287617daecc57235$export$7bec295fe7a71cc3(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "caption";
}
function $287617daecc57235$export$88a6ceeed5737ba3(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "input";
}
function $287617daecc57235$export$bd3879fce36eda9b(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "optgroup";
}
function $287617daecc57235$export$45bc5bbc5efddf5(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "select";
}
function $287617daecc57235$export$8756991f0c3249b6(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "table";
}
function $287617daecc57235$export$b7395b0e7f36a30b(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "textarea";
}
function $287617daecc57235$export$7dd80fbc14cd23b1(node) {
    var _ref = node.ownerDocument === null ? node : node.ownerDocument, defaultView = _ref.defaultView;
    if (defaultView === null) throw new TypeError("no window available");
    return defaultView;
}
function $287617daecc57235$export$224ee1e631187c8e(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "fieldset";
}
function $287617daecc57235$export$b5145d164c8e27ab(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "legend";
}
function $287617daecc57235$export$f3a7a3e8dd95230a(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "slot";
}
function $287617daecc57235$export$17eda790a720ec57(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && node.ownerSVGElement !== undefined;
}
function $287617daecc57235$export$66957ea77182581d(node) {
    return $287617daecc57235$export$45a5e7f76e0caa8d(node) && (0, $5rRYk.getLocalName)(node) === "svg";
}
function $287617daecc57235$export$2880bca45de60ab2(node) {
    return $287617daecc57235$export$17eda790a720ec57(node) && (0, $5rRYk.getLocalName)(node) === "title";
}
function $287617daecc57235$export$bd387f6d41bd1b18(node, attributeName) {
    if ($287617daecc57235$export$45a5e7f76e0caa8d(node) && node.hasAttribute(attributeName)) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- safe due to hasAttribute check
        var ids = node.getAttribute(attributeName).split(" ");
        // Browsers that don't support shadow DOM won't have getRootNode
        var root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
        return ids.map(function(id) {
            return root.getElementById(id);
        }).filter(function(element) {
            return element !== null;
        });
    }
    return [];
}
function $287617daecc57235$export$d8043cfd36e131b1(node, roles) {
    if ($287617daecc57235$export$45a5e7f76e0caa8d(node)) return roles.indexOf((0, $5rRYk.default)(node)) !== -1;
    return false;
}

});
parcelRegister("5rRYk", function(module, exports) {

$parcel$export(module.exports, "getLocalName", function () { return $71d5921d5b5d7062$export$2ef14d8f51556079; });
$parcel$export(module.exports, "default", function () { return $71d5921d5b5d7062$export$2e2bcd8739ae039; });
// https://w3c.github.io/html-aria/#document-conformance-requirements-for-use-of-aria-attributes-in-html
/**
 * Safe Element.localName for all supported environments
 * @param element
 */ function $71d5921d5b5d7062$export$2ef14d8f51556079(element) {
    var _element$localName;
    return (_element$localName = element.localName) !== null && _element$localName !== void 0 ? _element$localName : // eslint-disable-next-line no-restricted-properties -- required for the fallback
    element.tagName.toLowerCase();
}
var $71d5921d5b5d7062$var$localNameToRoleMappings = {
    article: "article",
    aside: "complementary",
    button: "button",
    datalist: "listbox",
    dd: "definition",
    details: "group",
    dialog: "dialog",
    dt: "term",
    fieldset: "group",
    figure: "figure",
    // WARNING: Only with an accessible name
    form: "form",
    footer: "contentinfo",
    h1: "heading",
    h2: "heading",
    h3: "heading",
    h4: "heading",
    h5: "heading",
    h6: "heading",
    header: "banner",
    hr: "separator",
    html: "document",
    legend: "legend",
    li: "listitem",
    math: "math",
    main: "main",
    menu: "list",
    nav: "navigation",
    ol: "list",
    optgroup: "group",
    // WARNING: Only in certain context
    option: "option",
    output: "status",
    progress: "progressbar",
    // WARNING: Only with an accessible name
    section: "region",
    summary: "button",
    table: "table",
    tbody: "rowgroup",
    textarea: "textbox",
    tfoot: "rowgroup",
    // WARNING: Only in certain context
    td: "cell",
    th: "columnheader",
    thead: "rowgroup",
    tr: "row",
    ul: "list"
};
var $71d5921d5b5d7062$var$prohibitedAttributes = {
    caption: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    code: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    deletion: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    emphasis: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    generic: new Set([
        "aria-label",
        "aria-labelledby",
        "aria-roledescription"
    ]),
    insertion: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    paragraph: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    presentation: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    strong: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    subscript: new Set([
        "aria-label",
        "aria-labelledby"
    ]),
    superscript: new Set([
        "aria-label",
        "aria-labelledby"
    ])
};
/**
 *
 * @param element
 * @param role The role used for this element. This is specified to control whether you want to use the implicit or explicit role.
 */ function $71d5921d5b5d7062$var$hasGlobalAriaAttributes(element, role) {
    // https://rawgit.com/w3c/aria/stable/#global_states
    // commented attributes are deprecated
    return [
        "aria-atomic",
        "aria-busy",
        "aria-controls",
        "aria-current",
        "aria-describedby",
        "aria-details",
        // "disabled",
        "aria-dropeffect",
        // "errormessage",
        "aria-flowto",
        "aria-grabbed",
        // "haspopup",
        "aria-hidden",
        // "invalid",
        "aria-keyshortcuts",
        "aria-label",
        "aria-labelledby",
        "aria-live",
        "aria-owns",
        "aria-relevant",
        "aria-roledescription"
    ].some(function(attributeName) {
        var _prohibitedAttributes;
        return element.hasAttribute(attributeName) && !((_prohibitedAttributes = $71d5921d5b5d7062$var$prohibitedAttributes[role]) !== null && _prohibitedAttributes !== void 0 && _prohibitedAttributes.has(attributeName));
    });
}
function $71d5921d5b5d7062$var$ignorePresentationalRole(element, implicitRole) {
    // https://rawgit.com/w3c/aria/stable/#conflict_resolution_presentation_none
    return $71d5921d5b5d7062$var$hasGlobalAriaAttributes(element, implicitRole);
}
function $71d5921d5b5d7062$export$2e2bcd8739ae039(element) {
    var explicitRole = $71d5921d5b5d7062$var$getExplicitRole(element);
    if (explicitRole === null || explicitRole === "presentation") {
        var implicitRole = $71d5921d5b5d7062$var$getImplicitRole(element);
        if (explicitRole !== "presentation" || $71d5921d5b5d7062$var$ignorePresentationalRole(element, implicitRole || "")) return implicitRole;
    }
    return explicitRole;
}
function $71d5921d5b5d7062$var$getImplicitRole(element) {
    var mappedByTag = $71d5921d5b5d7062$var$localNameToRoleMappings[$71d5921d5b5d7062$export$2ef14d8f51556079(element)];
    if (mappedByTag !== undefined) return mappedByTag;
    switch($71d5921d5b5d7062$export$2ef14d8f51556079(element)){
        case "a":
        case "area":
        case "link":
            if (element.hasAttribute("href")) return "link";
            break;
        case "img":
            if (element.getAttribute("alt") === "" && !$71d5921d5b5d7062$var$ignorePresentationalRole(element, "img")) return "presentation";
            return "img";
        case "input":
            var _ref = element, type = _ref.type;
            switch(type){
                case "button":
                case "image":
                case "reset":
                case "submit":
                    return "button";
                case "checkbox":
                case "radio":
                    return type;
                case "range":
                    return "slider";
                case "email":
                case "tel":
                case "text":
                case "url":
                    if (element.hasAttribute("list")) return "combobox";
                    return "textbox";
                case "search":
                    if (element.hasAttribute("list")) return "combobox";
                    return "searchbox";
                case "number":
                    return "spinbutton";
                default:
                    return null;
            }
        case "select":
            if (element.hasAttribute("multiple") || element.size > 1) return "listbox";
            return "combobox";
    }
    return null;
}
function $71d5921d5b5d7062$var$getExplicitRole(element) {
    var role = element.getAttribute("role");
    if (role !== null) {
        var explicitRole = role.trim().split(" ")[0];
        // String.prototype.split(sep, limit) will always return an array with at least one member
        // as long as limit is either undefined or > 0
        if (explicitRole.length > 0) return explicitRole;
    }
    return null;
}

});




parcelRegister("lX55U", function(module, exports) {

$parcel$export(module.exports, "computeAccessibleName", function () { return $30e9ff80da644ca5$export$8d691420cf9d64df; });

var $3Iky5 = parcelRequire("3Iky5");

var $6f9V5 = parcelRequire("6f9V5");
/**
 * https://w3c.github.io/aria/#namefromprohibited
 */ function $30e9ff80da644ca5$var$prohibitsNaming(node) {
    return (0, $6f9V5.hasAnyConcreteRoles)(node, [
        "caption",
        "code",
        "deletion",
        "emphasis",
        "generic",
        "insertion",
        "paragraph",
        "presentation",
        "strong",
        "subscript",
        "superscript"
    ]);
}
function $30e9ff80da644ca5$export$8d691420cf9d64df(root) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if ($30e9ff80da644ca5$var$prohibitsNaming(root)) return "";
    return (0, $3Iky5.computeTextAlternative)(root, options);
}

});

parcelRegister("lYf5C", function(module, exports) {
/**
 * Partial implementation https://www.w3.org/TR/wai-aria-1.2/#tree_exclusion
 * which should only be used for elements with a non-presentational role i.e.
 * `role="none"` and `role="presentation"` will not be excluded.
 *
 * Implements aria-hidden semantics (i.e. parent overrides child)
 * Ignores "Child Presentational: True" characteristics
 *
 * @param element
 * @param options
 * @returns {boolean} true if excluded, otherwise false
 */ function $aee973a024cbe12d$export$dae767fd6de0d418(element) {
    var _element$ownerDocumen;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$getComputedS = options.getComputedStyle, getComputedStyle = _options$getComputedS === void 0 ? (_element$ownerDocumen = element.ownerDocument.defaultView) === null || _element$ownerDocumen === void 0 ? void 0 : _element$ownerDocumen.getComputedStyle : _options$getComputedS, _options$isSubtreeIna = options.isSubtreeInaccessible, isSubtreeInaccessibleImpl = _options$isSubtreeIna === void 0 ? $aee973a024cbe12d$export$803b815ce286574d : _options$isSubtreeIna;
    if (typeof getComputedStyle !== "function") throw new TypeError("Owner document of the element needs to have an associated window.");
    // since visibility is inherited we can exit early
    if (getComputedStyle(element).visibility === "hidden") return true;
    var currentElement = element;
    while(currentElement){
        if (isSubtreeInaccessibleImpl(currentElement, {
            getComputedStyle: getComputedStyle
        })) return true;
        currentElement = currentElement.parentElement;
    }
    return false;
}
function $aee973a024cbe12d$export$803b815ce286574d(element) {
    var _element$ownerDocumen2;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$getComputedS2 = options.getComputedStyle, getComputedStyle = _options$getComputedS2 === void 0 ? (_element$ownerDocumen2 = element.ownerDocument.defaultView) === null || _element$ownerDocumen2 === void 0 ? void 0 : _element$ownerDocumen2.getComputedStyle : _options$getComputedS2;
    if (typeof getComputedStyle !== "function") throw new TypeError("Owner document of the element needs to have an associated window.");
    if (element.hidden === true) return true;
    if (element.getAttribute("aria-hidden") === "true") return true;
    if (getComputedStyle(element).display === "none") return true;
    return false;
}

});


parcelRegister("54Ttj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.roles = module.exports.roleElements = module.exports.elementRoles = module.exports.dom = module.exports.aria = void 0;

var $3b285b05fea94f6a$var$_ariaPropsMap = $3b285b05fea94f6a$var$_interopRequireDefault((parcelRequire("cqYyr")));

var $3b285b05fea94f6a$var$_domMap = $3b285b05fea94f6a$var$_interopRequireDefault((parcelRequire("3ahBf")));

var $3b285b05fea94f6a$var$_rolesMap = $3b285b05fea94f6a$var$_interopRequireDefault((parcelRequire("dVCzH")));

var $3b285b05fea94f6a$var$_elementRoleMap = $3b285b05fea94f6a$var$_interopRequireDefault((parcelRequire("cNpNf")));

var $3b285b05fea94f6a$var$_roleElementMap = $3b285b05fea94f6a$var$_interopRequireDefault((parcelRequire("lT17G")));
function $3b285b05fea94f6a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3b285b05fea94f6a$var$aria = $3b285b05fea94f6a$var$_ariaPropsMap.default;
module.exports.aria = $3b285b05fea94f6a$var$aria;
var $3b285b05fea94f6a$var$dom = $3b285b05fea94f6a$var$_domMap.default;
module.exports.dom = $3b285b05fea94f6a$var$dom;
var $3b285b05fea94f6a$var$roles = $3b285b05fea94f6a$var$_rolesMap.default;
module.exports.roles = $3b285b05fea94f6a$var$roles;
var $3b285b05fea94f6a$var$elementRoles = $3b285b05fea94f6a$var$_elementRoleMap.default;
module.exports.elementRoles = $3b285b05fea94f6a$var$elementRoles;
var $3b285b05fea94f6a$var$roleElements = $3b285b05fea94f6a$var$_roleElementMap.default;
module.exports.roleElements = $3b285b05fea94f6a$var$roleElements;

});
parcelRegister("cqYyr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $90d6e29611507e97$var$_iterationDecorator = $90d6e29611507e97$var$_interopRequireDefault((parcelRequire("CkDFn")));
function $90d6e29611507e97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $90d6e29611507e97$var$_slicedToArray(arr, i) {
    return $90d6e29611507e97$var$_arrayWithHoles(arr) || $90d6e29611507e97$var$_iterableToArrayLimit(arr, i) || $90d6e29611507e97$var$_unsupportedIterableToArray(arr, i) || $90d6e29611507e97$var$_nonIterableRest();
}
function $90d6e29611507e97$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $90d6e29611507e97$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $90d6e29611507e97$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $90d6e29611507e97$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $90d6e29611507e97$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $90d6e29611507e97$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $90d6e29611507e97$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $90d6e29611507e97$var$_arrayLikeToArray(o, minLen);
}
function $90d6e29611507e97$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $90d6e29611507e97$var$properties = [
    [
        'aria-activedescendant',
        {
            'type': 'id'
        }
    ],
    [
        'aria-atomic',
        {
            'type': 'boolean'
        }
    ],
    [
        'aria-autocomplete',
        {
            'type': 'token',
            'values': [
                'inline',
                'list',
                'both',
                'none'
            ]
        }
    ],
    [
        'aria-braillelabel',
        {
            'type': 'string'
        }
    ],
    [
        'aria-brailleroledescription',
        {
            'type': 'string'
        }
    ],
    [
        'aria-busy',
        {
            'type': 'boolean'
        }
    ],
    [
        'aria-checked',
        {
            'type': 'tristate'
        }
    ],
    [
        'aria-colcount',
        {
            type: 'integer'
        }
    ],
    [
        'aria-colindex',
        {
            type: 'integer'
        }
    ],
    [
        'aria-colspan',
        {
            type: 'integer'
        }
    ],
    [
        'aria-controls',
        {
            'type': 'idlist'
        }
    ],
    [
        'aria-current',
        {
            type: 'token',
            values: [
                'page',
                'step',
                'location',
                'date',
                'time',
                true,
                false
            ]
        }
    ],
    [
        'aria-describedby',
        {
            'type': 'idlist'
        }
    ],
    [
        'aria-description',
        {
            'type': 'string'
        }
    ],
    [
        'aria-details',
        {
            'type': 'id'
        }
    ],
    [
        'aria-disabled',
        {
            'type': 'boolean'
        }
    ],
    [
        'aria-dropeffect',
        {
            'type': 'tokenlist',
            'values': [
                'copy',
                'execute',
                'link',
                'move',
                'none',
                'popup'
            ]
        }
    ],
    [
        'aria-errormessage',
        {
            'type': 'id'
        }
    ],
    [
        'aria-expanded',
        {
            'type': 'boolean',
            'allowundefined': true
        }
    ],
    [
        'aria-flowto',
        {
            'type': 'idlist'
        }
    ],
    [
        'aria-grabbed',
        {
            'type': 'boolean',
            'allowundefined': true
        }
    ],
    [
        'aria-haspopup',
        {
            'type': 'token',
            'values': [
                false,
                true,
                'menu',
                'listbox',
                'tree',
                'grid',
                'dialog'
            ]
        }
    ],
    [
        'aria-hidden',
        {
            'type': 'boolean',
            'allowundefined': true
        }
    ],
    [
        'aria-invalid',
        {
            'type': 'token',
            'values': [
                'grammar',
                false,
                'spelling',
                true
            ]
        }
    ],
    [
        'aria-keyshortcuts',
        {
            type: 'string'
        }
    ],
    [
        'aria-label',
        {
            'type': 'string'
        }
    ],
    [
        'aria-labelledby',
        {
            'type': 'idlist'
        }
    ],
    [
        'aria-level',
        {
            'type': 'integer'
        }
    ],
    [
        'aria-live',
        {
            'type': 'token',
            'values': [
                'assertive',
                'off',
                'polite'
            ]
        }
    ],
    [
        'aria-modal',
        {
            type: 'boolean'
        }
    ],
    [
        'aria-multiline',
        {
            'type': 'boolean'
        }
    ],
    [
        'aria-multiselectable',
        {
            'type': 'boolean'
        }
    ],
    [
        'aria-orientation',
        {
            'type': 'token',
            'values': [
                'vertical',
                'undefined',
                'horizontal'
            ]
        }
    ],
    [
        'aria-owns',
        {
            'type': 'idlist'
        }
    ],
    [
        'aria-placeholder',
        {
            type: 'string'
        }
    ],
    [
        'aria-posinset',
        {
            'type': 'integer'
        }
    ],
    [
        'aria-pressed',
        {
            'type': 'tristate'
        }
    ],
    [
        'aria-readonly',
        {
            'type': 'boolean'
        }
    ],
    [
        'aria-relevant',
        {
            'type': 'tokenlist',
            'values': [
                'additions',
                'all',
                'removals',
                'text'
            ]
        }
    ],
    [
        'aria-required',
        {
            'type': 'boolean'
        }
    ],
    [
        'aria-roledescription',
        {
            type: 'string'
        }
    ],
    [
        'aria-rowcount',
        {
            type: 'integer'
        }
    ],
    [
        'aria-rowindex',
        {
            type: 'integer'
        }
    ],
    [
        'aria-rowspan',
        {
            type: 'integer'
        }
    ],
    [
        'aria-selected',
        {
            'type': 'boolean',
            'allowundefined': true
        }
    ],
    [
        'aria-setsize',
        {
            'type': 'integer'
        }
    ],
    [
        'aria-sort',
        {
            'type': 'token',
            'values': [
                'ascending',
                'descending',
                'none',
                'other'
            ]
        }
    ],
    [
        'aria-valuemax',
        {
            'type': 'number'
        }
    ],
    [
        'aria-valuemin',
        {
            'type': 'number'
        }
    ],
    [
        'aria-valuenow',
        {
            'type': 'number'
        }
    ],
    [
        'aria-valuetext',
        {
            'type': 'string'
        }
    ]
];
var $90d6e29611507e97$var$ariaPropsMap = {
    entries: function entries() {
        return $90d6e29611507e97$var$properties;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = $90d6e29611507e97$var$_createForOfIteratorHelper($90d6e29611507e97$var$properties), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $90d6e29611507e97$var$_slicedToArray(_step.value, 2), key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, key, $90d6e29611507e97$var$properties);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = $90d6e29611507e97$var$properties.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!$90d6e29611507e97$var$ariaPropsMap.get(key);
    },
    keys: function keys() {
        return $90d6e29611507e97$var$properties.map(function(_ref) {
            var _ref2 = $90d6e29611507e97$var$_slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return $90d6e29611507e97$var$properties.map(function(_ref3) {
            var _ref4 = $90d6e29611507e97$var$_slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var $90d6e29611507e97$var$_default = (0, $90d6e29611507e97$var$_iterationDecorator.default)($90d6e29611507e97$var$ariaPropsMap, $90d6e29611507e97$var$ariaPropsMap.entries());
module.exports.default = $90d6e29611507e97$var$_default;

});
parcelRegister("CkDFn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $07338f281338e93b$var$iterationDecorator;

var $07338f281338e93b$var$_iteratorProxy = $07338f281338e93b$var$_interopRequireDefault((parcelRequire("2LaHa")));
function $07338f281338e93b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $07338f281338e93b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $07338f281338e93b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $07338f281338e93b$var$_typeof(obj);
}
function $07338f281338e93b$var$iterationDecorator(collection, entries) {
    if (typeof Symbol === 'function' && $07338f281338e93b$var$_typeof(Symbol.iterator) === 'symbol') Object.defineProperty(collection, Symbol.iterator, {
        value: $07338f281338e93b$var$_iteratorProxy.default.bind(entries)
    });
    return collection;
}

});
parcelRegister("2LaHa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
// eslint-disable-next-line no-unused-vars
function $2028446550aea8f5$var$iteratorProxy() {
    var values = this;
    var index = 0;
    var iter = {
        '@@iterator': function iterator() {
            return iter;
        },
        next: function next() {
            if (index < values.length) {
                var value = values[index];
                index = index + 1;
                return {
                    done: false,
                    value: value
                };
            } else return {
                done: true
            };
        }
    };
    return iter;
}
var $2028446550aea8f5$var$_default = $2028446550aea8f5$var$iteratorProxy;
module.exports.default = $2028446550aea8f5$var$_default;

});



parcelRegister("3ahBf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $24dff5316326493b$var$_iterationDecorator = $24dff5316326493b$var$_interopRequireDefault((parcelRequire("CkDFn")));
function $24dff5316326493b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24dff5316326493b$var$_slicedToArray(arr, i) {
    return $24dff5316326493b$var$_arrayWithHoles(arr) || $24dff5316326493b$var$_iterableToArrayLimit(arr, i) || $24dff5316326493b$var$_unsupportedIterableToArray(arr, i) || $24dff5316326493b$var$_nonIterableRest();
}
function $24dff5316326493b$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $24dff5316326493b$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $24dff5316326493b$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $24dff5316326493b$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $24dff5316326493b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $24dff5316326493b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $24dff5316326493b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $24dff5316326493b$var$_arrayLikeToArray(o, minLen);
}
function $24dff5316326493b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $24dff5316326493b$var$dom = [
    [
        'a',
        {
            reserved: false
        }
    ],
    [
        'abbr',
        {
            reserved: false
        }
    ],
    [
        'acronym',
        {
            reserved: false
        }
    ],
    [
        'address',
        {
            reserved: false
        }
    ],
    [
        'applet',
        {
            reserved: false
        }
    ],
    [
        'area',
        {
            reserved: false
        }
    ],
    [
        'article',
        {
            reserved: false
        }
    ],
    [
        'aside',
        {
            reserved: false
        }
    ],
    [
        'audio',
        {
            reserved: false
        }
    ],
    [
        'b',
        {
            reserved: false
        }
    ],
    [
        'base',
        {
            reserved: true
        }
    ],
    [
        'bdi',
        {
            reserved: false
        }
    ],
    [
        'bdo',
        {
            reserved: false
        }
    ],
    [
        'big',
        {
            reserved: false
        }
    ],
    [
        'blink',
        {
            reserved: false
        }
    ],
    [
        'blockquote',
        {
            reserved: false
        }
    ],
    [
        'body',
        {
            reserved: false
        }
    ],
    [
        'br',
        {
            reserved: false
        }
    ],
    [
        'button',
        {
            reserved: false
        }
    ],
    [
        'canvas',
        {
            reserved: false
        }
    ],
    [
        'caption',
        {
            reserved: false
        }
    ],
    [
        'center',
        {
            reserved: false
        }
    ],
    [
        'cite',
        {
            reserved: false
        }
    ],
    [
        'code',
        {
            reserved: false
        }
    ],
    [
        'col',
        {
            reserved: true
        }
    ],
    [
        'colgroup',
        {
            reserved: true
        }
    ],
    [
        'content',
        {
            reserved: false
        }
    ],
    [
        'data',
        {
            reserved: false
        }
    ],
    [
        'datalist',
        {
            reserved: false
        }
    ],
    [
        'dd',
        {
            reserved: false
        }
    ],
    [
        'del',
        {
            reserved: false
        }
    ],
    [
        'details',
        {
            reserved: false
        }
    ],
    [
        'dfn',
        {
            reserved: false
        }
    ],
    [
        'dialog',
        {
            reserved: false
        }
    ],
    [
        'dir',
        {
            reserved: false
        }
    ],
    [
        'div',
        {
            reserved: false
        }
    ],
    [
        'dl',
        {
            reserved: false
        }
    ],
    [
        'dt',
        {
            reserved: false
        }
    ],
    [
        'em',
        {
            reserved: false
        }
    ],
    [
        'embed',
        {
            reserved: false
        }
    ],
    [
        'fieldset',
        {
            reserved: false
        }
    ],
    [
        'figcaption',
        {
            reserved: false
        }
    ],
    [
        'figure',
        {
            reserved: false
        }
    ],
    [
        'font',
        {
            reserved: false
        }
    ],
    [
        'footer',
        {
            reserved: false
        }
    ],
    [
        'form',
        {
            reserved: false
        }
    ],
    [
        'frame',
        {
            reserved: false
        }
    ],
    [
        'frameset',
        {
            reserved: false
        }
    ],
    [
        'h1',
        {
            reserved: false
        }
    ],
    [
        'h2',
        {
            reserved: false
        }
    ],
    [
        'h3',
        {
            reserved: false
        }
    ],
    [
        'h4',
        {
            reserved: false
        }
    ],
    [
        'h5',
        {
            reserved: false
        }
    ],
    [
        'h6',
        {
            reserved: false
        }
    ],
    [
        'head',
        {
            reserved: true
        }
    ],
    [
        'header',
        {
            reserved: false
        }
    ],
    [
        'hgroup',
        {
            reserved: false
        }
    ],
    [
        'hr',
        {
            reserved: false
        }
    ],
    [
        'html',
        {
            reserved: true
        }
    ],
    [
        'i',
        {
            reserved: false
        }
    ],
    [
        'iframe',
        {
            reserved: false
        }
    ],
    [
        'img',
        {
            reserved: false
        }
    ],
    [
        'input',
        {
            reserved: false
        }
    ],
    [
        'ins',
        {
            reserved: false
        }
    ],
    [
        'kbd',
        {
            reserved: false
        }
    ],
    [
        'keygen',
        {
            reserved: false
        }
    ],
    [
        'label',
        {
            reserved: false
        }
    ],
    [
        'legend',
        {
            reserved: false
        }
    ],
    [
        'li',
        {
            reserved: false
        }
    ],
    [
        'link',
        {
            reserved: true
        }
    ],
    [
        'main',
        {
            reserved: false
        }
    ],
    [
        'map',
        {
            reserved: false
        }
    ],
    [
        'mark',
        {
            reserved: false
        }
    ],
    [
        'marquee',
        {
            reserved: false
        }
    ],
    [
        'menu',
        {
            reserved: false
        }
    ],
    [
        'menuitem',
        {
            reserved: false
        }
    ],
    [
        'meta',
        {
            reserved: true
        }
    ],
    [
        'meter',
        {
            reserved: false
        }
    ],
    [
        'nav',
        {
            reserved: false
        }
    ],
    [
        'noembed',
        {
            reserved: true
        }
    ],
    [
        'noscript',
        {
            reserved: true
        }
    ],
    [
        'object',
        {
            reserved: false
        }
    ],
    [
        'ol',
        {
            reserved: false
        }
    ],
    [
        'optgroup',
        {
            reserved: false
        }
    ],
    [
        'option',
        {
            reserved: false
        }
    ],
    [
        'output',
        {
            reserved: false
        }
    ],
    [
        'p',
        {
            reserved: false
        }
    ],
    [
        'param',
        {
            reserved: true
        }
    ],
    [
        'picture',
        {
            reserved: true
        }
    ],
    [
        'pre',
        {
            reserved: false
        }
    ],
    [
        'progress',
        {
            reserved: false
        }
    ],
    [
        'q',
        {
            reserved: false
        }
    ],
    [
        'rp',
        {
            reserved: false
        }
    ],
    [
        'rt',
        {
            reserved: false
        }
    ],
    [
        'rtc',
        {
            reserved: false
        }
    ],
    [
        'ruby',
        {
            reserved: false
        }
    ],
    [
        's',
        {
            reserved: false
        }
    ],
    [
        'samp',
        {
            reserved: false
        }
    ],
    [
        'script',
        {
            reserved: true
        }
    ],
    [
        'section',
        {
            reserved: false
        }
    ],
    [
        'select',
        {
            reserved: false
        }
    ],
    [
        'small',
        {
            reserved: false
        }
    ],
    [
        'source',
        {
            reserved: true
        }
    ],
    [
        'spacer',
        {
            reserved: false
        }
    ],
    [
        'span',
        {
            reserved: false
        }
    ],
    [
        'strike',
        {
            reserved: false
        }
    ],
    [
        'strong',
        {
            reserved: false
        }
    ],
    [
        'style',
        {
            reserved: true
        }
    ],
    [
        'sub',
        {
            reserved: false
        }
    ],
    [
        'summary',
        {
            reserved: false
        }
    ],
    [
        'sup',
        {
            reserved: false
        }
    ],
    [
        'table',
        {
            reserved: false
        }
    ],
    [
        'tbody',
        {
            reserved: false
        }
    ],
    [
        'td',
        {
            reserved: false
        }
    ],
    [
        'textarea',
        {
            reserved: false
        }
    ],
    [
        'tfoot',
        {
            reserved: false
        }
    ],
    [
        'th',
        {
            reserved: false
        }
    ],
    [
        'thead',
        {
            reserved: false
        }
    ],
    [
        'time',
        {
            reserved: false
        }
    ],
    [
        'title',
        {
            reserved: true
        }
    ],
    [
        'tr',
        {
            reserved: false
        }
    ],
    [
        'track',
        {
            reserved: true
        }
    ],
    [
        'tt',
        {
            reserved: false
        }
    ],
    [
        'u',
        {
            reserved: false
        }
    ],
    [
        'ul',
        {
            reserved: false
        }
    ],
    [
        'var',
        {
            reserved: false
        }
    ],
    [
        'video',
        {
            reserved: false
        }
    ],
    [
        'wbr',
        {
            reserved: false
        }
    ],
    [
        'xmp',
        {
            reserved: false
        }
    ]
];
var $24dff5316326493b$var$domMap = {
    entries: function entries() {
        return $24dff5316326493b$var$dom;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = $24dff5316326493b$var$_createForOfIteratorHelper($24dff5316326493b$var$dom), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $24dff5316326493b$var$_slicedToArray(_step.value, 2), key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, key, $24dff5316326493b$var$dom);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = $24dff5316326493b$var$dom.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!$24dff5316326493b$var$domMap.get(key);
    },
    keys: function keys() {
        return $24dff5316326493b$var$dom.map(function(_ref) {
            var _ref2 = $24dff5316326493b$var$_slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return $24dff5316326493b$var$dom.map(function(_ref3) {
            var _ref4 = $24dff5316326493b$var$_slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var $24dff5316326493b$var$_default = (0, $24dff5316326493b$var$_iterationDecorator.default)($24dff5316326493b$var$domMap, $24dff5316326493b$var$domMap.entries());
module.exports.default = $24dff5316326493b$var$_default;

});

parcelRegister("dVCzH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a23e855dfad8eb50$var$_ariaAbstractRoles = $a23e855dfad8eb50$var$_interopRequireDefault((parcelRequire("73QHK")));

var $a23e855dfad8eb50$var$_ariaLiteralRoles = $a23e855dfad8eb50$var$_interopRequireDefault((parcelRequire("iNzjO")));

var $a23e855dfad8eb50$var$_ariaDpubRoles = $a23e855dfad8eb50$var$_interopRequireDefault((parcelRequire("kAKup")));

var $a23e855dfad8eb50$var$_ariaGraphicsRoles = $a23e855dfad8eb50$var$_interopRequireDefault((parcelRequire("lUHT7")));

var $a23e855dfad8eb50$var$_iterationDecorator = $a23e855dfad8eb50$var$_interopRequireDefault((parcelRequire("CkDFn")));
function $a23e855dfad8eb50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a23e855dfad8eb50$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a23e855dfad8eb50$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $a23e855dfad8eb50$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $a23e855dfad8eb50$var$_slicedToArray(arr, i) {
    return $a23e855dfad8eb50$var$_arrayWithHoles(arr) || $a23e855dfad8eb50$var$_iterableToArrayLimit(arr, i) || $a23e855dfad8eb50$var$_unsupportedIterableToArray(arr, i) || $a23e855dfad8eb50$var$_nonIterableRest();
}
function $a23e855dfad8eb50$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a23e855dfad8eb50$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a23e855dfad8eb50$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a23e855dfad8eb50$var$_arrayLikeToArray(o, minLen);
}
function $a23e855dfad8eb50$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a23e855dfad8eb50$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a23e855dfad8eb50$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a23e855dfad8eb50$var$roles = [].concat($a23e855dfad8eb50$var$_ariaAbstractRoles.default, $a23e855dfad8eb50$var$_ariaLiteralRoles.default, $a23e855dfad8eb50$var$_ariaDpubRoles.default, $a23e855dfad8eb50$var$_ariaGraphicsRoles.default);
$a23e855dfad8eb50$var$roles.forEach(function(_ref) {
    var _ref2 = $a23e855dfad8eb50$var$_slicedToArray(_ref, 2), roleDefinition = _ref2[1];
    // Conglomerate the properties
    var _iterator = $a23e855dfad8eb50$var$_createForOfIteratorHelper(roleDefinition.superClass), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var superClassIter = _step.value;
            var _iterator2 = $a23e855dfad8eb50$var$_createForOfIteratorHelper(superClassIter), _step2;
            try {
                var _loop = function _loop() {
                    var superClassName = _step2.value;
                    var superClassRoleTuple = $a23e855dfad8eb50$var$roles.find(function(_ref3) {
                        var _ref4 = $a23e855dfad8eb50$var$_slicedToArray(_ref3, 1), name = _ref4[0];
                        return name === superClassName;
                    });
                    if (superClassRoleTuple) {
                        var superClassDefinition = superClassRoleTuple[1];
                        for(var _i2 = 0, _Object$keys = Object.keys(superClassDefinition.props); _i2 < _Object$keys.length; _i2++){
                            var prop = _Object$keys[_i2];
                            if (// $FlowIssue Accessing the hasOwnProperty on the Object prototype is fine.
                            !Object.prototype.hasOwnProperty.call(roleDefinition.props, prop)) Object.assign(roleDefinition.props, $a23e855dfad8eb50$var$_defineProperty({}, prop, superClassDefinition.props[prop]));
                        }
                    }
                };
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;)_loop();
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
});
var $a23e855dfad8eb50$var$rolesMap = {
    entries: function entries() {
        return $a23e855dfad8eb50$var$roles;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator3 = $a23e855dfad8eb50$var$_createForOfIteratorHelper($a23e855dfad8eb50$var$roles), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var _step3$value = $a23e855dfad8eb50$var$_slicedToArray(_step3.value, 2), key = _step3$value[0], values = _step3$value[1];
                fn.call(thisArg, values, key, $a23e855dfad8eb50$var$roles);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    },
    get: function get(key) {
        var item = $a23e855dfad8eb50$var$roles.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!$a23e855dfad8eb50$var$rolesMap.get(key);
    },
    keys: function keys() {
        return $a23e855dfad8eb50$var$roles.map(function(_ref5) {
            var _ref6 = $a23e855dfad8eb50$var$_slicedToArray(_ref5, 1), key = _ref6[0];
            return key;
        });
    },
    values: function values() {
        return $a23e855dfad8eb50$var$roles.map(function(_ref7) {
            var _ref8 = $a23e855dfad8eb50$var$_slicedToArray(_ref7, 2), values = _ref8[1];
            return values;
        });
    }
};
var $a23e855dfad8eb50$var$_default = (0, $a23e855dfad8eb50$var$_iterationDecorator.default)($a23e855dfad8eb50$var$rolesMap, $a23e855dfad8eb50$var$rolesMap.entries());
module.exports.default = $a23e855dfad8eb50$var$_default;

});
parcelRegister("73QHK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5241b23db38739d7$var$_commandRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("3KIGe")));

var $5241b23db38739d7$var$_compositeRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("dv4T3")));

var $5241b23db38739d7$var$_inputRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("9wfoA")));

var $5241b23db38739d7$var$_landmarkRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("7uZOT")));

var $5241b23db38739d7$var$_rangeRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("lo5ys")));

var $5241b23db38739d7$var$_roletypeRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("6qk25")));

var $5241b23db38739d7$var$_sectionRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("90p6K")));

var $5241b23db38739d7$var$_sectionheadRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("k3ktN")));

var $5241b23db38739d7$var$_selectRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("gdGgw")));

var $5241b23db38739d7$var$_structureRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("2Y1YH")));

var $5241b23db38739d7$var$_widgetRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("2GzRy")));

var $5241b23db38739d7$var$_windowRole = $5241b23db38739d7$var$_interopRequireDefault((parcelRequire("7YRau")));
function $5241b23db38739d7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5241b23db38739d7$var$ariaAbstractRoles = [
    [
        'command',
        $5241b23db38739d7$var$_commandRole.default
    ],
    [
        'composite',
        $5241b23db38739d7$var$_compositeRole.default
    ],
    [
        'input',
        $5241b23db38739d7$var$_inputRole.default
    ],
    [
        'landmark',
        $5241b23db38739d7$var$_landmarkRole.default
    ],
    [
        'range',
        $5241b23db38739d7$var$_rangeRole.default
    ],
    [
        'roletype',
        $5241b23db38739d7$var$_roletypeRole.default
    ],
    [
        'section',
        $5241b23db38739d7$var$_sectionRole.default
    ],
    [
        'sectionhead',
        $5241b23db38739d7$var$_sectionheadRole.default
    ],
    [
        'select',
        $5241b23db38739d7$var$_selectRole.default
    ],
    [
        'structure',
        $5241b23db38739d7$var$_structureRole.default
    ],
    [
        'widget',
        $5241b23db38739d7$var$_widgetRole.default
    ],
    [
        'window',
        $5241b23db38739d7$var$_windowRole.default
    ]
];
var $5241b23db38739d7$var$_default = $5241b23db38739d7$var$ariaAbstractRoles;
module.exports.default = $5241b23db38739d7$var$_default;

});
parcelRegister("3KIGe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2bb8538a188b13ed$var$commandRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget'
        ]
    ]
};
var $2bb8538a188b13ed$var$_default = $2bb8538a188b13ed$var$commandRole;
module.exports.default = $2bb8538a188b13ed$var$_default;

});

parcelRegister("dv4T3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9d41f613ab899b45$var$compositeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-activedescendant': null,
        'aria-disabled': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget'
        ]
    ]
};
var $9d41f613ab899b45$var$_default = $9d41f613ab899b45$var$compositeRole;
module.exports.default = $9d41f613ab899b45$var$_default;

});

parcelRegister("9wfoA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6ee30b78f9539ea4$var$inputRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'input'
            },
            module: 'XForms'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget'
        ]
    ]
};
var $6ee30b78f9539ea4$var$_default = $6ee30b78f9539ea4$var$inputRole;
module.exports.default = $6ee30b78f9539ea4$var$_default;

});

parcelRegister("7uZOT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $575b49df160826f4$var$landmarkRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $575b49df160826f4$var$_default = $575b49df160826f4$var$landmarkRole;
module.exports.default = $575b49df160826f4$var$_default;

});

parcelRegister("lo5ys", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f92025ebdf42f0b9$var$rangeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-valuemax': null,
        'aria-valuemin': null,
        'aria-valuenow': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $f92025ebdf42f0b9$var$_default = $f92025ebdf42f0b9$var$rangeRole;
module.exports.default = $f92025ebdf42f0b9$var$_default;

});

parcelRegister("6qk25", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $0134faace96e26a7$var$roletypeRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {
        'aria-atomic': null,
        'aria-busy': null,
        'aria-controls': null,
        'aria-current': null,
        'aria-describedby': null,
        'aria-details': null,
        'aria-dropeffect': null,
        'aria-flowto': null,
        'aria-grabbed': null,
        'aria-hidden': null,
        'aria-keyshortcuts': null,
        'aria-label': null,
        'aria-labelledby': null,
        'aria-live': null,
        'aria-owns': null,
        'aria-relevant': null,
        'aria-roledescription': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'role'
            },
            module: 'XHTML'
        },
        {
            concept: {
                name: 'type'
            },
            module: 'Dublin Core'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
};
var $0134faace96e26a7$var$_default = $0134faace96e26a7$var$roletypeRole;
module.exports.default = $0134faace96e26a7$var$_default;

});

parcelRegister("90p6K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $68e7970f84e82f15$var$sectionRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'frontmatter'
            },
            module: 'DTB'
        },
        {
            concept: {
                name: 'level'
            },
            module: 'DTB'
        },
        {
            concept: {
                name: 'level'
            },
            module: 'SMIL'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $68e7970f84e82f15$var$_default = $68e7970f84e82f15$var$sectionRole;
module.exports.default = $68e7970f84e82f15$var$_default;

});

parcelRegister("k3ktN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e993f945d6fea5b2$var$sectionheadRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $e993f945d6fea5b2$var$_default = $e993f945d6fea5b2$var$sectionheadRole;
module.exports.default = $e993f945d6fea5b2$var$_default;

});

parcelRegister("gdGgw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $bceea54453512afa$var$selectRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-orientation': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite'
        ],
        [
            'roletype',
            'structure',
            'section',
            'group'
        ]
    ]
};
var $bceea54453512afa$var$_default = $bceea54453512afa$var$selectRole;
module.exports.default = $bceea54453512afa$var$_default;

});

parcelRegister("2Y1YH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2292b8264da28497$var$structureRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype'
        ]
    ]
};
var $2292b8264da28497$var$_default = $2292b8264da28497$var$structureRole;
module.exports.default = $2292b8264da28497$var$_default;

});

parcelRegister("2GzRy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1f4b52a2c87e4ba9$var$widgetRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype'
        ]
    ]
};
var $1f4b52a2c87e4ba9$var$_default = $1f4b52a2c87e4ba9$var$widgetRole;
module.exports.default = $1f4b52a2c87e4ba9$var$_default;

});

parcelRegister("7YRau", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5cf7611a5b05e025$var$windowRole = {
    abstract: true,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-modal': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype'
        ]
    ]
};
var $5cf7611a5b05e025$var$_default = $5cf7611a5b05e025$var$windowRole;
module.exports.default = $5cf7611a5b05e025$var$_default;

});


parcelRegister("iNzjO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $daf8331a292a70ff$var$_alertRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("4Wujo")));

var $daf8331a292a70ff$var$_alertdialogRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("I7FYk")));

var $daf8331a292a70ff$var$_applicationRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("eqNHM")));

var $daf8331a292a70ff$var$_articleRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("4xFKK")));

var $daf8331a292a70ff$var$_bannerRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("dhFwY")));

var $daf8331a292a70ff$var$_blockquoteRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("jCHkF")));

var $daf8331a292a70ff$var$_buttonRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("9QLm6")));

var $daf8331a292a70ff$var$_captionRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("bhKqd")));

var $daf8331a292a70ff$var$_cellRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("gmvku")));

var $daf8331a292a70ff$var$_checkboxRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("lJM7W")));

var $daf8331a292a70ff$var$_codeRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("2uqdJ")));

var $daf8331a292a70ff$var$_columnheaderRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("aCVDp")));

var $daf8331a292a70ff$var$_comboboxRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("doYGM")));

var $daf8331a292a70ff$var$_complementaryRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("6eH81")));

var $daf8331a292a70ff$var$_contentinfoRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("c6Jqa")));

var $daf8331a292a70ff$var$_definitionRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("2mH7e")));

var $daf8331a292a70ff$var$_deletionRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("lgkqH")));

var $daf8331a292a70ff$var$_dialogRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("8jtUM")));

var $daf8331a292a70ff$var$_directoryRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("7IiiI")));

var $daf8331a292a70ff$var$_documentRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("kSt7F")));

var $daf8331a292a70ff$var$_emphasisRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("c3lCj")));

var $daf8331a292a70ff$var$_feedRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("eKc8n")));

var $daf8331a292a70ff$var$_figureRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("lPkgd")));

var $daf8331a292a70ff$var$_formRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("8wQwF")));

var $daf8331a292a70ff$var$_genericRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("2CZHG")));

var $daf8331a292a70ff$var$_gridRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("7jAa8")));

var $daf8331a292a70ff$var$_gridcellRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("lQeaG")));

var $daf8331a292a70ff$var$_groupRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("8awx5")));

var $daf8331a292a70ff$var$_headingRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("fpRQK")));

var $daf8331a292a70ff$var$_imgRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("jpbth")));

var $daf8331a292a70ff$var$_insertionRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("gNzly")));

var $daf8331a292a70ff$var$_linkRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("7MREU")));

var $daf8331a292a70ff$var$_listRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("b9gwW")));

var $daf8331a292a70ff$var$_listboxRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("eTkEM")));

var $daf8331a292a70ff$var$_listitemRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("fXez5")));

var $daf8331a292a70ff$var$_logRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("emGf9")));

var $daf8331a292a70ff$var$_mainRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("e8Gcv")));

var $daf8331a292a70ff$var$_markRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("eOLaQ")));

var $daf8331a292a70ff$var$_marqueeRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("iFpM7")));

var $daf8331a292a70ff$var$_mathRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("cPRhD")));

var $daf8331a292a70ff$var$_menuRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("ehW2P")));

var $daf8331a292a70ff$var$_menubarRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("cuLbi")));

var $daf8331a292a70ff$var$_menuitemRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("gYkEL")));

var $daf8331a292a70ff$var$_menuitemcheckboxRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("fhBYi")));

var $daf8331a292a70ff$var$_menuitemradioRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("3jQG6")));

var $daf8331a292a70ff$var$_meterRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("76Df2")));

var $daf8331a292a70ff$var$_navigationRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("laURr")));

var $daf8331a292a70ff$var$_noneRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("94kp3")));

var $daf8331a292a70ff$var$_noteRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("3cu4N")));

var $daf8331a292a70ff$var$_optionRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("L0mdV")));

var $daf8331a292a70ff$var$_paragraphRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("hGNkD")));

var $daf8331a292a70ff$var$_presentationRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("3XLqg")));

var $daf8331a292a70ff$var$_progressbarRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("hHxis")));

var $daf8331a292a70ff$var$_radioRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("fdDma")));

var $daf8331a292a70ff$var$_radiogroupRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("ko90M")));

var $daf8331a292a70ff$var$_regionRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("5wpw5")));

var $daf8331a292a70ff$var$_rowRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("e5YqT")));

var $daf8331a292a70ff$var$_rowgroupRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("kOY74")));

var $daf8331a292a70ff$var$_rowheaderRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("5i2Av")));

var $daf8331a292a70ff$var$_scrollbarRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("37hbn")));

var $daf8331a292a70ff$var$_searchRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("ajmxq")));

var $daf8331a292a70ff$var$_searchboxRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("fNHdZ")));

var $daf8331a292a70ff$var$_separatorRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("84fQO")));

var $daf8331a292a70ff$var$_sliderRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("8M5Ra")));

var $daf8331a292a70ff$var$_spinbuttonRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("80EsX")));

var $daf8331a292a70ff$var$_statusRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("8QUem")));

var $daf8331a292a70ff$var$_strongRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("kGvDu")));

var $daf8331a292a70ff$var$_subscriptRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("4igW8")));

var $daf8331a292a70ff$var$_superscriptRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("hD5cA")));

var $daf8331a292a70ff$var$_switchRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("K8eRP")));

var $daf8331a292a70ff$var$_tabRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("egDPt")));

var $daf8331a292a70ff$var$_tableRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("45SyE")));

var $daf8331a292a70ff$var$_tablistRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("6mBNF")));

var $daf8331a292a70ff$var$_tabpanelRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("eFqDE")));

var $daf8331a292a70ff$var$_termRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("4zLm3")));

var $daf8331a292a70ff$var$_textboxRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("lUIDs")));

var $daf8331a292a70ff$var$_timeRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("4TtEp")));

var $daf8331a292a70ff$var$_timerRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("gwcE6")));

var $daf8331a292a70ff$var$_toolbarRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("f48Ke")));

var $daf8331a292a70ff$var$_tooltipRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("dUmQi")));

var $daf8331a292a70ff$var$_treeRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("5wsTu")));

var $daf8331a292a70ff$var$_treegridRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("8ecB0")));

var $daf8331a292a70ff$var$_treeitemRole = $daf8331a292a70ff$var$_interopRequireDefault((parcelRequire("8JaM1")));
function $daf8331a292a70ff$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $daf8331a292a70ff$var$ariaLiteralRoles = [
    [
        'alert',
        $daf8331a292a70ff$var$_alertRole.default
    ],
    [
        'alertdialog',
        $daf8331a292a70ff$var$_alertdialogRole.default
    ],
    [
        'application',
        $daf8331a292a70ff$var$_applicationRole.default
    ],
    [
        'article',
        $daf8331a292a70ff$var$_articleRole.default
    ],
    [
        'banner',
        $daf8331a292a70ff$var$_bannerRole.default
    ],
    [
        'blockquote',
        $daf8331a292a70ff$var$_blockquoteRole.default
    ],
    [
        'button',
        $daf8331a292a70ff$var$_buttonRole.default
    ],
    [
        'caption',
        $daf8331a292a70ff$var$_captionRole.default
    ],
    [
        'cell',
        $daf8331a292a70ff$var$_cellRole.default
    ],
    [
        'checkbox',
        $daf8331a292a70ff$var$_checkboxRole.default
    ],
    [
        'code',
        $daf8331a292a70ff$var$_codeRole.default
    ],
    [
        'columnheader',
        $daf8331a292a70ff$var$_columnheaderRole.default
    ],
    [
        'combobox',
        $daf8331a292a70ff$var$_comboboxRole.default
    ],
    [
        'complementary',
        $daf8331a292a70ff$var$_complementaryRole.default
    ],
    [
        'contentinfo',
        $daf8331a292a70ff$var$_contentinfoRole.default
    ],
    [
        'definition',
        $daf8331a292a70ff$var$_definitionRole.default
    ],
    [
        'deletion',
        $daf8331a292a70ff$var$_deletionRole.default
    ],
    [
        'dialog',
        $daf8331a292a70ff$var$_dialogRole.default
    ],
    [
        'directory',
        $daf8331a292a70ff$var$_directoryRole.default
    ],
    [
        'document',
        $daf8331a292a70ff$var$_documentRole.default
    ],
    [
        'emphasis',
        $daf8331a292a70ff$var$_emphasisRole.default
    ],
    [
        'feed',
        $daf8331a292a70ff$var$_feedRole.default
    ],
    [
        'figure',
        $daf8331a292a70ff$var$_figureRole.default
    ],
    [
        'form',
        $daf8331a292a70ff$var$_formRole.default
    ],
    [
        'generic',
        $daf8331a292a70ff$var$_genericRole.default
    ],
    [
        'grid',
        $daf8331a292a70ff$var$_gridRole.default
    ],
    [
        'gridcell',
        $daf8331a292a70ff$var$_gridcellRole.default
    ],
    [
        'group',
        $daf8331a292a70ff$var$_groupRole.default
    ],
    [
        'heading',
        $daf8331a292a70ff$var$_headingRole.default
    ],
    [
        'img',
        $daf8331a292a70ff$var$_imgRole.default
    ],
    [
        'insertion',
        $daf8331a292a70ff$var$_insertionRole.default
    ],
    [
        'link',
        $daf8331a292a70ff$var$_linkRole.default
    ],
    [
        'list',
        $daf8331a292a70ff$var$_listRole.default
    ],
    [
        'listbox',
        $daf8331a292a70ff$var$_listboxRole.default
    ],
    [
        'listitem',
        $daf8331a292a70ff$var$_listitemRole.default
    ],
    [
        'log',
        $daf8331a292a70ff$var$_logRole.default
    ],
    [
        'main',
        $daf8331a292a70ff$var$_mainRole.default
    ],
    [
        'mark',
        $daf8331a292a70ff$var$_markRole.default
    ],
    [
        'marquee',
        $daf8331a292a70ff$var$_marqueeRole.default
    ],
    [
        'math',
        $daf8331a292a70ff$var$_mathRole.default
    ],
    [
        'menu',
        $daf8331a292a70ff$var$_menuRole.default
    ],
    [
        'menubar',
        $daf8331a292a70ff$var$_menubarRole.default
    ],
    [
        'menuitem',
        $daf8331a292a70ff$var$_menuitemRole.default
    ],
    [
        'menuitemcheckbox',
        $daf8331a292a70ff$var$_menuitemcheckboxRole.default
    ],
    [
        'menuitemradio',
        $daf8331a292a70ff$var$_menuitemradioRole.default
    ],
    [
        'meter',
        $daf8331a292a70ff$var$_meterRole.default
    ],
    [
        'navigation',
        $daf8331a292a70ff$var$_navigationRole.default
    ],
    [
        'none',
        $daf8331a292a70ff$var$_noneRole.default
    ],
    [
        'note',
        $daf8331a292a70ff$var$_noteRole.default
    ],
    [
        'option',
        $daf8331a292a70ff$var$_optionRole.default
    ],
    [
        'paragraph',
        $daf8331a292a70ff$var$_paragraphRole.default
    ],
    [
        'presentation',
        $daf8331a292a70ff$var$_presentationRole.default
    ],
    [
        'progressbar',
        $daf8331a292a70ff$var$_progressbarRole.default
    ],
    [
        'radio',
        $daf8331a292a70ff$var$_radioRole.default
    ],
    [
        'radiogroup',
        $daf8331a292a70ff$var$_radiogroupRole.default
    ],
    [
        'region',
        $daf8331a292a70ff$var$_regionRole.default
    ],
    [
        'row',
        $daf8331a292a70ff$var$_rowRole.default
    ],
    [
        'rowgroup',
        $daf8331a292a70ff$var$_rowgroupRole.default
    ],
    [
        'rowheader',
        $daf8331a292a70ff$var$_rowheaderRole.default
    ],
    [
        'scrollbar',
        $daf8331a292a70ff$var$_scrollbarRole.default
    ],
    [
        'search',
        $daf8331a292a70ff$var$_searchRole.default
    ],
    [
        'searchbox',
        $daf8331a292a70ff$var$_searchboxRole.default
    ],
    [
        'separator',
        $daf8331a292a70ff$var$_separatorRole.default
    ],
    [
        'slider',
        $daf8331a292a70ff$var$_sliderRole.default
    ],
    [
        'spinbutton',
        $daf8331a292a70ff$var$_spinbuttonRole.default
    ],
    [
        'status',
        $daf8331a292a70ff$var$_statusRole.default
    ],
    [
        'strong',
        $daf8331a292a70ff$var$_strongRole.default
    ],
    [
        'subscript',
        $daf8331a292a70ff$var$_subscriptRole.default
    ],
    [
        'superscript',
        $daf8331a292a70ff$var$_superscriptRole.default
    ],
    [
        'switch',
        $daf8331a292a70ff$var$_switchRole.default
    ],
    [
        'tab',
        $daf8331a292a70ff$var$_tabRole.default
    ],
    [
        'table',
        $daf8331a292a70ff$var$_tableRole.default
    ],
    [
        'tablist',
        $daf8331a292a70ff$var$_tablistRole.default
    ],
    [
        'tabpanel',
        $daf8331a292a70ff$var$_tabpanelRole.default
    ],
    [
        'term',
        $daf8331a292a70ff$var$_termRole.default
    ],
    [
        'textbox',
        $daf8331a292a70ff$var$_textboxRole.default
    ],
    [
        'time',
        $daf8331a292a70ff$var$_timeRole.default
    ],
    [
        'timer',
        $daf8331a292a70ff$var$_timerRole.default
    ],
    [
        'toolbar',
        $daf8331a292a70ff$var$_toolbarRole.default
    ],
    [
        'tooltip',
        $daf8331a292a70ff$var$_tooltipRole.default
    ],
    [
        'tree',
        $daf8331a292a70ff$var$_treeRole.default
    ],
    [
        'treegrid',
        $daf8331a292a70ff$var$_treegridRole.default
    ],
    [
        'treeitem',
        $daf8331a292a70ff$var$_treeitemRole.default
    ]
];
var $daf8331a292a70ff$var$_default = $daf8331a292a70ff$var$ariaLiteralRoles;
module.exports.default = $daf8331a292a70ff$var$_default;

});
parcelRegister("4Wujo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $39941779f5720976$var$alertRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-atomic': 'true',
        'aria-live': 'assertive'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'alert'
            },
            module: 'XForms'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $39941779f5720976$var$_default = $39941779f5720976$var$alertRole;
module.exports.default = $39941779f5720976$var$_default;

});

parcelRegister("I7FYk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $084a10768de818f2$var$alertdialogRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'alert'
            },
            module: 'XForms'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'alert'
        ],
        [
            'roletype',
            'window',
            'dialog'
        ]
    ]
};
var $084a10768de818f2$var$_default = $084a10768de818f2$var$alertdialogRole;
module.exports.default = $084a10768de818f2$var$_default;

});

parcelRegister("eqNHM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a81a0ccb2579e86d$var$applicationRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-activedescendant': null,
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'Device Independence Delivery Unit'
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $a81a0ccb2579e86d$var$_default = $a81a0ccb2579e86d$var$applicationRole;
module.exports.default = $a81a0ccb2579e86d$var$_default;

});

parcelRegister("4xFKK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $34eaa1be40f96447$var$articleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-posinset': null,
        'aria-setsize': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'article'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'document'
        ]
    ]
};
var $34eaa1be40f96447$var$_default = $34eaa1be40f96447$var$articleRole;
module.exports.default = $34eaa1be40f96447$var$_default;

});

parcelRegister("dhFwY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9abd1411c0ad713f$var$bannerRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    'scoped to the body element'
                ],
                name: 'header'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $9abd1411c0ad713f$var$_default = $9abd1411c0ad713f$var$bannerRole;
module.exports.default = $9abd1411c0ad713f$var$_default;

});

parcelRegister("jCHkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e4932ddb57066d19$var$blockquoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'blockquote'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $e4932ddb57066d19$var$_default = $e4932ddb57066d19$var$blockquoteRole;
module.exports.default = $e4932ddb57066d19$var$_default;

});

parcelRegister("9QLm6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $72bdb42e8a02be74$var$buttonRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-pressed': null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'button'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'image'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'reset'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'submit'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'button'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'trigger'
            },
            module: 'XForms'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'command'
        ]
    ]
};
var $72bdb42e8a02be74$var$_default = $72bdb42e8a02be74$var$buttonRole;
module.exports.default = $72bdb42e8a02be74$var$_default;

});

parcelRegister("bhKqd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $83754aa59e3c2f50$var$captionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'caption'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [
        'figure',
        'grid',
        'table'
    ],
    requiredContextRole: [
        'figure',
        'grid',
        'table'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $83754aa59e3c2f50$var$_default = $83754aa59e3c2f50$var$captionRole;
module.exports.default = $83754aa59e3c2f50$var$_default;

});

parcelRegister("gmvku", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $be9700cf4492175d$var$cellRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-colindex': null,
        'aria-colspan': null,
        'aria-rowindex': null,
        'aria-rowspan': null
    },
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    'ancestor table element has table role'
                ],
                name: 'td'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [
        'row'
    ],
    requiredContextRole: [
        'row'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $be9700cf4492175d$var$_default = $be9700cf4492175d$var$cellRole;
module.exports.default = $be9700cf4492175d$var$_default;

});

parcelRegister("lJM7W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fd3321f507a704cb$var$checkboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-checked': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-invalid': null,
        'aria-readonly': null,
        'aria-required': null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'checkbox'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'option'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-checked': null
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input'
        ]
    ]
};
var $fd3321f507a704cb$var$_default = $fd3321f507a704cb$var$checkboxRole;
module.exports.default = $fd3321f507a704cb$var$_default;

});

parcelRegister("2uqdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1d02b8f85a135318$var$codeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'code'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $1d02b8f85a135318$var$_default = $1d02b8f85a135318$var$codeRole;
module.exports.default = $1d02b8f85a135318$var$_default;

});

parcelRegister("aCVDp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7bca2907bcc7adef$var$columnheaderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-sort': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'th'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        name: 'scope',
                        value: 'col'
                    }
                ],
                name: 'th'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        name: 'scope',
                        value: 'colgroup'
                    }
                ],
                name: 'th'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [
        'row'
    ],
    requiredContextRole: [
        'row'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'cell'
        ],
        [
            'roletype',
            'structure',
            'section',
            'cell',
            'gridcell'
        ],
        [
            'roletype',
            'widget',
            'gridcell'
        ],
        [
            'roletype',
            'structure',
            'sectionhead'
        ]
    ]
};
var $7bca2907bcc7adef$var$_default = $7bca2907bcc7adef$var$columnheaderRole;
module.exports.default = $7bca2907bcc7adef$var$_default;

});

parcelRegister("doYGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9c1c97d6b961a5c6$var$comboboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-activedescendant': null,
        'aria-autocomplete': null,
        'aria-errormessage': null,
        'aria-invalid': null,
        'aria-readonly': null,
        'aria-required': null,
        'aria-expanded': 'false',
        'aria-haspopup': 'listbox'
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'email'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'search'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'tel'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'text'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'url'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'url'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'multiple'
                    },
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'size'
                    }
                ],
                constraints: [
                    'the multiple attribute is not set and the size attribute does not have a value greater than 1'
                ],
                name: 'select'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'select'
            },
            module: 'XForms'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-controls': null,
        'aria-expanded': 'false'
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input'
        ]
    ]
};
var $9c1c97d6b961a5c6$var$_default = $9c1c97d6b961a5c6$var$comboboxRole;
module.exports.default = $9c1c97d6b961a5c6$var$_default;

});

parcelRegister("6eH81", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $48a58144abba1aea$var$complementaryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'aside'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'aria-label'
                    }
                ],
                constraints: [
                    'scoped to a sectioning content element',
                    'scoped to a sectioning root element other than body'
                ],
                name: 'aside'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'aria-labelledby'
                    }
                ],
                constraints: [
                    'scoped to a sectioning content element',
                    'scoped to a sectioning root element other than body'
                ],
                name: 'aside'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $48a58144abba1aea$var$_default = $48a58144abba1aea$var$complementaryRole;
module.exports.default = $48a58144abba1aea$var$_default;

});

parcelRegister("c6Jqa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8d09473bc2d69856$var$contentinfoRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    'scoped to the body element'
                ],
                name: 'footer'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $8d09473bc2d69856$var$_default = $8d09473bc2d69856$var$contentinfoRole;
module.exports.default = $8d09473bc2d69856$var$_default;

});

parcelRegister("2mH7e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1b8f14b64395b5d5$var$definitionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'dd'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $1b8f14b64395b5d5$var$_default = $1b8f14b64395b5d5$var$definitionRole;
module.exports.default = $1b8f14b64395b5d5$var$_default;

});

parcelRegister("lgkqH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f7aaf07a638a1426$var$deletionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'del'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $f7aaf07a638a1426$var$_default = $f7aaf07a638a1426$var$deletionRole;
module.exports.default = $f7aaf07a638a1426$var$_default;

});

parcelRegister("8jtUM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $60d74d8f01cb50e7$var$dialogRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'dialog'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'window'
        ]
    ]
};
var $60d74d8f01cb50e7$var$_default = $60d74d8f01cb50e7$var$dialogRole;
module.exports.default = $60d74d8f01cb50e7$var$_default;

});

parcelRegister("7IiiI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $59dad6a54c03d195$var$directoryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            module: 'DAISY Guide'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'list'
        ]
    ]
};
var $59dad6a54c03d195$var$_default = $59dad6a54c03d195$var$directoryRole;
module.exports.default = $59dad6a54c03d195$var$_default;

});

parcelRegister("kSt7F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f32f70ee9c210ad0$var$documentRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'Device Independence Delivery Unit'
            }
        },
        {
            concept: {
                name: 'html'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $f32f70ee9c210ad0$var$_default = $f32f70ee9c210ad0$var$documentRole;
module.exports.default = $f32f70ee9c210ad0$var$_default;

});

parcelRegister("c3lCj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8c66888ab2a6d767$var$emphasisRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'em'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $8c66888ab2a6d767$var$_default = $8c66888ab2a6d767$var$emphasisRole;
module.exports.default = $8c66888ab2a6d767$var$_default;

});

parcelRegister("eKc8n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $abbec6293bbe6fe2$var$feedRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'article'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'list'
        ]
    ]
};
var $abbec6293bbe6fe2$var$_default = $abbec6293bbe6fe2$var$feedRole;
module.exports.default = $abbec6293bbe6fe2$var$_default;

});

parcelRegister("lPkgd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fe3e13b6b9abb7e4$var$figureRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'figure'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $fe3e13b6b9abb7e4$var$_default = $fe3e13b6b9abb7e4$var$figureRole;
module.exports.default = $fe3e13b6b9abb7e4$var$_default;

});

parcelRegister("8wQwF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $635a0e73dbc90619$var$formRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'aria-label'
                    }
                ],
                name: 'form'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'aria-labelledby'
                    }
                ],
                name: 'form'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'name'
                    }
                ],
                name: 'form'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $635a0e73dbc90619$var$_default = $635a0e73dbc90619$var$formRole;
module.exports.default = $635a0e73dbc90619$var$_default;

});

parcelRegister("2CZHG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1e9efe68a785ceb4$var$genericRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'a'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'area'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'aside'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'b'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'bdo'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'body'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'data'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'div'
            },
            module: 'HTML'
        },
        {
            concept: {
                constraints: [
                    'scoped to the main element',
                    'scoped to a sectioning content element',
                    'scoped to a sectioning root element other than body'
                ],
                name: 'footer'
            },
            module: 'HTML'
        },
        {
            concept: {
                constraints: [
                    'scoped to the main element',
                    'scoped to a sectioning content element',
                    'scoped to a sectioning root element other than body'
                ],
                name: 'header'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'hgroup'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'i'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'pre'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'q'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'samp'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'section'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'small'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'span'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'u'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $1e9efe68a785ceb4$var$_default = $1e9efe68a785ceb4$var$genericRole;
module.exports.default = $1e9efe68a785ceb4$var$_default;

});

parcelRegister("7jAa8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $55365bdda43ae6ce$var$gridRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-multiselectable': null,
        'aria-readonly': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'row'
        ],
        [
            'row',
            'rowgroup'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite'
        ],
        [
            'roletype',
            'structure',
            'section',
            'table'
        ]
    ]
};
var $55365bdda43ae6ce$var$_default = $55365bdda43ae6ce$var$gridRole;
module.exports.default = $55365bdda43ae6ce$var$_default;

});

parcelRegister("lQeaG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $fe697267ed98bd17$var$gridcellRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null,
        'aria-readonly': null,
        'aria-required': null,
        'aria-selected': null
    },
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    'ancestor table element has grid role',
                    'ancestor table element has treegrid role'
                ],
                name: 'td'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [
        'row'
    ],
    requiredContextRole: [
        'row'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'cell'
        ],
        [
            'roletype',
            'widget'
        ]
    ]
};
var $fe697267ed98bd17$var$_default = $fe697267ed98bd17$var$gridcellRole;
module.exports.default = $fe697267ed98bd17$var$_default;

});

parcelRegister("8awx5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5f287e37e65cb009$var$groupRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-activedescendant': null,
        'aria-disabled': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'details'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'fieldset'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'optgroup'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'address'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $5f287e37e65cb009$var$_default = $5f287e37e65cb009$var$groupRole;
module.exports.default = $5f287e37e65cb009$var$_default;

});

parcelRegister("fpRQK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b392f63e8eaae70e$var$headingRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-level': '2'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'h1'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'h2'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'h3'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'h4'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'h5'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'h6'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-level': '2'
    },
    superClass: [
        [
            'roletype',
            'structure',
            'sectionhead'
        ]
    ]
};
var $b392f63e8eaae70e$var$_default = $b392f63e8eaae70e$var$headingRole;
module.exports.default = $b392f63e8eaae70e$var$_default;

});

parcelRegister("jpbth", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e209400fe19649bc$var$imgRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'alt'
                    }
                ],
                name: 'img'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'alt'
                    }
                ],
                name: 'img'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'imggroup'
            },
            module: 'DTB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $e209400fe19649bc$var$_default = $e209400fe19649bc$var$imgRole;
module.exports.default = $e209400fe19649bc$var$_default;

});

parcelRegister("gNzly", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $c3aca40b6c94c220$var$insertionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'ins'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $c3aca40b6c94c220$var$_default = $c3aca40b6c94c220$var$insertionRole;
module.exports.default = $c3aca40b6c94c220$var$_default;

});

parcelRegister("7MREU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5ab6a39d80e1a95f$var$linkRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-expanded': null,
        'aria-haspopup': null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'href'
                    }
                ],
                name: 'a'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'href'
                    }
                ],
                name: 'area'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'command'
        ]
    ]
};
var $5ab6a39d80e1a95f$var$_default = $5ab6a39d80e1a95f$var$linkRole;
module.exports.default = $5ab6a39d80e1a95f$var$_default;

});

parcelRegister("b9gwW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $81dd5b88e5271e43$var$listRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'menu'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'ol'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'ul'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'listitem'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $81dd5b88e5271e43$var$_default = $81dd5b88e5271e43$var$listRole;
module.exports.default = $81dd5b88e5271e43$var$_default;

});

parcelRegister("eTkEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ad7639bcef903e52$var$listboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-invalid': null,
        'aria-multiselectable': null,
        'aria-readonly': null,
        'aria-required': null,
        'aria-orientation': 'vertical'
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            '>1'
                        ],
                        name: 'size'
                    }
                ],
                constraints: [
                    'the size attribute value is greater than 1'
                ],
                name: 'select'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        name: 'multiple'
                    }
                ],
                name: 'select'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'datalist'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'list'
            },
            module: 'ARIA'
        },
        {
            concept: {
                name: 'select'
            },
            module: 'XForms'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'option',
            'group'
        ],
        [
            'option'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite',
            'select'
        ],
        [
            'roletype',
            'structure',
            'section',
            'group',
            'select'
        ]
    ]
};
var $ad7639bcef903e52$var$_default = $ad7639bcef903e52$var$listboxRole;
module.exports.default = $ad7639bcef903e52$var$_default;

});

parcelRegister("fXez5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b9d7a9fa48133377$var$listitemRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-level': null,
        'aria-posinset': null,
        'aria-setsize': null
    },
    relatedConcepts: [
        {
            concept: {
                constraints: [
                    'direct descendant of ol',
                    'direct descendant of ul',
                    'direct descendant of menu'
                ],
                name: 'li'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'item'
            },
            module: 'XForms'
        }
    ],
    requireContextRole: [
        'directory',
        'list'
    ],
    requiredContextRole: [
        'directory',
        'list'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $b9d7a9fa48133377$var$_default = $b9d7a9fa48133377$var$listitemRole;
module.exports.default = $b9d7a9fa48133377$var$_default;

});

parcelRegister("emGf9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a753e36910bf7d53$var$logRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-live': 'polite'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $a753e36910bf7d53$var$_default = $a753e36910bf7d53$var$logRole;
module.exports.default = $a753e36910bf7d53$var$_default;

});

parcelRegister("e8Gcv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a4b28c35826d9f49$var$mainRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'main'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $a4b28c35826d9f49$var$_default = $a4b28c35826d9f49$var$mainRole;
module.exports.default = $a4b28c35826d9f49$var$_default;

});

parcelRegister("eOLaQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ac9a53f789ff6b77$var$markRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [],
    props: {
        'aria-braillelabel': null,
        'aria-brailleroledescription': null,
        'aria-description': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'mark'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $ac9a53f789ff6b77$var$_default = $ac9a53f789ff6b77$var$markRole;
module.exports.default = $ac9a53f789ff6b77$var$_default;

});

parcelRegister("iFpM7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $d9700cbe4e3e0203$var$marqueeRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $d9700cbe4e3e0203$var$_default = $d9700cbe4e3e0203$var$marqueeRole;
module.exports.default = $d9700cbe4e3e0203$var$_default;

});

parcelRegister("cPRhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9583946d4a3bdd0f$var$mathRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'math'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $9583946d4a3bdd0f$var$_default = $9583946d4a3bdd0f$var$mathRole;
module.exports.default = $9583946d4a3bdd0f$var$_default;

});

parcelRegister("ehW2P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a66fadaf35f24ce7$var$menuRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-orientation': 'vertical'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'MENU'
            },
            module: 'JAPI'
        },
        {
            concept: {
                name: 'list'
            },
            module: 'ARIA'
        },
        {
            concept: {
                name: 'select'
            },
            module: 'XForms'
        },
        {
            concept: {
                name: 'sidebar'
            },
            module: 'DTB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'menuitem',
            'group'
        ],
        [
            'menuitemradio',
            'group'
        ],
        [
            'menuitemcheckbox',
            'group'
        ],
        [
            'menuitem'
        ],
        [
            'menuitemcheckbox'
        ],
        [
            'menuitemradio'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite',
            'select'
        ],
        [
            'roletype',
            'structure',
            'section',
            'group',
            'select'
        ]
    ]
};
var $a66fadaf35f24ce7$var$_default = $a66fadaf35f24ce7$var$menuRole;
module.exports.default = $a66fadaf35f24ce7$var$_default;

});

parcelRegister("cuLbi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $918ce294d3f5ccf5$var$menubarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-orientation': 'horizontal'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'toolbar'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'menuitem',
            'group'
        ],
        [
            'menuitemradio',
            'group'
        ],
        [
            'menuitemcheckbox',
            'group'
        ],
        [
            'menuitem'
        ],
        [
            'menuitemcheckbox'
        ],
        [
            'menuitemradio'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite',
            'select',
            'menu'
        ],
        [
            'roletype',
            'structure',
            'section',
            'group',
            'select',
            'menu'
        ]
    ]
};
var $918ce294d3f5ccf5$var$_default = $918ce294d3f5ccf5$var$menubarRole;
module.exports.default = $918ce294d3f5ccf5$var$_default;

});

parcelRegister("gYkEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $c5b245e03858a64c$var$menuitemRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-posinset': null,
        'aria-setsize': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'MENU_ITEM'
            },
            module: 'JAPI'
        },
        {
            concept: {
                name: 'listitem'
            },
            module: 'ARIA'
        },
        {
            concept: {
                name: 'option'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [
        'group',
        'menu',
        'menubar'
    ],
    requiredContextRole: [
        'group',
        'menu',
        'menubar'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'command'
        ]
    ]
};
var $c5b245e03858a64c$var$_default = $c5b245e03858a64c$var$menuitemRole;
module.exports.default = $c5b245e03858a64c$var$_default;

});

parcelRegister("fhBYi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b205e5ebc9898713$var$menuitemcheckboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'menuitem'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [
        'group',
        'menu',
        'menubar'
    ],
    requiredContextRole: [
        'group',
        'menu',
        'menubar'
    ],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-checked': null
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input',
            'checkbox'
        ],
        [
            'roletype',
            'widget',
            'command',
            'menuitem'
        ]
    ]
};
var $b205e5ebc9898713$var$_default = $b205e5ebc9898713$var$menuitemcheckboxRole;
module.exports.default = $b205e5ebc9898713$var$_default;

});

parcelRegister("3jQG6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $26ac02393cc3187b$var$menuitemradioRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'menuitem'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [
        'group',
        'menu',
        'menubar'
    ],
    requiredContextRole: [
        'group',
        'menu',
        'menubar'
    ],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-checked': null
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input',
            'checkbox',
            'menuitemcheckbox'
        ],
        [
            'roletype',
            'widget',
            'command',
            'menuitem',
            'menuitemcheckbox'
        ],
        [
            'roletype',
            'widget',
            'input',
            'radio'
        ]
    ]
};
var $26ac02393cc3187b$var$_default = $26ac02393cc3187b$var$menuitemradioRole;
module.exports.default = $26ac02393cc3187b$var$_default;

});

parcelRegister("76Df2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $52c78880718fdbd3$var$meterRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-valuetext': null,
        'aria-valuemax': '100',
        'aria-valuemin': '0'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'meter'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-valuenow': null
    },
    superClass: [
        [
            'roletype',
            'structure',
            'range'
        ]
    ]
};
var $52c78880718fdbd3$var$_default = $52c78880718fdbd3$var$meterRole;
module.exports.default = $52c78880718fdbd3$var$_default;

});

parcelRegister("laURr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f6a6a3921cf47970$var$navigationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'nav'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $f6a6a3921cf47970$var$_default = $f6a6a3921cf47970$var$navigationRole;
module.exports.default = $f6a6a3921cf47970$var$_default;

});

parcelRegister("94kp3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $69a4506d7d123651$var$noneRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: []
};
var $69a4506d7d123651$var$_default = $69a4506d7d123651$var$noneRole;
module.exports.default = $69a4506d7d123651$var$_default;

});

parcelRegister("3cu4N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2549d29f16a78bbe$var$noteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $2549d29f16a78bbe$var$_default = $2549d29f16a78bbe$var$noteRole;
module.exports.default = $2549d29f16a78bbe$var$_default;

});

parcelRegister("L0mdV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $08d4aae1c46b8de8$var$optionRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-checked': null,
        'aria-posinset': null,
        'aria-setsize': null,
        'aria-selected': 'false'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'item'
            },
            module: 'XForms'
        },
        {
            concept: {
                name: 'listitem'
            },
            module: 'ARIA'
        },
        {
            concept: {
                name: 'option'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-selected': 'false'
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input'
        ]
    ]
};
var $08d4aae1c46b8de8$var$_default = $08d4aae1c46b8de8$var$optionRole;
module.exports.default = $08d4aae1c46b8de8$var$_default;

});

parcelRegister("hGNkD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ce0ca02bc676192e$var$paragraphRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'p'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $ce0ca02bc676192e$var$_default = $ce0ca02bc676192e$var$paragraphRole;
module.exports.default = $ce0ca02bc676192e$var$_default;

});

parcelRegister("3XLqg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2e2baae73c78e24f$var$presentationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: 'alt',
                        value: ''
                    }
                ],
                name: 'img'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $2e2baae73c78e24f$var$_default = $2e2baae73c78e24f$var$presentationRole;
module.exports.default = $2e2baae73c78e24f$var$_default;

});

parcelRegister("hHxis", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ce3047df1cb60879$var$progressbarRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-valuetext': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'progress'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'status'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'range'
        ],
        [
            'roletype',
            'widget'
        ]
    ]
};
var $ce3047df1cb60879$var$_default = $ce3047df1cb60879$var$progressbarRole;
module.exports.default = $ce3047df1cb60879$var$_default;

});

parcelRegister("fdDma", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b146994a636a329d$var$radioRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-checked': null,
        'aria-posinset': null,
        'aria-setsize': null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'radio'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-checked': null
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input'
        ]
    ]
};
var $b146994a636a329d$var$_default = $b146994a636a329d$var$radioRole;
module.exports.default = $b146994a636a329d$var$_default;

});

parcelRegister("ko90M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ed7d0a0eb6faacb9$var$radiogroupRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-invalid': null,
        'aria-readonly': null,
        'aria-required': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'list'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'radio'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite',
            'select'
        ],
        [
            'roletype',
            'structure',
            'section',
            'group',
            'select'
        ]
    ]
};
var $ed7d0a0eb6faacb9$var$_default = $ed7d0a0eb6faacb9$var$radiogroupRole;
module.exports.default = $ed7d0a0eb6faacb9$var$_default;

});

parcelRegister("5wpw5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4053bbfc224441bd$var$regionRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'aria-label'
                    }
                ],
                name: 'section'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'set'
                        ],
                        name: 'aria-labelledby'
                    }
                ],
                name: 'section'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'Device Independence Glossart perceivable unit'
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $4053bbfc224441bd$var$_default = $4053bbfc224441bd$var$regionRole;
module.exports.default = $4053bbfc224441bd$var$_default;

});

parcelRegister("e5YqT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a43068ff56e537dd$var$rowRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-colindex': null,
        'aria-expanded': null,
        'aria-level': null,
        'aria-posinset': null,
        'aria-rowindex': null,
        'aria-selected': null,
        'aria-setsize': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'tr'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [
        'grid',
        'rowgroup',
        'table',
        'treegrid'
    ],
    requiredContextRole: [
        'grid',
        'rowgroup',
        'table',
        'treegrid'
    ],
    requiredOwnedElements: [
        [
            'cell'
        ],
        [
            'columnheader'
        ],
        [
            'gridcell'
        ],
        [
            'rowheader'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'group'
        ],
        [
            'roletype',
            'widget'
        ]
    ]
};
var $a43068ff56e537dd$var$_default = $a43068ff56e537dd$var$rowRole;
module.exports.default = $a43068ff56e537dd$var$_default;

});

parcelRegister("kOY74", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f2871b60b6078c0d$var$rowgroupRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'tbody'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'tfoot'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'thead'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [
        'grid',
        'table',
        'treegrid'
    ],
    requiredContextRole: [
        'grid',
        'table',
        'treegrid'
    ],
    requiredOwnedElements: [
        [
            'row'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $f2871b60b6078c0d$var$_default = $f2871b60b6078c0d$var$rowgroupRole;
module.exports.default = $f2871b60b6078c0d$var$_default;

});

parcelRegister("5i2Av", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3da0a410953fb8cf$var$rowheaderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-sort': null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: 'scope',
                        value: 'row'
                    }
                ],
                name: 'th'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        name: 'scope',
                        value: 'rowgroup'
                    }
                ],
                name: 'th'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [
        'row',
        'rowgroup'
    ],
    requiredContextRole: [
        'row',
        'rowgroup'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'cell'
        ],
        [
            'roletype',
            'structure',
            'section',
            'cell',
            'gridcell'
        ],
        [
            'roletype',
            'widget',
            'gridcell'
        ],
        [
            'roletype',
            'structure',
            'sectionhead'
        ]
    ]
};
var $3da0a410953fb8cf$var$_default = $3da0a410953fb8cf$var$rowheaderRole;
module.exports.default = $3da0a410953fb8cf$var$_default;

});

parcelRegister("37hbn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $244f5aa2d4243a34$var$scrollbarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-valuetext': null,
        'aria-orientation': 'vertical',
        'aria-valuemax': '100',
        'aria-valuemin': '0'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-controls': null,
        'aria-valuenow': null
    },
    superClass: [
        [
            'roletype',
            'structure',
            'range'
        ],
        [
            'roletype',
            'widget'
        ]
    ]
};
var $244f5aa2d4243a34$var$_default = $244f5aa2d4243a34$var$scrollbarRole;
module.exports.default = $244f5aa2d4243a34$var$_default;

});

parcelRegister("ajmxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $781d2951ddc5b0fb$var$searchRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $781d2951ddc5b0fb$var$_default = $781d2951ddc5b0fb$var$searchRole;
module.exports.default = $781d2951ddc5b0fb$var$_default;

});

parcelRegister("fNHdZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b80cf61d62d6bd2a$var$searchboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'search'
                    }
                ],
                constraints: [
                    'the list attribute is not set'
                ],
                name: 'input'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'input',
            'textbox'
        ]
    ]
};
var $b80cf61d62d6bd2a$var$_default = $b80cf61d62d6bd2a$var$searchboxRole;
module.exports.default = $b80cf61d62d6bd2a$var$_default;

});

parcelRegister("84fQO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5dfafe17d7150c09$var$separatorRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-orientation': 'horizontal',
        'aria-valuemax': '100',
        'aria-valuemin': '0',
        'aria-valuenow': null,
        'aria-valuetext': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'hr'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure'
        ]
    ]
};
var $5dfafe17d7150c09$var$_default = $5dfafe17d7150c09$var$separatorRole;
module.exports.default = $5dfafe17d7150c09$var$_default;

});

parcelRegister("8M5Ra", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $66375964b612e524$var$sliderRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-haspopup': null,
        'aria-invalid': null,
        'aria-readonly': null,
        'aria-valuetext': null,
        'aria-orientation': 'horizontal',
        'aria-valuemax': '100',
        'aria-valuemin': '0'
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'range'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-valuenow': null
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input'
        ],
        [
            'roletype',
            'structure',
            'range'
        ]
    ]
};
var $66375964b612e524$var$_default = $66375964b612e524$var$sliderRole;
module.exports.default = $66375964b612e524$var$_default;

});

parcelRegister("80EsX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5d4db684d145d2c6$var$spinbuttonRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-invalid': null,
        'aria-readonly': null,
        'aria-required': null,
        'aria-valuetext': null,
        'aria-valuenow': '0'
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        name: 'type',
                        value: 'number'
                    }
                ],
                name: 'input'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite'
        ],
        [
            'roletype',
            'widget',
            'input'
        ],
        [
            'roletype',
            'structure',
            'range'
        ]
    ]
};
var $5d4db684d145d2c6$var$_default = $5d4db684d145d2c6$var$spinbuttonRole;
module.exports.default = $5d4db684d145d2c6$var$_default;

});

parcelRegister("8QUem", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $671ecc43cb1dea6e$var$statusRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-atomic': 'true',
        'aria-live': 'polite'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'output'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $671ecc43cb1dea6e$var$_default = $671ecc43cb1dea6e$var$statusRole;
module.exports.default = $671ecc43cb1dea6e$var$_default;

});

parcelRegister("kGvDu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f0f04520f5ee1643$var$strongRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'strong'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $f0f04520f5ee1643$var$_default = $f0f04520f5ee1643$var$strongRole;
module.exports.default = $f0f04520f5ee1643$var$_default;

});

parcelRegister("4igW8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3205fb1d88f637be$var$subscriptRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'sub'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $3205fb1d88f637be$var$_default = $3205fb1d88f637be$var$subscriptRole;
module.exports.default = $3205fb1d88f637be$var$_default;

});

parcelRegister("hD5cA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $cd5a1d2daa9bf31b$var$superscriptRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'prohibited'
    ],
    prohibitedProps: [
        'aria-label',
        'aria-labelledby'
    ],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'sup'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $cd5a1d2daa9bf31b$var$_default = $cd5a1d2daa9bf31b$var$superscriptRole;
module.exports.default = $cd5a1d2daa9bf31b$var$_default;

});

parcelRegister("K8eRP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $08aab00b9c1cb185$var$switchRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'button'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-checked': null
    },
    superClass: [
        [
            'roletype',
            'widget',
            'input',
            'checkbox'
        ]
    ]
};
var $08aab00b9c1cb185$var$_default = $08aab00b9c1cb185$var$switchRole;
module.exports.default = $08aab00b9c1cb185$var$_default;

});

parcelRegister("egDPt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a6317490cc939299$var$tabRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-posinset': null,
        'aria-setsize': null,
        'aria-selected': 'false'
    },
    relatedConcepts: [],
    requireContextRole: [
        'tablist'
    ],
    requiredContextRole: [
        'tablist'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'sectionhead'
        ],
        [
            'roletype',
            'widget'
        ]
    ]
};
var $a6317490cc939299$var$_default = $a6317490cc939299$var$tabRole;
module.exports.default = $a6317490cc939299$var$_default;

});

parcelRegister("45SyE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2fb1f31d82587ab5$var$tableRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-colcount': null,
        'aria-rowcount': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'table'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'row'
        ],
        [
            'row',
            'rowgroup'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $2fb1f31d82587ab5$var$_default = $2fb1f31d82587ab5$var$tableRole;
module.exports.default = $2fb1f31d82587ab5$var$_default;

});

parcelRegister("6mBNF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4a221e76d41822a1$var$tablistRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-level': null,
        'aria-multiselectable': null,
        'aria-orientation': 'horizontal'
    },
    relatedConcepts: [
        {
            module: 'DAISY',
            concept: {
                name: 'guide'
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'tab'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite'
        ]
    ]
};
var $4a221e76d41822a1$var$_default = $4a221e76d41822a1$var$tablistRole;
module.exports.default = $4a221e76d41822a1$var$_default;

});

parcelRegister("eFqDE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $aad98ee3b6d96492$var$tabpanelRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $aad98ee3b6d96492$var$_default = $aad98ee3b6d96492$var$tabpanelRole;
module.exports.default = $aad98ee3b6d96492$var$_default;

});

parcelRegister("4zLm3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $354f29f9acfb1ea0$var$termRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'dfn'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'dt'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $354f29f9acfb1ea0$var$_default = $354f29f9acfb1ea0$var$termRole;
module.exports.default = $354f29f9acfb1ea0$var$_default;

});

parcelRegister("lUIDs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ff41739d21c29d34$var$textboxRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-activedescendant': null,
        'aria-autocomplete': null,
        'aria-errormessage': null,
        'aria-haspopup': null,
        'aria-invalid': null,
        'aria-multiline': null,
        'aria-placeholder': null,
        'aria-readonly': null,
        'aria-required': null
    },
    relatedConcepts: [
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'type'
                    },
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'list'
                    }
                ],
                constraints: [
                    'the list attribute is not set'
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'email'
                    }
                ],
                constraints: [
                    'the list attribute is not set'
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'tel'
                    }
                ],
                constraints: [
                    'the list attribute is not set'
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'text'
                    }
                ],
                constraints: [
                    'the list attribute is not set'
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                attributes: [
                    {
                        constraints: [
                            'undefined'
                        ],
                        name: 'list'
                    },
                    {
                        name: 'type',
                        value: 'url'
                    }
                ],
                constraints: [
                    'the list attribute is not set'
                ],
                name: 'input'
            },
            module: 'HTML'
        },
        {
            concept: {
                name: 'input'
            },
            module: 'XForms'
        },
        {
            concept: {
                name: 'textarea'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'input'
        ]
    ]
};
var $ff41739d21c29d34$var$_default = $ff41739d21c29d34$var$textboxRole;
module.exports.default = $ff41739d21c29d34$var$_default;

});

parcelRegister("4TtEp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $39034c7dd940d6b0$var$timeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'time'
            },
            module: 'HTML'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $39034c7dd940d6b0$var$_default = $39034c7dd940d6b0$var$timeRole;
module.exports.default = $39034c7dd940d6b0$var$_default;

});

parcelRegister("gwcE6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $c06971b584026d9a$var$timerRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'status'
        ]
    ]
};
var $c06971b584026d9a$var$_default = $c06971b584026d9a$var$timerRole;
module.exports.default = $c06971b584026d9a$var$_default;

});

parcelRegister("f48Ke", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $02d49cf4b0875e70$var$toolbarRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-orientation': 'horizontal'
    },
    relatedConcepts: [
        {
            concept: {
                name: 'menubar'
            },
            module: 'ARIA'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'group'
        ]
    ]
};
var $02d49cf4b0875e70$var$_default = $02d49cf4b0875e70$var$toolbarRole;
module.exports.default = $02d49cf4b0875e70$var$_default;

});

parcelRegister("dUmQi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $a202395871a0cdc5$var$tooltipRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $a202395871a0cdc5$var$_default = $a202395871a0cdc5$var$tooltipRole;
module.exports.default = $a202395871a0cdc5$var$_default;

});

parcelRegister("5wsTu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $40565aa2e0f7cd50$var$treeRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-invalid': null,
        'aria-multiselectable': null,
        'aria-required': null,
        'aria-orientation': 'vertical'
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'treeitem',
            'group'
        ],
        [
            'treeitem'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite',
            'select'
        ],
        [
            'roletype',
            'structure',
            'section',
            'group',
            'select'
        ]
    ]
};
var $40565aa2e0f7cd50$var$_default = $40565aa2e0f7cd50$var$treeRole;
module.exports.default = $40565aa2e0f7cd50$var$_default;

});

parcelRegister("8ecB0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5fd966cafa5d3140$var$treegridRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'row'
        ],
        [
            'row',
            'rowgroup'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'composite',
            'grid'
        ],
        [
            'roletype',
            'structure',
            'section',
            'table',
            'grid'
        ],
        [
            'roletype',
            'widget',
            'composite',
            'select',
            'tree'
        ],
        [
            'roletype',
            'structure',
            'section',
            'group',
            'select',
            'tree'
        ]
    ]
};
var $5fd966cafa5d3140$var$_default = $5fd966cafa5d3140$var$treegridRole;
module.exports.default = $5fd966cafa5d3140$var$_default;

});

parcelRegister("8JaM1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $65aae21dd06c5547$var$treeitemRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-expanded': null,
        'aria-haspopup': null
    },
    relatedConcepts: [],
    requireContextRole: [
        'group',
        'tree'
    ],
    requiredContextRole: [
        'group',
        'tree'
    ],
    requiredOwnedElements: [],
    requiredProps: {
        'aria-selected': null
    },
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'listitem'
        ],
        [
            'roletype',
            'widget',
            'input',
            'option'
        ]
    ]
};
var $65aae21dd06c5547$var$_default = $65aae21dd06c5547$var$treeitemRole;
module.exports.default = $65aae21dd06c5547$var$_default;

});


parcelRegister("kAKup", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efdb3b48414b2b13$var$_docAbstractRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("b05cs")));

var $efdb3b48414b2b13$var$_docAcknowledgmentsRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("51LcQ")));

var $efdb3b48414b2b13$var$_docAfterwordRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("4C79M")));

var $efdb3b48414b2b13$var$_docAppendixRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("cKXCd")));

var $efdb3b48414b2b13$var$_docBacklinkRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("kDceA")));

var $efdb3b48414b2b13$var$_docBiblioentryRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("aLVuO")));

var $efdb3b48414b2b13$var$_docBibliographyRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("eLCDY")));

var $efdb3b48414b2b13$var$_docBibliorefRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("MdXWl")));

var $efdb3b48414b2b13$var$_docChapterRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("cngwe")));

var $efdb3b48414b2b13$var$_docColophonRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("d1FdT")));

var $efdb3b48414b2b13$var$_docConclusionRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("cnhnE")));

var $efdb3b48414b2b13$var$_docCoverRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("jMufT")));

var $efdb3b48414b2b13$var$_docCreditRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("4M6fS")));

var $efdb3b48414b2b13$var$_docCreditsRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("1A447")));

var $efdb3b48414b2b13$var$_docDedicationRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("3TT0n")));

var $efdb3b48414b2b13$var$_docEndnoteRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("2C4sV")));

var $efdb3b48414b2b13$var$_docEndnotesRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("eJ6YG")));

var $efdb3b48414b2b13$var$_docEpigraphRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("gyupa")));

var $efdb3b48414b2b13$var$_docEpilogueRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("7PlAh")));

var $efdb3b48414b2b13$var$_docErrataRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("8b4lX")));

var $efdb3b48414b2b13$var$_docExampleRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("bcotj")));

var $efdb3b48414b2b13$var$_docFootnoteRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("bYnx4")));

var $efdb3b48414b2b13$var$_docForewordRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("fH5Su")));

var $efdb3b48414b2b13$var$_docGlossaryRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("2AvnT")));

var $efdb3b48414b2b13$var$_docGlossrefRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("aDcP2")));

var $efdb3b48414b2b13$var$_docIndexRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("j4kPr")));

var $efdb3b48414b2b13$var$_docIntroductionRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("bs5SF")));

var $efdb3b48414b2b13$var$_docNoterefRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("5GZoS")));

var $efdb3b48414b2b13$var$_docNoticeRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("8HMY8")));

var $efdb3b48414b2b13$var$_docPagebreakRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("4ESCe")));

var $efdb3b48414b2b13$var$_docPagelistRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("6symH")));

var $efdb3b48414b2b13$var$_docPartRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("8WjFl")));

var $efdb3b48414b2b13$var$_docPrefaceRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("7D2Hg")));

var $efdb3b48414b2b13$var$_docPrologueRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("jWkNh")));

var $efdb3b48414b2b13$var$_docPullquoteRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("kLUj2")));

var $efdb3b48414b2b13$var$_docQnaRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("ixT4n")));

var $efdb3b48414b2b13$var$_docSubtitleRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("6oNyA")));

var $efdb3b48414b2b13$var$_docTipRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("gb40F")));

var $efdb3b48414b2b13$var$_docTocRole = $efdb3b48414b2b13$var$_interopRequireDefault((parcelRequire("aTPjt")));
function $efdb3b48414b2b13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $efdb3b48414b2b13$var$ariaDpubRoles = [
    [
        'doc-abstract',
        $efdb3b48414b2b13$var$_docAbstractRole.default
    ],
    [
        'doc-acknowledgments',
        $efdb3b48414b2b13$var$_docAcknowledgmentsRole.default
    ],
    [
        'doc-afterword',
        $efdb3b48414b2b13$var$_docAfterwordRole.default
    ],
    [
        'doc-appendix',
        $efdb3b48414b2b13$var$_docAppendixRole.default
    ],
    [
        'doc-backlink',
        $efdb3b48414b2b13$var$_docBacklinkRole.default
    ],
    [
        'doc-biblioentry',
        $efdb3b48414b2b13$var$_docBiblioentryRole.default
    ],
    [
        'doc-bibliography',
        $efdb3b48414b2b13$var$_docBibliographyRole.default
    ],
    [
        'doc-biblioref',
        $efdb3b48414b2b13$var$_docBibliorefRole.default
    ],
    [
        'doc-chapter',
        $efdb3b48414b2b13$var$_docChapterRole.default
    ],
    [
        'doc-colophon',
        $efdb3b48414b2b13$var$_docColophonRole.default
    ],
    [
        'doc-conclusion',
        $efdb3b48414b2b13$var$_docConclusionRole.default
    ],
    [
        'doc-cover',
        $efdb3b48414b2b13$var$_docCoverRole.default
    ],
    [
        'doc-credit',
        $efdb3b48414b2b13$var$_docCreditRole.default
    ],
    [
        'doc-credits',
        $efdb3b48414b2b13$var$_docCreditsRole.default
    ],
    [
        'doc-dedication',
        $efdb3b48414b2b13$var$_docDedicationRole.default
    ],
    [
        'doc-endnote',
        $efdb3b48414b2b13$var$_docEndnoteRole.default
    ],
    [
        'doc-endnotes',
        $efdb3b48414b2b13$var$_docEndnotesRole.default
    ],
    [
        'doc-epigraph',
        $efdb3b48414b2b13$var$_docEpigraphRole.default
    ],
    [
        'doc-epilogue',
        $efdb3b48414b2b13$var$_docEpilogueRole.default
    ],
    [
        'doc-errata',
        $efdb3b48414b2b13$var$_docErrataRole.default
    ],
    [
        'doc-example',
        $efdb3b48414b2b13$var$_docExampleRole.default
    ],
    [
        'doc-footnote',
        $efdb3b48414b2b13$var$_docFootnoteRole.default
    ],
    [
        'doc-foreword',
        $efdb3b48414b2b13$var$_docForewordRole.default
    ],
    [
        'doc-glossary',
        $efdb3b48414b2b13$var$_docGlossaryRole.default
    ],
    [
        'doc-glossref',
        $efdb3b48414b2b13$var$_docGlossrefRole.default
    ],
    [
        'doc-index',
        $efdb3b48414b2b13$var$_docIndexRole.default
    ],
    [
        'doc-introduction',
        $efdb3b48414b2b13$var$_docIntroductionRole.default
    ],
    [
        'doc-noteref',
        $efdb3b48414b2b13$var$_docNoterefRole.default
    ],
    [
        'doc-notice',
        $efdb3b48414b2b13$var$_docNoticeRole.default
    ],
    [
        'doc-pagebreak',
        $efdb3b48414b2b13$var$_docPagebreakRole.default
    ],
    [
        'doc-pagelist',
        $efdb3b48414b2b13$var$_docPagelistRole.default
    ],
    [
        'doc-part',
        $efdb3b48414b2b13$var$_docPartRole.default
    ],
    [
        'doc-preface',
        $efdb3b48414b2b13$var$_docPrefaceRole.default
    ],
    [
        'doc-prologue',
        $efdb3b48414b2b13$var$_docPrologueRole.default
    ],
    [
        'doc-pullquote',
        $efdb3b48414b2b13$var$_docPullquoteRole.default
    ],
    [
        'doc-qna',
        $efdb3b48414b2b13$var$_docQnaRole.default
    ],
    [
        'doc-subtitle',
        $efdb3b48414b2b13$var$_docSubtitleRole.default
    ],
    [
        'doc-tip',
        $efdb3b48414b2b13$var$_docTipRole.default
    ],
    [
        'doc-toc',
        $efdb3b48414b2b13$var$_docTocRole.default
    ]
];
var $efdb3b48414b2b13$var$_default = $efdb3b48414b2b13$var$ariaDpubRoles;
module.exports.default = $efdb3b48414b2b13$var$_default;

});
parcelRegister("b05cs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8023ba6222dcc9ed$var$docAbstractRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'abstract [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $8023ba6222dcc9ed$var$_default = $8023ba6222dcc9ed$var$docAbstractRole;
module.exports.default = $8023ba6222dcc9ed$var$_default;

});

parcelRegister("51LcQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $3a91a9ebf1d53567$var$docAcknowledgmentsRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'acknowledgments [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $3a91a9ebf1d53567$var$_default = $3a91a9ebf1d53567$var$docAcknowledgmentsRole;
module.exports.default = $3a91a9ebf1d53567$var$_default;

});

parcelRegister("4C79M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $35c0433532e996ae$var$docAfterwordRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'afterword [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $35c0433532e996ae$var$_default = $35c0433532e996ae$var$docAfterwordRole;
module.exports.default = $35c0433532e996ae$var$_default;

});

parcelRegister("cKXCd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $949806474d7376e0$var$docAppendixRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'appendix [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $949806474d7376e0$var$_default = $949806474d7376e0$var$docAppendixRole;
module.exports.default = $949806474d7376e0$var$_default;

});

parcelRegister("kDceA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f050f0a1a765a15a$var$docBacklinkRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'referrer [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'command',
            'link'
        ]
    ]
};
var $f050f0a1a765a15a$var$_default = $f050f0a1a765a15a$var$docBacklinkRole;
module.exports.default = $f050f0a1a765a15a$var$_default;

});

parcelRegister("aLVuO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7d7ae4adbcb74793$var$docBiblioentryRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'EPUB biblioentry [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [
        'doc-bibliography'
    ],
    requiredContextRole: [
        'doc-bibliography'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'listitem'
        ]
    ]
};
var $7d7ae4adbcb74793$var$_default = $7d7ae4adbcb74793$var$docBiblioentryRole;
module.exports.default = $7d7ae4adbcb74793$var$_default;

});

parcelRegister("eLCDY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ac036e4c474f209a$var$docBibliographyRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'bibliography [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'doc-biblioentry'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $ac036e4c474f209a$var$_default = $ac036e4c474f209a$var$docBibliographyRole;
module.exports.default = $ac036e4c474f209a$var$_default;

});

parcelRegister("MdXWl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $090f511f012d9c34$var$docBibliorefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'biblioref [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'command',
            'link'
        ]
    ]
};
var $090f511f012d9c34$var$_default = $090f511f012d9c34$var$docBibliorefRole;
module.exports.default = $090f511f012d9c34$var$_default;

});

parcelRegister("cngwe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $9024724e5554e134$var$docChapterRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'chapter [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $9024724e5554e134$var$_default = $9024724e5554e134$var$docChapterRole;
module.exports.default = $9024724e5554e134$var$_default;

});

parcelRegister("d1FdT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $97bb5869b5fd6e33$var$docColophonRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'colophon [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $97bb5869b5fd6e33$var$_default = $97bb5869b5fd6e33$var$docColophonRole;
module.exports.default = $97bb5869b5fd6e33$var$_default;

});

parcelRegister("cnhnE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $90251d6d89d127b3$var$docConclusionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'conclusion [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $90251d6d89d127b3$var$_default = $90251d6d89d127b3$var$docConclusionRole;
module.exports.default = $90251d6d89d127b3$var$_default;

});

parcelRegister("jMufT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e669f818e5416d28$var$docCoverRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'cover [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'img'
        ]
    ]
};
var $e669f818e5416d28$var$_default = $e669f818e5416d28$var$docCoverRole;
module.exports.default = $e669f818e5416d28$var$_default;

});

parcelRegister("4M6fS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $37a07f41bf6c03c2$var$docCreditRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'credit [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $37a07f41bf6c03c2$var$_default = $37a07f41bf6c03c2$var$docCreditRole;
module.exports.default = $37a07f41bf6c03c2$var$_default;

});

parcelRegister("1A447", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $126c4e8f26223993$var$docCreditsRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'credits [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $126c4e8f26223993$var$_default = $126c4e8f26223993$var$docCreditsRole;
module.exports.default = $126c4e8f26223993$var$_default;

});

parcelRegister("3TT0n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2d712d01911c4b77$var$docDedicationRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'dedication [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $2d712d01911c4b77$var$_default = $2d712d01911c4b77$var$docDedicationRole;
module.exports.default = $2d712d01911c4b77$var$_default;

});

parcelRegister("2C4sV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1e729828d5837ce2$var$docEndnoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'rearnote [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [
        'doc-endnotes'
    ],
    requiredContextRole: [
        'doc-endnotes'
    ],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'listitem'
        ]
    ]
};
var $1e729828d5837ce2$var$_default = $1e729828d5837ce2$var$docEndnoteRole;
module.exports.default = $1e729828d5837ce2$var$_default;

});

parcelRegister("eJ6YG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ab8aae4d366f2082$var$docEndnotesRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'rearnotes [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'doc-endnote'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $ab8aae4d366f2082$var$_default = $ab8aae4d366f2082$var$docEndnotesRole;
module.exports.default = $ab8aae4d366f2082$var$_default;

});

parcelRegister("gyupa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $c0d7681fafcdbff2$var$docEpigraphRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'epigraph [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $c0d7681fafcdbff2$var$_default = $c0d7681fafcdbff2$var$docEpigraphRole;
module.exports.default = $c0d7681fafcdbff2$var$_default;

});

parcelRegister("7PlAh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5b2e09f8d13615d6$var$docEpilogueRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'epilogue [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $5b2e09f8d13615d6$var$_default = $5b2e09f8d13615d6$var$docEpilogueRole;
module.exports.default = $5b2e09f8d13615d6$var$_default;

});

parcelRegister("8b4lX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5f42ba3c9268cec6$var$docErrataRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'errata [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $5f42ba3c9268cec6$var$_default = $5f42ba3c9268cec6$var$docErrataRole;
module.exports.default = $5f42ba3c9268cec6$var$_default;

});

parcelRegister("bcotj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8273cc48ce278bbb$var$docExampleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $8273cc48ce278bbb$var$_default = $8273cc48ce278bbb$var$docExampleRole;
module.exports.default = $8273cc48ce278bbb$var$_default;

});

parcelRegister("bYnx4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8b778d567d4e9101$var$docFootnoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'footnote [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $8b778d567d4e9101$var$_default = $8b778d567d4e9101$var$docFootnoteRole;
module.exports.default = $8b778d567d4e9101$var$_default;

});

parcelRegister("fH5Su", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $b6cf6e6843b60096$var$docForewordRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'foreword [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $b6cf6e6843b60096$var$_default = $b6cf6e6843b60096$var$docForewordRole;
module.exports.default = $b6cf6e6843b60096$var$_default;

});

parcelRegister("2AvnT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1e2749d2942bfdb9$var$docGlossaryRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'glossary [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [
        [
            'definition'
        ],
        [
            'term'
        ]
    ],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $1e2749d2942bfdb9$var$_default = $1e2749d2942bfdb9$var$docGlossaryRole;
module.exports.default = $1e2749d2942bfdb9$var$_default;

});

parcelRegister("aDcP2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7bd77e205509a27b$var$docGlossrefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'glossref [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'command',
            'link'
        ]
    ]
};
var $7bd77e205509a27b$var$_default = $7bd77e205509a27b$var$docGlossrefRole;
module.exports.default = $7bd77e205509a27b$var$_default;

});

parcelRegister("j4kPr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $de1e8c3423f33d46$var$docIndexRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'index [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark',
            'navigation'
        ]
    ]
};
var $de1e8c3423f33d46$var$_default = $de1e8c3423f33d46$var$docIndexRole;
module.exports.default = $de1e8c3423f33d46$var$_default;

});

parcelRegister("bs5SF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $8566df095e4d9814$var$docIntroductionRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'introduction [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $8566df095e4d9814$var$_default = $8566df095e4d9814$var$docIntroductionRole;
module.exports.default = $8566df095e4d9814$var$_default;

});

parcelRegister("5GZoS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $425080ca5fdb6f7c$var$docNoterefRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'noteref [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'widget',
            'command',
            'link'
        ]
    ]
};
var $425080ca5fdb6f7c$var$_default = $425080ca5fdb6f7c$var$docNoterefRole;
module.exports.default = $425080ca5fdb6f7c$var$_default;

});

parcelRegister("8HMY8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $656853168b4951e7$var$docNoticeRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'notice [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'note'
        ]
    ]
};
var $656853168b4951e7$var$_default = $656853168b4951e7$var$docNoticeRole;
module.exports.default = $656853168b4951e7$var$_default;

});

parcelRegister("4ESCe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $36454361bffcf267$var$docPagebreakRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'pagebreak [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'separator'
        ]
    ]
};
var $36454361bffcf267$var$_default = $36454361bffcf267$var$docPagebreakRole;
module.exports.default = $36454361bffcf267$var$_default;

});

parcelRegister("6symH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4b4003c805b6992c$var$docPagelistRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'page-list [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark',
            'navigation'
        ]
    ]
};
var $4b4003c805b6992c$var$_default = $4b4003c805b6992c$var$docPagelistRole;
module.exports.default = $4b4003c805b6992c$var$_default;

});

parcelRegister("8WjFl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6822feba63603862$var$docPartRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'part [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $6822feba63603862$var$_default = $6822feba63603862$var$docPartRole;
module.exports.default = $6822feba63603862$var$_default;

});

parcelRegister("7D2Hg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $58de44729e814fb4$var$docPrefaceRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'preface [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $58de44729e814fb4$var$_default = $58de44729e814fb4$var$docPrefaceRole;
module.exports.default = $58de44729e814fb4$var$_default;

});

parcelRegister("jWkNh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $e8439058afbc5c07$var$docPrologueRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'prologue [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark'
        ]
    ]
};
var $e8439058afbc5c07$var$_default = $e8439058afbc5c07$var$docPrologueRole;
module.exports.default = $e8439058afbc5c07$var$_default;

});

parcelRegister("kLUj2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f1f3dfab4cc0771e$var$docPullquoteRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {},
    relatedConcepts: [
        {
            concept: {
                name: 'pullquote [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'none'
        ]
    ]
};
var $f1f3dfab4cc0771e$var$_default = $f1f3dfab4cc0771e$var$docPullquoteRole;
module.exports.default = $f1f3dfab4cc0771e$var$_default;

});

parcelRegister("ixT4n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $d80606bc43d07b17$var$docQnaRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'qna [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section'
        ]
    ]
};
var $d80606bc43d07b17$var$_default = $d80606bc43d07b17$var$docQnaRole;
module.exports.default = $d80606bc43d07b17$var$_default;

});

parcelRegister("6oNyA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $4a8b6cea248b5e4f$var$docSubtitleRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'subtitle [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'sectionhead'
        ]
    ]
};
var $4a8b6cea248b5e4f$var$_default = $4a8b6cea248b5e4f$var$docSubtitleRole;
module.exports.default = $4a8b6cea248b5e4f$var$_default;

});

parcelRegister("gb40F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $bc70c8b23b7226ab$var$docTipRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'help [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'note'
        ]
    ]
};
var $bc70c8b23b7226ab$var$_default = $bc70c8b23b7226ab$var$docTipRole;
module.exports.default = $bc70c8b23b7226ab$var$_default;

});

parcelRegister("aTPjt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $020c3d4ad623a100$var$docTocRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            concept: {
                name: 'toc [EPUB-SSV]'
            },
            module: 'EPUB'
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'landmark',
            'navigation'
        ]
    ]
};
var $020c3d4ad623a100$var$_default = $020c3d4ad623a100$var$docTocRole;
module.exports.default = $020c3d4ad623a100$var$_default;

});


parcelRegister("lUHT7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff40df29173f4831$var$_graphicsDocumentRole = $ff40df29173f4831$var$_interopRequireDefault((parcelRequire("9yArl")));

var $ff40df29173f4831$var$_graphicsObjectRole = $ff40df29173f4831$var$_interopRequireDefault((parcelRequire("6lCoj")));

var $ff40df29173f4831$var$_graphicsSymbolRole = $ff40df29173f4831$var$_interopRequireDefault((parcelRequire("bfhQ0")));
function $ff40df29173f4831$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ff40df29173f4831$var$ariaGraphicsRoles = [
    [
        'graphics-document',
        $ff40df29173f4831$var$_graphicsDocumentRole.default
    ],
    [
        'graphics-object',
        $ff40df29173f4831$var$_graphicsObjectRole.default
    ],
    [
        'graphics-symbol',
        $ff40df29173f4831$var$_graphicsSymbolRole.default
    ]
];
var $ff40df29173f4831$var$_default = $ff40df29173f4831$var$ariaGraphicsRoles;
module.exports.default = $ff40df29173f4831$var$_default;

});
parcelRegister("9yArl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $6f538e47195822ba$var$graphicsDocumentRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            module: 'GRAPHICS',
            concept: {
                name: 'graphics-object'
            }
        },
        {
            module: 'ARIA',
            concept: {
                name: 'img'
            }
        },
        {
            module: 'ARIA',
            concept: {
                name: 'article'
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'document'
        ]
    ]
};
var $6f538e47195822ba$var$_default = $6f538e47195822ba$var$graphicsDocumentRole;
module.exports.default = $6f538e47195822ba$var$_default;

});

parcelRegister("6lCoj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $49f27bf0c91b1619$var$graphicsObjectRole = {
    abstract: false,
    accessibleNameRequired: false,
    baseConcepts: [],
    childrenPresentational: false,
    nameFrom: [
        'author',
        'contents'
    ],
    prohibitedProps: [],
    props: {
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [
        {
            module: 'GRAPHICS',
            concept: {
                name: 'graphics-document'
            }
        },
        {
            module: 'ARIA',
            concept: {
                name: 'group'
            }
        },
        {
            module: 'ARIA',
            concept: {
                name: 'img'
            }
        },
        {
            module: 'GRAPHICS',
            concept: {
                name: 'graphics-symbol'
            }
        }
    ],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'group'
        ]
    ]
};
var $49f27bf0c91b1619$var$_default = $49f27bf0c91b1619$var$graphicsObjectRole;
module.exports.default = $49f27bf0c91b1619$var$_default;

});

parcelRegister("bfhQ0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $82feeea8709ba99f$var$graphicsSymbolRole = {
    abstract: false,
    accessibleNameRequired: true,
    baseConcepts: [],
    childrenPresentational: true,
    nameFrom: [
        'author'
    ],
    prohibitedProps: [],
    props: {
        'aria-disabled': null,
        'aria-errormessage': null,
        'aria-expanded': null,
        'aria-haspopup': null,
        'aria-invalid': null
    },
    relatedConcepts: [],
    requireContextRole: [],
    requiredContextRole: [],
    requiredOwnedElements: [],
    requiredProps: {},
    superClass: [
        [
            'roletype',
            'structure',
            'section',
            'img'
        ]
    ]
};
var $82feeea8709ba99f$var$_default = $82feeea8709ba99f$var$graphicsSymbolRole;
module.exports.default = $82feeea8709ba99f$var$_default;

});



parcelRegister("cNpNf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04NZX = parcelRequire("04NZX");

var $950e11a87a38c530$var$_iterationDecorator = $950e11a87a38c530$var$_interopRequireDefault((parcelRequire("CkDFn")));

var $950e11a87a38c530$var$_rolesMap = $950e11a87a38c530$var$_interopRequireDefault((parcelRequire("dVCzH")));
function $950e11a87a38c530$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $950e11a87a38c530$var$_slicedToArray(arr, i) {
    return $950e11a87a38c530$var$_arrayWithHoles(arr) || $950e11a87a38c530$var$_iterableToArrayLimit(arr, i) || $950e11a87a38c530$var$_unsupportedIterableToArray(arr, i) || $950e11a87a38c530$var$_nonIterableRest();
}
function $950e11a87a38c530$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $950e11a87a38c530$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $950e11a87a38c530$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $950e11a87a38c530$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $950e11a87a38c530$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $950e11a87a38c530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $950e11a87a38c530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $950e11a87a38c530$var$_arrayLikeToArray(o, minLen);
}
function $950e11a87a38c530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $950e11a87a38c530$var$elementRoles = [];
var $950e11a87a38c530$var$keys = $950e11a87a38c530$var$_rolesMap.default.keys();
for(var $950e11a87a38c530$var$i = 0; $950e11a87a38c530$var$i < $950e11a87a38c530$var$keys.length; $950e11a87a38c530$var$i++){
    var $950e11a87a38c530$var$key = $950e11a87a38c530$var$keys[$950e11a87a38c530$var$i];
    var $950e11a87a38c530$var$role = $950e11a87a38c530$var$_rolesMap.default.get($950e11a87a38c530$var$key);
    if ($950e11a87a38c530$var$role) {
        var $950e11a87a38c530$var$concepts = [].concat($950e11a87a38c530$var$role.baseConcepts, $950e11a87a38c530$var$role.relatedConcepts);
        for(var $950e11a87a38c530$var$k = 0; $950e11a87a38c530$var$k < $950e11a87a38c530$var$concepts.length; $950e11a87a38c530$var$k++){
            var $950e11a87a38c530$var$relation = $950e11a87a38c530$var$concepts[$950e11a87a38c530$var$k];
            if ($950e11a87a38c530$var$relation.module === 'HTML') (function() {
                var concept = $950e11a87a38c530$var$relation.concept;
                if (concept) {
                    var elementRoleRelation = $950e11a87a38c530$var$elementRoles.find(function(relation) {
                        return (0, $04NZX.dequal)(relation, concept);
                    });
                    var roles;
                    if (elementRoleRelation) roles = elementRoleRelation[1];
                    else roles = [];
                    var isUnique = true;
                    for(var _i = 0; _i < roles.length; _i++)if (roles[_i] === $950e11a87a38c530$var$key) {
                        isUnique = false;
                        break;
                    }
                    if (isUnique) roles.push($950e11a87a38c530$var$key);
                    $950e11a87a38c530$var$elementRoles.push([
                        concept,
                        roles
                    ]);
                }
            })();
        }
    }
}
var $950e11a87a38c530$var$elementRoleMap = {
    entries: function entries() {
        return $950e11a87a38c530$var$elementRoles;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = $950e11a87a38c530$var$_createForOfIteratorHelper($950e11a87a38c530$var$elementRoles), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $950e11a87a38c530$var$_slicedToArray(_step.value, 2), _key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, _key, $950e11a87a38c530$var$elementRoles);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = $950e11a87a38c530$var$elementRoles.find(function(tuple) {
            return key.name === tuple[0].name && (0, $04NZX.dequal)(key.attributes, tuple[0].attributes);
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!$950e11a87a38c530$var$elementRoleMap.get(key);
    },
    keys: function keys() {
        return $950e11a87a38c530$var$elementRoles.map(function(_ref) {
            var _ref2 = $950e11a87a38c530$var$_slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return $950e11a87a38c530$var$elementRoles.map(function(_ref3) {
            var _ref4 = $950e11a87a38c530$var$_slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var $950e11a87a38c530$var$_default = (0, $950e11a87a38c530$var$_iterationDecorator.default)($950e11a87a38c530$var$elementRoleMap, $950e11a87a38c530$var$elementRoleMap.entries());
module.exports.default = $950e11a87a38c530$var$_default;

});
parcelRegister("04NZX", function(module, exports) {

$parcel$export(module.exports, "dequal", function () { return $00e7287cf9a267f0$export$de8294bb3be0322f; }, function (v) { return $00e7287cf9a267f0$export$de8294bb3be0322f = v; });

var $YtE9h = parcelRequire("YtE9h");
var $00e7287cf9a267f0$export$de8294bb3be0322f;
var $00e7287cf9a267f0$var$has = Object.prototype.hasOwnProperty;
function $00e7287cf9a267f0$var$dequal(foo, bar) {
    var ctor, len;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $00e7287cf9a267f0$var$dequal(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (!ctor || (typeof foo === "undefined" ? "undefined" : (0, $YtE9h._)(foo)) === 'object') {
            len = 0;
            for(ctor in foo){
                if ($00e7287cf9a267f0$var$has.call(foo, ctor) && ++len && !$00e7287cf9a267f0$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$00e7287cf9a267f0$var$dequal(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}
$00e7287cf9a267f0$export$de8294bb3be0322f = $00e7287cf9a267f0$var$dequal;

});


parcelRegister("lT17G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $feef9b0a8812b46f$var$_iterationDecorator = $feef9b0a8812b46f$var$_interopRequireDefault((parcelRequire("CkDFn")));

var $feef9b0a8812b46f$var$_rolesMap = $feef9b0a8812b46f$var$_interopRequireDefault((parcelRequire("dVCzH")));
function $feef9b0a8812b46f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $feef9b0a8812b46f$var$_slicedToArray(arr, i) {
    return $feef9b0a8812b46f$var$_arrayWithHoles(arr) || $feef9b0a8812b46f$var$_iterableToArrayLimit(arr, i) || $feef9b0a8812b46f$var$_unsupportedIterableToArray(arr, i) || $feef9b0a8812b46f$var$_nonIterableRest();
}
function $feef9b0a8812b46f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $feef9b0a8812b46f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $feef9b0a8812b46f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $feef9b0a8812b46f$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $feef9b0a8812b46f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e2) {
                    throw _e2;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e3) {
            didErr = true;
            err = _e3;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $feef9b0a8812b46f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $feef9b0a8812b46f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $feef9b0a8812b46f$var$_arrayLikeToArray(o, minLen);
}
function $feef9b0a8812b46f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $feef9b0a8812b46f$var$roleElement = [];
var $feef9b0a8812b46f$var$keys = $feef9b0a8812b46f$var$_rolesMap.default.keys();
for(var $feef9b0a8812b46f$var$i = 0; $feef9b0a8812b46f$var$i < $feef9b0a8812b46f$var$keys.length; $feef9b0a8812b46f$var$i++){
    var $feef9b0a8812b46f$var$key = $feef9b0a8812b46f$var$keys[$feef9b0a8812b46f$var$i];
    var $feef9b0a8812b46f$var$role = $feef9b0a8812b46f$var$_rolesMap.default.get($feef9b0a8812b46f$var$key);
    var $feef9b0a8812b46f$var$relationConcepts = [];
    if ($feef9b0a8812b46f$var$role) {
        var $feef9b0a8812b46f$var$concepts = [].concat($feef9b0a8812b46f$var$role.baseConcepts, $feef9b0a8812b46f$var$role.relatedConcepts);
        for(var $feef9b0a8812b46f$var$k = 0; $feef9b0a8812b46f$var$k < $feef9b0a8812b46f$var$concepts.length; $feef9b0a8812b46f$var$k++){
            var $feef9b0a8812b46f$var$relation = $feef9b0a8812b46f$var$concepts[$feef9b0a8812b46f$var$k];
            if ($feef9b0a8812b46f$var$relation.module === 'HTML') {
                var $feef9b0a8812b46f$var$concept = $feef9b0a8812b46f$var$relation.concept;
                if ($feef9b0a8812b46f$var$concept != null) $feef9b0a8812b46f$var$relationConcepts.push($feef9b0a8812b46f$var$concept);
            }
        }
        if ($feef9b0a8812b46f$var$relationConcepts.length > 0) $feef9b0a8812b46f$var$roleElement.push([
            $feef9b0a8812b46f$var$key,
            $feef9b0a8812b46f$var$relationConcepts
        ]);
    }
}
var $feef9b0a8812b46f$var$roleElementMap = {
    entries: function entries() {
        return $feef9b0a8812b46f$var$roleElement;
    },
    forEach: function forEach(fn) {
        var thisArg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var _iterator = $feef9b0a8812b46f$var$_createForOfIteratorHelper($feef9b0a8812b46f$var$roleElement), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = $feef9b0a8812b46f$var$_slicedToArray(_step.value, 2), _key = _step$value[0], values = _step$value[1];
                fn.call(thisArg, values, _key, $feef9b0a8812b46f$var$roleElement);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    },
    get: function get(key) {
        var item = $feef9b0a8812b46f$var$roleElement.find(function(tuple) {
            return tuple[0] === key ? true : false;
        });
        return item && item[1];
    },
    has: function has(key) {
        return !!$feef9b0a8812b46f$var$roleElementMap.get(key);
    },
    keys: function keys() {
        return $feef9b0a8812b46f$var$roleElement.map(function(_ref) {
            var _ref2 = $feef9b0a8812b46f$var$_slicedToArray(_ref, 1), key = _ref2[0];
            return key;
        });
    },
    values: function values() {
        return $feef9b0a8812b46f$var$roleElement.map(function(_ref3) {
            var _ref4 = $feef9b0a8812b46f$var$_slicedToArray(_ref3, 2), values = _ref4[1];
            return values;
        });
    }
};
var $feef9b0a8812b46f$var$_default = (0, $feef9b0a8812b46f$var$_iterationDecorator.default)($feef9b0a8812b46f$var$roleElementMap, $feef9b0a8812b46f$var$roleElementMap.entries());
module.exports.default = $feef9b0a8812b46f$var$_default;

});


parcelRegister("3szAT", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function compressToBase64(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function decompressFromBase64(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function compressToUTF16(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function decompressFromUTF16(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function compressToUint8Array(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function decompressFromUint8Array(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function compressToEncodedURIComponent(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function decompressFromEncodedURIComponent(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function compress(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function _compress(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function decompress(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function _decompress(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});

parcelRegister("ibRPI", function(module, exports) {
// shim for using process in browser
var $d3e3033a14238d9e$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3e3033a14238d9e$var$cachedSetTimeout;
var $d3e3033a14238d9e$var$cachedClearTimeout;
function $d3e3033a14238d9e$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $d3e3033a14238d9e$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        else $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedSetTimeout = $d3e3033a14238d9e$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        else $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    } catch (e) {
        $d3e3033a14238d9e$var$cachedClearTimeout = $d3e3033a14238d9e$var$defaultClearTimeout;
    }
})();
function $d3e3033a14238d9e$var$runTimeout(fun) {
    if ($d3e3033a14238d9e$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedSetTimeout === $d3e3033a14238d9e$var$defaultSetTimout || !$d3e3033a14238d9e$var$cachedSetTimeout) && setTimeout) {
        $d3e3033a14238d9e$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3e3033a14238d9e$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3e3033a14238d9e$var$runClearTimeout(marker) {
    if ($d3e3033a14238d9e$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3e3033a14238d9e$var$cachedClearTimeout === $d3e3033a14238d9e$var$defaultClearTimeout || !$d3e3033a14238d9e$var$cachedClearTimeout) && clearTimeout) {
        $d3e3033a14238d9e$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3e3033a14238d9e$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3e3033a14238d9e$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3e3033a14238d9e$var$queue = [];
var $d3e3033a14238d9e$var$draining = false;
var $d3e3033a14238d9e$var$currentQueue;
var $d3e3033a14238d9e$var$queueIndex = -1;
function $d3e3033a14238d9e$var$cleanUpNextTick() {
    if (!$d3e3033a14238d9e$var$draining || !$d3e3033a14238d9e$var$currentQueue) return;
    $d3e3033a14238d9e$var$draining = false;
    if ($d3e3033a14238d9e$var$currentQueue.length) $d3e3033a14238d9e$var$queue = $d3e3033a14238d9e$var$currentQueue.concat($d3e3033a14238d9e$var$queue);
    else $d3e3033a14238d9e$var$queueIndex = -1;
    if ($d3e3033a14238d9e$var$queue.length) $d3e3033a14238d9e$var$drainQueue();
}
function $d3e3033a14238d9e$var$drainQueue() {
    if ($d3e3033a14238d9e$var$draining) return;
    var timeout = $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$cleanUpNextTick);
    $d3e3033a14238d9e$var$draining = true;
    var len = $d3e3033a14238d9e$var$queue.length;
    while(len){
        $d3e3033a14238d9e$var$currentQueue = $d3e3033a14238d9e$var$queue;
        $d3e3033a14238d9e$var$queue = [];
        while(++$d3e3033a14238d9e$var$queueIndex < len)if ($d3e3033a14238d9e$var$currentQueue) $d3e3033a14238d9e$var$currentQueue[$d3e3033a14238d9e$var$queueIndex].run();
        $d3e3033a14238d9e$var$queueIndex = -1;
        len = $d3e3033a14238d9e$var$queue.length;
    }
    $d3e3033a14238d9e$var$currentQueue = null;
    $d3e3033a14238d9e$var$draining = false;
    $d3e3033a14238d9e$var$runClearTimeout(timeout);
}
$d3e3033a14238d9e$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3e3033a14238d9e$var$queue.push(new $d3e3033a14238d9e$var$Item(fun, args));
    if ($d3e3033a14238d9e$var$queue.length === 1 && !$d3e3033a14238d9e$var$draining) $d3e3033a14238d9e$var$runTimeout($d3e3033a14238d9e$var$drainQueue);
};
// v8 likes predictible objects
function $d3e3033a14238d9e$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3e3033a14238d9e$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3e3033a14238d9e$var$process.title = 'browser';
$d3e3033a14238d9e$var$process.browser = true;
$d3e3033a14238d9e$var$process.env = {};
$d3e3033a14238d9e$var$process.argv = [];
$d3e3033a14238d9e$var$process.version = ''; // empty string to avoid regexp issues
$d3e3033a14238d9e$var$process.versions = {};
function $d3e3033a14238d9e$var$noop() {}
$d3e3033a14238d9e$var$process.on = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.addListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.once = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.off = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.removeAllListeners = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.emit = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.prependOnceListener = $d3e3033a14238d9e$var$noop;
$d3e3033a14238d9e$var$process.listeners = function(name) {
    return [];
};
$d3e3033a14238d9e$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$d3e3033a14238d9e$var$process.cwd = function() {
    return '/';
};
$d3e3033a14238d9e$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$d3e3033a14238d9e$var$process.umask = function() {
    return 0;
};

});


parcelRegister("c38Wl", function(module, exports) {


module.exports = (parcelRequire("jrcmb"))((parcelRequire("451Sc")).resolve("5Whcg")).then(function() {
    return parcelRequire('dhpq2');
});

});
parcelRegister("jrcmb", function(module, exports) {
"use strict";

var $bnxiY = parcelRequire("bnxiY");
module.exports = $bnxiY(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("bnxiY", function(module, exports) {
"use strict";
var $848bad63e2eca00a$var$cachedBundles = {};
var $848bad63e2eca00a$var$cachedPreloads = {};
var $848bad63e2eca00a$var$cachedPrefetches = {};
function $848bad63e2eca00a$var$getCache(type) {
    switch(type){
        case 'preload':
            return $848bad63e2eca00a$var$cachedPreloads;
        case 'prefetch':
            return $848bad63e2eca00a$var$cachedPrefetches;
        default:
            return $848bad63e2eca00a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $848bad63e2eca00a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



var $588a21add34f3aea$exports = {};


(parcelRequire("451Sc")).register((parcelRequire("i1aqH")).getBundleURL('a3HC9'), JSON.parse("[\"a3HC9\",\"index.d0556509.js\",\"6q769\",\"offline.1e17d73f.jpg\",\"lV70k\",\"menu-left.8e47e19e.png\",\"5ioBo\",\"menu-right.d7c89653.png\",\"cc1e2\",\"veg.3f118b6b.png\",\"bIO4O\",\"non-veg.655db56f.png\",\"bUkII\",\"tick.01c249bf.png\",\"j6KgO\",\"delivery.5aafa0f5.png\",\"1dZy5\",\"payment.4d2ba910.png\",\"TiCnK\",\"offer.789a1fc3.png\",\"gDruq\",\"veg-icon.8d41b584.png\",\"5Whcg\",\"Grocery.ed247c88.js\",\"2sRFk\",\"index.e91e2286.css\"]"));


var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
var $fb34d4b6d3b01836$exports = {};

$parcel$export($fb34d4b6d3b01836$exports, "createRoot", function () { return $fb34d4b6d3b01836$export$882461b6382ed46c; }, function (v) { return $fb34d4b6d3b01836$export$882461b6382ed46c = v; });
$parcel$export($fb34d4b6d3b01836$exports, "hydrateRoot", function () { return $fb34d4b6d3b01836$export$757ceba2d55c277e; }, function (v) { return $fb34d4b6d3b01836$export$757ceba2d55c277e = v; });
var $fb34d4b6d3b01836$export$882461b6382ed46c;
var $fb34d4b6d3b01836$export$757ceba2d55c277e;
'use strict';

var $9F3H4 = parcelRequire("9F3H4");
var $fb34d4b6d3b01836$var$i;
$fb34d4b6d3b01836$export$882461b6382ed46c = $9F3H4.createRoot;
$fb34d4b6d3b01836$export$757ceba2d55c277e = $9F3H4.hydrateRoot;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");
/**
 * React Router DOM v6.24.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7k5I8 = parcelRequire("7k5I8");

var $bB0zn = parcelRequire("bB0zn");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $9F3H4 = parcelRequire("9F3H4");
/**
 * @remix-run/router v1.17.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7k5I8 = parcelRequire("7k5I8");

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $Q9cvz = parcelRequire("Q9cvz");

var $Q6yVl = parcelRequire("Q6yVl");

var $dNApw = parcelRequire("dNApw");

var $ihB7G = parcelRequire("ihB7G");
function $89eb4a55c543f071$export$71511d61b312f219(arr) {
    return (0, $Q9cvz._)(arr) || (0, $Q6yVl._)(arr) || (0, $ihB7G._)(arr) || (0, $dNApw._)();
}



var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");

var $lFlDF = parcelRequire("lFlDF");

var $lFlDF = parcelRequire("lFlDF");
function $dc332a6010e2a7ab$var$_extends() {
    $dc332a6010e2a7ab$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc332a6010e2a7ab$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $dc332a6010e2a7ab$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($dc332a6010e2a7ab$export$e19cd5f9376f8cee || ($dc332a6010e2a7ab$export$e19cd5f9376f8cee = {}));
var $dc332a6010e2a7ab$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $dc332a6010e2a7ab$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = $dc332a6010e2a7ab$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $dc332a6010e2a7ab$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $dc332a6010e2a7ab$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return $dc332a6010e2a7ab$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to);
    }
    return $dc332a6010e2a7ab$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $dc332a6010e2a7ab$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = $dc332a6010e2a7ab$export$8ccf933b0513f8d0(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $dc332a6010e2a7ab$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $dc332a6010e2a7ab$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $dc332a6010e2a7ab$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $dc332a6010e2a7ab$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $dc332a6010e2a7ab$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $dc332a6010e2a7ab$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $dc332a6010e2a7ab$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $dc332a6010e2a7ab$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = $dc332a6010e2a7ab$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $dc332a6010e2a7ab$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $dc332a6010e2a7ab$export$fe53371bee54353d(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $dc332a6010e2a7ab$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $dc332a6010e2a7ab$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, window1 = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window1.history;
    var action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
    var listener = null;
    var index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($dc332a6010e2a7ab$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
        var location = $dc332a6010e2a7ab$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $dc332a6010e2a7ab$var$getHistoryState(location, index);
        var url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
        var location = $dc332a6010e2a7ab$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $dc332a6010e2a7ab$var$getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        var href = typeof to === "string" ? to : $dc332a6010e2a7ab$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $dc332a6010e2a7ab$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($dc332a6010e2a7ab$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window1.removeEventListener($dc332a6010e2a7ab$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $dc332a6010e2a7ab$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($dc332a6010e2a7ab$var$ResultType || ($dc332a6010e2a7ab$var$ResultType = {}));
var $dc332a6010e2a7ab$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $dc332a6010e2a7ab$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $dc332a6010e2a7ab$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        $dc332a6010e2a7ab$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($dc332a6010e2a7ab$var$isIndexRoute(route)) {
            var indexRoute = $dc332a6010e2a7ab$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = $dc332a6010e2a7ab$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $dc332a6010e2a7ab$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $dc332a6010e2a7ab$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $dc332a6010e2a7ab$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    var location = typeof locationArg === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(locationArg) : locationArg;
    var pathname = $dc332a6010e2a7ab$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = $dc332a6010e2a7ab$var$flattenRoutes(routes);
    $dc332a6010e2a7ab$var$rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        var decoded = $dc332a6010e2a7ab$var$decodePath(pathname);
        matches = $dc332a6010e2a7ab$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $dc332a6010e2a7ab$export$b3fac024fad9e8ff(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $dc332a6010e2a7ab$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $dc332a6010e2a7ab$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = $dc332a6010e2a7ab$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $dc332a6010e2a7ab$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $dc332a6010e2a7ab$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $dc332a6010e2a7ab$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = $dc332a6010e2a7ab$var$explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $dc332a6010e2a7ab$var$explodeOptionalSegments(path) {
    var // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $89eb4a55c543f071$export$71511d61b312f219)(segments), first = _segments[0], rest = _segments.slice(1);
    // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = $dc332a6010e2a7ab$var$explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $2Xzd1._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $2Xzd1._)(restExploded));
    // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function $dc332a6010e2a7ab$var$rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : $dc332a6010e2a7ab$var$compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var $dc332a6010e2a7ab$var$paramRe = /^:[\w-]+$/;
var $dc332a6010e2a7ab$var$dynamicSegmentValue = 3;
var $dc332a6010e2a7ab$var$indexRouteValue = 2;
var $dc332a6010e2a7ab$var$emptySegmentValue = 1;
var $dc332a6010e2a7ab$var$staticSegmentValue = 10;
var $dc332a6010e2a7ab$var$splatPenalty = -2;
var $dc332a6010e2a7ab$var$isSplat = function(s) {
    return s === "*";
};
function $dc332a6010e2a7ab$var$computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some($dc332a6010e2a7ab$var$isSplat)) initialScore += $dc332a6010e2a7ab$var$splatPenalty;
    if (index) initialScore += $dc332a6010e2a7ab$var$indexRouteValue;
    return segments.filter(function(s) {
        return !$dc332a6010e2a7ab$var$isSplat(s);
    }).reduce(function(score, segment) {
        return score + ($dc332a6010e2a7ab$var$paramRe.test(segment) ? $dc332a6010e2a7ab$var$dynamicSegmentValue : segment === "" ? $dc332a6010e2a7ab$var$emptySegmentValue : $dc332a6010e2a7ab$var$staticSegmentValue);
    }, initialScore);
}
function $dc332a6010e2a7ab$var$compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $dc332a6010e2a7ab$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = $dc332a6010e2a7ab$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $dc332a6010e2a7ab$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $dc332a6010e2a7ab$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $dc332a6010e2a7ab$export$a5c6d149b50c1d86($dc332a6010e2a7ab$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $dc332a6010e2a7ab$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $dc332a6010e2a7ab$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $dc332a6010e2a7ab$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        var keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, $kB67t._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            $dc332a6010e2a7ab$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $dc332a6010e2a7ab$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $kB67t._)($dc332a6010e2a7ab$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = compiledParams.reduce(function(memo, _ref, index) {
        var paramName = _ref.paramName, isOptional = _ref.isOptional;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        var value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $dc332a6010e2a7ab$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $dc332a6010e2a7ab$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, function(_, paramName, isOptional) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $dc332a6010e2a7ab$var$decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        $dc332a6010e2a7ab$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $dc332a6010e2a7ab$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $dc332a6010e2a7ab$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $dc332a6010e2a7ab$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $dc332a6010e2a7ab$var$normalizeSearch(search),
        hash: $dc332a6010e2a7ab$var$normalizeHash(hash)
    };
}
function $dc332a6010e2a7ab$var$resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $dc332a6010e2a7ab$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $dc332a6010e2a7ab$var$getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $dc332a6010e2a7ab$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    var pathMatches = $dc332a6010e2a7ab$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
    return pathMatches.map(function(match) {
        return match.pathnameBase;
    });
}
/**
 * @private
 */ function $dc332a6010e2a7ab$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = $dc332a6010e2a7ab$export$8ccf933b0513f8d0(toArg);
    else {
        to = $dc332a6010e2a7ab$var$_extends({}, toArg);
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $dc332a6010e2a7ab$var$getInvalidPathError("?", "pathname", "search", to));
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $dc332a6010e2a7ab$var$getInvalidPathError("#", "pathname", "hash", to));
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $dc332a6010e2a7ab$var$getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = $dc332a6010e2a7ab$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $dc332a6010e2a7ab$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ var $dc332a6010e2a7ab$export$86d9a7913e44197e = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var $dc332a6010e2a7ab$export$a5c6d149b50c1d86 = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var $dc332a6010e2a7ab$var$normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var $dc332a6010e2a7ab$var$normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var $dc332a6010e2a7ab$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $dc332a6010e2a7ab$var$_extends({}, responseInit, {
        headers: headers
    }));
};
var $dc332a6010e2a7ab$export$42a99a7a4bc0e76a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $5dLwP._)(AbortedDeferredError, Error1);
    function AbortedDeferredError() {
        (0, $bB0zn._)(this, AbortedDeferredError);
        return (0, $3Gvhd._)(this, AbortedDeferredError, arguments);
    }
    return AbortedDeferredError;
}((0, $fPaN7._)(Error));
var $dc332a6010e2a7ab$export$61d759255b4eec65 = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, $bB0zn._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $dc332a6010e2a7ab$export$3e9cee6b33872309(data && (typeof data === "undefined" ? "undefined" : (0, $YtE9h._)(data)) === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new $dc332a6010e2a7ab$export$42a99a7a4bc0e76a("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref2) {
            var _$_ref2 = (0, $kB67t._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
            return Object.assign(acc, (0, $hD5pT._)({}, key, _this.trackPromise(key, value)));
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, $6QEWP._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key);
                // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, undefined, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                });
                // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof $dc332a6010e2a7ab$export$42a99a7a4bc0e76a) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                // If the promise was resolved/rejected with undefined, we'll throw an error as you
                // should always resolve with a value or null
                if (error === undefined && data === undefined) {
                    var undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return undefinedError;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(undefinedError);
                }
                if (data === undefined) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, $7k5I8._)(function() {
                    var aborted, onAbort;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                $dc332a6010e2a7ab$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref3) {
                    var _$_ref3 = (0, $kB67t._)(_ref3, 2), key = _$_ref3[0], value = _$_ref3[1];
                    return Object.assign(acc, (0, $hD5pT._)({}, key, $dc332a6010e2a7ab$var$unwrapTrackedPromise(value)));
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function $dc332a6010e2a7ab$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $dc332a6010e2a7ab$var$unwrapTrackedPromise(value) {
    if (!$dc332a6010e2a7ab$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var $dc332a6010e2a7ab$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $dc332a6010e2a7ab$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $dc332a6010e2a7ab$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $dc332a6010e2a7ab$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var $dc332a6010e2a7ab$export$a6cd19cd1951a23c = function(url, init) {
    var response = $dc332a6010e2a7ab$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ var $dc332a6010e2a7ab$export$6c6580e81da25755 = function ErrorResponseImpl(status, statusText, data, internal) {
    "use strict";
    (0, $bB0zn._)(this, ErrorResponseImpl);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $dc332a6010e2a7ab$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var $dc332a6010e2a7ab$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var $dc332a6010e2a7ab$var$validMutationMethods = new Set($dc332a6010e2a7ab$var$validMutationMethodsArr);
var $dc332a6010e2a7ab$var$validRequestMethodsArr = [
    "get"
].concat((0, $2Xzd1._)($dc332a6010e2a7ab$var$validMutationMethodsArr));
var $dc332a6010e2a7ab$var$validRequestMethods = new Set($dc332a6010e2a7ab$var$validRequestMethodsArr);
var $dc332a6010e2a7ab$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $dc332a6010e2a7ab$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $dc332a6010e2a7ab$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $dc332a6010e2a7ab$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
var $dc332a6010e2a7ab$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var $dc332a6010e2a7ab$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $dc332a6010e2a7ab$var$defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
};
var $dc332a6010e2a7ab$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $dc332a6010e2a7ab$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    var isServer = !isBrowser;
    $dc332a6010e2a7ab$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $dc332a6010e2a7ab$var$defaultMapRouteProperties;
    // Routes keyed by ID
    var manifest = {};
    // Routes in tree format for matching
    var dataRoutes = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/";
    var dataStrategyImpl = init.unstable_dataStrategy || $dc332a6010e2a7ab$var$defaultDataStrategy;
    var patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    var future = $dc332a6010e2a7ab$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    var unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    var subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    var getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = $dc332a6010e2a7ab$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = $dc332a6010e2a7ab$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $dc332a6010e2a7ab$var$getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = (0, $hD5pT._)({}, route.id, error);
    }
    // If the user provided a patchRoutesOnMiss implementation and our initial
    // match is a splat route, clear them out so we run through lazy discovery
    // on hydration in case there's a more accurate lazy route match
    if (initialMatches && patchRoutesOnMissImpl) {
        var fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    var initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some(function(m) {
        return m.route.lazy;
    })) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some(function(m) {
        return m.route.loader;
    })) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        var errors = init.hydrationData ? init.hydrationData.errors : null;
        var isRouteInitialized = function(m) {
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            var idx = initialMatches.findIndex(function(m) {
                return errors[m.route.id] !== undefined;
            });
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $dc332a6010e2a7ab$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false;
    // AbortController for the active navigation
    var pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    var pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    var appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    var removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map();
    // Track loads based on the order in which they started
    var incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    var activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    var deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    var pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $dc332a6010e2a7ab$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $dc332a6010e2a7ab$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $dc332a6010e2a7ab$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $dc332a6010e2a7ab$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $dc332a6010e2a7ab$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        var completedFetchers = [];
        var deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        (0, $2Xzd1._)(subscribers).forEach(function(subscriber) {
            return subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            });
        });
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach(function(key) {
                return state.fetchers.delete(key);
            });
            deletedFetchersKeys.forEach(function(key) {
                return deleteFetcher(key);
            });
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        var flushSync = (_temp === void 0 ? {} : _temp).flushSync;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $dc332a6010e2a7ab$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? $dc332a6010e2a7ab$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        var blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $dc332a6010e2a7ab$export$386d57f03f0b2883);
            });
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $dc332a6010e2a7ab$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        var viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($dc332a6010e2a7ab$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $dc332a6010e2a7ab$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // Trigger a navigation event, which can either be a numerical POP or a PUSH
        // replace with an optional submission
        (0, $7k5I8._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = $dc332a6010e2a7ab$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = $dc332a6010e2a7ab$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = $dc332a6010e2a7ab$var$createLocation(state.location, path, opts && opts.state);
                        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = $dc332a6010e2a7ab$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
                        if (userReplace === true) historyAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && $dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        flushSync = (opts && opts.unstable_flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    });
                                    // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $dc332a6010e2a7ab$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.unstable_viewTransition,
                                flushSync: flushSync
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _navigate.apply(this, arguments);
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // Start a navigation to the given action/location.  Can optionally provide a
        // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, $7k5I8._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, flushSync, fogOfWar, _handleNavigational404, error, notFoundMatches, route, request, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, location, basename);
                        flushSync = (opts && opts.flushSync) === true;
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $hD5pT._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Short circuit if it's only a hash change and not a revalidation or
                        // mutation submission.
                        //
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
                        // which will default to a navigation to /page
                        if (state.initialized && !isRevalidationRequired && $dc332a6010e2a7ab$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $dc332a6010e2a7ab$var$isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingActionResult = [
                            $dc332a6010e2a7ab$var$findNearestBoundary(matches).route.id,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.error,
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && $dc332a6010e2a7ab$var$isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 2:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        // If we received a 404 from handleAction, it's because we couldn't lazily
                        // discover the destination route so we don't want to call loaders
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $kB67t._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if ($dc332a6010e2a7ab$var$isErrorResult(result) && $dc332a6010e2a7ab$export$972111febbeef05b(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = $dc332a6010e2a7ab$var$getLoadingNavigation(location, opts.submission);
                        flushSync = false;
                        // No need to do fog of war matching again on loader execution
                        fogOfWar.active = false;
                        // Create a GET request for the loaders
                        request = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                        // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, $dc332a6010e2a7ab$var$_extends({
                            matches: updatedMatches || matches
                        }, $dc332a6010e2a7ab$var$getActionDataForCommit(pendingActionResult), {
                            loaderData: loaderData,
                            errors: errors
                        }));
                        return [
                            2
                        ];
                }
            });
        });
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // Call the action matched by the leaf route for this navigation and handle
        // redirects/errors
        (0, $7k5I8._)(function(request, location, submission, matches, isFogOfWar, opts) {
            var navigation, discoverResult, _handleDiscoverRouteError, error, notFoundMatches, route, _handleNavigational404, notFoundMatches1, error1, route1, result, actionMatch, results, replace, _$location, boundaryMatch;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (opts === void 0) opts = {};
                        interruptActiveLoads();
                        // Put us in a submitting state
                        navigation = $dc332a6010e2a7ab$var$getSubmittingNavigation(location, submission);
                        updateState({
                            navigation: navigation
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), error = _handleDiscoverRouteError.error, notFoundMatches = _handleDiscoverRouteError.notFoundMatches, route = _handleDiscoverRouteError.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route.id,
                                        {
                                            type: $dc332a6010e2a7ab$var$ResultType.error,
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches1 = _handleNavigational404.notFoundMatches, error1 = _handleNavigational404.error, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches1,
                                    pendingActionResult: [
                                        route1.id,
                                        {
                                            type: $dc332a6010e2a7ab$var$ResultType.error,
                                            error: error1
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = $dc332a6010e2a7ab$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!$dc332a6010e2a7ab$var$isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else {
                            // If the user didn't explicity indicate replace behavior, replace if
                            // we redirected to the exact same location we're currently at to avoid
                            // double back-buttons
                            _$location = $dc332a6010e2a7ab$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                            replace = _$location === state.location.pathname + state.location.search;
                        }
                        return [
                            4,
                            startRedirectNavigation(request, result, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if ($dc332a6010e2a7ab$var$isDeferredResult(result)) throw $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(matches, actionMatch.route.id);
                            // By default, all submissions to the current location are REPLACE
                            // navigations, but if the action threw an error that'll be rendered in
                            // an errorElement, we fall back to PUSH so that the user can use the
                            // back button to get back to the pre-submission form location to try
                            // again
                            if ((opts && opts.replace) !== true) pendingAction = $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        });
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // Call all applicable loaders for the given matches, handling redirects,
        // errors, etc.
        (0, $7k5I8._)(function(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _handleDiscoverRouteError, error, notFoundMatches, route, _handleNavigational404, error1, notFoundMatches1, route1, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation || $dc332a6010e2a7ab$var$getLoadingNavigation(location, submission);
                        // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission || $dc332a6010e2a7ab$var$getSubmissionFromNavigation(loadingNavigation);
                        // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        // If we have partialHydration enabled, then don't update the state for the
                        // initial data load since it's not a "navigation"
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState($dc332a6010e2a7ab$var$_extends({
                                navigation: loadingNavigation
                            }, actionData !== undefined ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            _handleDiscoverRouteError = handleDiscoverRouteError(location.pathname, discoverResult), error = _handleDiscoverRouteError.error, notFoundMatches = _handleDiscoverRouteError.notFoundMatches, route = _handleDiscoverRouteError.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, route.id, error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error1 = _handleNavigational404.error, notFoundMatches1 = _handleNavigational404.notFoundMatches, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches1,
                                    loaderData: {},
                                    errors: (0, $hD5pT._)({}, route1.id, error1)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, $kB67t._)($dc332a6010e2a7ab$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        });
                        pendingNavigationLoadId = ++incrementingLoadId;
                        // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, $dc332a6010e2a7ab$var$_extends({
                                matches: matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingActionResult && $dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1]) ? (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, $dc332a6010e2a7ab$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                // Only update navigation/actionNData if we didn't already do it above
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== undefined) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        });
                        // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = $dc332a6010e2a7ab$var$findRedirect((0, $2Xzd1._)(loaderResults).concat((0, $2Xzd1._)(fetcherResults)));
                        if (!redirect) return [
                            3,
                            5
                        ];
                        if (redirect.idx >= matchesToLoad.length) {
                            // If this redirect came from a fetcher make sure we mark it in
                            // fetchRedirectIds so it doesn't get revalidated on the next set of
                            // loader executions
                            fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                            fetchRedirectIds.add(fetcherKey);
                        }
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        // Process and commit output from loaders
                        _processLoaderData = $dc332a6010e2a7ab$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        // During partial hydration, preserve SSR errors for routes that don't re-run
                        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter(function(_ref2) {
                            var _$_ref2 = (0, $kB67t._)(_ref2, 1), id = _$_ref2[0];
                            return !matchesToLoad.some(function(m) {
                                return m.route.id === id;
                            });
                        }).forEach(function(_ref3) {
                            var _$_ref3 = (0, $kB67t._)(_ref3, 2), routeId = _$_ref3[0], error = _$_ref3[1];
                            errors = Object.assign(errors || {}, (0, $hD5pT._)({}, routeId, error));
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = state.fetchers.get(rf.key);
            var revalidatingFetcher = $dc332a6010e2a7ab$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var flushSync = (opts && opts.unstable_flushSync) === true;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = $dc332a6010e2a7ab$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        var matches = $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        var fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        var _normalizeNavigateOptions = $dc332a6010e2a7ab$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        var match = $dc332a6010e2a7ab$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // Call the action for the matched fetcher.submit(), and then handle redirects,
        // errors, and revalidation
        (0, $7k5I8._)(function(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, actionResults, actionResult, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, fetcherKey, _processLoaderData, loaderData, errors, doneFetcher;
            function detectAndHandle405Error(m) {
                if (!m.route.action && !m.route.lazy) {
                    var error = $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                        method: submission.formMethod,
                        pathname: path,
                        routeId: routeId
                    });
                    setFetcherError(key, routeId, error, {
                        flushSync: flushSync
                    });
                    return true;
                }
                return false;
            }
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!isFogOfWar && detectAndHandle405Error(match)) return [
                            2
                        ];
                        // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getSubmittingFetcher(submission, existingFetcher), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            requestMatches = discoverResult.matches;
                            match = $dc332a6010e2a7ab$var$getTargetMatch(requestMatches, path);
                            if (detectAndHandle405Error(match)) return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        // Call the action for the fetcher
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("action", fetchRequest, [
                                match
                            ], requestMatches)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[0];
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
                        // or redirects processed for unmounted fetchers so we just revert them to
                        // idle
                        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
                            if ($dc332a6010e2a7ab$var$isRedirectResult(actionResult) || $dc332a6010e2a7ab$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($dc332a6010e2a7ab$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    // A new navigation was kicked off after our action started, so that
                                    // should take precedence over this redirect navigation.  We already
                                    // set isRevalidationRequired so all loaders for the new route should
                                    // fire unless opted out via shouldRevalidate
                                    updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $dc332a6010e2a7ab$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, {
                                            fetcherSubmission: submission
                                        })
                                    ];
                                }
                            }
                            // Process any non-redirect errors thrown
                            if ($dc332a6010e2a7ab$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        if ($dc332a6010e2a7ab$var$isDeferredResult(actionResult)) throw $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = $dc332a6010e2a7ab$var$getLoadingFetcher(submission, actionResult.data);
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, $kB67t._)($dc332a6010e2a7ab$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
                            match.route.id,
                            actionResult
                        ]), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1];
                        // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = $dc332a6010e2a7ab$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = $dc332a6010e2a7ab$var$findRedirect((0, $2Xzd1._)(loaderResults).concat((0, $2Xzd1._)(fetcherResults)));
                        if (redirect) {
                            if (redirect.idx >= matchesToLoad.length) {
                                // If this redirect came from a fetcher make sure we mark it in
                                // fetchRedirectIds so it doesn't get revalidated on the next set of
                                // loader executions
                                fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                                fetchRedirectIds.add(fetcherKey);
                            }
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result)
                            ];
                        }
                        // Process and commit output from loaders
                        _processLoaderData = $dc332a6010e2a7ab$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        // Since we let revalidations complete even if the submitting fetcher was
                        // deleted, only put it back to idle if it hasn't been deleted
                        if (state.fetchers.has(key)) {
                            doneFetcher = $dc332a6010e2a7ab$var$getDoneFetcher(actionResult.data);
                            state.fetchers.set(key, doneFetcher);
                        }
                        abortStaleFetchLoads(loadId);
                        // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            $dc332a6010e2a7ab$export$3e9cee6b33872309(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState({
                                errors: errors,
                                loaderData: $dc332a6010e2a7ab$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: new Map(state.fetchers)
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        (0, $7k5I8._)(function(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
            var existingFetcher, abortController, fetchRequest, discoverResult, error, originatingLoadId, results, result;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, path, fetchRequest.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            error = handleDiscoverRouteError(path, discoverResult).error;
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else {
                            matches = discoverResult.matches;
                            match = $dc332a6010e2a7ab$var$getTargetMatch(matches, path);
                        }
                        _state.label = 2;
                    case 2:
                        // Call the loader for this fetcher route match
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy("loader", fetchRequest, [
                                match
                            ], matches)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[0];
                        if (!$dc332a6010e2a7ab$var$isDeferredResult(result)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            $dc332a6010e2a7ab$var$resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 4:
                        result = _state.sent() || result;
                        _state.label = 5;
                    case 5:
                        // We can delete this so long as we weren't aborted by our our own fetcher
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        // We don't want errors bubbling up or redirects followed for unmounted
                        // fetchers, so short circuit here if it was removed from the UI
                        if (deletedFetchers.has(key)) {
                            updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                            return [
                                2
                            ];
                        }
                        if (!$dc332a6010e2a7ab$var$isRedirectResult(result)) return [
                            3,
                            8
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            6
                        ];
                        // A new navigation was kicked off after our loader started, so that
                        // should take precedence over this redirect navigation
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(undefined));
                        return [
                            2
                        ];
                    case 6:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result)
                        ];
                    case 7:
                        _state.sent();
                        return [
                            2
                        ];
                    case 8:
                        // Process any non-redirect errors thrown
                        if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(!$dc332a6010e2a7ab$var$isDeferredResult(result), "Unhandled fetcher deferred data");
                        // Put the fetcher back into an idle state
                        updateFetcherState(key, $dc332a6010e2a7ab$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(request, redirect, _temp2) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, $7k5I8._)(function(request, redirect, _temp2) {
            var _ref, submission, fetcherSubmission, replace, location, redirectLocation, isDocumentReload, url, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, activeSubmission, overrideNavigation;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp2 === void 0 ? {} : _temp2, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, replace = _ref.replace;
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
                        location = $dc332a6010e2a7ab$var$normalizeRedirectLocation(location, new URL(request.url), basename);
                        redirectLocation = $dc332a6010e2a7ab$var$createLocation(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
                            isDocumentReload = true;
                            else if ($dc332a6010e2a7ab$var$ABSOLUTE_URL_REGEX.test(location)) {
                                url = init.history.createURL(location);
                                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                                $dc332a6010e2a7ab$export$b69e3301ce081aa3(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Replace : $dc332a6010e2a7ab$export$e19cd5f9376f8cee.Push;
                        // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $dc332a6010e2a7ab$var$getSubmissionFromNavigation(state.navigation);
                        // If this was a 307/308 submission we want to preserve the HTTP method and
                        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
                        // redirected location
                        activeSubmission = submission || fetcherSubmission;
                        if (!($dc332a6010e2a7ab$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $dc332a6010e2a7ab$var$isMutationMethod(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: $dc332a6010e2a7ab$var$_extends({}, activeSubmission, {
                                    formAction: location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        // If we have a navigation submission, we will preserve it through the
                        // redirect navigation
                        overrideNavigation = $dc332a6010e2a7ab$var$getLoadingNavigation(redirectLocation, submission);
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: overrideNavigation,
                                // Send fetcher submissions through for shouldRevalidate
                                fetcherSubmission: fetcherSubmission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy client-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $7k5I8._)(function(type, request, matchesToLoad, matches) {
            var results, e;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            $dc332a6010e2a7ab$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($dc332a6010e2a7ab$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    return {
                                        type: $dc332a6010e2a7ab$var$ResultType.redirect,
                                        response: $dc332a6010e2a7ab$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                                    };
                                }
                                return $dc332a6010e2a7ab$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        e = _state.sent();
                        // If the outer dataStrategy method throws, just return the error for all
                        // matches - and it'll naturally bubble to the root
                        return [
                            2,
                            matchesToLoad.map(function() {
                                return {
                                    type: $dc332a6010e2a7ab$var$ResultType.error,
                                    error: e
                                };
                            })
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, $7k5I8._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var _ref, loaderResults, fetcherResults;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all([
                                matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : []
                            ].concat((0, $2Xzd1._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) {
                                    var fetcherRequest = $dc332a6010e2a7ab$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                                    return callDataStrategy("loader", fetcherRequest, [
                                        f.match
                                    ], f.matches).then(function(r) {
                                        return r[0];
                                    });
                                } else return Promise.resolve({
                                    type: $dc332a6010e2a7ab$var$ResultType.error,
                                    error: $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                                        pathname: f.path
                                    })
                                });
                            }))))
                        ];
                    case 1:
                        _ref = (0, $89eb4a55c543f071$export$71511d61b312f219).apply(void 0, [
                            _state.sent()
                        ]), loaderResults = _ref[0], fetcherResults = _ref.slice(1);
                        return [
                            4,
                            Promise.all([
                                $dc332a6010e2a7ab$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                $dc332a6010e2a7ab$var$resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                loaderResults: loaderResults,
                                fetcherResults: fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, $2Xzd1._)(cancelActiveDeferreds()));
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        var boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: (0, $hD5pT._)({}, boundaryMatch.route.id, error),
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $dc332a6010e2a7ab$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        var fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            var count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        $dc332a6010e2a7ab$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = $dc332a6010e2a7ab$var$getDoneFetcher(fetcher.data);
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                $dc332a6010e2a7ab$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    $dc332a6010e2a7ab$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $dc332a6010e2a7ab$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $dc332a6010e2a7ab$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $dc332a6010e2a7ab$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        var currentLocation = _ref4.currentLocation, nextLocation = _ref4.nextLocation, historyAction = _ref4.historyAction;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $dc332a6010e2a7ab$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $kB67t._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = $dc332a6010e2a7ab$var$getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var _getShortCircuitMatches = $dc332a6010e2a7ab$var$getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        var matches = discoverResult.partialMatches;
        var route = matches[matches.length - 1].route;
        var error = $dc332a6010e2a7ab$var$getInternalRouterError(400, {
            type: "route-discovery",
            routeId: route.id,
            pathname: pathname,
            message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
        });
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $dc332a6010e2a7ab$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            var key = getScrollRestorationKey(location, matches.map(function(m) {
                return $dc332a6010e2a7ab$export$b3fac024fad9e8ff(m, state.loaderData);
            }));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                var fogMatches = $dc332a6010e2a7ab$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                var leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    var partialMatches = $dc332a6010e2a7ab$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal) {
        return _discoverRoutes.apply(this, arguments);
    }
    function _discoverRoutes() {
        _discoverRoutes = (0, $7k5I8._)(function(matches, pathname, signal) {
            var partialMatches, route, isNonHMR, routesToUse, e, newMatches, matchedSplat, leafRoute, newPartialMatches;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        partialMatches = matches;
                        route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            7
                        ];
                        isNonHMR = inFlightDataRoutes == null;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            5,
                            6
                        ]);
                        return [
                            4,
                            $dc332a6010e2a7ab$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        e = _state.sent();
                        return [
                            2,
                            {
                                type: "error",
                                error: e,
                                partialMatches: partialMatches
                            }
                        ];
                    case 5:
                        // If we are not in the middle of an HMR revalidation and we changed the
                        // routes, provide a new identity so when we `updateState` at the end of
                        // this navigation/fetch `router.routes` will be a new identity and
                        // trigger a re-run of memoized `router.routes` dependencies.
                        // HMR will already update the identity and reflow when it lands
                        // `inFlightDataRoutes` in `completeNavigation`
                        if (isNonHMR) dataRoutes = (0, $2Xzd1._)(dataRoutes);
                        return [
                            7
                        ];
                    case 6:
                        if (signal.aborted) return [
                            2,
                            {
                                type: "aborted"
                            }
                        ];
                        newMatches = $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, pathname, basename);
                        matchedSplat = false;
                        if (newMatches) {
                            leafRoute = newMatches[newMatches.length - 1].route;
                            if (leafRoute.index) // If we found an index route, we can stop
                            return [
                                2,
                                {
                                    type: "success",
                                    matches: newMatches
                                }
                            ];
                            if (leafRoute.path && leafRoute.path.length > 0) {
                                if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                                // higher-scoring route down some partial matches trail so we need
                                // to check that out
                                matchedSplat = true;
                                else // If we found a non-splat route, we can stop
                                return [
                                    2,
                                    {
                                        type: "success",
                                        matches: newMatches
                                    }
                                ];
                            }
                        }
                        newPartialMatches = $dc332a6010e2a7ab$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                        // If we are no longer partially matching anything, this was either a
                        // legit splat match above, or it's a 404.  Also avoid loops if the
                        // second pass results in the same partial matches
                        if (!newPartialMatches || partialMatches.map(function(m) {
                            return m.route.id;
                        }).join("-") === newPartialMatches.map(function(m) {
                            return m.route.id;
                        }).join("-")) return [
                            2,
                            {
                                type: "success",
                                matches: matchedSplat ? newMatches : null
                            }
                        ];
                        partialMatches = newPartialMatches;
                        route = partialMatches[partialMatches.length - 1].route;
                        if (route.path === "*") // The splat is still our most accurate partial, so run with it
                        return [
                            2,
                            {
                                type: "success",
                                matches: partialMatches
                            }
                        ];
                        return [
                            3,
                            1
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return _discoverRoutes.apply(this, arguments);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        var isNonHMR = inFlightDataRoutes == null;
        var routesToUse = inFlightDataRoutes || dataRoutes;
        $dc332a6010e2a7ab$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = (0, $2Xzd1._)(dataRoutes);
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes: _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var $dc332a6010e2a7ab$export$4d0306f8f6a4585b = Symbol("deferred");
function $dc332a6010e2a7ab$export$3336b097a6fbc59a(routes, opts) {
    $dc332a6010e2a7ab$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = $dc332a6010e2a7ab$var$defaultMapRouteProperties;
    // Config driven behavior flags
    var future = $dc332a6010e2a7ab$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    var dataRoutes = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp3) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ (0, $7k5I8._)(function(request, _temp3) {
            var _ref, requestContext, skipLoaderErrorBubbling, unstable_dataStrategy, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, requestContext = _ref.requestContext, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = $dc332a6010e2a7ab$var$createLocation("", $dc332a6010e2a7ab$export$fe53371bee54353d(url), null, "default");
                        matches = $dc332a6010e2a7ab$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$dc332a6010e2a7ab$var$isValidMethod(method) && method !== "HEAD") {
                            error = $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $dc332a6010e2a7ab$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route.id, error),
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $dc332a6010e2a7ab$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename: basename,
                                    location: location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: (0, $hD5pT._)({}, route1.id, error1),
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($dc332a6010e2a7ab$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp4) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ (0, $7k5I8._)(function(request, _temp4) {
            var _ref, routeId, requestContext, unstable_dataStrategy, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp4 === void 0 ? {} : _temp4, routeId = _ref.routeId, requestContext = _ref.requestContext, unstable_dataStrategy = _ref.unstable_dataStrategy;
                        url = new URL(request.url);
                        method = request.method;
                        location = $dc332a6010e2a7ab$var$createLocation("", $dc332a6010e2a7ab$export$fe53371bee54353d(url), null, "default");
                        matches = $dc332a6010e2a7ab$export$2708184779ceb39d(dataRoutes, location, basename);
                        // SSR supports HEAD requests while SPA doesn't
                        if (!$dc332a6010e2a7ab$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $dc332a6010e2a7ab$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $dc332a6010e2a7ab$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if ($dc332a6010e2a7ab$var$isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                        // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$dc332a6010e2a7ab$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, $7k5I8._)(function(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
            var result, result1, e;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $dc332a6010e2a7ab$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$dc332a6010e2a7ab$var$isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || $dc332a6010e2a7ab$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            $dc332a6010e2a7ab$var$isResponse(result1) ? result1 : $dc332a6010e2a7ab$var$_extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction for a
                        // `queryRoute` call, we throw the `HandlerResult` to bail out early
                        // and then return or throw the raw Response here accordingly
                        if ($dc332a6010e2a7ab$var$isHandlerResult(e) && $dc332a6010e2a7ab$var$isResponse(e.result)) {
                            if (e.type === $dc332a6010e2a7ab$var$ResultType.error) throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if ($dc332a6010e2a7ab$var$isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, $7k5I8._)(function(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
            var result, error, results, error1, loaderRequest, boundaryMatch, context, context1;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy("action", request, [
                                actionMatch
                            ], matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 2:
                        results = _state.sent();
                        result = results[0];
                        if (request.signal.aborted) $dc332a6010e2a7ab$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        _state.label = 3;
                    case 3:
                        if ($dc332a6010e2a7ab$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if ($dc332a6010e2a7ab$var$isDeferredResult(result)) {
                            error1 = $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: $dc332a6010e2a7ab$var$ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if ($dc332a6010e2a7ab$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        // Create a GET request for the loaders
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!$dc332a6010e2a7ab$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $dc332a6010e2a7ab$var$findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                                boundaryMatch.route.id,
                                result
                            ])
                        ];
                    case 4:
                        context = _state.sent();
                        // action status codes take precedence over loader status codes
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({}, context, {
                                statusCode: $dc332a6010e2a7ab$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                actionData: null,
                                actionHeaders: $dc332a6010e2a7ab$var$_extends({}, result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {})
                            })
                        ];
                    case 5:
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({}, context1, {
                                actionData: (0, $hD5pT._)({}, actionMatch.route.id, result.data)
                            }, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionHeaders: result.headers ? (0, $hD5pT._)({}, actionMatch.route.id, result.headers) : {}
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, $7k5I8._)(function(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
            var isRouteRequest, requestMatches, matchesToLoad, results, activeDeferreds, context, executedLoaders;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : pendingActionResult && $dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1]) ? $dc332a6010e2a7ab$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        });
                        // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches: matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, (0, $hD5pT._)({}, m.route.id, null));
                                }, {}),
                                errors: pendingActionResult && $dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1]) ? (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $dc332a6010e2a7ab$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
                        // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = $dc332a6010e2a7ab$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
                        // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            $dc332a6010e2a7ab$var$_extends({}, context, {
                                matches: matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        return _callDataStrategy.apply(this, arguments);
    }
    function _callDataStrategy() {
        _callDataStrategy = // Utility wrapper for calling dataStrategy server-side without having to
        // pass around the manifest, mapRouteProperties, etc.
        (0, $7k5I8._)(function(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
            var results;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $dc332a6010e2a7ab$var$callDataStrategyImpl(unstable_dataStrategy || $dc332a6010e2a7ab$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext)
                        ];
                    case 1:
                        results = _state.sent();
                        return [
                            4,
                            Promise.all(results.map(function(result, i) {
                                if ($dc332a6010e2a7ab$var$isRedirectHandlerResult(result)) {
                                    var response = result.result;
                                    // Throw redirects and let the server handle them with an HTTP redirect
                                    throw $dc332a6010e2a7ab$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
                                }
                                if ($dc332a6010e2a7ab$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
                                // directly without unwrapping
                                throw result;
                                return $dc332a6010e2a7ab$var$convertHandlerResultToDataResult(result);
                            }))
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return _callDataStrategy.apply(this, arguments);
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $dc332a6010e2a7ab$export$fec11da027c70692(routes, context, error) {
    var newContext = $dc332a6010e2a7ab$var$_extends({}, context, {
        statusCode: $dc332a6010e2a7ab$export$972111febbeef05b(error) ? error.status : 500,
        errors: (0, $hD5pT._)({}, context._deepestRenderedBoundaryId || routes[0].id, error)
    });
    return newContext;
}
function $dc332a6010e2a7ab$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    var method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $dc332a6010e2a7ab$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $dc332a6010e2a7ab$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    var path = $dc332a6010e2a7ab$export$cae722b0cc860f13(to ? to : ".", $dc332a6010e2a7ab$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $dc332a6010e2a7ab$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$dc332a6010e2a7ab$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $dc332a6010e2a7ab$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $dc332a6010e2a7ab$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $dc332a6010e2a7ab$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$dc332a6010e2a7ab$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$dc332a6010e2a7ab$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $dc332a6010e2a7ab$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $dc332a6010e2a7ab$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    // Create a Submission on non-GET navigations
    var rawFormMethod = opts.formMethod || "get";
    var formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    var formAction = $dc332a6010e2a7ab$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$dc332a6010e2a7ab$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce(function(acc, _ref5) {
                var _$_ref5 = (0, $kB67t._)(_ref5, 2), name = _$_ref5[0], value = _$_ref5[1];
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$dc332a6010e2a7ab$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $dc332a6010e2a7ab$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $dc332a6010e2a7ab$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $dc332a6010e2a7ab$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $dc332a6010e2a7ab$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $dc332a6010e2a7ab$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = $dc332a6010e2a7ab$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $dc332a6010e2a7ab$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $dc332a6010e2a7ab$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $dc332a6010e2a7ab$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $dc332a6010e2a7ab$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    var actionResult = pendingActionResult ? $dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingActionResult && $dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    var boundaryMatches = boundaryId ? $dc332a6010e2a7ab$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    var shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        var route = match.route;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($dc332a6010e2a7ab$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return $dc332a6010e2a7ab$var$shouldRevalidateLoader(match, $dc332a6010e2a7ab$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $dc332a6010e2a7ab$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || deletedFetchers.has(key)) return;
        var fetcherMatches = $dc332a6010e2a7ab$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        var fetcher = state.fetchers.get(key);
        var fetcherMatch = $dc332a6010e2a7ab$var$getTargetMatch(fetcherMatches, f.path);
        var shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $dc332a6010e2a7ab$var$shouldRevalidateLoader(fetcherMatch, $dc332a6010e2a7ab$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $dc332a6010e2a7ab$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $dc332a6010e2a7ab$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $dc332a6010e2a7ab$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $dc332a6010e2a7ab$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    return $dc332a6010e2a7ab$var$_loadLazyRouteChildren.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_loadLazyRouteChildren() {
    $dc332a6010e2a7ab$var$_loadLazyRouteChildren = /**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ (0, $7k5I8._)(function(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
        var key, pending;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    key = [
                        path
                    ].concat((0, $2Xzd1._)(matches.map(function(m) {
                        return m.route.id;
                    }))).join("-");
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        ,
                        4,
                        5
                    ]);
                    pending = pendingRouteChildren.get(key);
                    if (!pending) {
                        pending = patchRoutesOnMissImpl({
                            path: path,
                            matches: matches,
                            patch: function(routeId, children) {
                                if (!signal.aborted) $dc332a6010e2a7ab$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                            }
                        });
                        pendingRouteChildren.set(key, pending);
                    }
                    if (!(pending && $dc332a6010e2a7ab$var$isPromise(pending))) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        pending
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        3,
                        5
                    ];
                case 4:
                    pendingRouteChildren.delete(key);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_loadLazyRouteChildren.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route_children;
        var _route$children;
        var route = manifest[routeId];
        $dc332a6010e2a7ab$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        var dataChildren = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) (_route_children = route.children).push.apply(_route_children, (0, $2Xzd1._)(dataChildren));
        else route.children = dataChildren;
    } else {
        var _routesToUse;
        var dataChildren1 = $dc332a6010e2a7ab$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        (_routesToUse = routesToUse).push.apply(_routesToUse, (0, $2Xzd1._)(dataChildren1));
    }
}
function $dc332a6010e2a7ab$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return $dc332a6010e2a7ab$var$_loadLazyRouteModule.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_loadLazyRouteModule() {
    $dc332a6010e2a7ab$var$_loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, $7k5I8._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // If the lazy route function was executed and removed by another parallel
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    $dc332a6010e2a7ab$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
                    // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        $dc332a6010e2a7ab$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
                        if (!isPropertyStaticallyDefined && !$dc332a6010e2a7ab$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    }
                    // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates);
                    // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, $dc332a6010e2a7ab$var$_extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_loadLazyRouteModule.apply(this, arguments);
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $dc332a6010e2a7ab$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map(function(m) {
        return m.resolve();
    }));
}
function $dc332a6010e2a7ab$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    return $dc332a6010e2a7ab$var$_callDataStrategyImpl.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_callDataStrategyImpl() {
    $dc332a6010e2a7ab$var$_callDataStrategyImpl = (0, $7k5I8._)(function(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
        var routeIdsToLoad, loadedMatches, results;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeIdsToLoad = matchesToLoad.reduce(function(acc, m) {
                        return acc.add(m.route.id);
                    }, new Set());
                    loadedMatches = new Set();
                    return [
                        4,
                        dataStrategyImpl({
                            matches: matches.map(function(match) {
                                var shouldLoad = routeIdsToLoad.has(match.route.id);
                                // `resolve` encapsulates the route.lazy, executing the
                                // loader/action, and mapping return values/thrown errors to a
                                // HandlerResult.  Users can pass a callback to take fine-grained control
                                // over the execution of the loader/action
                                var resolve = function(handlerOverride) {
                                    loadedMatches.add(match.route.id);
                                    return shouldLoad ? $dc332a6010e2a7ab$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                                        type: $dc332a6010e2a7ab$var$ResultType.data,
                                        result: undefined
                                    });
                                };
                                return $dc332a6010e2a7ab$var$_extends({}, match, {
                                    shouldLoad: shouldLoad,
                                    resolve: resolve
                                });
                            }),
                            request: request,
                            params: matches[0].params,
                            context: requestContext
                        })
                    ];
                case 1:
                    results = _state.sent();
                    // Throw if any loadRoute implementations not called since they are what
                    // ensures a route is fully loaded
                    matches.forEach(function(m) {
                        return $dc332a6010e2a7ab$export$3e9cee6b33872309(loadedMatches.has(m.route.id), "`match.resolve()` was not called for route id \"" + m.route.id + "\". " + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded.");
                    });
                    // Filter out any middleware-only matches for which we didn't need to run handlers
                    return [
                        2,
                        results.filter(function(_, i) {
                            return routeIdsToLoad.has(matches[i].route.id);
                        })
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_callDataStrategyImpl.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    return $dc332a6010e2a7ab$var$_callLoaderOrAction.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_callLoaderOrAction() {
    $dc332a6010e2a7ab$var$_callLoaderOrAction = // Default logic for calling a loader/action is the user has no specified a dataStrategy
    (0, $7k5I8._)(function(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
        var result, onReject, runHandler, handler, handlerError, _ref, value, url, pathname, url1, pathname1, e;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        // This will never resolve so safe to type it as Promise<HandlerResult> to
                        // satisfy the function return value
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    params: match.params,
                                    context: staticContext
                                }
                            ].concat((0, $2Xzd1._)(ctx !== undefined ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise;
                        if (handlerOverride) handlerPromise = handlerOverride(function(ctx) {
                            return actualHandler(ctx);
                        });
                        else handlerPromise = (0, $7k5I8._)(function() {
                            var val, e;
                            return (0, $lFlDF.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            actualHandler()
                                        ];
                                    case 1:
                                        val = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "data",
                                                result: val
                                            }
                                        ];
                                    case 2:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                type: "error",
                                                result: e
                                            }
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            // If the handler throws, don't let it immediately bubble out,
                            // since we need to let the lazy() execution finish so we know if this
                            // route has a boundary that can handle the error
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            $dc332a6010e2a7ab$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    _ref = (0, $kB67t._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== undefined) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        $dc332a6010e2a7ab$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still runs even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $dc332a6010e2a7ab$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            result: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw $dc332a6010e2a7ab$var$getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    $dc332a6010e2a7ab$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    // We should already be catching and converting normal handler executions to
                    // HandlerResults and returning them, so anything that throws here is an
                    // unexpected error we still need to wrap
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_callLoaderOrAction.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$convertHandlerResultToDataResult(handlerResult) {
    return $dc332a6010e2a7ab$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_convertHandlerResultToDataResult() {
    $dc332a6010e2a7ab$var$_convertHandlerResultToDataResult = (0, $7k5I8._)(function(handlerResult) {
        var result, type, status, data, contentType, e, _result$init, _result$init2;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = handlerResult.result, type = handlerResult.type, status = handlerResult.status;
                    if (!$dc332a6010e2a7ab$var$isResponse(result)) return [
                        3,
                        10
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        8,
                        ,
                        9
                    ]);
                    contentType = result.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        5
                    ];
                    if (!(result.body == null)) return [
                        3,
                        2
                    ];
                    data = null;
                    return [
                        3,
                        4
                    ];
                case 2:
                    return [
                        4,
                        result.json()
                    ];
                case 3:
                    data = _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        3,
                        7
                    ];
                case 5:
                    return [
                        4,
                        result.text()
                    ];
                case 6:
                    data = _state.sent();
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        9
                    ];
                case 8:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: e
                        }
                    ];
                case 9:
                    if (type === $dc332a6010e2a7ab$var$ResultType.error) return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: new $dc332a6010e2a7ab$export$6c6580e81da25755(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 10:
                    if (type === $dc332a6010e2a7ab$var$ResultType.error) return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.error,
                            error: result,
                            statusCode: $dc332a6010e2a7ab$export$972111febbeef05b(result) ? result.status : status
                        }
                    ];
                    if ($dc332a6010e2a7ab$export$fbcedacb60443473(result)) {
                        ;
                        return [
                            2,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            data: result,
                            statusCode: status
                        }
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_convertHandlerResultToDataResult.apply(this, arguments);
}
// Support relative routing in internal redirects
function $dc332a6010e2a7ab$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    var location = response.headers.get("Location");
    $dc332a6010e2a7ab$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$dc332a6010e2a7ab$var$ABSOLUTE_URL_REGEX.test(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = $dc332a6010e2a7ab$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $dc332a6010e2a7ab$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($dc332a6010e2a7ab$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        var normalizedLocation = location;
        var url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        var isSameBasename = $dc332a6010e2a7ab$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $dc332a6010e2a7ab$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($dc332a6010e2a7ab$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $dc332a6010e2a7ab$var$isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $dc332a6010e2a7ab$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $dc332a6010e2a7ab$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $dc332a6010e2a7ab$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $dc332a6010e2a7ab$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && $dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        $dc332a6010e2a7ab$export$3e9cee6b33872309(!$dc332a6010e2a7ab$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
            var error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                var boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $dc332a6010e2a7ab$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($dc332a6010e2a7ab$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = (0, $hD5pT._)({}, pendingActionResult[0], pendingError);
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $dc332a6010e2a7ab$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = $dc332a6010e2a7ab$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    ), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        $dc332a6010e2a7ab$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($dc332a6010e2a7ab$var$isErrorResult(result)) {
            var boundaryMatch = $dc332a6010e2a7ab$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $dc332a6010e2a7ab$var$_extends({}, errors, (0, $hD5pT._)({}, boundaryMatch.route.id, result.error));
            state.fetchers.delete(key);
        } else if ($dc332a6010e2a7ab$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $dc332a6010e2a7ab$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($dc332a6010e2a7ab$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $dc332a6010e2a7ab$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = $dc332a6010e2a7ab$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $dc332a6010e2a7ab$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = $dc332a6010e2a7ab$var$_extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function $dc332a6010e2a7ab$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $dc332a6010e2a7ab$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: (0, $hD5pT._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $dc332a6010e2a7ab$var$findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $2Xzd1._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function $dc332a6010e2a7ab$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $dc332a6010e2a7ab$var$getInternalRouterError(status, _temp5) {
    var _ref = _temp5 === void 0 ? {} : _temp5, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = "Unable to match URL \"" + pathname + "\" - the `children()` function for " + ("route `" + routeId + "` threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $dc332a6010e2a7ab$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $dc332a6010e2a7ab$var$findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if ($dc332a6010e2a7ab$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $dc332a6010e2a7ab$var$stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(path) : path;
    return $dc332a6010e2a7ab$export$fe53371bee54353d($dc332a6010e2a7ab$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $dc332a6010e2a7ab$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $dc332a6010e2a7ab$var$isPromise(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val)) === "object" && val != null && "then" in val;
}
function $dc332a6010e2a7ab$var$isHandlerResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) === "object" && "type" in result && "result" in result && (result.type === $dc332a6010e2a7ab$var$ResultType.data || result.type === $dc332a6010e2a7ab$var$ResultType.error);
}
function $dc332a6010e2a7ab$var$isRedirectHandlerResult(result) {
    return $dc332a6010e2a7ab$var$isResponse(result.result) && $dc332a6010e2a7ab$var$redirectStatusCodes.has(result.result.status);
}
function $dc332a6010e2a7ab$var$isDeferredResult(result) {
    return result.type === $dc332a6010e2a7ab$var$ResultType.deferred;
}
function $dc332a6010e2a7ab$var$isErrorResult(result) {
    return result.type === $dc332a6010e2a7ab$var$ResultType.error;
}
function $dc332a6010e2a7ab$var$isRedirectResult(result) {
    return (result && result.type) === $dc332a6010e2a7ab$var$ResultType.redirect;
}
function $dc332a6010e2a7ab$export$fbcedacb60443473(value) {
    var deferred = value;
    return deferred && (typeof deferred === "undefined" ? "undefined" : (0, $YtE9h._)(deferred)) === "object" && (0, $YtE9h._)(deferred.data) === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $dc332a6010e2a7ab$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $YtE9h._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function $dc332a6010e2a7ab$var$isRedirectResponse(result) {
    if (!$dc332a6010e2a7ab$var$isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $dc332a6010e2a7ab$var$isValidMethod(method) {
    return $dc332a6010e2a7ab$var$validRequestMethods.has(method.toLowerCase());
}
function $dc332a6010e2a7ab$var$isMutationMethod(method) {
    return $dc332a6010e2a7ab$var$validMutationMethods.has(method.toLowerCase());
}
function $dc332a6010e2a7ab$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return $dc332a6010e2a7ab$var$_resolveDeferredResults.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_resolveDeferredResults() {
    $dc332a6010e2a7ab$var$_resolveDeferredResults = (0, $7k5I8._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, $lFlDF.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index];
                                    // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !$dc332a6010e2a7ab$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!($dc332a6010e2a7ab$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    $dc332a6010e2a7ab$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        $dc332a6010e2a7ab$var$resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, $lFlDF.__values)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_resolveDeferredResults.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$resolveDeferredData(result, signal, unwrap) {
    return $dc332a6010e2a7ab$var$_resolveDeferredData.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$_resolveDeferredData() {
    $dc332a6010e2a7ab$var$_resolveDeferredData = (0, $7k5I8._)(function(result, signal, unwrap) {
        var aborted;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: $dc332a6010e2a7ab$var$ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: $dc332a6010e2a7ab$var$ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return $dc332a6010e2a7ab$var$_resolveDeferredData.apply(this, arguments);
}
function $dc332a6010e2a7ab$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $dc332a6010e2a7ab$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? $dc332a6010e2a7ab$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $dc332a6010e2a7ab$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = $dc332a6010e2a7ab$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $dc332a6010e2a7ab$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $dc332a6010e2a7ab$var$getLoadingNavigation(location, submission) {
    if (submission) {
        var navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        var navigation1 = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation1;
    }
}
function $dc332a6010e2a7ab$var$getSubmittingNavigation(location, submission) {
    var navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $dc332a6010e2a7ab$var$getLoadingFetcher(submission, data) {
    if (submission) {
        var fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        var fetcher1 = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher1;
    }
}
function $dc332a6010e2a7ab$var$getSubmittingFetcher(submission, existingFetcher) {
    var fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $dc332a6010e2a7ab$var$getDoneFetcher(data) {
    var fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $dc332a6010e2a7ab$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($dc332a6010e2a7ab$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $dc332a6010e2a7ab$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $kB67t._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $2Xzd1._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($dc332a6010e2a7ab$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $dc332a6010e2a7ab$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.24.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $fIwXP = parcelRequire("fIwXP");

function $9e36fd5982483bee$var$_extends() {
    $9e36fd5982483bee$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9e36fd5982483bee$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
var $9e36fd5982483bee$export$3add0d5dce533e2e = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$145dfa71566a64dc = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$var$AwaitContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ var $9e36fd5982483bee$export$26749e8557646306 = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$c7914228fb69b0f5 = /*#__PURE__*/ $fIwXP.createContext(null);
var $9e36fd5982483bee$export$9072aa6dd1f93057 = /*#__PURE__*/ $fIwXP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var $9e36fd5982483bee$var$RouteErrorContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $9e36fd5982483bee$export$b66bb29c5006f12f(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = $9e36fd5982483bee$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $9e36fd5982483bee$export$9c954a9d03d32f4a() {
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $9e36fd5982483bee$export$45d76561a5302f2b() {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $9e36fd5982483bee$export$1b3f31771c5d07c() {
    return $fIwXP.useContext($9e36fd5982483bee$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $9e36fd5982483bee$export$6c330e8992e8a295(pattern) {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var pathname = $9e36fd5982483bee$export$45d76561a5302f2b().pathname;
    return $fIwXP.useMemo(function() {
        return (0, $dc332a6010e2a7ab$export$81336c211d5ff295)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var $9e36fd5982483bee$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $9e36fd5982483bee$var$useIsomorphicLayoutEffect(cb) {
    var isStatic = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fIwXP.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $9e36fd5982483bee$export$9770f232ac06a008() {
    var isDataRoute = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).isDataRoute;
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $9e36fd5982483bee$var$useNavigateStable() : $9e36fd5982483bee$var$useNavigateUnstable();
}
function $9e36fd5982483bee$var$useNavigateUnstable() {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var dataRouterContext = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), basename = _React_useContext.basename, future = _React_useContext.future, navigator = _React_useContext.navigator;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $dc332a6010e2a7ab$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    var activeRef = $fIwXP.useRef(false);
    $9e36fd5982483bee$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $dc332a6010e2a7ab$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $9e36fd5982483bee$var$OutletContext = /*#__PURE__*/ $fIwXP.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $9e36fd5982483bee$export$4138103a3ae699cc() {
    return $fIwXP.useContext($9e36fd5982483bee$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $9e36fd5982483bee$export$a3be3530d8e40d0b(context) {
    var outlet = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $9e36fd5982483bee$export$99eaa27ddbbb95ef() {
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $9e36fd5982483bee$export$e75d2a2d1b3c245b(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var future = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).future;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $dc332a6010e2a7ab$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $fIwXP.useMemo(function() {
        return (0, $dc332a6010e2a7ab$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $9e36fd5982483bee$export$5d3fca4a98652595(routes, locationArg) {
    return $9e36fd5982483bee$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $9e36fd5982483bee$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var navigator = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306).navigator;
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = $9e36fd5982483bee$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $dc332a6010e2a7ab$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        var segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    var matches = (0, $dc332a6010e2a7ab$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $9e36fd5982483bee$var$_renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $9e36fd5982483bee$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $dc332a6010e2a7ab$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $9e36fd5982483bee$var$DefaultErrorComponent() {
    var error = $9e36fd5982483bee$export$ed527bf60f6e05f2();
    var message = (0, $dc332a6010e2a7ab$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $fIwXP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $fIwXP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $9e36fd5982483bee$var$defaultErrorElement = /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$DefaultErrorComponent, null);
var $9e36fd5982483bee$var$RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(RenderErrorBoundary, _React_Component);
    function RenderErrorBoundary(props) {
        (0, $bB0zn._)(this, RenderErrorBoundary);
        var _this;
        _this = (0, $3Gvhd._)(this, RenderErrorBoundary, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $6QEWP._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error !== undefined ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$9072aa6dd1f93057.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error !== undefined ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}($fIwXP.Component);
function $9e36fd5982483bee$var$RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $9e36fd5982483bee$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined;
        });
        !(errorIndex >= 0) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(var i = 0; i < renderedMatches.length; i++){
        var match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
            var needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors1 || errors1[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        // Only data routers handle errors/fallbacks
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $9e36fd5982483bee$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $9e36fd5982483bee$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $fIwXP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $9e36fd5982483bee$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($9e36fd5982483bee$var$DataRouterHook || {});
var $9e36fd5982483bee$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($9e36fd5982483bee$var$DataRouterStateHook || {});
function $9e36fd5982483bee$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $9e36fd5982483bee$var$useDataRouterContext(hookName) {
    var ctx = $fIwXP.useContext($9e36fd5982483bee$export$3add0d5dce533e2e);
    !ctx && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return ctx;
}
function $9e36fd5982483bee$var$useDataRouterState(hookName) {
    var state = $fIwXP.useContext($9e36fd5982483bee$export$145dfa71566a64dc);
    !state && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return state;
}
function $9e36fd5982483bee$var$useRouteContext(hookName) {
    var route = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057);
    !route && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $9e36fd5982483bee$var$useCurrentRouteId(hookName) {
    var route = $9e36fd5982483bee$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $9e36fd5982483bee$export$5fc8298006ad9e58() {
    return $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $9e36fd5982483bee$export$d0fd4b7106de2769() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $9e36fd5982483bee$export$600dc272ed516c15() {
    var dataRouterContext = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseRevalidator);
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRevalidator);
    return $fIwXP.useMemo(function() {
        return {
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        };
    }, [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $9e36fd5982483bee$export$2378eb7f5ff86053() {
    var _useDataRouterState = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $fIwXP.useMemo(function() {
        return matches.map(function(m) {
            return (0, $dc332a6010e2a7ab$export$b3fac024fad9e8ff)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $9e36fd5982483bee$export$1448a5050d252c4d() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $9e36fd5982483bee$export$fd5d37484eab868d(routeId) {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $9e36fd5982483bee$export$fdc00f3f26066d5e() {
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseActionData);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $9e36fd5982483bee$export$ed527bf60f6e05f2() {
    var _state$errors;
    var error = $fIwXP.useContext($9e36fd5982483bee$var$RouteErrorContext);
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseRouteError);
    var routeId = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $9e36fd5982483bee$export$78a72ddb39bdd145() {
    var value = $fIwXP.useContext($9e36fd5982483bee$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $9e36fd5982483bee$export$17f53340677d5831() {
    var value = $fIwXP.useContext($9e36fd5982483bee$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
var $9e36fd5982483bee$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $9e36fd5982483bee$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseBlocker), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $9e36fd5982483bee$var$useDataRouterState($9e36fd5982483bee$var$DataRouterStateHook.UseBlocker);
    var _React_useState = (0, $kB67t._)($fIwXP.useState(""), 2), blockerKey = _React_useState[0], setBlockerKey = _React_useState[1];
    var blockerFunction = $fIwXP.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: $9e36fd5982483bee$var$_extends({}, currentLocation, {
                pathname: (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $9e36fd5982483bee$var$_extends({}, nextLocation, {
                pathname: (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $fIwXP.useEffect(function() {
        var key = String(++$9e36fd5982483bee$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $fIwXP.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $dc332a6010e2a7ab$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $9e36fd5982483bee$var$useNavigateStable() {
    var router = $9e36fd5982483bee$var$useDataRouterContext($9e36fd5982483bee$var$DataRouterHook.UseNavigateStable).router;
    var id = $9e36fd5982483bee$var$useCurrentRouteId($9e36fd5982483bee$var$DataRouterStateHook.UseNavigateStable);
    var activeRef = $fIwXP.useRef(false);
    $9e36fd5982483bee$var$useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = $fIwXP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $9e36fd5982483bee$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var $9e36fd5982483bee$var$alreadyWarned = {};
function $9e36fd5982483bee$var$warningOnce(key, cond, message) {
    if (!cond && !$9e36fd5982483bee$var$alreadyWarned[key]) $9e36fd5982483bee$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $9e36fd5982483bee$var$START_TRANSITION = "startTransition";
var $9e36fd5982483bee$var$startTransitionImpl = $fIwXP[$9e36fd5982483bee$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9e36fd5982483bee$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $kB67t._)($fIwXP.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        if (v7_startTransition && $9e36fd5982483bee$var$startTransitionImpl) $9e36fd5982483bee$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        });
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fIwXP.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $fIwXP.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $fIwXP.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $fIwXP.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $9e36fd5982483bee$var$DataRoutes(_ref2) {
    var routes = _ref2.routes, future = _ref2.future, state = _ref2.state;
    return $9e36fd5982483bee$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $9e36fd5982483bee$export$ae46f04cfaffe093(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex, future = _ref3.future;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dc332a6010e2a7ab$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $9e36fd5982483bee$var$startTransitionImpl ? $9e36fd5982483bee$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $9e36fd5982483bee$export$444b3ab0cb9aec40(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var _React_useContext = $fIwXP.useContext($9e36fd5982483bee$export$26749e8557646306), future = _React_useContext.future, isStatic = _React_useContext.static;
    var matches = $fIwXP.useContext($9e36fd5982483bee$export$9072aa6dd1f93057).matches;
    var _useLocation = $9e36fd5982483bee$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var navigate = $9e36fd5982483bee$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, $dc332a6010e2a7ab$export$cae722b0cc860f13)(to, (0, $dc332a6010e2a7ab$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    $fIwXP.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $9e36fd5982483bee$export$910ae8079b2c2852(props) {
    return $9e36fd5982483bee$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $9e36fd5982483bee$export$e7b0ac011bb776c6(_props) {
    (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $9e36fd5982483bee$export$55185c17a0fcbe46(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, $dc332a6010e2a7ab$export$e19cd5f9376f8cee).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1, future = _ref5.future;
    !!$9e36fd5982483bee$export$9c954a9d03d32f4a() && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $fIwXP.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $9e36fd5982483bee$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        };
    }, [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $dc332a6010e2a7ab$export$8ccf933b0513f8d0)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = $fIwXP.useMemo(function() {
        var trailingPathname = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $9e36fd5982483bee$export$3565eb3d00ca5a74(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return $9e36fd5982483bee$export$5d3fca4a98652595($9e36fd5982483bee$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $9e36fd5982483bee$export$6ddabde395c8c576(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$ResolveAwait, null, children));
}
var $9e36fd5982483bee$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($9e36fd5982483bee$var$AwaitRenderStatus || {});
var $9e36fd5982483bee$var$neverSettledPromise = new Promise(function() {});
var $9e36fd5982483bee$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $5dLwP._)(AwaitErrorBoundary, _React_Component);
    function AwaitErrorBoundary(props) {
        (0, $bB0zn._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $3Gvhd._)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $6QEWP._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = "_error" in promise ? $9e36fd5982483bee$var$AwaitRenderStatus.error : "_data" in promise ? $9e36fd5982483bee$var$AwaitRenderStatus.success : $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = $9e36fd5982483bee$var$AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error && promise._error instanceof (0, $dc332a6010e2a7ab$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
                throw $9e36fd5982483bee$var$neverSettledPromise;
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === $9e36fd5982483bee$var$AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ $fIwXP.createElement($9e36fd5982483bee$var$AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($fIwXP.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $9e36fd5982483bee$var$ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = $9e36fd5982483bee$export$78a72ddb39bdd145();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $9e36fd5982483bee$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    $fIwXP.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ $fIwXP.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, $2Xzd1._)(parentPath).concat([
            index
        ]);
        if (element.type === $fIwXP.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $9e36fd5982483bee$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $9e36fd5982483bee$export$e7b0ac011bb776c6) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $9e36fd5982483bee$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $9e36fd5982483bee$export$daf73786167a7f72(matches) {
    return $9e36fd5982483bee$var$_renderMatches(matches);
}
function $9e36fd5982483bee$export$52b333d321859367(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $fIwXP.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $fIwXP.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $fIwXP.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $9e36fd5982483bee$export$f30f7e456d254e83(routes, opts) {
    return (0, $dc332a6010e2a7ab$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9e36fd5982483bee$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dc332a6010e2a7ab$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $9e36fd5982483bee$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}



function $76a326218c469af1$var$_extends() {
    $76a326218c469af1$var$_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $76a326218c469af1$var$_extends.apply(this, arguments);
}
function $76a326218c469af1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $76a326218c469af1$var$defaultMethod = "get";
var $76a326218c469af1$var$defaultEncType = "application/x-www-form-urlencoded";
function $76a326218c469af1$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $76a326218c469af1$var$isButtonElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $76a326218c469af1$var$isFormElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $76a326218c469af1$var$isInputElement(object) {
    return $76a326218c469af1$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $76a326218c469af1$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $76a326218c469af1$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$76a326218c469af1$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $76a326218c469af1$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $76a326218c469af1$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = $76a326218c469af1$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
var $76a326218c469af1$var$_formDataSupportsSubmitter = null;
function $76a326218c469af1$var$isFormDataSubmitterSupported() {
    if ($76a326218c469af1$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $76a326218c469af1$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $76a326218c469af1$var$_formDataSupportsSubmitter = true;
    }
    return $76a326218c469af1$var$_formDataSupportsSubmitter;
}
var $76a326218c469af1$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $76a326218c469af1$var$getFormEncType(encType) {
    if (encType != null && !$76a326218c469af1$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $76a326218c469af1$var$getFormSubmissionInfo(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($76a326218c469af1$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr = target.getAttribute("action");
        action = attr ? (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $76a326218c469af1$var$defaultMethod;
        encType = $76a326218c469af1$var$getFormEncType(target.getAttribute("enctype")) || $76a326218c469af1$var$defaultEncType;
        formData = new FormData(target);
    } else if ($76a326218c469af1$var$isButtonElement(target) || $76a326218c469af1$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $76a326218c469af1$var$defaultMethod;
        encType = $76a326218c469af1$var$getFormEncType(target.getAttribute("formenctype")) || $76a326218c469af1$var$getFormEncType(form.getAttribute("enctype")) || $76a326218c469af1$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$76a326218c469af1$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($76a326218c469af1$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $76a326218c469af1$var$defaultMethod;
        action = null;
        encType = $76a326218c469af1$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
var $76a326218c469af1$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $76a326218c469af1$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $76a326218c469af1$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
var $76a326218c469af1$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $76a326218c469af1$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $76a326218c469af1$export$1f3f55432a00e06d(routes, opts) {
    return (0, $dc332a6010e2a7ab$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76a326218c469af1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dc332a6010e2a7ab$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76a326218c469af1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9e36fd5982483bee$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76a326218c469af1$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $dc332a6010e2a7ab$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $76a326218c469af1$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dc332a6010e2a7ab$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $76a326218c469af1$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $9e36fd5982483bee$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $76a326218c469af1$var$parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $76a326218c469af1$var$_extends({}, state, {
        errors: $76a326218c469af1$var$deserializeErrors(state.errors)
    });
    return state;
}
function $76a326218c469af1$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $dc332a6010e2a7ab$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
                if (val.__subType) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        // @ts-expect-error
                        var error = new ErrorConstructor(val.message);
                        // Wipe away the client-side stack trace.  Nothing to fill it in with
                        // because we don't serialize SSR stack traces for security reasons
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {
                    // no-op - fall through and create a normal Error
                    }
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
var $76a326218c469af1$export$7ad602f0e94e62d1 = /*#__PURE__*/ $fIwXP.createContext({
    isTransitioning: false
});
var $76a326218c469af1$export$148fd98d095596d4 = /*#__PURE__*/ $fIwXP.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ var $76a326218c469af1$var$START_TRANSITION = "startTransition";
var $76a326218c469af1$var$startTransitionImpl = $fIwXP[$76a326218c469af1$var$START_TRANSITION];
var $76a326218c469af1$var$FLUSH_SYNC = "flushSync";
var $76a326218c469af1$var$flushSyncImpl = $9F3H4[$76a326218c469af1$var$FLUSH_SYNC];
var $76a326218c469af1$var$USE_ID = "useId";
var $76a326218c469af1$var$useIdImpl = $fIwXP[$76a326218c469af1$var$USE_ID];
function $76a326218c469af1$var$startTransitionSafe(cb) {
    if ($76a326218c469af1$var$startTransitionImpl) $76a326218c469af1$var$startTransitionImpl(cb);
    else cb();
}
function $76a326218c469af1$var$flushSyncSafe(cb) {
    if ($76a326218c469af1$var$flushSyncImpl) $76a326218c469af1$var$flushSyncImpl(cb);
    else cb();
}
var $76a326218c469af1$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $bB0zn._)(this, Deferred);
    this.status = "pending";
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $76a326218c469af1$export$323e4fc2fa4753fb(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router, future = _ref.future;
    var _React_useState = (0, $kB67t._)($fIwXP.useState(router.state), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var _React_useState1 = (0, $kB67t._)($fIwXP.useState(), 2), pendingState = _React_useState1[0], setPendingState = _React_useState1[1];
    var _React_useState2 = (0, $kB67t._)($fIwXP.useState({
        isTransitioning: false
    }), 2), vtContext = _React_useState2[0], setVtContext = _React_useState2[1];
    var _React_useState3 = (0, $kB67t._)($fIwXP.useState(), 2), renderDfd = _React_useState3[0], setRenderDfd = _React_useState3[1];
    var _React_useState4 = (0, $kB67t._)($fIwXP.useState(), 2), transition = _React_useState4[0], setTransition = _React_useState4[1];
    var _React_useState5 = (0, $kB67t._)($fIwXP.useState(), 2), interruption = _React_useState5[0], setInterruption = _React_useState5[1];
    var fetcherData = $fIwXP.useRef(new Map());
    var v7_startTransition = (future || {}).v7_startTransition;
    var optInStartTransition = $fIwXP.useCallback(function(cb) {
        if (v7_startTransition) $76a326218c469af1$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    var setState = $fIwXP.useCallback(function(newState, _ref2) {
        var deletedFetchers = _ref2.deletedFetchers, flushSync = _ref2.unstable_flushSync, viewTransitionOpts = _ref2.unstable_viewTransitionOpts;
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        var isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $76a326218c469af1$var$flushSyncSafe(function() {
                return setStateImpl(newState);
            });
            else optInStartTransition(function() {
                return setStateImpl(newState);
            });
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $76a326218c469af1$var$flushSyncSafe(function() {
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            var t = router.window.document.startViewTransition(function() {
                $76a326218c469af1$var$flushSyncSafe(function() {
                    return setStateImpl(newState);
                });
            });
            // Clean up after the animation completes
            t.finished.finally(function() {
                $76a326218c469af1$var$flushSyncSafe(function() {
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $76a326218c469af1$var$flushSyncSafe(function() {
                return setTransition(t);
            });
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fIwXP.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $fIwXP.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $76a326218c469af1$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(/*#__PURE__*/ (0, $7k5I8._)(function() {
                return (0, $lFlDF.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            optInStartTransition(function() {
                                return setStateImpl(newState);
                            });
                            return [
                                4,
                                renderPromise
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }));
            transition.finished.finally(function() {
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $fIwXP.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $fIwXP.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $fIwXP.useEffect(function() {
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var navigator = $fIwXP.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $fIwXP.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        };
    }, [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fIwXP.createElement($fIwXP.Fragment, null, /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $76a326218c469af1$var$DataRoutes(_ref3) {
    var routes = _ref3.routes, future = _ref3.future, state = _ref3.state;
    return (0, $9e36fd5982483bee$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $76a326218c469af1$export$9ba4e89fdfa1fc54(_ref4) {
    var basename = _ref4.basename, children = _ref4.children, future = _ref4.future, _$window = _ref4.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dc332a6010e2a7ab$export$719fc203c4e16dee)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $76a326218c469af1$export$7221d69dcfc8e36b(_ref5) {
    var basename = _ref5.basename, children = _ref5.children, future = _ref5.future, _$window = _ref5.window;
    var historyRef = $fIwXP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dc332a6010e2a7ab$export$b71fdd3798280242)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $76a326218c469af1$export$eefb0c834599897e(_ref6) {
    var basename = _ref6.basename, children = _ref6.children, future = _ref6.future, history = _ref6.history;
    var _React_useState = (0, $kB67t._)($fIwXP.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setStateImpl = _React_useState[1];
    var v7_startTransition = (future || {}).v7_startTransition;
    var setState = $fIwXP.useCallback(function(newState) {
        v7_startTransition && $76a326218c469af1$var$startTransitionImpl ? $76a326218c469af1$var$startTransitionImpl(function() {
            return setStateImpl(newState);
        }) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fIwXP.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fIwXP.createElement((0, $9e36fd5982483bee$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
var $76a326218c469af1$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var $76a326218c469af1$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ var $76a326218c469af1$export$a6c7ac8248d6e38a = /*#__PURE__*/ $fIwXP.forwardRef(function LinkWithRef(_ref7, ref) {
    var onClick = _ref7.onClick, relative = _ref7.relative, reloadDocument = _ref7.reloadDocument, replace = _ref7.replace, state = _ref7.state, target = _ref7.target, to = _ref7.to, preventScrollReset = _ref7.preventScrollReset, unstable_viewTransition = _ref7.unstable_viewTransition, rest = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref7, $76a326218c469af1$var$_excluded);
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && $76a326218c469af1$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($76a326218c469af1$var$isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    var href = (0, $9e36fd5982483bee$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var internalOnClick = $76a326218c469af1$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $fIwXP.createElement("a", $76a326218c469af1$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ var $76a326218c469af1$export$b0d92dbee9b5b60d = /*#__PURE__*/ $fIwXP.forwardRef(function NavLinkWithRef(_ref8, ref) {
    var tmp = _ref8["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref8_caseSensitive = _ref8.caseSensitive, caseSensitive = _ref8_caseSensitive === void 0 ? false : _ref8_caseSensitive, tmp1 = _ref8.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref8_end = _ref8.end, end = _ref8_end === void 0 ? false : _ref8_end, styleProp = _ref8.style, to = _ref8.to, unstable_viewTransition = _ref8.unstable_viewTransition, children = _ref8.children, rest = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref8, $76a326218c469af1$var$_excluded2);
    var path = (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var routerState = $fIwXP.useContext((0, $9e36fd5982483bee$export$145dfa71566a64dc));
    var _React_useContext = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)), navigator = _React_useContext.navigator, basename = _React_useContext.basename;
    var isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $76a326218c469af1$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$a6c7ac8248d6e38a, $76a326218c469af1$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var $76a326218c469af1$export$a7fed597f4b8afd8 = /*#__PURE__*/ $fIwXP.forwardRef(function(_ref9, forwardedRef) {
    var fetcherKey = _ref9.fetcherKey, navigate = _ref9.navigate, reloadDocument = _ref9.reloadDocument, replace = _ref9.replace, state = _ref9.state, _ref9_method = _ref9.method, method = _ref9_method === void 0 ? $76a326218c469af1$var$defaultMethod : _ref9_method, action = _ref9.action, onSubmit = _ref9.onSubmit, relative = _ref9.relative, preventScrollReset = _ref9.preventScrollReset, unstable_viewTransition = _ref9.unstable_viewTransition, props = $76a326218c469af1$var$_objectWithoutPropertiesLoose(_ref9, $76a326218c469af1$var$_excluded3);
    var submit = $76a326218c469af1$export$47c85c6e3a081d3();
    var formAction = $76a326218c469af1$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $fIwXP.createElement("form", $76a326218c469af1$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $76a326218c469af1$export$11aac1aab828f1fa(_ref10) {
    var getKey = _ref10.getKey, storageKey = _ref10.storageKey;
    $76a326218c469af1$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $76a326218c469af1$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($76a326218c469af1$var$DataRouterHook || ($76a326218c469af1$var$DataRouterHook = {}));
var $76a326218c469af1$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($76a326218c469af1$var$DataRouterStateHook || ($76a326218c469af1$var$DataRouterStateHook = {}));
// Internal hooks
function $76a326218c469af1$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $76a326218c469af1$var$useDataRouterContext(hookName) {
    var ctx = $fIwXP.useContext((0, $9e36fd5982483bee$export$3add0d5dce533e2e));
    !ctx && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return ctx;
}
function $76a326218c469af1$var$useDataRouterState(hookName) {
    var state = $fIwXP.useContext((0, $9e36fd5982483bee$export$145dfa71566a64dc));
    !state && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $76a326218c469af1$export$67621102c14d847(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, unstable_viewTransition = _ref.unstable_viewTransition;
    var navigate = (0, $9e36fd5982483bee$export$9770f232ac06a008)();
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var path = (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $fIwXP.useCallback(function(event) {
        if ($76a326218c469af1$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, $dc332a6010e2a7ab$export$fe53371bee54353d)(location) === (0, $dc332a6010e2a7ab$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $76a326218c469af1$export$f1a78c17382fe22a(defaultInit) {
    var defaultSearchParamsRef = $fIwXP.useRef($76a326218c469af1$export$a2e4e2dcc7b1f22f(defaultInit));
    var hasSetSearchParamsRef = $fIwXP.useRef(false);
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var searchParams = $fIwXP.useMemo(function() {
        return(// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $76a326218c469af1$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, $9e36fd5982483bee$export$9770f232ac06a008)();
    var setSearchParams = $fIwXP.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = $76a326218c469af1$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $76a326218c469af1$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
var $76a326218c469af1$var$fetcherId = 0;
var $76a326218c469af1$var$getUniqueFetcherId = function() {
    return "__" + String(++$76a326218c469af1$var$fetcherId) + "__";
};
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $76a326218c469af1$export$47c85c6e3a081d3() {
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseSubmit).router;
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    var currentRouteId = (0, $9e36fd5982483bee$export$5fc8298006ad9e58)();
    return $fIwXP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $76a326218c469af1$var$validateClientSideSubmission();
        var _getFormSubmissionInfo = $76a326218c469af1$var$getFormSubmissionInfo(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
        if (options.navigate === false) {
            var key = options.fetcherKey || $76a326218c469af1$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $76a326218c469af1$export$89a6bd6db0d97c56(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    var routeContext = $fIwXP.useContext((0, $9e36fd5982483bee$export$9072aa6dd1f93057));
    !routeContext && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var _routeContext_matches_slice = (0, $kB67t._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = $76a326218c469af1$var$_extends({}, (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        var params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dc332a6010e2a7ab$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $dc332a6010e2a7ab$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $76a326218c469af1$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    var key = (_temp3 === void 0 ? {} : _temp3).key;
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseFetcher).router;
    var state = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseFetcher);
    var fetcherData = $fIwXP.useContext($76a326218c469af1$export$148fd98d095596d4);
    var route = $fIwXP.useContext((0, $9e36fd5982483bee$export$9072aa6dd1f93057));
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    !route && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var defaultKey = $76a326218c469af1$var$useIdImpl ? $76a326218c469af1$var$useIdImpl() : "";
    var _React_useState = (0, $kB67t._)($fIwXP.useState(key || defaultKey), 2), fetcherKey = _React_useState[0], setFetcherKey = _React_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($76a326218c469af1$var$getUniqueFetcherId());
    // Registration/cleanup
    $fIwXP.useEffect(function() {
        router.getFetcher(fetcherKey);
        return function() {
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    var load = $fIwXP.useCallback(function(href, opts) {
        !routeId && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    var submitImpl = $76a326218c469af1$export$47c85c6e3a081d3();
    var submit = $fIwXP.useCallback(function(target, opts) {
        submitImpl(target, $76a326218c469af1$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    var FetcherForm = $fIwXP.useMemo(function() {
        var FetcherForm = /*#__PURE__*/ $fIwXP.forwardRef(function(props, ref) {
            return /*#__PURE__*/ $fIwXP.createElement($76a326218c469af1$export$a7fed597f4b8afd8, $76a326218c469af1$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    var fetcher = state.fetchers.get(fetcherKey) || (0, $dc332a6010e2a7ab$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    var fetcherWithComponents = $fIwXP.useMemo(function() {
        return $76a326218c469af1$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $76a326218c469af1$export$fa996778a3a31087() {
    var state = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map(function(_ref11) {
        var _$_ref11 = (0, $kB67t._)(_ref11, 2), key = _$_ref11[0], fetcher = _$_ref11[1];
        return $76a326218c469af1$var$_extends({}, fetcher, {
            key: key
        });
    });
}
var $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $76a326218c469af1$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $76a326218c469af1$export$25057cfe5591e3e9(_temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = $76a326218c469af1$var$useDataRouterState($76a326218c469af1$var$DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $fIwXP.useContext((0, $9e36fd5982483bee$export$26749e8557646306)).basename;
    var location = (0, $9e36fd5982483bee$export$45d76561a5302f2b)();
    var matches = (0, $9e36fd5982483bee$export$2378eb7f5ff86053)();
    var navigation = (0, $9e36fd5982483bee$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $fIwXP.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $76a326218c469af1$var$usePageHide($fIwXP.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            $76a326218c469af1$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($76a326218c469af1$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $76a326218c469af1$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $76a326218c469af1$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            var getKeyWithoutBasename = getKey && basename !== "/" ? function(location, matches) {
                return getKey($76a326218c469af1$var$_extends({}, location, {
                    pathname: (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches);
            } : getKey;
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($76a326218c469af1$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKeyWithoutBasename);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fIwXP.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76a326218c469af1$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $76a326218c469af1$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $fIwXP.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $76a326218c469af1$export$39f4eb3dbd812741(_ref12) {
    var when = _ref12.when, message = _ref12.message;
    var blocker = (0, $9e36fd5982483bee$export$b273b3273281a049)(when);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $fIwXP.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $76a326218c469af1$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    var vtContext = $fIwXP.useContext($76a326218c469af1$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $dc332a6010e2a7ab$export$3e9cee6b33872309)(false);
    var basename = $76a326218c469af1$var$useDataRouterContext($76a326218c469af1$var$DataRouterHook.useViewTransitionState).basename;
    var path = (0, $9e36fd5982483bee$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $dc332a6010e2a7ab$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $dc332a6010e2a7ab$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $dc332a6010e2a7ab$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $kB67t = parcelRequire("kB67t");

var $fIwXP = parcelRequire("fIwXP");
var $3c7428cbea0d9bb7$var$useOnlineStatus = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), onlineStatus = _useState[0], setOnlineStatus = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        window.addEventListener("offline", function() {
            setOnlineStatus(false);
        });
        window.addEventListener("online", function() {
            setOnlineStatus(true);
        });
    }, []);
    // boolean value
    return onlineStatus;
};
var $3c7428cbea0d9bb7$export$2e2bcd8739ae039 = $3c7428cbea0d9bb7$var$useOnlineStatus;



var $hD5pT = parcelRequire("hD5pT");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fIwXP = parcelRequire("fIwXP");
var $6dda7e3f4bfdb607$exports = {};
'use strict';

$6dda7e3f4bfdb607$exports = (parcelRequire("gHY9J"));


var $c7b80bd183211e5d$var$__defProp = Object.defineProperty;
var $c7b80bd183211e5d$var$__defProps = Object.defineProperties;
var $c7b80bd183211e5d$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $c7b80bd183211e5d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c7b80bd183211e5d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c7b80bd183211e5d$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $c7b80bd183211e5d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $c7b80bd183211e5d$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($c7b80bd183211e5d$var$__hasOwnProp.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($c7b80bd183211e5d$var$__propIsEnum.call(b, prop)) $c7b80bd183211e5d$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $c7b80bd183211e5d$var$__spreadProps = function(a, b) {
    return $c7b80bd183211e5d$var$__defProps(a, $c7b80bd183211e5d$var$__getOwnPropDescs(b));
};
var $c7b80bd183211e5d$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($c7b80bd183211e5d$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $c7b80bd183211e5d$var$__getOwnPropSymbols) try {
        for(var _iterator = $c7b80bd183211e5d$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $c7b80bd183211e5d$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $c7b80bd183211e5d$var$React = // prettier-ignore
// @ts-ignore
"default" in $fIwXP ? $fIwXP["default"] : $fIwXP;
// src/components/Context.ts
var $c7b80bd183211e5d$var$ContextKey = Symbol.for("react-redux-context");
var $c7b80bd183211e5d$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $c7b80bd183211e5d$var$getContext() {
    var _a;
    if (!$c7b80bd183211e5d$var$React.createContext) return {};
    var contextMap = (_a = $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey]) != null ? _a : $c7b80bd183211e5d$var$gT[$c7b80bd183211e5d$var$ContextKey] = /* @__PURE__ */ new Map();
    var realContext = contextMap.get($c7b80bd183211e5d$var$React.createContext);
    if (!realContext) {
        realContext = $c7b80bd183211e5d$var$React.createContext(null);
        contextMap.set($c7b80bd183211e5d$var$React.createContext, realContext);
    }
    return realContext;
}
var $c7b80bd183211e5d$export$cc80c08dc91f1c00 = /* @__PURE__ */ $c7b80bd183211e5d$var$getContext();
// src/utils/useSyncExternalStore.ts
var $c7b80bd183211e5d$var$notInitialized = function() {
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $c7b80bd183211e5d$var$createReduxContextHook() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return function useReduxContext2() {
        var contextValue = $c7b80bd183211e5d$var$React.useContext(context);
        return contextValue;
    };
}
var $c7b80bd183211e5d$var$useReduxContext = /* @__PURE__ */ $c7b80bd183211e5d$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $c7b80bd183211e5d$var$useSyncExternalStoreWithSelector = $c7b80bd183211e5d$var$notInitialized;
var $c7b80bd183211e5d$var$initializeUseSelector = function(fn) {
    $c7b80bd183211e5d$var$useSyncExternalStoreWithSelector = fn;
};
var $c7b80bd183211e5d$var$refEquality = function(a, b) {
    return a === b;
};
function $c7b80bd183211e5d$export$2b53f90d2bd1cbfb() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useSelector2 = function(selector) {
        var equalityFnOrOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _ref = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions, _ref_equalityFn = _ref.equalityFn, equalityFn = _ref_equalityFn === void 0 ? $c7b80bd183211e5d$var$refEquality : _ref_equalityFn, _ref_devModeChecks = _ref.devModeChecks, devModeChecks = _ref_devModeChecks === void 0 ? {} : _ref_devModeChecks;
        var _useReduxContext2 = useReduxContext2(), store = _useReduxContext2.store, subscription = _useReduxContext2.subscription, getServerState = _useReduxContext2.getServerState, stabilityCheck = _useReduxContext2.stabilityCheck, identityFunctionCheck = _useReduxContext2.identityFunctionCheck;
        var firstRun = $c7b80bd183211e5d$var$React.useRef(true);
        var wrappedSelector = $c7b80bd183211e5d$var$React.useCallback((0, $hD5pT._)({}, selector.name, function(state) {
            var selected = selector(state);
            var e, e1;
            return selected;
        })[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        var selectedState = $c7b80bd183211e5d$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $c7b80bd183211e5d$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: function() {
            return useSelector2;
        }
    });
    return useSelector2;
}
var $c7b80bd183211e5d$export$2105062e25df4afe = /* @__PURE__ */ $c7b80bd183211e5d$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $c7b80bd183211e5d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $c7b80bd183211e5d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $c7b80bd183211e5d$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $c7b80bd183211e5d$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $c7b80bd183211e5d$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $c7b80bd183211e5d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $c7b80bd183211e5d$var$ForwardRef = $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE;
var $c7b80bd183211e5d$var$Memo = $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
function $c7b80bd183211e5d$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE || type === $c7b80bd183211e5d$var$REACT_PROFILER_TYPE || type === $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE || type === $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE || type === $c7b80bd183211e5d$var$REACT_OFFSCREEN_TYPE) return true;
    if ((typeof type === "undefined" ? "undefined" : (0, $YtE9h._)(type)) === "object" && type !== null) {
        if (type.$$typeof === $c7b80bd183211e5d$var$REACT_LAZY_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_MEMO_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_PROVIDER_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE || type.$$typeof === $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $c7b80bd183211e5d$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $c7b80bd183211e5d$var$typeOf(object) {
    if ((typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) === "object" && object !== null) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $c7b80bd183211e5d$var$REACT_ELEMENT_TYPE:
                {
                    var type = object.type;
                    switch(type){
                        case $c7b80bd183211e5d$var$REACT_FRAGMENT_TYPE:
                        case $c7b80bd183211e5d$var$REACT_PROFILER_TYPE:
                        case $c7b80bd183211e5d$var$REACT_STRICT_MODE_TYPE:
                        case $c7b80bd183211e5d$var$REACT_SUSPENSE_TYPE:
                        case $c7b80bd183211e5d$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                var $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $c7b80bd183211e5d$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_FORWARD_REF_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_LAZY_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_MEMO_TYPE:
                                    case $c7b80bd183211e5d$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $c7b80bd183211e5d$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $c7b80bd183211e5d$var$isContextConsumer(object) {
    return $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_CONTEXT_TYPE;
}
function $c7b80bd183211e5d$var$isMemo(object) {
    return $c7b80bd183211e5d$var$typeOf(object) === $c7b80bd183211e5d$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $c7b80bd183211e5d$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $c7b80bd183211e5d$var$verify(selector, methodName) {
    if (!selector) throw new Error("Unexpected value for ".concat(methodName, " in connect."));
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $c7b80bd183211e5d$var$warning("The selector for ".concat(methodName, " of connect did not specify a value for dependsOnOwnProps."));
    }
}
function $c7b80bd183211e5d$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $c7b80bd183211e5d$var$verify(mapStateToProps, "mapStateToProps");
    $c7b80bd183211e5d$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $c7b80bd183211e5d$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, param) {
    var areStatesEqual = param.areStatesEqual, areOwnPropsEqual = param.areOwnPropsEqual, areStatePropsEqual = param.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $c7b80bd183211e5d$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, initMapStateToProps = _b.initMapStateToProps, initMapDispatchToProps = _b.initMapDispatchToProps, initMergeProps = _b.initMergeProps, options = $c7b80bd183211e5d$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    return $c7b80bd183211e5d$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $c7b80bd183211e5d$var$bindActionCreators(actionCreators, dispatch) {
    var _loop = function(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return dispatch(actionCreator.apply(void 0, (0, $2Xzd1._)(args)));
        };
    };
    var boundActionCreators = {};
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $c7b80bd183211e5d$var$isPlainObject(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $YtE9h._)(obj)) !== "object" || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $c7b80bd183211e5d$var$verifyPlainObject(value, displayName, methodName) {
    if (!$c7b80bd183211e5d$var$isPlainObject(value)) $c7b80bd183211e5d$var$warning("".concat(methodName, "() in ").concat(displayName, " must return a plain object. Instead received ").concat(value, "."));
}
// src/connect/wrapMapToProps.ts
function $c7b80bd183211e5d$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        var constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, param) {
        var displayName = param.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $c7b80bd183211e5d$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $c7b80bd183211e5d$var$createInvalidArgFactory(arg, name) {
    return function(dispatch, options) {
        throw new Error("Invalid value of type ".concat(typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg), " for ").concat(name, " argument when connecting component ").concat(options.wrappedComponentName, "."));
    };
}
// src/connect/mapDispatchToProps.ts
function $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && (typeof mapDispatchToProps === "undefined" ? "undefined" : (0, $YtE9h._)(mapDispatchToProps)) === "object" ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return(// @ts-ignore
        $c7b80bd183211e5d$var$bindActionCreators(mapDispatchToProps, dispatch));
    }) : !mapDispatchToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $c7b80bd183211e5d$var$wrapMapToPropsConstant(function() {
        return {};
    }) : typeof mapStateToProps === "function" ? // @ts-ignore
    $c7b80bd183211e5d$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $c7b80bd183211e5d$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $c7b80bd183211e5d$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues($c7b80bd183211e5d$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, param) {
        var displayName = param.displayName, areMergedPropsEqual = param.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $c7b80bd183211e5d$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? function() {
        return $c7b80bd183211e5d$var$defaultMergeProps;
    } : typeof mergeProps === "function" ? $c7b80bd183211e5d$var$wrapMergePropsFunc(mergeProps) : $c7b80bd183211e5d$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $c7b80bd183211e5d$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $c7b80bd183211e5d$var$createListenerCollection() {
    var first = null;
    var last = null;
    return {
        clear: function() {
            first = null;
            last = null;
        },
        notify: function() {
            $c7b80bd183211e5d$var$defaultNoopBatch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $c7b80bd183211e5d$var$nullListeners = {
    notify: function() {},
    get: function() {
        return [];
    }
};
function $c7b80bd183211e5d$var$createSubscription(store, parentSub) {
    var unsubscribe;
    var listeners = $c7b80bd183211e5d$var$nullListeners;
    var subscriptionsAmount = 0;
    var selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        var cleanupListener = listeners.subscribe(listener);
        var removed = false;
        return function() {
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $c7b80bd183211e5d$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $c7b80bd183211e5d$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: function() {
            return listeners;
        }
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $c7b80bd183211e5d$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $c7b80bd183211e5d$var$isReactNative = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $c7b80bd183211e5d$var$useIsomorphicLayoutEffect = $c7b80bd183211e5d$var$canUseDOM || $c7b80bd183211e5d$var$isReactNative ? $c7b80bd183211e5d$var$React.useLayoutEffect : $c7b80bd183211e5d$var$React.useEffect;
// src/utils/shallowEqual.ts
function $c7b80bd183211e5d$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $c7b80bd183211e5d$export$d36bdfa510afb180(objA, objB) {
    if ($c7b80bd183211e5d$var$is(objA, objB)) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $YtE9h._)(objA)) !== "object" || objA === null || (typeof objB === "undefined" ? "undefined" : (0, $YtE9h._)(objB)) !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$c7b80bd183211e5d$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $c7b80bd183211e5d$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $c7b80bd183211e5d$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $c7b80bd183211e5d$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $c7b80bd183211e5d$var$_obj;
var $c7b80bd183211e5d$var$TYPE_STATICS = ($c7b80bd183211e5d$var$_obj = {}, (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$ForwardRef, $c7b80bd183211e5d$var$FORWARD_REF_STATICS), (0, $hD5pT._)($c7b80bd183211e5d$var$_obj, $c7b80bd183211e5d$var$Memo, $c7b80bd183211e5d$var$MEMO_STATICS), $c7b80bd183211e5d$var$_obj);
function $c7b80bd183211e5d$var$getStatics(component) {
    if ($c7b80bd183211e5d$var$isMemo(component)) return $c7b80bd183211e5d$var$MEMO_STATICS;
    return $c7b80bd183211e5d$var$TYPE_STATICS[component["$$typeof"]] || $c7b80bd183211e5d$var$REACT_STATICS;
}
var $c7b80bd183211e5d$var$defineProperty = Object.defineProperty;
var $c7b80bd183211e5d$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $c7b80bd183211e5d$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $c7b80bd183211e5d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $c7b80bd183211e5d$var$getPrototypeOf = Object.getPrototypeOf;
var $c7b80bd183211e5d$var$objectPrototype = Object.prototype;
function $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($c7b80bd183211e5d$var$objectPrototype) {
            var inheritedComponent = $c7b80bd183211e5d$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $c7b80bd183211e5d$var$objectPrototype) $c7b80bd183211e5d$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        var keys = $c7b80bd183211e5d$var$getOwnPropertyNames(sourceComponent);
        if ($c7b80bd183211e5d$var$getOwnPropertySymbols) keys = keys.concat($c7b80bd183211e5d$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $c7b80bd183211e5d$var$getStatics(targetComponent);
        var sourceStatics = $c7b80bd183211e5d$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$c7b80bd183211e5d$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $c7b80bd183211e5d$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $c7b80bd183211e5d$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $c7b80bd183211e5d$var$useSyncExternalStore = $c7b80bd183211e5d$var$notInitialized;
var $c7b80bd183211e5d$var$initializeConnect = function(fn) {
    $c7b80bd183211e5d$var$useSyncExternalStore = fn;
};
var $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $c7b80bd183211e5d$var$stringifyComponent = function(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        return effectFunc.apply(void 0, (0, $2Xzd1._)(effectArgs));
    }, dependencies);
}
function $c7b80bd183211e5d$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return function() {};
    var didUnsubscribe = false;
    var lastThrownError = null;
    var checkForUpdates = function() {
        if (didUnsubscribe || !isMounted.current) return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    var unsubscribeWrapper = function() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $c7b80bd183211e5d$var$strictEqual(a, b) {
    return a === b;
}
var $c7b80bd183211e5d$var$hasWarnedAboutDeprecatedPureOption = false;
function $c7b80bd183211e5d$var$connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
    // @ts-ignore
    pure = _ref.pure, _ref_areStatesEqual = _ref.areStatesEqual, areStatesEqual = _ref_areStatesEqual === void 0 ? $c7b80bd183211e5d$var$strictEqual : _ref_areStatesEqual, _ref_areOwnPropsEqual = _ref.areOwnPropsEqual, areOwnPropsEqual = _ref_areOwnPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areOwnPropsEqual, _ref_areStatePropsEqual = _ref.areStatePropsEqual, areStatePropsEqual = _ref_areStatePropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areStatePropsEqual, _ref_areMergedPropsEqual = _ref.areMergedPropsEqual, areMergedPropsEqual = _ref_areMergedPropsEqual === void 0 ? $c7b80bd183211e5d$export$d36bdfa510afb180 : _ref_areMergedPropsEqual, _ref_forwardRef = _ref.// use React's forwardRef to expose a ref of the wrapped component
    forwardRef, forwardRef = _ref_forwardRef === void 0 ? false : _ref_forwardRef, _ref_context = _ref.// the context consumer to use
    context, context = _ref_context === void 0 ? $c7b80bd183211e5d$export$cc80c08dc91f1c00 : _ref_context;
    var Context = context;
    var initMapStateToProps = $c7b80bd183211e5d$var$mapStateToPropsFactory(mapStateToProps);
    var initMapDispatchToProps = $c7b80bd183211e5d$var$mapDispatchToPropsFactory(mapDispatchToProps);
    var initMergeProps = $c7b80bd183211e5d$var$mergePropsFactory(mergeProps);
    var shouldHandleStateChanges = Boolean(mapStateToProps);
    var wrapWithConnect = function(WrappedComponent) {
        var ConnectFunction = function ConnectFunction(props) {
            var _React_useMemo = (0, $kB67t._)($c7b80bd183211e5d$var$React.useMemo(function() {
                var _a = props, reactReduxForwardedRef2 = _a.reactReduxForwardedRef, wrapperProps2 = $c7b80bd183211e5d$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]), 3), propsContext = _React_useMemo[0], reactReduxForwardedRef = _React_useMemo[1], wrapperProps = _React_useMemo[2];
            var ContextToUse = $c7b80bd183211e5d$var$React.useMemo(function() {
                var ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            var contextValue = $c7b80bd183211e5d$var$React.useContext(ContextToUse);
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            var childPropsSelector = $c7b80bd183211e5d$var$React.useMemo(function() {
                return $c7b80bd183211e5d$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            var _React_useMemo1 = (0, $kB67t._)($c7b80bd183211e5d$var$React.useMemo(function() {
                if (!shouldHandleStateChanges) return $c7b80bd183211e5d$var$NO_SUBSCRIPTION_ARRAY;
                var subscription2 = $c7b80bd183211e5d$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                var notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), 2), subscription = _React_useMemo1[0], notifyNestedSubs = _React_useMemo1[1];
            var overriddenContextValue = $c7b80bd183211e5d$var$React.useMemo(function() {
                if (didStoreComeFromProps) return contextValue;
                return $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            var lastChildProps = $c7b80bd183211e5d$var$React.useRef(void 0);
            var lastWrapperProps = $c7b80bd183211e5d$var$React.useRef(wrapperProps);
            var childPropsFromStoreUpdate = $c7b80bd183211e5d$var$React.useRef(void 0);
            var renderIsScheduled = $c7b80bd183211e5d$var$React.useRef(false);
            var isMounted = $c7b80bd183211e5d$var$React.useRef(false);
            var latestSubscriptionCallbackError = $c7b80bd183211e5d$var$React.useRef(void 0);
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                isMounted.current = true;
                return function() {
                    isMounted.current = false;
                };
            }, []);
            var actualChildPropsSelector = $c7b80bd183211e5d$var$React.useMemo(function() {
                var selector = function() {
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            var subscribeForReact = $c7b80bd183211e5d$var$React.useMemo(function() {
                var subscribe = function(reactListener) {
                    if (!subscription) return function() {};
                    return $c7b80bd183211e5d$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffectWithArgs($c7b80bd183211e5d$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            var actualChildProps;
            try {
                actualChildProps = $c7b80bd183211e5d$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? function() {
                    return childPropsSelector(getServerState(), wrapperProps);
                } : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n".concat(latestSubscriptionCallbackError.current.stack, "\n\n");
                throw err;
            }
            $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            var renderedWrappedComponent = $c7b80bd183211e5d$var$React.useMemo(function() {
                return(// @ts-ignore
                /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(WrappedComponent, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            var renderedChild = $c7b80bd183211e5d$var$React.useMemo(function() {
                if (shouldHandleStateChanges) return /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        };
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        var displayName = "Connect(".concat(wrappedComponentName, ")");
        var selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            // @ts-ignore
            initMapStateToProps: initMapStateToProps,
            // @ts-ignore
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        var _Connect = $c7b80bd183211e5d$var$React.memo(ConnectFunction);
        var Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var _forwarded = $c7b80bd183211e5d$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(Connect, $c7b80bd183211e5d$var$__spreadProps($c7b80bd183211e5d$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            var forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $c7b80bd183211e5d$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $c7b80bd183211e5d$export$64605811ab45167f = $c7b80bd183211e5d$var$connect;
// src/components/Provider.tsx
function $c7b80bd183211e5d$var$Provider(param) {
    var store = param.store, context = param.context, children = param.children, serverState = param.serverState, _param_stabilityCheck = param.stabilityCheck, stabilityCheck = _param_stabilityCheck === void 0 ? "once" : _param_stabilityCheck, _param_identityFunctionCheck = param.identityFunctionCheck, identityFunctionCheck = _param_identityFunctionCheck === void 0 ? "once" : _param_identityFunctionCheck;
    var contextValue = $c7b80bd183211e5d$var$React.useMemo(function() {
        var subscription = $c7b80bd183211e5d$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? function() {
                return serverState;
            } : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    var previousState = $c7b80bd183211e5d$var$React.useMemo(function() {
        return store.getState();
    }, [
        store
    ]);
    $c7b80bd183211e5d$var$useIsomorphicLayoutEffect(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $c7b80bd183211e5d$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $c7b80bd183211e5d$export$2881499e37b75b9a = $c7b80bd183211e5d$var$Provider;
// src/hooks/useStore.ts
function $c7b80bd183211e5d$export$671dba69185d0304() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useReduxContext2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$var$useReduxContext : // @ts-ignore
    $c7b80bd183211e5d$var$createReduxContextHook(context);
    var useStore2 = function() {
        var store = useReduxContext2().store;
        return store;
    };
    Object.assign(useStore2, {
        withTypes: function() {
            return useStore2;
        }
    });
    return useStore2;
}
var $c7b80bd183211e5d$export$6ccbb43953eebf8 = /* @__PURE__ */ $c7b80bd183211e5d$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $c7b80bd183211e5d$export$bc9b55530897c558() {
    var context = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c7b80bd183211e5d$export$cc80c08dc91f1c00;
    var useStore2 = context === $c7b80bd183211e5d$export$cc80c08dc91f1c00 ? $c7b80bd183211e5d$export$6ccbb43953eebf8 : $c7b80bd183211e5d$export$671dba69185d0304(context);
    var useDispatch2 = function() {
        var store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: function() {
            return useDispatch2;
        }
    });
    return useDispatch2;
}
var $c7b80bd183211e5d$export$8ad76b76a4c905f8 = /* @__PURE__ */ $c7b80bd183211e5d$export$bc9b55530897c558();
// src/exports.ts
var $c7b80bd183211e5d$export$712ea50be43a7858 = $c7b80bd183211e5d$var$defaultNoopBatch;
// src/index.ts
$c7b80bd183211e5d$var$initializeUseSelector((0, $6dda7e3f4bfdb607$exports.useSyncExternalStoreWithSelector));
$c7b80bd183211e5d$var$initializeConnect($fIwXP.useSyncExternalStore);


var $f310bc4ea983f747$var$Header = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)("Sign In"), 2), auth = _useState[0], setAuth = _useState[1];
    var onlineStatus = (0, $3c7428cbea0d9bb7$export$2e2bcd8739ae039)();
    // const { loggedInUser } = useContext(UserContext);
    var cartItems = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart.items;
    });
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "header flex justify-between items-center px-40 py-4",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("svg", {
                            className: "_8pSp-",
                            viewBox: "0 0 559 825",
                            height: "49",
                            width: "34",
                            fill: "#fc8019",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M542.92 388.542C546.805 366.526 542.355 349.598 530.881 340.76C513.621 327.466 487.698 320.236 425.954 320.236C380.271 320.236 331.225 320.286 310.268 320.275C308.322 319.894 301.285 317.604 301.02 309.112L300.734 174.289C300.727 165.779 307.531 158.857 315.943 158.839C324.369 158.825 331.204 165.723 331.211 174.226C331.211 174.226 331.421 247.414 331.441 273.424C331.441 275.936 332.892 281.8 338.549 283.328C375.43 293.267 561.865 285.999 558.967 251.804C543.147 109.96 424.476 0 280.394 0C235.021 0 192.065 10.9162 154.026 30.2754C62.9934 77.5955 -1.65904 173.107 0.0324268 283.43C1.23215 361.622 52.2203 500.605 83.434 521.234C97.8202 530.749 116.765 527.228 201.484 527.228C239.903 527.228 275.679 527.355 293.26 527.436C295.087 527.782 304.671 530.001 304.671 538.907L304.894 641.393C304.915 649.907 298.104 656.826 289.678 656.829C281.266 656.843 274.434 649.953 274.42 641.446C274.42 641.446 275.17 600.322 275.17 584.985C275.17 581.435 275.424 575.339 265.178 570.727C231.432 555.553 121.849 564.712 115.701 581.457C113.347 587.899 125.599 612.801 144.459 644.731C170.102 685.624 211.889 747.245 245.601 792.625C261.047 813.417 268.77 823.813 280.467 824.101C292.165 824.389 300.514 814.236 317.213 793.928C383.012 713.909 516.552 537.663 542.92 388.542Z",
                                    fill: "url(#paint0_linear_19447_66107)"
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsx)("defs", {
                                    children: /*#__PURE__*/ (0, $cc6u1.jsxs)("linearGradient", {
                                        id: "paint0_linear_19447_66107",
                                        x1: "445.629",
                                        y1: "63.8626",
                                        x2: "160.773",
                                        y2: "537.598",
                                        gradientUnits: "userSpaceOnUse",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("stop", {
                                                stopColor: "#FF993A"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("stop", {
                                                offset: "1",
                                                stopColor: "#F15700"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                        className: "flex items-center ml-7",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "location text-sm",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "font-bold text-[#3d4152] pb-1 border-b-2 border-b-black",
                                        children: "Other"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "px-2",
                                        children: "Indore, Madhya Pradesh, India"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-3",
                                src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSaaJAni_s_McqO7MEIhoa8mFXCDqWaO6Xupg&s",
                                alt: ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "flex items-center",
                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                    className: "flex",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "mr-2",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "0 0 20 20",
                                            height: "20",
                                            width: "20",
                                            fill: "none",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("rect", {
                                                    x: "2.46094",
                                                    y: "7.98145",
                                                    width: "15.0784",
                                                    height: "10.7765",
                                                    rx: "1.52523",
                                                    stroke: "#686b78",
                                                    fill: "none",
                                                    strokeWidth: "1.8",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                    d: "M6.17822 4.91866C6.17822 3.90782 6.99767 3.08838 8.0085 3.08838H11.9916C13.0024 3.08838 13.8219 3.90782 13.8219 4.91866V5.22965C13.8219 5.61625 13.5085 5.92965 13.1219 5.92965H6.87822C6.49162 5.92965 6.17822 5.61625 6.17822 5.22965V4.91866Z",
                                                    fill: "#686b78"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "text-gray-600 font-medium",
                                        children: "Swiggy Corporate"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/search",
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "mr-2",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "5 -1 12 25",
                                            height: "17",
                                            width: "17",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                d: "M17.6671481,17.1391632 L22.7253317,22.1973467 L20.9226784,24 L15.7041226,18.7814442 C14.1158488,19.8024478 12.225761,20.3946935 10.1973467,20.3946935 C4.56550765,20.3946935 0,15.8291858 0,10.1973467 C0,4.56550765 4.56550765,0 10.1973467,0 C15.8291858,0 20.3946935,4.56550765 20.3946935,10.1973467 C20.3946935,12.8789625 19.3595949,15.3188181 17.6671481,17.1391632 Z M10.1973467,17.8453568 C14.4212261,17.8453568 17.8453568,14.4212261 17.8453568,10.1973467 C17.8453568,5.97346742 14.4212261,2.54933669 10.1973467,2.54933669 C5.97346742,2.54933669 2.54933669,5.97346742 2.54933669,10.1973467 C2.54933669,14.4212261 5.97346742,17.8453568 10.1973467,17.8453568 Z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "text-gray-600 font-medium",
                                        children: "Search"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/",
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "mr-2",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "0 0 32 32",
                                            height: "19",
                                            width: "19",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                d: "M14.2 2.864l-1.899 1.38c-0.612 0.447-1.35 0.687-2.11 0.687h-2.352c-0.386 0-0.727 0.248-0.845 0.613l-0.728 2.238c-0.235 0.721-0.691 1.348-1.302 1.79l-1.905 1.385c-0.311 0.226-0.442 0.626-0.323 0.991l0.728 2.241c0.232 0.719 0.232 1.492-0.001 2.211l-0.727 2.237c-0.119 0.366 0.011 0.767 0.323 0.994l1.906 1.384c0.61 0.445 1.064 1.070 1.3 1.79l0.728 2.24c0.118 0.365 0.459 0.613 0.844 0.613h2.352c0.759 0 1.497 0.24 2.107 0.685l1.9 1.381c0.313 0.227 0.736 0.227 1.048 0.001l1.9-1.38c0.613-0.447 1.349-0.687 2.11-0.687h2.352c0.384 0 0.726-0.248 0.845-0.615l0.727-2.235c0.233-0.719 0.688-1.346 1.302-1.794l1.904-1.383c0.311-0.226 0.442-0.627 0.323-0.993l-0.728-2.239c-0.232-0.718-0.232-1.49 0.001-2.213l0.727-2.238c0.119-0.364-0.012-0.765-0.324-0.992l-1.901-1.383c-0.614-0.445-1.070-1.074-1.302-1.793l-0.727-2.236c-0.119-0.366-0.461-0.614-0.845-0.614h-2.352c-0.76 0-1.497-0.239-2.107-0.685l-1.903-1.382c-0.313-0.227-0.736-0.226-1.047-0.001zM16.829 0.683l1.907 1.385c0.151 0.11 0.331 0.168 0.521 0.168h2.352c1.551 0 2.927 1 3.408 2.475l0.728 2.241c0.057 0.177 0.169 0.332 0.321 0.442l1.902 1.383c1.258 0.912 1.784 2.531 1.304 4.006l-0.726 2.234c-0.058 0.182-0.058 0.375-0.001 0.552l0.727 2.237c0.48 1.477-0.046 3.096-1.303 4.007l-1.9 1.38c-0.153 0.112-0.266 0.268-0.324 0.447l-0.727 2.237c-0.48 1.477-1.856 2.477-3.408 2.477h-2.352c-0.19 0-0.37 0.058-0.523 0.17l-1.904 1.383c-1.256 0.911-2.956 0.911-4.213-0.001l-1.903-1.384c-0.15-0.11-0.332-0.168-0.521-0.168h-2.352c-1.554 0-2.931-1.001-3.408-2.477l-0.726-2.234c-0.059-0.18-0.173-0.338-0.324-0.448l-1.902-1.381c-1.258-0.912-1.784-2.53-1.304-4.008l0.727-2.235c0.058-0.179 0.058-0.373 0.001-0.551l-0.727-2.236c-0.481-1.476 0.046-3.095 1.302-4.006l1.905-1.385c0.151-0.11 0.264-0.265 0.323-0.444l0.727-2.235c0.478-1.476 1.855-2.477 3.408-2.477h2.352c0.189 0 0.371-0.059 0.523-0.17l1.902-1.383c1.256-0.911 2.956-0.911 4.212 0zM18.967 23.002c-1.907 0-3.453-1.546-3.453-3.453s1.546-3.453 3.453-3.453c1.907 0 3.453 1.546 3.453 3.453s-1.546 3.453-3.453 3.453zM18.967 20.307c0.419 0 0.758-0.339 0.758-0.758s-0.339-0.758-0.758-0.758c-0.419 0-0.758 0.339-0.758 0.758s0.339 0.758 0.758 0.758zM10.545 14.549c-1.907 0-3.453-1.546-3.453-3.453s1.546-3.453 3.453-3.453c1.907 0 3.453 1.546 3.453 3.453s-1.546 3.453-3.453 3.453zM10.545 11.855c0.419 0 0.758-0.339 0.758-0.758s-0.339-0.758-0.758-0.758c-0.419 0-0.758 0.339-0.758 0.758s0.339 0.758 0.758 0.758zM17.78 7.882l2.331 1.352-7.591 13.090-2.331-1.352 7.591-13.090z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "text-gray-600 font-medium",
                                        children: "Offers"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/",
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "mr-2",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "6 -1 12 25",
                                            height: "19",
                                            width: "19",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                d: "M21.966903,13.2244898 C22.0156989,12.8231523 22.0408163,12.4145094 22.0408163,12 C22.0408163,11.8357822 22.036874,11.6724851 22.029079,11.5101984 L17.8574333,11.5102041 C17.8707569,11.6717062 17.877551,11.8350597 17.877551,12 C17.877551,12.4199029 17.8335181,12.8295214 17.749818,13.2244898 L21.966903,13.2244898 Z M21.5255943,15.1836735 L16.9414724,15.1836735 C15.8950289,16.8045422 14.0728218,17.877551 12,17.877551 C9.92717823,17.877551 8.1049711,16.8045422 7.05852762,15.1836735 L2.47440565,15.1836735 C3.80564362,19.168549 7.56739481,22.0408163 12,22.0408163 C16.4326052,22.0408163 20.1943564,19.168549 21.5255943,15.1836735 Z M21.7400381,9.55102041 C20.6468384,5.18931674 16.7006382,1.95918367 12,1.95918367 C7.2993618,1.95918367 3.3531616,5.18931674 2.25996187,9.55102041 L6.6553883,9.55102041 C7.58404845,7.5276442 9.62792376,6.12244898 12,6.12244898 C14.3720762,6.12244898 16.4159515,7.5276442 17.3446117,9.55102041 L21.7400381,9.55102041 Z M2.03309705,13.2244898 L6.25018203,13.2244898 C6.16648186,12.8295214 6.12244898,12.4199029 6.12244898,12 C6.12244898,11.8350597 6.1292431,11.6717062 6.14256675,11.5102041 L1.97092075,11.5102041 C1.96312595,11.6724851 1.95918367,11.8357822 1.95918367,12 C1.95918367,12.4145094 1.98430112,12.8231523 2.03309705,13.2244898 Z M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M12,15.9183673 C14.1640545,15.9183673 15.9183673,14.1640545 15.9183673,12 C15.9183673,9.83594547 14.1640545,8.08163265 12,8.08163265 C9.83594547,8.08163265 8.08163265,9.83594547 8.08163265,12 C8.08163265,14.1640545 9.83594547,15.9183673 12,15.9183673 Z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "text-gray-600 font-medium",
                                        children: "Help"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            onClick: function() {
                                auth === "Sign In" ? setAuth("Sign Out") : setAuth("Sign In");
                            },
                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "mr-2",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                            className: "_1GTCc",
                                            viewBox: "6 0 12 24",
                                            height: "19",
                                            width: "18",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                d: "M11.9923172,11.2463768 C8.81761115,11.2463768 6.24400341,8.72878961 6.24400341,5.62318841 C6.24400341,2.5175872 8.81761115,0 11.9923172,0 C15.1670232,0 17.740631,2.5175872 17.740631,5.62318841 C17.740631,8.72878961 15.1670232,11.2463768 11.9923172,11.2463768 Z M11.9923172,9.27536232 C14.0542397,9.27536232 15.7257581,7.64022836 15.7257581,5.62318841 C15.7257581,3.60614845 14.0542397,1.97101449 11.9923172,1.97101449 C9.93039471,1.97101449 8.25887628,3.60614845 8.25887628,5.62318841 C8.25887628,7.64022836 9.93039471,9.27536232 11.9923172,9.27536232 Z M24,24 L0,24 L1.21786143,19.7101449 L2.38352552,15.6939891 C2.85911209,14.0398226 4.59284263,12.7536232 6.3530098,12.7536232 L17.6316246,12.7536232 C19.3874139,12.7536232 21.1256928,14.0404157 21.6011089,15.6939891 L22.9903494,20.5259906 C23.0204168,20.63057 23.0450458,20.7352884 23.0641579,20.8398867 L24,24 Z M21.1127477,21.3339312 L21.0851024,21.2122487 C21.0772161,21.1630075 21.0658093,21.1120821 21.0507301,21.0596341 L19.6614896,16.2276325 C19.4305871,15.4245164 18.4851476,14.7246377 17.6316246,14.7246377 L6.3530098,14.7246377 C5.4959645,14.7246377 4.55444948,15.4231177 4.32314478,16.2276325 L2.75521062,21.6811594 L2.65068631,22.0289855 L21.3185825,22.0289855 L21.1127477,21.3339312 Z"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "text-gray-600 font-medium",
                                        children: auth
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                to: "/cart",
                                className: "flex items-center",
                                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                    className: "cart",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                            className: "_3yZyp",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                                    className: "_1GTCc _2MSid",
                                                    viewBox: "-1 0 37 32",
                                                    height: "20",
                                                    width: "20",
                                                    fill: "#686b78",
                                                    children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                        d: "M4.438 0l-2.598 5.11-1.84 26.124h34.909l-1.906-26.124-2.597-5.11z"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                    className: "_2vS77",
                                                    children: cartItems.length
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            className: "ml-5 text-gray-600 font-medium",
                                            children: "Cart"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                            className: "px-4",
                            children: onlineStatus ? "\uD83D\uDFE2" : "\uD83D\uDD34"
                        })
                    ]
                })
            })
        ]
    });
};
var $f310bc4ea983f747$export$2e2bcd8739ae039 = $f310bc4ea983f747$var$Header;



var $7k5I8 = parcelRequire("7k5I8");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $cc6u1 = parcelRequire("cc6u1");
// import { useContext } from "react";

var $eRslx = parcelRequire("eRslx");

var $cc6u1 = parcelRequire("cc6u1");
var $cc25cc9a913d8a70$export$b0fd8bc2b1d75505 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_288,h_360/";
var $cc25cc9a913d8a70$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
var $cc25cc9a913d8a70$export$b058da059f56be67 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_292,h_300/";
var $cc25cc9a913d8a70$export$34d86598e19a5b29 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_112,h_112,c_fill/";
var $cc25cc9a913d8a70$export$c0d48a7117cc6549 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_208,h_208,c_fit/";
var $cc25cc9a913d8a70$export$8878ead86ed0da0b = "https://cdn.worldvectorlogo.com/logos/swiggy-1.svg";
var $cc25cc9a913d8a70$export$b77c1aa4fb57bd1c = "https://swiggy-backend-9o8y.onrender.com/api/menu?resId=";
var $cc25cc9a913d8a70$export$d468c44ae1fb41bb = "https://swiggy-backend-9o8y.onrender.com/api/cuisines";
var $cc25cc9a913d8a70$export$211d963c14780a03 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/";


// import UserContext from "../utils/UserContext";
var $d6e6ef2e667bbda8$var$RestaurantCard = function(props) {
    var resData = props.resData;
    // const { loggedInUser } = useContext(UserContext);
    var cloudinaryImageId = resData.cloudinaryImageId, aggregatedDiscountInfoV3 = resData.aggregatedDiscountInfoV3, name = resData.name, cuisines = resData.cuisines, avgRating = resData.avgRating, costForTwo = resData.costForTwo, sla = resData.sla, locality = resData.locality;
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "res-card my-2 mb-5 w-full",
        "data-testid": "resCard",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                        className: "res-img rounded-xl h-[170px] object-cover w-full",
                        src: (0, $cc25cc9a913d8a70$export$31adfacaf07ffe63) + cloudinaryImageId,
                        alt: "res-logo"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "res-img-overlay"
                    }),
                    aggregatedDiscountInfoV3 && /*#__PURE__*/ (0, $cc6u1.jsxs)("h1", {
                        className: "absolute bottom-2 left-3 text-xl font-black text-white",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                children: [
                                    aggregatedDiscountInfoV3 === null || aggregatedDiscountInfoV3 === void 0 ? void 0 : aggregatedDiscountInfoV3.header,
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                children: aggregatedDiscountInfoV3 === null || aggregatedDiscountInfoV3 === void 0 ? void 0 : aggregatedDiscountInfoV3.subHeader
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
                className: "res-name font-bold pt-2 text-lg",
                children: name
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("svg", {
                                className: "mr-1",
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                role: "img",
                                "aria-hidden": "true",
                                strokeColor: "rgba(2, 6, 12, 0.92)",
                                fillColor: "rgba(2, 6, 12, 0.92)",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("circle", {
                                        cx: "10",
                                        cy: "10",
                                        r: "9",
                                        fill: "url(#StoreRating20_svg__paint0_linear_32982_71567)"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                        d: "M10.0816 12.865C10.0312 12.8353 9.96876 12.8353 9.91839 12.865L7.31647 14.3968C6.93482 14.6214 6.47106 14.2757 6.57745 13.8458L7.27568 11.0245C7.29055 10.9644 7.26965 10.9012 7.22195 10.8618L4.95521 8.99028C4.60833 8.70388 4.78653 8.14085 5.23502 8.10619L8.23448 7.87442C8.29403 7.86982 8.34612 7.83261 8.36979 7.77777L9.54092 5.06385C9.71462 4.66132 10.2854 4.66132 10.4591 5.06385L11.6302 7.77777C11.6539 7.83261 11.706 7.86982 11.7655 7.87442L14.765 8.10619C15.2135 8.14085 15.3917 8.70388 15.0448 8.99028L12.7781 10.8618C12.7303 10.9012 12.7095 10.9644 12.7243 11.0245L13.4225 13.8458C13.5289 14.2757 13.0652 14.6214 12.6835 14.3968L10.0816 12.865Z",
                                        fill: "white"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("defs", {
                                        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("linearGradient", {
                                            id: "StoreRating20_svg__paint0_linear_32982_71567",
                                            x1: "10",
                                            y1: "1",
                                            x2: "10",
                                            y2: "19",
                                            gradientUnits: "userSpaceOnUse",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("stop", {
                                                    "stop-color": "#21973B"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("stop", {
                                                    offset: "1",
                                                    "stop-color": "#128540"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            avgRating
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                        className: "mx-1",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                        children: sla === null || sla === void 0 ? void 0 : sla.slaString
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                className: "light-card-info",
                children: cuisines.join(", ")
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                className: "light-card-info",
                children: locality
            })
        ]
    });
};
var $d6e6ef2e667bbda8$export$ccb02a230af14023 = function(RestaurantCard) {
    return function(props) {
        return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
            className: "relative promoted-card",
            children: [
                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "label",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                            className: "ribbion",
                            children: "Promoted"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                            className: "fold"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $cc6u1.jsx)(RestaurantCard, (0, $eRslx._)({}, props))
            ]
        });
    };
};
var $d6e6ef2e667bbda8$export$2e2bcd8739ae039 = $d6e6ef2e667bbda8$var$RestaurantCard;



var $cc6u1 = parcelRequire("cc6u1");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");
function $161d7c7c971d371f$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $YtE9h = parcelRequire("YtE9h");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $YtE9h = parcelRequire("YtE9h");
var $ef483e37d783a0b4$var$extendStatics = function extendStatics1(d, b) {
    $ef483e37d783a0b4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ef483e37d783a0b4$var$extendStatics(d, b);
};
function $ef483e37d783a0b4$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ef483e37d783a0b4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ef483e37d783a0b4$export$18ce0697a983be9b = function __assign1() {
    $ef483e37d783a0b4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ef483e37d783a0b4$export$18ce0697a983be9b.apply(this, arguments);
};
function $ef483e37d783a0b4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ef483e37d783a0b4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ef483e37d783a0b4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ef483e37d783a0b4$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ef483e37d783a0b4$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ef483e37d783a0b4$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $YtE9h._)(x)) === "symbol" ? x : "".concat(x);
}
function $ef483e37d783a0b4$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $YtE9h._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ef483e37d783a0b4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $YtE9h._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ef483e37d783a0b4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ef483e37d783a0b4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ef483e37d783a0b4$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ef483e37d783a0b4$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ef483e37d783a0b4$export$45d3717a4c69092e(o, m, p);
}
function $ef483e37d783a0b4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ef483e37d783a0b4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ef483e37d783a0b4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ef483e37d783a0b4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ef483e37d783a0b4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ef483e37d783a0b4$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ef483e37d783a0b4$export$10c90e4f7922046c(v) {
    return this instanceof $ef483e37d783a0b4$export$10c90e4f7922046c ? (this.v = v, this) : new $ef483e37d783a0b4$export$10c90e4f7922046c(v);
}
function $ef483e37d783a0b4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ef483e37d783a0b4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ef483e37d783a0b4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ef483e37d783a0b4$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ef483e37d783a0b4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ef483e37d783a0b4$export$19a8beecd37a4c45 === "function" ? $ef483e37d783a0b4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ef483e37d783a0b4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ef483e37d783a0b4$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $ef483e37d783a0b4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ef483e37d783a0b4$export$45d3717a4c69092e(result, mod, k);
    }
    $ef483e37d783a0b4$var$__setModuleDefault(result, mod);
    return result;
}
function $ef483e37d783a0b4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ef483e37d783a0b4$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ef483e37d783a0b4$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ef483e37d783a0b4$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $YtE9h._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ef483e37d783a0b4$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ef483e37d783a0b4$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ef483e37d783a0b4$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ef483e37d783a0b4$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $ef483e37d783a0b4$export$2e2bcd8739ae039 = {
    __extends: $ef483e37d783a0b4$export$a8ba968b8961cb8a,
    __assign: $ef483e37d783a0b4$export$18ce0697a983be9b,
    __rest: $ef483e37d783a0b4$export$3c9a16f847548506,
    __decorate: $ef483e37d783a0b4$export$29e00dfd3077644b,
    __param: $ef483e37d783a0b4$export$d5ad3fd78186038f,
    __metadata: $ef483e37d783a0b4$export$f1db080c865becb9,
    __awaiter: $ef483e37d783a0b4$export$1050f835b63b671e,
    __generator: $ef483e37d783a0b4$export$67ebef60e6f28a6,
    __createBinding: $ef483e37d783a0b4$export$45d3717a4c69092e,
    __exportStar: $ef483e37d783a0b4$export$f33643c0debef087,
    __values: $ef483e37d783a0b4$export$19a8beecd37a4c45,
    __read: $ef483e37d783a0b4$export$8d051b38c9118094,
    __spread: $ef483e37d783a0b4$export$afc72e2116322959,
    __spreadArrays: $ef483e37d783a0b4$export$6388937ca91ccae8,
    __spreadArray: $ef483e37d783a0b4$export$1216008129fb82ed,
    __await: $ef483e37d783a0b4$export$10c90e4f7922046c,
    __asyncGenerator: $ef483e37d783a0b4$export$e427f37a30a4de9b,
    __asyncDelegator: $ef483e37d783a0b4$export$bbd80228419bb833,
    __asyncValues: $ef483e37d783a0b4$export$e3b29a3d6162315f,
    __makeTemplateObject: $ef483e37d783a0b4$export$4fb47efe1390b86f,
    __importStar: $ef483e37d783a0b4$export$c21735bcef00d192,
    __importDefault: $ef483e37d783a0b4$export$da59b14a69baef04,
    __classPrivateFieldGet: $ef483e37d783a0b4$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ef483e37d783a0b4$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ef483e37d783a0b4$export$81fdc39f203e4e04,
    __addDisposableResource: $ef483e37d783a0b4$export$88ac25d8e944e405,
    __disposeResources: $ef483e37d783a0b4$export$8f076105dc360e92
};


function $c9ca11a1cbd5937a$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $bb656a8008f6ea00$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bb656a8008f6ea00$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $c9ca11a1cbd5937a$export$2e2bcd8739ae039)(function(prop) {
    return $bb656a8008f6ea00$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $fIwXP = parcelRequire("fIwXP");
var $361d31f2e4fa0271$exports = {};
//

var $YtE9h = parcelRequire("YtE9h");
$361d31f2e4fa0271$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if ((typeof objA === "undefined" ? "undefined" : (0, $YtE9h._)(objA)) !== "object" || !objA || (typeof objB === "undefined" ? "undefined" : (0, $YtE9h._)(objB)) !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


var $08bc5874c1d6603c$export$71ad59f2e432cfe8 = "-ms-";
var $08bc5874c1d6603c$export$2c0f367103c8d01c = "-moz-";
var $08bc5874c1d6603c$export$39dfd62a25e0fe93 = "-webkit-";
var $08bc5874c1d6603c$export$a29989082612d0d9 = "comm";
var $08bc5874c1d6603c$export$aa3a2e812ca8570d = "rule";
var $08bc5874c1d6603c$export$527d108ccf083c2b = "decl";
var $08bc5874c1d6603c$export$d3d35020fa5b54f0 = "@page";
var $08bc5874c1d6603c$export$500415a86c544f73 = "@media";
var $08bc5874c1d6603c$export$a763edbf796b780a = "@import";
var $08bc5874c1d6603c$export$2790aeb8b4e5c826 = "@charset";
var $08bc5874c1d6603c$export$1cc683e23b84b133 = "@viewport";
var $08bc5874c1d6603c$export$9447a5efea57e862 = "@supports";
var $08bc5874c1d6603c$export$ef011b4e114b1fba = "@document";
var $08bc5874c1d6603c$export$6aad947bda0f3f46 = "@namespace";
var $08bc5874c1d6603c$export$b44a8529a35fcb60 = "@keyframes";
var $08bc5874c1d6603c$export$2c16de31893252e6 = "@font-face";
var $08bc5874c1d6603c$export$3d846dd52e150c6f = "@counter-style";
var $08bc5874c1d6603c$export$22314bfbb57653fe = "@font-feature-values";
var $08bc5874c1d6603c$export$d773506282b3cfe6 = "@layer";
var $08bc5874c1d6603c$export$1c5a554c78c0cd12 = "@scope";
var $08bc5874c1d6603c$export$2335f513bbd82c6d = Math.abs;
var $08bc5874c1d6603c$export$6788812c4e6611e6 = String.fromCharCode;
var $08bc5874c1d6603c$export$e6e34fd1f2686227 = Object.assign;
function $08bc5874c1d6603c$export$d6af199866bfb566(e, r) {
    return $08bc5874c1d6603c$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $08bc5874c1d6603c$export$a9db5e087081082d(e, 0)) << 2 ^ $08bc5874c1d6603c$export$a9db5e087081082d(e, 1)) << 2 ^ $08bc5874c1d6603c$export$a9db5e087081082d(e, 2)) << 2 ^ $08bc5874c1d6603c$export$a9db5e087081082d(e, 3) : 0;
}
function $08bc5874c1d6603c$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $08bc5874c1d6603c$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $08bc5874c1d6603c$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $08bc5874c1d6603c$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $08bc5874c1d6603c$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $08bc5874c1d6603c$export$36776f635604f274(e) {
    return e.length;
}
function $08bc5874c1d6603c$export$f9084667e487ed46(e) {
    return e.length;
}
function $08bc5874c1d6603c$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $08bc5874c1d6603c$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $08bc5874c1d6603c$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$08bc5874c1d6603c$export$4659b591c19bdf3d(e, r);
    });
}
var $08bc5874c1d6603c$export$53f1d5ea8de3d7c = 1;
var $08bc5874c1d6603c$export$4e0c71f277ca26b3 = 1;
var $08bc5874c1d6603c$export$f24224f1c91d8156 = 0;
var $08bc5874c1d6603c$export$5880b8b5730aff45 = 0;
var $08bc5874c1d6603c$export$c0306caf338ac095 = 0;
var $08bc5874c1d6603c$export$30a86d91af8ff6e6 = "";
function $08bc5874c1d6603c$export$35059013cd4a06db(e, r, a, n, c, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $08bc5874c1d6603c$export$53f1d5ea8de3d7c,
        column: $08bc5874c1d6603c$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $08bc5874c1d6603c$export$784d13d8ee351f07(e, r) {
    return $08bc5874c1d6603c$export$e6e34fd1f2686227($08bc5874c1d6603c$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $08bc5874c1d6603c$export$590e8b2c435046d9(e) {
    while(e.root)e = $08bc5874c1d6603c$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $08bc5874c1d6603c$export$10d8903dec122b9d(e, e.siblings);
}
function $08bc5874c1d6603c$export$eba6f6f03b0a92e7() {
    return $08bc5874c1d6603c$export$c0306caf338ac095;
}
function $08bc5874c1d6603c$export$232faf9add678146() {
    $08bc5874c1d6603c$export$c0306caf338ac095 = $08bc5874c1d6603c$export$5880b8b5730aff45 > 0 ? $08bc5874c1d6603c$export$a9db5e087081082d($08bc5874c1d6603c$export$30a86d91af8ff6e6, --$08bc5874c1d6603c$export$5880b8b5730aff45) : 0;
    if ($08bc5874c1d6603c$export$4e0c71f277ca26b3--, $08bc5874c1d6603c$export$c0306caf338ac095 === 10) $08bc5874c1d6603c$export$4e0c71f277ca26b3 = 1, $08bc5874c1d6603c$export$53f1d5ea8de3d7c--;
    return $08bc5874c1d6603c$export$c0306caf338ac095;
}
function $08bc5874c1d6603c$export$48cfd1e771a65c4f() {
    $08bc5874c1d6603c$export$c0306caf338ac095 = $08bc5874c1d6603c$export$5880b8b5730aff45 < $08bc5874c1d6603c$export$f24224f1c91d8156 ? $08bc5874c1d6603c$export$a9db5e087081082d($08bc5874c1d6603c$export$30a86d91af8ff6e6, $08bc5874c1d6603c$export$5880b8b5730aff45++) : 0;
    if ($08bc5874c1d6603c$export$4e0c71f277ca26b3++, $08bc5874c1d6603c$export$c0306caf338ac095 === 10) $08bc5874c1d6603c$export$4e0c71f277ca26b3 = 1, $08bc5874c1d6603c$export$53f1d5ea8de3d7c++;
    return $08bc5874c1d6603c$export$c0306caf338ac095;
}
function $08bc5874c1d6603c$export$4d3fb11e950abb9e() {
    return $08bc5874c1d6603c$export$a9db5e087081082d($08bc5874c1d6603c$export$30a86d91af8ff6e6, $08bc5874c1d6603c$export$5880b8b5730aff45);
}
function $08bc5874c1d6603c$export$e88cb2efb12ae807() {
    return $08bc5874c1d6603c$export$5880b8b5730aff45;
}
function $08bc5874c1d6603c$export$58adb3bec8346d0f(e, r) {
    return $08bc5874c1d6603c$export$2f35ab04d2335697($08bc5874c1d6603c$export$30a86d91af8ff6e6, e, r);
}
function $08bc5874c1d6603c$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $08bc5874c1d6603c$export$2de70f21292aac9e(e) {
    return $08bc5874c1d6603c$export$53f1d5ea8de3d7c = $08bc5874c1d6603c$export$4e0c71f277ca26b3 = 1, $08bc5874c1d6603c$export$f24224f1c91d8156 = $08bc5874c1d6603c$export$36776f635604f274($08bc5874c1d6603c$export$30a86d91af8ff6e6 = e), $08bc5874c1d6603c$export$5880b8b5730aff45 = 0, [];
}
function $08bc5874c1d6603c$export$45918ac1574455b1(e) {
    return $08bc5874c1d6603c$export$30a86d91af8ff6e6 = "", e;
}
function $08bc5874c1d6603c$export$410ac95b9ec204b8(e) {
    return $08bc5874c1d6603c$export$87c2784dc9fc4ab($08bc5874c1d6603c$export$58adb3bec8346d0f($08bc5874c1d6603c$export$5880b8b5730aff45 - 1, $08bc5874c1d6603c$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $08bc5874c1d6603c$export$660b2ee2d4fb4eff(e) {
    return $08bc5874c1d6603c$export$45918ac1574455b1($08bc5874c1d6603c$export$5f8c09e3ae6f64e1($08bc5874c1d6603c$export$2de70f21292aac9e(e)));
}
function $08bc5874c1d6603c$export$7af1228ff777d175(e) {
    while($08bc5874c1d6603c$export$c0306caf338ac095 = $08bc5874c1d6603c$export$4d3fb11e950abb9e())if ($08bc5874c1d6603c$export$c0306caf338ac095 < 33) $08bc5874c1d6603c$export$48cfd1e771a65c4f();
    else break;
    return $08bc5874c1d6603c$export$9e1725a4cfeada27(e) > 2 || $08bc5874c1d6603c$export$9e1725a4cfeada27($08bc5874c1d6603c$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $08bc5874c1d6603c$export$5f8c09e3ae6f64e1(e) {
    while($08bc5874c1d6603c$export$48cfd1e771a65c4f())switch($08bc5874c1d6603c$export$9e1725a4cfeada27($08bc5874c1d6603c$export$c0306caf338ac095)){
        case 0:
            $08bc5874c1d6603c$export$10d8903dec122b9d($08bc5874c1d6603c$export$c2ab62c7bf24634($08bc5874c1d6603c$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $08bc5874c1d6603c$export$10d8903dec122b9d($08bc5874c1d6603c$export$410ac95b9ec204b8($08bc5874c1d6603c$export$c0306caf338ac095), e);
            break;
        default:
            $08bc5874c1d6603c$export$10d8903dec122b9d($08bc5874c1d6603c$export$6788812c4e6611e6($08bc5874c1d6603c$export$c0306caf338ac095), e);
    }
    return e;
}
function $08bc5874c1d6603c$export$955ba06d119e085e(e, r) {
    while(--r && $08bc5874c1d6603c$export$48cfd1e771a65c4f())if ($08bc5874c1d6603c$export$c0306caf338ac095 < 48 || $08bc5874c1d6603c$export$c0306caf338ac095 > 102 || $08bc5874c1d6603c$export$c0306caf338ac095 > 57 && $08bc5874c1d6603c$export$c0306caf338ac095 < 65 || $08bc5874c1d6603c$export$c0306caf338ac095 > 70 && $08bc5874c1d6603c$export$c0306caf338ac095 < 97) break;
    return $08bc5874c1d6603c$export$58adb3bec8346d0f(e, $08bc5874c1d6603c$export$e88cb2efb12ae807() + (r < 6 && $08bc5874c1d6603c$export$4d3fb11e950abb9e() == 32 && $08bc5874c1d6603c$export$48cfd1e771a65c4f() == 32));
}
function $08bc5874c1d6603c$export$c889f2fcc19dbf12(e) {
    while($08bc5874c1d6603c$export$48cfd1e771a65c4f())switch($08bc5874c1d6603c$export$c0306caf338ac095){
        case e:
            return $08bc5874c1d6603c$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $08bc5874c1d6603c$export$c889f2fcc19dbf12($08bc5874c1d6603c$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $08bc5874c1d6603c$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $08bc5874c1d6603c$export$48cfd1e771a65c4f();
            break;
    }
    return $08bc5874c1d6603c$export$5880b8b5730aff45;
}
function $08bc5874c1d6603c$export$4254d4e2b3745c4c(e, r) {
    while($08bc5874c1d6603c$export$48cfd1e771a65c4f())if (e + $08bc5874c1d6603c$export$c0306caf338ac095 === 57) break;
    else if (e + $08bc5874c1d6603c$export$c0306caf338ac095 === 84 && $08bc5874c1d6603c$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $08bc5874c1d6603c$export$58adb3bec8346d0f(r, $08bc5874c1d6603c$export$5880b8b5730aff45 - 1) + "*" + $08bc5874c1d6603c$export$6788812c4e6611e6(e === 47 ? e : $08bc5874c1d6603c$export$48cfd1e771a65c4f());
}
function $08bc5874c1d6603c$export$c2ab62c7bf24634(e) {
    while(!$08bc5874c1d6603c$export$9e1725a4cfeada27($08bc5874c1d6603c$export$4d3fb11e950abb9e()))$08bc5874c1d6603c$export$48cfd1e771a65c4f();
    return $08bc5874c1d6603c$export$58adb3bec8346d0f(e, $08bc5874c1d6603c$export$5880b8b5730aff45);
}
function $08bc5874c1d6603c$export$ef7acd7185315e22(e) {
    return $08bc5874c1d6603c$export$45918ac1574455b1($08bc5874c1d6603c$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $08bc5874c1d6603c$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $08bc5874c1d6603c$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = c;
    var y = s;
    var j = n;
    var z = k;
    while(w)switch(h = g, g = $08bc5874c1d6603c$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $08bc5874c1d6603c$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($08bc5874c1d6603c$export$f8e21b1e77979a08(z += $08bc5874c1d6603c$export$77ad94ebf1c2b9ed($08bc5874c1d6603c$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $08bc5874c1d6603c$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $08bc5874c1d6603c$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $08bc5874c1d6603c$export$7af1228ff777d175(h);
            break;
        case 92:
            z += $08bc5874c1d6603c$export$955ba06d119e085e($08bc5874c1d6603c$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($08bc5874c1d6603c$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $08bc5874c1d6603c$export$10d8903dec122b9d($08bc5874c1d6603c$export$4a34f930e789283c($08bc5874c1d6603c$export$4254d4e2b3745c4c($08bc5874c1d6603c$export$48cfd1e771a65c4f(), $08bc5874c1d6603c$export$e88cb2efb12ae807()), r, a, i), i);
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * b:
            u[f++] = $08bc5874c1d6603c$export$36776f635604f274(z) * d;
        case 125 * b:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (p > 0 && $08bc5874c1d6603c$export$36776f635604f274(z) - l) $08bc5874c1d6603c$export$10d8903dec122b9d(p > 32 ? $08bc5874c1d6603c$export$f8483753829ec8f3(z + ";", n, a, l - 1, i) : $08bc5874c1d6603c$export$f8483753829ec8f3($08bc5874c1d6603c$export$77ad94ebf1c2b9ed(z, " ", "") + ";", n, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $08bc5874c1d6603c$export$10d8903dec122b9d(j = $08bc5874c1d6603c$export$3307ffa7023ede1e(z, r, a, f, o, c, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $08bc5874c1d6603c$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else switch(v === 99 && $08bc5874c1d6603c$export$a9db5e087081082d(z, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $08bc5874c1d6603c$export$98e6a39c04603d36(e, j, j, n && $08bc5874c1d6603c$export$10d8903dec122b9d($08bc5874c1d6603c$export$3307ffa7023ede1e(e, j, j, 0, 0, c, u, k, c, x = [], l, y), y), c, y, l, u, n ? x : y);
                                break;
                            default:
                                $08bc5874c1d6603c$export$98e6a39c04603d36(z, j, j, j, [
                                    ""
                                ], y, 0, u, y);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $08bc5874c1d6603c$export$36776f635604f274(z), p = h;
        default:
            if (b < 1) {
                if (g == 123) --b;
                else if (g == 125 && b++ == 0 && $08bc5874c1d6603c$export$232faf9add678146() == 125) continue;
            }
            switch(z += $08bc5874c1d6603c$export$6788812c4e6611e6(g), g * b){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($08bc5874c1d6603c$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($08bc5874c1d6603c$export$4d3fb11e950abb9e() === 45) z += $08bc5874c1d6603c$export$410ac95b9ec204b8($08bc5874c1d6603c$export$48cfd1e771a65c4f());
                    v = $08bc5874c1d6603c$export$4d3fb11e950abb9e(), o = l = $08bc5874c1d6603c$export$36776f635604f274(k = z += $08bc5874c1d6603c$export$c2ab62c7bf24634($08bc5874c1d6603c$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (h === 45 && $08bc5874c1d6603c$export$36776f635604f274(z) == 2) b = 0;
            }
    }
    return s;
}
function $08bc5874c1d6603c$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l, v) {
    var p = s - 1;
    var h = s === 0 ? t : [
        ""
    ];
    var b = $08bc5874c1d6603c$export$f9084667e487ed46(h);
    for(var w = 0, d = 0, g = 0; w < n; ++w)for(var k = 0, m = $08bc5874c1d6603c$export$2f35ab04d2335697(e, p + 1, p = $08bc5874c1d6603c$export$2335f513bbd82c6d(d = u[w])), x = e; k < b; ++k)if (x = $08bc5874c1d6603c$export$87c2784dc9fc4ab(d > 0 ? h[k] + " " + m : $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(m, /&\f/g, h[k]))) f[g++] = x;
    return $08bc5874c1d6603c$export$35059013cd4a06db(e, r, a, s === 0 ? $08bc5874c1d6603c$export$aa3a2e812ca8570d : i, f, o, l, v);
}
function $08bc5874c1d6603c$export$4a34f930e789283c(e, r, a, c) {
    return $08bc5874c1d6603c$export$35059013cd4a06db(e, r, a, $08bc5874c1d6603c$export$a29989082612d0d9, $08bc5874c1d6603c$export$6788812c4e6611e6($08bc5874c1d6603c$export$eba6f6f03b0a92e7()), $08bc5874c1d6603c$export$2f35ab04d2335697(e, 2, -2), 0, c);
}
function $08bc5874c1d6603c$export$f8483753829ec8f3(e, r, a, n, c) {
    return $08bc5874c1d6603c$export$35059013cd4a06db(e, r, a, $08bc5874c1d6603c$export$527d108ccf083c2b, $08bc5874c1d6603c$export$2f35ab04d2335697(e, 0, n), $08bc5874c1d6603c$export$2f35ab04d2335697(e, n + 1, -1), n, c);
}
function $08bc5874c1d6603c$export$82e9f45cca5ba907(n, c, s) {
    switch($08bc5874c1d6603c$export$d6af199866bfb566(n, c)){
        case 5103:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $08bc5874c1d6603c$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$2c0f367103c8d01c + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($08bc5874c1d6603c$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "box-$1$2" + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "flex-item-" + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$08bc5874c1d6603c$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "grid-row-" + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "flex-line-pack" + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "box-" + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "-grow", "") + $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $08bc5874c1d6603c$export$39dfd62a25e0fe93 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed($08bc5874c1d6603c$export$77ad94ebf1c2b9ed($08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed($08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "box-pack:$3" + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $08bc5874c1d6603c$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$08bc5874c1d6603c$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "grid-column-align" + $08bc5874c1d6603c$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $08bc5874c1d6603c$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$08bc5874c1d6603c$export$f8e21b1e77979a08(n + (s = s[c].value), "span", 0) ? n : $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$08bc5874c1d6603c$export$f8e21b1e77979a08(s, "span", 0) ? $08bc5874c1d6603c$export$4659b591c19bdf3d(s, /\d+/) : +$08bc5874c1d6603c$export$4659b591c19bdf3d(s, /\d+/) - +$08bc5874c1d6603c$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $08bc5874c1d6603c$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $08bc5874c1d6603c$export$71ad59f2e432cfe8 + $08bc5874c1d6603c$export$77ad94ebf1c2b9ed($08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($08bc5874c1d6603c$export$36776f635604f274(n) - 1 - c > 6) switch($08bc5874c1d6603c$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($08bc5874c1d6603c$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $08bc5874c1d6603c$export$2c0f367103c8d01c + ($08bc5874c1d6603c$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$08bc5874c1d6603c$export$f8e21b1e77979a08(n, "stretch", 0) ? $08bc5874c1d6603c$export$82e9f45cca5ba907($08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $08bc5874c1d6603c$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $08bc5874c1d6603c$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($08bc5874c1d6603c$export$a9db5e087081082d(n, c + 6) === 121) return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, ":", ":" + $08bc5874c1d6603c$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($08bc5874c1d6603c$export$a9db5e087081082d(n, $08bc5874c1d6603c$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $08bc5874c1d6603c$export$39dfd62a25e0fe93 + ($08bc5874c1d6603c$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, ":", ":" + $08bc5874c1d6603c$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $08bc5874c1d6603c$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var n = 0; n < e.length; n++)a += r(e[n], n, e, r) || "";
    return a;
}
function $08bc5874c1d6603c$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $08bc5874c1d6603c$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $08bc5874c1d6603c$export$a763edbf796b780a:
        case $08bc5874c1d6603c$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $08bc5874c1d6603c$export$a29989082612d0d9:
            return "";
        case $08bc5874c1d6603c$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $08bc5874c1d6603c$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $08bc5874c1d6603c$export$aa3a2e812ca8570d:
            if (!$08bc5874c1d6603c$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $08bc5874c1d6603c$export$36776f635604f274(a = $08bc5874c1d6603c$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $08bc5874c1d6603c$export$5a7767152ae0305f(e) {
    var r = $08bc5874c1d6603c$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $08bc5874c1d6603c$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $08bc5874c1d6603c$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $08bc5874c1d6603c$export$527d108ccf083c2b:
                n.return = $08bc5874c1d6603c$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $08bc5874c1d6603c$export$b44a8529a35fcb60:
                return $08bc5874c1d6603c$export$dfdc1655ccc5b9cb([
                    $08bc5874c1d6603c$export$784d13d8ee351f07(n, {
                        value: $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $08bc5874c1d6603c$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $08bc5874c1d6603c$export$aa3a2e812ca8570d:
                if (n.length) return $08bc5874c1d6603c$export$1be1fc439b849fdf(u = n.props, function(c) {
                    switch($08bc5874c1d6603c$export$4659b591c19bdf3d(c, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $08bc5874c1d6603c$export$590e8b2c435046d9($08bc5874c1d6603c$export$784d13d8ee351f07(n, {
                                props: [
                                    $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $08bc5874c1d6603c$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $08bc5874c1d6603c$export$590e8b2c435046d9($08bc5874c1d6603c$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $08bc5874c1d6603c$export$e6e34fd1f2686227(n, {
                                props: $08bc5874c1d6603c$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $08bc5874c1d6603c$export$590e8b2c435046d9($08bc5874c1d6603c$export$784d13d8ee351f07(n, {
                                props: [
                                    $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $08bc5874c1d6603c$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $08bc5874c1d6603c$export$590e8b2c435046d9($08bc5874c1d6603c$export$784d13d8ee351f07(n, {
                                props: [
                                    $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $08bc5874c1d6603c$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $08bc5874c1d6603c$export$590e8b2c435046d9($08bc5874c1d6603c$export$784d13d8ee351f07(n, {
                                props: [
                                    $08bc5874c1d6603c$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $08bc5874c1d6603c$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $08bc5874c1d6603c$export$590e8b2c435046d9($08bc5874c1d6603c$export$784d13d8ee351f07(n, {
                                props: [
                                    c
                                ]
                            }));
                            $08bc5874c1d6603c$export$e6e34fd1f2686227(n, {
                                props: $08bc5874c1d6603c$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $08bc5874c1d6603c$export$76a88f7de6507443(e) {
    switch(e.type){
        case $08bc5874c1d6603c$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $08bc5874c1d6603c$export$1be1fc439b849fdf($08bc5874c1d6603c$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($08bc5874c1d6603c$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $08bc5874c1d6603c$export$2f35ab04d2335697(r, 1, $08bc5874c1d6603c$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $08bc5874c1d6603c$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $08bc5874c1d6603c$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $08bc5874c1d6603c$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $c2bf37b9c9605325$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $ibRPI = parcelRequire("ibRPI");
var $5a013a0873ae9228$var$f = ("undefined" != typeof $ibRPI && void 0 !== $ibRPI.env && undefined, "data-styled"), $5a013a0873ae9228$var$m = "active", $5a013a0873ae9228$var$y = "data-styled-version", $5a013a0873ae9228$export$83d89fbfd8236492 = "6.1.12", $5a013a0873ae9228$var$g = "/*!sc*/\n", $5a013a0873ae9228$var$S = "undefined" != typeof window && "HTMLElement" in window, $5a013a0873ae9228$var$w = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : ("undefined" != typeof $ibRPI && $ibRPI.env, "undefined" != typeof $ibRPI && $ibRPI.env, false)), $5a013a0873ae9228$var$b = {}, $5a013a0873ae9228$var$E = /invalid hook call/i, $5a013a0873ae9228$var$N = new Set, $5a013a0873ae9228$var$P = function P(t, n) {
    var _$o, s, i, a, e;
}, $5a013a0873ae9228$var$_ = Object.freeze([]), $5a013a0873ae9228$var$C = Object.freeze({});
function $5a013a0873ae9228$var$I(e, t, n) {
    return void 0 === n && (n = $5a013a0873ae9228$var$C), e.theme !== n.theme && e.theme || t || n.theme;
}
var $5a013a0873ae9228$var$A = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "track",
    "u",
    "ul",
    "use",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
]), $5a013a0873ae9228$var$O = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $5a013a0873ae9228$var$D = /(^-|-$)/g;
function $5a013a0873ae9228$var$R(e) {
    return e.replace($5a013a0873ae9228$var$O, "-").replace($5a013a0873ae9228$var$D, "");
}
var $5a013a0873ae9228$var$T = /(a)(d)/gi, $5a013a0873ae9228$var$k = 52, $5a013a0873ae9228$var$j = function j(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $5a013a0873ae9228$var$x(e) {
    var t, n = "";
    for(t = Math.abs(e); t > $5a013a0873ae9228$var$k; t = t / $5a013a0873ae9228$var$k | 0)n = $5a013a0873ae9228$var$j(t % $5a013a0873ae9228$var$k) + n;
    return ($5a013a0873ae9228$var$j(t % $5a013a0873ae9228$var$k) + n).replace($5a013a0873ae9228$var$T, "$1-$2");
}
var $5a013a0873ae9228$var$V, $5a013a0873ae9228$var$F = 5381, $5a013a0873ae9228$var$M = function M(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $5a013a0873ae9228$var$z = function z(e) {
    return $5a013a0873ae9228$var$M($5a013a0873ae9228$var$F, e);
};
function $5a013a0873ae9228$var$$(e) {
    return $5a013a0873ae9228$var$x($5a013a0873ae9228$var$z(e) >>> 0);
}
function $5a013a0873ae9228$var$B(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $5a013a0873ae9228$var$L(e) {
    return "string" == typeof e && true;
}
var $5a013a0873ae9228$var$G = "function" == typeof Symbol && Symbol.for, $5a013a0873ae9228$var$Y = $5a013a0873ae9228$var$G ? Symbol.for("react.memo") : 60115, $5a013a0873ae9228$var$W = $5a013a0873ae9228$var$G ? Symbol.for("react.forward_ref") : 60112, $5a013a0873ae9228$var$q = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $5a013a0873ae9228$var$H = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $5a013a0873ae9228$var$U = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $5a013a0873ae9228$var$J = (($5a013a0873ae9228$var$V = {})[$5a013a0873ae9228$var$W] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $5a013a0873ae9228$var$V[$5a013a0873ae9228$var$Y] = $5a013a0873ae9228$var$U, $5a013a0873ae9228$var$V);
function $5a013a0873ae9228$var$X(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $5a013a0873ae9228$var$Y ? $5a013a0873ae9228$var$U : "$$typeof" in e ? $5a013a0873ae9228$var$J[e.$$typeof] : $5a013a0873ae9228$var$q;
}
var $5a013a0873ae9228$var$Z = Object.defineProperty, $5a013a0873ae9228$var$K = Object.getOwnPropertyNames, $5a013a0873ae9228$var$Q = Object.getOwnPropertySymbols, $5a013a0873ae9228$var$ee = Object.getOwnPropertyDescriptor, $5a013a0873ae9228$var$te = Object.getPrototypeOf, $5a013a0873ae9228$var$ne = Object.prototype;
function $5a013a0873ae9228$var$oe(e, t, n) {
    if ("string" != typeof t) {
        if ($5a013a0873ae9228$var$ne) {
            var _$o = $5a013a0873ae9228$var$te(t);
            _$o && _$o !== $5a013a0873ae9228$var$ne && $5a013a0873ae9228$var$oe(e, _$o, n);
        }
        var r = $5a013a0873ae9228$var$K(t);
        $5a013a0873ae9228$var$Q && (r = r.concat($5a013a0873ae9228$var$Q(t)));
        for(var s = $5a013a0873ae9228$var$X(e), i = $5a013a0873ae9228$var$X(t), a = 0; a < r.length; ++a){
            var c = r[a];
            if (!(c in $5a013a0873ae9228$var$H || n && n[c] || i && c in i || s && c in s)) {
                var l = $5a013a0873ae9228$var$ee(t, c);
                try {
                    $5a013a0873ae9228$var$Z(e, c, l);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $5a013a0873ae9228$var$re(e) {
    return "function" == typeof e;
}
function $5a013a0873ae9228$export$7ba318d8d2f06c76(e) {
    return "object" == (typeof e === "undefined" ? "undefined" : (0, $YtE9h._)(e)) && "styledComponentId" in e;
}
function $5a013a0873ae9228$var$ie(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $5a013a0873ae9228$var$ae(e, t) {
    if (0 === e.length) return "";
    for(var n = e[0], _$o = 1; _$o < e.length; _$o++)n += t ? t + e[_$o] : e[_$o];
    return n;
}
function $5a013a0873ae9228$var$ce(e) {
    return null !== e && "object" == (typeof e === "undefined" ? "undefined" : (0, $YtE9h._)(e)) && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $5a013a0873ae9228$var$le(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$5a013a0873ae9228$var$ce(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var _$o = 0; _$o < t.length; _$o++)e[_$o] = $5a013a0873ae9228$var$le(e[_$o], t[_$o]);
    else if ($5a013a0873ae9228$var$ce(t)) for(var _$o in t)e[_$o] = $5a013a0873ae9228$var$le(e[_$o], t[_$o]);
    return e;
}
function $5a013a0873ae9228$var$ue(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $5a013a0873ae9228$var$pe = {};
function $5a013a0873ae9228$var$de() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], _$o = [], r = 1, s = e.length; r < s; r += 1)_$o.push(e[r]);
    return _$o.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $5a013a0873ae9228$var$he(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $5a013a0873ae9228$var$fe = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    return e.prototype.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, _$o = n.length, r = _$o; e >= r;)if ((r <<= 1) < 0) throw $5a013a0873ae9228$var$he(16, "".concat(e));
            this.groupSizes = new Uint32Array(r), this.groupSizes.set(n), this.length = r;
            for(var s = _$o; s < r; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = (s = 0, t.length); s < a; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), _$o = n + t;
            this.groupSizes[e] = 0;
            for(var r = n; r < _$o; r++)this.tag.deleteRule(n);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], _$o = this.indexOfGroup(e), r = _$o + n, s = _$o; s < r; s++)t += "".concat(this.tag.getRule(s)).concat($5a013a0873ae9228$var$g);
        return t;
    }, e;
}(), $5a013a0873ae9228$var$me = 1073741824, $5a013a0873ae9228$var$ye = new Map, $5a013a0873ae9228$var$ve = new Map, $5a013a0873ae9228$var$ge = 1, $5a013a0873ae9228$var$Se = function Se(e) {
    if ($5a013a0873ae9228$var$ye.has(e)) return $5a013a0873ae9228$var$ye.get(e);
    for(; $5a013a0873ae9228$var$ve.has($5a013a0873ae9228$var$ge);)$5a013a0873ae9228$var$ge++;
    var t = $5a013a0873ae9228$var$ge++;
    return $5a013a0873ae9228$var$ye.set(e, t), $5a013a0873ae9228$var$ve.set(t, e), t;
}, $5a013a0873ae9228$var$we = function we(e, t) {
    $5a013a0873ae9228$var$ge = t + 1, $5a013a0873ae9228$var$ye.set(e, t), $5a013a0873ae9228$var$ve.set(t, e);
}, $5a013a0873ae9228$var$be = "style[".concat($5a013a0873ae9228$var$f, "][").concat($5a013a0873ae9228$var$y, '="').concat($5a013a0873ae9228$export$83d89fbfd8236492, '"]'), $5a013a0873ae9228$var$Ee = new RegExp("^".concat($5a013a0873ae9228$var$f, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $5a013a0873ae9228$var$Ne = function Ne(e, t, n) {
    for(var _$o, r = n.split(","), s = 0, i = r.length; s < i; s++)(_$o = r[s]) && e.registerName(t, _$o);
}, $5a013a0873ae9228$var$Pe = function Pe(e, t) {
    for(var n, _$o = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($5a013a0873ae9228$var$g), r = [], s = 0, i = _$o.length; s < i; s++){
        var a = _$o[s].trim();
        if (a) {
            var c = a.match($5a013a0873ae9228$var$Ee);
            if (c) {
                var l = 0 | parseInt(c[1], 10), u = c[2];
                0 !== l && ($5a013a0873ae9228$var$we(u, l), $5a013a0873ae9228$var$Ne(e, u, c[3]), e.getTag().insertRules(l, r)), r.length = 0;
            } else r.push(a);
        }
    }
}, $5a013a0873ae9228$var$_e = function _e(e) {
    for(var t = document.querySelectorAll($5a013a0873ae9228$var$be), n = 0, _$o = t.length; n < _$o; n++){
        var r = t[n];
        r && r.getAttribute($5a013a0873ae9228$var$f) !== $5a013a0873ae9228$var$m && ($5a013a0873ae9228$var$Pe(e, r), r.parentNode && r.parentNode.removeChild(r));
    }
};
function $5a013a0873ae9228$var$Ce() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $5a013a0873ae9228$var$Ie = function Ie(e) {
    var t = document.head, n = e || t, _$o = document.createElement("style"), r = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($5a013a0873ae9228$var$f, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== r ? r.nextSibling : null;
    _$o.setAttribute($5a013a0873ae9228$var$f, $5a013a0873ae9228$var$m), _$o.setAttribute($5a013a0873ae9228$var$y, $5a013a0873ae9228$export$83d89fbfd8236492);
    var i = $5a013a0873ae9228$var$Ce();
    return i && _$o.setAttribute("nonce", i), n.insertBefore(_$o, s), _$o;
}, $5a013a0873ae9228$var$Ae = function() {
    function e(e) {
        this.element = $5a013a0873ae9228$var$Ie(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, _$o = t.length; n < _$o; n++){
                var r = t[n];
                if (r.ownerNode === e) return r;
            }
            throw $5a013a0873ae9228$var$he(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $5a013a0873ae9228$var$Oe = function() {
    function e(e) {
        this.element = $5a013a0873ae9228$var$Ie(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $5a013a0873ae9228$var$De = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $5a013a0873ae9228$var$Re = $5a013a0873ae9228$var$S, $5a013a0873ae9228$var$Te = {
    isServer: !$5a013a0873ae9228$var$S,
    useCSSOMInjection: !$5a013a0873ae9228$var$w
}, $5a013a0873ae9228$var$ke = function() {
    function e(e, n, o) {
        void 0 === e && (e = $5a013a0873ae9228$var$C), void 0 === n && (n = {});
        var r = this;
        this.options = (0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, $5a013a0873ae9228$var$Te), e), this.gs = n, this.names = new Map(o), this.server = !!e.isServer, !this.server && $5a013a0873ae9228$var$S && $5a013a0873ae9228$var$Re && ($5a013a0873ae9228$var$Re = !1, $5a013a0873ae9228$var$_e(this)), $5a013a0873ae9228$var$ue(this, function() {
            return function(e) {
                for(var _$t = e.getTag(), _$n = _$t.length, _$o = "", r = function r(n) {
                    var r = function(e) {
                        return $5a013a0873ae9228$var$ve.get(e);
                    }(n);
                    if (void 0 === r) return "continue";
                    var s = e.names.get(r), i = _$t.getGroup(n);
                    if (void 0 === s || !s.size || 0 === i.length) return "continue";
                    var a = "".concat($5a013a0873ae9228$var$f, ".g").concat(n, '[id="').concat(r, '"]'), c = "";
                    void 0 !== s && s.forEach(function(e) {
                        e.length > 0 && (c += "".concat(e, ","));
                    }), _$o += "".concat(i).concat(a, '{content:"').concat(c, '"}').concat($5a013a0873ae9228$var$g);
                }, s = 0; s < _$n; s++)r(s);
                return _$o;
            }(r);
        });
    }
    return e.registerId = function(e) {
        return $5a013a0873ae9228$var$Se(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $5a013a0873ae9228$var$S && $5a013a0873ae9228$var$_e(this);
    }, e.prototype.reconstructWithOptions = function(n, o) {
        return void 0 === o && (o = !0), new e((0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, this.options), n), this.gs, o && this.names || void 0);
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var _$e;
        return this.tag || (this.tag = (_$e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $5a013a0873ae9228$var$De(n) : t ? new $5a013a0873ae9228$var$Ae(n) : new $5a013a0873ae9228$var$Oe(n);
        }(this.options), new $5a013a0873ae9228$var$fe(_$e)));
    }, e.prototype.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, e.prototype.registerName = function(e, t) {
        if ($5a013a0873ae9228$var$Se(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($5a013a0873ae9228$var$Se(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($5a013a0873ae9228$var$Se(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $5a013a0873ae9228$var$je = /&/g, $5a013a0873ae9228$var$xe = /^\s*\/\/.*$/gm;
function $5a013a0873ae9228$var$Ve(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $5a013a0873ae9228$var$Ve(e.children, t)), e;
    });
}
function $5a013a0873ae9228$var$Fe(e) {
    var t, n, _$o, r = void 0 === e ? $5a013a0873ae9228$var$C : e, s = r.options, i = void 0 === s ? $5a013a0873ae9228$var$C : s, a = r.plugins, c = void 0 === a ? $5a013a0873ae9228$var$_ : a, l = function l(e, o, r) {
        return r.startsWith(n) && r.endsWith(n) && r.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, u = c.slice();
    u.push(function(e) {
        e.type === $08bc5874c1d6603c$export$aa3a2e812ca8570d && e.value.includes("&") && (e.props[0] = e.props[0].replace($5a013a0873ae9228$var$je, n).replace(_$o, l));
    }), i.prefix && u.push($08bc5874c1d6603c$export$e08c7d021b829b7a), u.push($08bc5874c1d6603c$export$fac44ee5b035f737);
    var p = function p(e, r, s, a) {
        void 0 === r && (r = ""), void 0 === s && (s = ""), void 0 === a && (a = "&"), t = a, n = r, _$o = new RegExp("\\".concat(n, "\\b"), "g");
        var c = e.replace($5a013a0873ae9228$var$xe, ""), l = $08bc5874c1d6603c$export$ef7acd7185315e22(s || r ? "".concat(s, " ").concat(r, " { ").concat(c, " }") : c);
        i.namespace && (l = $5a013a0873ae9228$var$Ve(l, i.namespace));
        var p = [];
        return $08bc5874c1d6603c$export$dfdc1655ccc5b9cb(l, $08bc5874c1d6603c$export$5a7767152ae0305f(u.concat($08bc5874c1d6603c$export$38bcb760f1d4871c(function(e) {
            return p.push(e);
        })))), p;
    };
    return p.hash = c.length ? c.reduce(function(e, t) {
        return t.name || $5a013a0873ae9228$var$he(15), $5a013a0873ae9228$var$M(e, t.name);
    }, $5a013a0873ae9228$var$F).toString() : "", p;
}
var $5a013a0873ae9228$var$Me = new $5a013a0873ae9228$var$ke, $5a013a0873ae9228$var$ze = $5a013a0873ae9228$var$Fe(), $5a013a0873ae9228$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createContext({
    shouldForwardProp: void 0,
    styleSheet: $5a013a0873ae9228$var$Me,
    stylis: $5a013a0873ae9228$var$ze
}), $5a013a0873ae9228$export$91317688fc694efa = $5a013a0873ae9228$export$8c190ef828af4c86.Consumer, $5a013a0873ae9228$var$Le = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createContext(void 0);
function $5a013a0873ae9228$var$Ge() {
    return (0, $fIwXP.useContext)($5a013a0873ae9228$export$8c190ef828af4c86);
}
function $5a013a0873ae9228$export$a473771da2f0ff7c(e) {
    var t = (0, $fIwXP.useState)(e.stylisPlugins), n = t[0], r = t[1], c = $5a013a0873ae9228$var$Ge().styleSheet, l = (0, $fIwXP.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        c
    ]), u = (0, $fIwXP.useMemo)(function() {
        return $5a013a0873ae9228$var$Fe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        n
    ]);
    (0, $fIwXP.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($361d31f2e4fa0271$exports)))(n, e.stylisPlugins) || r(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]);
    var d = (0, $fIwXP.useMemo)(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: l,
            stylis: u
        };
    }, [
        e.shouldForwardProp,
        l,
        u
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($5a013a0873ae9228$export$8c190ef828af4c86.Provider, {
        value: d
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($5a013a0873ae9228$var$Le.Provider, {
        value: u
    }, e.children));
}
var $5a013a0873ae9228$var$We = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $5a013a0873ae9228$var$ze);
            var _$o = n.name + t.hash;
            e.hasNameForId(n.id, _$o) || e.insertRules(n.id, _$o, t(n.rules, _$o, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $5a013a0873ae9228$var$ue(this, function() {
            throw $5a013a0873ae9228$var$he(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $5a013a0873ae9228$var$ze), this.name + e.hash;
    }, e;
}(), $5a013a0873ae9228$var$qe = function qe(e) {
    return e >= "A" && e <= "Z";
};
function $5a013a0873ae9228$var$He(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var _$o = e[n];
        if (1 === n && "-" === _$o && "-" === e[0]) return e;
        $5a013a0873ae9228$var$qe(_$o) ? t += "-" + _$o.toLowerCase() : t += _$o;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $5a013a0873ae9228$var$Ue = function Ue(e) {
    return null == e || !1 === e || "" === e;
}, $5a013a0873ae9228$var$Je = function Je1(t) {
    var n, _$o, r = [];
    for(var s in t){
        var i = t[s];
        t.hasOwnProperty(s) && !$5a013a0873ae9228$var$Ue(i) && (Array.isArray(i) && i.isCss || $5a013a0873ae9228$var$re(i) ? r.push("".concat($5a013a0873ae9228$var$He(s), ":"), i, ";") : $5a013a0873ae9228$var$ce(i) ? r.push.apply(r, (0, $ef483e37d783a0b4$export$1216008129fb82ed)((0, $ef483e37d783a0b4$export$1216008129fb82ed)([
            "".concat(s, " {")
        ], $5a013a0873ae9228$var$Je(i), !1), [
            "}"
        ], !1)) : r.push("".concat($5a013a0873ae9228$var$He(s), ": ").concat((n = s, null == (_$o = i) || "boolean" == typeof _$o || "" === _$o ? "" : "number" != typeof _$o || 0 === _$o || n in (0, $c2bf37b9c9605325$export$2e2bcd8739ae039) || n.startsWith("--") ? String(_$o).trim() : "".concat(_$o, "px")), ";")));
    }
    return r;
};
function $5a013a0873ae9228$var$Xe(e, t, n, o) {
    if ($5a013a0873ae9228$var$Ue(e)) return [];
    if ($5a013a0873ae9228$export$7ba318d8d2f06c76(e)) return [
        ".".concat(e.styledComponentId)
    ];
    if ($5a013a0873ae9228$var$re(e)) {
        if (!$5a013a0873ae9228$var$re(s = e) || s.prototype && s.prototype.isReactComponent || !t) return [
            e
        ];
        var r = e(t);
        return $5a013a0873ae9228$var$Xe(r, t, n, o);
    }
    var s;
    return e instanceof $5a013a0873ae9228$var$We ? n ? (e.inject(n, o), [
        e.getName(o)
    ]) : [
        e
    ] : $5a013a0873ae9228$var$ce(e) ? $5a013a0873ae9228$var$Je(e) : Array.isArray(e) ? Array.prototype.concat.apply($5a013a0873ae9228$var$_, e.map(function(e) {
        return $5a013a0873ae9228$var$Xe(e, t, n, o);
    })) : [
        e.toString()
    ];
}
function $5a013a0873ae9228$var$Ze(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($5a013a0873ae9228$var$re(n) && !$5a013a0873ae9228$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $5a013a0873ae9228$var$Ke = $5a013a0873ae9228$var$z($5a013a0873ae9228$export$83d89fbfd8236492), $5a013a0873ae9228$var$Qe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $5a013a0873ae9228$var$Ze(e), this.componentId = t, this.baseHash = $5a013a0873ae9228$var$M($5a013a0873ae9228$var$Ke, t), this.baseStyle = n, $5a013a0873ae9228$var$ke.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var _$o = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n) : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) _$o = $5a013a0873ae9228$var$ie(_$o, this.staticRulesId);
            else {
                var r = $5a013a0873ae9228$var$ae($5a013a0873ae9228$var$Xe(this.rules, e, t, n)), s = $5a013a0873ae9228$var$x($5a013a0873ae9228$var$M(this.baseHash, r) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(r, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                _$o = $5a013a0873ae9228$var$ie(_$o, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $5a013a0873ae9228$var$M(this.baseHash, n.hash), c = "", l = 0; l < this.rules.length; l++){
                var u = this.rules[l];
                if ("string" == typeof u) c += u;
                else if (u) {
                    var p = $5a013a0873ae9228$var$ae($5a013a0873ae9228$var$Xe(u, e, t, n));
                    a = $5a013a0873ae9228$var$M(a, p + l), c += p;
                }
            }
            if (c) {
                var d = $5a013a0873ae9228$var$x(a >>> 0);
                t.hasNameForId(this.componentId, d) || t.insertRules(this.componentId, d, n(c, ".".concat(d), void 0, this.componentId)), _$o = $5a013a0873ae9228$var$ie(_$o, d);
            }
        }
        return _$o;
    }, e;
}(), $5a013a0873ae9228$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createContext(void 0), $5a013a0873ae9228$export$b631efc24e9d5e2f = $5a013a0873ae9228$export$2c657da244d00bd6.Consumer;
function $5a013a0873ae9228$export$93d4e7f90805808f() {
    var e = (0, $fIwXP.useContext)($5a013a0873ae9228$export$2c657da244d00bd6);
    if (!e) throw $5a013a0873ae9228$var$he(18);
    return e;
}
function $5a013a0873ae9228$export$d8964aec282183a3(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).useContext($5a013a0873ae9228$export$2c657da244d00bd6), r = (0, $fIwXP.useMemo)(function() {
        return function(e, n) {
            if (!e) throw $5a013a0873ae9228$var$he(14);
            if ($5a013a0873ae9228$var$re(e)) {
                var _$o = e(n);
                return _$o;
            }
            if (Array.isArray(e) || "object" != (typeof e === "undefined" ? "undefined" : (0, $YtE9h._)(e))) throw $5a013a0873ae9228$var$he(8);
            return n ? (0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($5a013a0873ae9228$export$2c657da244d00bd6.Provider, {
        value: r
    }, e.children) : null;
}
var $5a013a0873ae9228$var$rt = {}, $5a013a0873ae9228$var$st = new Set;
function $5a013a0873ae9228$var$it(e, r, s) {
    var i = $5a013a0873ae9228$export$7ba318d8d2f06c76(e), a = e, c = !$5a013a0873ae9228$var$L(e), p = r.attrs, d = void 0 === p ? $5a013a0873ae9228$var$_ : p, h = r.componentId, f = void 0 === h ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $5a013a0873ae9228$var$R(e);
        $5a013a0873ae9228$var$rt[n] = ($5a013a0873ae9228$var$rt[n] || 0) + 1;
        var _$o = "".concat(n, "-").concat($5a013a0873ae9228$var$$($5a013a0873ae9228$export$83d89fbfd8236492 + n + $5a013a0873ae9228$var$rt[n]));
        return t ? "".concat(t, "-").concat(_$o) : _$o;
    }(r.displayName, r.parentComponentId) : h, m = r.displayName, y = void 0 === m ? function(e) {
        return $5a013a0873ae9228$var$L(e) ? "styled.".concat(e) : "Styled(".concat($5a013a0873ae9228$var$B(e), ")");
    }(e) : m, g = r.displayName && r.componentId ? "".concat($5a013a0873ae9228$var$R(r.displayName), "-").concat(r.componentId) : r.componentId || f, S = i && a.attrs ? a.attrs.concat(d).filter(Boolean) : d, w = r.shouldForwardProp;
    if (i && a.shouldForwardProp) {
        var b = a.shouldForwardProp;
        if (r.shouldForwardProp) {
            var E = r.shouldForwardProp;
            w = function w(e, t) {
                return b(e, t) && E(e, t);
            };
        } else w = b;
    }
    var N = new $5a013a0873ae9228$var$Qe(s, g, i ? a.componentStyle : void 0);
    function O(e, r) {
        return function(e, r, s) {
            var i = e.attrs, a = e.componentStyle, c = e.defaultProps, p = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).useContext($5a013a0873ae9228$export$2c657da244d00bd6), m = $5a013a0873ae9228$var$Ge(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $5a013a0873ae9228$var$I(r, f, c) || $5a013a0873ae9228$var$C, g = function(e, n, o) {
                for(var _$r, _$s = (0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: o
                }), i = 0; i < e.length; i += 1){
                    var a = $5a013a0873ae9228$var$re(_$r = e[i]) ? _$r(_$s) : _$r;
                    for(var c in a)_$s[c] = "className" === c ? $5a013a0873ae9228$var$ie(_$s[c], a[c]) : "style" === c ? (0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, _$s[c]), a[c]) : a[c];
                }
                return n.className && (_$s.className = $5a013a0873ae9228$var$ie(_$s.className, n.className)), _$s;
            }(i, r, v), S = g.as || h, w = {};
            for(var b in g)void 0 === g[b] || "$" === b[0] || "as" === b || "theme" === b && g.theme === v || ("forwardedAs" === b ? w.as = g.forwardedAs : y && !y(b, S) || (w[b] = g[b], y));
            var E = function(e, t) {
                var n = $5a013a0873ae9228$var$Ge(), _$o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return _$o;
            }(a, g);
            var N = $5a013a0873ae9228$var$ie(p, d);
            return E && (N += " " + E), g.className && (N += " " + g.className), w[$5a013a0873ae9228$var$L(S) && !$5a013a0873ae9228$var$A.has(S) ? "class" : "className"] = N, w.ref = s, (0, $fIwXP.createElement)(S, w);
        }(D, e, r);
    }
    O.displayName = y;
    var D = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).forwardRef(O);
    return D.attrs = S, D.componentStyle = N, D.displayName = y, D.shouldForwardProp = w, D.foldedComponentIds = i ? $5a013a0873ae9228$var$ie(a.foldedComponentIds, a.styledComponentId) : "", D.styledComponentId = g, D.target = i ? a.target : e, Object.defineProperty(D, "defaultProps", {
        get: function get() {
            return this._foldedDefaultProps;
        },
        set: function set(e) {
            this._foldedDefaultProps = i ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var _$o = 0, _$r = t; _$o < _$r.length; _$o++)$5a013a0873ae9228$var$le(e, _$r[_$o], !0);
                return e;
            }({}, a.defaultProps, e) : e;
        }
    }), $5a013a0873ae9228$var$ue(D, function() {
        return ".".concat(D.styledComponentId);
    }), c && $5a013a0873ae9228$var$oe(D, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), D;
}
function $5a013a0873ae9228$var$at(e, t) {
    for(var n = [
        e[0]
    ], _$o = 0, r = t.length; _$o < r; _$o += 1)n.push(t[_$o], e[_$o + 1]);
    return n;
}
var $5a013a0873ae9228$var$ct = function ct(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $5a013a0873ae9228$export$dbf350e5966cf602(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    if ($5a013a0873ae9228$var$re(t) || $5a013a0873ae9228$var$ce(t)) return $5a013a0873ae9228$var$ct($5a013a0873ae9228$var$Xe($5a013a0873ae9228$var$at($5a013a0873ae9228$var$_, (0, $ef483e37d783a0b4$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var r = t;
    return 0 === n.length && 1 === r.length && "string" == typeof r[0] ? $5a013a0873ae9228$var$Xe(r) : $5a013a0873ae9228$var$ct($5a013a0873ae9228$var$Xe($5a013a0873ae9228$var$at(r, n)));
}
function $5a013a0873ae9228$var$ut(n, o, r) {
    if (void 0 === r && (r = $5a013a0873ae9228$var$C), !o) throw $5a013a0873ae9228$var$he(1, o);
    var s = function s(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(o, r, $5a013a0873ae9228$export$dbf350e5966cf602.apply(void 0, (0, $ef483e37d783a0b4$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $5a013a0873ae9228$var$ut(n, o, (0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, r), {
            attrs: Array.prototype.concat(r.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $5a013a0873ae9228$var$ut(n, o, (0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, r), e));
    }, s;
}
var $5a013a0873ae9228$var$pt = function pt(e) {
    return $5a013a0873ae9228$var$ut($5a013a0873ae9228$var$it, e);
}, $5a013a0873ae9228$export$2e2bcd8739ae039 = $5a013a0873ae9228$var$pt;
$5a013a0873ae9228$var$A.forEach(function(e) {
    $5a013a0873ae9228$export$2e2bcd8739ae039[e] = $5a013a0873ae9228$var$pt(e);
});
var $5a013a0873ae9228$var$ht = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $5a013a0873ae9228$var$Ze(e), $5a013a0873ae9228$var$ke.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, o) {
        var r = o($5a013a0873ae9228$var$ae($5a013a0873ae9228$var$Xe(this.rules, t, n, o)), ""), s = this.componentId + e;
        n.insertRules(s, s, r);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, o) {
        e > 2 && $5a013a0873ae9228$var$ke.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, o);
    }, e;
}();
function $5a013a0873ae9228$export$f0f03736edb61697(n) {
    for(var r = [], s = 1; s < arguments.length; s++)r[s - 1] = arguments[s];
    var i = $5a013a0873ae9228$export$dbf350e5966cf602.apply(void 0, (0, $ef483e37d783a0b4$export$1216008129fb82ed)([
        n
    ], r, !1)), a = "sc-global-".concat($5a013a0873ae9228$var$$(JSON.stringify(i))), c = new $5a013a0873ae9228$var$ht(i, a);
    var l = function l(e) {
        var t = $5a013a0873ae9228$var$Ge(), _$n = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).useContext($5a013a0873ae9228$export$2c657da244d00bd6), r = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).useRef(t.styleSheet.allocateGSInstance(a)).current;
        return t.styleSheet.server && u(r, e, t.styleSheet, _$n, t.stylis), (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).useLayoutEffect(function() {
            if (!t.styleSheet.server) return u(r, e, t.styleSheet, _$n, t.stylis), function() {
                return c.removeStyles(r, t.styleSheet);
            };
        }, [
            r,
            e,
            t.styleSheet,
            _$n,
            t.stylis
        ]), null;
    };
    function u(e, n, o, r, s) {
        if (c.isStatic) c.renderStyles(e, $5a013a0873ae9228$var$b, o, s);
        else {
            var i = (0, $ef483e37d783a0b4$export$18ce0697a983be9b)((0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, n), {
                theme: $5a013a0873ae9228$var$I(n, r, l.defaultProps)
            });
            c.renderStyles(e, i, o, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).memo(l);
}
function $5a013a0873ae9228$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], _$o = 1; _$o < arguments.length; _$o++)n[_$o - 1] = arguments[_$o];
    var r = $5a013a0873ae9228$var$ae($5a013a0873ae9228$export$dbf350e5966cf602.apply(void 0, (0, $ef483e37d783a0b4$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $5a013a0873ae9228$var$$(r);
    return new $5a013a0873ae9228$var$We(s, r);
}
function $5a013a0873ae9228$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).forwardRef(function(n, r) {
        var s = $5a013a0873ae9228$var$I(n, (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).useContext($5a013a0873ae9228$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement(e, (0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, n, {
            theme: s,
            ref: r
        }));
    });
    return n.displayName = "WithTheme(".concat($5a013a0873ae9228$var$B(e), ")"), $5a013a0873ae9228$var$oe(n, e);
}
var $5a013a0873ae9228$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var _$e = this;
        this._emitSheetCSS = function() {
            var t = _$e.instance.toString();
            if (!t) return "";
            var n = $5a013a0873ae9228$var$Ce(), _$o = $5a013a0873ae9228$var$ae([
                n && 'nonce="'.concat(n, '"'),
                "".concat($5a013a0873ae9228$var$f, '="true"'),
                "".concat($5a013a0873ae9228$var$y, '="').concat($5a013a0873ae9228$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(_$o, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (_$e.sealed) throw $5a013a0873ae9228$var$he(2);
            return _$e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (_$e.sealed) throw $5a013a0873ae9228$var$he(2);
            var r = _$e.instance.toString();
            if (!r) return [];
            var s = ((n = {})[$5a013a0873ae9228$var$f] = "", n[$5a013a0873ae9228$var$y] = $5a013a0873ae9228$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: r
            }, n), i = $5a013a0873ae9228$var$Ce();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement("style", (0, $ef483e37d783a0b4$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            _$e.sealed = !0;
        }, this.instance = new $5a013a0873ae9228$var$ke({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $5a013a0873ae9228$var$he(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($fIwXP))).createElement($5a013a0873ae9228$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $5a013a0873ae9228$var$he(3);
    }, e;
}(), $5a013a0873ae9228$export$5c87cfe6c475f500 = {
    StyleSheet: $5a013a0873ae9228$var$ke,
    mainSheet: $5a013a0873ae9228$var$Me
};
var $5a013a0873ae9228$var$St = "__sc-".concat($5a013a0873ae9228$var$f, "__");


function $715305e2ea9c3de1$var$_templateObject() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\n  display: ",
        ";\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject1() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\n12.5% {\n  stroke-dasharray: ",
        "px, ",
        "px;\n  stroke-dashoffset: -",
        "px;\n}\n43.75% {\n  stroke-dasharray: ",
        "px, ",
        "px;\n  stroke-dashoffset: -",
        "px;\n}\n100% {\n  stroke-dasharray: ",
        "px, ",
        "px;\n  stroke-dashoffset: -",
        "px;\n}\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject2() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\n  stroke-dasharray: ",
        "px, ",
        ";\n  stroke-dashoffset: 0;\n  animation: ",
        " ",
        "s linear infinite;\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject3() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\nto {\n   transform: rotate(360deg);\n }\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject4() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\n  animation: ",
        " 0.75s steps(12, end) infinite;\n  animation-duration: 0.75s;\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject5() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\n  stroke-width: ",
        "px;\n  stroke-linecap: round;\n\n  &:nth-child(12n + 0) {\n    stroke-opacity: 0.08;\n  }\n\n  &:nth-child(12n + 1) {\n    stroke-opacity: 0.17;\n  }\n\n  &:nth-child(12n + 2) {\n    stroke-opacity: 0.25;\n  }\n\n  &:nth-child(12n + 3) {\n    stroke-opacity: 0.33;\n  }\n\n  &:nth-child(12n + 4) {\n    stroke-opacity: 0.42;\n  }\n\n  &:nth-child(12n + 5) {\n    stroke-opacity: 0.5;\n  }\n\n  &:nth-child(12n + 6) {\n    stroke-opacity: 0.58;\n  }\n\n  &:nth-child(12n + 7) {\n    stroke-opacity: 0.66;\n  }\n\n  &:nth-child(12n + 8) {\n    stroke-opacity: 0.75;\n  }\n\n  &:nth-child(12n + 9) {\n    stroke-opacity: 0.83;\n  }\n\n  &:nth-child(12n + 11) {\n    stroke-opacity: 0.92;\n  }\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject6() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\nto {\n   stroke-dashoffset: 136;\n }\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject7() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\n  stroke-dasharray: 17;\n  animation: ",
        " 2.5s cubic-bezier(0.35, 0.04, 0.63, 0.95) infinite;\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function $715305e2ea9c3de1$var$_templateObject8() {
    var data = (0, $161d7c7c971d371f$export$71511d61b312f219)([
        "\n  transform-origin: 50% 65%;\n"
    ]);
    $715305e2ea9c3de1$var$_templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
// Such export is called Tree Shaking. It allows to import only the components
// that are needed while webpack will remove the rest of the code from the bundle.
var $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c = "#4fa94d";
var $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18 = {
    "aria-busy": true,
    role: "progressbar"
};
var $715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56 = (0, $5a013a0873ae9228$export$2e2bcd8739ae039).div($715305e2ea9c3de1$var$_templateObject(), function(props) {
    return props.$visible ? "flex" : "none";
});
var $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c = "http://www.w3.org/2000/svg";
var $715305e2ea9c3de1$export$153755f98d9861de = function(param) {
    var tmp = param.height, height = tmp === void 0 ? "100" : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "100" : tmp1, tmp2 = param.color, color = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, tmp3 = param.ariaLabel, ariaLabel = tmp3 === void 0 ? "audio-loading" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, wrapperClass = param.wrapperClass, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        $visible: visible,
        style: (0, $eRslx._)({}, wrapperStyle),
        className: wrapperClass,
        "data-testid": "audio-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            height: "".concat(height),
            width: "".concat(width),
            fill: color,
            viewBox: "0 0 55 80",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "audio-svg",
            children: [
                (0, $cc6u1.jsx)("title", {
                    children: "Audio Visualization"
                }),
                (0, $cc6u1.jsx)("desc", {
                    children: "Animated representation of audio data"
                }),
                (0, $cc6u1.jsxs)("g", {
                    transform: "matrix(1 0 0 -1 0 80)",
                    children: [
                        (0, $cc6u1.jsx)("rect", {
                            width: "10",
                            height: "20",
                            rx: "3",
                            children: (0, $cc6u1.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "4.3s",
                                values: "20;45;57;80;64;32;66;45;64;23;66;13;64;56;34;34;2;23;76;79;20",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $cc6u1.jsx)("rect", {
                            x: "15",
                            width: "10",
                            height: "80",
                            rx: "3",
                            children: (0, $cc6u1.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "80;55;33;5;75;23;73;33;12;14;60;80",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $cc6u1.jsx)("rect", {
                            x: "30",
                            width: "10",
                            height: "50",
                            rx: "3",
                            children: (0, $cc6u1.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "1.4s",
                                values: "50;34;78;23;56;23;34;76;80;54;21;50",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $cc6u1.jsx)("rect", {
                            x: "45",
                            width: "10",
                            height: "30",
                            rx: "3",
                            children: (0, $cc6u1.jsx)("animate", {
                                attributeName: "height",
                                begin: "0s",
                                dur: "2s",
                                values: "30;45;13;80;56;72;45;76;34;23;67;30",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$68949ad0373623af = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 100 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 100 : tmp1, tmp2 = param.radius, radius = tmp2 === void 0 ? 5 : tmp2, tmp3 = param.color, color = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.ariaLabel, ariaLabel = tmp4 === void 0 ? "ball-triangle-loading" : tmp4, wrapperClass = param.wrapperClass, wrapperStyle = param.wrapperStyle, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: (0, $eRslx._)({}, wrapperStyle),
        $visible: visible,
        className: wrapperClass,
        "data-testid": "ball-triangle-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            height: height,
            width: width,
            stroke: color,
            viewBox: "0 0 57 57",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "ball-triangle-svg",
            children: [
                (0, $cc6u1.jsx)("title", {
                    children: "Ball Triangle"
                }),
                (0, $cc6u1.jsx)("desc", {
                    children: "Animated representation of three balls"
                }),
                (0, $cc6u1.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $cc6u1.jsxs)("g", {
                        transform: "translate(1 1)",
                        strokeWidth: "2",
                        children: [
                            (0, $cc6u1.jsxs)("circle", {
                                cx: "5",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $cc6u1.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;5;50;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $cc6u1.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "5;27;49;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $cc6u1.jsxs)("circle", {
                                cx: "27",
                                cy: "5",
                                r: radius,
                                children: [
                                    (0, $cc6u1.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "5",
                                        to: "5",
                                        values: "5;50;50;5",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $cc6u1.jsx)("animate", {
                                        attributeName: "cx",
                                        begin: "0s",
                                        dur: "2.2s",
                                        from: "27",
                                        to: "27",
                                        values: "27;49;5;27",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            }),
                            (0, $cc6u1.jsxs)("circle", {
                                cx: "49",
                                cy: "50",
                                r: radius,
                                children: [
                                    (0, $cc6u1.jsx)("animate", {
                                        attributeName: "cy",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "50;50;5;50",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    }),
                                    (0, $cc6u1.jsx)("animate", {
                                        attributeName: "cx",
                                        from: "49",
                                        to: "49",
                                        begin: "0s",
                                        dur: "2.2s",
                                        values: "49;5;27;49",
                                        calcMode: "linear",
                                        repeatCount: "indefinite"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$fbc7d6f7dd821b47 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.color, color = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, tmp3 = param.ariaLabel, ariaLabel = tmp3 === void 0 ? "bars-loading" : tmp3, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp4 = param.visible, visible = tmp4 === void 0 ? true : tmp4;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        $visible: visible,
        style: (0, $eRslx._)({}, wrapperStyle),
        className: wrapperClass,
        "data-testid": "bars-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            width: width,
            height: height,
            fill: color,
            viewBox: "0 0 135 140",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "bars-svg",
            children: [
                (0, $cc6u1.jsxs)("rect", {
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $cc6u1.jsxs)("rect", {
                    x: "30",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $cc6u1.jsxs)("rect", {
                    x: "60",
                    width: "15",
                    height: "140",
                    rx: "6",
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "height",
                            begin: "0s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "y",
                            begin: "0s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $cc6u1.jsxs)("rect", {
                    x: "90",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.25s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.25s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $cc6u1.jsxs)("rect", {
                    x: "120",
                    y: "10",
                    width: "15",
                    height: "120",
                    rx: "6",
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "height",
                            begin: "0.5s",
                            dur: "1s",
                            values: "120;110;100;90;80;70;60;50;40;140;120",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "y",
                            begin: "0.5s",
                            dur: "1s",
                            values: "10;15;20;25;30;35;40;45;50;0;10",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$765808835a2dc0a2 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.color, color = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, tmp3 = param.ariaLabel, ariaLabel = tmp3 === void 0 ? "circles-loading" : tmp3, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp4 = param.visible, visible = tmp4 === void 0 ? true : tmp4;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "circles-loading"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 135 135",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "circles-svg",
            children: [
                (0, $cc6u1.jsx)("title", {
                    children: "circles-loading"
                }),
                (0, $cc6u1.jsx)("desc", {
                    children: "Animated representation of circles"
                }),
                (0, $cc6u1.jsx)("path", {
                    d: "M67.447 58c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10zm9.448 9.447c0 5.523 4.477 10 10 10 5.522 0 10-4.477 10-10s-4.478-10-10-10c-5.523 0-10 4.477-10 10zm-9.448 9.448c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c0-5.523-4.477-10-10-10zM58 67.447c0-5.523-4.477-10-10-10s-10 4.477-10 10 4.477 10 10 10 10-4.477 10-10z",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "-360 67 67",
                        dur: "2.5s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("path", {
                    d: "M28.19 40.31c6.627 0 12-5.374 12-12 0-6.628-5.373-12-12-12-6.628 0-12 5.372-12 12 0 6.626 5.372 12 12 12zm30.72-19.825c4.686 4.687 12.284 4.687 16.97 0 4.686-4.686 4.686-12.284 0-16.97-4.686-4.687-12.284-4.687-16.97 0-4.687 4.686-4.687 12.284 0 16.97zm35.74 7.705c0 6.627 5.37 12 12 12 6.626 0 12-5.373 12-12 0-6.628-5.374-12-12-12-6.63 0-12 5.372-12 12zm19.822 30.72c-4.686 4.686-4.686 12.284 0 16.97 4.687 4.686 12.285 4.686 16.97 0 4.687-4.686 4.687-12.284 0-16.97-4.685-4.687-12.283-4.687-16.97 0zm-7.704 35.74c-6.627 0-12 5.37-12 12 0 6.626 5.373 12 12 12s12-5.374 12-12c0-6.63-5.373-12-12-12zm-30.72 19.822c-4.686-4.686-12.284-4.686-16.97 0-4.686 4.687-4.686 12.285 0 16.97 4.686 4.687 12.284 4.687 16.97 0 4.687-4.685 4.687-12.283 0-16.97zm-35.74-7.704c0-6.627-5.372-12-12-12-6.626 0-12 5.373-12 12s5.374 12 12 12c6.628 0 12-5.373 12-12zm-19.823-30.72c4.687-4.686 4.687-12.284 0-16.97-4.686-4.686-12.284-4.686-16.97 0-4.687 4.686-4.687 12.284 0 16.97 4.686 4.687 12.284 4.687 16.97 0z",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 67 67",
                        to: "360 67 67",
                        dur: "8s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$17c11650828d97e = function(param) {
    var tmp = param.wrapperStyle, wrapperStyle = tmp === void 0 ? {} : tmp, tmp1 = param.visible, visible = tmp1 === void 0 ? true : tmp1, tmp2 = param.wrapperClass, wrapperClass = tmp2 === void 0 ? "" : tmp2, tmp3 = param.height, height = tmp3 === void 0 ? 100 : tmp3, tmp4 = param.width, width = tmp4 === void 0 ? 100 : tmp4, tmp5 = param.color, color = tmp5 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp5, outerCircleColor = param.outerCircleColor, innerCircleColor = param.innerCircleColor, barColor = param.barColor, tmp6 = param.ariaLabel, ariaLabel = tmp6 === void 0 ? "circles-with-bar-loading" : tmp6;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        "data-testid": "circles-with-bar-wrapper",
        children: (0, $cc6u1.jsxs)("svg", {
            version: "1.1",
            id: "L1",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            height: "".concat(height),
            width: "".concat(width),
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "circles-with-bar-svg",
            children: [
                (0, $cc6u1.jsx)("title", {
                    children: "circles-with-bar-loading"
                }),
                (0, $cc6u1.jsx)("desc", {
                    children: "Animated representation of circles with bar"
                }),
                (0, $cc6u1.jsx)("circle", {
                    fill: "none",
                    stroke: "".concat(outerCircleColor || color),
                    strokeWidth: "6",
                    strokeMiterlimit: "15",
                    strokeDasharray: "14.2472,14.2472",
                    cx: "50",
                    cy: "50",
                    r: "47",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    fill: "none",
                    stroke: "".concat(innerCircleColor || color),
                    strokeWidth: "1",
                    strokeMiterlimit: "10",
                    strokeDasharray: "10,10",
                    cx: "50",
                    cy: "50",
                    r: "39",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "5s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsxs)("g", {
                    fill: "".concat(barColor || color),
                    "data-testid": "circles-with-bar-svg-bar",
                    children: [
                        (0, $cc6u1.jsx)("rect", {
                            x: "30",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.1"
                            })
                        }),
                        (0, $cc6u1.jsx)("rect", {
                            x: "40",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.2"
                            })
                        }),
                        (0, $cc6u1.jsx)("rect", {
                            x: "50",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.3"
                            })
                        }),
                        (0, $cc6u1.jsx)("rect", {
                            x: "60",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.4"
                            })
                        }),
                        (0, $cc6u1.jsx)("rect", {
                            x: "70",
                            y: "35",
                            width: "5",
                            height: "30",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                dur: "1s",
                                type: "translate",
                                values: "0 5 ; 0 -5; 0 5",
                                repeatCount: "indefinite",
                                begin: "0.5"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$ef2184bd89960b14 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.radius, radius = tmp2 === void 0 ? 12.5 : tmp2, tmp3 = param.color, color = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.ariaLabel, ariaLabel = tmp4 === void 0 ? "grid-loading" : tmp4, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "grid-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 105 105",
            fill: color,
            "data-testid": "grid-svg",
            children: [
                (0, $cc6u1.jsx)("circle", {
                    cx: "12.5",
                    cy: "12.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "12.5",
                    cy: "52.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "100ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "52.5",
                    cy: "12.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "300ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "52.5",
                    cy: "52.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "600ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "92.5",
                    cy: "12.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "800ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "92.5",
                    cy: "52.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "400ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "12.5",
                    cy: "92.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "700ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "52.5",
                    cy: "92.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "500ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("circle", {
                    cx: "92.5",
                    cy: "92.5",
                    r: "".concat(radius),
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "200ms",
                        dur: "1s",
                        values: "1;.2;1",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$2da2f0c7403af3ce = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.color, color = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, tmp3 = param.ariaLabel, ariaLabel = tmp3 === void 0 ? "hearts-loading" : tmp3, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp4 = param.visible, visible = tmp4 === void 0 ? true : tmp4;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "hearts-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 140 64",
            xmlns: "http://www.w3.org/2000/svg",
            fill: color,
            "data-testid": "hearts-svg",
            children: [
                (0, $cc6u1.jsx)("path", {
                    d: "M30.262 57.02L7.195 40.723c-5.84-3.976-7.56-12.06-3.842-18.063 3.715-6 11.467-7.65 17.306-3.68l4.52 3.76 2.6-5.274c3.717-6.002 11.47-7.65 17.305-3.68 5.84 3.97 7.56 12.054 3.842 18.062L34.49 56.118c-.897 1.512-2.793 1.915-4.228.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("path", {
                    d: "M105.512 56.12l-14.44-24.272c-3.716-6.008-1.996-14.093 3.843-18.062 5.835-3.97 13.588-2.322 17.306 3.68l2.6 5.274 4.52-3.76c5.84-3.97 13.592-2.32 17.307 3.68 3.718 6.003 1.998 14.088-3.842 18.064L109.74 57.02c-1.434 1.014-3.33.61-4.228-.9z",
                    attributeName: "fill-opacity",
                    from: "0",
                    to: ".5",
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill-opacity",
                        begin: "0.7s",
                        dur: "1.4s",
                        values: "0.5;1;0.5",
                        calcMode: "linear",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("path", {
                    d: "M67.408 57.834l-23.01-24.98c-5.864-6.15-5.864-16.108 0-22.248 5.86-6.14 15.37-6.14 21.234 0L70 16.168l4.368-5.562c5.863-6.14 15.375-6.14 21.235 0 5.863 6.14 5.863 16.098 0 22.247l-23.007 24.98c-1.43 1.556-3.757 1.556-5.188 0z"
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len = 242.776657104492;
var $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$time = 1.6;
var $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$anim = (0, $5a013a0873ae9228$export$d25ddfdf17c3ad3e)($715305e2ea9c3de1$var$_templateObject1(), $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len * 0.14, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len * 0.11, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len * 0.35, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len * 0.35, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len * 0.01, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len * 0.99);
var $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$Path = (0, $5a013a0873ae9228$export$2e2bcd8739ae039).path($715305e2ea9c3de1$var$_templateObject2(), $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len * 0.01, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$len, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$anim, $715305e2ea9c3de1$var$$ad60b992c945fdb5$var$time);
var $715305e2ea9c3de1$export$8009d4483dfda42 = function(param) {
    var tmp = param.color, color = tmp === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "200" : tmp1;
    return (0, $cc6u1.jsxs)("svg", {
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: "".concat(width),
        height: "".concat(Number(width) * 0.5),
        viewBox: "0 0 ".concat(width, " ").concat(Number(100)),
        "data-testid": "infinity-spin",
        children: [
            (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$ad60b992c945fdb5$var$Path, {
                "data-testid": "infinity-spin-path-1",
                stroke: color,
                fill: "none",
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            }),
            (0, $cc6u1.jsx)("path", {
                "data-testid": "infinity-spin-path-2",
                opacity: "0.07",
                fill: "none",
                stroke: color,
                strokeWidth: "4",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: "10",
                d: "M93.9,46.4c9.3,9.5,13.8,17.9,23.5,17.9s17.5-7.8,17.5-17.5s-7.8-17.6-17.5-17.5c-9.7,0.1-13.3,7.2-22.1,17.1 c-8.9,8.8-15.7,17.9-25.4,17.9s-17.5-7.8-17.5-17.5s7.8-17.5,17.5-17.5S86.2,38.6,93.9,46.4z"
            })
        ]
    });
};
var $715305e2ea9c3de1$export$d2101d81f63866ab = function(param) {
    var tmp = param.wrapperStyle, wrapperStyle = tmp === void 0 ? {} : tmp, tmp1 = param.visible, visible = tmp1 === void 0 ? true : tmp1, tmp2 = param.wrapperClass, wrapperClass = tmp2 === void 0 ? "" : tmp2, tmp3 = param.height, height = tmp3 === void 0 ? 100 : tmp3, tmp4 = param.width, width = tmp4 === void 0 ? 100 : tmp4, tmp5 = param.color, color = tmp5 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp5, tmp6 = param.ariaLabel, ariaLabel = tmp6 === void 0 ? "line-wave-loading" : tmp6, firstLineColor = param.firstLineColor, middleLineColor = param.middleLineColor, lastLineColor = param.lastLineColor;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "line-wave-wrapper",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            version: "1.1",
            height: "".concat(height),
            width: "".concat(width),
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 0 0",
            xmlSpace: "preserve",
            "data-testid": "line-wave-svg",
            children: [
                (0, $cc6u1.jsx)("rect", {
                    x: "20",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: firstLineColor || color,
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("rect", {
                    x: "30",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: middleLineColor || color,
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.2s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("rect", {
                    x: "40",
                    y: "50",
                    width: "4",
                    height: "10",
                    fill: lastLineColor || color,
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeType: "xml",
                        attributeName: "transform",
                        type: "translate",
                        values: "0 0; 0 20; 0 0",
                        begin: "0.4s",
                        dur: "0.6s",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$64ea884904791f4 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 90 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.radius, radius = tmp2 === void 0 ? 12.5 : tmp2, tmp3 = param.color, color = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.secondaryColor, secondaryColor = tmp4 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "mutating-dots-loading" : tmp5, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp6 = param.visible, visible = tmp6 === void 0 ? true : tmp6;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "mutating-dots-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            id: "goo-loader",
            width: width,
            height: height,
            "data-testid": "mutating-dots-svg",
            children: [
                (0, $cc6u1.jsxs)("filter", {
                    id: "fancy-goo",
                    children: [
                        (0, $cc6u1.jsx)("feGaussianBlur", {
                            in: "SourceGraphic",
                            stdDeviation: "6",
                            result: "blur"
                        }),
                        (0, $cc6u1.jsx)("feColorMatrix", {
                            in: "blur",
                            mode: "matrix",
                            values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9",
                            result: "goo"
                        }),
                        (0, $cc6u1.jsx)("feComposite", {
                            in: "SourceGraphic",
                            in2: "goo",
                            operator: "atop"
                        })
                    ]
                }),
                (0, $cc6u1.jsxs)("g", {
                    filter: "url(#fancy-goo)",
                    children: [
                        (0, $cc6u1.jsx)("animateTransform", {
                            id: "mainAnim",
                            attributeName: "transform",
                            attributeType: "XML",
                            type: "rotate",
                            from: "0 50 50",
                            to: "359 50 50",
                            dur: "1.2s",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("circle", {
                            cx: "50%",
                            cy: "40",
                            r: radius,
                            fill: color,
                            children: (0, $cc6u1.jsx)("animate", {
                                id: "cAnim1",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0;cAnim1.end+0.2s",
                                calcMode: "spline",
                                values: "40;20;40",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        }),
                        (0, $cc6u1.jsx)("circle", {
                            cx: "50%",
                            cy: "60",
                            r: radius,
                            fill: secondaryColor,
                            children: (0, $cc6u1.jsx)("animate", {
                                id: "cAnim2",
                                attributeType: "XML",
                                attributeName: "cy",
                                dur: "0.6s",
                                begin: "0.4s;cAnim2.end+0.2s",
                                calcMode: "spline",
                                values: "60;80;60",
                                keyTimes: "0;0.3;1",
                                keySplines: "0.09, 0.45, 0.16, 1;0.09, 0.45, 0.16, 1"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};
/**
 * The radius of the circle
 * The Loader size is set with the width and height of the SVG
 * @type {number}
 */ var $715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$RADIUS = 20;
/**
 * Compute Path depending on circle radius
 * The structure with radius 20 is "M20 0c0-9.94-8.06-20-20-20"
 * @param radius of the circle radius default 20
 * @returns {string}
 */ var $715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$getPath = function(radius) {
    return [
        "M" + radius + " 0c0-9.94-8.06",
        radius,
        radius,
        radius
    ].join("-");
};
/**
 * Compute the size of the view box depending on the radius and Stroke-Width
 * @param strokeWidth Stroke-Width of the full circle
 * @param secondaryStrokeWidth Stroke-Width of the 1/4 circle
 * @param radius radius of the circle
 * @returns {string}
 */ var $715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$getViewBoxSize = function(strokeWidth, secondaryStrokeWidth, radius) {
    var maxStrokeWidth = Math.max(strokeWidth, secondaryStrokeWidth);
    var startingPoint = -radius - maxStrokeWidth / 2 + 1;
    var endpoint = radius * 2 + maxStrokeWidth;
    return [
        startingPoint,
        startingPoint,
        endpoint,
        endpoint
    ].join(" ");
};
var $715305e2ea9c3de1$export$67ad50c48ca3ede4 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.color, color = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, tmp3 = param.secondaryColor, secondaryColor = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.ariaLabel, ariaLabel = tmp4 === void 0 ? "oval-loading" : tmp4, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5, tmp6 = param.strokeWidth, strokeWidth = tmp6 === void 0 ? 2 : tmp6, strokeWidthSecondary = param.strokeWidthSecondary;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "oval-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsx)("svg", {
            width: width,
            height: height,
            viewBox: $715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$getViewBoxSize(Number(strokeWidth), Number(strokeWidthSecondary || strokeWidth), $715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$RADIUS),
            xmlns: "http://www.w3.org/2000/svg",
            stroke: color,
            "data-testid": "oval-svg",
            children: (0, $cc6u1.jsx)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: (0, $cc6u1.jsxs)("g", {
                    transform: "translate(1 1)",
                    strokeWidth: Number(strokeWidthSecondary || strokeWidth),
                    "data-testid": "oval-secondary-group",
                    children: [
                        (0, $cc6u1.jsx)("circle", {
                            strokeOpacity: ".5",
                            cx: "0",
                            cy: "0",
                            r: $715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$RADIUS,
                            stroke: secondaryColor,
                            strokeWidth: strokeWidth
                        }),
                        (0, $cc6u1.jsx)("path", {
                            d: $715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$getPath($715305e2ea9c3de1$var$$a5fa864d4dd36deb$var$RADIUS),
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                from: "0 0 0",
                                to: "360 0 0",
                                dur: "1s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    }));
};
var $715305e2ea9c3de1$export$83d2259ec538613b = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.radius, radius = tmp2 === void 0 ? 1 : tmp2, tmp3 = param.color, color = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.ariaLabel, ariaLabel = tmp4 === void 0 ? "puff-loading" : tmp4, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "puff-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 44 44",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "puff-svg",
            children: (0, $cc6u1.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                strokeWidth: "2",
                children: [
                    (0, $cc6u1.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "r",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "0s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $cc6u1.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        children: [
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "r",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 20",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.165, 0.84, 0.44, 1",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "-0.9s",
                                dur: "1.8s",
                                values: "1; 0",
                                calcMode: "spline",
                                keyTimes: "0; 1",
                                keySplines: "0.3, 0.61, 0.355, 1",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        })
    }));
};
var $715305e2ea9c3de1$export$8e22e563e5362f75 = function(param) {
    var tmp = param.radius, radius = tmp === void 0 ? 45 : tmp, tmp1 = param.strokeWidth, strokeWidth = tmp1 === void 0 ? 5 : tmp1, tmp2 = param.color, color = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, secondaryColor = param.secondaryColor, tmp3 = param.ariaLabel, ariaLabel = tmp3 === void 0 ? "revolving-dot-loading" : tmp3, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp4 = param.visible, visible = tmp4 === void 0 ? true : tmp4;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "aria-label": ariaLabel,
        "data-testid": "revolving-dot-loading"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            version: "1.1",
            width: "calc(".concat(radius, " * 2.5)"),
            height: "calc(".concat(radius, " * 2.5)"),
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            "data-testid": "revolving-dot-svg",
            children: [
                (0, $cc6u1.jsx)("circle", {
                    fill: "none",
                    stroke: secondaryColor || color,
                    strokeWidth: strokeWidth,
                    cx: "calc(".concat(radius, " * 1.28)"),
                    cy: "calc(".concat(radius, " * 1.28)"),
                    r: radius,
                    style: {
                        opacity: 0.5
                    }
                }),
                (0, $cc6u1.jsx)("circle", {
                    fill: color,
                    stroke: color,
                    strokeWidth: "3",
                    cx: "calc(".concat(radius, " * 1.28)"),
                    cy: "calc(".concat(radius, " / 3.5)"),
                    r: "calc(".concat(radius, " / 5)"),
                    style: {
                        transformOrigin: "50% 50%"
                    },
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0",
                        to: "360",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$fdd9e2f491a77de7 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.radius, radius = tmp2 === void 0 ? 6 : tmp2, tmp3 = param.color, color = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.ariaLabel, ariaLabel = tmp4 === void 0 ? "rings-loading" : tmp4, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rings-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsx)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 45 45",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            stroke: color,
            "data-testid": "rings-svg",
            children: (0, $cc6u1.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                transform: "translate(1 1)",
                strokeWidth: "2",
                children: [
                    (0, $cc6u1.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "r",
                                begin: "1.5s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "stroke-opacity",
                                begin: "1.5s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "stroke-width",
                                begin: "1.5s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $cc6u1.jsxs)("circle", {
                        cx: "22",
                        cy: "22",
                        r: radius,
                        strokeOpacity: "0",
                        children: [
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "r",
                                begin: "3s",
                                dur: "3s",
                                values: "6;22",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "strokeOpacity",
                                begin: "3s",
                                dur: "3s",
                                values: "1;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "strokeWidth",
                                begin: "3s",
                                dur: "3s",
                                values: "2;0",
                                calcMode: "linear",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $cc6u1.jsx)("circle", {
                        cx: "22",
                        cy: "22",
                        r: Number(radius) + 2,
                        children: (0, $cc6u1.jsx)("animate", {
                            attributeName: "r",
                            begin: "0s",
                            dur: "1.5s",
                            values: "6;1;2;3;4;5;6",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    })
                ]
            })
        })
    }));
};
var $715305e2ea9c3de1$export$bb511942ded86554 = function(param) {
    var tmp = param.wrapperClass, wrapperClass = tmp === void 0 ? "" : tmp, tmp1 = param.color, color = tmp1 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp1, tmp2 = param.height, height = tmp2 === void 0 ? 100 : tmp2, tmp3 = param.width, width = tmp3 === void 0 ? 100 : tmp3, tmp4 = param.strokeWidth, strokeWidth = tmp4 === void 0 ? 4 : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "rotating-square-loading" : tmp5, tmp6 = param.wrapperStyle, wrapperStyle = tmp6 === void 0 ? {} : tmp6, tmp7 = param.visible, visible = tmp7 === void 0 ? true : tmp7;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "rotating-square-wrapper",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            version: "1.1",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            height: "".concat(height),
            width: "".concat(width),
            "data-testid": "rotating-square-svg",
            xmlSpace: "preserve",
            children: [
                (0, $cc6u1.jsx)("rect", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: strokeWidth,
                    x: "25",
                    y: "25",
                    width: "50",
                    height: "50",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "0.5s",
                        from: "0 50 50",
                        to: "180 50 50",
                        type: "rotate",
                        id: "strokeBox",
                        attributeType: "XML",
                        begin: "rectBox.end"
                    })
                }),
                (0, $cc6u1.jsx)("rect", {
                    x: "27",
                    y: "27",
                    fill: color,
                    width: "46",
                    height: "50",
                    children: (0, $cc6u1.jsx)("animate", {
                        attributeName: "height",
                        dur: "1.3s",
                        attributeType: "XML",
                        from: "50",
                        to: "0",
                        id: "rectBox",
                        fill: "freeze",
                        begin: "0s;strokeBox.end"
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$var$$5819da83a926266a$var$POINTS = [
    0,
    30,
    60,
    90,
    120,
    150,
    180,
    210,
    240,
    270,
    300,
    330
];
var $715305e2ea9c3de1$var$$5819da83a926266a$var$spin = (0, $5a013a0873ae9228$export$d25ddfdf17c3ad3e)($715305e2ea9c3de1$var$_templateObject3());
var $715305e2ea9c3de1$var$$5819da83a926266a$var$Svg = (0, $5a013a0873ae9228$export$2e2bcd8739ae039).svg($715305e2ea9c3de1$var$_templateObject4(), $715305e2ea9c3de1$var$$5819da83a926266a$var$spin);
var $715305e2ea9c3de1$var$$5819da83a926266a$var$Polyline = (0, $5a013a0873ae9228$export$2e2bcd8739ae039).polyline($715305e2ea9c3de1$var$_templateObject5(), function(props) {
    return props.width;
});
var $715305e2ea9c3de1$export$d20df8773b6b77b5 = function(param) {
    var tmp = param.strokeColor, strokeColor = tmp === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp, tmp1 = param.strokeWidth, strokeWidth = tmp1 === void 0 ? "5" : tmp1, tmp2 = param.animationDuration, animationDuration = tmp2 === void 0 ? "0.75" : tmp2, tmp3 = param.width, width = tmp3 === void 0 ? "96" : tmp3, tmp4 = param.visible, visible = tmp4 === void 0 ? true : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "rotating-lines-loading" : tmp5;
    var lines = (0, $fIwXP.useCallback)(function() {
        return $715305e2ea9c3de1$var$$5819da83a926266a$var$POINTS.map(function(point) {
            return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$5819da83a926266a$var$Polyline, {
                points: "24,12 24,4",
                width: strokeWidth,
                transform: "rotate(".concat(point, ", 24, 24)")
            }, point);
        });
    }, [
        strokeWidth
    ]);
    return !visible ? null : (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$5819da83a926266a$var$Svg, (0, $kJeRc._)((0, $eRslx._)({
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 48 48",
        width: width,
        stroke: strokeColor,
        speed: animationDuration,
        "data-testid": "rotating-lines-svg",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: lines()
    }));
};
var $715305e2ea9c3de1$export$f8e5ae7506d65b32 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.strokeWidth, strokeWidth = tmp2 === void 0 ? 2 : tmp2, tmp3 = param.radius, radius = tmp3 === void 0 ? 1 : tmp3, tmp4 = param.color, color = tmp4 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "tail-spin-loading" : tmp5, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp6 = param.visible, visible = tmp6 === void 0 ? true : tmp6;
    var strokeWidthNum = parseInt(String(strokeWidth));
    var viewBoxValue = strokeWidthNum + 36;
    var halfStrokeWidth = strokeWidthNum / 2;
    var processedRadius = halfStrokeWidth + parseInt(String(radius)) - 1;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "tail-spin-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 ".concat(viewBoxValue, " ").concat(viewBoxValue),
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            "data-testid": "tail-spin-svg",
            children: [
                (0, $cc6u1.jsx)("defs", {
                    children: (0, $cc6u1.jsxs)("linearGradient", {
                        x1: "8.042%",
                        y1: "0%",
                        x2: "65.682%",
                        y2: "23.865%",
                        id: "a",
                        children: [
                            (0, $cc6u1.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: "0",
                                offset: "0%"
                            }),
                            (0, $cc6u1.jsx)("stop", {
                                stopColor: color,
                                stopOpacity: ".631",
                                offset: "63.146%"
                            }),
                            (0, $cc6u1.jsx)("stop", {
                                stopColor: color,
                                offset: "100%"
                            })
                        ]
                    })
                }),
                (0, $cc6u1.jsx)("g", {
                    fill: "none",
                    fillRule: "evenodd",
                    children: (0, $cc6u1.jsxs)("g", {
                        transform: "translate(".concat(halfStrokeWidth, " ").concat(halfStrokeWidth, ")"),
                        children: [
                            (0, $cc6u1.jsx)("path", {
                                d: "M36 18c0-9.94-8.06-18-18-18",
                                id: "Oval-2",
                                stroke: color,
                                strokeWidth: strokeWidth,
                                children: (0, $cc6u1.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            }),
                            (0, $cc6u1.jsx)("circle", {
                                fill: "#fff",
                                cx: "36",
                                cy: "18",
                                r: processedRadius,
                                children: (0, $cc6u1.jsx)("animateTransform", {
                                    attributeName: "transform",
                                    type: "rotate",
                                    from: "0 18 18",
                                    to: "360 18 18",
                                    dur: "0.9s",
                                    repeatCount: "indefinite"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$e21573137ccb7f5d = function(param) {
    var tmp = param.wrapperStyle, wrapperStyle = tmp === void 0 ? {} : tmp, tmp1 = param.visible, visible = tmp1 === void 0 ? true : tmp1, tmp2 = param.wrapperClass, wrapperClass = tmp2 === void 0 ? "" : tmp2, tmp3 = param.height, height = tmp3 === void 0 ? 100 : tmp3, tmp4 = param.width, width = tmp4 === void 0 ? 100 : tmp4, tmp5 = param.color, color = tmp5 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp5, tmp6 = param.ariaLabel, ariaLabel = tmp6 === void 0 ? "three-circles-loading" : tmp6, outerCircleColor = param.outerCircleColor, innerCircleColor = param.innerCircleColor, middleCircleColor = param.middleCircleColor;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-circles-wrapper",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            version: "1.1",
            height: "".concat(height),
            width: "".concat(width),
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "three-circles-svg",
            children: [
                (0, $cc6u1.jsx)("path", {
                    fill: outerCircleColor || color,
                    d: "M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("path", {
                    fill: middleCircleColor || color,
                    d: "M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "1s",
                        from: "0 50 50",
                        to: "-360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("path", {
                    fill: innerCircleColor || color,
                    d: "M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        attributeType: "XML",
                        type: "rotate",
                        dur: "2s",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$4bf83b24a11cff0b = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.radius, radius = tmp2 === void 0 ? 9 : tmp2, tmp3 = param.color, color = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.ariaLabel, ariaLabel = tmp4 === void 0 ? "three-dots-loading" : tmp4, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "three-dots-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            width: width,
            height: height,
            viewBox: "0 0 120 30",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            fill: color,
            "data-testid": "three-dots-svg",
            children: [
                (0, $cc6u1.jsxs)("circle", {
                    cx: "15",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $cc6u1.jsxs)("circle", {
                    cx: "60",
                    cy: "15",
                    r: radius,
                    attributeName: "fill-opacity",
                    from: "1",
                    to: "0.3",
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "r",
                            from: "9",
                            to: "9",
                            begin: "0s",
                            dur: "0.8s",
                            values: "9;15;9",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "0.5",
                            to: "0.5",
                            begin: "0s",
                            dur: "0.8s",
                            values: ".5;1;.5",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                }),
                (0, $cc6u1.jsxs)("circle", {
                    cx: "105",
                    cy: "15",
                    r: Number(radius) + 6,
                    children: [
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "r",
                            from: "15",
                            to: "15",
                            begin: "0s",
                            dur: "0.8s",
                            values: "15;9;15",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        }),
                        (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill-opacity",
                            from: "1",
                            to: "1",
                            begin: "0s",
                            dur: "0.8s",
                            values: "1;.5;1",
                            calcMode: "linear",
                            repeatCount: "indefinite"
                        })
                    ]
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES = "-3 -4 39 39";
var $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$POLYGON_POINTS = "16,0 32,32 0,32";
/** Styles */ var $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$dash = (0, $5a013a0873ae9228$export$d25ddfdf17c3ad3e)($715305e2ea9c3de1$var$_templateObject6());
var $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$Polygon = (0, $5a013a0873ae9228$export$2e2bcd8739ae039).polygon($715305e2ea9c3de1$var$_templateObject7(), $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$dash);
var $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$SVG = (0, $5a013a0873ae9228$export$2e2bcd8739ae039).svg($715305e2ea9c3de1$var$_templateObject8());
var $715305e2ea9c3de1$export$5a465592bfe74b48 = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.color, color = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, tmp3 = param.ariaLabel, ariaLabel = tmp3 === void 0 ? "triangle-loading" : tmp3, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp4 = param.visible, visible = tmp4 === void 0 ? true : tmp4;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: "".concat(wrapperClass),
        "data-testid": "triangle-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$afa12dd3e98f740f$var$SVG, {
            id: "triangle",
            width: width,
            height: height,
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            viewBox: $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$VIEW_BOX_VALUES,
            "data-testid": "triangle-svg",
            children: (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$afa12dd3e98f740f$var$Polygon, {
                fill: "transparent",
                stroke: color,
                strokeWidth: "1",
                points: $715305e2ea9c3de1$var$$afa12dd3e98f740f$var$POLYGON_POINTS
            })
        })
    }));
};
var $715305e2ea9c3de1$export$4c68f1a79f88778c = function(param) {
    var tmp = param.height, height = tmp === void 0 ? 80 : tmp, tmp1 = param.width, width = tmp1 === void 0 ? 80 : tmp1, tmp2 = param.radius, radius = tmp2 === void 0 ? 48 : tmp2, tmp3 = param.color, color = tmp3 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp3, tmp4 = param.ariaLabel, ariaLabel = tmp4 === void 0 ? "watch-loading" : tmp4, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp5 = param.visible, visible = tmp5 === void 0 ? true : tmp5;
    return (0, $cc6u1.jsx)($715305e2ea9c3de1$var$$4c3f0b77e8caf06d$export$21d9f1931ef75b56, (0, $kJeRc._)((0, $eRslx._)({
        style: wrapperStyle,
        $visible: visible,
        className: wrapperClass,
        "data-testid": "watch-loading",
        "aria-label": ariaLabel
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("svg", {
            width: width,
            height: height,
            version: "1.1",
            id: "L2",
            xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
            x: "0px",
            y: "0px",
            viewBox: "0 0 100 100",
            enableBackground: "new 0 0 100 100",
            xmlSpace: "preserve",
            "data-testid": "watch-svg",
            children: [
                (0, $cc6u1.jsx)("circle", {
                    fill: "none",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    cx: "50",
                    cy: "50",
                    r: radius
                }),
                (0, $cc6u1.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "85",
                    y2: "50.5",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "2s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                }),
                (0, $cc6u1.jsx)("line", {
                    fill: "none",
                    strokeLinecap: "round",
                    stroke: color,
                    strokeWidth: "4",
                    strokeMiterlimit: "10",
                    x1: "50",
                    y1: "50",
                    x2: "49.5",
                    y2: "74",
                    children: (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        dur: "15s",
                        type: "rotate",
                        from: "0 50 50",
                        to: "360 50 50",
                        repeatCount: "indefinite"
                    })
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$1ed1943372cc63a9 = function(param) {
    var tmp = param.color, color = tmp === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "100" : tmp1, tmp2 = param.visible, visible = tmp2 === void 0 ? true : tmp2;
    return visible ? (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: width,
        viewBox: "0 0 100 100",
        "data-testid": "falling-lines"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-1",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.4s",
                        repeatCount: "indefinite"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("rect", {
                y: "25",
                width: "10",
                height: "50",
                rx: "4",
                ry: "4",
                fill: color,
                "data-testid": "falling-lines-rect-2",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "x",
                        values: "10;100",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $cc6u1.jsx)("animateTransform", {
                        attributeName: "transform",
                        type: "rotate",
                        from: "0 10 70",
                        to: "-60 100 70",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "opacity",
                        values: "0;1;0",
                        dur: "1.2s",
                        begin: "0.8s",
                        repeatCount: "indefinite"
                    })
                ]
            })
        ]
    })) : null;
};
var $715305e2ea9c3de1$export$d25f4198d7ad6c78 = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.height, height = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.width, width = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.ariaLabel, ariaLabel = tmp3 === void 0 ? "vortex-loading" : tmp3, wrapperStyle = param.wrapperStyle, wrapperClass = param.wrapperClass, tmp4 = param.colors, colors = tmp4 === void 0 ? [
        "#1B5299",
        "#EF8354",
        "#DB5461",
        "#1B5299",
        "#EF8354",
        "#DB5461"
    ] : tmp4;
    return !visible ? null : (0, $cc6u1.jsx)("svg", (0, $kJeRc._)((0, $eRslx._)({
        height: height,
        width: width,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "data-testid": "vortex-svg",
        "aria-label": ariaLabel,
        style: wrapperStyle,
        className: wrapperClass
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $cc6u1.jsx)("g", {
                transform: "scale(0.7)",
                children: (0, $cc6u1.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $cc6u1.jsxs)("g", {
                        transform: "rotate(137.831 50 50)",
                        children: [
                            (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                repeatCount: "indefinite",
                                values: "360 50 50;0 50 50",
                                keyTimes: "0;1",
                                dur: "1",
                                keySplines: "0.5 0.5 0.5 0.5",
                                calcMode: "spline"
                            }),
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[0],
                                d: "M30.4,9.7c-7.4,10.9-11.8,23.8-12.3,37.9c0.2,1,0.5,1.9,0.7,2.8c1.4-5.2,3.4-10.3,6.2-15.1 c2.6-4.4,5.6-8.4,9-12c0.7-0.7,1.4-1.4,2.1-2.1c7.4-7,16.4-12,26-14.6C51.5,3.6,40.2,4.9,30.4,9.7z"
                            }),
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[1],
                                d: "M24.8,64.2c-2.6-4.4-4.5-9.1-5.9-13.8c-0.3-0.9-0.5-1.9-0.7-2.8c-2.4-9.9-2.2-20.2,0.4-29.8 C10.6,25.5,6,36,5.3,46.8C11,58.6,20,68.9,31.9,76.3c0.9,0.3,1.9,0.5,2.8,0.8C31,73.3,27.6,69,24.8,64.2z"
                            }),
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[2],
                                d: "M49.6,78.9c-5.1,0-10.1-0.6-14.9-1.8c-1-0.2-1.9-0.5-2.8-0.8c-9.8-2.9-18.5-8.2-25.6-15.2 c2.8,10.8,9.5,20,18.5,26c13.1,0.9,26.6-1.7,38.9-8.3c0.7-0.7,1.4-1.4,2.1-2.1C60.7,78.2,55.3,78.9,49.6,78.9z"
                            }),
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[3],
                                d: "M81.1,49.6c-1.4,5.2-3.4,10.3-6.2,15.1c-2.6,4.4-5.6,8.4-9,12c-0.7,0.7-1.4,1.4-2.1,2.1 c-7.4,7-16.4,12-26,14.6c10.7,3,22.1,1.7,31.8-3.1c7.4-10.9,11.8-23.8,12.3-37.9C81.6,51.5,81.4,50.6,81.1,49.6z"
                            }),
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[4],
                                d: "M75.2,12.9c-13.1-0.9-26.6,1.7-38.9,8.3c-0.7,0.7-1.4,1.4-2.1,2.1c5.2-1.4,10.6-2.2,16.2-2.2 c5.1,0,10.1,0.6,14.9,1.8c1,0.2,1.9,0.5,2.8,0.8c9.8,2.9,18.5,8.2,25.6,15.2C90.9,28.1,84.2,18.9,75.2,12.9z"
                            }),
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[5],
                                d: "M94.7,53.2C89,41.4,80,31.1,68.1,23.7c-0.9-0.3-1.9-0.5-2.8-0.8c3.8,3.8,7.2,8.1,10,13 c2.6,4.4,4.5,9.1,5.9,13.8c0.3,0.9,0.5,1.9,0.7,2.8c2.4,9.9,2.2,20.2-0.4,29.8C89.4,74.5,94,64,94.7,53.2z"
                            })
                        ]
                    })
                })
            })
        })
    }));
};
var $715305e2ea9c3de1$export$f64f16a115ce395d = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.height, height = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.width, width = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "rotating-triangle-loading" : tmp5, tmp6 = param.colors, colors = tmp6 === void 0 ? [
        "#1B5299",
        "#EF8354",
        "#DB5461"
    ] : tmp6;
    return !visible ? null : (0, $cc6u1.jsx)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "rotating-triangle-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsx)("g", {
            transform: "translate(50,42)",
            children: (0, $cc6u1.jsx)("g", {
                transform: "scale(0.8)",
                children: (0, $cc6u1.jsxs)("g", {
                    transform: "translate(-50,-50)",
                    children: [
                        (0, $cc6u1.jsx)("polygon", {
                            points: "72.5,50 50,11 27.5,50 50,50",
                            fill: colors[0],
                            transform: "rotate(186 50 38.5)",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 50 38.5;360 50 38.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $cc6u1.jsx)("polygon", {
                            points: "5,89 50,89 27.5,50",
                            fill: colors[1],
                            transform: "rotate(186 27.5 77.5)",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 27.5 77.5;360 27.5 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        }),
                        (0, $cc6u1.jsx)("polygon", {
                            points: "72.5,50 50,89 95,89",
                            fill: colors[2],
                            transform: "rotate(186 72.2417 77.5)",
                            children: (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "rotate",
                                calcMode: "linear",
                                values: "0 72.5 77.5;360 72 77.5",
                                keyTimes: "0;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        })
                    ]
                })
            })
        })
    }));
};
var $715305e2ea9c3de1$export$d7b12c4107be0d61 = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.height, height = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.width, width = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "radio-loading" : tmp5, tmp6 = param.colors, colors = tmp6 === void 0 ? [
        $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
        $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c,
        $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c
    ] : tmp6;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "radio-bar-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsx)("circle", {
                cx: "28",
                cy: "75",
                r: "11",
                fill: colors[0],
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $cc6u1.jsx)("path", {
                d: "M28 47A28 28 0 0 1 56 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[1],
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.1s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $cc6u1.jsx)("path", {
                d: "M28 25A50 50 0 0 1 78 75",
                fill: "none",
                strokeWidth: "10",
                stroke: colors[2],
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "stroke-opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0.2s",
                    repeatCount: "indefinite"
                })
            })
        ]
    }));
};
var $715305e2ea9c3de1$export$c17561cb55d4db30 = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.height, height = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.width, width = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "progress-bar-loading" : tmp5, tmp6 = param.borderColor, borderColor = tmp6 === void 0 ? "#F4442E" : tmp6, tmp7 = param.barColor, barColor = tmp7 === void 0 ? "#51E5FF" : tmp7;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "progress-bar-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsx)("defs", {
                children: (0, $cc6u1.jsx)("clipPath", {
                    x: "0",
                    y: "0",
                    width: "100",
                    height: "100",
                    id: "lds-progress-cpid-5009611b8a418",
                    children: (0, $cc6u1.jsxs)("rect", {
                        x: "0",
                        y: "0",
                        width: "66.6667",
                        height: "100",
                        children: [
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "width",
                                calcMode: "linear",
                                values: "0;100;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "x",
                                calcMode: "linear",
                                values: "0;0;100",
                                keyTimes: "0;0.5;1",
                                dur: "1",
                                begin: "0s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                })
            }),
            (0, $cc6u1.jsx)("path", {
                fill: "none",
                strokeWidth: "2.7928",
                d: "M82,63H18c-7.2,0-13-5.8-13-13v0c0-7.2,5.8-13,13-13h64c7.2,0,13,5.8,13,13v0C95,57.2,89.2,63,82,63z",
                stroke: borderColor
            }),
            (0, $cc6u1.jsx)("path", {
                d: "M81.3,58.7H18.7c-4.8,0-8.7-3.9-8.7-8.7v0c0-4.8,3.9-8.7,8.7-8.7h62.7c4.8,0,8.7,3.9,8.7,8.7v0C90,54.8,86.1,58.7,81.3,58.7z",
                fill: barColor,
                clipPath: "url(#lds-progress-cpid-5009611b8a418)"
            })
        ]
    }));
};
var $715305e2ea9c3de1$export$bdf537af43a20db5 = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.height, height = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.width, width = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "magnifying-glass-loading" : tmp5, tmp6 = param.glassColor, glassColor = tmp6 === void 0 ? "#c0efff" : tmp6, tmp7 = param.color, color = tmp7 === void 0 ? "#e15b64" : tmp7;
    return !visible ? null : (0, $cc6u1.jsx)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "magnifying-glass-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsx)("g", {
            transform: "translate(50,50)",
            children: (0, $cc6u1.jsx)("g", {
                transform: "scale(0.82)",
                children: (0, $cc6u1.jsx)("g", {
                    transform: "translate(-50,-50)",
                    children: (0, $cc6u1.jsxs)("g", {
                        transform: "translate(16.3636 -20)",
                        children: [
                            (0, $cc6u1.jsx)("animateTransform", {
                                attributeName: "transform",
                                type: "translate",
                                calcMode: "linear",
                                values: "-20 -20;20 -20;0 20;-20 -20",
                                keyTimes: "0;0.33;0.66;1",
                                dur: "1s",
                                begin: "0s",
                                repeatCount: "indefinite"
                            }),
                            (0, $cc6u1.jsx)("path", {
                                d: "M44.19,26.158c-4.817,0-9.345,1.876-12.751,5.282c-3.406,3.406-5.282,7.934-5.282,12.751 c0,4.817,1.876,9.345,5.282,12.751c3.406,3.406,7.934,5.282,12.751,5.282s9.345-1.876,12.751-5.282 c3.406-3.406,5.282-7.934,5.282-12.751c0-4.817-1.876-9.345-5.282-12.751C53.536,28.033,49.007,26.158,44.19,26.158z",
                                fill: glassColor
                            }),
                            (0, $cc6u1.jsx)("path", {
                                d: "M78.712,72.492L67.593,61.373l-3.475-3.475c1.621-2.352,2.779-4.926,3.475-7.596c1.044-4.008,1.044-8.23,0-12.238 c-1.048-4.022-3.146-7.827-6.297-10.979C56.572,22.362,50.381,20,44.19,20C38,20,31.809,22.362,27.085,27.085 c-9.447,9.447-9.447,24.763,0,34.21C31.809,66.019,38,68.381,44.19,68.381c4.798,0,9.593-1.425,13.708-4.262l9.695,9.695 l4.899,4.899C73.351,79.571,74.476,80,75.602,80s2.251-0.429,3.11-1.288C80.429,76.994,80.429,74.209,78.712,72.492z M56.942,56.942 c-3.406,3.406-7.934,5.282-12.751,5.282s-9.345-1.876-12.751-5.282c-3.406-3.406-5.282-7.934-5.282-12.751 c0-4.817,1.876-9.345,5.282-12.751c3.406-3.406,7.934-5.282,12.751-5.282c4.817,0,9.345,1.876,12.751,5.282 c3.406,3.406,5.282,7.934,5.282,12.751C62.223,49.007,60.347,53.536,56.942,56.942z",
                                fill: color
                            })
                        ]
                    })
                })
            })
        })
    }));
};
var $715305e2ea9c3de1$export$8e3fad5cade57efa = function(param) {
    var tmp = param.width, width = tmp === void 0 ? "80" : tmp, tmp1 = param.height, height = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.backgroundColor, backgroundColor = tmp2 === void 0 ? $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$37394b0fa44b998c : tmp2, tmp3 = param.ballColors, ballColors = tmp3 === void 0 ? [
        "#fc636b",
        "#6a67ce",
        "#ffb900"
    ] : tmp3, tmp4 = param.wrapperClass, wrapperClass = tmp4 === void 0 ? "" : tmp4, tmp5 = param.wrapperStyle, wrapperStyle = tmp5 === void 0 ? {} : tmp5, tmp6 = param.ariaLabel, ariaLabel = tmp6 === void 0 ? "fidget-spinner-loader" : tmp6, tmp7 = param.visible, visible = tmp7 === void 0 ? true : tmp7;
    return !visible ? null : (0, $cc6u1.jsx)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "fidget-spinner-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: (0, $cc6u1.jsxs)("g", {
            transform: "rotate(6 50 50)",
            children: [
                (0, $cc6u1.jsx)("g", {
                    transform: "translate(50 50)",
                    children: (0, $cc6u1.jsx)("g", {
                        transform: "scale(0.9)",
                        children: (0, $cc6u1.jsxs)("g", {
                            transform: "translate(-50 -58)",
                            children: [
                                (0, $cc6u1.jsx)("path", {
                                    d: "M27.1,79.4c-1.1,0.6-2.4,1-3.7,1c-2.6,0-5.1-1.4-6.4-3.7c-2-3.5-0.8-8,2.7-10.1c1.1-0.6,2.4-1,3.7-1c2.6,0,5.1,1.4,6.4,3.7 C31.8,72.9,30.6,77.4,27.1,79.4z",
                                    fill: ballColors[0]
                                }),
                                (0, $cc6u1.jsx)("path", {
                                    d: "M72.9,79.4c1.1,0.6,2.4,1,3.7,1c2.6,0,5.1-1.4,6.4-3.7c2-3.5,0.8-8-2.7-10.1c-1.1-0.6-2.4-1-3.7-1c-2.6,0-5.1,1.4-6.4,3.7 C68.2,72.9,69.4,77.4,72.9,79.4z",
                                    fill: ballColors[1]
                                }),
                                (0, $cc6u1.jsx)("circle", {
                                    cx: "50",
                                    cy: "27",
                                    r: "7.4",
                                    fill: ballColors[2]
                                }),
                                (0, $cc6u1.jsx)("path", {
                                    d: "M86.5,57.5c-3.1-1.9-6.4-2.8-9.8-2.8c-0.5,0-0.9,0-1.4,0c-0.4,0-0.8,0-1.1,0c-2.1,0-4.2-0.4-6.2-1.2 c-0.8-3.6-2.8-6.9-5.4-9.3c0.4-2.5,1.3-4.8,2.7-6.9c2-2.9,3.2-6.5,3.2-10.4c0-10.2-8.2-18.4-18.4-18.4c-0.3,0-0.6,0-0.9,0 C39.7,9,32,16.8,31.6,26.2c-0.2,4.1,1,7.9,3.2,11c1.4,2.1,2.3,4.5,2.7,6.9c-2.6,2.5-4.6,5.7-5.4,9.3c-1.9,0.7-4,1.1-6.1,1.1 c-0.4,0-0.8,0-1.2,0c-0.5,0-0.9-0.1-1.4-0.1c-3.1,0-6.3,0.8-9.2,2.5c-9.1,5.2-12,17-6.3,25.9c3.5,5.4,9.5,8.4,15.6,8.4 c2.9,0,5.8-0.7,8.5-2.1c3.6-1.9,6.3-4.9,8-8.3c1.1-2.3,2.7-4.2,4.6-5.8c1.7,0.5,3.5,0.8,5.4,0.8c1.9,0,3.7-0.3,5.4-0.8 c1.9,1.6,3.5,3.5,4.6,5.7c1.5,3.2,4,6,7.4,8c2.9,1.7,6.1,2.5,9.2,2.5c6.6,0,13.1-3.6,16.4-10C97.3,73.1,94.4,62.5,86.5,57.5z M29.6,83.7c-1.9,1.1-4,1.6-6.1,1.6c-4.2,0-8.4-2.2-10.6-6.1c-3.4-5.9-1.4-13.4,4.5-16.8c1.9-1.1,4-1.6,6.1-1.6 c4.2,0,8.4,2.2,10.6,6.1C37.5,72.8,35.4,80.3,29.6,83.7z M50,39.3c-6.8,0-12.3-5.5-12.3-12.3S43.2,14.7,50,14.7 c6.8,0,12.3,5.5,12.3,12.3S56.8,39.3,50,39.3z M87.2,79.2c-2.3,3.9-6.4,6.1-10.6,6.1c-2.1,0-4.2-0.5-6.1-1.6 c-5.9-3.4-7.9-10.9-4.5-16.8c2.3-3.9,6.4-6.1,10.6-6.1c2.1,0,4.2,0.5,6.1,1.6C88.6,65.8,90.6,73.3,87.2,79.2z",
                                    fill: backgroundColor
                                })
                            ]
                        })
                    })
                }),
                (0, $cc6u1.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            ]
        })
    }));
};
var $715305e2ea9c3de1$export$bee07fdc425df572 = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.height, height = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "dna-loading" : tmp5;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "dna-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "60.6229",
                r: "3.41988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "0s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "6.451612903225806",
                cy: "39.3771",
                r: "2.58012",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.5s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "68.1552",
                r: "3.17988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "16.129032258064512",
                cy: "31.8448",
                r: "2.82012",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.7s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "69.3634",
                r: "2.93988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "25.806451612903224",
                cy: "30.6366",
                r: "3.06012",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.9s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "65.3666",
                r: "2.69988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "35.48387096774193",
                cy: "34.6334",
                r: "3.30012",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.1s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "53.8474",
                r: "2.45988",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-0.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "45.16129032258064",
                cy: "46.1526",
                r: "3.54012",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.3s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "39.3771",
                r: "2.58012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "54.838709677419345",
                cy: "60.6229",
                r: "3.41988",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.5s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.5s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "31.8448",
                r: "2.82012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "64.51612903225805",
                cy: "68.1552",
                r: "3.17988",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.7s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.2s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.7s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "30.6366",
                r: "3.06012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "74.19354838709677",
                cy: "69.3634",
                r: "2.93988",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.9s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.4s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.9s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "34.6334",
                r: "3.30012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "83.87096774193547",
                cy: "65.3666",
                r: "2.69988",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.1s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.6s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.1s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "46.1526",
                r: "3.54012",
                fill: "rgba(233, 12, 89, 0.5125806451612902)",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-1.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "rgba(233, 12, 89, 0.5125806451612902);#ff0033;rgba(233, 12, 89, 0.5125806451612902)",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            }),
            (0, $cc6u1.jsxs)("circle", {
                cx: "93.54838709677418",
                cy: "53.8474",
                r: "2.45988",
                fill: "#46dff0",
                children: [
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "r",
                        keyTimes: "0;0.5;1",
                        values: "2.4000000000000004;3.5999999999999996;2.4000000000000004",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-3.3s"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "cy",
                        keyTimes: "0;0.5;1",
                        values: "30.5;69.5;30.5",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.8s",
                        keySplines: "0.5 0 0.5 1;0.5 0 0.5 1",
                        calcMode: "spline"
                    }),
                    (0, $cc6u1.jsx)("animate", {
                        attributeName: "fill",
                        keyTimes: "0;0.5;1",
                        values: "#46dff0;rgba(53, 58, 57, 0.1435483870967742);#46dff0",
                        dur: "2s",
                        repeatCount: "indefinite",
                        begin: "-2.3s"
                    })
                ]
            })
        ]
    }));
};
var $715305e2ea9c3de1$export$f93420b62a5bdffa = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.height, height = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "discuss-loading" : tmp5, tmp6 = param.colors, colors = tmp6 === void 0 ? [
        "#ff727d",
        "#ff727d"
    ] : tmp6;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "discuss-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsx)("path", {
                fill: "none",
                d: "M82 50A32 32 0 1 1 23.533421623214014 32.01333190873183 L21.71572875253809 21.7157287525381 L32.013331908731814 23.53342162321403 A32 32 0 0 1 82 50",
                strokeWidth: "5",
                stroke: colors[0]
            }),
            (0, $cc6u1.jsx)("circle", {
                cx: "50",
                cy: "50",
                fill: "none",
                strokeLinecap: "round",
                r: "20",
                strokeWidth: "5",
                stroke: colors[1],
                strokeDasharray: "31.41592653589793 31.41592653589793",
                transform: "rotate(96 50 50)",
                children: (0, $cc6u1.jsx)("animateTransform", {
                    attributeName: "transform",
                    type: "rotate",
                    calcMode: "linear",
                    values: "0 50 50;360 50 50",
                    keyTimes: "0;1",
                    dur: "1s",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    }));
};
var $715305e2ea9c3de1$export$dc036a5afb9ca26f = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.height, height = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.colors, colors = tmp3 === void 0 ? [
        "#e15b64",
        "#f47e60",
        "#f8b26a",
        "#abbd81",
        "#849b87"
    ] : tmp3, tmp4 = param.wrapperClass, wrapperClass = tmp4 === void 0 ? "" : tmp4, tmp5 = param.wrapperStyle, wrapperStyle = tmp5 === void 0 ? {} : tmp5, tmp6 = param.ariaLabel, ariaLabel = tmp6 === void 0 ? "color-ring-loading" : tmp6;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: width,
        height: height,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "color-ring-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsx)("defs", {
                children: (0, $cc6u1.jsx)("mask", {
                    id: "ldio-4offds5dlws-mask",
                    children: (0, $cc6u1.jsx)("circle", {
                        cx: "50",
                        cy: "50",
                        r: "26",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeDasharray: "122.52211349000194 40.840704496667314",
                        strokeWidth: "9",
                        transform: "rotate(198.018 50 50)",
                        children: (0, $cc6u1.jsx)("animateTransform", {
                            attributeName: "transform",
                            type: "rotate",
                            values: "0 50 50;360 50 50",
                            keyTimes: "0;1",
                            dur: "1s",
                            repeatCount: "indefinite"
                        })
                    })
                })
            }),
            (0, $cc6u1.jsxs)("g", {
                mask: "url(#ldio-4offds5dlws-mask)",
                children: [
                    (0, $cc6u1.jsx)("rect", {
                        x: "14.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[0],
                        children: (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.8s"
                        })
                    }),
                    (0, $cc6u1.jsx)("rect", {
                        x: "28.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[1],
                        children: (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.6s"
                        })
                    }),
                    (0, $cc6u1.jsx)("rect", {
                        x: "42.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[2],
                        children: (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.4s"
                        })
                    }),
                    (0, $cc6u1.jsx)("rect", {
                        x: "56.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[3],
                        children: (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "-0.2s"
                        })
                    }),
                    (0, $cc6u1.jsx)("rect", {
                        x: "70.5",
                        y: "0",
                        width: "15",
                        height: "100",
                        fill: colors[4],
                        children: (0, $cc6u1.jsx)("animate", {
                            attributeName: "fill",
                            values: colors.join(";").toString(),
                            keyTimes: "0;0.25;0.5;0.75;1",
                            dur: "1s",
                            repeatCount: "indefinite",
                            begin: "0s"
                        })
                    })
                ]
            })
        ]
    }));
};
var $715305e2ea9c3de1$export$4d299b491347818a = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.height, height = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.backgroundColor, backgroundColor = tmp3 === void 0 ? "#ff6d00" : tmp3, tmp4 = param.color, color = tmp4 === void 0 ? "#fff" : tmp4, tmp5 = param.wrapperClass, wrapperClass = tmp5 === void 0 ? "" : tmp5, tmp6 = param.wrapperStyle, wrapperStyle = tmp6 === void 0 ? {} : tmp6, tmp7 = param.ariaLabel, ariaLabel = tmp7 === void 0 ? "comment-loading" : tmp7;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "comment-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsx)("path", {
                d: "M78,19H22c-6.6,0-12,5.4-12,12v31c0,6.6,5.4,12,12,12h37.2c0.4,3,1.8,5.6,3.7,7.6c2.4,2.5,5.1,4.1,9.1,4 c-1.4-2.1-2-7.2-2-10.3c0-0.4,0-0.8,0-1.3h8c6.6,0,12-5.4,12-12V31C90,24.4,84.6,19,78,19z",
                fill: backgroundColor
            }),
            (0, $cc6u1.jsx)("circle", {
                cx: "30",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;1;1",
                    keyTimes: "0;0.2;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $cc6u1.jsx)("circle", {
                cx: "50",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.2;0.4;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            }),
            (0, $cc6u1.jsx)("circle", {
                cx: "70",
                cy: "47",
                r: "5",
                fill: color,
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "opacity",
                    calcMode: "linear",
                    values: "0;0;1;1",
                    keyTimes: "0;0.4;0.6;1",
                    dur: "1",
                    begin: "0s",
                    repeatCount: "indefinite"
                })
            })
        ]
    }));
};
var $715305e2ea9c3de1$export$2ba1b65b747a57aa = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.height, height = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "blocks-loading" : tmp5;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        className: wrapperClass,
        style: wrapperStyle,
        xmlns: $715305e2ea9c3de1$var$$eb040f10400edc38$export$98a285aab16ab26c,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        "aria-label": ariaLabel,
        "data-testid": "blocks-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsx)("title", {
                children: "Blocks"
            }),
            (0, $cc6u1.jsx)("desc", {
                children: "Animated representation of blocks"
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "17",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0s",
                    calcMode: "discrete"
                })
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "40",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.125s",
                    calcMode: "discrete"
                })
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "63",
                y: "17",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.25s",
                    calcMode: "discrete"
                })
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "17",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.875s",
                    calcMode: "discrete"
                })
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "63",
                y: "40",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.375s",
                    calcMode: "discrete"
                })
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "17",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.75s",
                    calcMode: "discrete"
                })
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "40",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.625s",
                    calcMode: "discrete"
                })
            }),
            (0, $cc6u1.jsx)("rect", {
                x: "63",
                y: "63",
                width: "20",
                height: "20",
                fill: "#577c9b",
                children: (0, $cc6u1.jsx)("animate", {
                    attributeName: "fill",
                    values: "#0dceff;#577c9b;#577c9b",
                    keyTimes: "0;0.125;1",
                    dur: "1s",
                    repeatCount: "indefinite",
                    begin: "0.5s",
                    calcMode: "discrete"
                })
            })
        ]
    }));
};
var $715305e2ea9c3de1$export$f3c41beb83007357 = function(param) {
    var tmp = param.visible, visible = tmp === void 0 ? true : tmp, tmp1 = param.width, width = tmp1 === void 0 ? "80" : tmp1, tmp2 = param.height, height = tmp2 === void 0 ? "80" : tmp2, tmp3 = param.wrapperClass, wrapperClass = tmp3 === void 0 ? "" : tmp3, tmp4 = param.wrapperStyle, wrapperStyle = tmp4 === void 0 ? {} : tmp4, tmp5 = param.ariaLabel, ariaLabel = tmp5 === void 0 ? "hourglass-loading" : tmp5, tmp6 = param.colors, colors = tmp6 === void 0 ? [
        "#306cce",
        "#72a1ed"
    ] : tmp6;
    return !visible ? null : (0, $cc6u1.jsxs)("svg", (0, $kJeRc._)((0, $eRslx._)({
        width: width,
        height: height,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 350 350",
        preserveAspectRatio: "xMidYMid",
        className: wrapperClass,
        style: wrapperStyle,
        "aria-label": ariaLabel,
        "data-testid": "hourglass-svg"
    }, $715305e2ea9c3de1$var$$84fda1e7e33cfd28$export$6bfda33bcd6c2d18), {
        children: [
            (0, $cc6u1.jsx)("animateTransform", {
                attributeName: "transform",
                type: "rotate",
                values: "0; 0; -30; 360; 360",
                keyTimes: "0; 0.40; 0.55; 0.65; 1",
                dur: "3s",
                begin: "0s",
                calcMode: "linear",
                repeatCount: "indefinite"
            }),
            (0, $cc6u1.jsxs)("g", {
                children: [
                    (0, $cc6u1.jsx)("path", {
                        fill: colors[0],
                        stroke: colors[0],
                        d: "M324.658,20.572v-2.938C324.658,7.935,316.724,0,307.025,0H40.313c-9.699,0-17.635,7.935-17.635,17.634v2.938     c0,9.699,7.935,17.634,17.635,17.634h6.814c3.5,0,3.223,3.267,3.223,4.937c0,19.588,8.031,42.231,14.186,56.698     c12.344,29.012,40.447,52.813,63.516,69.619c4.211,3.068,3.201,5.916,0.756,7.875c-22.375,17.924-51.793,40.832-64.271,70.16     c-6.059,14.239-13.934,36.4-14.18,55.772c-0.025,1.987,0.771,5.862-3.979,5.862h-6.064c-9.699,0-17.635,7.936-17.635,17.634v2.94     c0,9.698,7.935,17.634,17.635,17.634h266.713c9.699,0,17.633-7.936,17.633-17.634v-2.94c0-9.698-7.934-17.634-17.633-17.634     h-3.816c-7,0-6.326-5.241-6.254-7.958c0.488-18.094-4.832-38.673-12.617-54.135c-17.318-34.389-44.629-56.261-61.449-68.915     c-3.65-2.745-4.018-6.143,0-8.906c17.342-11.929,44.131-34.526,61.449-68.916c8.289-16.464,13.785-38.732,12.447-57.621     c-0.105-1.514-0.211-4.472,3.758-4.472h6.482C316.725,38.206,324.658,30.272,324.658,20.572z M270.271,93.216     c-16.113,31.998-41.967,54.881-64.455,68.67c-1.354,0.831-3.936,2.881-3.936,8.602v6.838c0,6.066,2.752,7.397,4.199,8.286     c22.486,13.806,48.143,36.636,64.191,68.508c7.414,14.727,11.266,32.532,10.885,46.702c-0.078,2.947,1.053,8.308-6.613,8.308     H72.627c-6.75,0-6.475-3.37-6.459-5.213c0.117-12.895,4.563-30.757,12.859-50.255c14.404-33.854,44.629-54.988,64.75-67.577     c0.896-0.561,2.629-1.567,2.629-6.922v-10.236c0-5.534-2.656-7.688-4.057-8.57c-20.098-12.688-49.256-33.618-63.322-66.681     c-8.383-19.702-12.834-37.732-12.861-50.657c-0.002-1.694,0.211-4.812,3.961-4.812h206.582c4.168,0,4.127,3.15,4.264,4.829     C282.156,57.681,278.307,77.257,270.271,93.216z"
                    }),
                    (0, $cc6u1.jsxs)("g", {
                        children: [
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M169.541,196.2l-68.748,86.03c-2.27,2.842-1.152,5.166,2.484,5.166h140.781c3.637,0,4.756-2.324,2.484-5.166     l-68.746-86.03C175.525,193.358,171.811,193.358,169.541,196.2z"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "opacity",
                                values: "0; 0; 1; 1; 0; 0",
                                keyTimes: "0; 0.1; 0.4; 0.6; 0.61; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    }),
                    (0, $cc6u1.jsxs)("g", {
                        children: [
                            (0, $cc6u1.jsx)("path", {
                                fill: colors[1],
                                stroke: colors[1],
                                d: "M168.986,156.219c2.576,2.568,6.789,2.568,9.363,0l34.576-34.489c2.574-2.568,1.707-4.67-1.932-4.67H136.34     c-3.637,0-4.506,2.102-1.932,4.67L168.986,156.219z"
                            }),
                            (0, $cc6u1.jsx)("animate", {
                                attributeName: "opacity",
                                values: "1; 1; 0; 0; 1; 1",
                                keyTimes: "0; 0.1; 0.4; 0.65; 0.66; 1",
                                dur: "3s",
                                repeatCount: "indefinite"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};


var $68ce1d77bc18c07c$var$Shimmer = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "shimmer-container",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "bg-[#171a29] h-[340px] flex flex-col justify-center items-center",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex justify-center items-center",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "relative",
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $715305e2ea9c3de1$export$67ad50c48ca3ede4), {
                                    visible: true,
                                    height: "65",
                                    width: "65",
                                    color: "#f0f0f0",
                                    secondaryColor: "grey",
                                    ariaLabel: "oval-loading",
                                    wrapperStyle: {},
                                    wrapperClass: ""
                                })
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "absolute h-8",
                                src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/icecream_wwomsa",
                                alt: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                        className: "mt-8 text-2xl text-gray-300",
                        children: "Looking for great food near you..."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "my-10  mx-40 flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "w-[254px] h-[600px] border mr-12",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "bg-gray-100 flex p-4",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-12 h-12 rounded-full bg-white mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "bg-white w-32 h-3 my-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex p-4",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-12 h-12 rounded-full bg-gray-100 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "bg-gray-100 w-32 h-3 my-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex p-4",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-12 h-12 rounded-full bg-gray-100 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "bg-gray-100 w-32 h-3 my-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex p-4",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-12 h-12 rounded-full bg-gray-100 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "bg-gray-100 w-32 h-3 my-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex p-4",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-12 h-12 rounded-full bg-gray-100 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "bg-gray-100 w-32 h-3 my-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex p-4",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-12 h-12 rounded-full bg-gray-100 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "bg-gray-100 w-32 h-3 my-4"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex p-4",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-12 h-12 rounded-full bg-gray-100 mr-4"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "bg-gray-100 w-32 h-3 my-4"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "bg-gray-100 w-32 h-3 my-4"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "grid grid-cols-3 gap-10",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "mt-4 mb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "w-[280px] h-[170px] bg-gray-100"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-36 h-3 my-4"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-28 h-3 my-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "card mt-4 mb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "w-[280px] h-[170px] bg-gray-100"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-36 h-3 my-4"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-28 h-3 my-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "card mt-4 mb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "w-[280px] h-[170px] bg-gray-100"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-36 h-3 my-4"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-28 h-3 my-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "card mt-4 mb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "w-[280px] h-[170px] bg-gray-100"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-36 h-3 my-4"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-28 h-3 my-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "card mt-4 mb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "w-[280px] h-[170px] bg-gray-100"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-36 h-3 my-4"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-28 h-3 my-4"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "card mt-4 mb-8",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "w-[280px] h-[170px] bg-gray-100"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-36 h-3 my-4"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "bg-gray-100 w-28 h-3 my-4"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $68ce1d77bc18c07c$export$2e2bcd8739ae039 = $68ce1d77bc18c07c$var$Shimmer;



var $fIwXP = parcelRequire("fIwXP");



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");

var $e0e4a71a2eabf1c9$var$CarouselDish = function(param) {
    var dishData = param.dishData;
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        className: "m-1",
        children: /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
            src: (0, $cc25cc9a913d8a70$export$b0fd8bc2b1d75505) + dishData.imageId,
            alt: ""
        })
    });
};
var $e0e4a71a2eabf1c9$export$2e2bcd8739ae039 = $e0e4a71a2eabf1c9$var$CarouselDish;


var $1580051cd03fa60e$exports = {};
"use strict";
Object.defineProperty($1580051cd03fa60e$exports, "__esModule", {
    value: true
});
$1580051cd03fa60e$exports["default"] = void 0;

var $1580051cd03fa60e$var$_slider = $1580051cd03fa60e$var$_interopRequireDefault((parcelRequire("1wVsT")));
function $1580051cd03fa60e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1580051cd03fa60e$var$_default = $1580051cd03fa60e$exports["default"] = $1580051cd03fa60e$var$_slider["default"];





var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $4bfd08f54435a7b3$var$BestRestaurants = function(param) {
    var bestRes = param.bestRes;
    var brands = bestRes.brands, title = bestRes.title;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(11), 2), visible = _useState[0], setVisible = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), showBtn = _useState1[0], setShowBtn = _useState1[1];
    var showMoreItems = function() {
        setVisible(function(prevValue) {
            return prevValue + (brands.length - visible);
        });
        setShowBtn(false);
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "my-8",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-bold text-xl py-3",
                children: title
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "grid grid-cols-4 text-[#02060cbf]",
                children: [
                    brands.slice(0, visible).map(function(city) {
                        return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                            to: city.link,
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "btn-tab border rounded-lg py-3 px-4 my-2 w-[270px] font-semibold",
                                children: city.text
                            })
                        });
                    }),
                    showBtn && /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                        className: "flex items-center justify-center border rounded-lg py-3 my-2 w-[270px] font-semibold",
                        onClick: showMoreItems,
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                className: "font-bold",
                                children: "Show More"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-5 ml-2",
                                src: "https://static.thenounproject.com/png/1123247-200.png",
                                alt: ""
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $4bfd08f54435a7b3$export$2e2bcd8739ae039 = $4bfd08f54435a7b3$var$BestRestaurants;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $0d12d99328d25af3$var$BestCuisines = function(param) {
    var cuisines = param.cuisines;
    var brands = cuisines.brands, title = cuisines.title;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(11), 2), visible = _useState[0], setVisible = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)(true), 2), showBtn = _useState1[0], setShowBtn = _useState1[1];
    var showMoreItems = function() {
        setVisible(function(prevValue) {
            return prevValue + (brands.length - visible);
        });
        setShowBtn(false);
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "my-8",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-bold text-xl py-3",
                children: title
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "grid grid-cols-4",
                children: [
                    brands.slice(0, visible).map(function(city) {
                        return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                            to: city.link,
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "btn-tab border rounded-lg py-3  px-4  my-2 w-[270px] font-semibold",
                                children: city.text
                            })
                        });
                    }),
                    showBtn && /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                        className: "flex items-center justify-center border rounded-lg py-3 my-2 w-[270px] font-semibold",
                        onClick: showMoreItems,
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                className: "font-bold",
                                children: "Show More"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-5 ml-2",
                                src: "https://static.thenounproject.com/png/1123247-200.png",
                                alt: ""
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $0d12d99328d25af3$export$2e2bcd8739ae039 = $0d12d99328d25af3$var$BestCuisines;



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");

var $96c3e7044ba77e10$var$NearbyRestaurants = function(param) {
    var nearBy = param.nearBy;
    var brands = nearBy.brands, title = nearBy.title;
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-bold text-xl py-3",
                children: title
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "grid grid-cols-2",
                children: brands.map(function(nearMe) {
                    return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                        to: nearMe.link,
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                            className: "border rounded-lg py-3 my-2 w-[570px] font-semibold",
                            children: nearMe.text
                        })
                    });
                })
            })
        ]
    });
};
var $96c3e7044ba77e10$export$2e2bcd8739ae039 = $96c3e7044ba77e10$var$NearbyRestaurants;



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");
var $fe47191d6390dcd0$exports = {};

$fe47191d6390dcd0$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "offline.1e17d73f.jpg";


var $573e4dc8e8e0dd3e$var$Offline = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "h-[85vh] text-center flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                className: "h-72",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($fe47191d6390dcd0$exports))),
                alt: ""
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "mt-6 text-xl font-semibold text-[#535665]",
                children: "Your internet is a little wonky"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                className: "text-[#7e808c] mt-2 w-[23%]",
                children: "Try switching to a different connection or reset your internet to place an order."
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                className: "mt-7 py-2 px-5 bg-[#ff5200] text-white font-semibold",
                children: "RETRY"
            })
        ]
    });
};
var $573e4dc8e8e0dd3e$export$2e2bcd8739ae039 = $573e4dc8e8e0dd3e$var$Offline;


var $373b11f276a41253$var$Body = function() {
    var _carouselDishes_imageGridCards, _topRestaurants_gridElements_infoWithStyle, _topRestaurants_gridElements, _topRestaurants_header;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), listOfRestaurants = _useState[0], setListOfRestaurants = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), filteredRestaurant = _useState1[0], setFilteredRestaurant = _useState1[1];
    var _useState2 = (0, $kB67t._)((0, $fIwXP.useState)(""), 2), searchText = _useState2[0], setSearchText = _useState2[1];
    var _useState3 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), carouselDishes = _useState3[0], setCarouselDishes = _useState3[1];
    var _useState4 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), topRestaurants = _useState4[0], setTopRestaurants = _useState4[1];
    var _useState5 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), bestResturants = _useState5[0], setBestRestaurants = _useState5[1];
    var _useState6 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), bestCuisines = _useState6[0], setBestCuisines = _useState6[1];
    var _useState7 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), nearBy = _useState7[0], setNearBy = _useState7[1];
    var RestaurantCardPromoted = (0, $d6e6ef2e667bbda8$export$ccb02a230af14023)((0, $d6e6ef2e667bbda8$export$2e2bcd8739ae039));
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function() {
            var _json_data_cards__card_card_gridElements_infoWithStyle, _json_data_cards__card_card_gridElements, _json_data_cards__card_card, _json_data_cards__card, _json_data_cards_, _json_data, _json_data_cards__card_card_gridElements_infoWithStyle1, _json_data_cards__card_card_gridElements1, _json_data_cards__card_card1, _json_data_cards__card1, _json_data_cards_1, _json_data1, _json_data_cards__card2, _json_data_cards_2, _json_data2, _json_data_cards__card3, _json_data_cards_3, _json_data3, _json_data_cards__card4, _json_data_cards_4, _json_data4, _json_data_cards__card5, _json_data_cards_5, _json_data5, _json_data_cards__card6, _json_data_cards_6, _json_data6, data, json;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("https://swiggy-backend-9o8y.onrender.com/api/restaurants")
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        console.log(json);
                        setListOfRestaurants(json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards_ = _json_data.cards[4]) === null || _json_data_cards_ === void 0 ? void 0 : (_json_data_cards__card = _json_data_cards_.card) === null || _json_data_cards__card === void 0 ? void 0 : (_json_data_cards__card_card = _json_data_cards__card.card) === null || _json_data_cards__card_card === void 0 ? void 0 : (_json_data_cards__card_card_gridElements = _json_data_cards__card_card.gridElements) === null || _json_data_cards__card_card_gridElements === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle = _json_data_cards__card_card_gridElements.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle.restaurants);
                        setFilteredRestaurant(json === null || json === void 0 ? void 0 : (_json_data1 = json.data) === null || _json_data1 === void 0 ? void 0 : (_json_data_cards_1 = _json_data1.cards[4]) === null || _json_data_cards_1 === void 0 ? void 0 : (_json_data_cards__card1 = _json_data_cards_1.card) === null || _json_data_cards__card1 === void 0 ? void 0 : (_json_data_cards__card_card1 = _json_data_cards__card1.card) === null || _json_data_cards__card_card1 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements1 = _json_data_cards__card_card1.gridElements) === null || _json_data_cards__card_card_gridElements1 === void 0 ? void 0 : (_json_data_cards__card_card_gridElements_infoWithStyle1 = _json_data_cards__card_card_gridElements1.infoWithStyle) === null || _json_data_cards__card_card_gridElements_infoWithStyle1 === void 0 ? void 0 : _json_data_cards__card_card_gridElements_infoWithStyle1.restaurants);
                        setCarouselDishes(json === null || json === void 0 ? void 0 : (_json_data2 = json.data) === null || _json_data2 === void 0 ? void 0 : (_json_data_cards_2 = _json_data2.cards[0]) === null || _json_data_cards_2 === void 0 ? void 0 : (_json_data_cards__card2 = _json_data_cards_2.card) === null || _json_data_cards__card2 === void 0 ? void 0 : _json_data_cards__card2.card);
                        setTopRestaurants(json === null || json === void 0 ? void 0 : (_json_data3 = json.data) === null || _json_data3 === void 0 ? void 0 : (_json_data_cards_3 = _json_data3.cards[1]) === null || _json_data_cards_3 === void 0 ? void 0 : (_json_data_cards__card3 = _json_data_cards_3.card) === null || _json_data_cards__card3 === void 0 ? void 0 : _json_data_cards__card3.card);
                        setBestRestaurants(json === null || json === void 0 ? void 0 : (_json_data4 = json.data) === null || _json_data4 === void 0 ? void 0 : (_json_data_cards_4 = _json_data4.cards[6]) === null || _json_data_cards_4 === void 0 ? void 0 : (_json_data_cards__card4 = _json_data_cards_4.card) === null || _json_data_cards__card4 === void 0 ? void 0 : _json_data_cards__card4.card);
                        setBestCuisines(json === null || json === void 0 ? void 0 : (_json_data5 = json.data) === null || _json_data5 === void 0 ? void 0 : (_json_data_cards_5 = _json_data5.cards[7]) === null || _json_data_cards_5 === void 0 ? void 0 : (_json_data_cards__card5 = _json_data_cards_5.card) === null || _json_data_cards__card5 === void 0 ? void 0 : _json_data_cards__card5.card);
                        setNearBy(json === null || json === void 0 ? void 0 : (_json_data6 = json.data) === null || _json_data6 === void 0 ? void 0 : (_json_data_cards_6 = _json_data6.cards[8]) === null || _json_data_cards_6 === void 0 ? void 0 : (_json_data_cards__card6 = _json_data_cards_6.card) === null || _json_data_cards__card6 === void 0 ? void 0 : _json_data_cards__card6.card);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6.8,
        slidesToScroll: 3
    };
    var settings1 = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3.7,
        slidesToScroll: 3
    };
    var onlineStatus = (0, $3c7428cbea0d9bb7$export$2e2bcd8739ae039)();
    var dish = carouselDishes === null || carouselDishes === void 0 ? void 0 : (_carouselDishes_imageGridCards = carouselDishes.imageGridCards) === null || _carouselDishes_imageGridCards === void 0 ? void 0 : _carouselDishes_imageGridCards.info;
    var topRes = topRestaurants === null || topRestaurants === void 0 ? void 0 : (_topRestaurants_gridElements = topRestaurants.gridElements) === null || _topRestaurants_gridElements === void 0 ? void 0 : (_topRestaurants_gridElements_infoWithStyle = _topRestaurants_gridElements.infoWithStyle) === null || _topRestaurants_gridElements_infoWithStyle === void 0 ? void 0 : _topRestaurants_gridElements_infoWithStyle.restaurants;
    if (onlineStatus === false) return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $573e4dc8e8e0dd3e$export$2e2bcd8739ae039), {});
    return (listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.length) === 0 ? /*#__PURE__*/ (0, $cc6u1.jsx)((0, $68ce1d77bc18c07c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "mx-40",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "mt-4 mb-14 mx-10",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "font-extrabold text-2xl",
                        children: carouselDishes.header.title
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "mr-4",
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1580051cd03fa60e$exports))), (0, $kJeRc._)((0, $eRslx._)({}, settings), {
                            children: dish === null || dish === void 0 ? void 0 : dish.map(function(d) {
                                return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $e0e4a71a2eabf1c9$export$2e2bcd8739ae039), {
                                    dishData: d
                                });
                            })
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("hr", {}),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "my-9 mx-10",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "font-extrabold text-2xl py-3",
                        children: topRestaurants === null || topRestaurants === void 0 ? void 0 : (_topRestaurants_header = topRestaurants.header) === null || _topRestaurants_header === void 0 ? void 0 : _topRestaurants_header.title
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "",
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1580051cd03fa60e$exports))), (0, $kJeRc._)((0, $eRslx._)({}, settings1), {
                            children: topRes === null || topRes === void 0 ? void 0 : topRes.map(function(res) {
                                return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                    to: "/restaurants/" + res.info.id,
                                    children: /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: "w-[273px]",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d6e6ef2e667bbda8$export$2e2bcd8739ae039), {
                                            resData: res === null || res === void 0 ? void 0 : res.info
                                        })
                                    })
                                }, res.info.id);
                            })
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("hr", {}),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "my-9 mx-10",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "font-extrabold text-2xl",
                        children: "Restaurants with online food delivery in Indore"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "filter-btns flex my-3",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                onClick: function() {
                                    var filteredList = listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.filter(function(res) {
                                        return res.info.sla.deliveryTime < 30;
                                    });
                                    setFilteredRestaurant(filteredList);
                                },
                                children: "Fast Delivery"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                onClick: function() {
                                    var filteredList = listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.filter(function(res) {
                                        return res.info.avgRating > 4;
                                    });
                                    setFilteredRestaurant(filteredList);
                                },
                                children: "Rating 4.0+"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                onClick: function() {
                                    var filteredList = listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.filter(function(res) {
                                        return res.info.veg == true;
                                    });
                                    setFilteredRestaurant(filteredList);
                                },
                                children: "Pure Veg"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                onClick: function() {
                                    var filteredList = listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.filter(function(res) {
                                        return res.info.aggregatedDiscountInfoV3 == undefined ? null : res;
                                    });
                                    setFilteredRestaurant(filteredList);
                                },
                                children: "Offers"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                onClick: function() {
                                    var filteredList = listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.filter(function(res) {
                                        var costParts = res.info.costForTwo.split(" ");
                                        var costNumber = parseInt(costParts[0].replace("\u20B9", ""), 10);
                                        return costNumber >= 300 && costNumber <= 600 ? res : null;
                                    });
                                    setFilteredRestaurant(filteredList);
                                },
                                children: "Rs 300-Rs 600"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                onClick: function() {
                                    console.log(listOfRestaurants);
                                    var filteredList = listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.filter(function(res) {
                                        var costParts = res.info.costForTwo.split(" ");
                                        var costNumber = parseInt(costParts[0].replace("\u20B9", ""), 10);
                                        return costNumber < 300 ? res : null;
                                    });
                                    setFilteredRestaurant(filteredList);
                                    console.log(filteredList);
                                },
                                children: "Less than Rs 300"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "rounded-full flex items-center justify-between px-4 py-1 mr-3 bg-gray-100 w-64",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                        className: "bg-gray-100 outline-none placeholder:text-[rgba(2,6,12,0.75)] w-60",
                                        type: "text",
                                        placeholder: "Seach for restaurant name...",
                                        value: searchText,
                                        onChange: function(e) {
                                            setSearchText(e.target.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        onClick: function() {
                                            var filteredRestaurant = listOfRestaurants === null || listOfRestaurants === void 0 ? void 0 : listOfRestaurants.filter(function(res) {
                                                return res.info.name.toLowerCase().includes(searchText.toLowerCase());
                                            });
                                            setFilteredRestaurant(filteredRestaurant);
                                        },
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                            className: "ml-3",
                                            viewBox: "5 -1 12 25",
                                            height: "17",
                                            width: "17",
                                            fill: "#686b78",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                d: "M17.6671481,17.1391632 L22.7253317,22.1973467 L20.9226784,24 L15.7041226,18.7814442 C14.1158488,19.8024478 12.225761,20.3946935 10.1973467,20.3946935 C4.56550765,20.3946935 0,15.8291858 0,10.1973467 C0,4.56550765 4.56550765,0 10.1973467,0 C15.8291858,0 20.3946935,4.56550765 20.3946935,10.1973467 C20.3946935,12.8789625 19.3595949,15.3188181 17.6671481,17.1391632 Z M10.1973467,17.8453568 C14.4212261,17.8453568 17.8453568,14.4212261 17.8453568,10.1973467 C17.8453568,5.97346742 14.4212261,2.54933669 10.1973467,2.54933669 C5.97346742,2.54933669 2.54933669,5.97346742 2.54933669,10.1973467 C2.54933669,14.4212261 5.97346742,17.8453568 10.1973467,17.8453568 Z"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[#ff5200] font-semibold",
                                onClick: function() {
                                    setFilteredRestaurant(listOfRestaurants);
                                },
                                children: "Clear Filters"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "grid grid-cols-4 ",
                        children: filteredRestaurant === null || filteredRestaurant === void 0 ? void 0 : filteredRestaurant.map(function(restaurant) {
                            return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "res-card w-[254px]",
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                    to: "/restaurants/" + restaurant.info.id,
                                    children: restaurant.info.isNewlyOnboarded ? /*#__PURE__*/ (0, $cc6u1.jsx)(RestaurantCardPromoted, {
                                        resData: restaurant === null || restaurant === void 0 ? void 0 : restaurant.info
                                    }) : /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d6e6ef2e667bbda8$export$2e2bcd8739ae039), {
                                        resData: restaurant === null || restaurant === void 0 ? void 0 : restaurant.info
                                    })
                                }, restaurant.info.id)
                            });
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $4bfd08f54435a7b3$export$2e2bcd8739ae039), {
                bestRes: bestResturants
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $0d12d99328d25af3$export$2e2bcd8739ae039), {
                cuisines: bestCuisines
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $96c3e7044ba77e10$export$2e2bcd8739ae039), {
                nearBy: nearBy
            })
        ]
    });
};
var $373b11f276a41253$export$2e2bcd8739ae039 = $373b11f276a41253$var$Body;



var $cc6u1 = parcelRequire("cc6u1");
var $717a2f0a6a708d12$var$Contact = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-bold text-3xl p-4 m-4",
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                        type: "text",
                        className: "border border-black p-2 m-2 rounded-lg",
                        placeholder: "Name"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                        type: "text",
                        className: "border border-black p-2 m-2 rounded-lg",
                        placeholder: "Message..."
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                        className: "px-4 py-2 bg-gray-100 rounded-lg m-4",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
var $717a2f0a6a708d12$export$2e2bcd8739ae039 = $717a2f0a6a708d12$var$Contact;



var $cc6u1 = parcelRequire("cc6u1");

var $eb9ea4566ac52960$var$Error = function() {
    var err = (0, $9e36fd5982483bee$export$ed527bf60f6e05f2)();
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                children: "Oops!!"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("h3", {
                children: [
                    err.status,
                    ": ",
                    err.statusText
                ]
            })
        ]
    });
};
var $eb9ea4566ac52960$export$2e2bcd8739ae039 = $eb9ea4566ac52960$var$Error;



var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");



var $7k5I8 = parcelRequire("7k5I8");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $6d359334c042511a$var$useRestaurantMenu = function(resId) {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), resInfo = _useState[0], setResInfo = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function() {
            var data, json, error;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetch((0, $cc25cc9a913d8a70$export$b77c1aa4fb57bd1c) + resId)
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setResInfo(json === null || json === void 0 ? void 0 : json.data);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.log(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return resInfo;
};
var $6d359334c042511a$export$2e2bcd8739ae039 = $6d359334c042511a$var$useRestaurantMenu;



var $cc6u1 = parcelRequire("cc6u1");

var $7k5I8 = parcelRequire("7k5I8");

var $hD5pT = parcelRequire("hD5pT");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $cc6u1 = parcelRequire("cc6u1");


var $7k5I8 = parcelRequire("7k5I8");

var $3Gvhd = parcelRequire("3Gvhd");

var $bB0zn = parcelRequire("bB0zn");

var $f5KHm = parcelRequire("f5KHm");

var $6QEWP = parcelRequire("6QEWP");

var $hD5pT = parcelRequire("hD5pT");

var $ZhYhU = parcelRequire("ZhYhU");
function $5f0e95e6df7a47eb$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $ZhYhU._)(object);
        if (object === null) break;
    }
    return object;
}


function $04ca9dac0ceac2e2$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $04ca9dac0ceac2e2$export$71511d61b312f219 = Reflect.get;
    else $04ca9dac0ceac2e2$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $5f0e95e6df7a47eb$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $04ca9dac0ceac2e2$export$71511d61b312f219(target, property, receiver || target);
}



var $ZhYhU = parcelRequire("ZhYhU");

var $5dLwP = parcelRequire("5dLwP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");

var $fPaN7 = parcelRequire("fPaN7");

var $lFlDF = parcelRequire("lFlDF");
// src/utils/formatProdErrorMessage.ts

var $hD5pT = parcelRequire("hD5pT");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
function $a039f9c7168ef4c9$var$formatProdErrorMessage(code) {
    return "Minified Redux error #".concat(code, "; visit https://redux.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}
// src/utils/symbol-observable.ts
var $a039f9c7168ef4c9$var$$$observable = /* @__PURE__ */ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
var $a039f9c7168ef4c9$var$symbol_observable_default = $a039f9c7168ef4c9$var$$$observable;
// src/utils/actionTypes.ts
var $a039f9c7168ef4c9$var$randomString = function() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $a039f9c7168ef4c9$var$ActionTypes = {
    INIT: "@@redux/INIT".concat($a039f9c7168ef4c9$var$randomString()),
    REPLACE: "@@redux/REPLACE".concat($a039f9c7168ef4c9$var$randomString()),
    PROBE_UNKNOWN_ACTION: function() {
        return "@@redux/PROBE_UNKNOWN_ACTION".concat($a039f9c7168ef4c9$var$randomString());
    }
};
var $a039f9c7168ef4c9$export$4219e499db7ca678 = $a039f9c7168ef4c9$var$ActionTypes;
// src/utils/isPlainObject.ts
function $a039f9c7168ef4c9$export$53b83ca8eaab0383(obj) {
    if ((typeof obj === "undefined" ? "undefined" : (0, $YtE9h._)(obj)) !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $a039f9c7168ef4c9$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($a039f9c7168ef4c9$var$isDate(val)) return "date";
    if ($a039f9c7168ef4c9$var$isError(val)) return "error";
    var constructorName = $a039f9c7168ef4c9$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $a039f9c7168ef4c9$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $a039f9c7168ef4c9$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $a039f9c7168ef4c9$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $a039f9c7168ef4c9$var$kindOf(val) {
    var typeOfVal = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return typeOfVal;
}
// src/createStore.ts
function $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(1));
        return enhancer($a039f9c7168ef4c9$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = /* @__PURE__ */ new Map();
    var nextListeners = currentListeners;
    var listenerIdCounter = 0;
    var isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach(function(listener, key) {
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        var listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(action)) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        listeners.forEach(function(listener) {
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        var outerSubscribe = subscribe;
        return (0, $hD5pT._)({
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function(observer) {
                if ((typeof observer === "undefined" ? "undefined" : (0, $YtE9h._)(observer)) !== "object" || observer === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(11));
                function observeState() {
                    var observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, $a039f9c7168ef4c9$var$symbol_observable_default, function() {
            return this;
        });
    }
    dispatch({
        type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
    });
    var store = (0, $hD5pT._)({
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, $a039f9c7168ef4c9$var$symbol_observable_default, observable);
    return store;
}
function $a039f9c7168ef4c9$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $a039f9c7168ef4c9$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $a039f9c7168ef4c9$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $a039f9c7168ef4c9$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$a039f9c7168ef4c9$export$53b83ca8eaab0383(inputState)) return "The ".concat(argumentName, ' has unexpected type of "').concat($a039f9c7168ef4c9$var$kindOf(inputState), '". Expected argument to be an object with the following keys: "').concat(reducerKeys.join('", "'), '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $a039f9c7168ef4c9$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected ".concat(unexpectedKeys.length > 1 ? "keys" : "key", ' "').concat(unexpectedKeys.join('", "'), '" found in ').concat(argumentName, '. Expected to find one of the known reducer keys instead: "').concat(reducerKeys.join('", "'), '". Unexpected keys will be ignored.');
}
function $a039f9c7168ef4c9$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $a039f9c7168ef4c9$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(13));
    });
}
function $a039f9c7168ef4c9$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers);
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $a039f9c7168ef4c9$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, action = arguments.length > 1 ? arguments[1] : void 0;
        if (shapeAssertionError) throw shapeAssertionError;
        var hasChanged = false;
        var nextState = {};
        for(var i = 0; i < finalReducerKeys.length; i++){
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return dispatch(actionCreator.apply(this, args));
    };
}
function $a039f9c7168ef4c9$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $a039f9c7168ef4c9$var$bindActionCreator(actionCreators, dispatch);
    if ((typeof actionCreators === "undefined" ? "undefined" : (0, $YtE9h._)(actionCreators)) !== "object" || actionCreators === null) throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $a039f9c7168ef4c9$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $a039f9c7168ef4c9$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++){
        funcs[_key] = arguments[_key];
    }
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return a(b.apply(void 0, (0, $2Xzd1._)(args)));
        };
    });
}
// src/applyMiddleware.ts
function $a039f9c7168ef4c9$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
        middlewares[_key] = arguments[_key];
    }
    return function(createStore2) {
        return function(reducer, preloadedState) {
            var store = createStore2(reducer, preloadedState);
            var dispatch = function() {
                throw new Error($a039f9c7168ef4c9$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function(action) {
                    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                        args[_key - 1] = arguments[_key];
                    }
                    return dispatch.apply(void 0, [
                        action
                    ].concat((0, $2Xzd1._)(args)));
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            dispatch = $a039f9c7168ef4c9$export$f672e0b6f7222cd7.apply(void 0, (0, $2Xzd1._)(chain))(store.dispatch);
            return (0, $kJeRc._)((0, $eRslx._)({}, store), {
                dispatch: dispatch
            });
        };
    };
}
// src/utils/isAction.ts
function $a039f9c7168ef4c9$export$b956e38827fca970(action) {
    return $a039f9c7168ef4c9$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}



var $5icQr = parcelRequire("5icQr");

var $bB0zn = parcelRequire("bB0zn");

var $6QEWP = parcelRequire("6QEWP");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $YtE9h = parcelRequire("YtE9h");
var $874a87fa87407f05$var$__defProp = Object.defineProperty;
var $874a87fa87407f05$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $874a87fa87407f05$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $874a87fa87407f05$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $874a87fa87407f05$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $874a87fa87407f05$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $874a87fa87407f05$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($874a87fa87407f05$var$__hasOwnProp.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($874a87fa87407f05$var$__getOwnPropSymbols) try {
        for(var _iterator = $874a87fa87407f05$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($874a87fa87407f05$var$__propIsEnum.call(b, prop)) $874a87fa87407f05$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $874a87fa87407f05$var$__publicField = function(obj, key, value) {
    $874a87fa87407f05$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $874a87fa87407f05$var$runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                stack = e.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $874a87fa87407f05$var$runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat((0, $2Xzd1._)(memoizeOptions)));
    var areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $874a87fa87407f05$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $874a87fa87407f05$export$1e290349de99e28c = function(devModeChecks) {
    Object.assign($874a87fa87407f05$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $874a87fa87407f05$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $874a87fa87407f05$var$assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0, $YtE9h._)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object));
    if ((typeof object === "undefined" ? "undefined" : (0, $YtE9h._)(object)) !== "object") throw new TypeError(errorMessage);
}
function $874a87fa87407f05$var$assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0, $YtE9h._)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var $874a87fa87407f05$var$ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function $874a87fa87407f05$var$getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $874a87fa87407f05$var$assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function $874a87fa87407f05$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $874a87fa87407f05$var$getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var __spreadValues1 = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, $874a87fa87407f05$var$globalDevModeChecks), devModeChecks), identityFunctionCheck = __spreadValues1.identityFunctionCheck, inputStabilityCheck = __spreadValues1.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $874a87fa87407f05$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $874a87fa87407f05$var$$REVISION = 0;
var $874a87fa87407f05$var$CURRENT_TRACKER = null;
var $874a87fa87407f05$var$Cell = /*#__PURE__*/ function() {
    "use strict";
    function Cell(initialValue) {
        var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
        (0, $bB0zn._)(this, Cell);
        $874a87fa87407f05$var$__publicField(this, "revision", $874a87fa87407f05$var$$REVISION);
        $874a87fa87407f05$var$__publicField(this, "_value");
        $874a87fa87407f05$var$__publicField(this, "_lastValue");
        $874a87fa87407f05$var$__publicField(this, "_isEqual", $874a87fa87407f05$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    (0, $6QEWP._)(Cell, [
        {
            key: "value",
            get: // Whenever a storage value is read, it'll add itself to the current tracker if
            // one exists, entangling its state with that cache.
            function get() {
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._value;
            },
            set: // Whenever a storage value is updated, we bump the global revision clock,
            // assign the revision for this storage to the new value, _and_ we schedule a
            // rerender. This is important, and it's what makes autotracking  _pull_
            // based. We don't actively tell the caches which depend on the storage that
            // anything has happened. Instead, we recompute the caches when needed.
            function set(newValue) {
                if (this.value === newValue) return;
                this._value = newValue;
                this.revision = ++$874a87fa87407f05$var$$REVISION;
            }
        }
    ]);
    return Cell;
}();
function $874a87fa87407f05$var$tripleEq(a, b) {
    return a === b;
}
var $874a87fa87407f05$var$TrackingCache = /*#__PURE__*/ function() {
    "use strict";
    function TrackingCache(fn) {
        (0, $bB0zn._)(this, TrackingCache);
        $874a87fa87407f05$var$__publicField(this, "_cachedValue");
        $874a87fa87407f05$var$__publicField(this, "_cachedRevision", -1);
        $874a87fa87407f05$var$__publicField(this, "_deps", []);
        $874a87fa87407f05$var$__publicField(this, "hits", 0);
        $874a87fa87407f05$var$__publicField(this, "fn");
        this.fn = fn;
    }
    (0, $6QEWP._)(TrackingCache, [
        {
            key: "clear",
            value: function clear() {
                this._cachedValue = void 0;
                this._cachedRevision = -1;
                this._deps = [];
                this.hits = 0;
            }
        },
        {
            key: "value",
            get: function get() {
                if (this.revision > this._cachedRevision) {
                    var fn = this.fn;
                    var currentTracker = /* @__PURE__ */ new Set();
                    var prevTracker = $874a87fa87407f05$var$CURRENT_TRACKER;
                    $874a87fa87407f05$var$CURRENT_TRACKER = currentTracker;
                    this._cachedValue = fn();
                    $874a87fa87407f05$var$CURRENT_TRACKER = prevTracker;
                    this.hits++;
                    this._deps = Array.from(currentTracker);
                    this._cachedRevision = this.revision;
                }
                $874a87fa87407f05$var$CURRENT_TRACKER == null || $874a87fa87407f05$var$CURRENT_TRACKER.add(this);
                return this._cachedValue;
            }
        },
        {
            key: "revision",
            get: function get() {
                var _Math;
                return (_Math = Math).max.apply(_Math, (0, $2Xzd1._)(this._deps.map(function(d) {
                    return d.revision;
                })).concat([
                    0
                ]));
            }
        }
    ]);
    return TrackingCache;
}();
function $874a87fa87407f05$var$getValue(cell) {
    if (!(cell instanceof $874a87fa87407f05$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $874a87fa87407f05$var$setValue(storage, value) {
    if (!(storage instanceof $874a87fa87407f05$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $874a87fa87407f05$var$createCell(initialValue) {
    var isEqual = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$var$tripleEq;
    return new $874a87fa87407f05$var$Cell(initialValue, isEqual);
}
function $874a87fa87407f05$var$createCache(fn) {
    $874a87fa87407f05$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $874a87fa87407f05$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $874a87fa87407f05$var$neverEq = function(a, b) {
    return false;
};
function $874a87fa87407f05$var$createTag() {
    return $874a87fa87407f05$var$createCell(null, $874a87fa87407f05$var$neverEq);
}
function $874a87fa87407f05$var$dirtyTag(tag, value) {
    $874a87fa87407f05$var$setValue(tag, value);
}
var $874a87fa87407f05$var$consumeCollection = function(node) {
    var tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $874a87fa87407f05$var$createTag();
    $874a87fa87407f05$var$getValue(tag);
};
var $874a87fa87407f05$var$dirtyCollection = function(node) {
    var tag = node.collectionTag;
    if (tag !== null) $874a87fa87407f05$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $874a87fa87407f05$var$REDUX_PROXY_LABEL = Symbol();
var $874a87fa87407f05$var$nextId = 0;
var $874a87fa87407f05$var$proto = Object.getPrototypeOf({});
var $874a87fa87407f05$var$ObjectTreeNode = function ObjectTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ObjectTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy(this, $874a87fa87407f05$var$objectProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$objectProxyHandler = {
    get: function(node, key) {
        function calculateResult() {
            var value = node.value;
            var childValue = Reflect.get(value, key);
            if ((typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) === "symbol") return childValue;
            if (key in $874a87fa87407f05$var$proto) return childValue;
            if ((typeof childValue === "undefined" ? "undefined" : (0, $YtE9h._)(childValue)) === "object" && childValue !== null) {
                var childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $874a87fa87407f05$var$createNode(childValue);
                if (childNode.tag) $874a87fa87407f05$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                var tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $874a87fa87407f05$var$createTag();
                    tag.value = childValue;
                }
                $874a87fa87407f05$var$getValue(tag);
                return childValue;
            }
        }
        var res = calculateResult();
        return res;
    },
    ownKeys: function(node) {
        $874a87fa87407f05$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor: function(node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has: function(node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $874a87fa87407f05$var$ArrayTreeNode = function ArrayTreeNode(value) {
    "use strict";
    (0, $bB0zn._)(this, ArrayTreeNode);
    this.value = value;
    $874a87fa87407f05$var$__publicField(this, "proxy", new Proxy([
        this
    ], $874a87fa87407f05$var$arrayProxyHandler));
    $874a87fa87407f05$var$__publicField(this, "tag", $874a87fa87407f05$var$createTag());
    $874a87fa87407f05$var$__publicField(this, "tags", {});
    $874a87fa87407f05$var$__publicField(this, "children", {});
    $874a87fa87407f05$var$__publicField(this, "collectionTag", null);
    $874a87fa87407f05$var$__publicField(this, "id", $874a87fa87407f05$var$nextId++);
    this.value = value;
    this.tag.value = value;
};
var $874a87fa87407f05$var$arrayProxyHandler = {
    get: function(param, key) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        if (key === "length") $874a87fa87407f05$var$consumeCollection(node);
        return $874a87fa87407f05$var$objectProxyHandler.get(node, key);
    },
    ownKeys: function(param) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has: function(param, prop) {
        var _param = (0, $kB67t._)(param, 1), node = _param[0];
        return $874a87fa87407f05$var$objectProxyHandler.has(node, prop);
    }
};
function $874a87fa87407f05$var$createNode(value) {
    if (Array.isArray(value)) return new $874a87fa87407f05$var$ArrayTreeNode(value);
    return new $874a87fa87407f05$var$ObjectTreeNode(value);
}
function $874a87fa87407f05$var$updateNode(node, newValue) {
    var value = node.value, tags = node.tags, children = node.children;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $874a87fa87407f05$var$dirtyCollection(node);
    else if (value !== newValue) {
        var oldKeysSize = 0;
        var newKeysSize = 0;
        var anyKeysAdded = false;
        for(var _key in value)oldKeysSize++;
        for(var key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        var isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $874a87fa87407f05$var$dirtyCollection(node);
    }
    for(var key1 in tags){
        var childValue = value[key1];
        var newChildValue = newValue[key1];
        if (childValue !== newChildValue) {
            $874a87fa87407f05$var$dirtyCollection(node);
            $874a87fa87407f05$var$dirtyTag(tags[key1], newChildValue);
        }
        if ((typeof newChildValue === "undefined" ? "undefined" : (0, $YtE9h._)(newChildValue)) === "object" && newChildValue !== null) delete tags[key1];
    }
    for(var key2 in children){
        var childNode = children[key2];
        var newChildValue1 = newValue[key2];
        var childValue1 = childNode.value;
        if (childValue1 === newChildValue1) continue;
        else if ((typeof newChildValue1 === "undefined" ? "undefined" : (0, $YtE9h._)(newChildValue1)) === "object" && newChildValue1 !== null) $874a87fa87407f05$var$updateNode(childNode, newChildValue1);
        else {
            $874a87fa87407f05$var$deleteNode(childNode);
            delete children[key2];
        }
    }
}
function $874a87fa87407f05$var$deleteNode(node) {
    if (node.tag) $874a87fa87407f05$var$dirtyTag(node.tag, null);
    $874a87fa87407f05$var$dirtyCollection(node);
    for(var key in node.tags)$874a87fa87407f05$var$dirtyTag(node.tags[key], null);
    for(var key1 in node.children)$874a87fa87407f05$var$deleteNode(node.children[key1]);
}
// src/lruMemoize.ts
function $874a87fa87407f05$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $874a87fa87407f05$var$NOT_FOUND;
        },
        put: function(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function() {
            entry = void 0;
        }
    };
}
function $874a87fa87407f05$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $874a87fa87407f05$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $874a87fa87407f05$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $874a87fa87407f05$export$3f025202a230c6dd = function(a, b) {
    return a === b;
};
function $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $874a87fa87407f05$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    var providedOptions = (typeof equalityCheckOrOptions === "undefined" ? "undefined" : (0, $YtE9h._)(equalityCheckOrOptions)) === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions_equalityCheck = providedOptions.equalityCheck, equalityCheck = _providedOptions_equalityCheck === void 0 ? $874a87fa87407f05$export$3f025202a230c6dd : _providedOptions_equalityCheck, _providedOptions_maxSize = providedOptions.maxSize, maxSize = _providedOptions_maxSize === void 0 ? 1 : _providedOptions_maxSize, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $874a87fa87407f05$var$createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? $874a87fa87407f05$var$createSingletonCache(comparator) : $874a87fa87407f05$var$createLruCache(maxSize, comparator);
    function memoized() {
        var value = cache.get(arguments);
        if (value === $874a87fa87407f05$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $874a87fa87407f05$export$c8f9cf88d9fdee55(func) {
    var node = $874a87fa87407f05$var$createNode([]);
    var lastArgs = null;
    var shallowEqual = $874a87fa87407f05$var$createCacheKeyComparator($874a87fa87407f05$export$3f025202a230c6dd);
    var cache = $874a87fa87407f05$var$createCache(function() {
        var res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $874a87fa87407f05$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $874a87fa87407f05$var$StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0, $bB0zn._)(this, StrongRef);
        this.value = value;
    }
    (0, $6QEWP._)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var $874a87fa87407f05$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $874a87fa87407f05$var$StrongRef;
var $874a87fa87407f05$var$UNTERMINATED = 0;
var $874a87fa87407f05$var$TERMINATED = 1;
function $874a87fa87407f05$var$createCacheNode() {
    return {
        s: $874a87fa87407f05$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $874a87fa87407f05$export$8402dc26d96f6902(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var fnNode = $874a87fa87407f05$var$createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    function memoized() {
        var _a, _b;
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || (typeof arg === "undefined" ? "undefined" : (0, $YtE9h._)(arg)) === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $874a87fa87407f05$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === $874a87fa87407f05$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                var needsWeakRef = (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $874a87fa87407f05$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $874a87fa87407f05$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = function() {
        fnNode = $874a87fa87407f05$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $874a87fa87407f05$export$5943f4447f6ef248(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if ((typeof resultFunc === "undefined" ? "undefined" : (0, $YtE9h._)(resultFunc)) === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $874a87fa87407f05$var$assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0, $YtE9h._)(resultFunc), "]"));
        var combinedOptions = $874a87fa87407f05$var$__spreadValues($874a87fa87407f05$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        var memoize = combinedOptions.memoize, _combinedOptions_memoizeOptions = combinedOptions.memoizeOptions, memoizeOptions = _combinedOptions_memoizeOptions === void 0 ? [] : _combinedOptions_memoizeOptions, _combinedOptions_argsMemoize = combinedOptions.argsMemoize, argsMemoize = _combinedOptions_argsMemoize === void 0 ? $874a87fa87407f05$export$8402dc26d96f6902 : _combinedOptions_argsMemoize, _combinedOptions_argsMemoizeOptions = combinedOptions.argsMemoizeOptions, argsMemoizeOptions = _combinedOptions_argsMemoizeOptions === void 0 ? [] : _combinedOptions_argsMemoizeOptions, _combinedOptions_devModeChecks = combinedOptions.devModeChecks, devModeChecks = _combinedOptions_devModeChecks === void 0 ? {} : _combinedOptions_devModeChecks;
        var finalMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = $874a87fa87407f05$var$ensureIsArray(argsMemoizeOptions);
        var dependencies = $874a87fa87407f05$var$getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0, $2Xzd1._)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = $874a87fa87407f05$var$collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                return lastResult;
            }
        ].concat((0, $2Xzd1._)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var $874a87fa87407f05$export$595d22ed68ca2841 = /* @__PURE__ */ $874a87fa87407f05$export$5943f4447f6ef248($874a87fa87407f05$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $874a87fa87407f05$export$75979cfcd91bf38f = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $874a87fa87407f05$export$595d22ed68ca2841;
    $874a87fa87407f05$var$assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0, $YtE9h._)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    var dependencies = inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    });
    var structuredSelector = selectorCreator(dependencies, function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: function() {
        return $874a87fa87407f05$export$75979cfcd91bf38f;
    }
});


// src/index.ts
function $2193944b4716daad$var$createThunkMiddleware(extraArgument) {
    var middleware = function(param) {
        var dispatch = param.dispatch, getState = param.getState;
        return function(next) {
            return function(action) {
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
    return middleware;
}
var $2193944b4716daad$export$dd164f5517779f15 = $2193944b4716daad$var$createThunkMiddleware();
var $2193944b4716daad$export$16d06542a1949d9e = $2193944b4716daad$var$createThunkMiddleware;



var $ibRPI = parcelRequire("ibRPI");
var $44e97ff44f917989$var$__defProp = Object.defineProperty;
var $44e97ff44f917989$var$__defProps = Object.defineProperties;
var $44e97ff44f917989$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $44e97ff44f917989$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $44e97ff44f917989$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $44e97ff44f917989$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $44e97ff44f917989$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $44e97ff44f917989$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $44e97ff44f917989$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($44e97ff44f917989$var$__hasOwnProp.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if ($44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(b)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if ($44e97ff44f917989$var$__propIsEnum.call(b, prop)) $44e97ff44f917989$var$__defNormalProp(a, prop, b[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return a;
};
var $44e97ff44f917989$var$__spreadProps = function(a, b) {
    return $44e97ff44f917989$var$__defProps(a, $44e97ff44f917989$var$__getOwnPropDescs(b));
};
var $44e97ff44f917989$var$__objRest = function(source, exclude) {
    var target = {};
    for(var prop in source)if ($44e97ff44f917989$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (source != null && $44e97ff44f917989$var$__getOwnPropSymbols) try {
        for(var _iterator = $44e97ff44f917989$var$__getOwnPropSymbols(source)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            if (exclude.indexOf(prop) < 0 && $44e97ff44f917989$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return target;
};
var $44e97ff44f917989$var$__publicField = function(obj, key, value) {
    $44e97ff44f917989$var$__defNormalProp(obj, (typeof key === "undefined" ? "undefined" : (0, $YtE9h._)(key)) !== "symbol" ? key + "" : key, value);
    return value;
};
var $44e97ff44f917989$export$aab6de9e3dbb1473 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var createSelector2 = (0, $874a87fa87407f05$export$5943f4447f6ef248).apply(void 0, (0, $2Xzd1._)(args));
    var createDraftSafeSelector2 = Object.assign(function() {
        for(var _len = arguments.length, args2 = new Array(_len), _key = 0; _key < _len; _key++){
            args2[_key] = arguments[_key];
        }
        var selector = createSelector2.apply(void 0, (0, $2Xzd1._)(args2));
        var wrappedSelector = function(value) {
            for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                rest[_key - 1] = arguments[_key];
            }
            return selector.apply(void 0, [
                (0, $5icQr.isDraft)(value) ? (0, $5icQr.current)(value) : value
            ].concat((0, $2Xzd1._)(rest)));
        };
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: function() {
            return createDraftSafeSelector2;
        }
    });
    return createDraftSafeSelector2;
};
var $44e97ff44f917989$export$a5d3c27355e35910 = $44e97ff44f917989$export$aab6de9e3dbb1473((0, $874a87fa87407f05$export$8402dc26d96f6902));
var $44e97ff44f917989$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function composeWithDevTools() {
    if (arguments.length === 0) return void 0;
    if ((0, $YtE9h._)(arguments[0]) === "object") return 0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7;
    return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $44e97ff44f917989$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function devToolsEnhancer() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $44e97ff44f917989$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, (0, $2Xzd1._)(args));
            if (!prepared) throw new Error($44e97ff44f917989$export$378fa86b259c0280(0));
            return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "".concat(type);
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && action.type === type;
    };
    return actionCreator;
}
function $44e97ff44f917989$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $44e97ff44f917989$var$hasMatchFunction(action);
}
function $44e97ff44f917989$export$ebd532f9034651f3(action) {
    return (0, $a039f9c7168ef4c9$export$b956e38827fca970)(action) && Object.keys(action).every($44e97ff44f917989$var$isValidKey);
}
function $44e97ff44f917989$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $44e97ff44f917989$var$getMessage(type) {
    var splitType = type ? "".concat(type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "'.concat(type || "unknown", "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(").concat(actionName, "())` instead of `dispatch(").concat(actionName, ")`. This is necessary even if the action has no payload.");
}
function $44e97ff44f917989$export$6a1fcb4ceef578f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn("".concat(fnName, " took ").concat(elapsed, "ms, which is more than the warning threshold of ").concat(maxDelay, "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that."));
        }
    };
}
function $44e97ff44f917989$var$find(iterable, comparator) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = iterable[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entry = _step.value;
            if (comparator(entry)) return entry;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return void 0;
}
var $44e97ff44f917989$export$1908877435b1d5e9 = /*#__PURE__*/ function(Array1) {
    "use strict";
    (0, $5dLwP._)(_Tuple, Array1);
    function _Tuple() {
        for(var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++){
            items[_key] = arguments[_key];
        }
        (0, $bB0zn._)(this, _Tuple);
        var _this;
        _this = (0, $3Gvhd._)(this, _Tuple, (0, $2Xzd1._)(items));
        Object.setPrototypeOf(_this, _Tuple.prototype);
        return _this;
    }
    (0, $6QEWP._)(_Tuple, [
        {
            key: "concat",
            value: function concat() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                return (0, $04ca9dac0ceac2e2$export$71511d61b312f219)((0, $ZhYhU._)(_Tuple.prototype), "concat", this).apply(this, arr);
            }
        },
        {
            key: "prepend",
            value: function prepend() {
                for(var _len = arguments.length, arr = new Array(_len), _key = 0; _key < _len; _key++){
                    arr[_key] = arguments[_key];
                }
                if (arr.length === 1 && Array.isArray(arr[0])) return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr[0].concat(this)));
                return (0, $f5KHm._)(_Tuple, (0, $2Xzd1._)(arr.concat(this)));
            }
        }
    ], [
        {
            key: Symbol.species,
            get: function get() {
                return _Tuple;
            }
        }
    ]);
    return _Tuple;
}((0, $fPaN7._)(Array));
function $44e97ff44f917989$var$freezeDraftable(val) {
    return (0, $5icQr.isDraftable)(val) ? (0, $5icQr.produce)(val, function() {}) : val;
}
function $44e97ff44f917989$var$emplace(map, key, handler) {
    if (map.has(key)) {
        var value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($44e97ff44f917989$export$378fa86b259c0280(10));
    var inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $44e97ff44f917989$export$9021b2733a0028a3(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" || value == null || Object.isFrozen(value);
}
function $44e97ff44f917989$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $44e97ff44f917989$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $44e97ff44f917989$var$trackProperties(isImmutable) {
    var ignorePaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], obj = arguments.length > 2 ? arguments[2] : void 0, path = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", checkedObjects = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : /* @__PURE__ */ new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $44e97ff44f917989$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $44e97ff44f917989$var$detectMutations(isImmutable) {
    var _loop = function(key2) {
        var nestedPath = path ? path + "." + key2 : key2;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $44e97ff44f917989$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key2], obj[key2], sameRef, nestedPath);
        if (result.wasMutated) return {
            v: result
        };
    };
    var ignoredPaths = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], trackedProperty = arguments.length > 2 ? arguments[2] : void 0, obj = arguments.length > 3 ? arguments[3] : void 0, sameParentRef = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, path = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key1 in obj)keysToDetect[key1] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for(var key2 in keysToDetect){
        var _ret = _loop(key2);
        if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
    }
    return {
        wasMutated: false
    };
}
function $44e97ff44f917989$export$9181bb1a5474289() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var stringify, getSerialize, getState, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $44e97ff44f917989$export$77670485918dab4e(val) {
    var type = typeof val === "undefined" ? "undefined" : (0, $YtE9h._)(val);
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(val);
}
function $44e97ff44f917989$export$ada5dca0b571bc7(value) {
    var path = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isSerializable = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $44e97ff44f917989$export$77670485918dab4e, getEntries = arguments.length > 3 ? arguments[3] : void 0, ignoredPaths = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [], cache = arguments.length > 5 ? arguments[5] : void 0;
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $kB67t._)(_step.value, 2), key = _step_value[0], nestedValue = _step_value[1];
            var nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                var hasMatches = ignoredPaths.some(function(ignored) {
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) return "continue";
            }
            if (!isSerializable(nestedValue)) return {
                v: {
                    keyPath: nestedPath,
                    value: nestedValue
                }
            };
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $YtE9h._)(nestedValue)) === "object") {
                foundNestedSerializable = $44e97ff44f917989$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
                if (foundNestedSerializable) return {
                    v: foundNestedSerializable
                };
            }
        };
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _ret = _loop();
            if ((0, $YtE9h._)(_ret) === "object") return _ret.v;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (cache && $44e97ff44f917989$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $44e97ff44f917989$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.values(value)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var nestedValue = _step.value;
            if ((typeof nestedValue === "undefined" ? "undefined" : (0, $YtE9h._)(nestedValue)) !== "object" || nestedValue === null) continue;
            if (!$44e97ff44f917989$var$isNestedFrozen(nestedValue)) return false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return true;
}
function $44e97ff44f917989$export$6dea1aad6dac5ac2() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var storeAPI, next, action;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $44e97ff44f917989$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $44e97ff44f917989$var$buildGetDefaultMiddleware = function() {
    return function getDefaultMiddleware(options) {
        var _ref = options != null ? options : {}, _ref_thunk = _ref.thunk, thunk = _ref_thunk === void 0 ? true : _ref_thunk, _ref_immutableCheck = _ref.immutableCheck, immutableCheck = _ref_immutableCheck === void 0 ? true : _ref_immutableCheck, _ref_serializableCheck = _ref.serializableCheck, serializableCheck = _ref_serializableCheck === void 0 ? true : _ref_serializableCheck, _ref_actionCreatorCheck = _ref.actionCreatorCheck, actionCreatorCheck = _ref_actionCreatorCheck === void 0 ? true : _ref_actionCreatorCheck;
        var middlewareArray = new $44e97ff44f917989$export$1908877435b1d5e9();
        if (thunk) {
            if ($44e97ff44f917989$var$isBoolean(thunk)) middlewareArray.push((0, $2193944b4716daad$export$dd164f5517779f15));
            else middlewareArray.push((0, $2193944b4716daad$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
};
// src/autoBatchEnhancer.ts
var $44e97ff44f917989$export$8fb31c0f05df007b = "RTK_autoBatch";
var $44e97ff44f917989$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        return {
            payload: payload,
            meta: (0, $hD5pT._)({}, $44e97ff44f917989$export$8fb31c0f05df007b, true)
        };
    };
};
var $44e97ff44f917989$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $44e97ff44f917989$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $44e97ff44f917989$var$createQueueWithTimer(10);
var $44e97ff44f917989$export$676277d7dca0f396 = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {
        type: "raf"
    };
    return function(next) {
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var store = next.apply(void 0, (0, $2Xzd1._)(args));
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = /* @__PURE__ */ new Set();
            var queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $44e97ff44f917989$var$rAF : options.type === "callback" ? options.queueNotification : $44e97ff44f917989$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$44e97ff44f917989$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/getDefaultEnhancers.ts
var $44e97ff44f917989$var$buildGetDefaultEnhancers = function(middlewareEnhancer) {
    return function getDefaultEnhancers(options) {
        var _ref = options != null ? options : {}, _ref_autoBatch = _ref.autoBatch, autoBatch = _ref_autoBatch === void 0 ? true : _ref_autoBatch;
        var enhancerArray = new $44e97ff44f917989$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($44e97ff44f917989$export$676277d7dca0f396((typeof autoBatch === "undefined" ? "undefined" : (0, $YtE9h._)(autoBatch)) === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
};
// src/configureStore.ts
var $44e97ff44f917989$var$IS_PRODUCTION = true;
function $44e97ff44f917989$export$7d8a5b498da695ac(options) {
    var getDefaultMiddleware = $44e97ff44f917989$var$buildGetDefaultMiddleware();
    var _ref = options || {}, reducer = _ref.reducer, middleware = _ref.middleware, _ref_devTools = _ref.devTools, devTools = _ref_devTools === void 0 ? true : _ref_devTools, preloadedState = _ref.preloadedState, enhancers = _ref.enhancers;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $a039f9c7168ef4c9$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducer);
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(1));
    if (!$44e97ff44f917989$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($44e97ff44f917989$export$378fa86b259c0280(2));
    var finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$44e97ff44f917989$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$44e97ff44f917989$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($44e97ff44f917989$export$378fa86b259c0280(4));
    var finalCompose = (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $44e97ff44f917989$var$composeWithDevTools($44e97ff44f917989$var$__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$44e97ff44f917989$var$IS_PRODUCTION
    }, (typeof devTools === "undefined" ? "undefined" : (0, $YtE9h._)(devTools)) === "object" && devTools));
    var middlewareEnhancer = (0, $a039f9c7168ef4c9$export$9ff26e0402cc7b7).apply(void 0, (0, $2Xzd1._)(finalMiddleware));
    var getDefaultEnhancers = $44e97ff44f917989$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$44e97ff44f917989$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($44e97ff44f917989$export$378fa86b259c0280(5));
    var storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$44e97ff44f917989$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(6));
    if (!$44e97ff44f917989$var$IS_PRODUCTION && storeEnhancers.some(function(item) {
        return typeof item !== "function";
    })) throw new Error($44e97ff44f917989$export$378fa86b259c0280(7));
    if (!$44e97ff44f917989$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    var composedEnhancer = finalCompose.apply(void 0, (0, $2Xzd1._)(storeEnhancers));
    return (0, $a039f9c7168ef4c9$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $44e97ff44f917989$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($44e97ff44f917989$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $44e97ff44f917989$var$isStateFunction(x) {
    return typeof x === "function";
}
function $44e97ff44f917989$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    var _executeReducerBuilderCallback = (0, $kB67t._)($44e97ff44f917989$var$executeReducerBuilderCallback(mapOrBuilderCallback), 3), actionsMap = _executeReducerBuilderCallback[0], finalActionMatchers = _executeReducerBuilderCallback[1], finalDefaultCaseReducer = _executeReducerBuilderCallback[2];
    var getInitialState;
    if ($44e97ff44f917989$var$isStateFunction(initialState)) getInitialState = function() {
        return $44e97ff44f917989$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState = $44e97ff44f917989$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState;
        };
    }
    function reducer() {
        var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getInitialState(), action = arguments.length > 1 ? arguments[1] : void 0;
        var caseReducers = [
            actionsMap[action.type]
        ].concat((0, $2Xzd1._)(finalActionMatchers.filter(function(param) {
            var matcher = param.matcher;
            return matcher(action);
        }).map(function(param) {
            var reducer2 = param.reducer;
            return reducer2;
        })));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $5icQr.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $5icQr.isDraftable)(previousState)) {
                    var result1 = caseReducer(previousState, action);
                    if (result1 === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($44e97ff44f917989$export$378fa86b259c0280(9));
                    }
                    return result1;
                } else return (0, $5icQr.produce)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $44e97ff44f917989$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $44e97ff44f917989$export$ac4959f4f1338dfc = function() {
    var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 21;
    var id = "";
    var i = size;
    while(i--)id += $44e97ff44f917989$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $44e97ff44f917989$var$matches = function(matcher, action) {
    if ($44e97ff44f917989$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $44e97ff44f917989$export$2c3435c7647f7b0d() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.some(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$export$9dd1fb32974da385() {
    for(var _len = arguments.length, matchers = new Array(_len), _key = 0; _key < _len; _key++){
        matchers[_key] = arguments[_key];
    }
    return function(action) {
        return matchers.every(function(matcher) {
            return $44e97ff44f917989$var$matches(matcher, action);
        });
    };
}
function $44e97ff44f917989$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $44e97ff44f917989$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $44e97ff44f917989$export$872dec21e9a69476() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$872dec21e9a69476()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.pending;
    })));
}
function $44e97ff44f917989$export$a5c5d27e3994c5be() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.rejected;
    })));
}
function $44e97ff44f917989$export$fcc3388fb56de601() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$fcc3388fb56de601()(asyncThunks[0]);
    return $44e97ff44f917989$export$9dd1fb32974da385($44e97ff44f917989$export$a5c5d27e3994c5be.apply(void 0, (0, $2Xzd1._)(asyncThunks)), hasFlag);
}
function $44e97ff44f917989$export$1da80a6ef1307441() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$1da80a6ef1307441()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.map(function(asyncThunk) {
        return asyncThunk.fulfilled;
    })));
}
function $44e97ff44f917989$export$6aa4142d99c1abce() {
    for(var _len = arguments.length, asyncThunks = new Array(_len), _key = 0; _key < _len; _key++){
        asyncThunks[_key] = arguments[_key];
    }
    if (asyncThunks.length === 0) return function(action) {
        return $44e97ff44f917989$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$44e97ff44f917989$var$isAsyncThunkArray(asyncThunks)) return $44e97ff44f917989$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $44e97ff44f917989$export$2c3435c7647f7b0d.apply(void 0, (0, $2Xzd1._)(asyncThunks.flatMap(function(asyncThunk) {
        return [
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ];
    })));
}
// src/createAsyncThunk.ts
var $44e97ff44f917989$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $44e97ff44f917989$var$RejectWithValue = function RejectWithValue(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, RejectWithValue);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$var$FulfillWithMeta = function FulfillWithMeta(payload, meta) {
    "use strict";
    (0, $bB0zn._)(this, FulfillWithMeta);
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ $44e97ff44f917989$var$__publicField(this, "_type");
};
var $44e97ff44f917989$export$c97c53d0b2d5d81e = function(value) {
    if ((typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && value !== null) {
        var simpleError = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = $44e97ff44f917989$var$commonProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var property = _step.value;
                if (typeof value[property] === "string") simpleError[property] = value[property];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $44e97ff44f917989$export$6abd22dc03e5063f = /* @__PURE__ */ function() {
    var createAsyncThunk2 = function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $44e97ff44f917989$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $44e97ff44f917989$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var abort = function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                };
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $44e97ff44f917989$export$ac4959f4f1338dfc();
                var abortController = new AbortController();
                var abortHandler;
                var abortReason;
                var promise = (0, $7k5I8._)(function() {
                    var _a, _b, finalAction, conditionResult, abortedPromise, err, skipDispatch;
                    return (0, $lFlDF.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    4,
                                    5,
                                    6
                                ]);
                                conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                    getState: getState,
                                    extra: extra
                                });
                                if (!$44e97ff44f917989$var$isThenable(conditionResult)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    conditionResult
                                ];
                            case 1:
                                conditionResult = _state.sent();
                                _state.label = 2;
                            case 2:
                                if (conditionResult === false || abortController.signal.aborted) throw {
                                    name: "ConditionError",
                                    message: "Aborted due to condition callback returning false."
                                };
                                abortedPromise = new Promise(function(_, reject) {
                                    abortHandler = function() {
                                        reject({
                                            name: "AbortError",
                                            message: abortReason || "Aborted"
                                        });
                                    };
                                    abortController.signal.addEventListener("abort", abortHandler);
                                });
                                dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                    requestId: requestId,
                                    arg: arg
                                }, {
                                    getState: getState,
                                    extra: extra
                                })));
                                return [
                                    4,
                                    Promise.race([
                                        abortedPromise,
                                        Promise.resolve(payloadCreator(arg, {
                                            dispatch: dispatch,
                                            getState: getState,
                                            extra: extra,
                                            requestId: requestId,
                                            signal: abortController.signal,
                                            abort: abort,
                                            rejectWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$RejectWithValue(value, meta);
                                            },
                                            fulfillWithValue: function(value, meta) {
                                                return new $44e97ff44f917989$var$FulfillWithMeta(value, meta);
                                            }
                                        })).then(function(result) {
                                            if (result instanceof $44e97ff44f917989$var$RejectWithValue) throw result;
                                            if (result instanceof $44e97ff44f917989$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                            return fulfilled(result, requestId, arg);
                                        })
                                    ])
                                ];
                            case 3:
                                finalAction = _state.sent();
                                return [
                                    3,
                                    6
                                ];
                            case 4:
                                err = _state.sent();
                                finalAction = err instanceof $44e97ff44f917989$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                                return [
                                    3,
                                    6
                                ];
                            case 5:
                                if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                                return [
                                    7
                                ];
                            case 6:
                                skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                if (!skipDispatch) dispatch(finalAction);
                                return [
                                    2,
                                    finalAction
                                ];
                        }
                    });
                })();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise.then($44e97ff44f917989$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $44e97ff44f917989$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    };
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $44e97ff44f917989$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $44e97ff44f917989$var$isThenable(value) {
    return value !== null && (typeof value === "undefined" ? "undefined" : (0, $YtE9h._)(value)) === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $44e97ff44f917989$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $44e97ff44f917989$export$343355ed40c51c46 = (0, $hD5pT._)({}, $44e97ff44f917989$var$asyncThunkSymbol, $44e97ff44f917989$export$6abd22dc03e5063f);
var $44e97ff44f917989$export$23a094319a4b586 = /* @__PURE__ */ function(ReducerType2) {
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
}($44e97ff44f917989$export$23a094319a4b586 || {});
function $44e97ff44f917989$var$getType(slice, actionKey) {
    return "".concat(slice, "/").concat(actionKey);
}
function $44e97ff44f917989$export$affdea4146de9cf5() {
    var creators = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).creators;
    var _a;
    var cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[$44e97ff44f917989$var$asyncThunkSymbol];
    return function createSlice2(options) {
        var name = options.name, _options_reducerPath = options.reducerPath, reducerPath = _options_reducerPath === void 0 ? name : _options_reducerPath;
        if (!name) throw new Error($44e97ff44f917989$export$378fa86b259c0280(11));
        typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI);
        var reducers = (typeof options.reducers === "function" ? options.reducers($44e97ff44f917989$var$buildReducerCreators()) : options.reducers) || {};
        var reducerNames = Object.keys(reducers);
        var context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        var contextMethods = {
            addCase: function(typeOrActionCreator, reducer2) {
                var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($44e97ff44f917989$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($44e97ff44f917989$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher: function(matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction: function(name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer: function(name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach(function(reducerName) {
            var reducerDefinition = reducers[reducerName];
            var reducerDetails = {
                reducerName: reducerName,
                type: $44e97ff44f917989$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $44e97ff44f917989$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $44e97ff44f917989$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            var _ref = (0, $kB67t._)(typeof options.extraReducers === "function" ? $44e97ff44f917989$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ], 3), tmp = _ref[0], extraReducers = tmp === void 0 ? {} : tmp, tmp1 = _ref[1], actionMatchers = tmp1 === void 0 ? [] : tmp1, defaultCaseReducer = _ref[2];
            var finalCaseReducers = $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return $44e97ff44f917989$export$473eb76d322d0290(options.initialState, function(builder) {
                for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = context.sliceMatchers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sM = _step.value;
                        builder.addMatcher(sM.matcher, sM.reducer);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = actionMatchers[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var m = _step1.value;
                        builder.addMatcher(m.matcher, m.reducer);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        var selectSelf = function(state) {
            return state;
        };
        var injectedSelectorCache = /* @__PURE__ */ new Map();
        var _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2) {
            var injected = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
            function selectSlice(state) {
                var sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors() {
                var selectState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : selectSelf;
                var selectorCache = $44e97ff44f917989$var$emplace(injectedSelectorCache, injected, {
                    insert: function() {
                        return /* @__PURE__ */ new WeakMap();
                    }
                });
                return $44e97ff44f917989$var$emplace(selectorCache, selectState, {
                    insert: function() {
                        var _a2;
                        var map = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries((_a2 = options.selectors) != null ? _a2 : {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $kB67t._)(_step.value, 2), name2 = _step_value[0], selector = _step_value[1];
                                map[name2] = $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        var slice = $44e97ff44f917989$var$__spreadProps($44e97ff44f917989$var$__spreadValues({
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto: function(injectable) {
                var _a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _b = _a2, pathOpt = _b.reducerPath, config = $44e97ff44f917989$var$__objRest(_b, [
                    "reducerPath"
                ]);
                var newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function $44e97ff44f917989$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector.apply(void 0, [
            sliceState
        ].concat((0, $2Xzd1._)(args)));
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $44e97ff44f917989$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $44e97ff44f917989$export$affdea4146de9cf5();
function $44e97ff44f917989$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return $44e97ff44f917989$var$__spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator
        }, config);
    }
    asyncThunk.withTypes = function() {
        return asyncThunk;
    };
    return {
        reducer: function(caseReducer) {
            return Object.assign(// hack so the wrapping function has the same name as the original
            // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
            (0, $hD5pT._)({}, caseReducer.name, function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return caseReducer.apply(void 0, (0, $2Xzd1._)(args));
            })[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer: function(prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $44e97ff44f917989$var$handleNormalReducerDefinition(param, maybeReducerWithPrepare, context) {
    var type = param.type, reducerName = param.reducerName, createNotation = param.createNotation;
    var caseReducer;
    var prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $44e97ff44f917989$export$309c7a02b0b0bc62(type, prepareCallback) : $44e97ff44f917989$export$309c7a02b0b0bc62(type));
}
function $44e97ff44f917989$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $44e97ff44f917989$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $44e97ff44f917989$var$handleThunkCaseReducerDefinition(param, reducerDefinition, context, cAT) {
    var type = param.type, reducerName = param.reducerName;
    if (!cAT) throw new Error($44e97ff44f917989$export$378fa86b259c0280(18));
    var payloadCreator = reducerDefinition.payloadCreator, fulfilled = reducerDefinition.fulfilled, pending = reducerDefinition.pending, rejected = reducerDefinition.rejected, settled = reducerDefinition.settled, options = reducerDefinition.options;
    var thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $44e97ff44f917989$var$noop,
        pending: pending || $44e97ff44f917989$var$noop,
        rejected: rejected || $44e97ff44f917989$var$noop,
        settled: settled || $44e97ff44f917989$var$noop
    });
}
function $44e97ff44f917989$var$noop() {}
// src/entities/entity_state.ts
function $44e97ff44f917989$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $44e97ff44f917989$var$createInitialStateFactory(stateAdapter) {
    function getInitialState() {
        var additionalState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, entities = arguments.length > 1 ? arguments[1] : void 0;
        var state = Object.assign($44e97ff44f917989$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $44e97ff44f917989$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var tmp = options.createSelector, createSelector2 = tmp === void 0 ? $44e97ff44f917989$export$a5d3c27355e35910 : tmp;
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = createSelector2(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = createSelector2(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $44e97ff44f917989$var$isDraftTyped = (0, $5icQr.isDraft);
function $44e97ff44f917989$var$createSingleArgumentStateOperator(mutator) {
    var operator = $44e97ff44f917989$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $44e97ff44f917989$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $44e97ff44f917989$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($44e97ff44f917989$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $5icQr.produce)(state, runMutator);
    };
}
function $44e97ff44f917989$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $44e97ff44f917989$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $44e97ff44f917989$var$getCurrent(value) {
    return (0, $5icQr.isDraft)(value) ? (0, $5icQr.current)(value) : value;
}
function $44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
    var existingIdsArray = $44e97ff44f917989$var$getCurrent(state.ids);
    var existingIds = new Set(existingIdsArray);
    var added = [];
    var updated = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var entity = _step.value;
            var id = $44e97ff44f917989$var$selectIdValue(entity, selectId);
            if (existingIds.has(id)) updated.push({
                id: id,
                changes: entity
            });
            else added.push(entity);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $44e97ff44f917989$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                addOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setOneMutably(entity, state) {
        var key = $44e97ff44f917989$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var entity = _step.value;
                setOneMutably(entity, state);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        var updated = Object.assign({}, original3, update.changes);
        var newKey = $44e97ff44f917989$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map(function(e) {
                return $44e97ff44f917989$var$selectIdValue(e, selectId);
            });
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 2), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $44e97ff44f917989$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably),
        removeOne: $44e97ff44f917989$var$createStateOperator(removeOneMutably),
        removeMany: $44e97ff44f917989$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $44e97ff44f917989$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    var lowIndex = 0;
    var highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        var middleIndex = lowIndex + highIndex >>> 1;
        var currentItem = sortedItems[middleIndex];
        var res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $44e97ff44f917989$var$insert(sortedItems, item, comparisonFunction) {
    var insertAtIndex = $44e97ff44f917989$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $44e97ff44f917989$var$createSortedStateAdapter(selectId, comparer) {
    var _createUnsortedStateAdapter = $44e97ff44f917989$var$createUnsortedStateAdapter(selectId), removeOne = _createUnsortedStateAdapter.removeOne, removeMany = _createUnsortedStateAdapter.removeMany, removeAll = _createUnsortedStateAdapter.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        var existingKeys = new Set(existingIds != null ? existingIds : $44e97ff44f917989$var$getCurrent(state.ids));
        var models = newEntities.filter(function(model) {
            return !existingKeys.has($44e97ff44f917989$var$selectIdValue(model, selectId));
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = newEntities[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var item = _step.value;
                    delete state.entities[selectId(item)];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $44e97ff44f917989$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        var replacedIds = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var update = _step.value;
                var entity = state.entities[update.id];
                if (!entity) continue;
                appliedUpdates = true;
                Object.assign(entity, update.changes);
                var newId = selectId(entity);
                if (update.id !== newId) {
                    replacedIds = true;
                    delete state.entities[update.id];
                    var oldIndex = state.ids.indexOf(update.id);
                    state.ids[oldIndex] = newId;
                    state.entities[newId] = entity;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _splitAddedUpdatedEntities = (0, $kB67t._)($44e97ff44f917989$var$splitAddedUpdatedEntities(newEntities, selectId, state), 3), added = _splitAddedUpdatedEntities[0], updated = _splitAddedUpdatedEntities[1], existingIdsArray = _splitAddedUpdatedEntities[2];
        if (updated.length) updateManyMutably(updated, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    var mergeFunction = function(state, addedItems, appliedUpdates, replacedIds) {
        var currentEntities = $44e97ff44f917989$var$getCurrent(state.entities);
        var currentIds = $44e97ff44f917989$var$getCurrent(state.ids);
        var stateEntities = state.entities;
        var ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        var sortedEntities = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var id = _step.value;
                var entity = currentEntities[id];
                if (entity) sortedEntities.push(entity);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var wasPreviouslyEmpty = sortedEntities.length === 0;
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = addedItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                stateEntities[selectId(item)] = item;
                if (!wasPreviouslyEmpty) $44e97ff44f917989$var$insert(sortedEntities, item, comparer);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        var newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $44e97ff44f917989$var$createStateOperator(addOneMutably),
        updateOne: $44e97ff44f917989$var$createStateOperator(updateOneMutably),
        upsertOne: $44e97ff44f917989$var$createStateOperator(upsertOneMutably),
        setOne: $44e97ff44f917989$var$createStateOperator(setOneMutably),
        setMany: $44e97ff44f917989$var$createStateOperator(setManyMutably),
        setAll: $44e97ff44f917989$var$createStateOperator(setAllMutably),
        addMany: $44e97ff44f917989$var$createStateOperator(addManyMutably),
        updateMany: $44e97ff44f917989$var$createStateOperator(updateManyMutably),
        upsertMany: $44e97ff44f917989$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $44e97ff44f917989$export$abcf4037b41e0df() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __spreadValues1 = $44e97ff44f917989$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = __spreadValues1.selectId, sortComparer = __spreadValues1.sortComparer;
    var stateAdapter = sortComparer ? $44e97ff44f917989$var$createSortedStateAdapter(selectId, sortComparer) : $44e97ff44f917989$var$createUnsortedStateAdapter(selectId);
    var stateFactory = $44e97ff44f917989$var$createInitialStateFactory(stateAdapter);
    var selectorsFactory = $44e97ff44f917989$var$createSelectorsFactory();
    return $44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues($44e97ff44f917989$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var $44e97ff44f917989$var$task = "task";
var $44e97ff44f917989$var$listener = "listener";
var $44e97ff44f917989$var$completed = "completed";
var $44e97ff44f917989$var$cancelled = "cancelled";
var $44e97ff44f917989$var$taskCancelled = "task-".concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$taskCompleted = "task-".concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$var$listenerCancelled = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$cancelled);
var $44e97ff44f917989$var$listenerCompleted = "".concat($44e97ff44f917989$var$listener, "-").concat($44e97ff44f917989$var$completed);
var $44e97ff44f917989$export$cb1bdac908fed7f = function TaskAbortError(code) {
    "use strict";
    (0, $bB0zn._)(this, TaskAbortError);
    this.code = code;
    $44e97ff44f917989$var$__publicField(this, "name", "TaskAbortError");
    $44e97ff44f917989$var$__publicField(this, "message");
    this.message = "".concat($44e97ff44f917989$var$task, " ").concat($44e97ff44f917989$var$cancelled, " (reason: ").concat(code, ")");
};
// src/listenerMiddleware/utils.ts
var $44e97ff44f917989$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new Error($44e97ff44f917989$export$378fa86b259c0280(32));
};
var $44e97ff44f917989$var$noop2 = function() {};
var $44e97ff44f917989$var$catchRejection = function(promise) {
    var onError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $44e97ff44f917989$var$noop2;
    promise.catch(onError);
    return promise;
};
var $44e97ff44f917989$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $44e97ff44f917989$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $44e97ff44f917989$var$validateActive = function(signal) {
    if (signal.aborted) {
        var reason = signal.reason;
        throw new $44e97ff44f917989$export$cb1bdac908fed7f(reason);
    }
};
function $44e97ff44f917989$var$raceWithSignal(signal, promise) {
    var cleanup = $44e97ff44f917989$var$noop2;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $44e97ff44f917989$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $44e97ff44f917989$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $44e97ff44f917989$var$noop2;
    });
}
var $44e97ff44f917989$var$runTask = /*#__PURE__*/ function() {
    var _ref = (0, $7k5I8._)(function(task2, cleanUp) {
        var value, error;
        return (0, $lFlDF.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.resolve()
                    ];
                case 1:
                    _state.sent();
                    return [
                        4,
                        task2()
                    ];
                case 2:
                    value = _state.sent();
                    return [
                        2,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error = _state.sent();
                    return [
                        2,
                        {
                            status: error instanceof $44e97ff44f917989$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function runTask(task2, cleanUp) {
        return _ref.apply(this, arguments);
    };
}();
var $44e97ff44f917989$var$createPause = function(signal) {
    return function(promise) {
        return $44e97ff44f917989$var$catchRejection($44e97ff44f917989$var$raceWithSignal(signal, promise).then(function(output) {
            $44e97ff44f917989$var$validateActive(signal);
            return output;
        }));
    };
};
var $44e97ff44f917989$var$createDelay = function(signal) {
    var pause = $44e97ff44f917989$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $44e97ff44f917989$var$assign = Object.assign;
var $44e97ff44f917989$var$INTERNAL_NIL_TOKEN = {};
var $44e97ff44f917989$var$alm = "listenerMiddleware";
var $44e97ff44f917989$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $44e97ff44f917989$var$addAbortSignalListener(parentAbortSignal, function() {
            return $44e97ff44f917989$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $44e97ff44f917989$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $44e97ff44f917989$var$runTask(/*#__PURE__*/ (0, $7k5I8._)(function() {
            var result2;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(parentAbortSignal);
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            4,
                            taskExecutor({
                                pause: $44e97ff44f917989$var$createPause(childAbortController.signal),
                                delay: $44e97ff44f917989$var$createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })
                        ];
                    case 1:
                        result2 = _state.sent();
                        $44e97ff44f917989$var$validateActive(childAbortController.signal);
                        return [
                            2,
                            result2
                        ];
                }
            });
        }), function() {
            return $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch($44e97ff44f917989$var$noop2));
        return {
            result: $44e97ff44f917989$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $44e97ff44f917989$var$abortControllerWithReason(childAbortController, $44e97ff44f917989$var$taskCancelled);
            }
        };
    };
};
var $44e97ff44f917989$var$createTakePattern = function(startListening, signal) {
    var take = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(predicate, timeout) {
            var unsubscribe, tuplePromise, promises, output;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        $44e97ff44f917989$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4,
                            $44e97ff44f917989$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _state.sent();
                        $44e97ff44f917989$var$validateActive(signal);
                        return [
                            2,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function take(predicate, timeout) {
            return _ref.apply(this, arguments);
        };
    }();
    return function(predicate, timeout) {
        return $44e97ff44f917989$var$catchRejection(take(predicate, timeout));
    };
};
var $44e97ff44f917989$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $44e97ff44f917989$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($44e97ff44f917989$export$378fa86b259c0280(21));
    $44e97ff44f917989$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $44e97ff44f917989$var$createListenerEntry = Object.assign(function(options) {
    var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, predicate = _getListenerEntryPropsFrom.predicate, effect = _getListenerEntryPropsFrom.effect;
    var id = $44e97ff44f917989$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: function() {
            throw new Error($44e97ff44f917989$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: function() {
        return $44e97ff44f917989$var$createListenerEntry;
    }
});
var $44e97ff44f917989$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
    });
};
var $44e97ff44f917989$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($44e97ff44f917989$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $44e97ff44f917989$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $44e97ff44f917989$export$f03a6b845d3fb58b = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/add")), {
    withTypes: function() {
        return $44e97ff44f917989$export$f03a6b845d3fb58b;
    }
});
var $44e97ff44f917989$export$b1b8022855fb2b71 = $44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/removeAll"));
var $44e97ff44f917989$export$b03e9483f936dccb = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("".concat($44e97ff44f917989$var$alm, "/remove")), {
    withTypes: function() {
        return $44e97ff44f917989$export$b03e9483f936dccb;
    }
});
var $44e97ff44f917989$var$defaultErrorHandler = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _console;
    (_console = console).error.apply(_console, [
        "".concat($44e97ff44f917989$var$alm, "/error")
    ].concat((0, $2Xzd1._)(args)));
};
var $44e97ff44f917989$export$1228acebbbcb485b = function() {
    var middlewareOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var listenerMap = /* @__PURE__ */ new Map();
    var extra = middlewareOptions.extra, _middlewareOptions_onError = middlewareOptions.onError, onError = _middlewareOptions_onError === void 0 ? $44e97ff44f917989$var$defaultErrorHandler : _middlewareOptions_onError;
    $44e97ff44f917989$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        };
    };
    var startListening = function(options) {
        var entry = $44e97ff44f917989$var$find(Array.from(listenerMap.values()), function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $44e97ff44f917989$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: function() {
            return startListening;
        }
    });
    var stopListening = function(options) {
        var _getListenerEntryPropsFrom = $44e97ff44f917989$var$getListenerEntryPropsFrom(options), type = _getListenerEntryPropsFrom.type, effect = _getListenerEntryPropsFrom.effect, predicate = _getListenerEntryPropsFrom.predicate;
        var entry = $44e97ff44f917989$var$find(Array.from(listenerMap.values()), function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $44e97ff44f917989$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: function() {
            return stopListening;
        }
    });
    var notifyListener = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(entry, action, api, getOriginalState) {
            var internalTaskController, take, autoJoinPromises, listenerError;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $44e97ff44f917989$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4,
                            Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
                            $44e97ff44f917989$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $44e97ff44f917989$var$createDelay(internalTaskController.signal),
                                pause: $44e97ff44f917989$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $44e97ff44f917989$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $44e97ff44f917989$var$abortControllerWithReason(controller, $44e97ff44f917989$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                },
                                cancel: function() {
                                    $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCancelled);
                                    entry.pending.delete(internalTaskController);
                                },
                                throwIfCancelled: function() {
                                    $44e97ff44f917989$var$validateActive(internalTaskController.signal);
                                }
                            })))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 3:
                        listenerError = _state.sent();
                        if (!(listenerError instanceof $44e97ff44f917989$export$cb1bdac908fed7f)) $44e97ff44f917989$var$safelyNotifyError(onError, listenerError, {
                            raisedBy: "effect"
                        });
                        return [
                            3,
                            6
                        ];
                    case 4:
                        return [
                            4,
                            Promise.all(autoJoinPromises)
                        ];
                    case 5:
                        _state.sent();
                        $44e97ff44f917989$var$abortControllerWithReason(internalTaskController, $44e97ff44f917989$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function notifyListener(entry, action, api, getOriginalState) {
            return _ref.apply(this, arguments);
        };
    }();
    var clearListenerMiddleware = $44e97ff44f917989$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!(0, $a039f9c7168ef4c9$export$b956e38827fca970)(action)) return next(action);
                if ($44e97ff44f917989$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($44e97ff44f917989$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($44e97ff44f917989$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $44e97ff44f917989$var$INTERNAL_NIL_TOKEN) throw new Error($44e97ff44f917989$export$378fa86b259c0280(23));
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = listenerEntries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var entry = _step.value;
                                var runListener = false;
                                try {
                                    runListener = entry.predicate(action, currentState, originalState);
                                } catch (predicateError) {
                                    runListener = false;
                                    $44e97ff44f917989$var$safelyNotifyError(onError, predicateError, {
                                        raisedBy: "predicate"
                                    });
                                }
                                if (!runListener) continue;
                                notifyListener(entry, action, api, getOriginalState);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } finally{
                    originalState = $44e97ff44f917989$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $44e97ff44f917989$var$createMiddlewareEntry = function(middleware) {
    return {
        id: $44e97ff44f917989$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    };
};
var $44e97ff44f917989$var$matchInstance = function(instanceId) {
    return function(action) {
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
};
var $44e97ff44f917989$export$4bb1606a79445586 = function() {
    var instanceId = $44e97ff44f917989$export$ac4959f4f1338dfc();
    var middlewareMap = /* @__PURE__ */ new Map();
    var withMiddleware = Object.assign($44e97ff44f917989$export$309c7a02b0b0bc62("dynamicMiddleware/add", function() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        return {
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        };
    }), {
        withTypes: function() {
            return withMiddleware;
        }
    });
    var addMiddleware = Object.assign(function addMiddleware2() {
        for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++){
            middlewares[_key] = arguments[_key];
        }
        middlewares.forEach(function(middleware2) {
            var entry = $44e97ff44f917989$var$find(Array.from(middlewareMap.values()), function(entry2) {
                return entry2.middleware === middleware2;
            });
            if (!entry) entry = $44e97ff44f917989$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: function() {
            return addMiddleware;
        }
    });
    var getFinalMiddleware = function(api) {
        var appliedMiddleware = Array.from(middlewareMap.values()).map(function(entry) {
            return $44e97ff44f917989$var$emplace(entry.applied, api, {
                insert: function() {
                    return entry.middleware(api);
                }
            });
        });
        return (0, $a039f9c7168ef4c9$export$f672e0b6f7222cd7).apply(void 0, (0, $2Xzd1._)(appliedMiddleware));
    };
    var isWithMiddleware = $44e97ff44f917989$export$9dd1fb32974da385(withMiddleware, $44e97ff44f917989$var$matchInstance(instanceId));
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (isWithMiddleware(action)) {
                    addMiddleware.apply(void 0, (0, $2Xzd1._)(action.payload));
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
        };
    };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $44e97ff44f917989$var$isSliceLike = function(maybeSliceLike) {
    return "reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
};
var $44e97ff44f917989$var$getReducers = function(slices) {
    return slices.flatMap(function(sliceOrMap) {
        return $44e97ff44f917989$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap);
    });
};
var $44e97ff44f917989$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $44e97ff44f917989$var$isStateProxy = function(value) {
    return !!value && !!value[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $44e97ff44f917989$var$createStateProxy = function(state, reducerMap) {
    return $44e97ff44f917989$var$emplace($44e97ff44f917989$var$stateProxyMap, state, {
        insert: function() {
            return new Proxy(state, {
                get: function(target, prop, receiver) {
                    if (prop === $44e97ff44f917989$var$ORIGINAL_STATE) return target;
                    var result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        var reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            var reducerResult = reducer(void 0, {
                                type: $44e97ff44f917989$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($44e97ff44f917989$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            });
        }
    });
};
var $44e97ff44f917989$var$original = function(state) {
    if (!$44e97ff44f917989$var$isStateProxy(state)) throw new Error($44e97ff44f917989$export$378fa86b259c0280(25));
    return state[$44e97ff44f917989$var$ORIGINAL_STATE];
};
var $44e97ff44f917989$var$noopReducer = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return state;
};
function $44e97ff44f917989$export$a3734c7614660b9() {
    for(var _len = arguments.length, slices = new Array(_len), _key = 0; _key < _len; _key++){
        slices[_key] = arguments[_key];
    }
    var reducerMap = Object.fromEntries($44e97ff44f917989$var$getReducers(slices));
    var getReducer = function() {
        return Object.keys(reducerMap).length ? (0, $a039f9c7168ef4c9$export$66e4520cdb265d18)(reducerMap) : $44e97ff44f917989$var$noopReducer;
    };
    var reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = function() {
        return combinedReducer;
    };
    var inject = function(slice) {
        var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var reducerPath = slice.reducerPath, reducerToInject = slice.reducer;
        var currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $ibRPI === "undefined" ? "undefined" : (0, $YtE9h._)($ibRPI);
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    var selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                args[_key - 1] = arguments[_key];
            }
            return selectorFn.apply(void 0, [
                $44e97ff44f917989$var$createStateProxy(selectState ? selectState.apply(void 0, [
                    state
                ].concat((0, $2Xzd1._)(args))) : state, reducerMap)
            ].concat((0, $2Xzd1._)(args)));
        };
    }, {
        original: $44e97ff44f917989$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $44e97ff44f917989$export$378fa86b259c0280(code) {
    return "Minified Redux Toolkit error #".concat(code, "; visit https://redux-toolkit.js.org/Errors?code=").concat(code, " for the full message or use the non-minified dev environment for full errors. ");
}



var $7k5I8 = parcelRequire("7k5I8");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $1dxAe = parcelRequire("1dxAe");

var $YtE9h = parcelRequire("YtE9h");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");
var $8e77098ba321d6df$exports = {};
'use strict';

$8e77098ba321d6df$exports = (parcelRequire("1wEEe"));



var $9F3H4 = parcelRequire("9F3H4");


var $9EFo8 = parcelRequire("9EFo8");
var $10c8f0562721b7f9$var$_process_env;

var $ibRPI = parcelRequire("ibRPI");
var $10c8f0562721b7f9$var$reactAct = typeof $fIwXP.act === 'function' ? $fIwXP.act : $8e77098ba321d6df$exports.act;
function $10c8f0562721b7f9$var$getGlobalThis() {
    /* istanbul ignore else */ if (typeof globalThis !== 'undefined') return globalThis;
    /* istanbul ignore next */ if (typeof self !== 'undefined') return self;
    /* istanbul ignore next */ if (typeof window !== 'undefined') return window;
    /* istanbul ignore next */ if (typeof $parcel$global !== 'undefined') return $parcel$global;
    /* istanbul ignore next */ throw new Error('unable to locate global object');
}
function $10c8f0562721b7f9$var$setIsReactActEnvironment(isReactActEnvironment) {
    $10c8f0562721b7f9$var$getGlobalThis().IS_REACT_ACT_ENVIRONMENT = isReactActEnvironment;
}
function $10c8f0562721b7f9$var$getIsReactActEnvironment() {
    return $10c8f0562721b7f9$var$getGlobalThis().IS_REACT_ACT_ENVIRONMENT;
}
function $10c8f0562721b7f9$var$withGlobalActEnvironment(actImplementation) {
    return function(callback) {
        var previousActEnvironment = $10c8f0562721b7f9$var$getIsReactActEnvironment();
        $10c8f0562721b7f9$var$setIsReactActEnvironment(true);
        try {
            // The return value of `act` is always a thenable.
            var callbackNeedsToBeAwaited = false;
            var actResult = actImplementation(function() {
                var result = callback();
                if (result !== null && (typeof result === "undefined" ? "undefined" : (0, $YtE9h._)(result)) === 'object' && typeof result.then === 'function') callbackNeedsToBeAwaited = true;
                return result;
            });
            if (callbackNeedsToBeAwaited) {
                var thenable = actResult;
                return {
                    then: function(resolve, reject) {
                        thenable.then(function(returnValue) {
                            $10c8f0562721b7f9$var$setIsReactActEnvironment(previousActEnvironment);
                            resolve(returnValue);
                        }, function(error) {
                            $10c8f0562721b7f9$var$setIsReactActEnvironment(previousActEnvironment);
                            reject(error);
                        });
                    }
                };
            } else {
                $10c8f0562721b7f9$var$setIsReactActEnvironment(previousActEnvironment);
                return actResult;
            }
        } catch (error) {
            // Can't be a `finally {}` block since we don't know if we have to immediately restore IS_REACT_ACT_ENVIRONMENT
            // or if we have to await the callback first.
            $10c8f0562721b7f9$var$setIsReactActEnvironment(previousActEnvironment);
            throw error;
        }
    };
}
var $10c8f0562721b7f9$export$3ba232387fd5d6dd = $10c8f0562721b7f9$var$withGlobalActEnvironment($10c8f0562721b7f9$var$reactAct);
/* eslint no-console:0 */ // react-testing-library's version of fireEvent will call
// dom-testing-library's version of fireEvent. The reason
// we make this distinction however is because we have
// a few extra events that work a bit differently
var $10c8f0562721b7f9$export$43835e9acf248a15 = function fireEvent() {
    return (0, $9EFo8.fireEvent).apply(void 0, arguments);
};
Object.keys((0, $9EFo8.fireEvent)).forEach(function(key) {
    $10c8f0562721b7f9$export$43835e9acf248a15[key] = function() {
        var _fireEvent$1;
        return (_fireEvent$1 = (0, $9EFo8.fireEvent))[key].apply(_fireEvent$1, arguments);
    };
});
// React event system tracks native mouseOver/mouseOut events for
// running onMouseEnter/onMouseLeave handlers
// @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/EnterLeaveEventPlugin.js#L24-L31
var $10c8f0562721b7f9$var$mouseEnter = $10c8f0562721b7f9$export$43835e9acf248a15.mouseEnter;
var $10c8f0562721b7f9$var$mouseLeave = $10c8f0562721b7f9$export$43835e9acf248a15.mouseLeave;
$10c8f0562721b7f9$export$43835e9acf248a15.mouseEnter = function() {
    var _fireEvent;
    $10c8f0562721b7f9$var$mouseEnter.apply(void 0, arguments);
    return (_fireEvent = $10c8f0562721b7f9$export$43835e9acf248a15).mouseOver.apply(_fireEvent, arguments);
};
$10c8f0562721b7f9$export$43835e9acf248a15.mouseLeave = function() {
    var _fireEvent;
    $10c8f0562721b7f9$var$mouseLeave.apply(void 0, arguments);
    return (_fireEvent = $10c8f0562721b7f9$export$43835e9acf248a15).mouseOut.apply(_fireEvent, arguments);
};
var $10c8f0562721b7f9$var$pointerEnter = $10c8f0562721b7f9$export$43835e9acf248a15.pointerEnter;
var $10c8f0562721b7f9$var$pointerLeave = $10c8f0562721b7f9$export$43835e9acf248a15.pointerLeave;
$10c8f0562721b7f9$export$43835e9acf248a15.pointerEnter = function() {
    var _fireEvent;
    $10c8f0562721b7f9$var$pointerEnter.apply(void 0, arguments);
    return (_fireEvent = $10c8f0562721b7f9$export$43835e9acf248a15).pointerOver.apply(_fireEvent, arguments);
};
$10c8f0562721b7f9$export$43835e9acf248a15.pointerLeave = function() {
    var _fireEvent;
    $10c8f0562721b7f9$var$pointerLeave.apply(void 0, arguments);
    return (_fireEvent = $10c8f0562721b7f9$export$43835e9acf248a15).pointerOut.apply(_fireEvent, arguments);
};
var $10c8f0562721b7f9$var$select = $10c8f0562721b7f9$export$43835e9acf248a15.select;
$10c8f0562721b7f9$export$43835e9acf248a15.select = function(node, init) {
    $10c8f0562721b7f9$var$select(node, init);
    // React tracks this event only on focused inputs
    node.focus();
    // React creates this event when one of the following native events happens
    // - contextMenu
    // - mouseUp
    // - dragEnd
    // - keyUp
    // - keyDown
    // so we can use any here
    // @link https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/events/SelectEventPlugin.js#L203-L224
    $10c8f0562721b7f9$export$43835e9acf248a15.keyUp(node, init);
};
// React event system tracks native focusout/focusin events for
// running blur/focus handlers
// @link https://github.com/facebook/react/pull/19186
var $10c8f0562721b7f9$var$blur = $10c8f0562721b7f9$export$43835e9acf248a15.blur;
var $10c8f0562721b7f9$var$focus = $10c8f0562721b7f9$export$43835e9acf248a15.focus;
$10c8f0562721b7f9$export$43835e9acf248a15.blur = function() {
    var _fireEvent;
    (_fireEvent = $10c8f0562721b7f9$export$43835e9acf248a15).focusOut.apply(_fireEvent, arguments);
    return $10c8f0562721b7f9$var$blur.apply(void 0, arguments);
};
$10c8f0562721b7f9$export$43835e9acf248a15.focus = function() {
    var _fireEvent;
    (_fireEvent = $10c8f0562721b7f9$export$43835e9acf248a15).focusIn.apply(_fireEvent, arguments);
    return $10c8f0562721b7f9$var$focus.apply(void 0, arguments);
};
var $10c8f0562721b7f9$var$configForRTL = {
    reactStrictMode: false
};
function $10c8f0562721b7f9$export$44487a86467333c3() {
    return (0, $eRslx._)({}, (0, $9EFo8.getConfig)(), $10c8f0562721b7f9$var$configForRTL);
}
function $10c8f0562721b7f9$export$8d21e34596265fa2(newConfig) {
    if (typeof newConfig === 'function') // Pass the existing config out to the provided function
    // and accept a delta in return
    newConfig = newConfig($10c8f0562721b7f9$export$44487a86467333c3());
    var reactStrictMode = newConfig.reactStrictMode, configForDTL = (0, $1dxAe._)(newConfig, [
        "reactStrictMode"
    ]);
    (0, $9EFo8.configure)(configForDTL);
    $10c8f0562721b7f9$var$configForRTL = (0, $kJeRc._)((0, $eRslx._)({}, $10c8f0562721b7f9$var$configForRTL), {
        reactStrictMode: reactStrictMode
    });
}
function $10c8f0562721b7f9$var$jestFakeTimersAreEnabled() {
    /* istanbul ignore else */ if (typeof jest !== 'undefined' && jest !== null) return(// legacy timers
    setTimeout._isMockFunction === true || // modern timers
    // eslint-disable-next-line prefer-object-has-own -- No Object.hasOwn in all target environments we support.
    Object.prototype.hasOwnProperty.call(setTimeout, 'clock'));
     // istanbul ignore next
    return false;
}
(0, $9EFo8.configure)({
    unstable_advanceTimersWrapper: function(cb) {
        return $10c8f0562721b7f9$export$3ba232387fd5d6dd(cb);
    },
    // We just want to run `waitFor` without IS_REACT_ACT_ENVIRONMENT
    // But that's not necessarily how `asyncWrapper` is used since it's a public method.
    // Let's just hope nobody else is using it.
    asyncWrapper: /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(cb) {
            var previousActEnvironment, result;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        previousActEnvironment = $10c8f0562721b7f9$var$getIsReactActEnvironment();
                        $10c8f0562721b7f9$var$setIsReactActEnvironment(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            ,
                            4,
                            5
                        ]);
                        return [
                            4,
                            cb()
                        ];
                    case 2:
                        result = _state.sent();
                        // Drain microtask queue.
                        // Otherwise we'll restore the previous act() environment, before we resolve the `waitFor` call.
                        // The caller would have no chance to wrap the in-flight Promises in `act()`
                        return [
                            4,
                            new Promise(function(resolve) {
                                setTimeout(function() {
                                    resolve();
                                }, 0);
                                if ($10c8f0562721b7f9$var$jestFakeTimersAreEnabled()) jest.advanceTimersByTime(0);
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 4:
                        $10c8f0562721b7f9$var$setIsReactActEnvironment(previousActEnvironment);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(cb) {
            return _ref.apply(this, arguments);
        };
    }(),
    eventWrapper: function(cb) {
        var result;
        $10c8f0562721b7f9$export$3ba232387fd5d6dd(function() {
            result = cb();
        });
        return result;
    }
});
// Ideally we'd just use a WeakMap where containers are keys and roots are values.
// We use two variables so that we can bail out in constant time when we render with a new container (most common use case)
/**
 * @type {Set<import('react-dom').Container>}
 */ var $10c8f0562721b7f9$var$mountedContainers = new Set();
/**
 * @type Array<{container: import('react-dom').Container, root: ReturnType<typeof createConcurrentRoot>}>
 */ var $10c8f0562721b7f9$var$mountedRootEntries = [];
function $10c8f0562721b7f9$var$strictModeIfNeeded(innerElement) {
    return $10c8f0562721b7f9$export$44487a86467333c3().reactStrictMode ? /*#__PURE__*/ $fIwXP.createElement($fIwXP.StrictMode, null, innerElement) : innerElement;
}
function $10c8f0562721b7f9$var$wrapUiIfNeeded(innerElement, wrapperComponent) {
    return wrapperComponent ? /*#__PURE__*/ $fIwXP.createElement(wrapperComponent, null, innerElement) : innerElement;
}
function $10c8f0562721b7f9$var$createConcurrentRoot(container, _ref) {
    var hydrate = _ref.hydrate, ui = _ref.ui, WrapperComponent = _ref.wrapper;
    var root;
    if (hydrate) $10c8f0562721b7f9$export$3ba232387fd5d6dd(function() {
        root = $fb34d4b6d3b01836$export$757ceba2d55c277e(container, $10c8f0562721b7f9$var$strictModeIfNeeded($10c8f0562721b7f9$var$wrapUiIfNeeded(ui, WrapperComponent)));
    });
    else root = $fb34d4b6d3b01836$export$882461b6382ed46c(container);
    return {
        hydrate: function() {
            /* istanbul ignore if */ if (!hydrate) throw new Error('Attempted to hydrate a non-hydrateable root. This is a bug in `@testing-library/react`.');
        // Nothing to do since hydration happens when creating the root object.
        },
        render: function(element) {
            root.render(element);
        },
        unmount: function() {
            root.unmount();
        }
    };
}
function $10c8f0562721b7f9$var$createLegacyRoot(container) {
    return {
        hydrate: function(element) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9F3H4))).hydrate(element, container);
        },
        render: function(element) {
            (0, (/*@__PURE__*/$parcel$interopDefault($9F3H4))).render(element, container);
        },
        unmount: function() {
            (0, (/*@__PURE__*/$parcel$interopDefault($9F3H4))).unmountComponentAtNode(container);
        }
    };
}
function $10c8f0562721b7f9$var$renderRoot(ui, _ref2) {
    var baseElement = _ref2.baseElement, container = _ref2.container, hydrate = _ref2.hydrate, queries = _ref2.queries, root = _ref2.root, WrapperComponent = _ref2.wrapper;
    $10c8f0562721b7f9$export$3ba232387fd5d6dd(function() {
        if (hydrate) root.hydrate($10c8f0562721b7f9$var$strictModeIfNeeded($10c8f0562721b7f9$var$wrapUiIfNeeded(ui, WrapperComponent)), container);
        else root.render($10c8f0562721b7f9$var$strictModeIfNeeded($10c8f0562721b7f9$var$wrapUiIfNeeded(ui, WrapperComponent)), container);
    });
    return (0, $eRslx._)({
        container: container,
        baseElement: baseElement,
        debug: function debug(el, maxLength, options) {
            if (el === void 0) el = baseElement;
            return Array.isArray(el) ? // eslint-disable-next-line no-console
            el.forEach(function(e) {
                return console.log((0, $9EFo8.prettyDOM)(e, maxLength, options));
            }) : // eslint-disable-next-line no-console,
            console.log((0, $9EFo8.prettyDOM)(el, maxLength, options));
        },
        unmount: function() {
            $10c8f0562721b7f9$export$3ba232387fd5d6dd(function() {
                root.unmount();
            });
        },
        rerender: function(rerenderUi) {
            $10c8f0562721b7f9$var$renderRoot(rerenderUi, {
                container: container,
                baseElement: baseElement,
                root: root,
                wrapper: WrapperComponent
            });
        // Intentionally do not return anything to avoid unnecessarily complicating the API.
        // folks can use all the same utilities we return in the first place that are bound to the container
        },
        asFragment: function() {
            /* istanbul ignore else (old jsdom limitation) */ if (typeof document.createRange === 'function') return document.createRange().createContextualFragment(container.innerHTML);
            else {
                var template = document.createElement('template');
                template.innerHTML = container.innerHTML;
                return template.content;
            }
        }
    }, (0, $9EFo8.getQueriesForElement)(baseElement, queries));
}
function $10c8f0562721b7f9$export$b3890eb0ae9dca99(ui, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, container = _ref.container, _ref_baseElement = _ref.baseElement, baseElement = _ref_baseElement === void 0 ? container : _ref_baseElement, _ref_legacyRoot = _ref.legacyRoot, legacyRoot = _ref_legacyRoot === void 0 ? false : _ref_legacyRoot, queries = _ref.queries, _ref_hydrate = _ref.hydrate, hydrate = _ref_hydrate === void 0 ? false : _ref_hydrate, wrapper = _ref.wrapper;
    if (legacyRoot && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9F3H4))).render !== 'function') {
        var error = new Error("`legacyRoot: true` is not supported in this version of React. If your app runs React 19 or later, you should remove this flag. If your app runs React 18 or earlier, visit https://react.dev/blog/2022/03/08/react-18-upgrade-guide for upgrade instructions.");
        Error.captureStackTrace(error, $10c8f0562721b7f9$export$b3890eb0ae9dca99);
        throw error;
    }
    if (!baseElement) // default to document.body instead of documentElement to avoid output of potentially-large
    // head elements (such as JSS style blocks) in debug output
    baseElement = document.body;
    if (!container) container = baseElement.appendChild(document.createElement('div'));
    var root;
    // eslint-disable-next-line no-negated-condition -- we want to map the evolution of this over time. The root is created first. Only later is it re-used so we don't want to read the case that happens later first.
    if (!$10c8f0562721b7f9$var$mountedContainers.has(container)) {
        var createRootImpl = legacyRoot ? $10c8f0562721b7f9$var$createLegacyRoot : $10c8f0562721b7f9$var$createConcurrentRoot;
        root = createRootImpl(container, {
            hydrate: hydrate,
            ui: ui,
            wrapper: wrapper
        });
        $10c8f0562721b7f9$var$mountedRootEntries.push({
            container: container,
            root: root
        });
        // we'll add it to the mounted containers regardless of whether it's actually
        // added to document.body so the cleanup method works regardless of whether
        // they're passing us a custom container or not.
        $10c8f0562721b7f9$var$mountedContainers.add(container);
    } else $10c8f0562721b7f9$var$mountedRootEntries.forEach(function(rootEntry) {
        // Else is unreachable since `mountedContainers` has the `container`.
        // Only reachable if one would accidentally add the container to `mountedContainers` but not the root to `mountedRootEntries`
        /* istanbul ignore else */ if (rootEntry.container === container) root = rootEntry.root;
    });
    return $10c8f0562721b7f9$var$renderRoot(ui, {
        container: container,
        baseElement: baseElement,
        queries: queries,
        hydrate: hydrate,
        wrapper: wrapper,
        root: root
    });
}
function $10c8f0562721b7f9$export$de863c629cb9919d() {
    $10c8f0562721b7f9$var$mountedRootEntries.forEach(function(_ref3) {
        var root = _ref3.root, container = _ref3.container;
        $10c8f0562721b7f9$export$3ba232387fd5d6dd(function() {
            root.unmount();
        });
        if (container.parentNode === document.body) document.body.removeChild(container);
    });
    $10c8f0562721b7f9$var$mountedRootEntries.length = 0;
    $10c8f0562721b7f9$var$mountedContainers.clear();
}
function $10c8f0562721b7f9$export$420b65f5de102ae0(renderCallback, options) {
    if (options === void 0) options = {};
    var initialProps = options.initialProps, renderOptions = (0, $1dxAe._)(options, [
        "initialProps"
    ]);
    if (renderOptions.legacyRoot && typeof (0, (/*@__PURE__*/$parcel$interopDefault($9F3H4))).render !== 'function') {
        var error = new Error("`legacyRoot: true` is not supported in this version of React. If your app runs React 19 or later, you should remove this flag. If your app runs React 18 or earlier, visit https://react.dev/blog/2022/03/08/react-18-upgrade-guide for upgrade instructions.");
        Error.captureStackTrace(error, $10c8f0562721b7f9$export$420b65f5de102ae0);
        throw error;
    }
    var result = /*#__PURE__*/ $fIwXP.createRef();
    function TestComponent(_ref4) {
        var renderCallbackProps = _ref4.renderCallbackProps;
        var pendingResult = renderCallback(renderCallbackProps);
        $fIwXP.useEffect(function() {
            result.current = pendingResult;
        });
        return null;
    }
    var _render = $10c8f0562721b7f9$export$b3890eb0ae9dca99(/*#__PURE__*/ $fIwXP.createElement(TestComponent, {
        renderCallbackProps: initialProps
    }), renderOptions), baseRerender = _render.rerender, unmount = _render.unmount;
    function rerender(rerenderCallbackProps) {
        return baseRerender(/*#__PURE__*/ $fIwXP.createElement(TestComponent, {
            renderCallbackProps: rerenderCallbackProps
        }));
    }
    return {
        result: result,
        rerender: rerender,
        unmount: unmount
    };
}
/* eslint func-name-matching:0 */ // if we're running in a test runner that supports afterEach
// or teardown then we'll automatically run cleanup afterEach test
// this ensures that tests run in isolation from each other
// if you don't like this then either import the `pure` module
// or set the RTL_SKIP_AUTO_CLEANUP env variable to 'true'.
if (typeof $ibRPI === 'undefined' || !(($10c8f0562721b7f9$var$_process_env = $ibRPI.env) === null || $10c8f0562721b7f9$var$_process_env === void 0 ? void 0 : $10c8f0562721b7f9$var$_process_env.RTL_SKIP_AUTO_CLEANUP)) {
    // ignore teardown() in code coverage because Jest does not support it
    /* istanbul ignore else */ if (typeof afterEach === 'function') afterEach(function() {
        $10c8f0562721b7f9$export$de863c629cb9919d();
    });
    else if (typeof teardown === 'function') // Block is guarded by `typeof` check.
    // eslint does not support `typeof` guards.
    // eslint-disable-next-line no-undef
    teardown(function() {
        $10c8f0562721b7f9$export$de863c629cb9919d();
    });
    // No test setup with other test runners available
    /* istanbul ignore else */ if (typeof beforeAll === 'function' && typeof afterAll === 'function') {
        // This matches the behavior of React < 18.
        var $10c8f0562721b7f9$var$previousIsReactActEnvironment = $10c8f0562721b7f9$var$getIsReactActEnvironment();
        beforeAll(function() {
            $10c8f0562721b7f9$var$previousIsReactActEnvironment = $10c8f0562721b7f9$var$getIsReactActEnvironment();
            $10c8f0562721b7f9$var$setIsReactActEnvironment(true);
        });
        afterAll(function() {
            $10c8f0562721b7f9$var$setIsReactActEnvironment($10c8f0562721b7f9$var$previousIsReactActEnvironment);
        });
    }
}


var $2767c9397776ff73$var$cartSlice = (0, $44e97ff44f917989$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: [],
        quantity: {}
    },
    reducers: {
        addItem: function(state, action) {
            var _state_items;
            // state.items.push(action.payload.items);
            var index = (_state_items = state.items) === null || _state_items === void 0 ? void 0 : _state_items.findIndex(function(item) {
                return item.id === action.payload.items.id;
            });
            console.log(index);
            if (index === -1) {
                console.log(action.payload.items);
                state.items.push(action.payload.items);
            } else console.log("Object already exists");
        },
        updateQuantity: function(state, action) {
            state.quantity = action.payload.quantity;
        },
        removeItem: function(state) {
            state.items.pop();
        },
        clearCart: function(state) {
            state.items.length = 0;
        }
    }
});
var $2767c9397776ff73$var$_cartSlice_actions = $2767c9397776ff73$var$cartSlice.actions;
var $2767c9397776ff73$export$fb9705de59d96855 = $2767c9397776ff73$var$_cartSlice_actions.addItem, $2767c9397776ff73$export$aab4304d9ee3f4c7 = $2767c9397776ff73$var$_cartSlice_actions.updateQuantity, $2767c9397776ff73$export$fe2d9b4e03920b4c = $2767c9397776ff73$var$_cartSlice_actions.removeItem, $2767c9397776ff73$export$810121176e3e3671 = $2767c9397776ff73$var$_cartSlice_actions.clearCart;
var $2767c9397776ff73$export$2e2bcd8739ae039 = $2767c9397776ff73$var$cartSlice.reducer;




var $fIwXP = parcelRequire("fIwXP");
var $3a63efcc8c0a1cc1$var$ItemList = function(param) {
    var items = param.items;
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), selectedItems = _useState[0], setSelectedItems = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)(1), 2), itemNumber = _useState1[0], setItemNumber = _useState1[1];
    var _useState2 = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), showInc = _useState2[0], setShowInc = _useState2[1];
    var handleAddItem = function(item) {
        var _item_card;
        var ids = item.card.info.id;
        setSelectedItems(function(prevState) {
            return (0, $kJeRc._)((0, $eRslx._)({}, prevState), (0, $hD5pT._)({}, ids, 1));
        });
        setShowInc(function(prevState) {
            return (0, $kJeRc._)((0, $eRslx._)({}, prevState), (0, $hD5pT._)({}, ids, true));
        });
        dispatch((0, $2767c9397776ff73$export$fb9705de59d96855)({
            items: item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : _item_card.info
        }));
    };
    (0, $fIwXP.useEffect)(function() {
        dispatch((0, $2767c9397776ff73$export$aab4304d9ee3f4c7)({
            quantity: selectedItems
        }));
    }, [
        selectedItems
    ]);
    var incrementItem = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(item) {
            var ids;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // setItemNumber(itemNumber + 1);
                        ids = item.card.info.id;
                        return [
                            4,
                            setSelectedItems(function(prevState) {
                                return (0, $kJeRc._)((0, $eRslx._)({}, prevState), (0, $hD5pT._)({}, ids, selectedItems[ids] + 1));
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function incrementItem(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var decrementItem = function(item) {
        var _item_card;
        // setItemNumber(itemNumber - 1);
        var ids = item.card.info.id;
        setSelectedItems(function(prevState) {
            return (0, $kJeRc._)((0, $eRslx._)({}, prevState), (0, $hD5pT._)({}, ids, selectedItems[ids] - 1 > 0 ? selectedItems[ids] - 1 : 0));
        });
        setShowInc(function(prevState) {
            return (0, $kJeRc._)((0, $eRslx._)({}, prevState), (0, $hD5pT._)({}, ids, selectedItems[ids] > 1 ? true : false));
        });
        dispatch((0, $2767c9397776ff73$export$fb9705de59d96855)({
            items: item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : _item_card.info
        }));
    };
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        children: items.map(function(item) {
            var _item_card_info, _item_card_info_offerTags_, _item_card_info1, _item_card_info_offerTags_1, _item_card_info2, _item_card_info_ratings_aggregatedRating, _item_card_info_ratings, _item_card_info3, _item_card, _item_card_info_ratings_aggregatedRating1, _item_card_info_ratings1, _item_card_info4, _item_card1, _item_card_info_ratings_aggregatedRating2, _item_card_info_ratings2, _item_card_info5, _item_card2;
            return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                "data-testid": "foodItems",
                className: "item-info py-7 m-2 pb-10 border-gray-200 border-b-2 text-left flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "w-9/12",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                className: "font-bold text-[#02060cbf]",
                                children: item.card.info.name
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                        className: "mr-2",
                                        children: [
                                            "Rs",
                                            " ",
                                            item.card.info.price ? item.card.info.price / 100 : item.card.info.defaultPrice / 100
                                        ]
                                    }),
                                    ((_item_card_info = item.card.info) === null || _item_card_info === void 0 ? void 0 : _item_card_info.offerTags) && /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 16 16",
                                                fill: "none",
                                                xmlns: "http://www.w3.org/2000/svg",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                    "fill-rule": "evenodd",
                                                    "clip-rule": "evenodd",
                                                    d: "M1.63362 8.39604C1.28368 8.7446 1.28368 9.30972 1.63362 9.65828L6.1293 14.1362C6.47924 14.4848 7.0466 14.4848 7.39654 14.1362L12.9543 8.60038C13.1228 8.43251 13.2173 8.20468 13.2168 7.96728L13.2069 3.49924C13.2058 3.00785 12.8061 2.60977 12.3128 2.60868L7.827 2.5988C7.58866 2.59828 7.35993 2.69235 7.1914 2.86022L1.63362 8.39604ZM10.8177 6.90055C11.3458 6.37452 11.3439 5.51976 10.8134 4.99139C10.283 4.46302 9.4248 4.46113 8.89668 4.98717C8.36856 5.5132 8.37045 6.36796 8.90092 6.89633C9.43138 7.4247 10.2895 7.42659 10.8177 6.90055Z",
                                                    fill: "#1BA672"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                                className: "font-bold text-xs text-[#02060c99]",
                                                children: [
                                                    (_item_card_info1 = item.card.info) === null || _item_card_info1 === void 0 ? void 0 : (_item_card_info_offerTags_ = _item_card_info1.offerTags[0]) === null || _item_card_info_offerTags_ === void 0 ? void 0 : _item_card_info_offerTags_.title,
                                                    " ",
                                                    (_item_card_info2 = item.card.info) === null || _item_card_info2 === void 0 ? void 0 : (_item_card_info_offerTags_1 = _item_card_info2.offerTags[0]) === null || _item_card_info_offerTags_1 === void 0 ? void 0 : _item_card_info_offerTags_1.subTitle
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : (_item_card_info3 = _item_card.info) === null || _item_card_info3 === void 0 ? void 0 : (_item_card_info_ratings = _item_card_info3.ratings) === null || _item_card_info_ratings === void 0 ? void 0 : (_item_card_info_ratings_aggregatedRating = _item_card_info_ratings.aggregatedRating) === null || _item_card_info_ratings_aggregatedRating === void 0 ? void 0 : _item_card_info_ratings_aggregatedRating.rating) && /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex items-center mb-2",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 14 14",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        role: "img",
                                        fillColor: "#1BA672",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("rect", {
                                                width: "14",
                                                height: "14",
                                                fill: "white"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                d: "M5.67163 3.99166C6.22068 2.34179 6.49521 1.51686 7 1.51686C7.50479 1.51686 7.77932 2.34179 8.32837 3.99166L8.65248 4.96556H9.60668C11.4122 4.96556 12.315 4.96556 12.4703 5.45302C12.6256 5.94049 11.8893 6.4628 10.4167 7.50744L9.67376 8.03444L9.97544 8.94095C10.5325 10.615 10.8111 11.452 10.4033 11.754C9.99553 12.056 9.27604 11.5457 7.83705 10.5249L7 9.93112L6.16295 10.5249C4.72396 11.5457 4.00447 12.056 3.5967 11.754C3.18893 11.452 3.46747 10.615 4.02456 8.94095L4.04557 8.87783C4.18081 8.47145 4.24843 8.26825 4.18684 8.08006C4.12525 7.89187 3.94958 7.76725 3.59824 7.51802C2.11566 6.46633 1.37437 5.94049 1.52971 5.45302C1.68504 4.96556 2.5878 4.96556 4.39332 4.96556H5.34752L5.67163 3.99166Z",
                                                fill: "#1BA672"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: " text-[13px] font-bold text-green-600 mx-1",
                                        children: item === null || item === void 0 ? void 0 : (_item_card1 = item.card) === null || _item_card1 === void 0 ? void 0 : (_item_card_info4 = _item_card1.info) === null || _item_card_info4 === void 0 ? void 0 : (_item_card_info_ratings1 = _item_card_info4.ratings) === null || _item_card_info_ratings1 === void 0 ? void 0 : (_item_card_info_ratings_aggregatedRating1 = _item_card_info_ratings1.aggregatedRating) === null || _item_card_info_ratings_aggregatedRating1 === void 0 ? void 0 : _item_card_info_ratings_aggregatedRating1.rating
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                        className: "text-[13px] text-[#02060c99]",
                                        children: [
                                            "(",
                                            item === null || item === void 0 ? void 0 : (_item_card2 = item.card) === null || _item_card2 === void 0 ? void 0 : (_item_card_info5 = _item_card2.info) === null || _item_card_info5 === void 0 ? void 0 : (_item_card_info_ratings2 = _item_card_info5.ratings) === null || _item_card_info_ratings2 === void 0 ? void 0 : (_item_card_info_ratings_aggregatedRating2 = _item_card_info_ratings2.aggregatedRating) === null || _item_card_info_ratings_aggregatedRating2 === void 0 ? void 0 : _item_card_info_ratings_aggregatedRating2.ratingCountV2,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                children: item.card.info.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "w-[156px] relative",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                src: (0, $cc25cc9a913d8a70$export$31adfacaf07ffe63) + item.card.info.imageId,
                                className: "w-full h-[144px] object-cover rounded-xl",
                                alt: ""
                            }),
                            showInc ? !showInc.hasOwnProperty(item.card.info.id) || !showInc[item.card.info.id] ? /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "text-lg px-6 py-1 text-green-600 font-bold rounded-md bg-white shadow-md absolute -bottom-4 left-[23%] border",
                                onClick: function() {
                                    return handleAddItem(item);
                                },
                                children: "ADD"
                            }) : null : /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "text-lg px-6 py-1 text-green-600 font-bold rounded-md bg-white shadow-md absolute -bottom-4 left-[23%] border",
                                onClick: function() {
                                    return handleAddItem(item);
                                },
                                children: "ADD"
                            }),
                            showInc && showInc[item.card.info.id] ? /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "text-lg px-4 py-1 text-green-600 font-bold rounded-md bg-white shadow-md absolute -bottom-4 left-[21%] border",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        onClick: function() {
                                            return decrementItem(item);
                                        },
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "px-4",
                                        children: selectedItems && selectedItems[item.card.info.id] ? selectedItems[item.card.info.id] : 0
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        onClick: function() {
                                            return incrementItem(item);
                                        },
                                        children: "+"
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }, item.card.info.id);
        })
    });
};
var $3a63efcc8c0a1cc1$export$2e2bcd8739ae039 = $3a63efcc8c0a1cc1$var$ItemList;


var $d61e5d477b89ad78$var$RestaurantCategory = function(param) {
    var data = param.data, showItems = param.showItems, setShowIndex = param.setShowIndex;
    var handleClick = function() {
        setShowIndex();
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "w-full my-5  mx-auto  ",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "h-4 bg-gray-100"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex justify-between items-center mx-4 my-5 cursor-pointer",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                        className: "font-bold text-lg",
                        children: [
                            data.title,
                            " (",
                            data.itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                        className: "h-6",
                        src: "https://static.thenounproject.com/png/1123247-200.png",
                        alt: ""
                    })
                ]
            }),
            showItems && /*#__PURE__*/ (0, $cc6u1.jsx)((0, $3a63efcc8c0a1cc1$export$2e2bcd8739ae039), {
                items: data.itemCards
            })
        ]
    });
};
var $d61e5d477b89ad78$export$2e2bcd8739ae039 = $d61e5d477b89ad78$var$RestaurantCategory;



var $fIwXP = parcelRequire("fIwXP");

var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");
var $0f5b39c193ecb6e2$var$HalfOfferCard = function(param) {
    var data = param.data;
    var _data_info, _data_info1;
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "border rounded-2xl p-3 mr-4 my-4 flex items-center",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                className: "w-12 mx-2",
                src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_96,h_96/offers/generic",
                alt: ""
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "ml-1",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
                        className: "font-extrabold",
                        children: data === null || data === void 0 ? void 0 : (_data_info = data.info) === null || _data_info === void 0 ? void 0 : _data_info.header
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                        className: "text-sm font-bold text-[#02060c72]",
                        children: data === null || data === void 0 ? void 0 : (_data_info1 = data.info) === null || _data_info1 === void 0 ? void 0 : _data_info1.couponCode
                    })
                ]
            })
        ]
    });
};
var $0f5b39c193ecb6e2$export$2e2bcd8739ae039 = $0f5b39c193ecb6e2$var$HalfOfferCard;


var $10d98c88068a73ec$exports = {};

$10d98c88068a73ec$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "menu-left.8e47e19e.png";


var $217d869197afbef5$exports = {};

$217d869197afbef5$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "menu-right.d7c89653.png";


var $b60bb9b93294f68b$exports = {};

$b60bb9b93294f68b$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "veg.3f118b6b.png";


var $d2e79c530f272c92$exports = {};

$d2e79c530f272c92$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "non-veg.655db56f.png";






var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");



var $6a79e65d36b5f45b$var$TopPicks = function(param) {
    var topCard = param.topCard;
    var _topCard_dish_info, _topCard_dish, _topCard_dish_info1, _topCard_dish1;
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    console.log(topCard);
    var handleAddItem = function(item) {
        var _item_dish;
        dispatch((0, $2767c9397776ff73$export$fb9705de59d96855)(item === null || item === void 0 ? void 0 : (_item_dish = item.dish) === null || _item_dish === void 0 ? void 0 : _item_dish.info));
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "relative my-4",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                src: (0, $cc25cc9a913d8a70$export$b058da059f56be67) + (topCard === null || topCard === void 0 ? void 0 : topCard.creativeId),
                alt: ""
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                className: "absolute bottom-4 left-4 font-semibold text-white",
                children: [
                    "\u20B9",
                    (topCard === null || topCard === void 0 ? void 0 : (_topCard_dish = topCard.dish) === null || _topCard_dish === void 0 ? void 0 : (_topCard_dish_info = _topCard_dish.info) === null || _topCard_dish_info === void 0 ? void 0 : _topCard_dish_info.price) / 100 || (topCard === null || topCard === void 0 ? void 0 : (_topCard_dish1 = topCard.dish) === null || _topCard_dish1 === void 0 ? void 0 : (_topCard_dish_info1 = _topCard_dish1.info) === null || _topCard_dish_info1 === void 0 ? void 0 : _topCard_dish_info1.defaultPrice) / 100
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                onClick: function() {
                    return handleAddItem(topCard);
                },
                className: "absolute bottom-4 right-10 py-1.5 px-6 rounded-md bg-white text-green-600 font-bold",
                children: "ADD"
            })
        ]
    });
};
var $6a79e65d36b5f45b$export$2e2bcd8739ae039 = $6a79e65d36b5f45b$var$TopPicks;



var $kB67t = parcelRequire("kB67t");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");

var $34292d13f7004ea4$var$RestaurantSubCategory = function(param) {
    var nestedItem = param.nestedItem, showItems = param.showItems, setShowIndex = param.setShowIndex;
    var _nestedItem_itemCards;
    var handleClick = function() {
        setShowIndex();
    };
    console.log(nestedItem);
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "sub-item-info mx-4 cursor-pointer  border-b-2",
        onClick: handleClick,
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex justify-between items-center my-4",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                        className: "font-bold text-base",
                        children: [
                            nestedItem === null || nestedItem === void 0 ? void 0 : nestedItem.title,
                            " (",
                            nestedItem === null || nestedItem === void 0 ? void 0 : (_nestedItem_itemCards = nestedItem.itemCards) === null || _nestedItem_itemCards === void 0 ? void 0 : _nestedItem_itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                        className: "h-6",
                        src: "https://static.thenounproject.com/png/1123247-200.png",
                        alt: ""
                    })
                ]
            }),
            showItems && /*#__PURE__*/ (0, $cc6u1.jsx)((0, $3a63efcc8c0a1cc1$export$2e2bcd8739ae039), {
                items: nestedItem.itemCards
            })
        ]
    });
};
var $34292d13f7004ea4$export$2e2bcd8739ae039 = $34292d13f7004ea4$var$RestaurantSubCategory;


var $944be4cb434817da$var$RestaurantNestedCategory = function(param) {
    var data = param.data;
    console.log(data);
    var nestedCategories = data === null || data === void 0 ? void 0 : data.categories;
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), showIndex = _useState[0], setShowIndex = _useState[1];
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "w-full my-5  mx-auto  ",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "h-4 bg-gray-100"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "font-bold text-lg mx-4 my-5",
                children: [
                    data.title,
                    " (",
                    data.categories.length,
                    ")"
                ]
            }),
            nestedCategories && nestedCategories.map(function(nestedCategory, index) {
                return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $34292d13f7004ea4$export$2e2bcd8739ae039), {
                    nestedItem: nestedCategory,
                    showItems: index === showIndex ? true : false,
                    setShowIndex: function() {
                        return setShowIndex(index);
                    }
                });
            })
        ]
    });
};
var $944be4cb434817da$export$2e2bcd8739ae039 = $944be4cb434817da$var$RestaurantNestedCategory;


var $d1dc02be9882a390$var$RestaurantMenu = function() {
    var _resInfo_cards__card_card, _resInfo_cards__card, _resInfo_cards_, _resInfo_cards__card_card1, _resInfo_cards__card1, _resInfo_cards_1, _resInfo_cards__card_card_gridElements, _resInfo_cards__card_card2, _resInfo_cards__card2, _resInfo_cards_2, _resInfo_cards__groupedCard_cardGroupMap_REGULAR, _resInfo_cards__groupedCard_cardGroupMap, _resInfo_cards__groupedCard, _resInfo_cards_3, _resInfo_cards__groupedCard_cardGroupMap_REGULAR1, _resInfo_cards__groupedCard_cardGroupMap1, _resInfo_cards__groupedCard1, _resInfo_cards_4, _resInfo_cards__groupedCard_cardGroupMap_REGULAR2, _resInfo_cards__groupedCard_cardGroupMap2, _resInfo_cards__groupedCard2, _resInfo_cards_5, _topPicks__card_card, _topPicks__card, _topPicks_, _sla_slaString;
    var resId = (0, $9e36fd5982483bee$export$99eaa27ddbbb95ef)().resId;
    var resInfo = (0, $6d359334c042511a$export$2e2bcd8739ae039)(resId);
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), showIndex = _useState[0], setShowIndex = _useState[1];
    // console.log(resInfo);
    // if (resInfo === null) return <Shimmer />;
    var _ref = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_ = resInfo.cards[2]) === null || _resInfo_cards_ === void 0 ? void 0 : (_resInfo_cards__card = _resInfo_cards_.card) === null || _resInfo_cards__card === void 0 ? void 0 : (_resInfo_cards__card_card = _resInfo_cards__card.card) === null || _resInfo_cards__card_card === void 0 ? void 0 : _resInfo_cards__card_card.info) || {}, areaName = _ref.areaName, avgRating = _ref.avgRating, city = _ref.city, locality = _ref.locality, sla = _ref.sla, totalRatingsString = _ref.totalRatingsString, veg = _ref.veg, name = _ref.name, cuisines = _ref.cuisines, costForTwoMessage = _ref.costForTwoMessage, feeDetails = _ref.feeDetails;
    console.log("RESTAURANT INFO", resInfo);
    console.log(resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_1 = resInfo.cards[2]) === null || _resInfo_cards_1 === void 0 ? void 0 : (_resInfo_cards__card1 = _resInfo_cards_1.card) === null || _resInfo_cards__card1 === void 0 ? void 0 : (_resInfo_cards__card_card1 = _resInfo_cards__card1.card) === null || _resInfo_cards__card_card1 === void 0 ? void 0 : _resInfo_cards__card_card1.info.feeDetails);
    var offers = ((resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_2 = resInfo.cards[3]) === null || _resInfo_cards_2 === void 0 ? void 0 : (_resInfo_cards__card2 = _resInfo_cards_2.card) === null || _resInfo_cards__card2 === void 0 ? void 0 : (_resInfo_cards__card_card2 = _resInfo_cards__card2.card) === null || _resInfo_cards__card_card2 === void 0 ? void 0 : (_resInfo_cards__card_card_gridElements = _resInfo_cards__card_card2.gridElements) === null || _resInfo_cards__card_card_gridElements === void 0 ? void 0 : _resInfo_cards__card_card_gridElements.infoWithStyle) || {}).offers;
    var categories = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_3 = resInfo.cards[4]) === null || _resInfo_cards_3 === void 0 ? void 0 : (_resInfo_cards__groupedCard = _resInfo_cards_3.groupedCard) === null || _resInfo_cards__groupedCard === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap = _resInfo_cards__groupedCard.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR = _resInfo_cards__groupedCard_cardGroupMap.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return ((_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory";
    });
    var nestedCategories = resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_4 = resInfo.cards[4]) === null || _resInfo_cards_4 === void 0 ? void 0 : (_resInfo_cards__groupedCard1 = _resInfo_cards_4.groupedCard) === null || _resInfo_cards__groupedCard1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap1 = _resInfo_cards__groupedCard1.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap1 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR1 = _resInfo_cards__groupedCard_cardGroupMap1.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR1 === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR1.cards.filter(function(nc) {
        var _nc_card_card, _nc_card;
        return ((_nc_card = nc.card) === null || _nc_card === void 0 ? void 0 : (_nc_card_card = _nc_card.card) === null || _nc_card_card === void 0 ? void 0 : _nc_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.NestedItemCategory";
    });
    var topPicks = (resInfo === null || resInfo === void 0 ? void 0 : (_resInfo_cards_5 = resInfo.cards[4]) === null || _resInfo_cards_5 === void 0 ? void 0 : (_resInfo_cards__groupedCard2 = _resInfo_cards_5.groupedCard) === null || _resInfo_cards__groupedCard2 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap2 = _resInfo_cards__groupedCard2.cardGroupMap) === null || _resInfo_cards__groupedCard_cardGroupMap2 === void 0 ? void 0 : (_resInfo_cards__groupedCard_cardGroupMap_REGULAR2 = _resInfo_cards__groupedCard_cardGroupMap2.REGULAR) === null || _resInfo_cards__groupedCard_cardGroupMap_REGULAR2 === void 0 ? void 0 : _resInfo_cards__groupedCard_cardGroupMap_REGULAR2.cards.filter(function(c) {
        var _c_card_card, _c_card;
        return (c === null || c === void 0 ? void 0 : (_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.MenuCarousel";
    })) || [];
    var topBanners = (_topPicks_ = topPicks[0]) === null || _topPicks_ === void 0 ? void 0 : (_topPicks__card = _topPicks_.card) === null || _topPicks__card === void 0 ? void 0 : (_topPicks__card_card = _topPicks__card.card) === null || _topPicks__card_card === void 0 ? void 0 : _topPicks__card_card.carousel;
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2.26,
        slidesToScroll: 1
    };
    var settings1 = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2.5,
        slidesToScroll: 1
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "flex flex-col w-1/2 my-8 mx-auto",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "text-[10px]",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                        className: "text-[#93959f]",
                        children: [
                            "Home / ",
                            city,
                            " / "
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                        className: "text-[#535665]",
                        children: name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "font-extrabold mt-6 mb-4 text-2xl",
                children: name
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "res-info-box-bg",
                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "bg-white p-4 mt-2 res-info-box rou",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "flex",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                    className: "flex items-center font-bold",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("svg", {
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 20 20",
                                            fill: "none",
                                            role: "img",
                                            "aria-hidden": "true",
                                            strokeColor: "rgba(2, 6, 12, 0.92)",
                                            fillColor: "rgba(2, 6, 12, 0.92)",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("circle", {
                                                    cx: "10",
                                                    cy: "10",
                                                    r: "9",
                                                    fill: "url(#StoreRating20_svg__paint0_linear_32982_71567)"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                    d: "M10.0816 12.865C10.0312 12.8353 9.96876 12.8353 9.91839 12.865L7.31647 14.3968C6.93482 14.6214 6.47106 14.2757 6.57745 13.8458L7.27568 11.0245C7.29055 10.9644 7.26965 10.9012 7.22195 10.8618L4.95521 8.99028C4.60833 8.70388 4.78653 8.14085 5.23502 8.10619L8.23448 7.87442C8.29403 7.86982 8.34612 7.83261 8.36979 7.77777L9.54092 5.06385C9.71462 4.66132 10.2854 4.66132 10.4591 5.06385L11.6302 7.77777C11.6539 7.83261 11.706 7.86982 11.7655 7.87442L14.765 8.10619C15.2135 8.14085 15.3917 8.70388 15.0448 8.99028L12.7781 10.8618C12.7303 10.9012 12.7095 10.9644 12.7243 11.0245L13.4225 13.8458C13.5289 14.2757 13.0652 14.6214 12.6835 14.3968L10.0816 12.865Z",
                                                    fill: "white"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("defs", {
                                                    children: /*#__PURE__*/ (0, $cc6u1.jsxs)("linearGradient", {
                                                        id: "StoreRating20_svg__paint0_linear_32982_71567",
                                                        x1: "10",
                                                        y1: "1",
                                                        x2: "10",
                                                        y2: "19",
                                                        gradientUnits: "userSpaceOnUse",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("stop", {
                                                                "stop-color": "#21973B"
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("stop", {
                                                                offset: "1",
                                                                "stop-color": "#128540"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            className: "mx-1",
                                            children: avgRating
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                            children: [
                                                "(",
                                                totalRatingsString,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                    className: "text-[#02060c72] mx-2",
                                    children: "\u2022"
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                    className: "font-bold",
                                    children: costForTwoMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                            className: "text-[#ff5200] font-bold underline text-sm",
                            children: cuisines === null || cuisines === void 0 ? void 0 : cuisines.join(", ")
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "flex my-3 w-full text-sm",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    class: "sc-fmzyuX jICcAR mr-2",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                            class: "sc-cyRcrZ cAzFIF"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                            class: "sc-kUdmhA gzkjpM"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                            class: "sc-cyRcrZ cAzFIF"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                    className: "font-bold mr-2",
                                                    children: "Outlet "
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                    className: "text-[#02060c99]",
                                                    children: areaName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                            className: "font-bold",
                                            children: sla === null || sla === void 0 ? void 0 : (_sla_slaString = sla.slaString) === null || _sla_slaString === void 0 ? void 0 : _sla_slaString.toLowerCase()
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsx)("hr", {
                            className: "my-3"
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "flex items-center text-[#02060c99] text-sm font-medium",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                    className: "h-5",
                                    src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_40,h_40/v1648635511/Delivery_fee_new_cjxumu",
                                    alt: "delivery"
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                    className: "ml-2",
                                    children: [
                                        "Distance ",
                                        sla === null || sla === void 0 ? void 0 : sla.lastMileTravelString
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            offers && /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "offer-container my-8",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "text-xl font-extrabold",
                        children: "Deals for you"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1580051cd03fa60e$exports))), (0, $kJeRc._)((0, $eRslx._)({}, settings), {
                        children: offers.map(function(offer) {
                            return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $0f5b39c193ecb6e2$export$2e2bcd8739ae039), {
                                data: offer
                            });
                        })
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex items-center justify-center mb-6",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-3",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($10d98c88068a73ec$exports))),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                className: "text-[13px] mx-2 text-[#02060c99] font-medium tracking-widest",
                                children: "MENU"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-3",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($217d869197afbef5$exports))),
                                alt: ""
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex justify-between bg-gray-100 px-4 py-2.5 rounded-lg",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                className: "bg-gray-100 w-[100%] text-center",
                                type: "text",
                                placeholder: "Search for dishes"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                    className: "h-4",
                                    src: "https://static-00.iconduck.com/assets.00/search-icon-2048x2048-cmujl7en.png",
                                    alt: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "filter-btns flex my-6",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                                className: "text-green-700 flex items-center rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                        className: "h-4 mr-2",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b60bb9b93294f68b$exports))),
                                        alt: ""
                                    }),
                                    "Pure Veg"
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                                className: "text-red-700 flex items-center rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                        className: "h-4 mr-2",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d2e79c530f272c92$exports))),
                                        alt: ""
                                    }),
                                    "Non Veg"
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "rounded-full py-2 px-3 mr-3 text-sm text-[rgba(2,6,12,0.75)] font-semibold",
                                children: "Bestseller"
                            })
                        ]
                    }),
                    topBanners && /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "banners-container",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("hr", {}),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                className: "text-xl font-extrabold",
                                children: "Top Picks"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1580051cd03fa60e$exports))), (0, $kJeRc._)((0, $eRslx._)({}, settings1), {
                                children: topBanners.map(function(banner) {
                                    return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $6a79e65d36b5f45b$export$2e2bcd8739ae039), {
                                        topCard: banner
                                    });
                                })
                            }))
                        ]
                    }),
                    nestedCategories === null || nestedCategories === void 0 ? void 0 : nestedCategories.map(function(nestedCategory, index) {
                        var _nestedCategory_card, _nestedCategory_card_card, _nestedCategory_card1;
                        return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $944be4cb434817da$export$2e2bcd8739ae039), {
                            data: nestedCategory === null || nestedCategory === void 0 ? void 0 : (_nestedCategory_card = nestedCategory.card) === null || _nestedCategory_card === void 0 ? void 0 : _nestedCategory_card.card
                        }, nestedCategory === null || nestedCategory === void 0 ? void 0 : (_nestedCategory_card1 = nestedCategory.card) === null || _nestedCategory_card1 === void 0 ? void 0 : (_nestedCategory_card_card = _nestedCategory_card1.card) === null || _nestedCategory_card_card === void 0 ? void 0 : _nestedCategory_card_card.title);
                    }),
                    categories === null || categories === void 0 ? void 0 : categories.map(function(category, index) {
                        var _category_card, _category_card_card, _category_card1;
                        return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d61e5d477b89ad78$export$2e2bcd8739ae039), {
                                data: category === null || category === void 0 ? void 0 : (_category_card = category.card) === null || _category_card === void 0 ? void 0 : _category_card.card,
                                showItems: index === showIndex ? true : false,
                                setShowIndex: function() {
                                    return setShowIndex(index);
                                }
                            }, category === null || category === void 0 ? void 0 : (_category_card1 = category.card) === null || _category_card1 === void 0 ? void 0 : (_category_card_card = _category_card1.card) === null || _category_card_card === void 0 ? void 0 : _category_card_card.title)
                        });
                    })
                ]
            })
        ]
    });
};
var $d1dc02be9882a390$export$2e2bcd8739ae039 = $d1dc02be9882a390$var$RestaurantMenu;






var $8c21c4a485ab61ca$var$appStore = (0, $44e97ff44f917989$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $2767c9397776ff73$export$2e2bcd8739ae039)
    }
});
var $8c21c4a485ab61ca$export$2e2bcd8739ae039 = $8c21c4a485ab61ca$var$appStore;



var $cc6u1 = parcelRequire("cc6u1");



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");

var $2ca31816de7d1a41$var$EmptyCart = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "flex flex-col items-center justify-center my-20 ",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                className: "w-[271px]",
                src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/2xempty_cart_yfxml0",
                alt: ""
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                className: "mt-6 text-xl font-semibold text-[#535665]",
                children: "Your cart is empty"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                className: "text-[#7e808c] mt-2",
                children: "You can go to home page to view more restaurants"
            }),
            /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                to: "/",
                children: /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                    className: "mt-7 py-3 px-5 bg-[#ff5200] text-white font-semibold",
                    children: "SEE RESTAURANTS NEAR YOU"
                })
            })
        ]
    });
};
var $2ca31816de7d1a41$export$2e2bcd8739ae039 = $2ca31816de7d1a41$var$EmptyCart;


var $48ed93b9cce506bf$exports = {};

$48ed93b9cce506bf$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "tick.01c249bf.png";


var $109c00527dd9899c$exports = {};

$109c00527dd9899c$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "delivery.5aafa0f5.png";


var $1b76474d98be9e7d$exports = {};

$1b76474d98be9e7d$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "payment.4d2ba910.png";


var $db5524e8d1c8ff4b$exports = {};

$db5524e8d1c8ff4b$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "offer.789a1fc3.png";



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");
var $b50ff2421c0cc8f2$exports = {};

$b50ff2421c0cc8f2$exports = (parcelRequire("i1aqH")).getBundleURL('a3HC9') + "veg-icon.8d41b584.png";


var $d6734cd554ebe394$var$CartItem = function(param) {
    var items = param.items, quantity = param.quantity;
    console.log(items);
    return /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
        children: items === null || items === void 0 ? void 0 : items.map(function(item) {
            return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "flex justify-between py-2.5",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex basis-3/5 items-center",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-4",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b50ff2421c0cc8f2$exports))),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h5", {
                                className: "text-sm ml-[10px]",
                                children: item === null || item === void 0 ? void 0 : item.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex items-center justify-between basis-5/12",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex justify-around items-center font-bold border text-[#60b246] w-[70px] h-[30px] mr-2",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        children: "-"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "text-xs",
                                        children: quantity[item === null || item === void 0 ? void 0 : item.id]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        children: "+"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("h5", {
                                className: "text-[#535665] text-[13px]",
                                children: [
                                    "\u20B9",
                                    ((item === null || item === void 0 ? void 0 : item.price) / 100 || (item === null || item === void 0 ? void 0 : item.defaultPrice) / 100 || (item === null || item === void 0 ? void 0 : item.finalPrice) / 100) * quantity[item === null || item === void 0 ? void 0 : item.id]
                                ]
                            })
                        ]
                    })
                ]
            });
        })
    });
};
var $d6734cd554ebe394$export$2e2bcd8739ae039 = $d6734cd554ebe394$var$CartItem;


var $b47241cf3d81c34b$var$Cart = function() {
    var _useSelector = (0, $c7b80bd183211e5d$export$2105062e25df4afe)(function(store) {
        return store.cart;
    }), items = _useSelector.items, quantity = _useSelector.quantity;
    console.log(items, quantity);
    var totalPrice = items === null || items === void 0 ? void 0 : items.reduce(function(acc, item) {
        return acc + ((item === null || item === void 0 ? void 0 : item.price) / 100 || (item === null || item === void 0 ? void 0 : item.defaultPrice) / 100 || (item === null || item === void 0 ? void 0 : item.finalPrice) / 100) * quantity[item === null || item === void 0 ? void 0 : item.id];
    }, 0);
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var handleClearCart = function() {
        dispatch((0, $2767c9397776ff73$export$810121176e3e3671)());
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)((0, $cc6u1.Fragment), {
        children: [
            !(items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0, $cc6u1.jsx)((0, $2ca31816de7d1a41$export$2e2bcd8739ae039), {}),
            (items === null || items === void 0 ? void 0 : items.length) > 0 && /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "bg-[#E9ECEE] p-8",
                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                    className: "w-4/5 flex justify-center m-auto",
                    children: [
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "mr-5 relative",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                    className: "absolute left-[-13px] top-[35px]  h-60 w-1 border border-t-0 border-r-0 border-b-0 border-black border-dashed"
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "bg-white w-[779px] h-[219px] py-[34px] px-10 mb-5 relative",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                            className: "cart-steps absolute top-[34px] left-[-30px] bg-[#282c3f] h-10 w-10 flex justify-center items-center",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                className: "w-5",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($109c00527dd9899c$exports))),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                            className: "flex justify-between",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                    className: "flex items-center mb-7",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                                            className: "mr-6 text-[17.2px] font-semibold",
                                                            children: "Delivery address"
                                                        }),
                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                            className: "h-5",
                                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($48ed93b9cce506bf$exports))),
                                                            alt: ""
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                    className: "text-sm text-[#ff5200] font-bold",
                                                    children: "CHANGE"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                                            className: "text-[17px] font-medium",
                                            children: "Work"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                            className: "text-[#93959F] text-sm w-[480px]",
                                            children: "603, 10/4, Moti Tabela, New Harsiddhi Nagar, Indore, Madhya Pradesh 452007, India"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("h5", {
                                            className: "text-[13px] font-semibold mt-3",
                                            children: "32 MINS"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "bg-white p-9 h-[178px] flex justify-between flex-col relative",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                            className: "cart-steps absolute top-[34px] left-[-30px] bg-[#282c3f] h-10 w-10 flex justify-center items-center",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                className: "w-5",
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($1b76474d98be9e7d$exports))),
                                                alt: ""
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                            className: "mr-6 text-[17.2px] font-semibold text-black",
                                            children: "Choose payment Method"
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                            className: "bg-[#60b256] text-white w-full font-semibold h-[50px] flex justify-center items-center",
                                            children: "PROCEED TO PAY"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "w-[366px]",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                    className: "bg-white",
                                    children: [
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                            className: "flex justify-between items-center py-5 px-[30px]",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                    className: "flex items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                            className: "h-[50px]",
                                                            src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_100,h_100,c_fill/RX_THUMBNAIL/IMAGES/VENDOR/2024/6/11/a5cee281-c25f-494a-8cab-ba7f49acfb03_728301.JPG",
                                                            alt: ""
                                                        }),
                                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                            className: "ml-[14px]",
                                                            children: [
                                                                /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                                                            className: "text-[17px] font-semibold",
                                                                            children: "Your Order"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                                                            className: "text-[13px] text-[#686b78] -mt-1.5 mb-1",
                                                                            children: "Indore"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                                    className: "border-black border h-[0px] w-10"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                    onClick: handleClearCart,
                                                    className: "w-4 cursor-pointer",
                                                    src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZ1oG15xO3ntA7XZjJvncQSxz4TSEV7aIr9g&s",
                                                    alt: ""
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                            className: "h-[460px] overflow-y-scroll pl-[30px]",
                                            children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                className: "pr-[30px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d6734cd554ebe394$export$2e2bcd8739ae039), {
                                                        items: items,
                                                        quantity: quantity
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                        className: "bg-[#f9f9f9] p-4 flex items-center mt-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                                                className: "w-3",
                                                                viewBox: "0 0 32 32",
                                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                                    d: "M7.031 14c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7l-0.031-1c0-7.732 6.268-14 14-14v4c-2.671 0-5.182 1.040-7.071 2.929-0.364 0.364-0.695 0.751-0.995 1.157 0.357-0.056 0.724-0.086 1.097-0.086zM25.031 14c3.866 0 7 3.134 7 7s-3.134 7-7 7-7-3.134-7-7l-0.031-1c0-7.732 6.268-14 14-14v4c-2.671 0-5.182 1.040-7.071 2.929-0.364 0.364-0.695 0.751-0.995 1.157 0.358-0.056 0.724-0.086 1.097-0.086z"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                                                className: "outline-none bg-[#f9f9f9] text-[13px] ml-2 w-full",
                                                                type: "text",
                                                                placeholder: "Any suggestions? We will pass it on..."
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                        className: "flex items-baseline border border-gray-300 px-[15px] py-[5px] mt-4",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                                                                type: "checkbox",
                                                                name: "",
                                                                id: "delivery"
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                className: "text-sm ml-3",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("label", {
                                                                        className: "text-[#3e4152] font-semibold",
                                                                        htmlFor: "delivery",
                                                                        children: [
                                                                            "Opt in for No-contact Delivery",
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                                        className: "text-[#282c3f] font-normal opacity-60",
                                                                        children: "Unwell, or avoiding contact? Please select no-contact delivery. Partner will safely place the order outside your door (not for COD)"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                        className: "border border-gray-300 border-dashed my-4 px-4 flex items-center h-[55px]",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                                className: "w-5 mr-3",
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($db5524e8d1c8ff4b$exports))),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                                                className: "text-[#535665] text-sm font-semibold",
                                                                children: "Apply Coupon"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                        className: "border-b-2 border-black pb-3",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("h5", {
                                                                className: "text-[#282c3f] mb-2.5 text-[13px] font-semibold",
                                                                children: "Bill Details"
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                className: "text-[#686b78] text-[13px] flex justify-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "my-1.5",
                                                                        children: "Item Total"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                                                        className: "my-1.5",
                                                                        children: [
                                                                            "\u20B9",
                                                                            totalPrice
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                className: "text-[#686b78] text-[13px] flex justify-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "my-1.5",
                                                                        children: "Delivery Fee | 1.8 kms"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "my-1.5",
                                                                        children: "\u20B947"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("hr", {
                                                                className: "my-2"
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                className: "text-[#686b78] text-[13px] flex justify-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "my-1.5",
                                                                        children: "Delivery Tip"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "text-[#e46d47] my-1.5",
                                                                        children: "Add tip"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                className: "text-[#686b78] text-[13px] flex justify-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "my-1.5",
                                                                        children: "Platform fee"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                                                        className: "my-1.5",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("strike", {
                                                                                className: "mr-2 text-[#d3d3d3]",
                                                                                children: "\u20B97.00"
                                                                            }),
                                                                            "6"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                className: "text-[#686b78] text-[13px] flex justify-between",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "my-1.5",
                                                                        children: "GST and Restaurant Charges"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "my-1.5",
                                                                        children: "\u20B931.08"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                            className: "px-[30px] flex items-center justify-between font-bold text-sm shadow-sm h-[60px]",
                                            children: [
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                    children: "TO PAY"
                                                }),
                                                /*#__PURE__*/ (0, $cc6u1.jsxs)("span", {
                                                    children: [
                                                        "\u20B9",
                                                        totalPrice + 47 + 6 + 31.08
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                    className: "bg-white px-[30px] py-4 mt-4",
                                    children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "border rounded-sm p-4 flex flex-col justify-between",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                                className: "text-[#3e4152] font-bold",
                                                children: "Review your order and address detailes to avoid cancellations"
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("p", {
                                                className: "text-[#282c3f] pt-4 text-[13px]",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                        className: "text-[#ff0000]",
                                                        children: "Note: "
                                                    }),
                                                    "If you cancel within 60 seconds of placing your order, a 100% refund will be issued. No refund for cancellations made after 60 seconds."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                                className: "text-[#808080] pt-6 text-[13px]",
                                                children: "Avoid cancellation as it leads to food wastage."
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                                className: "w-fit text-[#ff5200] text-sm pb-1 pt-4 border border-dotted border-b border-t-0 border-r-0 border-l-0 border-[#ff5200] font-semibold",
                                                children: "Read cancellation policy"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $b47241cf3d81c34b$export$2e2bcd8739ae039 = $b47241cf3d81c34b$var$Cart;



var $cc6u1 = parcelRequire("cc6u1");
parcelRequire("fIwXP");

var $6709bac9fe63cf1c$var$Footer = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "px-64 py-5 bg-gray-200 flex items-center justify-between mt-20",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "font-extrabold text-[28px] text-[rgba(2,6,12,0.75)] basis-1/2",
                        children: "For better experience,download the Swiggy app now"
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex",
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "w-44 mr-4",
                                src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/play_store.png",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "w-44",
                                src: "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/app_store.png",
                                alt: ""
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "px-64 pt-10 pb-20 bg-black flex text-white mx-auto justify-between",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex mb-4 ",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("svg", {
                                        width: "21",
                                        height: "32",
                                        viewBox: "0 0 21 32",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("g", {
                                                filter: "url(#filter0_b_674_19294)",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                    fillRule: "evenodd",
                                                    clipRule: "evenodd",
                                                    d: "M20.3819 14.7977C20.5245 13.9563 20.3574 13.3121 19.9261 12.9756C19.2787 12.4711 18.3021 12.1959 15.9859 12.204C14.2724 12.2082 12.4327 12.2167 11.6469 12.2205C11.5739 12.2082 11.3093 12.1181 11.297 11.7938L11.2683 6.64781C11.2683 6.3236 11.5207 6.05694 11.8385 6.05694C12.1559 6.05694 12.412 6.31936 12.412 6.64358C12.412 6.64358 12.4285 9.43839 12.4327 10.4314C12.4327 10.5257 12.4897 10.7513 12.7011 10.8089C14.085 11.1822 21.0778 10.883 20.9639 9.57764C20.3536 4.16496 15.8884 -0.0164585 10.4829 4.87055e-05C8.78164 0.00385807 7.16965 0.426698 5.745 1.16952C2.33815 2.98744 -0.0755529 6.63977 0.00180748 10.8542C0.0546894 13.8374 1.98811 19.1396 3.16037 19.923C3.70173 20.2845 4.40996 20.1491 7.58886 20.1368C9.0298 20.1325 10.3732 20.1325 11.0324 20.1325C11.1016 20.1448 11.4599 20.2312 11.4637 20.5677L11.484 24.4782C11.484 24.8024 11.232 25.0691 10.9142 25.0691C10.5968 25.0691 10.3402 24.8109 10.3402 24.4824C10.3402 24.4824 10.3647 22.9108 10.3609 22.328C10.3609 22.1926 10.3689 21.9585 9.98235 21.7862C8.71622 21.2119 4.60532 21.5729 4.37737 22.2129C4.29191 22.4592 4.75185 23.4073 5.46418 24.6259C7.83331 28.4425 10.1571 31.4176 10.5318 31.8937C10.5563 31.9141 10.5766 31.9348 10.5968 31.9471C10.9104 31.5611 19.1078 22.2747 20.3819 14.7977Z",
                                                    fill: "white"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("defs", {
                                                children: /*#__PURE__*/ (0, $cc6u1.jsxs)("filter", {
                                                    id: "filter0_b_674_19294",
                                                    x: "-9.26002",
                                                    y: "-9.26002",
                                                    width: "39.4853",
                                                    height: "50.4673",
                                                    filterUnits: "userSpaceOnUse",
                                                    colorInterpolationFilters: "sRGB",
                                                    children: [
                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("feFlood", {
                                                            floodOpacity: "0",
                                                            result: "BackgroundImageFix"
                                                        }),
                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("feGaussianBlur", {
                                                            in: "BackgroundImageFix",
                                                            stdDeviation: "4.63001"
                                                        }),
                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("feComposite", {
                                                            in2: "SourceAlpha",
                                                            operator: "in",
                                                            result: "effect1_backgroundBlur_674_19294"
                                                        }),
                                                        /*#__PURE__*/ (0, $cc6u1.jsx)("feBlend", {
                                                            mode: "normal",
                                                            in: "SourceGraphic",
                                                            in2: "effect1_backgroundBlur_674_19294",
                                                            result: "shape"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
                                        className: "font-black text-2xl ml-3",
                                        children: "Swiggy"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                className: "opacity-60",
                                children: "\xa9 2024 Bundl Technologies Pvt. Ltd"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                className: "text-[18px] font-bold",
                                children: "Company"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "About"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Careers"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Team"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Swiggy One"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Swiggy Instamart"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Swiggy Genie"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "mb-16",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                        className: "text-[18px] font-bold",
                                        children: "Contact us"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                                className: "my-4 opacity-60",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                                    to: "/",
                                                    children: "Help & Support"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                                className: "my-4 opacity-60",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                                    to: "/",
                                                    children: "partner with us"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                                className: "my-4 opacity-60",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                                    to: "/",
                                                    children: "Ride with us"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                        className: "text-[18px] font-bold",
                                        children: "Legal"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                                className: "my-4 opacity-60",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                                    to: "/",
                                                    children: "Terms & Conditions"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                                className: "my-4 opacity-60",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                                    to: "/",
                                                    children: "Cookie Policy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                                className: "my-4 opacity-60",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                                    to: "/",
                                                    children: "Privacy Policy"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                                className: "my-4 opacity-60",
                                                children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                                    to: "/",
                                                    children: "Investor Relations"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                className: "text-[18px] font-bold",
                                children: "We deliver to:"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Bangalore"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Gurgoan"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Hyderabad"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Delhi"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Mumbai"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("li", {
                                        className: "my-4 opacity-60",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$a6c7ac8248d6e38a), {
                                            to: "/",
                                            children: "Pune"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                                className: "flex items-center justify-between w-[120px] border border-gray-800 p-1 px-2 rounded-md",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                        className: "text-sm opacity-60",
                                        children: "589 cities"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                        className: "h-2",
                                        src: "https://clipground.com/images/dropdown-icon-png-3.png",
                                        alt: ""
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6709bac9fe63cf1c$export$2e2bcd8739ae039 = $6709bac9fe63cf1c$var$Footer;



var $7k5I8 = parcelRequire("7k5I8");

var $eRslx = parcelRequire("eRslx");

var $kJeRc = parcelRequire("kJeRc");

var $kB67t = parcelRequire("kB67t");

var $2Xzd1 = parcelRequire("2Xzd1");

var $lFlDF = parcelRequire("lFlDF");

var $cc6u1 = parcelRequire("cc6u1");

var $fIwXP = parcelRequire("fIwXP");

var $7k5I8 = parcelRequire("7k5I8");

var $kB67t = parcelRequire("kB67t");

var $lFlDF = parcelRequire("lFlDF");

var $fIwXP = parcelRequire("fIwXP");

var $0191cca6bf2ff55f$var$useCuisines = function() {
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(null), 2), cuisinesInfo = _useState[0], setCuisinesInfo = _useState[1];
    (0, $fIwXP.useEffect)(function() {
        fetchData();
    }, []);
    var fetchData = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function() {
            var data, json;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch((0, $cc25cc9a913d8a70$export$d468c44ae1fb41bb))
                        ];
                    case 1:
                        data = _state.sent();
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setCuisinesInfo(json);
                        console.log(json);
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchData() {
            return _ref.apply(this, arguments);
        };
    }();
    return cuisinesInfo;
};
var $0191cca6bf2ff55f$export$2e2bcd8739ae039 = $0191cca6bf2ff55f$var$useCuisines;









var $21e3b6032e132b0b$var$Search = function() {
    var _cuisinesInfo_data_cards__card_card_gridElements_infoWithStyle, _cuisinesInfo_data_cards__card_card_gridElements, _cuisinesInfo_data_cards__card_card, _cuisinesInfo_data_cards__card, _cuisinesInfo_data_cards_, _cuisinesInfo_data, _cuisinesInfo_data_cards__card_card_header, _cuisinesInfo_data_cards__card_card1, _cuisinesInfo_data_cards__card1, _cuisinesInfo_data_cards_1, _cuisinesInfo_data1;
    var dispatch = (0, $c7b80bd183211e5d$export$8ad76b76a4c905f8)();
    var _useState = (0, $kB67t._)((0, $fIwXP.useState)(""), 2), searchQuery = _useState[0], setSearchQuery = _useState[1];
    var _useState1 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), suggestions = _useState1[0], setSuggestions = _useState1[1];
    var _useState2 = (0, $kB67t._)((0, $fIwXP.useState)(false), 2), showSuggestions = _useState2[0], setShowSuggestions = _useState2[1];
    var _useState3 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), searchResult = _useState3[0], setSearchResult = _useState3[1];
    var _useState4 = (0, $kB67t._)((0, $fIwXP.useState)(false), 2), searchedResults = _useState4[0], setSearchedResults = _useState4[1];
    var _useState5 = (0, $kB67t._)((0, $fIwXP.useState)([]), 2), searchHistory = _useState5[0], setSearchHistory = _useState5[1];
    var cuisinesInfo = (0, $0191cca6bf2ff55f$export$2e2bcd8739ae039)();
    var cuisines = cuisinesInfo === null || cuisinesInfo === void 0 ? void 0 : (_cuisinesInfo_data = cuisinesInfo.data) === null || _cuisinesInfo_data === void 0 ? void 0 : (_cuisinesInfo_data_cards_ = _cuisinesInfo_data.cards[1]) === null || _cuisinesInfo_data_cards_ === void 0 ? void 0 : (_cuisinesInfo_data_cards__card = _cuisinesInfo_data_cards_.card) === null || _cuisinesInfo_data_cards__card === void 0 ? void 0 : (_cuisinesInfo_data_cards__card_card = _cuisinesInfo_data_cards__card.card) === null || _cuisinesInfo_data_cards__card_card === void 0 ? void 0 : (_cuisinesInfo_data_cards__card_card_gridElements = _cuisinesInfo_data_cards__card_card.gridElements) === null || _cuisinesInfo_data_cards__card_card_gridElements === void 0 ? void 0 : (_cuisinesInfo_data_cards__card_card_gridElements_infoWithStyle = _cuisinesInfo_data_cards__card_card_gridElements.infoWithStyle) === null || _cuisinesInfo_data_cards__card_card_gridElements_infoWithStyle === void 0 ? void 0 : _cuisinesInfo_data_cards__card_card_gridElements_infoWithStyle.info;
    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6.8,
        slidesToScroll: 3
    };
    (0, $fIwXP.useEffect)(function() {
        var data = JSON.parse(localStorage.getItem("seachHistory"));
        if (data) setSearchHistory(data);
    }, []);
    (0, $fIwXP.useEffect)(function() {
        localStorage.setItem("seachHistory", JSON.stringify(searchHistory));
    }, [
        searchHistory
    ]);
    (0, $fIwXP.useEffect)(function() {
        if (searchQuery !== "") getSearchSuggestions();
    }, [
        searchQuery
    ]);
    var getSearchSuggestions = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function() {
            var _json_data, data, json;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch(// "http://localhost:5000/api/search-sugggestions?searchQuery=" + searchQuery
                            "https://swiggy-backend-9o8y.onrender.com/api/search-sugggestions?searchQuery=" + searchQuery)
                        ];
                    case 1:
                        data = _state.sent();
                        console.log(data);
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        setSuggestions(json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : _json_data.suggestions);
                        return [
                            2
                        ];
                }
            });
        });
        return function getSearchSuggestions() {
            return _ref.apply(this, arguments);
        };
    }();
    var searchResults = /*#__PURE__*/ function() {
        var _ref = (0, $7k5I8._)(function(searchName) {
            var _json_data_cards__groupedCard_cardGroupMap_DISH, _json_data_cards__groupedCard_cardGroupMap, _json_data_cards__groupedCard, _json_data_cards_, _json_data, data, json, dishes;
            return (0, $lFlDF.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(searchName !== "")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            fetch(// "http://localhost:5000/api/search-results?searchQuery=" + searchName
                            "https://swiggy-backend-9o8y.onrender.com/api/search-results?searchQuery=" + searchName)
                        ];
                    case 1:
                        data = _state.sent();
                        setSearchHistory((0, $2Xzd1._)(searchHistory).concat([
                            searchName
                        ]));
                        return [
                            4,
                            data.json()
                        ];
                    case 2:
                        json = _state.sent();
                        dishes = json === null || json === void 0 ? void 0 : (_json_data = json.data) === null || _json_data === void 0 ? void 0 : (_json_data_cards_ = _json_data.cards[1]) === null || _json_data_cards_ === void 0 ? void 0 : (_json_data_cards__groupedCard = _json_data_cards_.groupedCard) === null || _json_data_cards__groupedCard === void 0 ? void 0 : (_json_data_cards__groupedCard_cardGroupMap = _json_data_cards__groupedCard.cardGroupMap) === null || _json_data_cards__groupedCard_cardGroupMap === void 0 ? void 0 : (_json_data_cards__groupedCard_cardGroupMap_DISH = _json_data_cards__groupedCard_cardGroupMap.DISH) === null || _json_data_cards__groupedCard_cardGroupMap_DISH === void 0 ? void 0 : _json_data_cards__groupedCard_cardGroupMap_DISH.cards.filter(function(c) {
                            var _c_card_card, _c_card;
                            return ((_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : _c_card_card["@type"]) === "type.googleapis.com/swiggy.presentation.food.v2.Dish";
                        });
                        setSearchResult(dishes);
                        setShowSuggestions(false);
                        setSearchedResults(true);
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function searchResults(searchName) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnSuggestionClick = function(suggestionName) {
        if (suggestionName !== "") searchResults(suggestionName);
    };
    var handleOnEnter = function(e) {
        if (e.key === "Enter") {
            if (e.target.value !== "") searchResults(e.target.value);
        }
    };
    // const recentlyClickedObj = {};
    // const recentSearchStorageData = localStorage.getItem("recentSearch") ?? [];
    // console.log(recentSearchStorageData);
    // recentSearchStorageData.unshift(recentlyClickedObj);
    // localStorage.setItem("recentSearch", recentSearchStorageData);
    var handleAddItem = function(item) {
        var _item_card_card, _item_card;
        console.log(item);
        dispatch((0, $2767c9397776ff73$export$fb9705de59d96855)(item === null || item === void 0 ? void 0 : (_item_card = item.card) === null || _item_card === void 0 ? void 0 : (_item_card_card = _item_card.card) === null || _item_card_card === void 0 ? void 0 : _item_card_card.info));
    };
    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
        className: "w-[860px] mx-auto my-12",
        children: [
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "border p-2.5 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("input", {
                        className: "w-3/4 outline-none",
                        placeholder: "Search for restaurant and foods",
                        type: "text",
                        value: searchQuery,
                        onChange: function(e) {
                            return setSearchQuery(e.target.value);
                        },
                        onFocus: function() {
                            return setShowSuggestions(true);
                        },
                        onKeyUp: handleOnEnter
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                        onClick: function() {
                            return searchResults(searchQuery);
                        },
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                            viewBox: "5 -1 12 25",
                            height: "17",
                            width: "17",
                            fill: "#686b78",
                            children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                d: "M17.6671481,17.1391632 L22.7253317,22.1973467 L20.9226784,24 L15.7041226,18.7814442 C14.1158488,19.8024478 12.225761,20.3946935 10.1973467,20.3946935 C4.56550765,20.3946935 0,15.8291858 0,10.1973467 C0,4.56550765 4.56550765,0 10.1973467,0 C15.8291858,0 20.3946935,4.56550765 20.3946935,10.1973467 C20.3946935,12.8789625 19.3595949,15.3188181 17.6671481,17.1391632 Z M10.1973467,17.8453568 C14.4212261,17.8453568 17.8453568,14.4212261 17.8453568,10.1973467 C17.8453568,5.97346742 14.4212261,2.54933669 10.1973467,2.54933669 C5.97346742,2.54933669 2.54933669,5.97346742 2.54933669,10.1973467 C2.54933669,14.4212261 5.97346742,17.8453568 10.1973467,17.8453568 Z"
                            })
                        })
                    })
                ]
            }),
            showSuggestions && /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                className: "m-4",
                children: suggestions === null || suggestions === void 0 ? void 0 : suggestions.map(function(s) {
                    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex items-center py-2 hover:bg-blue-50",
                        onClick: function() {
                            return handleOnSuggestionClick(s === null || s === void 0 ? void 0 : s.text);
                        },
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                className: "h-16 w-16 object-cover rounded-[4px] mr-4",
                                src: (0, $cc25cc9a913d8a70$export$34d86598e19a5b29) + (s === null || s === void 0 ? void 0 : s.cloudinaryId),
                                alt: ""
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("h2", {
                                        className: "text-[15px] text-[#282c3f]",
                                        children: s === null || s === void 0 ? void 0 : s.text
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("h4", {
                                        className: "text-sm text-[#686b78]",
                                        children: s === null || s === void 0 ? void 0 : s.tagToDisplay
                                    })
                                ]
                            })
                        ]
                    });
                })
            }),
            searchedResults && /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "my-4",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "text-[#282c3f] font-semibold py-2 px-3.5 mr-2 text-sm border rounded-full",
                                children: "Restaurants"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                className: "bg-[#282c3f] text-white font-semibold py-2 px-3.5 mr-2 text-sm border rounded-full",
                                children: "Dishes"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "bg-[#f5f6f8]",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                className: "flex gap-3 bg-white py-4 border-t mb-8",
                                children: [
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                        className: " pr-3 border-gray-400 border-r border-dashed",
                                        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                                            className: "flex items-center bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                            children: [
                                                "Sort by",
                                                /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                    className: "ml-1 h-4",
                                                    src: "https://static.thenounproject.com/png/1123247-200.png",
                                                    alt: ""
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Fast Delivery"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Veg"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Non-Veg"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Rated 4+"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Rs 100-Rs 250"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Less than Rs 100"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Gourmet"
                                    }),
                                    /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                        className: "bg-[#fafafa] rounded-md text-xs font-medium px-[10px] py-[5px] text-[#686b78] border",
                                        children: "Spicy"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                                className: "flex flex-wrap justify-between m-3",
                                children: searchResult.map(function(c) {
                                    var _c_card_card_restaurant_info, _c_card_card_restaurant, _c_card_card, _c_card, _c_card_card_info_ratings_aggregatedRating, _c_card_card_info_ratings, _c_card_card_info, _c_card_card1, _c_card1, _c_card_card_restaurant_info_sla, _c_card_card_restaurant_info1, _c_card_card_restaurant1, _c_card_card2, _c_card2, _c_card_card_info1, _c_card_card3, _c_card3, _c_card_card_info2, _c_card_card4, _c_card4, _c_card_card_info3, _c_card_card5, _c_card5;
                                    return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                        className: "dish-card w-[410px] h-[277px] bg-white py-6 px-4 rounded-3xl mb-6",
                                        children: [
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                className: "flex justify-between items-center border-b border-dotted pb-3",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                        className: "",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("h3", {
                                                                className: "text-[#686b78] font-bold text-sm",
                                                                children: c === null || c === void 0 ? void 0 : (_c_card = c.card) === null || _c_card === void 0 ? void 0 : (_c_card_card = _c_card.card) === null || _c_card_card === void 0 ? void 0 : (_c_card_card_restaurant = _c_card_card.restaurant) === null || _c_card_card_restaurant === void 0 ? void 0 : (_c_card_card_restaurant_info = _c_card_card_restaurant.info) === null || _c_card_card_restaurant_info === void 0 ? void 0 : _c_card_card_restaurant_info.name
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                                className: "flex items-center text-[13px] text-[#7e808c]",
                                                                children: [
                                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("svg", {
                                                                        width: "12",
                                                                        height: "12",
                                                                        viewBox: "0 0 12 12",
                                                                        fill: "none",
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        role: "img",
                                                                        fillColor: "#686b78",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("rect", {
                                                                                width: "12",
                                                                                height: "12",
                                                                                fill: "white"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                                                d: "M5.67163 3.99166C6.22068 2.34179 6.49521 1.51686 7 1.51686C7.50479 1.51686 7.77932 2.34179 8.32837 3.99166L8.65248 4.96556H9.60668C11.4122 4.96556 12.315 4.96556 12.4703 5.45302C12.6256 5.94049 11.8893 6.4628 10.4167 7.50744L9.67376 8.03444L9.97544 8.94095C10.5325 10.615 10.8111 11.452 10.4033 11.754C9.99553 12.056 9.27604 11.5457 7.83705 10.5249L7 9.93112L6.16295 10.5249C4.72396 11.5457 4.00447 12.056 3.5967 11.754C3.18893 11.452 3.46747 10.615 4.02456 8.94095L4.04557 8.87783C4.18081 8.47145 4.24843 8.26825 4.18684 8.08006C4.12525 7.89187 3.94958 7.76725 3.59824 7.51802C2.11566 6.46633 1.37437 5.94049 1.52971 5.45302C1.68504 4.96556 2.5878 4.96556 4.39332 4.96556H5.34752L5.67163 3.99166Z",
                                                                                fill: "#686b78"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "ml-1",
                                                                        children: c === null || c === void 0 ? void 0 : (_c_card1 = c.card) === null || _c_card1 === void 0 ? void 0 : (_c_card_card1 = _c_card1.card) === null || _c_card_card1 === void 0 ? void 0 : (_c_card_card_info = _c_card_card1.info) === null || _c_card_card_info === void 0 ? void 0 : (_c_card_card_info_ratings = _c_card_card_info.ratings) === null || _c_card_card_info_ratings === void 0 ? void 0 : (_c_card_card_info_ratings_aggregatedRating = _c_card_card_info_ratings.aggregatedRating) === null || _c_card_card_info_ratings_aggregatedRating === void 0 ? void 0 : _c_card_card_info_ratings_aggregatedRating.rating
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        className: "mx-1",
                                                                        children: " . "
                                                                    }),
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                                                        children: c === null || c === void 0 ? void 0 : (_c_card2 = c.card) === null || _c_card2 === void 0 ? void 0 : (_c_card_card2 = _c_card2.card) === null || _c_card_card2 === void 0 ? void 0 : (_c_card_card_restaurant1 = _c_card_card2.restaurant) === null || _c_card_card_restaurant1 === void 0 ? void 0 : (_c_card_card_restaurant_info1 = _c_card_card_restaurant1.info) === null || _c_card_card_restaurant_info1 === void 0 ? void 0 : (_c_card_card_restaurant_info_sla = _c_card_card_restaurant_info1.sla) === null || _c_card_card_restaurant_info_sla === void 0 ? void 0 : _c_card_card_restaurant_info_sla.slaString
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                                        width: "28",
                                                        height: "28",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                                            "fill-rule": "evenodd",
                                                            "clip-rule": "evenodd",
                                                            d: "M13.2307 5.53999C12.9769 5.28615 12.5653 5.28615 12.3115 5.53999C12.0576 5.79383 12.0576 6.20539 12.3115 6.45923L17.2019 11.3496L5.39414 11.3496C5.03516 11.3496 4.74414 11.6406 4.74414 11.9996C4.74414 12.3586 5.03516 12.6496 5.39414 12.6496L17.2019 12.6496L12.3115 17.54C12.0576 17.7938 12.0576 18.2054 12.3115 18.4592C12.5653 18.7131 12.9769 18.7131 13.2307 18.4592L18.949 12.741C19.3584 12.3315 19.3584 11.6677 18.949 11.2583L13.2307 5.53999Z",
                                                            fill: "#868891"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                className: "flex justify-between items-center my-6",
                                                children: [
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                                className: "h-4",
                                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($b50ff2421c0cc8f2$exports))),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                                                className: "font-bold text-lg text-[#02060cbf]",
                                                                children: c === null || c === void 0 ? void 0 : (_c_card3 = c.card) === null || _c_card3 === void 0 ? void 0 : (_c_card_card3 = _c_card3.card) === null || _c_card_card3 === void 0 ? void 0 : (_c_card_card_info1 = _c_card_card3.info) === null || _c_card_card_info1 === void 0 ? void 0 : _c_card_card_info1.name
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("h2", {
                                                                className: "font-bold tracking-[-0.5px]",
                                                                children: [
                                                                    "\u20B9 ",
                                                                    (c === null || c === void 0 ? void 0 : (_c_card4 = c.card) === null || _c_card4 === void 0 ? void 0 : (_c_card_card4 = _c_card4.card) === null || _c_card_card4 === void 0 ? void 0 : (_c_card_card_info2 = _c_card_card4.info) === null || _c_card_card_info2 === void 0 ? void 0 : _c_card_card_info2.price) / 100
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsxs)("button", {
                                                                className: "flex items-center border rounded-full font-bold mt-3 py-1 px-2 text-[#02060c99] text-[13px] ",
                                                                children: [
                                                                    "More Details",
                                                                    /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                                        className: "h-2.5 ml-1 opacity-50",
                                                                        src: "https://cdn-icons-png.flaticon.com/512/32/32213.png",
                                                                        alt: ""
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                                                        className: "relative",
                                                        children: [
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                                                className: "w-[156px] h-[144px] rounded-lg",
                                                                src: (0, $cc25cc9a913d8a70$export$c0d48a7117cc6549) + (c === null || c === void 0 ? void 0 : (_c_card5 = c.card) === null || _c_card5 === void 0 ? void 0 : (_c_card_card5 = _c_card5.card) === null || _c_card_card5 === void 0 ? void 0 : (_c_card_card_info3 = _c_card_card5.info) === null || _c_card_card_info3 === void 0 ? void 0 : _c_card_card_info3.imageId),
                                                                alt: ""
                                                            }),
                                                            /*#__PURE__*/ (0, $cc6u1.jsx)("button", {
                                                                onClick: function() {
                                                                    return handleAddItem(c);
                                                                },
                                                                className: "text-lg px-7 py-1 text-green-600 font-bold rounded-md bg-white shadow-sm absolute -bottom-4 left-[19%] border",
                                                                children: "ADD"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    });
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                        className: "flex justify-between items-center my-8 mx-2",
                        children: [
                            /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                                className: "text-[#3d4152] font-bold text-lg",
                                children: "Recent Searches"
                            }),
                            /*#__PURE__*/ (0, $cc6u1.jsx)("span", {
                                className: "text-[#ff5200] font-bold text-xs",
                                children: "SHOW MORE"
                            })
                        ]
                    }),
                    searchHistory.length > 0 && searchHistory.map(function(item) {
                        return /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                            className: "w-full flex items-center",
                            children: [
                                /*#__PURE__*/ (0, $cc6u1.jsx)("svg", {
                                    viewBox: "5 -1 12 25",
                                    height: "17",
                                    width: "17",
                                    fill: "#686b78",
                                    children: /*#__PURE__*/ (0, $cc6u1.jsx)("path", {
                                        d: "M17.6671481,17.1391632 L22.7253317,22.1973467 L20.9226784,24 L15.7041226,18.7814442 C14.1158488,19.8024478 12.225761,20.3946935 10.1973467,20.3946935 C4.56550765,20.3946935 0,15.8291858 0,10.1973467 C0,4.56550765 4.56550765,0 10.1973467,0 C15.8291858,0 20.3946935,4.56550765 20.3946935,10.1973467 C20.3946935,12.8789625 19.3595949,15.3188181 17.6671481,17.1391632 Z M10.1973467,17.8453568 C14.4212261,17.8453568 17.8453568,14.4212261 17.8453568,10.1973467 C17.8453568,5.97346742 14.4212261,2.54933669 10.1973467,2.54933669 C5.97346742,2.54933669 2.54933669,5.97346742 2.54933669,10.1973467 C2.54933669,14.4212261 5.97346742,17.8453568 10.1973467,17.8453568 Z"
                                    })
                                }),
                                /*#__PURE__*/ (0, $cc6u1.jsx)("p", {
                                    className: "text-[#686b78] font-medium w-full ml-4 py-4 border-b-2",
                                    children: item
                                })
                            ]
                        });
                    })
                ]
            }),
            /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
                className: "mt-4 mb-14",
                children: [
                    /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        className: "font-extrabold text-2xl",
                        children: cuisinesInfo === null || cuisinesInfo === void 0 ? void 0 : (_cuisinesInfo_data1 = cuisinesInfo.data) === null || _cuisinesInfo_data1 === void 0 ? void 0 : (_cuisinesInfo_data_cards_1 = _cuisinesInfo_data1.cards[1]) === null || _cuisinesInfo_data_cards_1 === void 0 ? void 0 : (_cuisinesInfo_data_cards__card1 = _cuisinesInfo_data_cards_1.card) === null || _cuisinesInfo_data_cards__card1 === void 0 ? void 0 : (_cuisinesInfo_data_cards__card_card1 = _cuisinesInfo_data_cards__card1.card) === null || _cuisinesInfo_data_cards__card_card1 === void 0 ? void 0 : (_cuisinesInfo_data_cards__card_card_header = _cuisinesInfo_data_cards__card_card1.header) === null || _cuisinesInfo_data_cards__card_card_header === void 0 ? void 0 : _cuisinesInfo_data_cards__card_card_header.title
                    }),
                    /*#__PURE__*/ (0, $cc6u1.jsx)("div", {
                        className: "mr-4",
                        children: /*#__PURE__*/ (0, $cc6u1.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1580051cd03fa60e$exports))), (0, $kJeRc._)((0, $eRslx._)({}, settings), {
                            children: cuisines === null || cuisines === void 0 ? void 0 : cuisines.map(function(c) {
                                return /*#__PURE__*/ (0, $cc6u1.jsx)("img", {
                                    src: (0, $cc25cc9a913d8a70$export$211d963c14780a03) + (c === null || c === void 0 ? void 0 : c.imageId),
                                    alt: ""
                                });
                            })
                        }))
                    })
                ]
            })
        ]
    });
};
var $21e3b6032e132b0b$export$2e2bcd8739ae039 = $21e3b6032e132b0b$var$Search;



var $0daa6d02c6c97a55$var$Grocery = /*#__PURE__*/ (0, $fIwXP.lazy)(function() {
    return (parcelRequire("c38Wl"));
});
var $0daa6d02c6c97a55$var$Applayout = function() {
    return /*#__PURE__*/ (0, $cc6u1.jsx)((0, $c7b80bd183211e5d$export$2881499e37b75b9a), {
        store: (0, $8c21c4a485ab61ca$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $cc6u1.jsxs)("div", {
            className: "app",
            children: [
                /*#__PURE__*/ (0, $cc6u1.jsx)((0, $f310bc4ea983f747$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $cc6u1.jsx)((0, $9e36fd5982483bee$export$910ae8079b2c2852), {}),
                /*#__PURE__*/ (0, $cc6u1.jsx)((0, $6709bac9fe63cf1c$export$2e2bcd8739ae039), {})
            ]
        })
    });
};
var $0daa6d02c6c97a55$var$appRouter = (0, $76a326218c469af1$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $cc6u1.jsx)($0daa6d02c6c97a55$var$Applayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $373b11f276a41253$export$2e2bcd8739ae039), {})
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $717a2f0a6a708d12$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $fIwXP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $cc6u1.jsx)("h1", {
                        children: "Loading..."
                    }),
                    children: /*#__PURE__*/ (0, $cc6u1.jsx)($0daa6d02c6c97a55$var$Grocery, {})
                })
            },
            {
                path: "/restaurants/:resId",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $d1dc02be9882a390$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $b47241cf3d81c34b$export$2e2bcd8739ae039), {})
            },
            {
                path: "/search",
                element: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $21e3b6032e132b0b$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $cc6u1.jsx)((0, $eb9ea4566ac52960$export$2e2bcd8739ae039), {})
    }
]);
var $0daa6d02c6c97a55$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($fb34d4b6d3b01836$exports))).createRoot(document.getElementById("root"));
$0daa6d02c6c97a55$var$root.render(/*#__PURE__*/ (0, $cc6u1.jsx)((0, $76a326218c469af1$export$323e4fc2fa4753fb), {
    router: $0daa6d02c6c97a55$var$appRouter
}));

})();
//# sourceMappingURL=index.d0556509.js.map
